/**
 * pt-BR is the source of truth: the operations team works in Portuguese and
 * the legal vocabulary (ICMS-ST, MVA, NCM, CEST) is Brazilian. Every other
 * catalogue is typed against this one and checked for completeness in
 * `src/i18n/i18n.test.ts`.
 */
export const ptBR = {
  "calc.form.individualDiagnostic":
    "Sem método de preço, este modo é um diagnóstico de tributos. O total fiscal não é o custo de caixa da compra nem o preço de publicação. Para calcular um preço de publicação apenas com a aquisição, use Planilha e o modelo comercial. As opções de preço individual com TR consideram a venda e exigem as regras dessa operação.",
  "research.resolution.supplierDeclarationCorrection":
    "Confira e corrija o IPI e o IPI Valor nas colunas N e O da planilha do fornecedor e importe o arquivo novamente. A internet não pode alterar essa declaração do fornecedor; esta correção não exige nova pesquisa paga.",
  "wb.issue.MISSING_VALUE.required.title": "Valor obrigatório ausente: {field}",
  "wb.issue.MISSING_VALUE.required.hint":
    "Preencha a célula obrigatória na planilha original e envie o arquivo novamente. Esta linha não pode ser calculada antes da correção; nenhum valor é preenchido por padrão.",
  "lotSim.file.addToQueue": "Adicionar planilhas à fila",
  "rulesets.publish.rootImpact":
    "Esta é a primeira publicação, sem versão anterior para comparar. Revise o total de regras e as propostas incluídas; não há contagem de adições ou alterações contra uma base anterior.",
  "rulesets.publish.rootBase": "Sem versão anterior",
  "rulesets.publish.comparison": "Comparação de versões",
  "rulesets.publish.technicalImpact": "Entradas da diferença técnica (não são totais de regras)",
  "lotOps.researchCalculated":
    "Os {count} resultados desta execução foram calculados com regras publicadas da versão {version}. A revisão de outras evidências de pesquisa não bloqueia esses resultados salvos.",
  "research.publishedRule.separate":
    "Há uma regra publicada vinculada a esta pesquisa. Seu vínculo não certifica automaticamente as evidências da busca nem altera cálculos anteriores.",
  "research.publishedRule.open": "Ver regra publicada · {version}",
  "research.publishedRule.evidence": "Evidências desta pesquisa",
  "rulesets.publish.ruleImpact": "Alterações agrupadas por regra",
  "rulesets.publish.unparsedImpact":
    "Há alterações técnicas que não puderam ser agrupadas por regra. Os totais acima abrangem apenas as regras identificadas; revise também a diferença técnica completa antes de publicar.",
  "jamerson.title": "Modelo comercial Jamerson",
  "jamerson.download": "Baixar modelo Excel",
  "jamerson.downloadHint":
    "Use este Excel com as 15 colunas na ordem original e o cabeçalho na linha 1. O modelo está vazio, pronto para seus produtos.",
  "jamerson.uploadBody":
    "Envie o modelo preenchido. Depois confirme o fornecedor, o regime e o take rate deste lote antes de calcular a compra e o preço de publicação.",
  "jamerson.guide": "Como preencher o preço e os dados fiscais",
  "jamerson.help.price.title": "Preço NF (Produtos) UNITÁRIO: mercadoria com tributos por dentro",
  "jamerson.help.price.body":
    "Informe o preço da mercadoria por unidade comercial, antes dos adicionais de IPI e ST. ICMS próprio e PIS/COFINS já estão dentro desse principal: o cálculo apenas os discrimina, sem somá-los novamente.",
  "jamerson.help.ipi.title": "IPI e ST: adicionais separados do preço da mercadoria",
  "jamerson.field.supplierIpiRate": "Alíquota de IPI declarada pelo fornecedor",
  "jamerson.field.supplierIpiAmount": "IPI declarado pelo fornecedor por unidade comercial",
  "jamerson.help.ipi.body":
    "Para indústria, preencha IPI com a alíquota declarada (ex.: 6,5% ou 0,065) e IPI Valor com seu valor por unidade comercial. Esses dados são conferidos como declaração do fornecedor. A ST aplicável é calculada separadamente, conforme a operação e sua qualificação fiscal.",
  "jamerson.help.origin.title": "N/ I é a origem da mercadoria; UF é a rota",
  "jamerson.help.origin.body":
    "Preencha N/ I em cada produto com Nacional, Importada ou o código fiscal 0–8. UF ORIGEM e UF DESTINO são os estados da compra, como MG e SP. Uma UF não substitui a origem fiscal do produto.",
  "jamerson.help.quantity.title": "Caixa e preço devem usar a mesma unidade comercial",
  "jamerson.help.quantity.body":
    "Caixa informa quantas unidades comerciais estão sendo compradas ao Preço NF informado. Declare a unidade abaixo, por exemplo CX ou UN. O sistema multiplica preço por quantidade uma vez; não converte caixas em peças automaticamente.",
  "jamerson.help.takeRate.title": "Take rate por lote, aplicado depois do custo de aquisição",
  "jamerson.help.takeRate.body":
    "Informe o TR na tela, inclusive 0% quando essa for a decisão. Preço de publicação = custo de aquisição ÷ (1 − TR). O custo considera mercadoria e adicionais de aquisição; os tributos da futura revenda dependem do comprador e não fazem parte desta etapa.",
  "jamerson.help.includedPrice.title": "Se seu preço já contém IPI, ST ou take rate",
  "jamerson.help.includedPrice.body":
    "Separe primeiro a composição com o fornecedor e preencha Preço NF apenas com a mercadoria. Registre o IPI nas colunas próprias e o TR na tela. Enviar o total já acrescido como Preço NF faria somar os adicionais novamente; não use esse total como principal.",
  "jamerson.required":
    "Obrigatórios por produto: NCM, N/ I, UF ORIGEM, UF DESTINO, Caixa e Preço NF. Para indústria, IPI e IPI Valor também são obrigatórios, inclusive zero quando declarado.",
  "jamerson.optional":
    "Categoria, marca, família, SKU, descrição, EAN e peso são metadados e podem ficar em branco. Mantenha todas as 15 colunas, mesmo quando suas células estiverem vazias.",
  "jamerson.mappingLocked":
    "Modelo conferido: cabeçalhos e colunas fixos; a rota e a origem fiscal vêm de cada linha. Para corrigir esses dados, ajuste o Excel e envie novamente.",
  "jamerson.supplier": "Fornecedor deste lote",
  "jamerson.supplierRequired": "Selecione indústria ou distribuidor",
  "jamerson.supplierHint":
    "Confirme um perfil válido para todas as linhas. Se os produtos tiverem perfis distintos, envie lotes separados. Indústria exige os dois campos de IPI por produto.",
  "jamerson.declarationHint":
    "O modelo declara preço por unidade comercial e mercadoria antes dos adicionais de IPI/ST, sem ST retida anteriormente. Confirme a unidade usada em Caixa e no preço e o regime de todas as linhas. Se houver ST anterior no preço, separe essa composição antes de usar o modelo.",
  "jamerson.takeRate.title": "Take rate deste lote",
  "jamerson.takeRate.hint":
    "Preencha de 0% até menos de 100%. Não há TR presumido. O mesmo percentual vale para todos os produtos deste lote.",
  "jamerson.takeRate.scope":
    "Publicação = custo de aquisição ÷ (1 − TR). Esta etapa calcula a compra para revenda; destino e tributos da venda serão tratados quando houver um comprador.",
  "wb.issue.TEMPLATE_HEADER_MISMATCH.title": "A coluna {column} não corresponde ao modelo Jamerson",
  "wb.issue.TEMPLATE_HEADER_MISMATCH.hint":
    "Baixe o modelo Excel acima e copie os produtos sem renomear, mover, duplicar ou acrescentar colunas. Mantenha os 15 cabeçalhos na linha 1. Corrija a coluna indicada e envie novamente.",
  "wb.issue.TEMPLATE_SHEET_COUNT.title": "O modelo exige uma única aba de entrada visível",
  "wb.issue.TEMPLATE_SHEET_COUNT.hint":
    "Use o Excel baixado acima com uma única aba preenchida e visível. Abas extras só podem estar totalmente vazias; ocultar uma aba preenchida não resolve. Salve e envie novamente.",
  "wb.issue.TEMPLATE_MAPPING_MISMATCH.title":
    "A configuração não corresponde às colunas fixas do modelo",
  "wb.issue.TEMPLATE_MAPPING_MISMATCH.hint":
    "Envie novamente o modelo Excel baixado acima. Mantenha os 15 cabeçalhos na ordem original e a rota de compra em cada linha; o mapeamento é aplicado automaticamente.",
  "argonAcceptance.title": "Aceitação sintética do Argon",
  "argonAcceptance.summary":
    "Prepare três casos com dados sintéticos. A execução ocorre depois, pelo fluxo protegido.",
  "argonAcceptance.prepared": "Admissão registrada",
  "argonAcceptance.executionSeparate":
    "Admissão registrada. Consulte a execução pelo fluxo protegido.",
  "argonAcceptance.copyHelp": "Copie o ID para continuar pelo fluxo autorizado.",
  "argonAcceptance.available": "Saldo disponível para o teste",
  "argonAcceptance.executionLimit": "Limite desta execução",
  "argonAcceptance.campaign": "Campanha",
  "argonAcceptance.acceptanceId": "ID da aceitação",
  "argonAcceptance.unknown": "Não disponível",
  "argonAcceptance.prepare": "Preparar aceitação",
  "argonAcceptance.preparing": "Preparando…",
  "argonAcceptance.retry": "Repetir a mesma solicitação",
  "argonAcceptance.boundary":
    "Preparar não chama o modelo, altera limites ou publica regras fiscais.",
  "argonAcceptance.uncertain":
    "A preparação não foi confirmada. Atualize o estado antes de repetir; uma tentativa manual mantém a mesma solicitação.",
  "argonAcceptance.contextChanged":
    "A campanha mudou enquanto a preparação anterior estava sem confirmação. Verifique a solicitação anterior antes de preparar outra.",
  "argonAcceptance.status.CAN_ADMIT": "Disponível para preparar",
  "argonAcceptance.status.ALREADY_ADMITTED": "Admissão registrada",
  "argonAcceptance.status.MAINTENANCE": "Em manutenção",
  "argonAcceptance.status.RESEARCH_DISABLED": "Pesquisa não configurada",
  "argonAcceptance.status.RESEARCH_PAUSED": "Pesquisa pausada",
  "argonAcceptance.status.NO_VERIFIED_CAMPAIGN": "Aguarda campanha verificada",
  "argonAcceptance.status.BUDGET_UNAVAILABLE": "Preparação indisponível",
  "argonAcceptance.reason.CAN_ADMIT":
    "Há uma campanha verificada disponível para preparar a solicitação.",
  "argonAcceptance.reason.ALREADY_ADMITTED":
    "Já existe uma admissão. Consulte a execução pelo fluxo protegido.",
  "argonAcceptance.reason.MAINTENANCE":
    "A preparação está bloqueada durante a manutenção. Atualize o estado após a liberação.",
  "argonAcceptance.reason.RESEARCH_DISABLED":
    "A pesquisa ainda não está configurada para este ambiente.",
  "argonAcceptance.reason.RESEARCH_PAUSED":
    "A pesquisa está pausada. A preparação permanece bloqueada.",
  "argonAcceptance.reason.NO_VERIFIED_CAMPAIGN":
    "Não há uma campanha verificada disponível para esta solicitação.",
  "argonAcceptance.reason.BUDGET_UNAVAILABLE":
    "Não é possível preparar outra solicitação com a campanha atual. Revise seu saldo e as reservas existentes.",

  "common.costPending": "Pendente",
  "research.blocked.ARGON_COST_BOUND_UNAVAILABLE":
    "O custo da busca com IA está pendente. O IOB determinístico pode continuar.",
  "research.deferral.ARGON_COST_BOUND_UNAVAILABLE":
    "A pesquisa automática aguarda uma estimativa de custo.",
  "research.lanes.unavailable.UNQUALIFIED": "A busca com IA aguarda uma estimativa de custo.",
  "productImages.activation.ARGON_COST_BOUND_UNAVAILABLE":
    "O custo da busca com IA está pendente. Este plano continua pausado.",
  "webResearch.preview.costPending":
    "O custo da busca com IA está pendente. Revise o plano; o trabalho pago continua bloqueado.",

  "productImages.candidateStatus.PENDING_REVIEW": "Pendente de revisão",
  "productImages.candidateStatus.REVIEWED_ACCEPTED_CANDIDATE": "Candidata aceita em revisão",
  "productImages.candidateStatus.REVIEWED_REJECTED": "Candidata rejeitada",
  "productImages.originalGtin": "GTIN original do catálogo",
  "productImages.reviewedGtin": "GTIN revisado",
  "productImages.reviewedVariant": "Variante revisada",
  "productImages.reviewedSize": "Tamanho ou conteúdo revisado",
  "productImages.reviewedPackaging": "Embalagem revisada",
  "productImages.identityReviewId": "Identificador da revisão de identidade",
  "productImages.openIdentityEvidence": "Abrir evidência pública da identidade",
  "productImages.identityOriginalPreserved":
    "Esta revisão mantém o GTIN original e não altera a classificação fiscal nem publica uma imagem.",
  "productImages.reviewIdentity": "Revisar identidade para pesquisa de imagem",
  "productImages.identityReviewHelp":
    "Registre uma decisão humana baseada em fonte pública para este produto e esta revisão. Informe variante, tamanho e embalagem exatos; o nome ou a marca, isoladamente, não comprovam a identidade.",
  "productImages.gtinCheckHint":
    "Use 8, 12, 13 ou 14 dígitos, com dígito verificador válido. Não será corrigido automaticamente.",
  "productImages.identityEvidenceUrl": "Fonte pública da identidade (HTTPS)",
  "productImages.identityEvidenceConfirmation":
    "Conferi o GTIN, a variante, o tamanho e a embalagem com a fonte pública indicada. Esta decisão é específica deste produto e não representa aprovação fiscal.",
  "productImages.invalidIdentityReview":
    "Confira o GTIN e seu dígito verificador, a variante, o tamanho, a embalagem, a URL pública HTTPS e o motivo com pelo menos 10 caracteres.",
  "productImages.identityReviewRecorded":
    "Revisão de identidade registrada. Selecione-a explicitamente ao preparar uma nova pesquisa.",
  "productImages.recordIdentityReview": "Registrar revisão de identidade",
  "productImages.identityReviews": "Identidade pública revisada",
  "productImages.pinnedIdentity": "Identidade fixada nesta pesquisa",
  "productImages.noPinnedIdentity":
    "Nenhuma revisão de identidade está fixada à pesquisa atual. Dados originais insuficientes mantêm o produto pendente.",
  "productImages.identityReviewHistory": "Ver revisões registradas para este produto",
  "productImages.selectedIdentity": "Identidade usada na nova pesquisa",
  "productImages.originalIdentity": "Usar dados originais do catálogo",
  "productImages.selectIdentityHelp":
    "Uma revisão registrada só será usada se selecionada aqui. Dados ausentes ou conflitantes permanecem pendentes; não há associação automática.",
  "webResearch.kind.LOCATE_APPLIANCE_PRODUCT": "Localizar identidade pública do produto",
  "webResearch.scope.APPLIANCE_PRODUCTS.short": "Produtos sem NCM",
  "webResearch.kind.LOCATE_PRODUCT_IMAGE": "Localizar imagem pública de produto",
  "webResearch.scope.PRODUCT_IMAGES.short":
    "Imagens públicas de produtos · fluxo separado da pesquisa fiscal",

  // Public image research: candidate-only overlay, explicit rights review, no publication.
  "productImages.title": "Imagens de produtos",
  "productImages.currentPreserved":
    "A imagem do catálogo é preservada. Ilustrações geradas e candidatos de pesquisa nunca a substituem.",
  "productImages.scope":
    "Gere ilustrações sintéticas claramente identificadas ou consulte candidatos públicos. Nenhuma opção altera a imagem do catálogo ou aprova dados fiscais.",
  "productImages.generateIllustrations": "Gerar ilustrações de produtos",
  "productImages.generateIllustrationsHelp":
    "Cria ilustrações sintéticas de categoria com o Vertex Imagen. Não pesquisa na web nem exige revisão humana por produto. A imagem original do catálogo não muda; a ilustração não comprova a identidade exata do SKU. A execução ainda exige campanha verificada e respeita todos os limites de gasto.",
  "productImages.illustrationCount": "Quantidade de ilustrações",
  "productImages.illustrationCountHelp":
    "As primeiras N linhas elegíveis sem ilustração salva nem tentativa paga pendente, ordenadas pelo ID estável do produto. O valor inicial seleciona as primeiras 100.",
  "productImages.illustrationMaximumCost": "Custo máximo do modelo (USD)",
  "productImages.illustrationPrice":
    "Custo do modelo: US$ 0,02 por imagem; armazenamento e transferência são cobrados à parte.",
  "productImages.illustrationCostConfirmation":
    "Autorizo um custo máximo de {amount} para este lote.",
  "productImages.invalidIllustrationJob":
    "Informe um número inteiro de 1 a 50.000 e confirme o custo máximo exibido.",
  "productImages.illustrationJobRecorded":
    "Trabalho de ilustração registrado. A geração começa somente quando a campanha verificada e os limites de gasto permitirem.",
  "productImages.queueIllustrations": "Enfileirar ilustrações",
  "productImages.syntheticIllustrationLabel": "Ilustração de produto gerada por IA",
  "productImages.syntheticIllustrationDisclosure":
    "Apenas ilustrativa; não é uma foto do produto exato e não comprova a identidade do SKU. A imagem do catálogo não muda.",
  "productImages.syntheticIllustrationAlt": "Ilustração sintética de uma categoria de produto",
  "productImages.illustrationUnavailable": "Não foi possível carregar a ilustração salva.",
  "productImages.illustrationLoading": "Carregando ilustração gerada…",
  "productImages.jobMode": "Tipo de trabalho",
  "productImages.jobMode.SEARCH": "Pesquisa de imagens públicas",
  "productImages.jobMode.GENERATE_ILLUSTRATION": "Geração de ilustração sintética",
  "productImages.organizationRequired":
    "Esta consulta exige uma única organização autorizada na sessão. Solicite o contexto correto ao administrador.",
  "productImages.createJob": "Preparar pesquisa deste produto",
  "productImages.createPausedHelp":
    "Preparar registra uma pesquisa pausada desta revisão. A execução exige ativação explícita, campanha de orçamento verificada e liberação do serviço.",
  "productImages.budgetUsd": "Limite da pesquisa (USD)",
  "productImages.budgetHint":
    "Use ponto decimal. O limite não representa gasto confirmado nem garante uma quantidade de imagens.",
  "productImages.callLimit": "Limite de chamadas de pesquisa",
  "productImages.officialHosts": "Domínios oficiais comprovados (opcional)",
  "productImages.hostsHint":
    "Até 20 domínios, separados por linha ou vírgula. Informe apenas domínios cuja relação com o fabricante foi verificada; a marca não comprova essa relação.",
  "productImages.identityReviewRef": "Referência da revisão da identidade pública",
  "productImages.identityReviewReason": "Justificativa da identidade pública",
  "productImages.publicIdentityConfirmation":
    "Revisei e confirmo que nome, marca, GTIN e atributos selecionados podem ser usados em consultas a fontes públicas.",
  "productImages.invalidJob":
    "Confira o orçamento positivo, o limite de chamadas, os domínios e a referência e justificativa da revisão (mínimo de 10 caracteres).",
  "productImages.jobRecorded":
    "Pesquisa registrada. Confira o estado de ativação; nenhum resultado de imagem está implícito neste registro.",
  "productImages.recordPausedJob": "Registrar pesquisa pausada",
  "productImages.saving": "Registrando…",
  "productImages.writeUnconfirmed":
    "A resposta não foi confirmada. Os dados e a chave da solicitação estão preservados; repetir usa a mesma ação, sem criar outra solicitação.",
  "productImages.retrySame": "Repetir a mesma solicitação",
  "productImages.resumeJob": "Vincular campanha e retomar",
  "productImages.resumeHelp":
    "Retomar pode executar consultas pagas quando os controles do servidor permitirem. Exige campanha verificada; não aumenta o orçamento nem libera custos desconhecidos.",
  "productImages.costReviewHelp":
    "Uma tentativa paga de imagem tem resultado financeiro pendente ou o arquivo não foi salvo. Este produto fica retido; tentar novamente não repete a cobrança nem libera a reserva.",
  "productImages.campaignId": "Campanha de orçamento verificada",
  "productImages.resumeReason": "Justificativa para retomar",
  "productImages.resumeConfirmation":
    "Confirmo que a campanha foi verificada e autorizo a retomada dentro dos limites registrados e dos controles do servidor.",
  "productImages.invalidResume":
    "Informe o identificador válido da campanha e uma justificativa com ao menos 10 caracteres.",
  "productImages.resumeRecorded":
    "Solicitação de retomada registrada. O estado da pesquisa informa se a execução foi liberada.",
  "productImages.confirmResume": "Confirmar campanha e retomar",
  "productImages.newTab": "Abre em nova aba",
  "productImages.notEstablished": "Não estabelecido",
  "productImages.candidateTitle": "Candidato {number}",
  "productImages.candidateUnpublished":
    "Candidato para revisão; não substitui nem publica a imagem do produto.",
  "productImages.publicIdentity": "Identidade encontrada na fonte pública",
  "productImages.confidence": "Confiança relatada pela pesquisa",
  "productImages.confidence.EXACT": "Correspondência relatada como exata",
  "productImages.confidence.PARTIAL": "Correspondência parcial",
  "productImages.confidence.UNCERTAIN": "Correspondência incerta",
  "productImages.matchField.gtin": "Correspondência do GTIN",
  "productImages.matchField.variant": "Correspondência da variante",
  "productImages.matchField.size": "Correspondência do tamanho",
  "productImages.matchField.packaging": "Correspondência da embalagem",
  "productImages.match.EXACT": "Exata (relatada)",
  "productImages.match.MISMATCH": "Divergente",
  "productImages.match.NOT_ESTABLISHED": "Não estabelecida",
  "productImages.sourceKind": "Tipo de fonte declarado",
  "productImages.sourceKind.OFFICIAL_MANUFACTURER": "Apontada como fonte oficial do fabricante",
  "productImages.sourceKind.OTHER_PUBLIC": "Outra fonte pública",
  "productImages.httpVerification": "Verificação da página e imagem",
  "productImages.http.PUBLIC_HTTP_VERIFIED": "Recebimentos HTTP públicos registrados",
  "productImages.http.NOT_VERIFIED": "Não verificada",
  "productImages.openSource": "Abrir página da fonte pública",
  "productImages.openPublicImage": "Abrir imagem na fonte pública",
  "productImages.noQuote": "Sem trecho de evidência registrado",
  "productImages.sourceRights": "Alegação de uso da fonte",
  "productImages.rights.UNKNOWN":
    "Direitos de uso desconhecidos. Encontrar uma imagem publicamente não concede licença.",
  "productImages.rights.SOURCE_LICENSE_CLAIM":
    "A fonte declara uma licença; esta alegação ainda exige revisão humana independente.",
  "productImages.openRightsClaim": "Abrir evidência da alegação",
  "productImages.reviewRecorded": "Revisão do candidato registrada",
  "productImages.reviewDecision": "Decisão sobre o candidato",
  "productImages.reviewDecision.ACCEPT_CANDIDATE": "Aceitar como candidato, sem publicar",
  "productImages.reviewDecision.REJECT_CANDIDATE": "Rejeitar candidato",
  "productImages.reviewReason": "Justificativa da revisão",
  "productImages.reviewedAt": "Revisado em",
  "productImages.reviewer": "Responsável pela revisão",
  "productImages.license": "Licença ou autorização de uso revisada",
  "productImages.scopeOfUse": "Escopo de uso autorizado",
  "productImages.rightsEvidenceUrl": "URL da evidência da revisão de uso",
  "productImages.openReviewedRights": "Abrir evidência revisada de uso",
  "productImages.reviewNotPublication":
    "A decisão permanece como revisão de candidato. Nenhuma imagem foi publicada ou substituída.",
  "productImages.reviewCandidate": "Revisar candidato e evidência de uso",
  "productImages.acceptBlocked":
    "Aceitar exige GTIN único, correspondência exata de GTIN, variante, tamanho e embalagem, confiança exata e verificação HTTP. Incertezas permanecem pendentes.",
  "productImages.chooseDecision": "Selecionar decisão",
  "productImages.reviewConfirmation":
    "Revisei a identidade e a autorização de uso. Esta decisão aceita apenas o candidato e não publica a imagem.",
  "productImages.invalidReview":
    "Confira a decisão, a justificativa (mínimo de 10 caracteres) e, para aceitar, a evidência pública, licença e escopo de uso.",
  "productImages.recordReview": "Registrar revisão do candidato",
  "productImages.candidateAudit": "Origem e recibos do candidato",
  "productImages.candidateId": "Identificador do candidato",
  "productImages.identityHash": "SHA-256 da identidade fixada",
  "productImages.candidateCreatedAt": "Candidato registrado em",
  "productImages.retrievedAt": "Fontes recuperadas em",
  "productImages.imageHash": "SHA-256 da imagem",
  "productImages.pageHash": "SHA-256 da página",
  "productImages.imageBytes": "Bytes da imagem verificada",
  "productImages.imageType": "Formato de imagem verificado",
  "productImages.targetStatus": "Estado deste produto",
  "productImages.targetStatus.PENDING": "Pendente",
  "productImages.targetStatus.IN_PROGRESS": "Em pesquisa",
  "productImages.targetStatus.DONE": "Pesquisa concluída; publicação separada",
  "productImages.targetStatus.FAILED": "Pesquisa interrompida",
  "productImages.targetStatus.BLOCKED_IDENTITY": "Identidade pendente",
  "productImages.checkpoint": "Resultado de pesquisa preservado",
  "productImages.checkpointRetained": "Recibo durável disponível",
  "productImages.noCheckpoint": "Sem recibo confirmado",
  "productImages.targetFailed":
    "A pesquisa deste produto foi interrompida. Confira o estado e os recibos antes de solicitar outra tentativa.",
  "productImages.noJob": "Nenhuma pesquisa de imagens registrada para este produto e revisão.",
  "productImages.candidates": "Candidatos da pesquisa",
  "productImages.noCandidates": "Nenhum candidato confirmado",
  "productImages.noCandidatesHelp":
    "Uma pesquisa pendente, bloqueada ou sem resultado não significa que a imagem foi encontrada ou qualificada.",
  "productImages.overlayAudit": "Identidade e estado preservados",
  "productImages.targetErrorCode": "Código técnico da interrupção",
  "productImages.jobTitle": "Pesquisa registrada",
  "productImages.jobStatus.BLOCKED": "Bloqueada",
  "productImages.jobStatus.PENDING": "Pendente",
  "productImages.jobStatus.IN_PROGRESS": "Em execução",
  "productImages.jobStatus.COMPLETED": "Concluída, sem publicação",
  "productImages.jobStatus.PARTIAL": "Resultado parcial",
  "productImages.jobCreatedAt": "Pesquisa registrada em",
  "productImages.jobProgress": "Estado da pesquisa completa",
  "productImages.jobProgressValue":
    "{done} concluídos · {pending} pendentes · {failed} interrompidos · {total} produtos no total",
  "productImages.jobCountsScope":
    "Os totais pertencem à pesquisa completa. O estado deste produto aparece separadamente.",
  "productImages.jobAudit": "Identificadores da pesquisa",
  "productImages.jobId": "Identificador da pesquisa",
  "productImages.sweepId": "Identificador da execução",
  "productImages.activation.FEATURE_DISABLED":
    "A pesquisa de imagens está desativada neste ambiente. Os resultados registrados permanecem disponíveis.",
  "productImages.activation.BUDGET_CAMPAIGN_REQUIRED":
    "Uma campanha de orçamento verificada ainda precisa ser vinculada.",
  "productImages.activation.CAMPAIGN_UNAVAILABLE":
    "A campanha vinculada não está disponível ou não foi verificada.",
  "productImages.activation.SWEEP_PAUSED": "A execução está pausada.",
  "productImages.activation.BUDGET_EXHAUSTED":
    "O orçamento disponível foi esgotado; retomar não aumenta o limite.",
  "productImages.activation.IDENTITY_REVIEW_REQUIRED":
    "A identidade pública ainda exige revisão explícita.",
  "productImages.activation.IMAGE_MODEL_PRICE_UNQUALIFIED":
    "O preço do modelo Imagen não está qualificado para esta campanha.",
  "productImages.activation.PRODUCT_NAME_REQUIRED":
    "É necessário um nome de produto para gerar uma ilustração.",
  "productImages.issue.MISSING_GTIN": "GTIN ausente; a imagem permanece pendente.",
  "productImages.issue.GTIN_CONFLICT":
    "GTIN compartilhado ou duplicado; não há associação automática de imagem.",
  "productImages.issue.MISSING_PUBLIC_NAME": "Nome público não estabelecido para a consulta.",
  "productImages.issue.VARIANT_NOT_ESTABLISHED": "A variante exata ainda não foi estabelecida.",
  "productImages.issue.SIZE_NOT_ESTABLISHED": "O tamanho exato ainda não foi estabelecido.",
  "productImages.issue.PACKAGING_NOT_ESTABLISHED": "A embalagem exata ainda não foi estabelecida.",
  "productImages.issue.NO_PUBLIC_CANDIDATE":
    "Nenhum candidato público foi encontrado nesta tentativa.",
  "productImages.issue.UNSAFE_URL": "Uma URL foi recusada pelos controles de origem pública.",
  "productImages.issue.HTTP_VERIFICATION_FAILED":
    "Não foi possível confirmar o recebimento da página ou imagem pública.",
  "productImages.issue.RIGHTS_EVIDENCE_REQUIRED":
    "Ainda é necessária evidência de autorização de uso.",
  "productImages.issue.MANUFACTURER_NOT_ESTABLISHED":
    "A relação com o fabricante não foi estabelecida.",
  "productImages.issue.EXISTING_IMAGE_PRESERVED": "A imagem já existente permanece preservada.",

  // Product catalog: immutable source revisions, declarations and explicit supplier SKU maps.
  "productCatalog.title": "Produtos",
  "productCatalog.description":
    "Consulte o catálogo, suas revisões de origem e as declarações de fornecedores.",
  "productCatalog.product": "Produto",
  "productCatalog.catalog": "Catálogo",
  "productCatalog.chooseCatalog": "Selecionar catálogo",
  "productCatalog.internalCode": "Código interno",
  "productCatalog.brand": "Marca declarada",
  "productCatalog.gtin": "GTIN / EAN",
  "productCatalog.classification": "Classificação",
  "productCatalog.declared": "Dados declarados na origem",
  "productCatalog.reviewed": "Classificação revisada",
  "productCatalog.unreviewed": "Classificação ainda não revisada",
  "productCatalog.scope":
    "O catálogo conserva dados declarados de produtos. Revisar a classificação não qualifica regras fiscais, preços ou condições tributárias do fornecedor.",
  "productCatalog.classificationScope":
    "Os valores originais permanecem preservados. Uma revisão de NCM/CEST é separada da qualificação das regras, da operação e das partes.",
  "productCatalog.searchLabel": "Buscar produtos",
  "productCatalog.searchPlaceholder": "Nome, código interno, GTIN, marca ou NCM",
  "productCatalog.manage": "Importar e vincular",
  "productCatalog.pinnedRevision": "Revisão fixada · {version}",
  "productCatalog.noActiveRevision": "Sem revisão ativa",
  "productCatalog.openCurrent": "Abrir revisão atual",
  "productCatalog.tableCaption": "Produtos da revisão selecionada",
  "productCatalog.noResults": "Nenhum produto nesta busca",
  "productCatalog.noResultsHelp": "Tente outro nome ou identificador nesta mesma revisão.",
  "productCatalog.empty": "Nenhum catálogo disponível",
  "productCatalog.emptyHelp":
    "Um operador com permissão de gestão pode importar os arquivos preparados e ativar uma revisão após verificar a origem.",
  "productCatalog.catalogUnavailable":
    "O catálogo solicitado não está disponível para esta sessão.",
  "productCatalog.revisionMismatch":
    "Este produto não pertence à revisão fixada. Volte à lista e abra uma linha desta revisão.",
  "productCatalog.unnamed": "Produto sem nome registrado",
  "productCatalog.notRecorded": "Não registrado",
  "productCatalog.issues": "Pendências da importação",
  "productCatalog.noImportIssues": "Sem alertas de importação registrados",
  "productCatalog.noMerge":
    "Linhas repetidas permanecem separadas. GTIN, nome ou marca não comprovam um vínculo de SKU do fornecedor.",
  "productCatalog.imagesPending": "Imagens pendentes",
  "productCatalog.imagesHelp": "Esta revisão ainda não contém imagens qualificadas do produto.",
  "productCatalog.provenance": "Origem e auditoria",
  "productCatalog.revisionId": "Revisão exata",
  "productCatalog.sourceRow": "Aba e linha de origem",
  "productCatalog.worksheetPart": "Parte da planilha no arquivo",
  "productCatalog.sourceHash": "SHA-256 do arquivo de origem declarado",
  "productCatalog.rowHash": "SHA-256 da linha de origem",
  "productCatalog.sourceReference": "Referência da fonte / documento",
  "productCatalog.reason": "Motivo registrado",
  "productCatalog.reviewedAt": "Revisada em",
  "productCatalog.reviewer": "Responsável pela revisão",
  "productCatalog.validFrom": "Válido a partir de",
  "productCatalog.validTo": "Válido até · opcional",
  "productCatalog.openEnded": "Sem data final declarada",
  "productCatalog.retryOriginal": "Repetir a solicitação original",
  "productCatalog.recordAnother": "Registrar outro",
  "productCatalog.writeUnknown":
    "A resposta não foi confirmada. As entradas estão fixadas; repetir envia a mesma solicitação para recuperar o resultado.",
  "productCatalog.import.title": "Importar revisão preparada",
  "productCatalog.import.help":
    "Selecione o manifesto e as linhas JSONL gerados pelo preparador local do catálogo. Os valores declarados e seus identificadores são preservados.",
  "productCatalog.import.preparation":
    "O preparo local deve registrar o namespace INTERNAL_PRODUCT_CODE, a aba, as células e os hashes. A ativação não transforma esses dados em regras fiscais aprovadas.",
  "productCatalog.import.target": "Destino da revisão",
  "productCatalog.import.newCatalog": "Criar novo catálogo",
  "productCatalog.import.name": "Nome do novo catálogo",
  "productCatalog.import.manifestFile": "Manifesto · manifest.json",
  "productCatalog.import.rowsFile": "Linhas preparadas · rows.jsonl",
  "productCatalog.import.validate": "Verificar arquivos localmente",
  "productCatalog.import.rows": "Linhas do manifesto",
  "productCatalog.import.worksheet": "Aba declarada",
  "productCatalog.import.sourceDigest": "Hash da origem declarado no manifesto",
  "productCatalog.import.rowsDigest": "SHA-256 das linhas preparadas",
  "productCatalog.import.bytes": "Bytes UTF-8 canônicos",
  "productCatalog.import.validated":
    "Estrutura, ordem, quantidade, bytes e hash das linhas conferem com o manifesto.",
  "productCatalog.import.upload": "Enviar rascunho em blocos de 100 linhas",
  "productCatalog.import.uploading": "Enviando blocos…",
  "productCatalog.import.resume": "Retomar envio com as mesmas solicitações",
  "productCatalog.import.progress": "{received} de {total} linhas confirmadas pelo servidor",
  "productCatalog.import.resumeHelp":
    "Ao fechar, o envio pausa após o bloco atual. Para retomar nesta sessão, selecione os mesmos arquivos e verifique-os novamente; as solicitações originais são reutilizadas.",
  "productCatalog.import.activationHelp":
    "Confira a origem e registre o motivo. A ativação torna esta revisão consultável e mantém as revisões anteriores. Pendências e duplicidades continuam visíveis.",
  "productCatalog.import.activate": "Ativar revisão conferida",
  "productCatalog.import.activated": "Revisão {version} do catálogo ativada",
  "productCatalog.import.finished":
    "Revisão ativada. Feche este painel para consultar os produtos ou reabra-o para preparar outra importação.",
  "productCatalog.import.storageWarning":
    "Não foi possível guardar os dados de retomada nesta sessão. Mantenha este painel aberto até concluir o envio e a ativação.",
  "productCatalog.import.error.size":
    "Os arquivos excedem o limite local de 1 MiB para o manifesto ou 128 MiB para as linhas.",
  "productCatalog.import.error.manifest":
    "O manifesto não corresponde ao formato preparado suportado. Revise-o no preparador local.",
  "productCatalog.import.error.row":
    "JSONL inválido ou posição de origem inconsistente na linha {row}. Nenhuma linha foi enviada nesta verificação.",
  "productCatalog.import.error.count":
    "A quantidade ou a sequência de linhas confirmadas não corresponde ao manifesto. O rascunho permanece sem ativação.",
  "productCatalog.import.error.digest":
    "Os bytes ou o SHA-256 canônico das linhas diferem do manifesto. Gere novamente os dois arquivos da mesma origem.",
  "productCatalog.supplier.create": "Registrar fornecedor",
  "productCatalog.supplier.name": "Nome declarado do fornecedor",
  "productCatalog.supplier.externalId": "Referência externa do fornecedor · opcional",
  "productCatalog.supplier.scope":
    "O fornecedor é declarado pelo operador. Marca, fabricante do produto e código interno não determinam seu perfil tributário.",
  "productCatalog.supplier.createdUnknown":
    "Registro criado sem perfil fiscal comprovado. Declare o perfil separadamente com fonte e período.",
  "productCatalog.supplier.choose": "Selecionar fornecedor declarado",
  "productCatalog.supplier.declare": "Declarar perfil do fornecedor",
  "productCatalog.supplier.profile": "Perfil declarado",
  "productCatalog.supplier.profile.UNKNOWN": "Desconhecido / não comprovado",
  "productCatalog.supplier.profile.INDUSTRY": "Indústria declarada",
  "productCatalog.supplier.profile.DISTRIBUTOR": "Distribuidor declarado",
  "productCatalog.supplier.currentDeclaration": "Perfil declarado vigente: {profile}",
  "productCatalog.supplier.saveDeclaration": "Registrar declaração e fonte",
  "productCatalog.supplier.declarationSaved":
    "Declaração registrada como DECLARED. Não comprova benefício, IPI ou ST anterior.",
  "productCatalog.binding.title": "Associar fornecedor à revisão",
  "productCatalog.binding.help":
    "Associação documental a uma revisão exata. O vínculo de SKU do fornecedor com um produto exige um mapeamento individual no detalhe do produto.",
  "productCatalog.binding.requiresRevision":
    "Selecione e carregue uma revisão ativa para registrar esta associação.",
  "productCatalog.binding.save": "Registrar associação à revisão",
  "productCatalog.binding.saved":
    "Associação registrada. Não cria automaticamente um mapeamento de SKU.",
  "productCatalog.link.title": "Mapear SKU declarado do fornecedor",
  "productCatalog.link.help":
    "Registre explicitamente qual SKU desse fornecedor identifica este produto nesta revisão. Exige fonte e período; não deduza pelo nome, GTIN, marca ou código interno.",
  "productCatalog.link.supplierSku": "SKU do fornecedor · declarado explicitamente",
  "productCatalog.link.save": "Registrar mapeamento com fonte",
  "productCatalog.link.saved": "Mapeamento explícito registrado",
  "productCatalog.field.status": "Situação declarada",
  "productCatalog.field.sku": "Código interno",
  "productCatalog.field.name": "Nome declarado",
  "productCatalog.field.family": "Família declarada",
  "productCatalog.field.brand": "Marca declarada",
  "productCatalog.field.model": "Modelo declarado",
  "productCatalog.field.gtinRaw": "GTIN original",
  "productCatalog.field.gtin": "GTIN normalizado",
  "productCatalog.field.ncmRaw": "NCM original",
  "productCatalog.field.ncm": "NCM normalizado",
  "productCatalog.field.ncmExtension": "Extensão de NCM declarada",
  "productCatalog.field.cestRaw": "CEST original",
  "productCatalog.field.cest": "CEST normalizado",
  "productCatalog.field.unit": "Unidade comercial declarada",
  "productCatalog.field.unitPriceRaw": "Preço unitário original",
  "productCatalog.field.unitPrice": "Preço unitário normalizado",
  "productCatalog.field.availableStockRaw": "Estoque original",
  "productCatalog.field.availableStock": "Estoque normalizado",
  "productCatalog.field.netWeightRaw": "Peso líquido original",
  "productCatalog.field.grossWeightRaw": "Peso bruto original",
  "productCatalog.field.heightRaw": "Altura original",
  "productCatalog.field.widthRaw": "Largura original",
  "productCatalog.field.depthRaw": "Profundidade original",
  "productCatalog.field.goodsOriginRaw": "Origem da mercadoria declarada",
  "productCatalog.field.characteristics": "Características declaradas",
  "productCatalog.field.includedAtRaw": "Inclusão na origem",
  "productCatalog.field.updatedAtRaw": "Atualização na origem",
  "productCatalog.issue.MISSING_SKU": "Código interno ausente",
  "productCatalog.issue.MISSING_NAME": "Nome ausente",
  "productCatalog.issue.IDENTIFIER_FORMAT_UNKNOWN": "Formato do identificador desconhecido",
  "productCatalog.issue.NUMERIC_IDENTIFIER_UNSAFE":
    "Identificador numérico com risco de perda de precisão",
  "productCatalog.issue.INVALID_NCM": "NCM inválido na origem",
  "productCatalog.issue.NCM_EXTENSION_PRESENT": "Extensão de NCM exige revisão",
  "productCatalog.issue.INVALID_CEST": "CEST inválido na origem",
  "productCatalog.issue.INVALID_GTIN": "GTIN inválido na origem",
  "productCatalog.issue.GTIN_SHARED": "GTIN compartilhado por códigos internos diferentes",
  "productCatalog.issue.SKU_REPEATED": "Código interno repetido em linhas diferentes",
  "productCatalog.issue.FORMULA_NOT_EVALUATED": "Fórmula não avaliada",
  "productCatalog.issue.PRICE_UNPARSEABLE": "Preço não interpretável",
  "productCatalog.issue.STOCK_UNPARSEABLE": "Estoque não interpretável",

  "calculationMemory.title": "Memória do cálculo",
  "calculationMemory.intro":
    "Fórmulas e dependências reconstruídas dos registros imutáveis deste item e da versão de regras vinculada.",
  "calculationMemory.qualification":
    "Esta memória explica o registro salvo. A qualificação jurídica e a aplicabilidade fiscal não foram realizadas por esta visualização.",
  "calculationMemory.loading": "Carregando a memória do item…",
  "calculationMemory.legacy":
    "A memória não está disponível para este registro. Os dados originais ou a trilha imutável necessários estão ausentes.",
  "calculationMemory.error": "Não foi possível carregar a memória do item.",
  "calculationMemory.retry": "Tentar novamente",
  "calculationMemory.status.AVAILABLE": "Memória disponível",
  "calculationMemory.status.PARTIAL": "Memória parcial",
  "calculationMemory.status.UNAVAILABLE": "Memória indisponível",
  "calculationMemory.cardStatus.CALCULATED": "Calculado",
  "calculationMemory.cardStatus.DECLARED": "Declarado",
  "calculationMemory.cardStatus.EXEMPT": "Isento conforme registro",
  "calculationMemory.cardStatus.OUTSIDE_SCOPE": "Fora do escopo do registro",
  "calculationMemory.cardStatus.PENDING": "Pendente",
  "calculationMemory.formula": "Fórmula",
  "calculationMemory.substitution": "Substituição",
  "calculationMemory.raw": "Resultado sem arredondamento",
  "calculationMemory.result": "Resultado da etapa",
  "calculationMemory.stored": "Valor salvo",
  "calculationMemory.rounding": "Arredondamento",
  "calculationMemory.roundingScale": "{scale} casas · {mode}",
  "calculationMemory.roundingNone": "Sem arredondamento nesta etapa",
  "calculationMemory.dependencies": "Depende de",
  "calculationMemory.none": "Nenhuma",
  "calculationMemory.unit": "Unidade",
  "calculationMemory.unit.BRL": "BRL · reais",
  "calculationMemory.unit.RATE": "Fração decimal (1 = 100%)",
  "calculationMemory.unit.COUNT": "Quantidade",
  "calculationMemory.unavailableValue": "Não disponível",
  "calculationMemory.source": "Origem do registro",
  "calculationMemory.source.INPUT": "Entrada original",
  "calculationMemory.source.PINNED_RULE": "Regra da versão vinculada",
  "calculationMemory.source.STORED_TRACE": "Trilha salva",
  "calculationMemory.source.DECLARED_REGIME": "Regime declarado",
  "calculationMemory.trace": "Etapas da trilha: {sequences}",
  "calculationMemory.blockers": "Pendências e limites",
  "calculationMemory.basis": "Base e quantidade",
  "calculationMemory.basisDetail": "{quantity} × {unit} · origem: {source} · valores: {scope}",
  "calculationMemory.inputBasis": "Preço original",
  "calculationMemory.normalizedBasis": "Base normalizada",
  "calculationMemory.extension": "Multiplicador da entrada",
  "calculationMemory.aggregation": "Multiplicador de agregação",
  "calculationMemory.binding": "Versão vinculada",
  "calculationMemory.evidence": "Evidência salva",
  "calculationMemory.rule": "Regra salva",
  "calculationMemory.recordedSource": "Fonte registrada",
  "calculationMemory.provenance": "Regras e evidências vinculadas",
  "calculationMemory.provenanceHint":
    "Os links e hashes pertencem ao registro salvo; não representam uma nova verificação da fonte.",
  "calculationMemory.GOODS": "Mercadoria",
  "calculationMemory.OWN_ICMS_DISPLAYED": "ICMS próprio exibido",
  "calculationMemory.FEDERAL_BASE": "Base federal",
  "calculationMemory.PIS": "PIS",
  "calculationMemory.COFINS": "COFINS",
  "calculationMemory.IPI": "IPI",
  "calculationMemory.ST_SEED": "Semente da ST",
  "calculationMemory.MVA": "MVA aplicada",
  "calculationMemory.ST_BASE": "Base da ST",
  "calculationMemory.ST_GROSS_DEBIT": "Débito bruto da ST",
  "calculationMemory.ST_OWN_DEDUCTION": "Dedução do ICMS próprio",
  "calculationMemory.ST_NET": "ST líquida",
  "calculationMemory.ACQUISITION_FISCAL": "Aquisição fiscal",
  "lotMap.field.base_preco": "Composição do preço de compra",
  "wb.field.base_preco": "Composição do preço de compra",
  // Explicit import formats and supplier declarations.
  "importTemplate.title": "Modelos de importação",
  "lotDeclaration.title": "Declarações comerciais para células vazias",
  "lotDeclaration.otherInputs": "dados da operação",
  "lotDeclaration.pendingInputs":
    "Linhas fora do cálculo: {count}. Revise: {fields}. A importação conserva essas linhas e os motivos.",
  "lotDeclaration.preflightPending":
    "Conferindo dados comerciais e fiscais da planilha. A confirmação ficará disponível após a conferência.",
  "lotDeclaration.hint":
    "Declare apenas o que está confirmado para todas as linhas desta aba. Uma célula preenchida prevalece, inclusive UNKNOWN. A origem da declaração fica no registro da importação.",
  "lotDeclaration.amountBasis": "O custo selecionado é",
  "lotDeclaration.commercialUnit": "Unidade comercial declarada",
  "lotDeclaration.unitPlaceholder": "Ex.: UN, CX de 12 unidades",
  "lotDeclaration.priceBasis": "Composição do custo selecionado",
  "lotDeclaration.purchaseStStatus": "Situação da ST na compra",
  "lotDeclaration.pisCofinsRegime": "Regime PIS/COFINS declarado",
  "lotDeclaration.option.UNKNOWN": "Não confirmado / exige revisão",
  "lotDeclaration.option.UNIT": "Preço por unidade comercial",
  "lotDeclaration.option.LINE_TOTAL": "Total da linha, já multiplicado",
  "lotDeclaration.option.GOODS_BEFORE_IPI_ST": "Mercadoria antes de IPI e ST adicionais",
  "lotDeclaration.option.ACQUISITION_INCLUDES_TAXES": "Aquisição com tributos incluídos",
  "lotDeclaration.option.NEW": "Sem declaração de ST anterior",
  "lotDeclaration.option.PRIOR_ST_INCLUDED": "ST anterior incluída: compra interna de distribuidor",
  "lotDeclaration.option.INVOICE_RETAINED": "ST destacada na nota fiscal",
  "lotDeclaration.option.CUMULATIVE": "Cumulativo",
  "lotDeclaration.option.NON_CUMULATIVE": "Não cumulativo",
  "lotDeclaration.review":
    "Preço com tributos incluídos e ST destacada na nota exigem composição e evidência antes do cálculo. Um percentual comercial não é MVA nem alíquota aprovada. Não aplique a toda a aba uma condição confirmada só para alguns produtos.",
  "importTemplate.xlsx": "Baixar Excel",
  "importTemplate.csv": "Baixar CSV",
  "importTemplate.txt": "Baixar TXT",
  "importTemplate.hint":
    "Identificadores como texto, preço e quantidade separados. O Excel inclui uma guia; CSV e TXT usam UTF-8 e ponto e vírgula. Declare as premissas fiscais antes de calcular.",
  "importTemplate.supplierFallback": "Tipo declarado do fornecedor para linhas sem essa informação",
  "importTemplate.supplierPerRow": "Usar a informação de cada linha",
  "importTemplate.industry": "Indústria ou equiparado",
  "importTemplate.distributor": "Distribuidor / revendedor comum",
  "importTemplate.supplierFallbackHint":
    "Preenche somente células vazias. Um valor desconhecido ou conflitante exige revisão. A declaração não comprova IPI, retenção ou ST anterior.",
  "lotMap.field.situacao_st_compra": "Situação da ST na compra",
  "lotMap.field.preco_venda": "Preço de venda",
  "lotMap.field.uf_destino_venda": "UF do comprador",
  "lotMap.field.tipo_comprador": "Perfil ICMS do comprador",
  "lotMap.field.regime_pis_cofins": "Regime PIS/COFINS declarado",
  "lotMap.field.deposito": "Depósito / linha de estoque",
  "lotMap.field.validade": "Vencimento / validade do estoque",
  "wb.field.situacao_st_compra": "Situação da ST na compra",
  "wb.field.preco_venda": "Preço de venda",
  "wb.field.uf_destino_venda": "UF do comprador",
  "wb.field.tipo_comprador": "Perfil ICMS do comprador",
  "wb.field.regime_pis_cofins": "Regime PIS/COFINS declarado",
  "wb.field.deposito": "Depósito / linha de estoque",
  "wb.field.validade": "Vencimento / validade do estoque",
  // Supplier snapshot: declarations and engine output remain independent.
  "supplierCard.title": "Fornecedor e ST anterior",
  "supplierCard.intro": "Entradas salvas e resposta do motor para esta linha.",
  "supplierCard.declarations": "Entradas declaradas",
  "supplierCard.returned": "Retornado pelo motor",
  "supplierCard.type": "Tipo de fornecedor declarado",
  "supplierCard.type.INDUSTRY": "Indústria",
  "supplierCard.type.DISTRIBUTOR": "Distribuidor comum",
  "supplierCard.priorSt": "ST anterior incluída no preço",
  "supplierCard.priorSt.true": "Declarada como paga anteriormente",
  "supplierCard.priorSt.false": "Pagamento anterior não confirmado",
  "supplierCard.unknown": "Não registrado · desconhecido",
  "supplierCard.stStatus": "Tratamento de ST retornado",
  "supplierCard.stStatus.PREVIOUSLY_PAID": "Paga anteriormente",
  "supplierCard.stStatus.CURRENT_RULE": "Regra selecionada para este cálculo",
  "supplierCard.stStatus.PENDING": "Pendente de revisão",
  "supplierCard.returnedProfile": "Perfil de fornecedor retornado",
  "supplierCard.returnedPriorSt": "Indicador de ST anterior do motor: {value}",
  "supplierCard.inputSource.calculation": "Fonte: entrada salva do cálculo",
  "supplierCard.inputSource.task": "Fonte: entrada salva da linha do lote",
  "supplierCard.inputUnavailable": "Entrada original indisponível neste registro",
  "supplierCard.mappedColumn":
    "Coluna mapeada: {cell}. O texto original da célula não foi preservado; uma declaração do arquivo pode se aplicar.",
  "supplierCard.resultSource": "Fonte: resposta salva do motor",
  "supplierCard.legacyUnknown": "Nenhum perfil de fornecedor foi registrado neste resultado.",
  "supplierCard.qualification":
    "São declarações da transação e resultados salvos do cálculo, não um cadastro verificado do fornecedor nem prova de retenção anterior. Campos ausentes continuam desconhecidos; o tipo de fornecedor sozinho não comprova isenção nem elegibilidade legal.",

  "operation.research.providerBudgetBlocked":
    "Um limite do provedor ou da reserva de orçamento bloqueou esta consulta. A evidência ausente continua pendente.",

  "operation.research.optIn": "Pesquisar e qualificar esta operação",
  "operation.research.rollout":
    "Pesquisa governada opcional. Evidências ausentes ficam pendentes; a qualificação automática completa do produto ainda não está disponível.",
  "operation.research.legacyScope":
    "Estimativa da versão publicada selecionada. A aplicabilidade atual ao produto e às partes não foi qualificada novamente. Não é uma cotação final.",

  "operation.research.billingPending":
    "A pesquisa paga aguarda a verificação de faturamento e uma campanha ativa com limite total de orçamento.",

  "operation.research.saved": "Revisão imutável {revision} salva",

  "research.family.IPI": "IPI",
  "research.family.FCP": "FCP",
  "research.family.PIS": "PIS",
  "research.family.COFINS": "COFINS",
  "research.origin.OPERATION": "Operação",

  "operation.research.PENDING": "Pesquisa fiscal pendente.",
  "operation.research.DISABLED": "A pesquisa não foi iniciada para todas as pendências.",
  "operation.research.REVIEW_REQUIRED": "Dados fiscais pendentes de revisão.",
  "operation.research.RECALCULABLE": "Há dados disponíveis para recalcular em uma nova revisão.",
  "operation.research.gaps": "Pendências para revisar: {count}.",
  "operation.research.failed": "Uma pesquisa falhou; os dados continuam pendentes.",
  "operation.research.cancelled": "Uma pesquisa foi cancelada; os dados continuam pendentes.",
  "operation.research.notFound":
    "Uma pesquisa não encontrou evidência para esta operação. Isso não significa isenção ou imposto zero.",
  "operation.research.capacityPending":
    "A pesquisa tem pendências por limites de capacidade ou custo.",
  "operation.research.costPending": "O custo máximo da consulta ainda precisa ser confirmado.",
  "operation.research.budgetPending": "A pesquisa aguarda orçamento mensal disponível.",
  "operation.research.activationPending":
    "A pesquisa está desativada, pausada ou aguarda autorização.",
  "operation.research.evidencePending": "Falta confirmar as fontes e se valem para esta operação.",
  "operation.research.otherBlocker": "Há uma pendência que precisa de revisão fiscal.",
  "operation.research.missingDetails": "Ver dados pendentes",
  "operation.research.next.PENDING": "Use Atualizar pesquisa para acompanhar o resultado.",
  "operation.research.next.DISABLED":
    "Peça ao responsável fiscal que verifique o que falta para iniciar.",
  "operation.research.next.REVIEW_REQUIRED":
    "Envie esta referência ao responsável fiscal para revisar os dados.",
  "operation.research.next.RECALCULABLE":
    "Escolha uma nova versão publicada e use Emitir nova revisão.",
  "operation.research.handoff":
    "A análise fiscal precisa dos documentos do produto e da operação para conferir as fontes, as partes e a data do negócio.",
  "operation.research.reference": "Referência da revisão:",
  "operation.research.details": "Sobre esta pesquisa",
  "operation.research.immutable":
    "Revisão {revision} · versão {version}. Novas evidências não alteram este resultado emitido.",
  "operation.research.scope":
    "A busca atual cobre evidências de ICMS/ST. IPI, FCP e contribuições dependem de fontes e condições qualificadas; NCM e CEST não comprovam o perfil completo do produto.",
  "operation.research.refresh": "Atualizar pesquisa",
  "operation.research.refreshError":
    "Não foi possível confirmar o estado atual. O último resultado permanece inalterado.",
  "operation.research.version": "Versão publicada para a nova revisão",
  "operation.research.chooseVersion": "Selecione uma versão",
  "operation.research.recalculate": "Emitir nova revisão",

  "spCoverage.selectionChanged":
    "A seleção mudou ou foi recusada antes de criar trabalho. Atualize a leitura, limpe a seleção e escolha as lacunas atuais. Nenhum reenvio com uma nova chave é necessário.",

  "spCoverage.workspaceTitle": "Qualificar, priorizar e pesquisar",
  "spCoverage.workspaceHelp":
    "Escolha o sentido e a UF. Confira os seis critérios e selecione lacunas reais para uma pesquisa limitada.",

  "spCoverage.title": "Cobertura das rotas de São Paulo",
  "spCoverage.priority": "Prioridade comercial · São Paulo",
  "spCoverage.intro":
    "Veja o que sustenta cada rota, o que falta comprovar e a próxima pesquisa necessária.",
  "spCoverage.hub": "Centro de operação",
  "spCoverage.esLater": "Espírito Santo na próxima fase",
  "spCoverage.direction": "Sentido da operação",
  "spCoverage.inbound": "Compra · ALL → SP",
  "spCoverage.outbound": "Venda · SP → ALL",
  "spCoverage.asOf": "Data fiscal",
  "spCoverage.ncm": "Filtrar por NCM",
  "spCoverage.allProducts": "Todos os produtos publicados",
  "spCoverage.ncmHint": "Informe os 8 dígitos para filtrar.",
  "spCoverage.refresh": "Atualizar leitura",
  "spCoverage.stale":
    "A atualização falhou. Os dados abaixo são a última leitura confirmada; novos envios estão bloqueados.",
  "spCoverage.published": "Versão publicada",
  "spCoverage.noBase": "Nenhuma base publicada",
  "spCoverage.observed": "Leitura confirmada",
  "spCoverage.scopeWarning":
    "Escopo atual: candidatos da base publicada. Sem escopo de produtos e perfis acreditado, atualização das fontes e recibos de testes, nenhuma rota pode ser declarada completa.",
  "spCoverage.shortStatus.COMPLETE": "Completa",
  "spCoverage.shortStatus.PARTIAL": "Parcial",
  "spCoverage.shortStatus.MISSING": "Sem regra",
  "spCoverage.shortStatus.BLOCKED": "Bloqueada",
  "spCoverage.shortStatus.RUNNING": "Em curso",
  "spCoverage.status.COMPLETE": "Completa",
  "spCoverage.status.PARTIAL": "Parcial",
  "spCoverage.status.MISSING": "Sem regra candidata",
  "spCoverage.status.BLOCKED": "Bloqueada",
  "spCoverage.status.RUNNING": "Em execução",
  "spCoverage.routes": "Rotas por UF",
  "spCoverage.chooseRoute":
    "Selecione uma UF para entender os critérios e as lacunas daquela rota.",
  "spCoverage.candidateRules": "candidatas",
  "spCoverage.qualification": "Critérios de cobertura",
  "spCoverage.underlying": "Qualificação fiscal:",
  "spCoverage.check.DECLARED_PRODUCT_SCOPE": "Produtos e perfis declarados",
  "spCoverage.check.APPLICABLE_RULES": "Regras candidatas na data",
  "spCoverage.check.SOURCE_PROVENANCE": "Documentos e proveniência",
  "spCoverage.check.SOURCE_CURRENTNESS": "Versão atual da fonte",
  "spCoverage.check.SUPPLIER_CASES": "Indústria e revenda",
  "spCoverage.check.VALIDATION_RECEIPTS": "Validação e recibos de testes",
  "spCoverage.reason.PRODUCT_PROFILE_SCOPE_NOT_QUALIFIED":
    "O universo de produtos, CEST e perfis ainda não foi acreditado para esta rota.",
  "spCoverage.reason.PUBLISHED_CANDIDATES_FOR_ROUTE_DATE_ONLY":
    "Existem regras candidatas publicadas. A contagem não comprova aplicabilidade a todos os produtos ou perfis.",
  "spCoverage.reason.NO_PUBLISHED_ICMS_CANDIDATE_FOR_ROUTE_DATE":
    "Nenhuma regra candidata de ICMS para esta rota e data foi encontrada na base publicada.",
  "spCoverage.reason.IMMUTABLE_REFERENCES_REQUIRE_DOCUMENT_VERIFICATION":
    "Há referências imutáveis com hash. O documento e sua aplicabilidade ainda precisam de verificação.",
  "spCoverage.reason.NO_BOUND_SOURCE_REFERENCE":
    "Nenhuma referência documental imutável está vinculada aos candidatos desta rota.",
  "spCoverage.reason.CURRENT_PRIMARY_SOURCE_VERSION_NOT_ATTESTED":
    "A vigência da regra não comprova que a última versão da fonte primária foi conferida.",
  "spCoverage.reason.INDUSTRY_AND_RESELLER_CASES_NOT_ATTESTED":
    "Faltam comprovantes dos casos de indústria e distribuidor/revendedor, incluindo ST e IPI quando aplicáveis.",
  "spCoverage.reason.ROUTE_PRODUCT_PROFILE_TEST_RECEIPTS_NOT_AVAILABLE":
    "Não há recibos de validação para o conjunto completo rota × produto × perfil.",
  "spCoverage.products": "produtos candidatos",
  "spCoverage.boundRefs": "referências vinculadas",
  "spCoverage.sources": "fontes cadastradas",
  "spCoverage.degraded": "degradadas",
  "spCoverage.gaps": "Lacunas observadas em cálculos",
  "spCoverage.gapHelp":
    "Selecione até 10 lacunas reais. Uma rota sem lacunas observadas ainda pode estar incompleta.",
  "spCoverage.noGap":
    "Nenhuma lacuna de cálculo registrada nesta leitura. Isso não comprova cobertura.",
  "spCoverage.active": "na fila ou em execução",
  "spCoverage.gapStatus.OPEN": "Disponível para pesquisa",
  "spCoverage.gapStatus.RESEARCHING": "Em pesquisa",
  "spCoverage.gapStatus.NO_RULE_FOUND": "Sem regra encontrada · revisar",
  "spCoverage.gapStatus.RULE_FOUND": "Resultado para revisão",
  "spCoverage.gapStatus.RESOLVED": "Resolvida",
  "spCoverage.gapStatus.DISMISSED": "Dispensada",
  "spCoverage.bounded":
    "Amostra limitada a 50 registros por rota. Os totais incluem os demais. Seleção bloqueada quando a lista de pesquisas ativas está truncada.",
  "spCoverage.batch": "Pesquisar lacunas selecionadas",
  "spCoverage.selected": "{count} de 10 lacunas selecionadas",
  "spCoverage.batchHelp":
    "Usa o fluxo existente de agentes, com orçamento e pausas atuais. Pedidos iguais ativos são reutilizados.",
  "spCoverage.permission": "É necessário acesso de execução de pesquisa e leitura de cálculos.",
  "spCoverage.dispatcher":
    "O executor não está configurado nesta instância. A leitura permanece disponível.",
  "spCoverage.estimating": "Verificando custo e limites…",
  "spCoverage.estimateError":
    "Não foi possível verificar custo e limites. O envio permanece bloqueado.",
  "spCoverage.requests": "solicitações estimadas",
  "spCoverage.lane.AVAILABLE": "disponível",
  "spCoverage.lane.PAUSED": "pausado",
  "spCoverage.lane.BUDGET": "limite de orçamento",
  "spCoverage.lane.DAILY_CAP": "limite diário",
  "spCoverage.lane.DISABLED": "desativado",
  "spCoverage.launch": "Iniciar lote limitado",
  "spCoverage.launching": "Enviando lote…",
  "spCoverage.retryBatch": "Consultar / repetir com a mesma chave",
  "spCoverage.clear": "Limpar seleção",
  "spCoverage.finishRetry": "Resolva o envio pendente antes de mudar o escopo.",
  "spCoverage.uncertain":
    "Um envio não foi confirmado. A sequência parou. Tente novamente com a mesma chave; não inicie outro lote equivalente.",
  "spCoverage.receipt":
    "Confirmado: {created} criadas · {joined} vinculadas · {reused} resultados reutilizados · {deferred} adiadas.",
  "spCoverage.noAutoPublish":
    "Pesquisa concluída não equivale a cobertura completa. Nenhuma regra é aprovada ou publicada por esta ação.",
  "spCoverage.activity": "Execuções e resultados da rota",
  "spCoverage.review": "aguardando revisão",
  "spCoverage.failed": "falhas ou cancelamentos",
  "spCoverage.research.QUEUED": "Na fila",
  "spCoverage.research.RUNNING": "Em execução",
  "spCoverage.research.FOUND": "Encontrada · revisar",
  "spCoverage.research.NOT_FOUND": "Sem resultado",
  "spCoverage.research.NEEDS_REVIEW": "Revisão necessária",
  "spCoverage.research.FAILED": "Falhou",
  "spCoverage.research.CANCELLED": "Cancelada",
  "spCoverage.provenance": "Versão, vigência e documentos",
  "spCoverage.provenanceHelp":
    "Amostra dos candidatos publicados e hashes vinculados. Não substitui a conferência das fontes primárias.",
  "spCoverage.openDate": "sem data final",
  "spCoverage.boundedRules": "Amostra limitada às primeiras 10 regras e 5 referências por regra.",
  "spCoverage.referenceTitle": "Referência da base publicada",
  "spCoverage.referenceHelp":
    "O mapa abaixo conta menções de UF nas regras. Não representa cobertura completa das rotas de compra ou venda.",

  "operation.pricing.strategy": "Preço de venda",
  "operation.pricing.fixed": "Preço fechado",
  "operation.pricing.tr": "Calcular por TR · SP → SP → SP",
  "operation.pricing.spHub": "Calcular por TR · todas as UFs → SP → todas as UFs",
  "operation.pricing.spHubScope":
    "O TR via SP exige o CD BackChannel em SP. Fornecedor e cliente podem estar em qualquer UF brasileira.",
  "operation.pricing.spHubHint":
    "Informe de 0 até menos de 100%, com até 6 casas decimais. Qualquer UF de fornecedor/cliente, com o CD em SP. Exige ST de compra, IPI, FCP e regras fiscais qualificados; aceitar a rota não comprova cobertura fiscal.",
  "operation.pricing.stBasis": "Base de ST da compra",
  "operation.pricing.stBasis.RESOLVED_NON_ST": "A regra de aquisição selecionada não calcula ST",
  "operation.pricing.stBasis.PRIOR_ST_INCLUDED":
    "ST pago anteriormente declarado como incluído no preço de compra",
  "operation.pricing.stBasis.DECLARED_INVOICE_ST":
    "ST retido positivo declarado da nota do fornecedor",
  "operation.pricing.stBasis.RESOLVED_SENDER_ST":
    "ST calculado com responsabilidade qualificada do remetente",
  "operation.pricing.netTarget": "Meta de contribuição · todas as UFs → SP → todas as UFs",
  "operation.pricing.targetRate": "Contribuição desejada / venda (%)",
  "operation.pricing.netHint":
    "Contribuição do P&L após os tributos qualificados da operação, créditos de compra e despesas declaradas. Não é meta de caixa nem lucro final da empresa. O CD deve estar em SP.",
  "operation.pricing.netExpensesHint":
    "Informe as três despesas como totais da linha; declare zero quando não houver custo. Editar uma despesa limpa a cotação líquida anterior.",
  "operation.pricing.expensesRequired":
    "Declare as três despesas antes de calcular a meta de contribuição. Informe zero explicitamente quando aplicável.",
  "operation.pricing.invalidTargetRate":
    "Informe uma contribuição desejada de 0 até menos de 100%, com até 6 casas decimais.",
  "operation.pricing.netScope": "A meta de contribuição exige o CD BackChannel em SP.",
  "operation.pricing.achievedMargin": "Contribuição calculada / venda",
  "operation.pricing.targetDifference": "Diferença para a meta · arredondada em centavos",
  "operation.pricing.netFormula":
    "Contribuição do P&L no centavo mais próximo após tributos qualificados, créditos de compra e despesas declaradas. Saldo de crédito permanece ativo e ST do cliente é repasse. Não se presume recuperação de ST nem tributos ou despesas não declarados.",
  "commercial.grossProfitMargin": "Lucro bruto / GMV · parcial",
  "commercial.purchaseGoodsBase": "Valor da mercadoria antes de IPI/ST",
  "commercial.purchaseFederalBase": "Base PIS/COFINS · aquisição",
  "commercial.purchaseIcmsCredit": "Crédito ICMS · aquisição",
  "commercial.purchaseSt": "ST retido / devido na aquisição",
  "commercial.saleFederalBase": "Base PIS/COFINS · venda",
  "commercial.saleOwnIcms": "Débito ICMS próprio · venda",
  "operation.pricing.rate": "TR sobre a venda (%)",
  "operation.pricing.hint":
    "Informe de 0 até menos de 100%, com até 6 casas decimais. Disponível para compra e venda internas em SP.",
  "operation.pricing.scope": "O cálculo por TR exige fornecedor, estabelecimento e cliente em SP.",
  "operation.pricing.invalidRate":
    "Informe um TR de 0 até menos de 100%, com até 6 casas decimais.",
  "operation.pricing.costBasis": "Custo da nota de aquisição",
  "operation.pricing.saleLineValue": "Venda calculada · total da linha",
  "operation.pricing.unitApproximation": "Venda unitária aproximada · só referência",
  "operation.pricing.formula":
    "Venda = custo da nota ÷ (1 − TR), arredondada a centavos. O total da linha é a referência. TR não é margem líquida; tributos de venda e despesas reduzem a contribuição.",
  "operation.pricing.review": "Revise as condições fiscais antes de calcular o preço.",
  "errors.OPERATION_PRICING_UNRESOLVED":
    "Preço pendente. Resolva as condições abaixo e calcule novamente.",
  "operation.pricing.blocker.INPUT_INVALID":
    "Confira a rota permitida pelo modo TR selecionado, o tipo de fornecedor e o TR.",
  "operation.pricing.blocker.PURCHASE_RULE_PENDING":
    "A regra ou o valor de aquisição não está resolvido.",
  "operation.pricing.blocker.PURCHASE_IPI_PENDING":
    "Falta o tratamento IPI aplicável à aquisição industrial.",
  "operation.pricing.blocker.PURCHASE_FCP_PENDING":
    "O FCP-ST da aquisição está desconhecido ou não está contabilizado no custo fiscal.",
  "operation.pricing.blocker.PURCHASE_ST_PENDING":
    "Confirme a situação ST e os valores retidos na nota do fornecedor.",
  "operation.pricing.blocker.SALE_RULE_PENDING": "A regra fiscal de venda está ausente ou ambígua.",
  "operation.pricing.blocker.MONETARY_LIMIT":
    "O custo ou preço calculado excede o limite monetário.",
  "operation.pricing.blocker.FEDERAL_TAXES_PENDING":
    "Tributos federais ou créditos de compra pendentes para a meta líquida.",
  "operation.pricing.blocker.SALE_FCP_PENDING":
    "O FCP de destino é desconhecido; qualifique a venda antes de calcular a meta líquida.",
  "operation.pricing.blocker.NET_TARGET_UNREACHABLE":
    "A contribuição desejada não tem solução positiva verificada em centavos.",
  "operation.pricing.blocker.PRICING_PRECISION_LIMIT":
    "A meta é alcançável, mas a busca limitada não consegue certificar o preço no centavo mais próximo. Ajuste a meta ou solicite uma revisão de precisão.",
  "autonomousResearch.scope.phase": "Fase SP · ALL → SP → ALL",
  "autonomousResearch.scope.planned":
    "{count} rotas planejadas pela política. Cobertura fiscal ainda não acreditada.",
  "autonomousResearch.scope.control":
    "O corte controla apenas novas tarefas do scheduler autônomo. Pesquisas manuais, outras automações, leases e filas anteriores e IOB externo seguem seus próprios fluxos.",
  "autonomousResearch.scope.recorded": "Escopo registrado na execução selecionada",
  "autonomousResearch.scope.unknown": "Escopo da execução anterior desconhecido",
  "autonomousResearch.scope.noRun": "Nenhuma execução registrada ainda",
  "autonomousResearch.scope.future":
    "ES exige uma mudança revisada e nova aceitação; não há avanço automático quando as lacunas chegam a zero.",
  "workbookDrafts.open": "Revisar extrato fiscal",
  "workbookDrafts.continue": "Revisar linhas guardadas",
  "workbookDrafts.title": "Revisão de linhas fiscais",
  "workbookDrafts.description":
    "Selecione linhas de um extrato guardado e organize as evidências para revisão.",
  "workbookDrafts.extractId": "ID do extrato guardado",
  "workbookDrafts.extractHint": "Use o ID do recibo gerado ao guardar o JSON fiscal.",
  "workbookDrafts.loadExtract": "Abrir extrato",
  "workbookDrafts.loading": "Carregando a revisão fiscal…",
  "workbookDrafts.working": "Processando…",
  "workbookDrafts.retry": "Tentar novamente",
  "workbookDrafts.error":
    "Não foi possível concluir a ação. Confira os dados e a conexão e tente novamente.",
  "workbookDrafts.denied": "Seu acesso não permite consultar esta revisão de linhas e evidências.",
  "workbookDrafts.notFound": "Extrato, rascunho ou documento não encontrado neste ambiente.",
  "workbookDrafts.unavailable":
    "O serviço de revisão está temporariamente indisponível. Tente novamente para verificar o resultado.",
  "workbookDrafts.invalidId": "Informe um ID válido para continuar.",
  "workbookDrafts.invalidReceipt":
    "É necessário um recibo fiscal guardado, válido e sem divergências.",
  "workbookDrafts.sourceTitle": "Origem do extrato",
  "workbookDrafts.extractHash": "SHA-256 do extrato",
  "workbookDrafts.parentHash": "SHA-256 declarado da planilha",
  "workbookDrafts.profile": "Perfil fiscal",
  "workbookDrafts.extractorVersion": "Versão do extrator",
  "workbookDrafts.parentVerification": "Verificação da planilha",
  "workbookDrafts.layoutVerification": "Verificação do mapeamento",
  "workbookDrafts.legalValidity": "Validade legal",
  "workbookDrafts.effectiveFrom": "Início de vigência",
  "workbookDrafts.effectiveTo": "Fim de vigência",
  "workbookDrafts.nullDate": "Não definida",
  "workbookDrafts.origin": "Origem",
  "workbookDrafts.status": "Estado",
  "workbookDrafts.workbook": "Planilha",
  "workbookDrafts.nonExecutable": "Fora dos cálculos",
  "workbookDrafts.noProposal": "Sem proposta associada",
  "workbookDrafts.rowsTitle": "Linhas para revisão",
  "workbookDrafts.rowsHint":
    "Selecione individualmente as linhas de compra ou venda com ST que deseja revisar. Réplicas da mesma linha são agrupadas; referências e linhas sem dados tipados ficam fora desta seleção.",
  "workbookDrafts.noRows": "Este extrato não contém linhas elegíveis para esta revisão.",
  "workbookDrafts.selectionCount": "{count} linhas selecionadas",
  "workbookDrafts.selectRow": "Selecionar {block}, linha {row}",
  "workbookDrafts.row": "Linha",
  "workbookDrafts.block": "Bloco fiscal",
  "workbookDrafts.observations": "Observações da origem",
  "workbookDrafts.locators": "Localizadores da origem",
  "workbookDrafts.recordHash": "SHA-256 da linha",
  "workbookDrafts.previewDrafts": "Revisar seleção",
  "workbookDrafts.previewTitle": "Prévia dos rascunhos",
  "workbookDrafts.batchHash": "SHA-256 da seleção revisada",
  "workbookDrafts.batchCounts": "{selected} linhas selecionadas · {blocked} rascunhos bloqueados",
  "workbookDrafts.previewNoWrites": "Esta prévia ainda não guardou rascunhos.",
  "workbookDrafts.confirmDrafts":
    "Confirmo estas linhas para guardar como rascunhos bloqueados. A origem continua declarada, a validade legal desconhecida e nenhuma regra será aprovada ou publicada.",
  "workbookDrafts.commitDrafts": "Guardar rascunhos bloqueados",
  "workbookDrafts.savedDrafts": "Seleção guardada para revisão",
  "workbookDrafts.savedCounts": "{created} rascunhos novos · {reused} já guardados",
  "workbookDrafts.verificationFailed":
    "Não foi possível confirmar os mesmos dados guardados. Atualize a leitura antes de continuar.",
  "workbookDrafts.retainedTitle": "Rascunhos guardados",
  "workbookDrafts.noDrafts": "Nenhum rascunho foi guardado para este extrato.",
  "workbookDrafts.refresh": "Atualizar lista",
  "workbookDrafts.readOnly":
    "Seu acesso permite consultar as linhas. Guardar rascunhos e vínculos não está disponível para este perfil.",
  "workbookDrafts.openDraft": "Abrir rascunho",
  "workbookDrafts.detailTitle": "Detalhe do rascunho",
  "workbookDrafts.chooseDraft":
    "Abra um rascunho guardado para revisar sua origem e as evidências vinculadas.",
  "workbookDrafts.draftId": "ID do rascunho",
  "workbookDrafts.createdAt": "Guardado em",
  "workbookDrafts.createdBy": "Guardado por",
  "workbookDrafts.blockers": "Pendências para revisão fiscal",
  "workbookDrafts.trustNotice":
    "Os rascunhos permanecem bloqueados e fora dos cálculos. Guardar linhas ou vincular evidências não aprova nem publica regras.",
  "workbookDrafts.linksTitle": "Evidências vinculadas",
  "workbookDrafts.noLinks": "Nenhuma evidência foi vinculada a este rascunho.",
  "workbookDrafts.evidenceTitle": "Vincular evidência para revisão",
  "workbookDrafts.evidenceId": "ID do documento de evidência",
  "workbookDrafts.evidenceHint":
    "Abra um documento aprovado, de fonte cadastrada no nível 1, e selecione um localizador exato do conteúdo verificado.",
  "workbookDrafts.loadEvidence": "Abrir documento",
  "workbookDrafts.evidenceNotApproved":
    "O vínculo exige um documento aprovado de fonte cadastrada no nível 1. Revise o documento na área de evidências.",
  "workbookDrafts.evidenceHash": "SHA-256 do conteúdo",
  "workbookDrafts.evidenceSource": "Fonte cadastrada",
  "workbookDrafts.evidenceReview": "Revisão do documento",
  "workbookDrafts.locator": "Localizador exato",
  "workbookDrafts.locatorPosition": "Caracteres {start} a {end}",
  "workbookDrafts.locatorCount": "{count} localizadores carregados",
  "workbookDrafts.moreLocators": "Carregar mais localizadores",
  "workbookDrafts.noLocators": "Nenhum localizador verificável nas páginas carregadas.",
  "workbookDrafts.purpose": "Finalidade da evidência",
  "workbookDrafts.choosePurpose": "Selecione a finalidade",
  "workbookDrafts.previewLink": "Revisar vínculo",
  "workbookDrafts.linkPreviewTitle": "Prévia do vínculo",
  "workbookDrafts.linkHash": "SHA-256 do vínculo revisado",
  "workbookDrafts.confirmLink":
    "Confirmo este documento, localizador exato e finalidade para registrar o vínculo para revisão. O rascunho continua bloqueado e a validade legal desconhecida.",
  "workbookDrafts.commitLink": "Guardar vínculo para revisão",
  "workbookDrafts.linkSaved": "Vínculo guardado para revisão",
  "workbookDrafts.linkTrust":
    "A aprovação do documento e o nível cadastral da fonte não confirmam a autoridade legal para esta linha. O vínculo mantém todas as pendências do rascunho.",
  "workbookDrafts.authorityAssessment": "Autoridade legal para esta linha",
  "workbookDrafts.reviewAtLink": "Revisão do documento ao vincular",
  "workbookDrafts.sourceTier": "Nível cadastral da fonte",
  "workbookDrafts.tierOne": "Nível 1",
  "workbookDrafts.variantHash": "SHA-256 da variante informada",
  "workbookDrafts.formulaHash": "SHA-256 da fórmula",
  "workbookDrafts.contentHash": "SHA-256 do texto omitido",
  "workbookDrafts.cacheTitle": "Resultado armazenado da fórmula",
  "workbookDrafts.block.PURCHASE_ST": "Compra · ST",
  "workbookDrafts.block.SALE_ST": "Venda · ST",
  "workbookDrafts.status.BLOCKED": "Bloqueado para uso fiscal",
  "workbookDrafts.legal.UNKNOWN": "Desconhecida",
  "workbookDrafts.provenance.DECLARED_UNVERIFIED": "Declarada; não verificada",
  "workbookDrafts.provenance.DECLARED_PROFILE_MAPPING": "Mapeamento declarado do perfil",
  "workbookDrafts.authority.UNASSESSED": "Não avaliada",
  "workbookDrafts.linkStatus.RECORDED_FOR_REVIEW": "Registrado para revisão",
  "workbookDrafts.documentReview.APPROVED": "Documento aprovado",
  "workbookDrafts.boolean.true": "Sim",
  "workbookDrafts.boolean.false": "Não",
  "workbookDrafts.blocker.SOURCE_PROVENANCE_DECLARED":
    "Origem declarada; planilha e mapeamento ainda não verificados",
  "workbookDrafts.blocker.OFFICIAL_EVIDENCE_REQUIRED":
    "Falta corroborar a linha com evidência oficial",
  "workbookDrafts.blocker.LEGAL_INTERVAL_UNKNOWN": "Período de vigência legal desconhecido",
  "workbookDrafts.blocker.CLASSIFICATION_UNRESOLVED": "Classificação fiscal pendente",
  "workbookDrafts.blocker.PRODUCT_SCOPE_UNRESOLVED": "Aplicabilidade ao produto pendente",
  "workbookDrafts.blocker.ROUTE_SCOPE_UNRESOLVED": "Aplicabilidade à rota pendente",
  "workbookDrafts.blocker.SUPPLIER_TAX_CONDITIONS_UNRESOLVED":
    "Condições fiscais do fornecedor pendentes",
  "workbookDrafts.blocker.COVERAGE_COMPARISON_REQUIRED":
    "Falta comparar com a cobertura fiscal existente",
  "workbookDrafts.blocker.MISSING_VALUE": "Há valores ausentes na origem",
  "workbookDrafts.blocker.UNKNOWN_UNIT": "Há valores decimais com unidade desconhecida",
  "workbookDrafts.blocker.FORMULA_NOT_EXECUTED": "Fórmula preservada como hash; não executada",
  "workbookDrafts.blocker.CACHE_UNAVAILABLE": "Resultado armazenado da fórmula indisponível",
  "workbookDrafts.purpose.CLASSIFICATION": "Classificação fiscal",
  "workbookDrafts.purpose.ST_APPLICABILITY": "Aplicabilidade da ST",
  "workbookDrafts.purpose.MVA": "MVA",
  "workbookDrafts.purpose.ROUTE_SCOPE": "Aplicabilidade à rota",
  "workbookDrafts.purpose.LEGAL_INTERVAL": "Vigência legal",
  "workbookDrafts.purpose.OTHER_FISCAL": "Outro tema fiscal",
  "workbookDrafts.field.sourceKey": "Identificador da origem",
  "workbookDrafts.field.originUf": "UF de origem informada",
  "workbookDrafts.field.ncmVariant": "NCM e variante informados",
  "workbookDrafts.field.ncmScope": "NCM ou prefixo informado",
  "workbookDrafts.field.cest": "CEST informado",
  "workbookDrafts.field.originalMva": "MVA original informada",
  "workbookDrafts.field.destinationInternalRate": "Alíquota interna de destino informada",
  "workbookDrafts.field.appliedMvaObservation": "MVA aplicada informada",
  "workbookDrafts.field.treatmentText": "Texto sobre tratamento fiscal",
  "workbookDrafts.field.legalReferenceText": "Texto de referência legal",
  "workbookDrafts.field.destinationUf": "UF de destino informada",
  "workbookDrafts.field.mvaObservation": "MVA informada",
  "workbookDrafts.field.stApplicabilityDeclaration": "Declaração de aplicação de ST",
  "workbookDrafts.field.productScopeText": "Texto sobre o alcance do produto",
  "workbookDrafts.unit.EXCEL_FRACTION": "Fração do Excel",
  "workbookDrafts.unit.PERCENT": "Percentual",
  "workbookDrafts.unit.UNKNOWN": "Unidade desconhecida",
  "workbookDrafts.kind.NCM": "NCM informado",
  "workbookDrafts.kind.NCM_VARIANT": "NCM e variante",
  "workbookDrafts.kind.CEST": "CEST informado",
  "workbookDrafts.kind.UF": "UF informada",
  "workbookDrafts.kind.DECIMAL": "Valor decimal da origem",
  "workbookDrafts.kind.BOOLEAN": "Declaração sim/não",
  "workbookDrafts.kind.HASH_ONLY": "Somente hash; texto omitido",
  "workbookDrafts.kind.MISSING": "Valor ausente",
  "workbookDrafts.kind.FORMULA": "Fórmula não executada",
  "workbookDrafts.cache.ABSENT": "Sem resultado armazenado",
  "workbookDrafts.cache.EMPTY": "Resultado armazenado vazio",
  "workbookDrafts.cache.VALUE": "Resultado armazenado; fórmula não executada",
  "workbookDrafts.normalizedText": "Trecho normalizado desta página",
  "workbookDrafts.evidenceSearch": "Buscar documentos aprovados",
  "workbookDrafts.evidenceSearchHint":
    "Busque um documento aprovado e confira o título e o publicador antes de selecionar.",
  "workbookDrafts.evidenceSearchPlaceholder": "Buscar documento",
  "workbookDrafts.evidenceSearchAction": "Buscar",
  "workbookDrafts.evidenceSearchResults": "{count} documentos aprovados nesta lista",
  "workbookDrafts.noEvidenceResults": "Nenhum documento aprovado encontrado. Ajuste a busca.",
  "workbookDrafts.chooseEvidence": "Selecionar documento",
  "workbookDrafts.evidencePublisher": "Publicador",
  "workbookDrafts.evidenceById": "Abrir por ID",
  "workbookDrafts.moreEvidence": "Carregar mais documentos",
  "workbookDrafts.evidenceDocument": "Documento de evidência",
  "fiscalExtract.open": "Guardar JSON fiscal",
  "fiscalExtract.title": "Admissão de extrato fiscal",
  "fiscalExtract.reset": "Limpar",
  "fiscalExtract.preview": "Pré-visualizar JSON",
  "fiscalExtract.working": "Processando…",
  "fiscalExtract.retain": "Guardar como NEW",
  "fiscalExtract.limits":
    "Cole apenas o extrato JSON fiscal permitido. Este fluxo não abre o XLSX nem verifica seu hash ou estrutura. A vigência legal continua desconhecida; nenhuma regra é aprovada ou publicada.",
  "fiscalExtract.json": "JSON fiscal (objeto extract)",
  "fiscalExtract.hint":
    "Perfil versionado COMMERCIAL_FISCAL_PARAMETERS_V1 · máximo 256 KB. Textos livres e fórmulas devem ser hashes; dados comerciais são rejeitados.",
  "fiscalExtract.error":
    "Não foi possível validar ou guardar este JSON. Confira contrato, seleção, permissões e conexão e gere outra prévia.",
  "fiscalExtract.saved": "Extrato guardado como NEW",
  "fiscalExtract.previewTitle": "Revisar prévia do JSON",
  "fiscalExtract.hash": "SHA-256 do extrato",
  "fiscalExtract.counts": "Observações selecionadas",
  "fiscalExtract.countValues":
    "Linhas fiscais tipadas: {fiscal} · sem dados tipados: {unknown} · referências geográficas: {geographic} · réplicas: {duplicates}",
  "fiscalExtract.valid":
    "Seleção JSON válida para guardar. Evidência oficial, procedência, vigência legal e aplicabilidade do produto ainda exigem revisão.",
  "fiscalExtract.blocked":
    "Gravação bloqueada: corrija os diagnósticos de estrutura, intervalo, tipo ou réplicas conflitantes.",
  "fiscalExtract.diagnostics": "Diagnósticos por linha",
  "fiscalExtract.confirm":
    "Confirmo que este JSON contém apenas a seleção fiscal permitida, sem dados comerciais. Entendo que o hash e o mapeamento do workbook são declarados e não verificados.",
  "fiscalExtract.savedBody":
    "Foi guardado um recibo JSON não executável. Nenhum documento de evidência aprovado, proposta ou regra foi criado. Recibo:",
  "fiscalExtract.diagnostic.LAYOUT_MAPPING_INVALID":
    "Mapeamento declarado não corresponde ao perfil",
  "fiscalExtract.diagnostic.PROFILE_RANGE_INVALID": "Planilha ou linha fora do perfil permitido",
  "fiscalExtract.diagnostic.DUPLICATE_LOCATOR": "Localizador de origem repetido",
  "fiscalExtract.diagnostic.CELL_TYPE_INVALID": "Tipo da célula incompatível com a coluna",
  "fiscalExtract.diagnostic.MISSING_VALUE": "Valor ausente",
  "fiscalExtract.diagnostic.UNKNOWN_UNIT": "Unidade decimal desconhecida",
  "fiscalExtract.diagnostic.FREE_TEXT_NOT_RETAINED": "Texto livre guardado apenas como hash",
  "fiscalExtract.diagnostic.FORMULA_NOT_EXECUTED": "Fórmula guardada como hash; não executada",
  "fiscalExtract.diagnostic.CACHE_UNAVAILABLE": "Sem cache utilizável da fórmula",
  "fiscalExtract.diagnostic.ALIAS_CONFLICT": "Planilhas replicadas divergem",

  "operation.federal.title": "PIS/COFINS da operação",
  "operation.federal.regime": "Regime declarado para esta simulação",
  "operation.federal.unknown": "Não informado / pendente",
  "operation.federal.cumulative": "Cumulativo",
  "operation.federal.nonCumulative": "Não cumulativo",
  "operation.federal.creditEligibility": "Direito ao crédito nesta aquisição",
  "operation.federal.eligible": "Aquisição elegível, conforme análise fiscal",
  "operation.federal.ineligible": "Sem direito ao crédito",
  "operation.federal.catalog": "Resolver pelo catálogo legal",
  "operation.federal.stBasis":
    "Análise fiscal confirma PIS/COFINS sobre o valor de venda quando ST encerra a operação interna.",
  "operation.federal.declarationHint":
    "Declarações do operador para esta simulação. O regime da BackChannel segue não acreditado; confirmar regime, enquadramento do produto e direito ao crédito com o responsável fiscal. Simples Nacional fora deste cálculo.",
  "operation.federal.calculatedScope":
    "PIS/COFINS incluídos conforme as declarações e fontes abaixo. Recuperação de ST não apurada; FCP só entra quando acompanhado. Esta simulação não certifica o regime da empresa.",
  "operation.federal.fiscalTotals":
    "Os totais desta memória ICMS/IPI mantêm seu escopo original. PIS/COFINS aparecem separadamente e entram na visão comercial somente quando calculados.",
  "operation.federal.base": "Base sem ICMS próprio",
  "operation.federal.pending.FISCAL_LEGS_PENDING":
    "PIS/COFINS aguardam a resolução fiscal da compra e da venda.",
  "operation.federal.pending.REGIME_UNKNOWN":
    "Informe o regime PIS/COFINS validado pelo responsável fiscal.",
  "operation.federal.pending.PROFILE_PENDING":
    "O perfil do produto exige confirmação fiscal; nenhuma alíquota foi presumida.",
  "operation.federal.pending.CREDIT_ELIGIBILITY_UNKNOWN":
    "Falta confirmar o direito ao crédito desta aquisição. Não foi subtraído crédito presumido.",
  "operation.federal.pending.ST_RESALE_BASIS_UNKNOWN":
    "Falta confirmar a base federal da revenda interna com ST encerrada na entrada.",
  "operation.federal.pending.POST_2026_REGIME":
    "A partir de 2027, este cálculo de PIS/COFINS fica pendente da transição CBS. Nenhuma alíquota anterior foi aplicada.",
  "operation.federal.pending.PURCHASE_OWN_ICMS_UNKNOWN":
    "Compra de distribuidor com ST anterior: falta o ICMS próprio destacado para determinar a base de crédito federal.",
  "operation.federal.pending.RATE_RULE_AMBIGUOUS":
    "Há regras federais publicadas concorrentes para esta rota; revisão necessária.",
  "commercial.federalPurchaseCredit": "Crédito PIS/COFINS da compra",
  "commercial.federalSaleDebit": "Débito PIS/COFINS da venda",
  "commercial.federalCarryover": "Saldo de crédito PIS/COFINS · ativo",
  "overview.issue.purchaseCreditBasePending": "Base de crédito da compra não confirmada",
  "issueHelp.purchaseCreditBasePending":
    "O preço inclui ST anterior, mas não há discriminação fiscal qualificada para calcular créditos de PIS/COFINS. Confirme a base com a equipe fiscal antes de usar o custo líquido ou a margem.",
  "calcTrace.step.SUPPLIER_CREDIT_BASE_PENDING": "Base de crédito da compra pendente",
  "supplier.type": "Tipo de fornecedor",
  "supplier.choose": "Selecione o tipo de fornecedor",
  "supplier.legacy": "Manter cálculo anterior · sem declaração",
  "supplier.industry": "Indústria",
  "supplier.distributor": "Fornecedor / distribuidor comum",
  "supplier.hint":
    "Distribuidor comum não destaca IPI de fabricante. Estabelecimento equiparado a industrial exige análise própria.",
  "supplier.priorSt": "ST já pago e incluído no preço?",
  "supplier.stUnknown": "Não verificado · revisar nota fiscal",
  "supplier.stConfirmed": "Sim · retenção anterior confirmada",
  "supplier.stNotConfirmed": "Não confirmado",
  "supplier.stHint":
    "A confirmação vale apenas na operação interna com ST vigente. Operações interestaduais exigem análise da retenção na nota; não há dispensa automática.",
  "supplier.templateHint":
    "Preencha tipo_fornecedor com INDUSTRY ou DISTRIBUTOR. Para distribuidor interno, st_pago_anteriormente=TRUE confirma ST anterior incluído no preço; FALSE ou vazio não confirma retenção. A regra vigente continua obrigatória.",
  "lotMap.field.tipo_fornecedor": "Tipo de fornecedor · INDUSTRY ou DISTRIBUTOR",
  "lotMap.field.st_pago_anteriormente": "ST anterior incluído · TRUE ou FALSE",
  "wb.field.tipo_fornecedor": "tipo de fornecedor",
  "wb.field.st_pago_anteriormente": "ST pago anteriormente",
  "overview.issue.purchaseStStatusPending": "ST da compra requer confirmação",
  "issueHelp.purchaseStStatusPending":
    "Revise a nota fiscal e a regra vigente: distribuidor não implica dispensa de ST; a retenção anterior só é confirmada em rota interna com ST aplicável.",
  "calcTrace.step.DISTRIBUTOR_IPI_NOT_CHARGED": "Distribuidor comum · sem IPI de fabricante",
  "calcTrace.step.SUPPLIER_ST_PREVIOUSLY_PAID": "ST anterior incluído no preço",
  "calcTrace.step.SUPPLIER_ST_PENDING": "Retenção de ST pendente de confirmação",
  "monetary.inputCost": "Custo da mercadoria",
  "monetary.resultBasisHint":
    "Para entradas UNIT ou LINE_TOTAL, os impostos e custos calculados são totais da linha. No formato anterior, são unitários. O custo editável mantém a base declarada na entrada.",
  "lotMap.field.custo_original": "Custo original declarado",
  "monetary.amountBrl": "Valor (R$)",
  "monetary.lotCostTotal": "Custo total do lote (com quantidades)",
  "monetary.tableHint":
    "Valores calculados na base indicada em cada linha: total da linha ou unitário no formato anterior.",
  "monetary.unitShort": "Unitário",
  "monetary.totalShort": "Total da linha",

  "monetary.templateHint":
    "No template, preencha base_valor com UNIT ou LINE_TOTAL e unidade_comercial com UN, CX etc. UNIT exige quantidade; não preencha tributos calculados.",
  "calcTrace.step.COMMERCIAL_FIXED_COSTS_EXTENDED":
    "Custos fixos por unidade comercial × quantidade",

  "monetary.basis": "Base dos valores",
  "monetary.unit": "Preço por unidade comercial · até 6 casas",
  "monetary.total": "Total de mercadoria da linha",
  "monetary.legacy": "Formato anterior · cálculo por unidade",
  "monetary.commercialUnit": "Unidade comercial (UN, CX…)",
  "monetary.totalCost": "Custo total da mercadoria (R$)",
  "monetary.lineQuantity": "Resultado por linha · quantidade comercial {quantity}",
  "monetary.result": "Custo fiscal total da linha",
  "monetary.lineUnit": "BRL por linha",
  "monetary.hint":
    "Preço unitário é multiplicado pela quantidade antes de arredondar a linha. Total de linha não é multiplicado novamente. CX é a unidade comercial; não se infere conteúdo da caixa.",
  "lotMap.field.base_valor": "Base do valor · UNIT ou LINE_TOTAL",
  "lotMap.field.unidade_comercial": "Unidade comercial",
  "wb.field.base_valor": "base do valor",
  "wb.field.unidade_comercial": "unidade comercial",
  "calcTrace.step.MONETARY_BASIS_NORMALIZED": "Valor total da linha normalizado",

  "commercial.editConditions": "Editar condições e despesas comerciais",
  "commercial.upfront": "À vista",
  "commercial.days": "{count} dias",
  "commercial.title": "Visão comercial",
  "commercial.subtitle": "Fluxo de caixa e P&L da mesma operação, com conciliação dos créditos.",
  "commercial.transaction": "Tipo de transação",
  "commercial.buySell": "Compra e venda",
  "commercial.status": "Status",
  "commercial.simulation": "Simulação · parcial",
  "commercial.supplierName": "Vendedor original",
  "commercial.customerName": "Comprador final",
  "commercial.partyLocation": "{name} · UF: {uf}",
  "commercial.category": "Categoria",
  "commercial.supplierPaymentDays": "Prazo do fornecedor (dias)",
  "commercial.customerPaymentDays": "Prazo do comprador (dias)",
  "commercial.paymentPlaceholder": "0 = à vista",
  "commercial.paymentHint":
    "Prazos informativos. Esta visão não projeta datas de caixa nem calcula juros pelo prazo.",
  "commercial.expenses": "Despesas comerciais da operação",
  "commercial.expensesHint":
    "Informe os totais em R$, inclusive zero quando não houver despesa. Não são preços unitários nem alíquotas fiscais.",
  "commercial.scope":
    "Subtotal parcial: PIS/COFINS pendentes ou fora desta simulação. FCP só entra quando acompanhado pela regra. Contribuição e margem abaixo não são o resultado final completo.",
  "commercial.cashFlow": "Fluxo de caixa",
  "commercial.cashHint": "Desembolso e recebimento; saldo de crédito não vira caixa.",
  "commercial.profitLoss": "P&L · resultado",
  "commercial.earningsHint": "Custo líquido do crédito e tributos da venda antes da compensação.",
  "commercial.salesPrice": "Preço de venda",
  "commercial.cashTaxes": "(−) Tributos pagos na venda · parcial",
  "commercial.netRevenue": "(=) Receita líquida · parcial",
  "commercial.acquisitionPrice": "(−) Preço de aquisição",
  "commercial.grossProfit": "(=) Lucro bruto · parcial",
  "commercial.operations": "Despesas operacionais",
  "commercial.commission": "Comissão de terceiros",
  "commercial.financing": "Custo de adiantamento de crédito",
  "commercial.contribution": "(=) Contribuição antes de bônus · parcial",
  "commercial.creditBalance": "Saldo de crédito fiscal · ativo",
  "commercial.gmv": "Receita bruta (GMV sem ST de repasse)",
  "commercial.earningsTaxes": "(−) Tributos sobre a venda · parcial",
  "commercial.cogs": "(−) Custo da mercadoria (CMV)",
  "commercial.margin": "Contribuição / GMV · parcial",
  "commercial.cashTaxesTitle": "Tributos e créditos",
  "commercial.icmsPayable": "ICMS a pagar",
  "commercial.difalFcp": "DIFAL e FCP na venda",
  "commercial.customerSt": "ST/FCP cobrado do cliente · repasse",
  "commercial.pisCofins": "PIS/COFINS",
  "commercial.pending": "Pendente",
  "commercial.stRecovery": "Recuperação de ST",
  "commercial.notAssessed": "Não apurada",
  "commercial.creditHint":
    "Crédito não utilizado é ativo. Recuperação de ST depende de análise e procedimento; não foi somada ao caixa nem ao lucro.",
  "commercial.acquisition": "Aquisição",
  "commercial.purchaseInvoice": "Valor de aquisição com IPI/ST",
  "commercial.purchaseCredit": "(−) Créditos fiscais da compra incluídos",
  "commercial.netInventory": "(=) Estoque líquido · parcial",
  "commercial.sales": "Venda",
  "commercial.salesInvoice": "(=) Total da NF de venda",
  "commercial.expensesPending":
    "Preencha as três despesas para calcular a contribuição. Use zero explicitamente quando não houver custo.",
  "commercial.unsaved": "Simulação comercial não salva",
  "commercial.hideInputs": "Recolher dados fiscais",
  "commercial.editInputs": "Editar compra e venda",

  "operation.supplierType": "Tipo de fornecedor",
  "operation.supplierType.industry": "Indústria ou equiparado",
  "operation.supplierType.distributor": "Distribuidor / revendedor comum",
  "operation.supplierType.hint":
    "Indústria: IPI e ST conforme a regra. Revendedor comum: sem IPI de fabricante; informe a situação da ST na compra.",
  "operation.valueBasis": "Valores informados",
  "operation.valueBasis.unit": "Preços por unidade",
  "operation.valueBasis.total": "Totais da operação",
  "operation.quantity": "Quantidade de unidades comerciais",
  "operation.quantity.hint":
    "Use a mesma unidade de compra e venda. Os preços mantêm até seis casas antes de multiplicar.",
  "operation.purchaseUnitValue": "Compra por unidade, antes de IPI e ST (R$)",
  "operation.saleUnitValue": "Venda por unidade, antes da ST de repasse (R$)",
  "operation.invalid.supplierType": "Selecione o tipo de fornecedor.",
  "operation.invalid.quantity": "Informe uma quantidade inteira de 1 a 999.999.999.",
  "operation.invalid.precision":
    "Confira os valores: unitários até seis casas, totais até duas e sem ultrapassar o limite monetário.",
  "operation.stPreviouslyPaid":
    "A NF confirma ST anterior incluída no preço, sem novo destaque nesta compra interna.",
  "operation.stPreviouslyPaid.short": "ST anterior incluída no preço",
  "operation.distributor.internalHint":
    "Confirme a ST anterior somente com suporte da NF. Sem confirmação, um produto sujeito à ST permanece em revisão.",
  "operation.distributor.interstateHint":
    "Em compra interestadual, informe a ST retida para o destino na NF. Ser distribuidor não dispensa a análise de antecipação.",
  "operation.issue.purchase_ipi_pending":
    "Falta resolver o tratamento de IPI da compra industrial. Ausência de informação não significa alíquota zero.",
  "operation.issue.purchase_fcp_pending":
    "O FCP-ST da compra está desconhecido ou não foi contabilizado no custo.",
  "operation.ipiPending": "IPI com tratamento fiscal pendente",
  "operation.issue.purchase_st_status_pending":
    "Confirme a ST da compra: retenção na NF ou ST anterior em compra interna.",
  "operation.commercialSummary": "Resumo comercial",
  "operation.closedSalePrice": "Preço de venda informado, com ST/FCP da NF quando aplicáveis.",
  "operation.showFiscalDetails": "Ver tributos, créditos e memória de cálculo",
  "operation.unitExtended": "Preço unitário × quantidade",
  "operation.distributorIpi": "IPI sem novo destaque pelo revendedor",
  "calcTrace.step.BASE_SELECTED": "Base de cálculo selecionada",
  "calcTrace.step.RULE_SELECTED": "Regra selecionada",
  "calcTrace.step.RULE_NOT_SELECTED": "Regra não encontrada",
  "calcTrace.step.TAX_EXEMPT": "Tributo isento",
  "calcTrace.step.TAX_EXCLUDED": "Não informado pela regra",
  "calcTrace.step.IPI_CALCULATED": "IPI calculado",
  "calcTrace.step.ICMS_ST_CALCULATED": "ICMS-ST calculado",
  "calcTrace.step.ICMS_ST_MVA_ADJUSTMENT": "Ajuste da MVA",
  "calcTrace.step.ICMS_ST_NOT_APPLICABLE": "ICMS-ST não se aplica",
  "calcTrace.step.ICMS_STANDARD_CALCULATED": "ICMS próprio calculado",
  "calcTrace.step.PIS_CALCULATED": "PIS calculado",
  "calcTrace.step.COFINS_CALCULATED": "COFINS calculada",
  "calcTrace.step.ISS_CALCULATED": "ISS calculado",
  "calcTrace.step.OPERATIONAL_COST_CALCULATED": "Custo operacional calculado",
  "calcTrace.step.COMMERCIAL_FEE_CALCULATED": "Taxa comercial calculada",
  "calcTrace.step.OPERATIONAL_COST_NOT_CONFIGURED": "Custo operacional não configurado",
  "calcTrace.step.COMMERCIAL_FEE_NOT_CONFIGURED": "Taxa comercial não configurada",
  "calcTrace.step.TOTAL_CALCULATED": "Custo fiscal posto calculado",
  "calcTrace.step.FCP_CALCULATED": "FCP calculado",
  "calcTrace.step.FCP_NOT_APPLICABLE": "FCP não se aplica",
  "calcTrace.step.FCP_NOT_TRACKED": "FCP não acompanhado",
  "calcTrace.step.PIS_COFINS_RATE_SELECTED": "Alíquotas de PIS/COFINS selecionadas",
  "calcTrace.step.PIS_COFINS_NOT_TRACKED": "PIS/COFINS não acompanhado",
  "calcTrace.step.SALE_PRICE_CALCULATED": "Preço de venda calculado",
  "calcTrace.step.PIS_ON_SALE_CALCULATED": "PIS na venda calculado",
  "calcTrace.step.COFINS_ON_SALE_CALCULATED": "COFINS na venda calculada",
  "calcTrace.step.MARGIN_CALCULATED": "Margem calculada",
  "calcTrace.step.NET_SALE_PRICE_CALCULATED": "Preço de venda pela margem líquida calculado",
  "calcTrace.step.NET_SALE_LEG_INVALID": "Perna de venda inválida",
  "calcTrace.step.NET_MARGIN_UNREACHABLE": "Margem líquida inalcançável",
  "calcTrace.step.PURCHASE_OWN_ICMS_CALCULATED": "ICMS próprio da compra calculado",
  "calcTrace.step.PURCHASE_OWN_ICMS_NOT_TRACKED": "ICMS próprio da compra não acompanhado",
  "calcTrace.step.PURCHASE_PIS_COFINS_CALCULATED": "PIS/COFINS da compra calculado",
  "calcTrace.step.PURCHASE_PIS_COFINS_NOT_TRACKED": "PIS/COFINS da compra não acompanhado",
  "calcTrace.step.TR_SALE_PRICE_CALCULATED": "Preço de venda (custo + TR) calculado",
  "calcTrace.step.TR_SALE_LEG_CALCULATED": "Perna de venda (custo + TR) calculada",
  "calcTrace.step.TR_SALE_IMPORTED_INTERSTATE_RATE":
    "Alíquota interestadual de importados na venda com TR (4%)",
  "calcTrace.step.NET_SALE_IMPORTED_INTERSTATE_RATE":
    "Alíquota interestadual de importados na venda a margem líquida (4%)",
  "calcTrace.step.ICMS_IMPORTED_INTERSTATE_RATE": "Alíquota interestadual de importados (4%)",
  "calcTrace.step.ICMS_GENERAL_RULE_APPLIED": "Regra geral de ICMS aplicada",
  "calcTrace.step.ICMS_DESTINATION_ST_DERIVED": "ICMS-ST do destino derivado",
  "calcTrace.step.ICMS_ST_FCP_IN_ALQ_INTRA": "FECP na alíquota interna da MVA ajustada",
  "calcTrace.step.ICMS_ST_SENDER_WITHHOLDING": "ST retido pelo remetente",
  "calcTrace.step.PURCHASE_OWN_ICMS_STATUTORY_RATE": "Alíquota interestadual legal do ICMS próprio",
  "calcTrace.step.RESALE_PURCHASE_CALCULATED": "Compra para revenda calculada",
  "calcTrace.step.RESALE_SALE_CALCULATED": "Venda de revenda calculada",
  "calcTrace.step.RESALE_MARGIN_CALCULATED": "Margem de revenda calculada",
  "calcTrace.step.RESALE_MARGIN_PENDING": "Margem de revenda pendente",
  "calcTrace.step.PIS_COFINS_PROFILE_RESOLVED": "Perfil de PIS/COFINS resolvido",
  "calcTrace.result.NOT_TRACKED": "não acompanhado",
  "calcTrace.result.NOT_CONFIGURED": "não configurado",
  "calcTrace.result.NOT_CALCULATED": "não calculado",
  "calcTrace.result.NOT_PRICED": "sem preço",
  "lotOps.fixedInput": "Rota fixa configurada para o arquivo",
  "lotOps.inferredBySheet": "Inferida pela planilha",
  "lotOps.editedInput": "Valor corrigido; no arquivo: {value}",
  "lotOps.finding": "Fato encontrado",
  "lotOps.missingFields": "Campos pendentes",
  "lotOps.detailDescription": "Resultados, cobertura e memória fiscal de cada linha.",
  "lotOps.today": "Operação de hoje",
  "lotOps.live": "Atualização automática",
  "lotOps.lotsToday": "Lotes hoje",
  "lotOps.rowsCalculated": "Linhas calculadas",
  "lotOps.rowsReview": "Linhas em revisão",
  "lotOps.taxRecorded": "Tributos registrados",
  "lotOps.researchRunning": "Pesquisas em andamento",
  "lotOps.summaryScope":
    "Todos os {count} lotes de hoje. Valores calculados × quantidade; cenários são alternativas independentes.",
  "lotOps.summaryLimited": "Há mais lotes no período.",
  "lotOps.upload": "Enviar planilhas",
  "lotOps.scenarios.one": "1 cenário deste arquivo",
  "lotOps.scenarios.other": "{count} cenários do mesmo arquivo",
  "lotOps.independentScenarios": "Alternativas; não somar entre si",
  "lotOps.open": "Abrir",
  "lotOps.export": "Exportar CSV",
  "lotOps.exportExcel": "Baixar Excel comercial",
  "lotOps.exportLimit": "Exportação limitada a 20.000 linhas.",
  "lotOps.recalculateHelp": "Abrir registro e selecionar novo conjunto para recalcular",
  "lotOps.actions": "Ações",
  "lotOps.eta": "~{minutes} min restantes",
  "lotOps.etaWaiting": "Estimando tempo restante",
  "lotOps.dynamic": "Rota por linha",
  "lotOps.allRoutes": "Todas as rotas",
  "lotOps.excluded": "Linhas excluídas",
  "lotOps.totalIpi": "Total IPI",
  "lotOps.totalSt": "Total ICMS-ST",
  "lotOps.totalLanded": "Custo fiscal total",
  "lotOps.coverage": "Cobertura",
  "lotOps.quantityTotals": "Totais com quantidades aplicadas uma vez; somente linhas calculadas.",
  "lotStory.title": "Da compra ao preço",
  "lotStory.basis":
    "Valores do lote ponderados por quantidade · {rows} de {total} linhas calculadas",
  "lotStory.loading": "Somando as linhas do lote…",
  "lotStory.purchase": "Custo de compra",
  "lotStory.purchaseTaxes": "Impostos na compra",
  "lotStory.otherTaxes": "outros tributos {value}",
  "lotStory.landed": "Custo posto",
  "lotStory.sale": "Preço de venda",
  "lotStory.margin": "Margem líquida",
  "lotStory.notPriced": "Não calculado",
  "lotStory.onSale": "Na venda:",
  "lotStory.pisCofinsUntracked": "PIS/COFINS não acompanhados neste regime",
  "lotStory.credits": "créditos {value}",
  "lotStory.saleSt": "ICMS-ST/FCP-ST nas NFs de venda {value}",
  "lotStory.invoices.title": "NF compra vs NF venda:",
  "lotStory.invoices.body": "compra {purchase} · venda {sale} · diferença bruta {difference}",
  "lotStory.invoices.pisCofinsNet": "PIS/COFINS a recolher (venda − crédito da compra) {value}",
  "lotStory.invoices.discounted":
    "Com o desconto da planilha (só exibição, não muda a base dos impostos): V final comprador {saleFinal} ({saleDiscount}) · V final vendedor {purchaseFinal} ({purchaseDiscount}) · diferença líquida {net}",
  "lotStory.invoices.discount.with": "desconto {pct} · {cell}",
  "lotStory.invoices.discount.none": "sem desconto",
  "lotStory.invoices.discount.hint":
    "Desconto comercial lido da planilha. Se for incondicional (na NF), reduz a base do ICMS e do PIS/COFINS; isso depende de confirmação do dono, então aqui só aparece nos totais.",
  "lotStory.priceHint":
    "Para ver preço de venda, PIS/COFINS na venda e margem, use Recalcular lote e escolha um método em Preço de venda.",
  "lotStory.notTracked": "não acompanhado",
  "lotStory.column.pis": "PIS venda",
  "lotStory.column.cofins": "COFINS venda",
  "lotStory.column.icmsSale": "ICMS venda",
  "lotStory.column.saleSt": "ICMS-ST/FCP-ST venda",
  "lotStory.column.saleStHint": "ICMS-ST + FCP-ST na NF de venda (coluna AU da planilha).",
  "lotStory.column.saleStFcpUntracked": "FCP-ST não acompanhado",
  "lotStory.column.buyerInvoice": "NF comprador",
  "lotStory.done": "Lote calculado",
  "lotStory.doneReview": "Lote calculado com linhas para revisar",
  "lotStory.rows.one": "{count} linha",
  "lotStory.rows.other": "{count} linhas",
  "lotStory.in": "em {duration}",
  "lotStory.seconds": "{count} s",
  "lotStory.minutesSeconds": "{minutes} min {seconds} s",
  "lotStory.calculated": "{count} calculadas",
  "lotStory.toReview": "{count} para revisar",
  "lotStory.excluded": "{count} excluídas",
  "lotStory.coverage": "cobertura hoje {value}",
  "lotStory.coverageStale":
    "A cobertura das regras publicadas atuais inclui {covered} linhas; este registro calculou {calculated}. O recálculo ainda verifica a qualificação fiscal da operação.",
  "lotStory.rules": "regras {version}",
  "lotStory.date": "data fiscal {date}",
  "lotStory.next.title": "Próximos passos",
  "lotStory.next.export": "Baixar Excel comercial",
  "lotStory.next.exportBody":
    "Todas as linhas, com impostos, preço, PIS/COFINS e regra de cada uma.",
  "lotStory.next.share": "Copiar link do lote",
  "lotStory.next.shareBody":
    "Para um colega com acesso abrir este mesmo resultado, com a memória fixada.",
  "lotStory.next.review.one": "Revisar {count} linha",
  "lotStory.next.review.other": "Revisar {count} linhas",
  "lotStory.next.reviewBody":
    "Filtra a tabela nas linhas que precisam de revisão, com o motivo de cada uma.",
  "lotStory.next.research.one": "Pesquisar {count} lacuna",
  "lotStory.next.research.other": "Pesquisar {count} lacunas",
  "lotStory.next.researchBody":
    "Combinações de rota e NCM sem regra publicada: o agente busca evidência na web para revisão.",
  "lotStory.linkCopied": "Link do lote copiado",
  "lotStory.linkManual": "Copie o link do lote",
  "lotStory.row.title": "História desta linha",
  "lotStory.row.base": "Custo",
  "lotStory.row.otherTaxes": "Outros tributos",
  "lotStory.row.icmsSale": "ICMS venda",
  "lotStory.row.credits": "Créditos",
  "lotStory.row.costBasis": "Custo posto (base do preço)",
  "lotStory.row.onSale": "Na venda, por unidade",
  "lotStory.row.notPriced":
    "Preço e margem não calculados: o lote foi calculado sem método de Preço de venda.",
  "lotStory.row.unusable":
    "Esta linha não tem valores utilizáveis: nenhum valor é mostrado até resolver a revisão.",
  "lotStory.compare.match": "Igual",
  "lotStory.compare.difference": "Diferente",
  "lotStory.compare.pending": "Sem cálculo",
  "lotStory.compare.allMatch": "· tudo igual ao arquivo",
  "lotStory.compare.differs": "· {count} diferença(s) do arquivo",
  "lotStory.outside.title": "Fora do custo posto:",
  "lotStory.outside.ownIcms": "ICMS próprio da compra {value}",
  "lotStory.outside.pisCofins": "PIS/COFINS da compra (fora da base) {value} · {treatment}",
  "lotStory.outside.treatment.CREDIT": "crédito (não cumulativo)",
  "lotStory.outside.treatment.INFORMATIONAL": "informativo (sem crédito neste regime)",
  "lotStory.outside.treatment.MIXED": "crédito ou informativo conforme o regime de cada linha",
  "lotStory.outside.pisCofinsUntracked":
    "PIS/COFINS da compra não acompanhado: escolha o regime PIS/COFINS ao recalcular o lote",
  "lotStory.outside.untrackedRows.one": "{count} linha sem regime PIS/COFINS",
  "lotStory.outside.untrackedRows.other": "{count} linhas sem regime PIS/COFINS",
  "lotStory.outside.burdenNeeded.one":
    "Regra necessária: {count} linha de operação interna sem redução de base declarada na regra. O ICMS próprio usou a alíquota nominal; se houver redução (ex.: art. 39 do Anexo II do RICMS/SP), ela precisa ser publicada na regra.",
  "lotStory.outside.burdenNeeded.other":
    "Regra necessária: {count} linhas de operação interna sem redução de base declarada na regra. O ICMS próprio usou a alíquota nominal; se houver redução (ex.: art. 39 do Anexo II do RICMS/SP), ela precisa ser publicada na regra.",
  "lotStory.row.outside": "Fora do custo posto (não soma no custo)",
  "lotStory.row.ownIcms": "ICMS próprio da compra",
  "lotStory.row.notInCost": "fora do custo",
  "lotStory.row.buyerInvoice":
    "NF venda do comprador = {price} + ICMS-ST {st} + FCP-ST {fcp} = {total}",
  "lotStory.row.ownIcmsFormula": "{base} × {rate}",
  "lotStory.row.ownIcmsReduced": "base reduzida {base} × {nominal} = carga de {rate} · {reference}",
  "lotStory.row.pisCofins": "PIS/COFINS da compra (fora da base)",
  "lotStory.row.pisCofinsFormula": "({base} − ICMS próprio {icms}) × {rate}",
  "lotStory.row.pisCofinsCredit": "crédito (não cumulativo)",
  "lotStory.row.pisCofinsInfo": "informativo",
  "lotStory.row.pisCofinsUntracked": "não acompanhado: escolha o regime PIS/COFINS do lote",
  "lotStory.row.burdenNeeded":
    "Regra necessária: a regra desta operação interna não declara redução de base; o ICMS próprio usou a alíquota nominal.",
  "lotStory.row.ownIcmsStatutory":
    "Alíquota interestadual legal do ICMS próprio (compra sem ST): {reference}.",
  "lotStory.row.burdenExpired":
    "A carga efetiva da regra está fora da vigência nesta data; o ICMS próprio usou a alíquota nominal.",
  "lotOps.partialTotals": "Subtotal parcial: pendências não entram nos valores.",
  "lotOps.byNcm": "Tributos por NCM",
  "lotOps.byRoute": "Tributos por rota",
  "lotOps.reviewReasons": "O que precisa de revisão",
  "lotOps.fixHint": "Selecione um motivo para ver as linhas afetadas.",
  "lotOps.fixCost": "Corrigir custo ou mapeamento no arquivo",
  "lotOps.fixClassification": "Revisar NCM, CEST e classificação",
  "lotOps.fixProfile": "Confirmar o tratamento pelo produto e recalcular",
  "lotOps.fixRule": "Pesquisar e revisar a regra; publicar antes de recalcular",
  "lotOps.rowCount": "{count} linhas",
  "lotOps.rowCountCalculated": "{calculated} de {count} linhas calculadas",
  "lotOps.resultCount": "{count} resultados",
  "lotOps.waitingResults": "Os resultados aparecerão conforme os blocos terminarem.",
  "lotOps.unavailable": "Valor indisponível",
  "lotOps.research": "Pesquisa fiscal desta planilha",
  "lotOps.webUnverified":
    "A pesquisa reúne evidências candidatas. A verificação da pesquisa e a publicação de regras são etapas distintas; consulte a situação de cada uma abaixo.",
  "lotOps.allResearch": "Ver pesquisas",
  "lotOps.noResearch":
    "Nenhuma pesquisa vinculada. Use “Buscar com agente?” para investigar as lacunas.",
  "lotOps.noGaps": "Nenhuma lacuna de cobertura neste conjunto.",
  "lotOps.rowResearch": "Pesquisa desta linha",
  "lotOps.sourceRow": "Linha {row} no arquivo",
  "lotOps.sourceUnavailable": "Coordenadas de origem não registradas para este lote.",
  "lotOps.ruleUnavailable": "Não há uma regra determinística para esta linha.",
  "lotOps.anyOrigin": "A regra aceita qualquer origem; o destino define o escopo.",
  "lotOps.stepInputs": "Entradas e precisão de cada etapa",
  "lotOps.compare": "Comparar com valores do arquivo",
  "lotOps.fileValue": "No arquivo",
  "lotOps.calculatedValue": "Calculado",
  "lotOps.noComparison": "O arquivo não tem colunas de comparação mapeadas.",
  "lotOps.tableHint": "Valores por unidade · abra a linha para ver a memória",
  "lotOps.inTape": "Ver memória",
  "lotOps.warning.short": "Com aviso",
  "lotOps.warning.coverageNeedsReview":
    "Revisar a regra {rule}: ela informa ICMS interestadual de {stated} para qualquer origem, mas a Res. SF 22/89 define {expected} para esta rota. Os valores não foram alterados.",
  "lotOps.warningRows": "Calculadas com aviso",
  "lotOps.group.base": "Base",
  "lotOps.group.ipi": "IPI",
  "lotOps.group.own": "ICMS próprio",
  "lotOps.group.st": "ICMS-ST",
  "lotOps.group.landedAmount": "Custo fiscal (R$)",
  "lotOps.stBaseAmount": "Base ST (R$)",
  "lotOps.group.landed": "Custo fiscal / un.",
  "lotOps.group.workbookCost": "Custo como na planilha",
  "lotOps.workbookCostFormula": "Prod + IPI + ST",
  "lotOps.workbookCostHint":
    "Como a planilha (coluna AQ): produtos + IPI + ICMS-ST. Não soma o ICMS próprio. O custo posto do motor soma o ICMS próprio quando não há ST (decisão pendente do dono).",
  "lotOps.importedOrigin": "Importada · {origin}",
  "lotOps.group.purchasePisCofins": "PIS/COFINS compra",
  "lotOps.purchasePisCofinsHint":
    "PIS/COFINS da compra fora da base: (custo − ICMS próprio) × alíquota. Não entra no custo.",
  "lotOps.group.issues": "Pendências",
  "lotOps.quantity": "Qtd.",
  "lotOps.rate": "Alíquota",
  "lotOps.perUnitBrl": "BRL / un.",
  "lotOps.mva": "MVA orig. → ajust.",
  "lotOps.stBase": "Base ST / un.",
  "lotOps.openRow": "Abrir memória de {item}",
  "lotOps.search": "Buscar item, SKU ou NCM",
  "lotOps.filter.status": "Todos os estados",
  "lotOps.filter.route": "Todas as rotas",
  "lotOps.filter.ncm": "Todos os NCMs",
  "lotOps.filter.issue": "Todas as pendências",
  "lotOps.clearFilters": "Limpar filtros",
  "lotOps.disconnected": "Atualização interrompida. Exibindo o último estado confirmado.",
  "lotOps.scenario": "Cenário fiscal",
  "lotOps.routeUnrecorded": "Modo de rota não registrado",
  "lotOps.pinnedRecord": "Registro fixado",
  "lotOps.queueTitle": "Fila de arquivos",
  "lotOps.queueHint":
    "Confirme as abas de cada arquivo, em sequência. Os lotes continuam em andamento.",
  "lotOps.queueMore": "Solte mais planilhas aqui ou escolha arquivos",
  "lotOps.nextFile": "Configurar próximo arquivo",
  "lotOps.nextFileUncalculated":
    "Este arquivo ainda não foi calculado: ao seguir, ele fica importado em Lotes, sem cálculo.",
  "lotOps.queuePosition": "Arquivo {current} de {total}",
  "lotOps.queueWaiting": "Na fila",
  "lotOps.queueActive": "Configurando",
  "lotOps.queueDone": "Abas confirmadas",
  "lotOps.queueSkip": "Pular arquivo",
  "lotOps.followLots": "Acompanhar todos os lotes",

  "calculatorFocus.back": "Voltar",
  "calculatorFocus.announce": "Modo calculadora. Pressione Escape para voltar.",
  "calculatorUi.memoryPermission":
    "Leitura da memória detalhada indisponível para este perfil. Consulte um operador com acesso aos cálculos.",
  "calculatorUi.currencyHint": "Moeda: reais brasileiros (BRL).",
  "calculatorUi.origin.entered": "Informado",
  "calculatorUi.origin.published": "Regra publicada",
  "calculatorUi.origin.calculated": "Calculado",
  "calculatorUi.origin.pending": "Pendente",
  "calculatorUi.origin.finding": "Evidência — pendente de revisão",
  "calculatorUi.origin.treatment": "Tratamento publicado",
  "calculatorUi.status.covered": "Coberto",
  "calculatorUi.status.missing": "Sem regra",
  "calculatorUi.status.stale": "Fora da vigência",
  "calculatorUi.status.researching": "Pesquisando",
  "calculatorUi.status.unchecked": "Não verificado",
  "calculatorUi.status.review": "Revisão necessária",
  "calculatorUi.why": "Por que este valor? {label}",
  "calculatorUi.date": "Data do cálculo",
  "calculatorUi.selected": "Conjunto selecionado",
  "calculatorUi.pinned": "Calculado com",
  "calculatorUi.viewMemory": "Ver memória",
  "calculatorUi.memory": "Memória de cálculo",
  "calculatorUi.purchasePisCredit": "Crédito de PIS · compra",
  "calculatorUi.purchaseCofinsCredit": "Crédito de COFINS · compra",
  "calculatorUi.memoryHint":
    "Entradas e valores do registro, em ordem de leitura. A memória original permanece nos detalhes.",
  "calculatorUi.result.empty": "Aguardando entradas",
  "calculatorUi.result.loading": "Calculando…",
  "calculatorUi.result.unavailable": "Valor indisponível",
  "calculatorUi.individual.empty":
    "Informe produto, rota e custo para calcular com as regras publicadas.",
  "calculatorUi.individual.definition": "Custo fiscal por unidade",
  "calculatorUi.operation.definition": "Carga tributária líquida da operação",
  "calculatorUi.unit": "BRL por unidade",
  "calculatorUi.operation.unit": "BRL · operação",
  "calculatorUi.unitQuantity": "Cálculo unitário · quantidade {quantity}",
  "calculatorUi.inputTitle": "Entradas do cenário",
  "calculatorUi.context": "Contexto do cálculo",
  "calculatorUi.scope":
    "Escopo: valores resolvidos pelo motor. Famílias não acompanhadas não equivalem a zero.",
  "calculatorUi.operation.scope":
    "PIS/COFINS e precificação fora deste cálculo. IBS/CBS e ISS não incluídos.",
  "calculatorUi.operation.empty": "Informe produto, as duas rotas e os valores de compra e venda.",
  "calculatorUi.operation.example": "Carregar exemplo",
  "calculatorUi.operation.exampleLoaded":
    "Exemplo carregado · revise as entradas antes de calcular.",
  "calculatorUi.operation.routeRequired": "Informe fornecedor, centro e cliente com UFs válidas.",
  "calculatorUi.operation.active": "Selecione um conjunto publicado para a operação.",
  "calculatorUi.operation.unsaved": "Simulação da operação · não é um registro salvo.",
  "calculatorUi.previous": "Resultado anterior — entradas alteradas",
  "calculatorUi.completed": "Cálculo concluído. Consulte o resultado abaixo.",
  "calculatorUi.goResult": "Ir para resultado",
  "calculatorUi.blocked": "As pendências impedem um resultado completo. Revise os motivos abaixo.",
  "calculatorUi.taxSubtotal": "Subtotal de tributos: {value}",
  "calculatorUi.formulaUnavailable":
    "Fórmula não informada neste registro. Consulte a memória completa.",
  "calculatorUi.sourceUnavailable": "Base legal não informada neste registro",
  "calculatorUi.sourceRelationship":
    "Fontes do registro. A ligação a um passo aparece somente quando informada pelo motor.",
  "calculatorUi.sources": "Regras e fontes ({count})",
  "calculatorUi.canonical": "Valor canônico",
  "calculatorUi.notCovered": "Não informado · não é alíquota zero",
  "calculatorUi.openRule": "Abrir regra aplicada",
  "calculatorUi.presentationOrder":
    "Ordem de leitura: principal → ICMS → base PIS/COFINS → IPI → MVA/ST → aquisição. Valores e memória original preservados.",
  "calculatorUi.rule": "Regra aplicada",
  "calculatorUi.precision": "Precisão e arredondamento",
  "calculatorUi.precisionUnavailable": "Precisão intermediária não informada neste registro.",
  "calculatorUi.numberLabel": "{label} · {unit} · reais",
  "calculatorUi.tape.empty":
    "A memória ficará disponível após o cálculo. Nenhuma alíquota foi presumida.",
  "calculatorUi.tape.loading": "Carregando a memória do registro…",
  "calculatorUi.tape.blocked": "Memória fiscal indisponível enquanto o resultado exige revisão.",
  "calculatorUi.tape.error": "Não foi possível carregar a memória. Tente novamente.",
  "calculatorUi.export.record": "Registro reproduzível com entradas, versão e memória.",
  "calculatorUi.export.partial":
    "Inclui pendências; valores indisponíveis permanecem identificados.",
  "calculatorUi.export.simulation": "Exportar simulação (JSON)",
  "calculatorUi.diff.title": "Comparação de revisões",
  "calculatorUi.diff.field": "Campo",
  "calculatorUi.diff.before": "Anterior",
  "calculatorUi.diff.after": "Atual",
  "calculatorUi.diff.delta": "Variação absoluta",
  "calculatorUi.mode.individual": "Individual",
  "calculatorUi.mode.workbook": "Planilha",
  "calculatorUi.mode.operation": "Compra e venda",
  "calculatorUi.mode.choose": "Qual cálculo usar?",
  "calculatorUi.mode.individualHint": "Um produto e um trajeto: confira o custo com tributos.",
  "calculatorUi.mode.operationHint": "Compra e revenda: compare caixa, resultado e preço de venda.",
  "calculatorUi.mode.workbookHint": "Vários produtos: envie uma planilha e acompanhe os lotes.",
  "operation.form.cestInvalid": "Informe os 7 dígitos do CEST ou deixe em branco.",
  "operation.design.purchaseTitle": "Compra e produto",
  "operation.design.saleTitle": "Venda e formação do preço",
  "operation.design.expensesTitle": "Despesas desta operação",
  "operation.design.declaredSummary": "Resumo das entradas",
  "operation.design.declaredOnly": "Valores declarados · ainda sem resultado",
  "operation.design.toCalculate": "A calcular",
  "operation.design.resultTitle": "Resultado da operação",
  "operation.design.resultSubtitle":
    "Caixa, resultado e tributos do mesmo cálculo. Revise as pendências antes de decidir.",
  "operation.design.contextDetails": "Dados da operação e formação do preço",
  "operation.design.saleTotal": "Venda · total sem ST de repasse",
  "operation.design.earningsBasis": "Base P&L · após despesas declaradas",
  "operation.design.statementTitle": "Como o resultado se forma",
  "operation.form.title": "Simule sua compra e venda",
  "operation.form.intro": "Informe o produto, o que você compra e para quem vai revender.",
  "operation.form.required": "Obrigatório",
  "operation.form.requiredHint":
    "* Campos obrigatórios. Dados fiscais ausentes podem exigir revisão.",
  "operation.form.product": "Produto",
  "operation.form.classification": "CEST e origem da mercadoria",
  "operation.form.classificationHint":
    "Informe conforme a nota fiscal. A classificação pode ser necessária para resolver as regras; ausência não significa isenção.",
  "operation.form.purchaseHint": "Do fornecedor até o centro de distribuição.",
  "operation.form.saleHint": "Do centro de distribuição até seu cliente.",
  "operation.form.unitHint": "Valor por unidade. A quantidade será aplicada à compra e à venda.",
  "operation.form.totalHint": "Valor total da operação. Sem multiplicação por quantidade.",
  "operation.form.invoiceSt": "ST da nota de compra",
  "operation.form.declared": "Valor declarado",
  "operation.form.priceGoal": "Como definir o preço de venda?",
  "operation.form.knownPrice": "Já tenho o preço",
  "operation.form.knownPriceHint": "Informe o valor para simular caixa e resultado.",
  "operation.form.findPrice": "Quero calcular o preço",
  "operation.form.findPriceHint":
    "Defina uma contribuição NET ou uma participação TR sobre a venda.",
  "operation.form.federalPending": "Regime não declarado · resultado pode ficar parcial",
  "operation.form.nextHint":
    "A simulação mostra fluxo de caixa e P&L. Pendências fiscais continuam visíveis.",
  "operation.form.submit": "Simular compra e venda",
  "operation.form.needExample": "Precisa de um exemplo?",
  "operation.form.resultHint":
    "Preencha os dados acima e simule para comparar fluxo de caixa e P&L. O detalhe fiscal estará disponível para consulta.",
  "operation.form.fixFields": "Revise os campos sinalizados antes de simular.",
  "operation.form.purchaseRequired": "Informe um valor de compra válido.",
  "operation.form.saleRequired": "Informe um preço de venda válido.",
  "operation.form.retainedInvalid":
    "Informe a ST da nota em reais, com até duas casas decimais, ou deixe em branco.",
  "calculatorUi.description": "Produto, rota e regras publicadas em um cálculo rastreável.",
  "calculatorUi.recent.retry": "Tentar carregar novamente",
  "calculatorUi.recent.review": "{count} itens aguardam revisão fiscal",

  "legacy.batch.exportJson": "Exportar memória (JSON)",
  "legacy.batch.exportCsv": "Exportar todas as linhas (CSV)",
  "legacy.batch.onlyReview": "Somente linhas que precisam de revisão ({count})",
  "legacy.batch.noReview": "Nenhuma linha deste arquivo precisa de revisão.",
  "legacy.breakdown": "Detalhamento de impostos e custos",
  "legacy.pricing": "Venda e pagamento",
  "legacy.resultEmpty":
    "Preencha a operação e calcule para consultar preço, custos, impostos e margem.",
  "workspace.operationsTitle": "Operações fiscais",
  "workspace.researchTitle": "Pesquisa com agentes",
  "review.savedResult": "Abrir resultado salvo",
  "review.progress": "{calculated} calculados · {review} para revisar",
  "evidence.empty.prepareResearch": "Preparar pesquisa deste NCM",
  "evidence.empty.researchHint":
    "Nenhum documento corresponde a estes filtros. Abra a pesquisa com este NCM, escolha as fontes e revise o motivo antes de iniciar.",
  "recalculateLot.action": "Recalcular lote",
  "recalculateLot.body":
    "Crie um novo cálculo para os {count} itens salvos com data de {date}, preservando as correções de entrada. O cálculo anterior continuará disponível.",
  "recalculateLot.previousVersion": "Versão original",
  "recalculateLot.nextVersion": "Nova versão publicada",
  "recalculateLot.noVersion": "Publique outra versão de regras antes de recalcular este lote.",
  "recalculateLot.incomplete":
    "Os dados salvos do lote estão incompletos ou inconsistentes. Atualize os resultados antes de tentar novamente.",
  "recalculateLot.submit": "Criar novo cálculo",
  "recalculateLot.created": "Novo cálculo do lote criado.",
  "recalculateLot.originalEngine": "Motor original",
  "recalculateLot.engineBefore": "anterior a {version}",
  "recalculateLot.unchanged.title": "Nada mudou desde o cálculo original.",
  "recalculateLot.unchanged.body":
    "Com as regras ({ruleset}) e o motor atual ({engine}), cada linha sairia igual ao cálculo original, então um novo cálculo não mudaria nada.",
  "recalculateLot.how": "Como recalcular",
  "recalculateLot.engine.title":
    "Recalcular com o motor atual ({engine}) e as mesmas regras ({ruleset})",
  "recalculateLot.engine.hint":
    "Mesmos itens, mesmas correções e mesma versão de regras; muda só o motor.",
  "recalculateLot.changes.title": "O que mudou desde o cálculo original",
  "recalculateLot.change.IMPORTED_PURCHASE_LINES":
    "Alinha o ICMS próprio da compra interestadual importada e a base de crédito de PIS/COFINS à alíquota aplicada de 4% (motor 1.19.0). Cria um novo registro e preserva o original.",
  "recalculateLot.change.PURCHASE_LINES":
    "1.6.0 · ICMS próprio e PIS/COFINS da compra fora da base",
  "recalculateLot.change.GENERAL_RULE":
    "1.7.0 · Regra geral (sem ST) para rotas sem regra publicada",
  "recalculateLot.change.PIS_COFINS_PROFILES":
    "1.8.0 · Perfis de PIS/COFINS (monofásico, alíquota zero, pendente)",
  "recalculateLot.change.ROUTE_RULES":
    "1.9.0 · ST derivada da regra de destino e regra geral na venda",
  "recalculateLot.change.ST_ADJUSTMENTS":
    "1.10.0 · FECP do RJ na MVA ajustada, ST retido pelo remetente PR→SP e ICMS próprio interestadual da compra",
  "recalculateLot.change.PIS_COFINS_CATALOG_V2":
    "1.13.0 · Catálogo legal PIS/COFINS ampliado para combustíveis e água mineral; produtos que exigem confirmação seguem para revisão",
  "recalculateLot.ruleset.title": "Usar outra versão publicada das regras",
  "recalculateLot.ruleset.hint": "Os itens são recalculados com a versão escolhida.",
  "recalculateLot.reason": "Motivo (opcional)",
  "recalculateLot.reasonPlaceholder": "Ex.: conferir o lote com o motor 1.13.0",
  "recalculateLot.audit":
    "Fica registrado quem recalculou, o motivo e o link para o lote original.",
  "pisCofinsConfirm.open": "Confirmar perfil em lote ({count})",
  "pisCofinsConfirm.title": "Confirmar perfil PIS/COFINS",
  "pisCofinsConfirm.intro":
    "O motor 1.8.0 não aplica alíquota zero quando a condição da lei não se prova pelo NCM, nem escolhe uma lista quando o NCM está em mais de uma. Confira o que o arquivo diz de cada produto e confirme o tratamento de cada NCM. A confirmação fica registrada com quem, quando e por quê; o cálculo original não muda.",
  "pisCofinsConfirm.loading": "Lendo os {count} itens que esperam confirmação…",
  "pisCofinsConfirm.notConfirmable":
    "Estes itens não são confirmáveis em lote: o catálogo não aceita confirmação para os seus NCMs (bebidas ou fora do catálogo). Abra o item para ver o motivo.",
  "pisCofinsConfirm.recalculate": "Recalcular com as confirmações",
  "pisCofinsConfirm.list.STANDARD": "Regime padrão (CST 01)",
  "pisCofinsConfirm.list.ZERO_RATE": "Alíquota zero (CST 06)",
  "pisCofinsConfirm.list.SINGLE_STAGE": "Monofásico (CST 04)",
  "pisCofinsConfirm.list.BEVERAGE": "Monofásico / bebidas frias",
  "pisCofinsConfirm.lists.note":
    "NCM em mais de uma lista. O motor não escolhe: indique qual se aplica a estes produtos. Nada vem pré-selecionado.",
  "pisCofinsConfirm.lists.hint.STANDARD":
    "O produto não se enquadra em nenhuma das listas abaixo: PIS/COFINS pelas alíquotas do regime, com crédito na compra quando não cumulativo.",
  "pisCofinsConfirm.lists.hint.ZERO_RATE":
    "O produto atende à condição desta lista: CST 06 na venda e sem crédito na compra (CST 73).",
  "pisCofinsConfirm.lists.hint.SINGLE_STAGE":
    "Revenda monofásica: CST 04 na venda e sem crédito na compra (CST 70).",
  "pisCofinsConfirm.lists.hint.BEVERAGE":
    "Indisponível: o motor não calcula o regime de bebidas frias (alíquotas do art. 25 para o atacadista). Se for esta a lista, o item continua em revisão.",
  "pisCofinsConfirm.lists.noSuggestion":
    "Sem sugestão para NCM em mais de uma lista: escolha depois de conferir o produto.",
  "pisCofinsConfirm.row.open": "Confirmar perfil PIS/COFINS",
  "pisCofinsConfirm.row.confirmed":
    "Confirmado: {treatment}. Entra no próximo cálculo deste arquivo; este cálculo continua como foi feito.",
  "pisCofinsConfirm.row.otherReasons":
    "Só o perfil PIS/COFINS é confirmado; os outros motivos de revisão continuam.",
  "pisCofinsConfirm.treatment.STANDARD": "Regime normal",
  "pisCofinsConfirm.treatment.ZERO_RATE": "Alíquota zero",
  "pisCofinsConfirm.treatment.SINGLE_STAGE_RESALE": "Monofásico (revenda)",
  "pisCofinsConfirm.qualifier.not": "não é {subject}",
  "pisCofinsConfirm.qualifier.is": "é {subject}",
  "pisCofinsConfirm.qualifier.outside": "fora da condição",
  "pisCofinsConfirm.qualifier.meets": "atende à condição",
  "pisCofinsConfirm.subject.ORDINARY_BREAD": "pão comum",
  "pisCofinsConfirm.subject.BREAD_PREMIX": "pré-mistura para pão comum",
  "pisCofinsConfirm.reason.suggested":
    "{treatment}: as descrições do arquivo citam {terms} (NCM {ncm}).",
  "pisCofinsConfirm.reason.default":
    "{treatment}: conferido pelas descrições do arquivo (NCM {ncm}).",
  "pisCofinsConfirm.done.one": "{count} item confirmado: {treatment}",
  "pisCofinsConfirm.done.other": "{count} itens confirmados: {treatment}",
  "pisCofinsConfirm.recorded":
    "Registrado com seu usuário, a data e o motivo. Entra no próximo cálculo deste arquivo.",
  "pisCofinsConfirm.groupTitle.one": "Confirmar perfil para {count} item com NCM {ncm}",
  "pisCofinsConfirm.groupTitle.other": "Confirmar perfil para {count} itens com NCM {ncm}",
  "pisCofinsConfirm.alreadyConfirmed": "{count} já confirmados neste arquivo",
  "pisCofinsConfirm.items": "Produtos, como o arquivo os descreve",
  "pisCofinsConfirm.selected": "{selected} de {total} selecionados",
  "pisCofinsConfirm.noDescription": "Sem descrição no arquivo",
  "pisCofinsConfirm.treatmentLabel": "Tratamento",
  "pisCofinsConfirm.hint.STANDARD":
    "CST 01: débito na venda e crédito na compra pelas alíquotas do regime.",
  "pisCofinsConfirm.hint.ZERO_RATE":
    "CST 06: sem débito na venda e sem crédito na compra. Só vale se o catálogo respaldar o NCM.",
  "pisCofinsConfirm.hint.SINGLE_STAGE_RESALE":
    "CST 04: revenda monofásica, sem débito nem crédito. Só vale se o catálogo respaldar o NCM.",
  "pisCofinsConfirm.suggested":
    "Pré-selecionado porque as descrições citam {terms}. Confira e confirme: nada é aplicado sem o seu clique.",
  "pisCofinsConfirm.noSuggestion": "Escolha o tratamento depois de conferir as descrições.",
  "pisCofinsConfirm.reason": "Motivo",
  "pisCofinsConfirm.audit":
    "Fica registrado quem confirmou, quando e o motivo. O cálculo original não muda.",
  "pisCofinsConfirm.submit.one": "Confirmar {treatment} para {count} item",
  "pisCofinsConfirm.submit.other": "Confirmar {treatment} para {count} itens",
  "pisCofinsConfirm.choose": "Escolha o tratamento",
  "pisCofinsConfirm.band.title.one": "{count} item com perfil PIS/COFINS confirmado",
  "pisCofinsConfirm.band.title.other": "{count} itens com perfil PIS/COFINS confirmado",
  "pisCofinsConfirm.band.body":
    "As confirmações entram no próximo cálculo deste arquivo; este cálculo continua como foi feito.",
  "recalculateLot.change.INPUT_CORRECTIONS": "Perfil PIS/COFINS confirmado em {count} itens",
  "recalculateLot.reasonConfirmations": "Recalcular com as confirmações de perfil PIS/COFINS",
  "calculateSheets.action.one": "Calcular {count} aba",
  "calculateSheets.action.other": "Calcular {count} abas",
  "calculateSheets.body":
    "Abas de {file} importadas e nunca calculadas. Cada aba usa as linhas, o mapeamento e as premissas guardados na importação; não é preciso enviar o arquivo de novo.",
  "calculateSheets.bodyNoFile":
    "Cada aba usa as linhas, o mapeamento e as premissas guardados na importação; não é preciso enviar o arquivo de novo.",
  "calculateSheets.listLabel": "Abas a calcular",
  "calculateSheets.reading": "Lendo as abas e as premissas de cada uma no arquivo guardado…",
  "calculateSheets.readingShort": "Lendo premissas…",
  "calculateSheets.rows": "{count} itens válidos",
  "calculateSheets.excluded": "{count} com erro ficam de fora",
  "calculateSheets.premise.tr": "TR {value}",
  "calculateSheets.premise.saleUf": "Venda para {value}",
  "calculateSheets.premise.regime.NON_CUMULATIVE": "PIS/COFINS não cumulativo",
  "calculateSheets.premise.regime.CUMULATIVE": "PIS/COFINS cumulativo",
  "calculateSheets.premise.regime.UNKNOWN": "Regime não informado",
  "calculateSheets.noPremises":
    "Sem premissas de venda na aba: calcula os tributos da compra, sem preço de venda.",
  "calculateSheets.unread":
    "Arquivo grande demais para reler as premissas aqui: calcula sem preço de venda, ou ajuste esta aba.",
  "calculateSheets.blockedPricing":
    "A TR da aba não tem UF de venda válida. Ajuste esta aba para calculá-la.",
  "calculateSheets.adjust": "Ajustar premissas",
  "calculateSheets.sending": "Criando cálculo…",
  "calculateSheets.state.created": "Em cálculo",
  "calculateSheets.state.failed": "Não iniciado",
  "calculateSheets.state.existing": "Já calculada",
  "calculateSheets.running": "Criando {done} de {total}…",
  "calculateSheets.retry": "Tentar de novo as que falharam",
  "calculateSheets.once":
    "Cada aba é calculada uma única vez: um segundo clique, outra aba do navegador ou um colega recebem o mesmo cálculo, sem duplicar.",
  "calculateSheets.created": "Cálculos das abas criados.",
  "calculateSheets.bandLabel": "Abas importadas sem cálculo",
  "calculateSheets.band.title.one": "{count} aba deste arquivo ainda não foi calculada",
  "calculateSheets.band.title.other": "{count} abas deste arquivo ainda não foram calculadas",
  "calculateSheets.band.body.one":
    "{sheets} foi importada com as premissas da própria aba. Calcule sem enviar o arquivo de novo.",
  "calculateSheets.band.body.other":
    "{sheets} foram importadas com as premissas de cada aba. Calcule sem enviar o arquivo de novo.",
  "calculateUpload.action": "Calcular",
  "calculateUpload.help": "Calcular a partir do arquivo já importado, sem enviar de novo",
  "calculateUpload.title": "Calcular planilha importada",
  "calculateUpload.body":
    "{count} itens válidos de {file} · {sheet}. Usa o arquivo e o mapeamento guardados na importação; não é preciso enviar de novo.",
  "calculateUpload.excluded": "{count} linhas com erro ficam de fora, como na importação.",
  "calculateUpload.readingPremises": "Lendo as premissas da planilha…",
  "calculateUpload.premisesNone":
    "A planilha não declara premissas de venda (TR, UF de venda, regime). Escolha-as abaixo para ver o preço de venda.",
  "calculateUpload.premisesUnavailable":
    "Não foi possível reler as premissas da planilha (TR, UF de venda, regime). Confira-as antes de calcular.",
  "calculateUpload.submit": "Calcular {count} itens",
  "calculateUpload.created": "Cálculo do lote criado.",
  "recalculation.basis.CURRENT_ENGINE": "Recalculado com o motor atual e as mesmas regras",
  "recalculation.basis.RULESET": "Recalculado com outra versão das regras",
  "recalculation.compare.title": "Comparação com o cálculo original",
  "recalculation.compare.openOriginal": "Abrir cálculo original",
  "recalculation.compare.rules": "Regras {before} → {after}",
  "recalculation.compare.engine": "Motor {before} → {after}",
  "recalculation.compare.byYou": "por você",
  "recalculation.compare.by": "por {id}",
  "recalculation.compare.reviewToCalculated": "Saíram da revisão",
  "recalculation.compare.calculatedToReview": "Foram para revisão",
  "recalculation.compare.stillReview": "Continuam em revisão",
  "recalculation.compare.taxDelta": "Variação de impostos",
  "recalculation.compare.newlyCalculatedTax": "Impostos dos itens que saíram da revisão",
  "recalculation.compare.note":
    "A variação compara só os itens calculados nos dois cálculos ({changed} mudaram): {before} → {after}, impostos da compra × quantidade.",
  "recalculation.compare.pinned": "O cálculo original continua fixado e não foi alterado.",
  "recalculation.compare.unmatched":
    "{count} itens não têm par no outro cálculo e ficaram fora da comparação.",
  "proposals.create.advancedEditingHint":
    "As alterações JSON são enviadas como informadas e não atualizam o formulário guiado. O tipo de regra permanece fixo durante a edição JSON. As referências de evidência são anexadas automaticamente.",
  "proposals.create.discardJson": "Descartar alterações JSON e voltar ao formulário guiado",
  "proposals.create.editJsonHint":
    "Continue a partir do rascunho guiado completo. O formulário guiado será preservado separadamente.",
  "proposals.create.startJsonHint":
    "O rascunho guiado está incompleto. Inicie um modelo JSON separado; os campos parciais continuarão disponíveis ao voltar, mas não serão copiados para o modelo.",
  "proposals.create.editJson": "Editar rascunho completo como JSON",
  "proposals.create.startJson": "Iniciar modelo JSON separado",
  "proposals.create.unlinkEvidence": "Remover",
  "proposals.create.linkedEvidence": "Evidências vinculadas",
  "proposals.create.linkedEvidenceHint":
    "Anexe os documentos aprovados que fundamentam a alíquota, rota, vigência e exceções. Até 100 documentos; o servidor confere novamente a aprovação ao criar a proposta.",
  "proposals.create.removeEvidence": "Remover evidência: {title}",
  "proposals.create.addEvidence": "Adicionar evidência aprovada",
  "proposals.create.changeEvidence": "Trocar evidência",
  "proposals.create.selectEvidence":
    "Escolha uma evidência aprovada para fundamentar a nova proposta.",
  "proposals.create.noEvidence":
    "Nenhuma evidência aprovada encontrada. Revise as evidências antes de criar uma proposta.",
  "proposals.create.type.fiscal": "Parâmetro fiscal",
  "proposals.create.type.commercial": "Taxa comercial",
  "proposals.create.type.operational": "Custo operacional",
  "proposals.create.business.scope": "Aplicabilidade",
  "proposals.create.business.scopeHint":
    "Identificadores exatos opcionais. Campos vazios se aplicam a todos os valores da organização.",
  "proposals.create.business.category": "Categoria",
  "proposals.create.business.paymentMethod": "Forma de pagamento",
  "proposals.create.business.transactionType": "Tipo de transação",
  "proposals.create.business.takeRate": "Taxa comercial (%)",
  "proposals.create.business.percentHint":
    "Informe um percentual de 0 a 100. Por exemplo, 10 significa 10%.",
  "proposals.create.business.logistics": "Logística",
  "proposals.create.business.freight": "Frete",
  "proposals.create.business.other": "Outros custos",
  "proposals.create.business.formula": "Método de cálculo",
  "proposals.create.business.fixed": "Valor fixo (BRL)",
  "proposals.create.business.percent": "Percentual (%)",
  "proposals.create.business.amount": "Valor (BRL)",
  "proposals.create.business.amountHint":
    "Informe um valor não negativo em reais. Informe 0 explicitamente se este custo não se aplicar.",
  "review.nextTitle": "O que fazer agora",
  "review.correctInput":
    "Confira o produto, a rota e o custo fiscal; depois execute um novo cálculo.",
  "review.fiscalHelp":
    "Revise as regras fiscais aplicáveis. Alíquotas ausentes ou conflitantes precisam de uma proposta revisada e de uma versão publicada.",
  "review.costHelp":
    "Revise as comissões e os custos operacionais. Aprovar uma proposta não altera, por si só, um cálculo salvo.",
  "review.immutableHelp":
    "Cada novo cálculo mantém o resultado anterior e sua versão de regras inalterados.",
  "review.correctRecalculate": "Corrigir e recalcular",
  "review.inspectRules": "Revisar regras aplicáveis",
  "review.proposeRule": "Criar proposta de regra",
  "review.loadSource": "Recupere a entrada original para preparar um novo cálculo.",
  "review.sourceUnavailable":
    "A entrada original não está disponível para este registro. Inicie um novo cálculo com os dados verificados do produto e seu custo.",
  "review.sourceLoaded":
    "Entrada original recuperada da versão {version}. Revise os campos e escolha a versão publicada para o novo cálculo. Nada é enviado automaticamente.",
  "review.amountsPending":
    "Valores e alíquotas não são definitivos enquanto este item exigir revisão.",
  "review.taskHelp":
    "Este arquivo precisa de revisão. Abra uma linha afetada para conferir os dados ou regras. Após publicar as correções, crie um novo cálculo; tentar novamente uma tarefa interrompida não aplica novas regras.",
  "lotMap.empty": "Nenhuma aba legível foi encontrada. Escolha outro arquivo XLSX ou CSV.",
  "lotMap.inspecting": "Lendo abas e sugerindo colunas…",
  "lotMap.requiredCost": "Selecione a coluna de custo da mercadoria para continuar.",
  "lotMap.duplicateColumns":
    "Cada coluna de origem só pode ser atribuída a um campo. Revise as seleções destacadas.",
  "lotMap.originalHelp":
    "Este download contém o arquivo original. As correções no cálculo não o alteram.",
  "lotMap.downloading": "Preparando download…",
  "ui.results.new": "Novo cálculo",
  "legacy.batch.template": "Baixar modelo CSV (v8)",
  "legacy.batch.supplier": "Padrões do fornecedor",
  "legacy.batch.error":
    "Confira o modelo de 26 colunas, os valores numéricos, a data e os limites (5 MB / 500 linhas).",
  "legacy.batch.count": "{count} linhas processadas",
  "legacy.batch.product": "Produto / NCM",
  "legacy.batch.result": "Situação e pendências",
  "legacy.batch.sale": "Preço de venda",
  "legacy.batch.margin": "Margem",

  "rules.detail.fiscal.title": "Parâmetros fiscais publicados",
  "rules.detail.fiscal.ipi": "IPI",
  "rules.detail.fiscal.internal": "ICMS interno",
  "rules.detail.fiscal.interstate": "ICMS interestadual",
  "rules.detail.fiscal.st": "ICMS-ST declarado",
  "rules.detail.fiscal.mva": "MVA original",
  "rules.detail.fiscal.effectiveRate": "Carga efetiva (ALQ intra da MVA)",
  "rules.detail.fiscal.effectiveUntil": "até {date}",
  "rules.detail.fiscal.adjustedMva": "MVA ajustada publicada",
  "rules.detail.fiscal.missing": "Não informado",
  "rules.detail.fiscal.yes": "Aplicável",
  "rules.detail.fiscal.no": "Não aplicável",
  "rules.detail.fiscal.ipiTreatment": "Tratamento do IPI",
  "rules.detail.fiscal.icmsTreatment": "Tratamento do ICMS",
  "rules.detail.fiscal.mode": "Modo do ICMS",
  "rules.detail.fiscal.reduction": "Redução da base (%)",
  "rules.detail.fiscal.conditions": "Condições adicionais",
  "rules.detail.fiscal.payment": "Meio de pagamento",
  "rules.detail.fiscal.transaction": "Tipo de transação",
  "rules.detail.fiscal.TAXED": "Tributado",
  "rules.detail.fiscal.EXEMPT": "Isento",
  "rules.detail.fiscal.EXCLUDED": "Excluído",
  "rules.detail.fiscal.unspecified.one": "{count} parâmetro não informado",
  "rules.detail.fiscal.unspecified.other": "{count} parâmetros não informados",
  "rules.detail.fiscal.empty": "Nenhum parâmetro informado",
  "rules.detail.sourceNote": "Nota da fonte (texto original)",

  "workspace.calculationDescription":
    "Confira os impostos e as pendências de cada produto. Abra a explicação para ver como o resultado foi calculado.",
  "workspace.calculationSummary": "Resumo do cálculo",

  "workspace.savedCommercialNote":
    "Este registro preserva as revisões de entradas comerciais do fluxo original. Elas não são campos adicionais solicitados pela calculadora fiscal.",
  "lookup.routeFilter": "Filtrar por trajeto e data",
  "lookup.routeOptional": "Opcional · consulte o NCM antes de definir a operação",
  "lookup.dateMissing": "Data não definida",
  "lookup.useToday": "Usar a data de hoje",
  "lookup.clearRoute": "Limpar trajeto e data",
  "lookup.refineMissing": "Para filtrar pela operação, preencha: {fields}.",
  "lookup.officialClassification": "Consultar classificação oficial",
  "workspace.individualVersionUnavailable":
    "Selecione uma versão de regras disponível para simular.",

  "workspace.addEvidence": "Pesquisar questão",
  "workspace.unitCostSum": "Soma dos custos unitários (sem quantidades)",
  "workspace.openFile": "Abrir a importação",
  "workspace.reviews": "Revisões",
  "workspace.documents": "Documentos",
  "workspace.discovery": "Pesquisar questão",
  "workspace.publications": "Publicações",
  "workspace.individual": "Individual",
  "workspace.spreadsheet": "Planilha",
  "workspace.optionalColumns": "Mais colunas (opcionais)",
  "workspace.fileType": "Escolha Excel (.xlsx, .xlsm), CSV ou TXT delimitado.",
  "workspace.newProposal": "Escolher evidência para criar proposta",
  "lookup.registered": "Regras publicadas para este NCM",
  "lookup.registeredNote":
    "Estas regras estão vinculadas ao NCM. O trajeto e a data ajudam a refinar a consulta.",
  "lookup.noRegistered": "Nenhuma regra publicada para este NCM",
  "lookup.noRegisteredBody":
    "A base ainda não tem regras publicadas para este código. Isso não significa imposto zero. Consulte outro produto ou a biblioteca de regras.",
  "ui.filters.remove": "Remover filtro: {filter}",
  "ui.results.search": "Buscar cálculos salvos",
  "ui.upload.pending": "Lendo seu arquivo…",
  "customer.results.action": "Ver resultados",
  "lookup.title": "Consultar regras",
  "workspace.operation": "Compra + venda",
  "operation.title": "Impostos da operação de revenda",
  "operation.body":
    "Compra do fornecedor para o CD da BackChannel e venda ao cliente, com as regras publicadas de cada trecho. Informe preço fechado, TR ou uma meta de contribuição via SP.",
  "operation.route": "Trajeto da operação",
  "operation.supplier": "Fornecedor (UF)",
  "operation.supplierHint": "Quem emite a NF de compra",
  "operation.center": "CD BackChannel (UF)",
  "operation.centerHint": "Onde a BCH recebe e revende",
  "operation.customer": "Cliente (UF)",
  "operation.customerHint": "Destino da venda",
  "operation.cest": "CEST (opcional)",
  "operation.goodsOrigin": "Origem da mercadoria (CST)",
  "operation.goodsOrigin.hint":
    "Origens 1, 2, 3 e 8 usam a alíquota interestadual de 4% (Resolução do Senado 13/2012). Não informado: vale a alíquota da regra.",
  "operation.goodsOrigin.notInformed": "Não informado",
  "operation.goodsOrigin.option.0": "Nacional",
  "operation.goodsOrigin.option.1": "Estrangeira, importação direta",
  "operation.goodsOrigin.option.2": "Estrangeira, adquirida no mercado interno",
  "operation.goodsOrigin.option.3": "Nacional, conteúdo de importação acima de 40% e até 70%",
  "operation.goodsOrigin.option.4": "Nacional, processos produtivos básicos (PPB)",
  "operation.goodsOrigin.option.5": "Nacional, conteúdo de importação até 40%",
  "operation.goodsOrigin.option.6": "Estrangeira, importação direta sem similar nacional (CAMEX)",
  "operation.goodsOrigin.option.7": "Estrangeira, mercado interno sem similar nacional (CAMEX)",
  "operation.goodsOrigin.option.8": "Nacional, conteúdo de importação acima de 70%",
  "operation.purchaseValue": "Compra antes de IPI e ST (R$)",
  "operation.saleValue": "Venda antes da ST de repasse (R$)",
  "operation.buyer": "Cliente",
  "operation.taxpayer": "Contribuinte de ICMS (revenda)",
  "operation.finalConsumer": "Consumidor final (DIFAL)",
  "operation.calculate": "Calcular operação",
  "operation.calculating": "Calculando…",
  "operation.invalid.ncm": "Informe um NCM de 8 dígitos.",
  "operation.invalid.values": "Informe valores de compra e venda válidos.",
  "operation.result": "Resultado fiscal",
  "operation.ruleset": "Conjunto",
  "operation.status.ok": "Calculado com regras publicadas",
  "operation.status.review": "Requer revisão",
  "operation.issue.purchase_rule_missing": "Sem regra de ICMS publicada para a compra",
  "operation.issue.purchase_rule_ambiguous": "Regra de compra ambígua (informe o CEST)",
  "operation.issue.sale_rule_missing": "Sem regra de ICMS publicada para a venda",
  "operation.issue.sale_rule_ambiguous": "Regra de venda ambígua (informe o CEST)",
  "operation.issue.purchase_value_missing": "Valor de compra ausente",
  "operation.issue.sale_value_missing": "Valor de venda ausente",
  "operation.mode.ST": "ICMS-ST",
  "operation.mode.STANDARD": "ICMS próprio",
  "operation.mode.NOT_TAXED": "ICMS não tributado",
  "operation.mode.none": "Sem regra publicada",
  "operation.purchase": "Compra",
  "operation.sale": "Venda",
  "operation.totals": "Carga fiscal da operação",
  "operation.totalsHint": "O que a BCH paga e o que repassa ao cliente",
  "operation.stClosed": "ST recolhida na entrada: venda interna sem ICMS",
  "operation.line.value": "Valor da NF",
  "operation.line.ownIcms": "ICMS próprio",
  "operation.line.mva": "Base ST · MVA",
  "operation.line.stEntry": "ICMS-ST na entrada",
  "operation.line.stRetained": "ICMS-ST retido na NF do fornecedor",
  "operation.line.fcpDifal": "FCP do destino na DIFAL",
  "operation.stRetained": "ICMS-ST retido na NF de compra (opcional)",
  "operation.stRetainedHint":
    "Valor total retido na nota, mesmo com preços por unidade. Declare 0 se a nota informar zero; deixe em branco se não informado. A declaração não comprova responsabilidade pelo recolhimento.",
  "operation.line.acquisition": "Custo de aquisição",
  "operation.line.credit": "Crédito de ICMS",
  "operation.line.saleValue": "Valor de venda",
  "operation.line.stSale": "ICMS-ST retido do cliente",
  "operation.line.invoice": "Total da NF de venda",
  "operation.line.taxesInCost": "Impostos no custo (IPI + ST entrada)",
  "operation.line.icmsPayable": "ICMS a recolher (venda − crédito)",
  "operation.line.carryover": "Crédito a transportar",
  "operation.line.salePaid": "Pago pela BCH na venda (ICMS + DIFAL)",
  "operation.line.stCustomer": "ST repassada ao cliente",
  "operation.line.burden": "Carga fiscal líquida",
  "operation.note.pisCofins":
    "PIS/COFINS estão fora desta base (regime ainda não credenciado); não aparecem como zero.",
  "operation.note.pricing":
    "Preço, markup e margem comercial ficam na calculadora comercial (R-15).",
  "operation.note.reimbursement":
    "ST paga na entrada e venda interestadual: o ressarcimento da ST não é modelado aqui.",
  "operation.note.senderWithholding": "ST retido pelo remetente ({agreement})",
  "operation.stReview.title": "Recolhimento de ST na compra",
  "operation.stReview.route": "Trajeto da compra",
  "operation.stReview.source": "Procedência do valor",
  "operation.stReview.source.prior":
    "ST anterior declarada como incluída no preço; sem novo destaque declarado.",
  "operation.stReview.source.invoice":
    "Valor declarado como retido na NF do fornecedor; não confirma um protocolo.",
  "operation.stReview.source.calculated":
    "Valor calculado no resultado devolvido; essa origem não define quem recolhe.",
  "operation.stReview.source.pending": "Procedência por revisar.",
  "operation.stReview.responsibility": "Responsabilidade pelo recolhimento",
  "operation.stReview.responsibility.pending": "Responsabilidade por resolver.",
  "operation.stReview.responsibility.prior": "Sem novo recolhimento declarado nesta compra.",
  "operation.stReview.responsibility.sender":
    "Remetente, conforme o acordo devolvido para este trajeto.",
  "operation.stReview.responsibility.general":
    "Sem ST calculada nesta compra pela regra geral devolvida.",
  "operation.stReview.responsibility.rule": "A regra selecionada não calcula ST para esta compra.",
  "operation.stReview.stAmount": "ICMS-ST informado no resultado",
  "operation.stReview.fcpAmount": "FCP/FECP-ST da compra",
  "operation.stReview.fcpUndetailed": "Sem detalhamento separado",
  "operation.stReview.conflict":
    "As declarações e os metadados fiscais devolvidos divergem. Revise a NF, o trajeto e a regra antes de usar os valores ou atribuir responsabilidade pelo recolhimento.",
  "operation.stReview.review":
    "Este resultado exige revisão. Valores e responsabilidade continuam pendentes; eventual acordo abaixo é informação devolvida, não confirmação de retenção aplicada.",
  "operation.stReview.anticipation":
    "A antecipação pelo destinatário ainda precisa de revisão. A ausência de informação sobre o remetente não define quem paga nem comprova ausência de ST.",
  "operation.stReview.returnedAgreement": "Acordo devolvido, para revisão:",
  "operation.stReview.returnedBasis": "Fundamento devolvido:",
  "operation.stReview.generalBasis": "Fundamento da regra geral devolvida:",
  "operation.stReview.cashScope":
    "Detalhe do custo de aquisição, sem pagamento adicional nem divisão entre fornecedor e Fisco. Recuperação de ST e prazos não apurados.",
  "operation.note.statutoryOwnIcms": "ICMS próprio interestadual pela alíquota legal ({basis})",
  "operation.note.generalRule": "Compra calculada com a regra geral (sem ST)",
  "operation.note.saleGeneralRule": "Venda calculada com a regra geral (sem ST)",
  "operation.note.destinationStRule": "Compra calculada com a regra de destino derivada",
  "operation.statutory.sf2289": "Res. SF 22/89",
  "operation.statutory.sf132012": "Res. SF 13/2012",
  "operation.evidence": "Evidências e regras ({count})",
  "rulesets.policy.label": "Política de cálculo",
  "rulesets.policy.title": "Política de cálculo do rascunho",
  "rulesets.policy.body":
    "A política viaja com a próxima publicação e não altera cálculos anteriores. tax-family-v1: uma regra só responde pelos impostos que declara; a linha TIPI fornece o IPI e nunca um ICMS zero. tax-family-v2: igual, e a MVA ajustada usa a carga efetiva da regra como ALQ intra, sem arredondar.",
  "rulesets.policy.legacy-v1": "regra inteira; MVA ajustada armazenada permitida",
  "rulesets.policy.derived-mva-v1": "regra inteira; MVA ajustada derivada",
  "rulesets.policy.tax-family-v1": "por imposto: ICMS da rota, IPI da TIPI; MVA derivada",
  "rulesets.policy.tax-family-v2": "por imposto; MVA ajustada pela carga efetiva (ALQ_intra)",
  "rulesets.policy.reason": "Motivo da mudança",
  "rulesets.policy.reasonRequired": "Escreva ao menos 10 caracteres.",
  "rulesets.policy.saved": "Política atualizada no rascunho.",
  "rulesets.policy.save": "Salvar política",
  "gaps.tab": "Lacunas",
  "gaps.title": "Lacunas de cobertura",
  "gaps.description":
    "NCM e trajetos que os cálculos não encontraram no conjunto publicado. Pesquise com IA nas fontes oficiais e registre o que foi verificado.",
  "gaps.summary": "Resumo das lacunas",
  "gaps.how":
    "A pesquisa usa Vertex AI com Google Search, apenas fontes oficiais revisadas (CONFAZ e SEFAZ de origem e destino). O resultado vira evidência para revisão; nunca publica regra.",
  "gaps.researchNext": "Pesquisar as 5 prioritárias com IA",
  "gaps.researching": "Enviando pesquisas…",
  "gaps.researchNext.done": "{queued} pesquisa(s) enviada(s); {failed} sem fonte disponível.",
  "gaps.error": "Não foi possível concluir. Tente novamente.",
  "gaps.filter": "Filtrar por estado",
  "gaps.filter.all": "Todas",
  "gaps.status.OPEN": "Abertas",
  "gaps.status.RESEARCHING": "Em pesquisa",
  "gaps.status.NO_RULE_FOUND": "Verificadas sem ST",
  "gaps.status.RULE_FOUND": "Regra encontrada",
  "gaps.status.RESOLVED": "Resolvidas",
  "gaps.status.DISMISSED": "Dispensadas",
  "gaps.state.OPEN": "Aberta",
  "gaps.state.RESEARCHING": "Em pesquisa",
  "gaps.state.NO_RULE_FOUND": "Verificada sem ST",
  "gaps.state.RULE_FOUND": "Regra encontrada",
  "gaps.state.RESOLVED": "Resolvida",
  "gaps.state.DISMISSED": "Dispensada",
  "gaps.list": "Lacunas por prioridade",
  "gaps.empty": "Nenhuma lacuna neste filtro",
  "gaps.emptyBody":
    "Quando um cálculo não encontra regra para um NCM e trajeto, a lacuna aparece aqui automaticamente.",
  "gaps.honesty":
    "Lacuna não é imposto zero: o cálculo fica em revisão até existir regra publicada. “Verificada sem ST” registra a conferência com evidência.",
  "gaps.occurrences": "Itens",
  "gaps.calculations": "Cálculos",
  "gaps.lastSeen": "Último",
  "gaps.researchTask": "Pesquisa: {status}",
  "gaps.research.QUEUED": "na fila",
  "gaps.research.RUNNING": "em andamento",
  "gaps.research.WAITING_REVIEW": "aguardando revisão",
  "gaps.research.SUCCEEDED": "concluída",
  "gaps.research.FAILED": "falhou",
  "gaps.research.CANCELLED": "cancelada",
  "gaps.outcome.NO_ST_FOUND": "Sem ST encontrada",
  "gaps.outcome.RULE_FOUND": "Regra encontrada",
  "gaps.outcome.INCONCLUSIVE": "Inconclusivo",
  "gaps.outcomeHint.NO_ST_FOUND":
    "Fontes oficiais revisadas; não há ST vigente para este NCM e trajeto. É uma resposta válida.",
  "gaps.outcomeHint.RULE_FOUND":
    "Existe ato vigente (MVA, CEST). Crie a proposta de regra a partir da evidência.",
  "gaps.outcomeHint.INCONCLUSIVE":
    "Ainda não dá para concluir; a lacuna continua aberta para outra pesquisa.",
  "gaps.research": "Pesquisar com IA",
  "gaps.recordFinding": "Registrar resultado",
  "gaps.proposeStandard": "Criar proposta",
  "gaps.dismiss": "Dispensar",
  "gaps.finding.title": "Resultado · NCM {ncm} · {route}",
  "gaps.finding.outcome": "O que foi verificado",
  "gaps.finding.note": "Nota do revisor",
  "gaps.finding.notePlaceholder":
    "Ex.: Protocolo ICMS 97/10 revisado; NCM fora do anexo para SP→RJ.",
  "gaps.finding.cited": "Evidências da pesquisa",
  "gaps.finding.evidenceIds": "Outras evidências (IDs)",
  "gaps.finding.checkedAsOf": "Verificado para a data",
  "gaps.finding.noteRequired": "Escreva ao menos 10 caracteres.",
  "gaps.finding.evidenceRequired": "Cite ao menos uma evidência oficial.",
  "gaps.finding.evidenceInvalid": "IDs de evidência inválidos.",
  "gaps.finding.boundary":
    "Registrar o resultado não publica regra. Regras seguem proposta, revisão e publicação.",
  "gaps.finding.save": "Salvar resultado",
  "gaps.dismissTitle": "Dispensar lacuna · NCM {ncm}",
  "gaps.dismissReason": "Motivo",
  "quick.description": "Informe o NCM, o CEST ou o produto. Origem e destino são opcionais.",
  "quick.searchBy": "Pesquisar por",
  "quick.mode.ncm": "Pesquisa por NCM",
  "quick.mode.cest": "Pesquisa por CEST",
  "quick.mode.product": "Pesquisa por produto",
  "quick.hint.ncm":
    "Informe os oito dígitos do NCM conforme a TIPI. Com menos dígitos, escolha o produto na lista.",
  "quick.hint.cest": "Informe o CEST (ex.: 17.001.00) para ver os NCM que ele abrange.",
  "quick.hint.product": "Descreva o produto (ex.: chocolate, biscoito, secador) e escolha o NCM.",
  "quick.placeholder.ncm": "Ex.: 1704.90.10",
  "quick.placeholder.cest": "Ex.: 17.001.00",
  "quick.placeholder.product": "Ex.: chocolate",
  "quick.anyState": "Qualquer estado",
  "quick.search": "Buscar",
  "quick.invalid.ncm": "Informe um NCM com 2 a 8 dígitos.",
  "quick.invalid.cest": "Informe um CEST com 7 dígitos (ex.: 17.001.00).",
  "quick.invalid.product": "Descreva o produto para pesquisar.",
  "quick.inForceOn": "Vigente em",
  "quick.routeOptional": "Sem origem e destino, mostramos todas as regras do NCM.",
  "quick.clear": "Limpar consulta",
  "quick.start.title": "Comece pelo NCM",
  "quick.start.body":
    "Você verá os dados fiscais publicados: regime do ICMS, MVA, alíquotas, CEST, vigência e fundamento legal.",
  "quick.start.try": "Experimente:",
  "quick.start.exampleLabel": "Consultar NCM {ncm} de {origin} para {destination}",
  "quick.candidates.title": "Escolha o produto",
  "quick.candidates.body": "Produtos do catálogo NCM para “{query}”.",
  "quick.cest.missing": "CEST não encontrado",
  "quick.cest.missingBody": "Confira o código no Convênio ICMS 142/18 ou pesquise por NCM.",
  "quick.cest.pick": "Escolha um NCM abrangido por este CEST:",
  "quick.loadingCatalog": "Carregando descrição…",
  "quick.internalSt.title": "Atenção:",
  "quick.internalSt.body": "este NCM tem ST na operação interna de {uf}.",
  "quick.internalSt.action": "Consultar ST interna {uf} → {uf}",
  "quick.inForce.title": "Regras vigentes para a operação",
  "quick.outside.title": "Fora de vigência nesta data",
  "quick.other.title": "Outras regras deste NCM",
  "quick.other.body": "Regras vigentes em outros trajetos. Clique no trajeto para consultá-lo.",
  "quick.more": "Mostrando as primeiras {count} regras. Veja todas na",
  "quick.honesty":
    "Somente regras publicadas no conjunto em vigor. Ausência de regra não é isenção; PIS/COFINS estão fora desta base.",
  "quick.none.title": "Não aplicável.",
  "quick.none.route": "Não existem regras publicadas vigentes para {route}.",
  "quick.none.body":
    "Este NCM ainda não tem regra fiscal publicada. Isso não significa imposto zero: o cálculo fica para revisão.",
  "quick.none.bodyOther":
    "Existem regras deste NCM em outros trajetos (abaixo). Para este trajeto, o cálculo fica para revisão.",
  "quick.regime.st": "ICMS-ST",
  "quick.regime.stOff": "ST não aplicável",
  "quick.regime.standard": "ICMS próprio",
  "quick.regime.exempt": "ICMS não tributado",
  "quick.value.exempt": "Isento",
  "quick.value.outside": "Fora desta base",
  "quick.value.internalOp": "Operação interna",
  "quick.fact.regime": "Regime",
  "quick.fact.originalMva": "MVA original",
  "quick.fact.adjustedMva": "MVA ajustada",
  "quick.fact.derived": "calculada",
  "quick.fact.internal": "Alíquota interna (destino)",
  "quick.fact.interstate": "Alíquota interestadual",
  "quick.fact.reduction": "Redução de base",
  "quick.detail": "Ver detalhe",
  "quick.regime.ipiOnly": "Só IPI (TIPI)",
  "quick.ipi.title": "IPI nacional (TIPI)",
  "quick.ipi.body":
    "Linha nacional da TIPI: informa só o IPI deste NCM. O ICMS vem das regras do trajeto acima.",
  "quick.gap.seen": "{count} item(ns) de cálculo sem regra",
  "quick.gap.openResearch": "Abrir pesquisa",
  "quick.gap.all": "Ver lacunas",
  "quick.pickRoute":
    "Várias regras vigentes. Escolha o trajeto para ver os dados fiscais completos.",
  "quick.validity": "Vigência",
  "quick.legal": "Fundamento legal",
  "quick.useRoute": "Consultar este trajeto",
  "lookup.catalog": "Catálogo NCM",
  "lookup.library": "Biblioteca de regras",
  "lookup.description": "Encontre um produto ou NCM e abra suas regras publicadas.",
  "lookup.catalogNote": "O catálogo identifica a classificação; não comprova uma alíquota.",
  "lookup.destinations": "Ferramentas fiscais",
  "lookup.route": "Trajeto da operação",
  "lookup.origin": "Estado de origem",
  "lookup.destination": "Estado de destino",
  "lookup.swap": "Inverter origem e destino",
  "lookup.internal": "Operação interna",
  "account.description": "Seu perfil, idioma e formas de acesso.",
  "account.section.profile": "Perfil",
  "account.section.preferences": "Preferências",
  "account.section.passkeys": "Passkeys",
  "account.section.password": "Senha",
  "account.profileManaged": "Os dados da sua conta são gerenciados pelo administrador.",
  "account.passwordHelp":
    "Crie uma senha ou altere a atual por um link seguro enviado ao e-mail da sua conta. Esse processo verifica seu e-mail e não exige uma senha anterior.",
  "account.passwordAction": "Enviar link de senha",
  "account.passwordUnavailable": "O envio de e-mail exige entrar em uma conta conectada.",
  "account.title": "Minha conta",
  "account.sections": "Seções da conta",
  "account.section.language": "Idioma",
  "account.section.profile.description": "Seu nome, e-mail e perfil de acesso.",
  "account.section.language.description": "Idioma dos textos da interface.",
  "account.languageHint": "A mudança vale na hora, sem recarregar a página.",
  "account.passwordSentTo": "O link será enviado para",
  "legacy.modeHelp":
    "Exporte os resultados antes de sair desta página; nada é salvo na plataforma.",
  "legacy.switch": "Calculadora anterior",
  "legacy.switch.help":
    "Abre a calculadora anterior ({version}) de next.backchannel.ws. Tabelas fixas; as regras publicadas não mudam.",
  "legacy.switch.helpActive": "Ativo. Pressione para voltar às regras publicadas.",
  "legacy.title": "Calculadora anterior",
  "legacy.tabs.label": "Ferramentas da calculadora anterior",
  "legacy.engineTitle": "Calculadora anterior {version}",
  "legacy.provenance":
    "fixado em {date} · commit {commit} · tabelas históricas, não regras publicadas",
  "legacy.routeLabel": "Rota",
  "legacy.confirm.date": "Data",
  "legacy.drop.title": "Solte aqui o CSV da calculadora anterior (v8)",
  "legacy.drop.limits": ".csv · 26 colunas (v8) · até 500 linhas · 5 MB",
  "legacy.batch.foot":
    "Campos vazios usam os padrões do fornecedor; valores inválidos exigem revisão. Exporte o Excel como CSV antes.",
  "legacy.batch.supplierFact": "padrões {supplier}",
  "legacy.batch.local": "Cálculo local. Não é salvo como resultado da plataforma.",
  "legacy.batch.parsingNote":
    "Esta calculadora lê “1.250,00” como mil duzentos e cinquenta e aceita o CSV com a linha de título do modelo. O app original lê esse número como 1,25 e pode recusar a linha de título; se os resultados divergirem, confira esses campos primeiro.",
  "legacy.batch.results": "Linhas do CSV",
  "legacy.description":
    "Calculadora de lucro de next.backchannel.ws, versão {version}, com tabelas fixas: CMV, créditos, ST, DIFAL, margem e intermediação. Não usa nem altera as regras publicadas; os resultados ficam neste navegador.",
  "legacy.operation": "Operação",
  "legacy.resale": "Compra e revenda",
  "legacy.intermediation": "Intermediação",
  "legacy.route": "Produto e rota",
  "legacy.legalDescription": "Descrição legal do produto",
  "legacy.costs": "Custos de compra",
  "legacy.options": "Evidência fiscal e pagamento",
  "legacy.quantityNote":
    "A calculadora anterior usa valores totais por linha. A quantidade só afeta a tarifa do boleto; não multiplica custo nem receita.",
  "legacy.channel": "Canal de pagamento",
  "legacy.inPerson": "Presencial",
  "legacy.brand": "Bandeira do cartão",
  "legacy.installments": "Parcelas",
  "legacy.stProof": "Informar evidência estruturada de ST",
  "legacy.compare": "Comparar BCH SP / ES",
  "legacy.calculate": "Calcular com a calculadora anterior",
  "legacy.result": "Resultado da calculadora anterior",
  "legacy.resultNote":
    "Calculado com as tabelas fixas da calculadora anterior {version}. É um resultado de compatibilidade, não uma aprovação fiscal.",
  "legacy.review":
    "Revisão necessária. Esses dados não produzem um cálculo completo na calculadora anterior.",
  "legacy.block.purchase": "Compra",
  "legacy.block.sale": "Venda",
  "legacy.block.saleTaxes": "Tributos da venda",
  "legacy.block.result": "Resultado",
  "legacy.block.service": "Serviço",
  "legacy.block.margin": "Margem",
  "legacy.marginSub": "margem {pct}",
  "legacy.cm1Sub": "CM1 / GMV {pct}",
  "legacy.compareTitle": "BCH SP × BCH ES",
  "legacy.export": "Exportar memória de cálculo (JSON)",
  "legacy.field.supplierUF": "UF do fornecedor",
  "legacy.field.bchCenter": "Centro BCH",
  "legacy.field.customerUF": "UF do cliente",
  "legacy.field.purchasePurpose": "Finalidade da compra",
  "legacy.field.supplierTotalInclTaxes": "Valor da NF do fornecedor (BRL)",
  "legacy.field.freight": "Frete de compra (BRL)",
  "legacy.field.insurance": "Seguro (BRL)",
  "legacy.field.otherExpenses": "Outras despesas de compra (BRL)",
  "legacy.field.freightRevenue": "Frete cobrado do cliente (BRL)",
  "legacy.field.freightCost": "Custo do frete de entrega (BRL)",
  "legacy.field.logisticsCost": "Custo logístico (BRL)",
  "legacy.field.stValueFromSupplier": "ST na NF do fornecedor (BRL)",
  "legacy.field.boletoFeeFixed": "Tarifa do boleto (BRL)",
  "legacy.field.markupPct": "Percentual de preço",
  "legacy.field.backchannelCommissionPct": "Comissão BCH",
  "legacy.field.quantity": "Quantidade",
  "legacy.field.ipiBase": "Base do IPI",
  "legacy.field.isImported": "Produto importado",
  "legacy.field.isZFMSupplier": "Fornecedor da Zona Franca de Manaus",
  "legacy.field.customerIsIcmsTaxpayer": "Cliente contribuinte de ICMS",
  "legacy.field.stAlreadyCollected": "Fornecedor já recolheu ST",
  "legacy.field.pricing_method": "Método de preço",
  "legacy.field.paymentMethod": "Forma de pagamento",
  "legacy.option.resale": "Revenda",
  "legacy.option.own_use": "Uso próprio",
  "legacy.option.fixed_asset": "Ativo imobilizado",
  "legacy.option.manufacturing": "Industrialização",
  "legacy.option.valor_com_imposto": "Com IPI",
  "legacy.option.valor_sem_imposto": "Sem IPI",
  "legacy.option.gross_margin_on_purchase": "Margem bruta sobre compra",
  "legacy.option.markup_on_cost": "Markup sobre custo",
  "legacy.option.target_contribution_after_tax": "Contribuição alvo após impostos",
  "legacy.option.credit_card": "Cartão de crédito",
  "legacy.option.boleto": "Boleto",
  "legacy.option.pix": "PIX",
  "legacy.service.gmv": "GMV (BRL)",
  "legacy.service.take": "Taxa de serviço (%)",
  "legacy.service.iss": "ISS (%)",
  "legacy.service.cost": "Custo de operações (BRL)",
  "legacy.result.purchaseValue": "Valor de compra",
  "legacy.result.totalCredits": "Créditos totais",
  "legacy.result.fiscalCMV": "CMV fiscal",
  "legacy.result.entryAnticipation": "Antecipação de entrada",
  "legacy.result.merchandisePrice": "Preço da mercadoria",
  "legacy.result.invoiceTotal": "Total da NF",
  "legacy.result.icmsST": "ICMS-ST",
  "legacy.result.fecpST": "FECP-ST",
  "legacy.result.difalOnSale": "DIFAL",
  "legacy.result.totalSaleTaxes": "Tributos da venda",
  "legacy.result.paymentFees": "Tarifas de pagamento",
  "legacy.result.marginValue": "Contribuição",
  "legacy.serviceResult.serviceValue": "Valor do serviço",
  "legacy.serviceResult.iss": "ISS",
  "legacy.serviceResult.totalWithholding": "Retenções",
  "legacy.serviceResult.netCashToReceive": "Líquido a receber",
  "legacy.serviceResult.revenueTaxes": "Tributos sobre receita",
  "legacy.serviceResult.valueForMargin": "Valor para margem",
  "legacy.serviceResult.operationsCost": "Custo de operações",
  "lookup.product": "Produto ou NCM",
  "lookup.placeholder": "Ex.: café, 0901 ou 0901.21.00",
  "lookup.category": "Categoria · capítulo SH",
  "lookup.allCategories": "Todas as categorias",
  "lookup.clear": "Limpar produto e categoria",
  "lookup.selected": "Produto selecionado",
  "lookup.change": "Trocar produto",
  "lookup.calculate": "Calcular este produto",
  "lookup.descriptionColumn": "Descrição",
  "lookup.chapterColumn": "Capítulo SH",
  "common.nextPage": "Próxima página",
  "common.pageResults": "{count} nesta página · {total} resultados",
  "lookup.results": "Produtos do catálogo",
  "lookup.noProducts": "Nenhum produto encontrado",
  "lookup.noProductsBody": "Tente outro termo, NCM ou capítulo.",
  "lookup.candidates": "Regras publicadas encontradas",
  "lookup.conditions":
    "Correspondências por NCM, trajeto e vigência. CEST, regime e condições da operação ainda precisam ser conferidos. Revise a fundamentação e complete os dados na calculadora para determinar o resultado.",
  "lookup.noRules": "Sem regra publicada para esta consulta",
  "lookup.noRulesBody":
    "Isso não significa imposto zero. A base pode estar incompleta; consulte a biblioteca e as fontes.",
  "lookup.unavailable": "Não informado",
  "lookup.version": "Versão",
  "lotMap.help":
    "Selecione a aba, os cabeçalhos e as colunas. Declare se cada custo da mercadoria é unitário ou total da linha. Preços de venda não são convertidos automaticamente.",
  "lotMap.mesa.fields": "Campos fiscais",
  "lotMap.mesa.preview": "Prévia · {count} linhas depois do cabeçalho",
  "lotMap.mesa.column": "Coluna {index}",
  "lotMap.mesa.mapped": "Coluna {column} → {field}",
  "lotMap.mesa.required": "Obrigatório",
  "lotMap.confirmHint":
    "Guarda o arquivo original e lê todas as linhas. Nenhuma linha é descartada em silêncio.",
  "lotMap.sheet": "Aba",
  "lotMap.header": "Linha de cabeçalhos",
  "lotMap.unmapped": "Não informado",
  "lotMap.decimal": "Formato numérico",
  "lotMap.originUf": "UF de origem quando a coluna estiver vazia",
  "lotMap.destinationUf": "UF de destino quando a coluna estiver vazia",
  "lotMap.sample": "Valores de exemplo",
  "lotMap.comparisonHelp":
    "Comparação opcional: mapeie os valores por unidade que o arquivo informa. O motor recalcula com regras publicadas. Diferenças de até R$ 0,01 contam como iguais. Uma correspondência compara valores; não aprova uma fórmula do Excel. CSV não preserva fórmulas do Excel.",
  "lotMap.field.expected_ipi": "IPI esperado por unidade",
  "lotMap.field.expected_icms_st": "ICMS-ST esperado por unidade",
  "lotMap.field.expected_tax_total": "Total de impostos esperado por unidade",
  "lotCompare.title": "Comparar valores do meu arquivo (opcional)",
  "lotCompare.field": "Imposto",
  "lotCompare.expected": "Arquivo / unidade",
  "lotCompare.actual": "Motor / unidade",
  "lotCompare.delta": "Motor menos arquivo",
  "lotCompare.status": "Comparação",
  "lotCompare.match": "Valores iguais",
  "lotCompare.difference": "Valor diferente",
  "lotCompare.pending": "Aguardando cálculo válido",
  "lotMap.cached":
    "Usar valores salvos das fórmulas. Eles não serão recalculados; confirme que o arquivo foi atualizado no Excel.",
  "lotMap.confirm": "Confirmar e conferir cobertura",
  "lotFlow.label": "Etapas do cálculo da planilha",
  "lotFlow.stepOf": "Etapa {current} de {total}",
  "lotFlow.step.send": "Enviar",
  "lotFlow.step.columns": "Revisar colunas",
  "lotFlow.step.coverage": "Conferir cobertura",
  "lotFlow.step.calculate": "Calcular",
  "lotFlow.step.results": "Resultados",
  "lotFlow.session.title": "Lotes enviados nesta sessão",
  "lotFlow.session.hint.one": "Ele continua calculando enquanto você envia outra planilha.",
  "lotFlow.session.hint.other": "Eles continuam calculando enquanto você envia outra planilha.",
  "lotFlow.session.view": "Ver progresso",
  "lotFlow.session.viewResult": "Ver resultado",
  "lotFlow.session.open": "Abrir registro",
  "lotFlow.record.created": "Registro do lote criado para acompanhamento e auditoria.",
  "lotFlow.record.open": "Ver registro e responsável",
  "lotFlow.session.another": "Enviar outra planilha",
  "lotFlow.session.count.one": "{count} lote desta sessão continua nesta página",
  "lotFlow.session.count.other": "{count} lotes desta sessão continuam nesta página",
  "lotFlow.reading.title": "Lendo a planilha",
  "lotFlow.reading.sheets": "Procurando abas com lista de produtos",
  "lotFlow.reading.header": "Encontrando o cabeçalho e o formato dos números",
  "lotFlow.reading.columns": "Sugerindo as colunas de NCM, custo, quantidade e rota",
  "lotFlow.detect.title": "O que encontramos",
  "lotFlow.detect.body.one":
    "Aba {sheet} · 1 linha de produto. Se algo estiver errado, ajuste abaixo.",
  "lotFlow.detect.body.other":
    "Aba {sheet} · {rows} linhas de produto. Se algo estiver errado, ajuste abaixo.",
  "lotFlow.detect.ok": "Detectado",
  "lotFlow.detect.check": "Confira",
  "lotFlow.detect.sheets.one": "{count} aba",
  "lotFlow.detect.sheets.other": "{count} abas",
  "lotFlow.detect.lists.one": "{count} lista de produtos",
  "lotFlow.detect.lists.other": "{count} listas de produtos",
  "lotFlow.detect.header": "Cabeçalho na linha {row}",
  "lotFlow.detect.decimal": "Números no formato {format}, lido dos próprios valores",
  "lotFlow.detect.decimalDefault":
    "Números no formato {format} (padrão: os valores não deixam claro)",
  "lotFlow.detect.routeFixed": "Rota única",
  "lotFlow.detect.source.SHEET_NAME": "lida do nome da aba",
  "lotFlow.detect.source.COLUMN": "lida das colunas de UF",
  "lotFlow.detect.source.HEADER_BLOCK": "lida do bloco acima do cabeçalho",
  "lotFlow.detect.source.PARAMETER_SHEET": "lida da aba de parâmetros",
  "lotFlow.detect.routeRows.one": "Rota por linha · {count} rota no arquivo",
  "lotFlow.detect.routeRows.other": "Rota por linha · {count} rotas no arquivo",
  "lotFlow.detect.routeMissing": "Falta a rota: escolha a UF de origem e a de destino abaixo",
  "lotFlow.detect.costMissing":
    "Falta a coluna de custo fiscal unitário: escolha em Campos fiscais",
  "lotFlow.detect.column": "{field} em {column}",
  "lotFlow.field.ncm": "NCM",
  "lotFlow.field.custo": "Custo",
  "lotFlow.field.quantidade": "Quantidade",
  "lotFlow.confirm.title": "Resumo antes de confirmar",
  "lotFlow.confirm.rows": "linhas de produto",
  "lotFlow.confirm.repair": "linhas com reparo sugerido",
  "lotFlow.confirm.mended": "linhas reparadas",
  "lotFlow.confirm.open": "linhas com pendências",
  "lotFlow.confirm.mini": "{rows} linhas · {open} com pendências",
  "lotFlow.run.title": "Configurar o cálculo",
  "lotFlow.run.body":
    "Data, versão das regras e, se quiser, o regime de PIS/COFINS e o preço de venda. O resto vem da planilha.",
  "lotFlow.run.ready": "{count} linhas prontas para calcular.",
  "lotFlow.premises.title": "Premissas lidas da planilha, já preenchidas abaixo:",
  "lotFlow.premises.tr": "Valor de venda com TR {value} ({cell})",
  "lotFlow.premises.saleUf":
    "UF de destino da venda {value} ({cell}), cliente contribuinte de ICMS",
  "lotFlow.premises.regime": "Regime PIS/COFINS {value} ({cell})",
  "lotFlow.premises.saleDiscount":
    "Desconto comercial da venda {value} ({cell}) · só nos totais, não muda a base dos impostos",
  "lotFlow.premises.purchaseDiscount":
    "Desconto comercial da compra {value} ({cell}) · só nos totais, não muda a base dos impostos",
  "lotFlow.premises.changed": "alterado por você",
  "lotFlow.premises.check":
    "São premissas do arquivo, não regras publicadas: confira antes de calcular.",
  "lotMap.field.item_id": "Identificador da linha",
  "lotMap.field.sku": "SKU",
  "lotMap.field.category": "Categoria",
  "lotMap.field.marca": "Marca",
  "lotMap.field.familia": "Família",
  "lotMap.field.ean": "EAN",
  "lotMap.field.peso": "Peso",
  "lotMap.field.ncm": "NCM",
  "productFile.title": "Produto no arquivo",
  "productFile.fact.description": "Descrição",
  "productFile.fact.category": "Categoria",
  "productFile.fact.brand": "Marca",
  "productFile.fact.family": "Família",
  "productFile.fact.ean": "EAN",
  "productFile.fact.weight": "Peso",
  "productFile.cellTitle": "{header}, célula {cell}",
  "productFile.cellTitlePlain": "célula {cell}",
  "lotMap.field.cest": "CEST",
  "lotMap.field.origem_mercadoria": "Origem da mercadoria (CST)",
  "lotMap.field.uf_origem": "UF de origem",
  "lotMap.field.uf_destino": "UF de destino",
  "lotMap.field.custo": "Custo da mercadoria (obrigatório)",
  "lotMap.field.quantidade": "Quantidade",
  "lotMap.field.meio_pagamento": "Meio de pagamento",
  "lotMap.field.tipo_transacao": "Tipo de transação",

  "lotSim.permission": "A permissão de executar cálculos é necessária para importar e simular.",
  "lotSim.retry.slow": "O servidor demorou para responder; tentando de novo…",
  "lotSim.retry.network": "A conexão caiu; tentando de novo…",
  "lotSim.retry.action": "Tentar de novo",
  "lotSim.missingUpload": "Importe o arquivo antes de iniciar a tarefa.",
  "lotSim.downloadOriginal": "Baixar original",
  "lotSim.title": "Calculadora fiscal",
  "lotSim.subtitle": "Operações · Calculadora fiscal em lote · regras publicadas",
  "lotSim.body":
    "Aplique as regras publicadas à sua lista e confira o detalhamento de cada imposto.",
  "lotSim.input": "Preparar simulação",
  "lotSim.template": "Baixar modelo CSV",
  "lotSim.file": "Arquivo Excel ou CSV · até 5.000 linhas por aba e 25 MB",
  "lotSim.date": "Data da operação",
  "lotSim.version": "Versão das regras",
  "lotSim.choose": "Selecione uma versão publicada",
  "lotSim.loading": "Processando…",
  "lotSim.noRules":
    "Não há regras publicadas para simular. Peça ao responsável fiscal que verifique a cobertura necessária.",
  "lotSim.run": "Calcular lote",
  "lotSim.rows": "Linhas do arquivo",
  "lotSim.fix":
    "As linhas com erro ficam fora da simulação e são listadas abaixo. Corrija-as no arquivo e importe novamente para incluí-las. Nenhuma linha é descartada em silêncio.",
  "lotSim.row": "Linha",
  "lotSim.cost": "Custo fiscal unitário",
  "lotSim.result": "Resultado / pendências",
  "lotSim.receipt": "Recibo da simulação",
  "lotSim.trace": "Abrir memória de cálculo",
  "lotSim.export": "Exportar requisição e resultado",
  "lotSim.size": "O limite do arquivo é 25 MB.",
  "lotSim.runHint": "A tarefa será registrada com a versão escolhida.",
  "lotSim.mode.label": "Modo da calculadora",
  "lotSim.mode.lote": "Upload em Lote",
  "lotSim.mode.individual": "Simulação Individual",
  "lotSim.drop.title": "Solte suas planilhas aqui",
  "lotSim.drop.active": "Solte para ler a planilha",
  "lotSim.drop.limits": ".xlsx, .xlsm ou .csv · até 5.000 linhas por aba · 25 MB",
  "lotSim.drop.legacySteps": "Como resolver",
  "lotSim.drop.choose": "Escolher arquivos",
  "lotSim.drop.orOne": "ou escolha um arquivo",
  "lotSim.drop.sending": "Enviando {size} MB direto ao armazenamento…",
  "lotSim.upload.title": "Calcular por planilha",
  "lotSim.upload.body":
    "Envie o Excel ou CSV. Conferimos as colunas e as regras fiscais publicadas; itens sem regra ficam para revisão.",
  "lotSim.guide.title": "Como a planilha é processada",
  "lotSim.guide.files": "Vários arquivos de uma vez, confirmados em sequência",
  "lotSim.guide.sheets": "Cada aba de produtos escolhida vira um cálculo",
  "lotSim.guide.route": "Rota fixa ou uma rota por linha, das colunas de UF",
  "lotSim.guide.numbers": "O formato dos números, 1.234,56 ou 1,234.56",
  "lotSim.guide.premises": "TR, UF de venda e regime do cabeçalho da aba, oferecidos como entrada",
  "lotSim.guide.repair": "“Reparar planilha” sugere correções; você aceita uma a uma",
  "lotSim.rowsShown": "Mostrando {shown} de {total} linhas",
  "lotSim.showMoreRows": "Mostrar mais {count}",
  "lotSim.showAllRows": "Mostrar todas as {total}",
  "lotSim.drop.invalid": "Não foi possível ler este arquivo",
  "lotSim.file.change": "Trocar arquivo",
  "lotSim.file.facts.sheets": "{count} abas",
  "lotSim.file.facts.rows": "{count} linhas",
  "lotSim.file.facts.rowsRead": "{count} linhas lidas",
  "lotSim.file.facts.columns": "{count} colunas",
  "lotSim.file.facts.formulas": "{count} fórmulas",
  "lotSim.file.facts.invalid": "{count} linhas com erro",
  "lotSim.file.facts.size": "{size} KB",
  "lotSim.file.facts.fiscalDate": "data fiscal {date}",
  "lotSim.file.noDrop": "Nenhuma linha foi descartada em silêncio.",
  "lotSim.run.blocked.rows":
    "Não há linha válida para simular. Corrija o arquivo e importe novamente.",
  "lotSim.run.excludedNote": "{count} linhas com erro ficarão de fora e são listadas abaixo.",
  "lotSim.excluded.title": "{count} linhas fora da simulação",
  "lotSim.excluded.hint":
    "Estas linhas têm erros no arquivo. As linhas válidas são calculadas; cada linha excluída é listada aqui com planilha, linha, coluna e motivo, e nas exportações.",
  "lotSim.status.excluded": "Excluída",
  "lotSim.row.excluded": "Excluída: {reason}",
  "lotSim.run.blocked.version": "Escolha uma versão publicada.",
  "lotSim.run.blocked.date": "Informe a data da operação.",
  "lotSim.drop.or": "ou escolha vários arquivos",
  "lotSim.stepKicker": "PASSO {n}",
  "lotSim.banner":
    "O custo pode ser unitário ou total da linha, conforme base_valor. Os tributos vêm das regras publicadas.",
  "lotSim.clear": "Remover arquivo",
  "lotLive.steps.label": "Etapas da leitura",
  "lotLive.steps.sheets": "Procurando abas",
  "lotLive.steps.header": "Cabeçalho e formato",
  "lotLive.steps.columns": "Sugerindo colunas",
  "lotLive.steps.state.complete": "concluído",
  "lotLive.steps.state.running": "em andamento",
  "lotLive.steps.state.waiting": "aguardando",
  "lotLive.caption": "Primeiras linhas · cabeçalho na linha {row}",
  "lotLive.headerTag": "Cabeçalho",
  "lotLive.table.region": "Prévia da aba {sheet}",
  "lotLive.table.rowNumber": "Número da linha",
  "lotLive.columns.title": "Colunas reconhecidas",
  "lotLive.columns.field": "{field} · {column}",
  "lotLive.columns.missing": "{field} não encontrado(a)",
  "lotLive.review": "Revisar colunas",
  "lotLive.reviewNeeded": "Revisar colunas",
  "lotLive.summary.decimal": "{format}",
  "lotLive.fixedRoute": "Rota {origin} → {destination}",
  "lotLive.sheets.ready": "{count} abas prontas para calcular",
  "lotLive.premise.tr": "TR",
  "lotLive.premise.saleUf": "UF de venda",
  "lotLive.premise.regime": "PIS/COFINS",
  "lotLive.premise.saleDiscount": "Desconto da venda",
  "lotLive.premise.purchaseDiscount": "Desconto da compra",
  "lotLive.premise.missing": "Não informado na aba",
  "lotLive.ignored.one": "{count} aba ignorada: {names}",
  "lotLive.ignored.other": "{count} abas ignoradas: {names}",
  "lotLive.calculate.invalid": "Revise as colunas de {sheets} antes de calcular",
  "lotLive.calculate.choose": "Escolha ao menos uma aba",
  "lotLive.autoInfo":
    "Se a planilha já trouxer a rota, o fornecedor e os dados fiscais, o cálculo começa automaticamente quando esta conferência terminar. Caso contrário, revise as colunas e confirme; linhas sem regra ou dado ficam para revisão.",
  "lotLive.announce.reading": "{file}: lendo a planilha",
  "lotLive.announce.header": "Cabeçalho na linha {row} · {count} colunas reconhecidas",
  "lotLive.announce.sheetsReady": "{count} abas prontas para calcular",
  "lotLive.format.notAccepted": "não aceito",
  "lotLive.format.saveAsXlsx": "Salve como .xlsx",
  "lotLive.format.rule":
    "Formatos aceitos: .xlsx, .xlsm, .csv e .txt delimitado em UTF-8. O .xls (Excel 97-2003) não é aceito. Até 5.000 linhas por aba e 25 MB.",
  "lotLive.format.limits": "até 5.000 linhas por aba · 25 MB",
  "lotSim.metric.rows": "Linhas",
  "lotSim.metric.calculated": "Calculadas",
  "lotSim.metric.review": "Revisão",
  "reviewFix.title": "O que falta para calcular",
  "reviewFix.generalRuleRow": "Regra geral (sem ST), não é regra publicada: {basis}.",
  "reviewFix.generalRule.one":
    "{count} linha calculada pela regra geral (sem ST): alíquota da Res. SF 22/89 (ou interna verificada) e NCM sem ST comprovado.",
  "reviewFix.generalRule.other":
    "{count} linhas calculadas pela regra geral (sem ST): alíquota da Res. SF 22/89 (ou interna verificada) e NCM sem ST comprovado.",
  "reviewFix.destinationStRuleRow":
    "{label}: regra de ST do destino, publicada como {source}, com a alíquota interestadual da Res. SF 22/89. {basis}.",
  "reviewFix.fcpInAlqIntraRow":
    "FECP do destino na MVA ajustada: ALQ intra {alqIntra} ({internal} + FECP {fcp}). ICMS-ST {icmsSt} e FECP-ST {fcpSt}, em linhas separadas. {basis}.",
  "reviewFix.stCollectionRow":
    "ST retido pelo remetente ({agreement}, {route}): ICMS-ST {amount}, FECP-ST {fcpAmount}, na NF do fornecedor. {basis}.",
  "reviewFix.destinationStRule.one":
    "{count} linha calculada com a regra de ST derivada da regra publicada do destino (outra origem, mesma MVA, alíquota interestadual legal).",
  "reviewFix.destinationStRule.other":
    "{count} linhas calculadas com a regra de ST derivada da regra publicada do destino (outra origem, mesma MVA, alíquota interestadual legal).",
  "compareFile.name.ipi": "IPI",
  "compareFile.name.icmsSt": "ICMS-ST",
  "compareFile.name.taxTotal": "total de tributos",
  "compareFile.name.landed": "custo posto",
  "compareFile.name.ownIcms": "ICMS da entrada",
  "compareFile.name.purchasePisCofins": "PIS/COFINS da compra",
  "compareFile.name.workbookCost": "custo como na planilha (Prod. + IPI + ST)",
  "compareFile.name.salePrice": "valor de venda com TR",
  "compareFile.name.saleIcms": "ICMS próprio da venda",
  "compareFile.name.salePisCofins": "PIS/COFINS da venda",
  "compareFile.name.saleStFcp": "ICMS-ST e FCP-ST da NF de venda",
  "compareFile.name.buyerInvoice": "NF de venda do comprador",
  "compareFile.toggle": "Comparar com meu arquivo",
  "compareFile.fields":
    "Compara {fields} com as colunas que o arquivo informa. Diferenças de até R$ 0,01 contam como iguais.",
  "compareFile.tally.rows": "linhas comparadas",
  "compareFile.tally.difference": "diferentes",
  "compareFile.tally.match": "iguais",
  "compareFile.tally.pending": "sem valor do motor",
  "compareFile.onlyDifferent": "Só diferentes",
  "compareFile.caption": "Resultados comparados com o arquivo",
  "compareFile.base": "Base BRL / un.",
  "compareFile.field.ipi": "IPI / un.",
  "compareFile.field.icmsSt": "ICMS-ST / un.",
  "compareFile.field.taxTotal": "Tributos / un.",
  "compareFile.field.landed": "Custo posto / un.",
  "compareFile.field.ownIcms": "ICMS entrada / un.",
  "compareFile.field.purchasePisCofins": "PIS/COFINS compra / un.",
  "compareFile.field.workbookCost": "Custo como na planilha / un.",
  "compareFile.field.salePrice": "Venda c/ TR / un.",
  "compareFile.field.saleIcms": "ICMS próprio venda / un.",
  "compareFile.field.salePisCofins": "PIS/COFINS venda / un.",
  "compareFile.field.saleStFcp": "ICMS-ST/FCP-ST venda / un.",
  "compareFile.field.buyerInvoice": "NF venda Buyer / un.",
  "compareFile.file": "Arquivo",
  "compareFile.engine": "Motor",
  "compareFile.delta": "Δ",
  "compareFile.deltaHint": "Diferença: motor − arquivo",
  "compareFile.verdict": "Comparação",
  "compareFile.notMapped": "Sem coluna no arquivo",
  "compareFile.note":
    "Somente leitura: os valores do arquivo vêm das colunas mapeadas na importação. Diferenças de até R$ 0,01 contam como iguais. Uma linha sem regra não tem valor do motor e nunca é tratada como zero. Desligue a comparação para voltar à tabela de resultados.",
  "compareFile.limit":
    "Mostrando {shown} de {total} linhas diferentes. Exporte o CSV para ver todas.",
  "compareFile.empty.title": "Nenhuma linha diferente",
  "compareFile.empty.body":
    "Com os filtros atuais, os valores do motor batem com o arquivo ou ainda não têm cálculo.",
  "reviewCause.title": "{count} de {total} linhas para revisar",
  "reviewCause.hint":
    "Por motivo, com a ação que resolve cada um. Uma linha pode ter mais de um motivo: os grupos não se somam. Cotações estimadas são identificadas e separadas dos totais fiscais confirmados.",
  "reviewCause.reading": "Lendo os motivos de cada linha…",
  "reviewCause.example": "Ex.: {text}",
  "reviewCause.less": "Mostrar menos motivos",
  "reviewCause.more.one": "Mais {count} motivo",
  "reviewCause.more.other": "Mais {count} motivos",
  "reviewCause.viewRows.one": "Ver a linha",
  "reviewCause.viewRows.other": "Ver as {count} linhas",
  "reviewCause.research.one": "Pesquisar {count} lacuna",
  "reviewCause.research.other": "Pesquisar {count} lacunas",
  "reviewCause.scope.ncm.one": "{count} NCM",
  "reviewCause.scope.ncm.other": "{count} NCMs",
  "reviewCause.scope.route.one": "{count} rota",
  "reviewCause.scope.route.other": "{count} rotas",
  "reviewCause.kind.RULE": "Regra",
  "reviewCause.kind.CEST": "Classificação",
  "reviewCause.kind.FILE": "Planilha",
  "reviewCause.kind.PROFILE": "PIS/COFINS",
  "reviewCause.kind.OTHER": "Revisão",
  "reviewCause.short.CEST_MISMATCH": "CEST não confere com a regra",
  "reviewCause.short.AMBIGUOUS_CEST": "Vários CEST possíveis",
  "reviewCause.short.NO_RULE_FOR_ROUTE": "NCM sem regra publicada nesta rota",
  "reviewCause.short.NO_RULE_FOR_NCM": "NCM sem regra publicada",
  "reviewCause.short.ICMS_NOT_PUBLISHED": "ICMS não publicado para a rota",
  "reviewCause.short.RULE_EXPIRED": "Regra vencida na data do cálculo",
  "reviewCause.short.RULE_NOT_YET_EFFECTIVE": "Regra ainda não vigente na data",
  "reviewCause.short.RULESET_EMPTY": "Sem regras publicadas",
  "reviewCause.short.FIELD_MISSING": "Campo faltando na planilha",
  "reviewCause.short.PROFILE_PENDING": "Perfil PIS/COFINS a confirmar",
  "reviewCause.short.BENEFIT_NOT_IN_RULE": "cBenef fora da regra da venda",
  "reviewCause.short.SALE_RULE_MISSING": "Sem regra para o ICMS da venda",
  "reviewCause.short.OTHER": "Outro motivo",
  "reviewCause.short.ACQUISITION_PENDING": "Dados fiscais da aquisição pendentes",
  "reviewCause.next.ACQUISITION_PENDING":
    "Abra o detalhe da linha para conferir e completar a classificação, a origem da mercadoria ou a regra fiscal que estiver pendente.",
  "reviewCause.next.RULE":
    "Revise as regras aplicáveis ou pesquise a rota; publique antes de recalcular.",
  "reviewCause.next.CEST": "Corrija o CEST e recalcule.",
  "reviewCause.next.FILE": "Corrija a planilha e importe de novo.",
  "reviewCause.next.PROFILE": "Confirme o perfil PIS/COFINS pelo produto e recalcule.",
  "reviewCause.next.OTHER": "Abra a linha para ver a memória do cálculo.",
  "reviewCause.profile.BEVERAGE_PROFILE": "bebida fria da Lei 13.097/2015",
  "reviewCause.profile.REQUIRES_CONFIRMATION": "lista com condição que o NCM não comprova",
  "reviewCause.profile.OVERLAPPING_LISTS": "em mais de uma lista",
  "reviewCause.profile.NOT_IN_CATALOG": "tratamento fora da lista legal",
  "reviewCause.profile.OTHER": "a confirmar",
  "reviewCause.rowTitle": "Por que esta linha precisa de revisão",
  "reviewCause.fact.product": "Produto",
  "reviewCause.fact.route": "NCM e rota",
  "reviewCause.fact.provenance": "Procedência",
  "reviewCause.fact.provenanceRow": "{sheet}, linha {row}",
  "reviewCause.fact.rules": "regras {version}",
  "reviewCause.noRule": "Sem regra publicada",
  "reviewCause.pending": "Pendente",
  "reviewFix.fixCests": "Corrigir CEST e recalcular ({count})",
  "reviewFix.reason.CEST_MISMATCH":
    "CEST {cest} não corresponde ao NCM {ncm} em {route} (esperado {expected}).",
  "reviewFix.reason.AMBIGUOUS_CEST":
    "NCM {ncm} em {route} tem regras para vários CEST ({expected}); a linha não informa CEST.",
  "reviewFix.reason.NO_RULE_FOR_ROUTE":
    "NCM {ncm} tem regras publicadas, mas nenhuma para {route}.",
  "reviewFix.reason.NO_RULE_FOR_NCM": "Nenhuma regra publicada para o NCM {ncm} ({route}).",
  "reviewFix.reason.ICMS_NOT_PUBLISHED":
    "Só a linha da TIPI cobre o NCM {ncm}: ICMS não publicado para {route}.",
  "reviewFix.reason.RULE_EXPIRED":
    "A regra do NCM {ncm} em {route} terminou antes da data do cálculo.",
  "reviewFix.reason.RULE_NOT_YET_EFFECTIVE":
    "A regra do NCM {ncm} em {route} começa depois da data do cálculo.",
  "reviewFix.reason.RULESET_EMPTY": "Não há regras fiscais publicadas.",
  "reviewFix.reason.FIELD_MISSING": "A linha não tem {field} válido.",
  "reviewFix.reason.PROFILE_PENDING":
    "O NCM {ncm} tem tratamento próprio de PIS/COFINS ({profile}).",
  "reviewFix.reason.BENEFIT_NOT_IN_RULE":
    "O cBenef {benefit} não está na regra publicada da venda.",
  "reviewFix.reason.SALE_RULE_MISSING":
    "Nenhuma regra informa o ICMS da venda {saleRoute} para o NCM {ncm}.",
  "reviewFix.reason.OTHER": "Revisão necessária para o NCM {ncm} em {route}.",
  "reviewFix.fix.SET_CEST": "Correção: usar o CEST {value} da regra publicada.",
  "reviewFix.fix.PICK_CEST": "Correção: escolher o CEST em Reparar planilha.",
  "reviewFix.fix.RESEARCH_ROUTE": "Próximo passo: pesquisar a rota.",
  "reviewFix.fix.FIX_SHEET": "Correção: preencher {field} na planilha e importar de novo.",
  "reviewFix.fix.STATE_TREATMENT": "Correção: informar o tratamento confirmado.",
  "reviewFix.fixFailed": "Nenhuma correção de CEST pôde ser aplicada à planilha.",
  "lotSim.column.item": "Item",
  "lotSim.column.ncm": "NCM / rota",
  "lotSim.column.ipi": "IPI",
  "lotSim.column.icmsSt": "ICMS (ST ou próprio)",
  "lotSim.column.taxTotal": "Tributos",
  "lotSim.column.landed": "Custo posto",
  "lotSim.column.status": "Estado",
  "lotSim.expand": "Abrir memória da linha {row}",
  "lotSim.collapse": "Fechar memória da linha {row}",
  "lotSim.waterfall.title": "Memória fiscal",
  "lotSim.waterfall.cost": "Custo fiscal unitário",
  "lotSim.waterfall.ipi": "(+) IPI",
  "lotSim.waterfall.icmsSt": "(+) ICMS (ST ou próprio)",
  "lotSim.waterfall.taxTotal": "Total de tributos",
  "lotSim.waterfall.take": "(+) Taxa de intermediação",
  "lotSim.waterfall.logistics": "(+) Logística",
  "lotSim.waterfall.freight": "(+) Frete",
  "lotSim.waterfall.other": "(+) Outros",
  "lotSim.waterfall.landed": "Custo posto unitário",
  "costs.operationalNotConfigured": "Custo operacional não configurado — fora do cálculo fiscal",
  "costs.feeNotConfigured": "Taxa comercial não configurada — fora do cálculo fiscal",
  "costs.bothNotConfigured":
    "Custo operacional e taxa comercial não configurados — fora do cálculo fiscal",
  "costs.explainer":
    "IPI, ICMS e ICMS-ST e o custo fiscal posto estão calculados. O custo comercial posto fica indisponível até a publicação desses custos.",
  "costs.fiscalLanded": "Custo fiscal posto unitário",
  "costs.pricingBasis":
    "Preço de venda e margem usam o custo fiscal posto, antes do custo operacional e da taxa comercial.",
  "costs.notConfiguredShort": "Não configurado",
  "costs.invalid":
    "A regra de custo operacional ou de taxa comercial não pode ser aplicada; o item precisa de revisão.",
  "lotSim.waterfall.ipiRate": "Alíquota IPI publicada",
  "lotSim.waterfall.mva": "MVA ajustada",
  "shadow.title": "Comparação com dados verificados",
  "shadow.hint":
    "Modo sombra: o mesmo item calculado com fatos fiscais verificados ou certificados vigentes em {date}. Só leitura.",
  "shadow.returned": "Os valores devolvidos e salvos continuam os da regra publicada.",
  "shadow.unavailable": "Os fatos não puderam ser lidos neste cálculo. O cálculo não foi afetado.",
  "shadow.status.NO_FACTS": "Nenhum fato verificado ou certificado cobre este NCM e trajeto.",
  "shadow.status.INCOMPLETE":
    "Os fatos verificados não cobrem todos os campos necessários, então não há resultado alternativo.",
  "shadow.status.CONFLICT":
    "Fatos verificados divergem entre si; nenhum resultado alternativo foi calculado.",
  "shadow.status.AMBIGUOUS":
    "Há fatos de CESTs diferentes para este NCM e o item não informa CEST.",
  "shadow.status.NOT_COMPARABLE": "Item sem NCM ou UF: nada a comparar.",
  "shadow.changed": "Os dados verificados mudariam este item.",
  "shadow.same": "Os dados verificados confirmam este item.",
  "shadow.level.CERTIFIED": "Nível: certificado.",
  "shadow.level.VERIFIED": "Nível: verificado.",
  "shadow.gap": "sem regra publicada, os fatos preencheriam esta lacuna",
  "shadow.revalidation": "revalidação pedida",
  "shadow.column.field": "Campo",
  "shadow.column.rule": "Regra publicada",
  "shadow.column.facts": "Dados verificados",
  "shadow.field.stApplicable": "ICMS-ST aplicável",
  "shadow.field.originalMva": "MVA original",
  "shadow.field.destinationInternalRate": "Alíquota interna no destino",
  "shadow.field.interstateRate": "Alíquota interestadual",
  "shadow.st.yes": "sim",
  "shadow.st.no": "não",
  "shadow.noSt.certified": "Sem ST (certificado IOB)",
  "shadow.noSt.verified": "Sem ST (dados verificados)",
  "shadow.noSt.internal":
    "ST interna no destino ({uf}): sem retenção pelo remetente; o destinatário recolhe a antecipação ou ST nas operações internas.",
  "shadow.noSt.internalNoUf":
    "ST interna no destino: sem retenção pelo remetente; o destinatário recolhe a antecipação ou ST nas operações internas.",
  "shadow.admin.title": "Modo sombra: comparação com dados verificados",
  "shadow.admin.hint":
    "Últimos {days} dias. Quantos itens os fatos verificados ou certificados mudariam. Os valores devolvidos continuam os da regra.",
  "shadow.admin.off":
    "Modo sombra desligado. Ele precisa de FISCAL_FACTS_MODE=SHADOW no ambiente (hoje: {environment}) e do modo Sombra ou Ligado salvo acima.",
  "shadow.admin.calculations": "Cálculos",
  "shadow.admin.compared": "Itens comparados",
  "shadow.admin.changed": "Mudariam",
  "shadow.admin.gapsFilled": "Lacunas preenchidas",
  "shadow.admin.disagreements": "Divergem da regra",
  "shadow.admin.noFacts": "Sem fatos",
  "shadow.admin.incomplete": "Incompletos ou em conflito",
  "shadow.admin.levels": "Certificado / verificado",
  "shadow.admin.landedDelta": "Δ custo posto (soma)",
  "shadow.admin.maxDelta": "Maior |Δ| por item",
  "shadow.admin.routes": "Trajetos com mais itens comparados",
  "shadow.admin.column.route": "NCM · trajeto",
  "shadow.admin.column.compared": "Comparados",
  "shadow.admin.column.changed": "Mudariam",
  "shadow.admin.column.delta": "Δ custo posto",
  "shadow.admin.last": "Última comparação: {time}",
  "shadow.admin.none": "Nenhuma comparação registrada no período.",
  "calc.form.regime": "Regime de PIS/COFINS",
  "calc.form.regime.UNKNOWN": "Não informado",
  "calc.form.regime.NON_CUMULATIVE": "Não cumulativo (1,65% / 7,6%)",
  "calc.form.regime.CUMULATIVE": "Cumulativo (0,65% / 3%)",
  "calc.form.regimeHint":
    "Vale quando a regra não traz PIS/COFINS. Nas planilhas, o regime preenchido na linha prevalece, inclusive UNKNOWN; este controle preenche regimes ausentes ou o padrão não confirmado do mapeamento. Sem regime, PIS/COFINS fica não acompanhado.",
  "calc.form.pricing": "Preço de venda",
  "calc.form.pricing.NONE": "Não calcular",
  "calc.form.pricing.MARKUP": "Markup sobre o custo posto",
  "calc.form.pricing.TARGET_MARGIN": "Margem bruta sobre o preço",
  "calc.form.pricingRate": "Percentual (%)",
  "calc.form.pricingRateError":
    "Informe um percentual válido. A margem alvo precisa ficar abaixo de 100%.",
  "fiscalLines.fcp": "(+) FCP/FECP",
  "fiscalLines.fcpSt": "(+) FCP-ST",
  "fiscalLines.fcpNote":
    "Fundo de combate à pobreza da UF de destino, como a regra vigente o declara. Sem FCP na regra, fica como não acompanhado.",
  "fiscalLines.notTracked": "não acompanhado",
  "fiscalLines.notApplicable": "não se aplica",
  "fiscalLines.exempt": "isento",
  "fiscalLines.pisRate": "Alíquota PIS na venda",
  "fiscalLines.cofinsRate": "Alíquota COFINS na venda",
  "fiscalLines.pisOnSale": "(−) PIS na venda",
  "fiscalLines.cofinsOnSale": "(−) COFINS na venda",
  "fiscalLines.source.RULE": "regra publicada",
  "fiscalLines.source.REGIME_DEFAULT": "alíquota geral do regime",
  "pricing.title": "Preço e margem",
  "pricing.salePrice": "Preço de venda",
  "pricing.method.MARKUP": "markup {rate}",
  "pricing.method.TARGET_MARGIN": "margem alvo {rate}",
  "pricing.margin": "Margem",
  "pricing.marginPct": "{value} do preço",
  "calc.form.pricing.NET_TARGET_MARGIN": "Margem líquida desejada (após impostos da venda)",
  "calc.form.pricing.COST_PLUS_TR": "Valor de venda com TR (custo da NF de compra ÷ (1 − TR))",
  "calc.form.pricingTrHint":
    "Como na planilha: preço = custo da NF de compra (produtos + IPI + ICMS-ST) ÷ (1 − TR). ICMS, PIS/COFINS e ST da venda são calculados sobre esse preço, sem embuti-los.",
  "pricing.method.COST_PLUS_TR": "TR {rate}",
  "pricing.tr.invoiceCost": "Custo da NF de compra (produtos + IPI + ICMS-ST)",
  "pricing.tr.icmsOnSale": "ICMS próprio da venda",
  "pricing.tr.icmsClosed":
    "Mercadoria já substituída: venda interna sem novo ICMS (CST 60). PIS/COFINS sobre o preço cheio.",
  "pricing.tr.icmsBurdenNeeded":
    "Venda interna sem redução de base declarada na regra: ICMS próprio pela alíquota nominal. Se houver carga efetiva (ex.: art. 39 do RICMS/SP), ela precisa ser publicada na regra.",
  "pricing.tr.pisCofins": "PIS/COFINS da venda (fora da base)",
  "pricing.tr.pisCofinsFormula": "({price} − ICMS {icms}) × alíquota",
  "pricing.tr.st": "ICMS-ST na NF de venda",
  "pricing.tr.stNotOnInvoice":
    "A regra da venda é ST, mas a NF não carrega a retenção (sem acordo ou cliente não contribuinte); eventual antecipação é do destinatário.",
  "pricing.tr.fcpSt": "FCP/FECP-ST na NF de venda",
  "pricing.tr.difal": "DIFAL + FCP do destino",
  "pricing.tr.buyerInvoice": "NF venda do comprador (preço + ICMS-ST + FCP-ST)",
  "pricing.tr.margin": "Sobra após os impostos da venda",
  "pricing.tr.marginNote":
    "O TR não embute os impostos da venda: a sobra depois deles é menor que o TR (nota 4 da planilha).",
  "pricing.tr.cst": "CST indicativo {cst}",
  "calc.form.pricingNetHint":
    "O preço sai de (custo posto − créditos) ÷ (1 − margem − impostos da venda): a margem informada é a que sobra depois de ICMS, PIS e COFINS da venda.",
  "calc.form.pricingNetRegime":
    "Sem o regime de PIS/COFINS, a margem líquida não desconta PIS/COFINS da venda nem soma os créditos da compra.",
  "calc.form.saleDestination": "Destino da venda",
  "calc.form.saleDestination.center": "Venda interna no CD",
  "calc.form.customerType": "Cliente da venda",
  "calc.form.customerType.ICMS_TAXPAYER": "Contribuinte de ICMS",
  "calc.form.customerType.FINAL_CONSUMER": "Consumidor final (DIFAL)",
  "pricing.method.NET_TARGET_MARGIN": "margem líquida {rate}",
  "pricing.net.route": "Venda {origin} → {destination} · {customer}",
  "pricing.net.assumedDestination": "venda interna no CD",
  "pricing.net.assumedCustomer": "cliente contribuinte de ICMS",
  "pricing.net.assumedNote":
    "Premissa: {what}. Informe o destino e o cliente da venda para fixar a premissa.",
  "pricing.net.formula": "Preço = (custo posto − créditos) ÷ (1 − margem − impostos da venda)",
  "pricing.net.formulaValues": "({cost} − {credits}) ÷ {divisor} = {price}",
  "pricing.net.icmsOnSale": "(−) ICMS na venda",
  "pricing.net.icmsClosed": "ICMS-ST pago na entrada: sem ICMS na venda e sem crédito de ICMS.",
  "pricing.net.icmsNotTaxed": "Venda sem ICMS: o crédito de ICMS da compra é estornado.",
  "pricing.net.fcpOnSale": "(−) FCP na venda",
  "pricing.net.difalOnSale": "(−) DIFAL na venda",
  "pricing.net.credits": "(−) Créditos da compra",
  "pricing.net.creditsDetail": "ICMS {icms} · PIS {pis} · COFINS {cofins}",
  "pricing.net.netCost": "Custo líquido de créditos",
  "pricing.net.margin": "Margem líquida",
  "pricing.net.markup": "Markup sobre o custo posto",
  "lotOps.group.price": "Preço sugerido",
  "lotOps.price.netMargin": "Margem líq.",
  "lotOps.price.markup": "Markup",
  "pricing.untracked": "PIS/COFINS não acompanhado: a margem está antes dessas contribuições.",
  "calculations.explain.fiscalLines": "FCP, PIS/COFINS e margem",
  "lotSim.status.calculated": "Calculado",
  "lotSim.status.review": "Revisão",
  "lotSim.pending": "Aguardando simulação",
  "lotSim.individual.body":
    "Uma SKU, uma rota, as regras publicadas. Preço e margem ficam em Mais opções.",
  "lotSim.individual.ncm": "NCM",
  "lotSim.individual.origin": "UF de origem",
  "lotSim.individual.destination": "UF de destino",
  "lotSim.selectUf": "Selecione a UF",
  "lotSim.individual.quantity": "Quantidade",
  "lotSim.individual.result": "Resultado",
  "lotSim.individual.resultMeta": "{date} · {version}",
  "calc.form.title": "Produto e rota",
  "calc.form.ncmPlaceholder": "Ex.: 8471.30.12",
  "calc.form.ncmHint": "Os 8 dígitos da NCM do produto.",
  "calc.form.ncmError": "Informe os 8 dígitos da NCM.",
  "calc.form.route": "Rota",
  "calc.form.ufError": "Selecione a UF.",
  "calc.form.swap": "Inverter origem e destino",
  "calc.form.costHint": "Custo fiscal de uma unidade, antes de tributos.",
  "calc.form.costInvalid": "Use o formato 1.000,00.",
  "calc.form.costError": "Informe o custo fiscal unitário.",
  "calc.form.more": "Mais opções",
  "calc.form.moreSummary": "Qtd. {quantity} · {date} · Regras {version}",
  "calc.form.sku": "SKU (opcional)",
  "calc.form.skuPlaceholder": "Ex.: CAFE-500G",
  "calc.form.cest": "CEST (opcional)",
  "calc.form.cestPlaceholder": "Ex.: 17.001.00",
  "calc.form.cestHint": "Só se o produto tiver CEST atribuído; não presuma o código.",
  "calc.form.cestRemoved": "CEST removido: {cest} não corresponde ao NCM {ncm}",
  "calc.form.missing": "Falta preencher: {fields}.",
  "calc.form.ready": "Pronto para calcular.",
  "calc.form.calculate": "Calcular",
  "calc.form.calculating": "Calculando…",
  "calc.result.cost": "Custo",
  "calc.result.empty":
    "Preencha NCM, rota e custo e clique em Calcular. O resultado aparece aqui, imposto por imposto.",
  "calc.result.taxes": "{value} em tributos",
  "calc.result.mva": "MVA {value}",
  "calc.result.icmsNote":
    "Com substituição tributária, este valor é o ICMS-ST. Sem ST, é o ICMS próprio da compra, somado ao custo sem crédito.",
  "calc.fecp.omitted": "FECP do destino não informado na regra; ST calculada sem FECP",
  "calc.recent.title": "Últimos cálculos",
  "calc.recent.all": "Ver todos os lotes",
  "calc.recent.error": "Não foi possível carregar os últimos cálculos.",
  "calc.recent.empty": "Nenhum cálculo nos últimos 30 dias.",
  "calc.recent.items.one": "{count} item",
  "calc.recent.items.other": "{count} itens",
  "calc.recent.missing": "O que falta",
  "calc.recent.missingIssue": "{issue} · {count}",
  "calc.recent.seeItems": "Ver itens",
  "calc.recent.next.queued": "Aguardando a vez na fila",
  "calc.recent.next.running": "{done} de {total} itens calculados",
  "calc.recent.next.failed": "O cálculo parou; abra para ver o motivo.",
  "calc.error.details": "Detalhes técnicos",
  "calc.error.generic.title": "Não foi possível calcular",
  "calc.error.generic.body":
    "Tente novamente. Se persistir, envie os detalhes técnicos ao suporte.",
  "calc.error.lot.title": "O lote parou antes de terminar",
  "calc.error.lot.body":
    "O motivo está em Detalhes técnicos. Corrija a planilha e envie o lote de novo; se não souber o que corrigir, envie o código ao suporte.",
  "calc.error.lot.retryableBody":
    "Foi uma falha temporária. Use Reprocessar para tentar de novo; se voltar a falhar, envie o código ao suporte.",
  "calc.error.OPERATION_NOT_AVAILABLE.title": "Cálculo indisponível neste ambiente",
  "calc.error.OPERATION_NOT_AVAILABLE.body":
    "Este ambiente não executa o motor fiscal (por exemplo, o modo de demonstração). Calcule no ambiente ao vivo.",
  "calc.error.DEPENDENCY_UNAVAILABLE.title": "O motor de cálculo não respondeu",
  "calc.error.DEPENDENCY_UNAVAILABLE.body": "Nada foi salvo. Tente novamente em alguns instantes.",
  "calc.error.NO_PUBLISHED_RULESET.title": "Não há regras publicadas para calcular",
  "calc.error.NO_PUBLISHED_RULESET.body":
    "Escolha outra versão publicada. Se não houver uma versão aplicável, peça ao responsável fiscal que verifique a cobertura para o NCM, a rota e a data da operação.",
  "calc.error.VALIDATION_FAILED.title": "Alguns dados não foram aceitos",
  "calc.error.VALIDATION_FAILED.body": "Confira NCM, UFs, custo e data e tente de novo.",
  "calc.error.BATCH_TOO_LARGE.title": "Lote acima do limite",
  "calc.error.BATCH_TOO_LARGE.body": "Divida a planilha em arquivos menores e envie de novo.",
  "calc.error.RATE_LIMITED.title": "Muitos cálculos em sequência",
  "calc.error.RATE_LIMITED.body": "Aguarde alguns segundos e tente novamente.",
  "calc.error.PERMISSION_DENIED.title": "Sem permissão para calcular",
  "calc.error.PERMISSION_DENIED.body": "Peça a um administrador a permissão de executar cálculos.",
  "calc.error.NETWORK.title": "Sem conexão com a API fiscal",
  "calc.error.NETWORK.body": "Verifique sua conexão e tente novamente.",
  "calc.rate.ipiRate": "Alíquota de IPI",
  "calc.rate.interstateIcmsRate": "Alíquota interestadual de ICMS",
  "calc.rate.destinationInternalIcmsRate": "Alíquota interna de ICMS no destino",
  "calc.rate.originalMva": "MVA original",
  "calc.rate.adjustedMva": "MVA ajustada",
  "mva.adjust.title": "Ajuste da MVA (ICMS-ST)",
  "mva.adjust.alqInter": "ALQ interestadual",
  "mva.adjust.alqIntra": "ALQ intra efetiva",
  "mva.adjust.original": "MVA original",
  "mva.adjust.adjusted": "MVA ajustada",
  "mva.adjust.applied": "Ajuste aplicado",
  "mva.adjust.yes": "Sim",
  "mva.adjust.no": "Não",
  "mva.adjust.reason.ADJUSTED": "ALQ intra acima da interestadual: a MVA foi ajustada.",
  "mva.adjust.reason.NOT_INTERSTATE": "Operação interna: vale a MVA original.",
  "mva.adjust.reason.INTRA_NOT_GREATER_THAN_INTER":
    "ALQ intra não supera a interestadual: vale a MVA original, sem ajuste.",
  "mva.adjust.source.RULE": "Carga efetiva da regra: {legal}",
  "mva.adjust.source.NOMINAL_NOT_INFORMED":
    "carga efetiva não informada — usando alíquota interna nominal",
  "mva.adjust.source.NOMINAL_OUT_OF_VALIDITY":
    "carga efetiva fora da vigência — usando alíquota interna nominal",
  "mva.adjust.debit": "O débito da ST usa a alíquota interna nominal ({rate}).",
  "calc.rate.takeRate": "Taxa de intermediação",
  "calc.engine.name": "Motor",
  "calc.engine.version": "Versão do motor",
  "calc.engine.policy": "Política de cálculo",
  "calc.engine.rounding": "Arredondamento",
  "calc.engine.scale": "Casas decimais",
  "lotSim.exportCsv": "Exportar CSV",
  "lotSim.results": "Resultados por item",
  "lotSim.resultsHint": "{count} linhas · {date} · {version}",

  "app.name": "Operações Fiscais",
  "app.org": "BackChannel",

  "nav.areas": "Áreas",
  "nav.overview": "Visão geral",
  "nav.evidence": "Evidências",
  "nav.proposals": "Propostas",
  "nav.rulesets": "Conjuntos",
  "nav.rules": "Regras",
  "nav.calculator": "Calculadora",
  "nav.calculations": "Cálculos",
  "nav.sources": "Fontes",
  "nav.audit": "Auditoria",
  "nav.settings": "Perfil",
  "nav.admin.module": "Administração",
  "nav.users": "Usuários",
  "nav.legal": "Dados da empresa",
  "nav.agents": "Agentes",
  "nav.demos": "Demos",
  "nav.agentFindings": "Registros do agente",
  "agents.retention": "Registros de execução ficam disponíveis por 30 dias.",
  "agents.retentionFindings": "Os achados ficam para sempre em Registros do agente.",
  "agentFindings.title": "Registros do agente",
  "agentFindings.description":
    "Tudo o que o agente de navegador extraiu, dia a dia (horário de Brasília): totais por resultado e por rota, filtros e exportação. Os achados são material de revisão e ficam guardados permanentemente.",
  "agentFindings.day.previous": "Dia anterior",
  "agentFindings.day.next": "Próximo dia",
  "agentFindings.day.pick": "Escolher o dia",
  "agentFindings.day.today": "Hoje",
  "agentFindings.day.total.one": "{count} achado",
  "agentFindings.day.total.other": "{count} achados",
  "agentFindings.byOutcome": "Por resultado",
  "agentFindings.byRoute": "Por rota",
  "agentFindings.heat.title": "Achados nos últimos {days} dias",
  "agentFindings.heat.window": "Período do gráfico",
  "agentFindings.heat.days": "{days} dias",
  "agentFindings.heat.less": "Menos",
  "agentFindings.heat.more": "Mais",
  "agentFindings.heat.error": "Não foi possível carregar os totais diários.",
  "agentFindings.table.title": "Achados do dia",
  "agentFindings.retention":
    "Achados ficam guardados permanentemente. Capturas de tela e registros de execução ficam disponíveis por 30 dias (exceto os salvos como demo).",
  "agentFindings.export.dayCsv": "Exportar dia (CSV)",
  "agentFindings.export.dayJson": "Exportar dia (JSON)",
  "agentFindings.export.range": "Exportar período…",
  "agentFindings.export.rangeTitle": "Exportar período",
  "agentFindings.export.rangeBody":
    "Baixa os achados entre as datas escolhidas (dias de Brasília, inclusive), até um ano.",
  "agentFindings.export.from": "De",
  "agentFindings.export.to": "Até",
  "agentFindings.export.format": "Formato",
  "agentFindings.export.filtersApply":
    "Os filtros atuais (resultado, rota, NCM) também se aplicam à exportação.",
  "agentFindings.export.invalid": "Escolha um período válido de até 366 dias, sem datas futuras.",
  "agentFindings.export.go": "Baixar",
  "agentFindings.export.busy": "Preparando…",
  "agentFindings.export.done": "{count} achados exportados.",
  "agentFindings.export.truncated":
    "{count} achados exportados; o limite de 20.000 foi atingido. Reduza o período.",
  "agentFindings.export.error": "Não foi possível exportar. Tente novamente.",
  "agentFindings.filter.ncm": "NCM ou descrição",
  "agentFindings.filter.ncmPlaceholder": "Ex.: 8516 ou secadores",
  "agentFindings.filter.outcome": "Resultado",
  "agentFindings.filter.route": "Rota",
  "agentFindings.filter.all": "Todos",
  "agentFindings.filter.clear": "Limpar filtros",
  "agentFindings.filteredCount": "Mostrando {shown} de {total} achados do dia.",
  "agentFindings.empty.day": "Nenhum achado neste dia",
  "agentFindings.empty.dayBody":
    "O agente não registrou consultas nesta data. Use o gráfico para ir a um dia com atividade.",
  "agentFindings.empty.filtered": "Nenhum achado com estes filtros",
  "agentFindings.col.time": "Hora",
  "agentFindings.col.ncm": "NCM",
  "agentFindings.col.route": "Rota",
  "agentFindings.col.outcome": "Resultado",
  "agentFindings.col.mva": "MVA original",
  "agentFindings.col.cest": "CEST",
  "agentFindings.col.validity": "Vigência",
  "agentFindings.col.basis": "Base legal",
  "agentFindings.col.source": "Origem",
  "agentFindings.col.run": "Execução",
  "agentFindings.col.frame": "Captura",
  "agentFindings.source.task": "Tarefa da fila",
  "agentFindings.source.lookupJob": "Consulta do sistema",
  "agentFindings.source.gap": "Lacuna de cobertura",
  "agentFindings.openRun": "Ver execução",
  "agentFindings.openFrame": "Abrir a captura de NCM {ncm}",
  "agents.schedule.recordRuns": "Gravar a tela das execuções",
  "agents.schedule.recordRunsHint":
    "A gravação começa depois do login (nunca mostra o formulário de acesso) e alimenta a seção Demos. Os arquivos das execuções são apagados após 30 dias; os salvos como demo ficam.",
  "agents.live.recording": "Gravando",
  "agents.live.recordingHint": "A tela desta execução está sendo gravada desde o fim do login.",
  "agents.runs.current": "Execução iniciada em {time}.",
  "agents.runs.col.demo": "Demo",
  "demos.title": "Demos",
  "demos.description":
    "Execuções do agente gravadas e salvas para apresentar como o processo funciona: o vídeo da tela, os passos narrados em sincronia e o que foi encontrado.",
  "demos.listLabel": "Demos salvas",
  "demos.empty.title": "Nenhuma demo ainda",
  "demos.empty.body":
    "Em Administração → Agentes, abra uma execução gravada e use “Salvar como demo”.",
  "demos.empty.action": "Ir para Agentes",
  "demos.card.routes.one": "{count} rota",
  "demos.card.routes.other": "{count} rotas",
  "demos.card.ncms.one": "{count} NCM",
  "demos.card.ncms.other": "{count} NCMs",
  "demos.card.findings.one": "{count} achado",
  "demos.card.findings.other": "{count} achados",
  "demos.notFound.title": "Demo não encontrada",
  "demos.notFound.body": "Ela pode ter sido removida. A execução original continua em Agentes.",
  "demos.back": "Todas as demos",
  "demos.detail.savedOn": "Salva em {time}",
  "demos.detail.openRun": "Ver execução em Agentes",
  "demos.delete.action": "Remover demo",
  "demos.delete.title": "Remover esta demo?",
  "demos.delete.body":
    "“{title}” sai da seção Demos. A execução, seus passos, achados e gravações continuam em Agentes. A ação fica registrada na auditoria.",
  "demos.delete.confirm": "Remover demo",
  "demos.delete.error": "Não foi possível remover a demo. Tente novamente.",
  "demos.summary.title": "Resumo da execução",
  "demos.summary.duration": "Vídeo",
  "demos.summary.lookups": "Consultas",
  "demos.summary.findings": "Achados",
  "demos.summary.routes": "Rotas",
  "demos.summary.run": "Execução",
  "demos.summary.boundary":
    "Demonstração do processo. Os achados são material de revisão: não criam, aprovam nem publicam regras.",
  "demos.timeline.title": "Passos narrados",
  "demos.timeline.hint": "Clique em um passo para ir a esse momento do vídeo.",
  "demos.timeline.empty": "Esta execução não tem passos.",
  "demos.timeline.seek": "Ir para {time}",
  "demos.timeline.offCamera": "fora da gravação",
  "demos.findings.moment": "No vídeo",
  "demos.findings.seek": "Ir para este achado no vídeo",
  "demos.player.noRecording": "Esta demo não tem gravação.",
  "demos.player.unavailable":
    "O vídeo não está disponível agora. Os passos e achados continuam abaixo.",
  "demos.player.leave": "Sair do modo apresentação",
  "demos.player.leaveShort": "Sair",
  "demos.player.segment": "Parte {part} de {count}",
  "demos.player.single": "Gravação da tela",
  "demos.player.present": "Modo apresentação",
  "demos.save.action": "Salvar como demo",
  "demos.save.open": "Ver demo",
  "demos.save.reasonRunning": "Disponível quando a execução terminar.",
  "demos.save.reasonNoRecording": "Esta execução não tem gravação.",
  "demos.save.defaultTitle": "Agente IOB · {time}",
  "demos.save.title": "Salvar como demo",
  "demos.save.body":
    "A gravação, os passos e os achados desta execução ficam disponíveis em Administração → Demos.",
  "demos.save.titleLabel": "Título",
  "demos.save.titleHint": "Sugerido a partir da tarefa da fila. Até 120 caracteres.",
  "demos.save.titleRequired": "Informe um título.",
  "demos.save.descriptionLabel": "Descrição",
  "demos.save.optional": "(opcional)",
  "demos.save.retention":
    "O vídeo e os quadros são copiados para a área de demos e deixam de seguir a exclusão de 30 dias das execuções.",
  "demos.save.confirm": "Salvar demo",
  "demos.save.saving": "Salvando…",
  "demos.save.errorConflict": "Esta execução já foi salva como demo ou ainda não terminou.",
  "demos.save.errorStorage":
    "Não foi possível preservar a gravação agora. Tente novamente em instantes.",
  "demos.save.error": "Não foi possível salvar a demo. Tente novamente.",
  "agents.title": "Agente IOB",
  "agents.description":
    "Acompanhe o agente que consulta o IOB Simulador Tributário, organize a fila e a agenda e revise o que ele encontrou.",
  "agents.statusLabel": "Estado do agente",
  "agents.tabs": "Seções do agente",
  "agents.tab.live": "Ao vivo",
  "agents.tab.queue": "Fila",
  "agents.tab.schedule": "Agenda",
  "agents.tab.history": "Histórico",
  "agents.tab.settings": "Configurações",
  "agents.state.running": "Execução em andamento",
  "agents.state.recording": "Gravando a tela desta execução",
  "agents.state.stopping": "Parando",
  "agents.state.stoppingDetail": "Parada solicitada; a consulta atual termina antes",
  "agents.state.noSignal": "Sem sinal",
  "agents.state.pausedDetail": "Nenhuma consulta nova começa até ser retomado",
  "agents.state.outsideWindow": "Fora do horário",
  "agents.state.noCredentialsDetail": "Cadastre o acesso ao IOB em Configurações",
  "agents.state.stoppedDetail": "A última execução falhou; veja o Histórico",
  "agents.findings.open": "{count} achados: ver no Histórico",
  "agents.findings.runTitle": "Achados da execução de {time}",
  "agents.findings.openLive": "Ver tela e passos",
  "agents.status.RUNNING": "Rodando",
  "agents.status.WAITING_WINDOW": "Em espera fora do horário",
  "agents.status.STOPPED": "Parado com erro",
  "agents.status.IDLE": "Aguardando trabalho",
  "agents.status.NO_CREDENTIALS": "Sem credenciais IOB",
  "agents.source": "Fonte",
  "agents.source.IOB_SIMULADOR": "IOB Simulador Tributário",
  "agents.currentLookup": "Consulta atual",
  "agents.noLookup": "Nenhuma consulta em andamento",
  "agents.lookupsDone": "Consultas feitas",
  "agents.findings": "Achados",
  "agents.errors": "Erros",
  "agents.heartbeat": "Último sinal",
  "agents.lastPoll": "Última consulta",
  "agents.heartbeatAgo": "há {age}",
  "agents.heartbeatStale": "Sem sinal há {age}",
  "agents.stop": "Parar execução",
  "agents.stopping": "Parada solicitada",
  "agents.stop.title": "Parar a execução do agente?",
  "agents.stop.body":
    "O agente conclui o passo atual com segurança e encerra a sessão. Ele só volta a rodar no próximo horário da agenda semanal.",
  "agents.stop.confirm": "Parar execução",
  "agents.stop.error": "Não foi possível solicitar a parada. Tente novamente.",
  "agents.lastError": "Último erro",
  "agents.live.title": "Tela do agente",
  "agents.live.meta.idle": "Nenhuma execução em andamento",
  "agents.live.note.disconnectedIdle": "Visor sem transmissão; nova tentativa em {time}.",
  "agents.live.note.disconnectedIdleNow": "Visor sem transmissão; reconectando…",
  "agents.live.note.unconfiguredIdle": "Este ambiente não transmite a tela do agente.",
  "agents.live.viewer.label": "Visor:",
  "agents.live.viewer.live": "ao vivo",
  "agents.live.viewer.connecting": "conectando…",
  "agents.live.viewer.disconnected": "desconectado",
  "agents.live.viewer.unconfigured": "transmissão não configurada",
  "agents.live.viewer.historical": "captura histórica",
  "agents.live.meta.streaming": "Transmissão ao vivo do navegador do agente",
  "agents.live.meta.frame": "Quadro de {time} · há {age}",
  "agents.live.meta.noFrame": "Sem quadro registrado",
  "agents.live.note.historical":
    "Execução de {time}: é o registro dessa execução, não a tela atual.",
  "agents.live.note.historicalPlain": "Registro de uma execução anterior, não a tela atual.",
  "agents.live.note.disconnectedWorking":
    "O agente continua trabalhando; só o visor caiu. Nova tentativa em {time}.",
  "agents.live.note.disconnectedWorkingNow":
    "O agente continua trabalhando; só o visor caiu. Reconectando…",
  "agents.live.note.connectingWorking": "O agente está trabalhando; abrindo a transmissão.",
  "agents.live.note.unconfiguredWorking":
    "O agente está trabalhando. Este ambiente não transmite a tela; os quadros registrados seguem abaixo.",
  "agents.live.art.waiting": "Agente aguardando",
  "agents.live.art.blocked": "Agente bloqueado",
  "agents.live.art.noFrame": "O visor ainda não recebeu nenhum quadro",
  "agents.live.stage.label": "Etapa da consulta atual",
  "agents.live.stage.query": "Consulta",
  "agents.live.stage.capture": "Captura",
  "agents.live.stage.finding": "Achado",
  "agents.live.stage.state.done": "concluída",
  "agents.live.stage.state.current": "em andamento",
  "agents.live.stage.state.recovering": "recuperando de um erro",
  "agents.live.stage.state.todo": "pendente",
  "agents.live.stage.at": "Último evento {time}",
  "agents.live.viewOnly": "Somente visualização",
  "agents.live.reconnect": "Reconectar agora",
  "agents.live.canvasLabel": "Tela ao vivo do navegador do agente, somente visualização",
  "agents.live.noFrame": "Nenhum quadro registrado ainda.",
  "agents.steps.title": "Passos",
  "agents.steps.hint": "Mais recentes primeiro",
  "agents.steps.polling": "Ao vivo · atualiza a cada 2,5 s",
  "agents.steps.empty": "Nenhum passo registrado nesta execução.",
  "agents.steps.openFrame": "Ampliar o quadro do passo {sequence}",
  "agents.steps.group.session": "Sessão e navegação",
  "agents.steps.group.inProgress": "Em andamento",
  "agents.steps.group.count.one": "{count} passo",
  "agents.steps.group.count.other": "{count} passos",
  "agents.steps.recovery.one": "Recuperação assistida · {count} ação",
  "agents.steps.recovery.other": "Recuperação assistida · {count} ações",
  "agents.live.overlay.IDLE": "Agente aguardando trabalho · próxima verificação em até 5 min",
  "agents.live.overlay.STOPPED": "Última execução falhou · próxima verificação em até 5 min",
  "agents.live.overlay.WAITING_WINDOW": "Fora do horário da agenda · {detail}",
  "agents.live.overlay.PAUSED": "Agente pausado · nenhuma consulta nova começa até ser retomado",
  "agents.live.overlay.NO_CREDENTIALS":
    "Credenciais do IOB ausentes · o agente não consegue entrar no simulador",
  "agents.kind.SESSION": "Sessão",
  "agents.kind.NAVIGATE": "Navegação",
  "agents.kind.INPUT": "Preenchimento",
  "agents.kind.CLICK": "Clique",
  "agents.kind.WAIT": "Espera",
  "agents.kind.READ": "Leitura",
  "agents.kind.EXTRACT": "Extração",
  "agents.kind.RECOVER": "Recuperação",
  "agents.kind.PAUSE": "Pausa",
  "agents.kind.ERROR": "Erro",
  "agents.frame.title": "Quadro · {time}",
  "agents.frame.alt": "Quadro capturado pelo agente às {time}",
  "agents.frame.error": "Não foi possível carregar o quadro.",
  "agents.frame.loading": "Carregando quadro…",
  "agents.findings.title": "Achados da execução",
  "agents.findings.boundary":
    "Achados são material de revisão: registram o que a página do simulador mostrou. Não criam, aprovam nem publicam regras; uma regra só muda com o ato oficial, por proposta → revisão → publicação.",
  "agents.findings.filter": "Filtrar por resultado",
  "agents.findings.all": "Todos",
  "agents.findings.compare": "Comparar com regras publicadas",
  "agents.findings.compareShort": "Comparar regras",
  "agents.findings.viewFrame": "Ver quadro",
  "agents.findings.empty": "Nenhum achado nesta execução.",
  "agents.findings.emptyFiltered": "Nenhum achado com este resultado.",
  "agents.outcome.ST_FOUND": "ST encontrada",
  "agents.outcome.NO_ST_FOUND": "Sem ST",
  "agents.outcome.INTERNAL_ST_ONLY": "Só ST interna",
  "agents.outcome.NCM_NOT_FOUND": "NCM não encontrado",
  "agents.outcome.UNREADABLE": "Ilegível",
  "agents.outcome.INCONCLUSIVE": "Inconclusivo",
  "agents.col.ncm": "NCM",
  "agents.col.route": "Rota",
  "agents.col.outcome": "Resultado",
  "agents.col.mva": "MVA original",
  "agents.col.cest": "CEST",
  "agents.col.validity": "Vigência",
  "agents.col.basis": "Fundamento",
  "agents.col.captured": "Capturado",
  "agents.col.actions": "Ações",
  "agents.validity.range": "{from} a {to}",
  "agents.validity.from": "desde {from}",
  "agents.runs.title": "Histórico de execuções",
  "agents.runs.viewing": "Vendo a execução iniciada em {time}.",
  "agents.runs.backToLatest": "Voltar à execução atual",
  "agents.runs.select": "Ver a execução de {time}",
  "agents.runs.col.started": "Início",
  "agents.runs.col.status": "Estado",
  "agents.runs.col.duration": "Duração",
  "agents.runs.col.lookups": "Consultas",
  "agents.runs.col.findings": "Achados",
  "agents.runs.col.errors": "Erros",
  "agents.runs.trigger.SCHEDULE": "Programada",
  "agents.runs.trigger.MANUAL": "Manual",
  "agents.run.status.RUNNING": "Em execução",
  "agents.run.status.SUCCEEDED": "Concluída",
  "agents.run.status.FAILED": "Falhou",
  "agents.run.status.STOPPED": "Parada",
  "agents.noRuns.title": "Nenhuma execução ainda",
  "agents.noRuns.body":
    "Quando o agente iniciar dentro do horário da agenda semanal, a tela, os passos e os achados aparecem aqui.",
  "agents.status.PAUSED": "Pausado",
  "agents.workingOn": "Trabalhando em",
  "agents.workingOnPosition": "{position}ª de {count} na fila",
  "agents.workingOnWaiting": "Nenhuma em andamento · {count} aguardando na fila",
  "agents.workingOnNone": "Nenhuma tarefa na fila",
  "agents.workingOnGaps": "Fila vazia · lacunas de cobertura",
  "agents.schedule.weekly": "Agenda semanal",
  "agents.schedule.block.mondayToThursday": "Segunda a quinta",
  "agents.schedule.block.friday": "Sexta",
  "agents.schedule.block.weekend": "Sábado e domingo",
  "agents.schedule.off": "Desligado",
  "agents.schedule.perDayHours": "{hours} por dia",
  "agents.schedule.allDay": "24 horas",
  "agents.schedule.allDayNote": "Dia inteiro · 00:00–24:00",
  "agents.schedule.from": "Início",
  "agents.schedule.to": "Fim",
  "agents.schedule.nextDay": "termina às {time} do dia seguinte",
  "agents.schedule.issue.CLOCK_INVALID": "Use o formato 24 h HH:MM, de 00:00 a 23:59.",
  "agents.schedule.fullDayNextDay": "24 h, termina às {time} do dia seguinte",
  "agents.schedule.week": "Semana · horário de Brasília",
  "agents.schedule.dayAria": "{day}: {ranges}",
  "agents.schedule.dayAriaOff": "{day}: sem horário",
  "agents.schedule.legendOn": "Horário ativo",
  "agents.schedule.legendNow": "Agora",
  "agents.schedule.noActive":
    "Nenhum horário ativo: o agente não fará consultas até um bloco ser ligado.",
  "agents.schedule.weeklyHours": "Horas por semana",
  "agents.schedule.weeklyHoursMeta": "{percent} da semana",
  "agents.schedule.perWeek": "Por semana",
  "agents.schedule.perWeekValue": "{count} consultas",
  "agents.schedule.perWeekMeta": "no ritmo efetivo, dentro da agenda",
  "agents.scheduleNow": "Agenda",
  "agents.scheduleNow.active": "Dentro do horário",
  "agents.scheduleNow.idle": "Fora do horário",
  "agents.scheduleNow.none": "Sem horário ativo",
  "agents.scheduleNow.until": "até {time}",
  "agents.scheduleNow.resumes": "retoma {time}",
  "agents.scheduleNow.always": "24 h, 7 dias",
  "agents.queueEta": "Fila restante",
  "agents.queueEtaEmpty": "Sem itens na fila",
  "agents.schedule.day.0": "Seg",
  "agents.schedule.dayLong.0": "Segunda",
  "agents.schedule.day.1": "Ter",
  "agents.schedule.dayLong.1": "Terça",
  "agents.schedule.day.2": "Qua",
  "agents.schedule.dayLong.2": "Quarta",
  "agents.schedule.day.3": "Qui",
  "agents.schedule.dayLong.3": "Quinta",
  "agents.schedule.day.4": "Sex",
  "agents.schedule.dayLong.4": "Sexta",
  "agents.schedule.day.5": "Sáb",
  "agents.schedule.dayLong.5": "Sábado",
  "agents.schedule.day.6": "Dom",
  "agents.schedule.dayLong.6": "Domingo",
  "agents.schedule.title": "Horário e ritmo",
  "agents.schedule.hint": "Agenda semanal no horário de Brasília (America/Sao_Paulo), formato 24 h",
  "agents.schedule.pause": "Pausa entre consultas (s)",
  "agents.schedule.pauseHint": "Entre {min} e {max} segundos",
  "agents.schedule.maxPerHour": "Máx. de consultas por hora",
  "agents.schedule.maxPerHourHint": "Até {max} por hora",
  "agents.schedule.fallback": "Usar lacunas quando a fila estiver vazia",
  "agents.schedule.fallbackHint":
    "Sem tarefas na fila, o agente consulta as lacunas de cobertura mais frequentes.",
  "agents.schedule.killSwitch": "Pausar o agente",
  "agents.schedule.killSwitchOn":
    "O agente está pausado. Nenhuma consulta nova no IOB até retomar; a VM continua ligada.",
  "agents.schedule.killSwitchOff":
    "Para de consultar o IOB na próxima verificação do agente (até 5 min), sem desligar a VM.",
  "agents.schedule.pauseConfirm.title": "Pausar o agente?",
  "agents.schedule.pauseConfirm.body":
    "O agente termina a consulta atual e não inicia nenhuma outra no IOB até que alguém retome. A fila e o progresso das tarefas são mantidos.",
  "agents.schedule.pauseConfirm.confirm": "Pausar agente",
  "agents.schedule.effective": "Ritmo efetivo",
  "agents.schedule.effectiveValue": "{count} consultas/h",
  "agents.schedule.limitedByCap": "limitado pelo máximo por hora",
  "agents.schedule.limitedByPause": "limitado pela pausa",
  "agents.schedule.issue.PAUSE_RANGE":
    "A pausa deve ser um número inteiro entre {min} e {max} segundos.",
  "agents.schedule.issue.RATE_RANGE":
    "O máximo por hora deve ser um número inteiro entre 1 e {max}.",
  "agents.schedule.updated": "Atualizado por {who} em {time}",
  "agents.schedule.neverUpdated": "Valores padrão, nunca alterados",
  "agents.schedule.save": "Salvar horário e ritmo",
  "agents.schedule.discard": "Descartar",
  "agents.schedule.saved": "Horário e ritmo salvos. O agente aplica na próxima consulta.",
  "agents.schedule.conflict":
    "Outra pessoa alterou estas configurações. Carregamos os valores atuais; revise e salve de novo.",
  "agents.schedule.error": "Não foi possível salvar. Tente novamente.",
  "agents.schedule.dirty": "Alterações não salvas",
  "agents.who.you": "você",
  "agents.credentials.title": "Credenciais IOB",
  "agents.credentials.configured": "Configuradas",
  "agents.credentials.notConfigured": "Não configuradas",
  "agents.credentials.notConfiguredBody":
    "Sem credenciais o agente não consegue entrar no IOB Simulador.",
  "agents.credentials.account": "Conta",
  "agents.credentials.updated": "Atualizadas por {who} em {time}",
  "agents.credentials.explain":
    "Salvas direto no cofre de credenciais da plataforma. Não ficam no banco de dados, nos logs nem neste navegador, e ninguém consegue lê-las de volta por aqui. O agente usa as novas credenciais na próxima sessão.",
  "agents.credentials.username": "Usuário do IOB",
  "agents.credentials.password": "Senha do IOB",
  "agents.credentials.save": "Salvar credenciais",
  "agents.credentials.replace": "Substituir credenciais",
  "agents.credentials.saving": "Salvando…",
  "agents.credentials.saved":
    "Credenciais salvas com segurança. O agente as usa na próxima sessão.",
  "agents.credentials.error":
    "Não foi possível salvar as credenciais. Nada foi alterado; tente novamente.",
  "agents.credentials.unavailableTitle": "Cofre de credenciais não configurado",
  "agents.credentials.unavailableBody":
    "Este ambiente ainda não tem o cofre das credenciais IOB. Quando a infraestrutura estiver pronta, as credenciais poderão ser cadastradas aqui.",
  "agents.queue.title": "Fila de tarefas",
  "agents.queue.description":
    "O agente trabalha a fila de cima para baixo, uma consulta por vez, no ritmo e na agenda semanal configurados.",
  "agents.queue.pace":
    "{perHour} consultas/h · {perWeek} por semana · {hours} de agenda por semana",
  "agents.queue.new": "Nova tarefa",
  "agents.queue.empty.title": "A fila está vazia",
  "agents.queue.empty.body":
    "Crie uma tarefa para o agente consultar o catálogo, os NCMs que usamos ou uma lista.",
  "agents.queue.emptyGaps":
    "Enquanto a fila estiver vazia, o agente trabalha nas lacunas de cobertura.",
  "agents.queue.finished": "Concluídas",
  "agents.queue.workingNow": "Trabalhando agora",
  "agents.queue.position": "Posição {position}",
  "agents.queue.progress": "{processed} de {items}",
  "agents.queue.count.done": "{count} consultadas",
  "agents.queue.count.cached": "{count} já cobertas",
  "agents.queue.count.failed": "{count} com falha",
  "agents.queue.count.pending": "{count} pendentes",
  "agents.queue.count.skipped": "{count} puladas",
  "agents.queue.eta": "Estimativa",
  "agents.queue.eta.minutes": "≈ {count} min de agenda",
  "agents.queue.eta.hours": "≈ {count} h de agenda",
  "agents.queue.eta.until": "término ≈ {time} (Brasília)",
  "agents.queue.eta.done": "Sem itens pendentes",
  "agents.queue.eta.paused": "Em pausa · sem estimativa",
  "agents.queue.eta.agentPaused": "Agente pausado · sem estimativa",
  "agents.queue.eta.none": "Sem estimativa: revise o horário e o ritmo",
  "agents.queue.eta.completed": "Concluída em {time}",
  "agents.queue.eta.cancelled": "Cancelada em {time}",
  "agents.queue.created": "Criada em {time}",
  "agents.queue.actions": "Ações da tarefa {name}",
  "agents.queue.action.MOVE_UP": "Subir",
  "agents.queue.action.MOVE_DOWN": "Descer",
  "agents.queue.action.MOVE_TO_FRONT": "Mover para o início",
  "agents.queue.action.PAUSE": "Pausar",
  "agents.queue.action.RESUME": "Retomar",
  "agents.queue.action.CANCEL": "Cancelar tarefa",
  "agents.queue.details": "Detalhes",
  "agents.queue.actionError": "Não foi possível atualizar a tarefa. Tente novamente.",
  "agents.queue.cancel.title": "Cancelar a tarefa “{name}”?",
  "agents.queue.cancel.body":
    "Os {count} itens pendentes serão pulados. O que já foi consultado continua registrado como achado. Não é possível desfazer.",
  "agents.queue.cancel.confirm": "Cancelar tarefa",
  "agents.queue.cancel.keep": "Manter na fila",
  "agents.task.status.QUEUED": "Na fila",
  "agents.task.status.RUNNING": "Em andamento",
  "agents.task.status.PAUSED": "Pausada",
  "agents.task.status.COMPLETED": "Concluída",
  "agents.task.status.CANCELLED": "Cancelada",
  "agents.task.scope.CATALOG": "Catálogo NCM completo",
  "agents.task.scope.CATALOG_CHAPTERS": "Catálogo NCM · capítulos {chapters}",
  "agents.task.scope.SEEN": "NCMs usados nos nossos cálculos (12 meses)",
  "agents.task.scope.LIST": "Lista de {count} NCMs",
  "agents.task.scope.LOOKUP_JOB": "Consulta do sistema",
  "agents.task.scope.SWEEP": "Pesquisa web",
  "agents.task.item.PENDING": "Pendente",
  "agents.task.item.IN_PROGRESS": "Consultando",
  "agents.task.item.DONE": "Consultado",
  "agents.task.item.CACHED": "Já coberto",
  "agents.task.item.FAILED": "Falhou",
  "agents.task.item.SKIPPED": "Pulado",
  "agents.task.detail.route": "Rota",
  "agents.task.detail.scope": "Escopo",
  "agents.task.detail.started": "Início",
  "agents.task.detail.items": "Itens",
  "agents.task.detail.filter": "Filtrar itens por estado",
  "agents.task.detail.all": "Todos",
  "agents.task.detail.col.ncm": "NCM",
  "agents.task.detail.col.status": "Estado",
  "agents.task.detail.col.outcome": "Resultado",
  "agents.task.detail.col.attempts": "Tentativas",
  "agents.task.detail.col.updated": "Atualizado",
  "agents.task.detail.empty": "Nenhum item com este estado.",
  "agents.task.detail.showing": "{shown} de {total}",
  "agents.task.detail.notFound": "Tarefa não encontrada.",
  "agents.create.title": "Nova tarefa",
  "agents.create.name": "Nome",
  "agents.create.nameHint": "Se ficar em branco, usamos “{name}”.",
  "agents.create.scope": "O que consultar",
  "agents.create.scope.CATALOG.body":
    "Todos os NCMs ativos do catálogo oficial, ou só os capítulos escolhidos.",
  "agents.create.scope.SEEN.body": "NCMs que apareceram nos nossos cálculos nos últimos 365 dias.",
  "agents.create.scope.LIST": "Lista de NCMs",
  "agents.create.scope.LIST.body": "Cole os códigos: um por linha ou separados por vírgula.",
  "agents.create.chapters": "Capítulos (opcional)",
  "agents.create.chaptersAll": "Nenhum capítulo escolhido: o catálogo inteiro.",
  "agents.create.chaptersSome.one": "{count} capítulo escolhido",
  "agents.create.chaptersSome.other": "{count} capítulos escolhidos",
  "agents.create.chaptersClear": "Limpar",
  "agents.create.chapter": "Capítulo {chapter}",
  "agents.create.list": "NCMs",
  "agents.create.listPlaceholder": "8516.31.00\n85094050\n2203.00.00, 3304.99.90",
  "agents.create.listCount": "Válidos: {count}",
  "agents.create.listDuplicates": "Repetidos ignorados: {count}",
  "agents.create.listInvalid": "Inválidos: {count}",
  "agents.create.listInvalidLine": "Linha {line}: “{value}”",
  "agents.create.listMore": "e mais {count}",
  "agents.create.listTooMany": "Máximo de {max} NCMs por tarefa.",
  "agents.create.listEmpty": "Cole pelo menos um NCM de 8 dígitos.",
  "agents.create.listInvalidBlock": "Corrija ou remova as linhas inválidas para criar a tarefa.",
  "agents.create.origin": "UF de origem",
  "agents.create.destination": "UF de destino",
  "agents.create.skipCovered": "Pular NCMs já cobertos",
  "agents.create.skipCoveredHint":
    "Não consulta o que uma regra publicada ou um achado dos últimos 30 dias já responde.",
  "agents.create.placement": "Posição na fila",
  "agents.create.placement.END": "No fim da fila",
  "agents.create.placement.FRONT": "Na frente",
  "agents.create.estimate": "Estimativa",
  "agents.create.estimateOnCreate":
    "Calculado ao criar: o total de NCMs só é conhecido no servidor.",
  "agents.create.estimateList": "{count} consultas · {eta} · {until}",
  "agents.create.estimateSkip": "Antes de pular os já cobertos; o total real pode ser menor.",
  "agents.create.estimatePending": "Cole a lista para ver a estimativa.",
  "agents.create.submit": "Criar tarefa",
  "agents.create.creating": "Criando…",
  "agents.create.error": "Não foi possível criar a tarefa. Revise os campos e tente novamente.",
  "agents.jobs.title": "Consultas do sistema",
  "agents.jobs.description":
    "Somente leitura. Fluxos do backend enviam milhares de NCM × rota; o que uma regra publicada já cobre é respondido na hora, o resto vai para pesquisa.",
  "agents.jobs.empty": "Nenhuma consulta enviada pelo sistema.",
  "agents.jobs.entries": "{count} entradas",
  "agents.jobs.lanes": "Pesquisa",
  "agents.jobs.lane.iob": "IOB",
  "agents.jobs.lane.web": "Web",
  "agents.jobs.lane.none": "Só cache",
  "agents.jobs.eta": "Previsão",
  "agents.jobs.heading": "Consulta em lote · cálculo de {date}",
  "agents.jobs.workflow": "Fluxo",
  "agents.jobs.created": "Criado",
  "agents.jobs.completed": "Concluído",
  "agents.jobs.calcDate": "Data de cálculo",
  "agents.jobs.openTask": "Ver tarefa",
  "agents.jobs.noTask": "Sem tarefa IOB",
  "agents.jobs.breakdown": "Entradas por estado",
  "agents.jobs.status.RUNNING": "Em andamento",
  "agents.jobs.status.COMPLETED": "Concluído",
  "agents.jobs.status.CANCELLED": "Cancelado",
  "agents.jobs.entry.COVERED": "Coberto",
  "agents.jobs.entry.FOUND": "Encontrado",
  "agents.jobs.entry.NO_ST": "Sem ST",
  "agents.jobs.entry.NOT_FOUND": "Não encontrado",
  "agents.jobs.entry.FAILED": "Falhou",
  "agents.jobs.entry.QUEUED": "Na fila",
  "agents.jobs.entry.RESEARCHING": "Pesquisando",
  "nav.mode": "Modo",
  "nav.mode.developers": "Desenvolvedores",
  "nav.developers.keys": "Chaves de API",
  "nav.developers.requests": "Requisições",
  "nav.developers.docs": "Documentação da API",
  "nav.developers.mcp": "Ferramentas MCP",
  "nav.developers.section": "API",
  "nav.developers.dock": "Desenvolvedores",
  "nav.viewAs.title": "Prévia por perfil",
  "nav.viewAs.help":
    "Confira a navegação e as ferramentas disponíveis. Sua conta continua como Superadministrador; as ações usam sua conta real.",
  "nav.viewAs.label": "Ver como",
  "nav.viewAs.own": "Eu",
  "nav.viewAs.short.commercial": "Comercial",
  "nav.viewAs.short.manager": "Gestor",
  "nav.viewAs.short.developer": "Dev",
  "nav.viewAs.short.reader": "Leitor",
  "nav.viewAs.acting": "Vendo como {role}",
  "nav.viewAs.banner":
    "Você está vendo o espaço como {role}. A sessão de superadministrador não muda.",
  "nav.viewAs.exit": "Voltar para Superadministrador",
  "nav.operationsHome": "Operações",
  "nav.menu": "Menu de navegação",
  "nav.open": "Abrir navegação",
  "nav.close": "Fechar navegação",
  "nav.collapse": "Recolher navegação",
  "nav.expand": "Expandir navegação",
  "nav.locked": "Sem permissão",

  "trace.origin": "Origem",
  "trace.state": "Estado",
  "trace.next": "Próximo passo",
  "trace.howItWorks": "Como funciona",
  "trace.evidence.origin": "Fonte observada",
  "trace.evidence.state": "Triagem",
  "trace.evidence.next": "Propor ou arquivar",
  "trace.sources.origin": "Fonte oficial revisada",
  "trace.sources.state": "Coleta",
  "trace.sources.next": "Rodar ou reprocessar",
  "trace.proposals.origin": "Evidência aceita",
  "trace.proposals.state": "Revisão",
  "trace.proposals.next": "Publicar conjunto",
  "trace.rulesets.origin": "Propostas aprovadas",
  "trace.rulesets.state": "Publicação",
  "trace.rulesets.next": "Cálculo fixa a versão",
  "trace.rules.origin": "Capítulo SH",
  "trace.rules.state": "Regra publicada",
  "trace.rules.next": "Lacuna sem alíquota inventada",
  "trace.rules.chapter.origin": "Capítulo SH",
  "trace.rules.chapter.state": "Classificação oficial",
  "trace.rules.chapter.next": "Subconjunto publicado, se houver",
  "trace.audit.origin": "Ator",
  "trace.audit.state": "Ação",
  "trace.audit.next": "Correlação",
  "commandSearch.trigger": "Buscar no espaço fiscal",
  "commandSearch.title": "Busca fiscal",
  "commandSearch.description":
    "Lance uma extração, abra o catálogo Siscomex (classificação, não alíquota) ou um registro já gravado.",
  "commandSearch.placeholder": "ICMS SP papelaria, NCM 84713012, ou um destino…",
  "commandSearch.results": "Resultados da busca fiscal",
  "commandSearch.emptyTitle": "Nada encontrado nesta base",
  "commandSearch.emptyBody": "Tente um imposto, UF, NCM, capítulo SH ou o nome de uma evidência.",
  "commandSearch.move": "Mover",
  "commandSearch.open": "Abrir",
  "commandSearch.close": "Fechar busca",
  "commandSearch.honesty": "Catálogo classifica. Só o conjunto publicado calcula.",
  "commandSearch.group.launch": "Lançar extração",
  "commandSearch.group.evidence": "Evidências",
  "commandSearch.group.rules": "Regras",
  "commandSearch.group.sources": "Fontes",
  "commandSearch.group.proposals": "Propostas",
  "commandSearch.group.calculations": "Cálculos",
  "commandSearch.group.catalog": "Catálogo NCM",
  "commandSearch.launch.label": "Buscar {query} nas fontes oficiais",
  "commandSearch.launch.hint": "Fetcher e extrator. Não publica regra.",
  "commandSearch.catalog.label": "NCM {ncm} no catálogo Siscomex",
  "commandSearch.catalog.hint": "Classificação oficial. Não é alíquota publicada.",
  "commandSearch.catalog.prefix.label": "NCM {ncm}… no catálogo Siscomex",
  "commandSearch.catalog.chapter.label": "SH {chapter} · {title}",
  "commandSearch.catalog.chapter.hint": "Capítulo do Sistema Harmonizado. Não é alíquota.",
  "commandSearch.searching": "Buscando em {groups}…",
  "commandSearch.partialError": "Não foi possível buscar em {groups}.",
  "commandSearch.emptyPartialTitle": "Nada encontrado nas categorias que responderam",
  "commandSearch.denied": "Fora do seu acesso, não pesquisado: {groups}.",
  "ui.sort.label": "Ordenar por",
  "ui.sort.direction": "Ordem {direction}",
  "ui.table.staleError":
    "Não foi possível atualizar a lista. As linhas abaixo podem estar desatualizadas.",
  "ui.table.refreshing": "Atualizando…",
  "ui.table.loading": "Carregando resultados…",
  "ui.table.density": "Densidade",
  "ui.table.density.normal": "Normal",
  "ui.table.density.compact": "Compacta",
  "ui.table.columns": "Colunas",
  "ui.table.columnsLegend": "Colunas secundárias",
  "ui.drawer.navLabel": "Navegar na lista",
  "ui.drawer.previous": "Anterior na lista",
  "ui.drawer.next": "Próximo na lista",
  "ui.drawer.position": "{index} de {total}",
  "ui.toast.region": "Notificações",
  "ui.toast.close": "Fechar notificação",
  "ui.stat.error": "Não foi possível carregar este número",
  "ui.stat.unknown": "Sem dados para este período",
  "ui.stat.stale": "Desatualizado",
  "ui.stat.staleSince": "Desatualizado · {since}",
  "lots.summary.count.one": "{count} lote",
  "lots.summary.count.other": "{count} lotes",
  "lots.summary.window": "· período: {period}",
  "lots.toast.exported": "{format} exportado · {count} itens",
  "lots.toast.truncated": "{format} exportado até o limite de {cap} itens",
  "lots.toast.failed": "Exportação {format} não concluída",
  "proposals.summary.count.one": "{count} proposta",
  "proposals.summary.count.other": "{count} propostas",
  "evidence.toast.APPROVED.one": "{count} documento aprovado",
  "evidence.toast.APPROVED.other": "{count} documentos aprovados",
  "evidence.toast.REJECTED.one": "{count} documento rejeitado",
  "evidence.toast.REJECTED.other": "{count} documentos rejeitados",
  "evidence.toast.DUPLICATE.one": "{count} documento marcado como duplicado",
  "evidence.toast.DUPLICATE.other": "{count} documentos marcados como duplicados",

  "common.placeholder.url": "https://…",
  "common.placeholder.evidencePath": "/evidence/…",
  "common.placeholder.sourceRunPath": "/sources/…/runs/…",
  "common.placeholder.uuid": "00000000-0000-0000-0000-000000000000",
  "common.placeholder.time": "HH:MM",
  "common.search": "Buscar",
  "proposals.filter.search": "Resumo, referência ou NCM",
  "rulesets.filter.search": "Versão ou autor",
  "rules.filter.search": "NCM, trecho ou referência",
  "audit.filter.search": "Ação, ator ou correlação",
  "rulesets.inForce": "Conjunto em vigor",
  "rulesets.inForce.missing": "Nenhum conjunto publicado",
  "common.filters": "Filtros",
  "common.moreFilters": "Mais filtros",
  "common.clear": "Limpar",
  "common.clearFilters": "Limpar filtros",
  "date.placeholder.dmy": "dd/mm/aaaa",
  "date.placeholder.mdy": "mm/dd/yyyy",
  "date.openCalendar": "Abrir calendário",
  "common.apply": "Aplicar",
  "common.save": "Salvar",
  "common.cancel": "Cancelar",
  "common.close": "Fechar",
  "common.back": "Voltar",
  "common.next": "Avançar",
  "tabs.scrollNext": "Mais abas",
  "tabs.scrollPrev": "Abas anteriores",
  "common.confirm": "Confirmar",
  "common.copy": "Copiar",
  "common.copied": "Copiado",
  "common.loading": "Carregando…",
  "common.refresh": "Atualizar",
  "common.retry": "Tentar novamente",
  "common.details": "Detalhes",
  "common.status": "Situação",
  "common.jurisdiction": "Jurisdição",
  "common.publisher": "Publicador",
  "common.updated": "Atualizado",
  "common.created": "Criado",
  "common.author": "Autor",
  "common.reviewer": "Revisor",
  "common.reason": "Justificativa",
  "common.none": "Nenhum",
  "common.all": "Todos",
  "common.selected.one": "{count} selecionado",
  "common.selected.other": "{count} selecionados",
  "common.selectAll": "Selecionar tudo na página",
  "common.selectRow": "Selecionar {label}",
  "common.results.one": "{count} resultado",
  "common.results.other": "{count} resultados",
  "common.loadMore": "Carregar mais",
  "common.loadingMore": "Carregando resultados…",
  "common.endOfList": "Fim da lista",
  "common.firstPage": "Primeira página",
  "common.pageSize": "Itens por página",
  "common.sortBy": "Ordenar por {field}",
  "common.sortAscending": "crescente",
  "common.sortDescending": "decrescente",
  "common.language": "Idioma",
  "common.environment": "Ambiente",
  "common.of": "de",
  "common.yes": "Sim",
  "common.no": "Não",
  "common.notAvailable": "—",
  "common.workspaceHome": "Início do espaço fiscal",

  "state.empty.title": "Nenhum resultado neste recorte",
  "state.empty.body": "Limpe os filtros para ver a lista, ou busque com outro termo.",
  "stepper.state.pending": "pendente",
  "stepper.state.current": "etapa atual",
  "stepper.state.complete": "concluída",
  "stepper.state.invalid": "precisa de correção",
  "stepper.state.blocked": "bloqueada até corrigir uma etapa anterior",
  "stepper.state.submitting": "enviando",
  "stepper.state.result": "resultado",
  "state.error.title": "Não foi possível carregar",
  "state.error.body": "A requisição falhou. Verifique a conexão e tente novamente.",
  "state.loading.label": "Carregando conteúdo",

  "access.denied.title": "Acesso negado",
  "access.denied.body":
    "Seu perfil não inclui {permission}. Solicite ao administrador do espaço fiscal.",
  "access.denied.short": "Requer {permission}",
  "access.disabled.title": "Ação indisponível agora",
  "access.disabled.body": "{reason}",
  "access.unavailable.title": "Serviço indisponível",
  "access.unavailable.body":
    "A dependência necessária não está respondendo: {reason}. Tente novamente mais tarde.",
  "access.requestAccess": "Solicitar acesso",
  "access.legend": "Negado, desabilitado e indisponível são estados distintos.",

  "auth.accessTitle": "Entre na sua conta",
  "auth.signIn": "Entrar",
  "auth.email": "E-mail",
  "auth.emailPlaceholder": "nome@backchannel.com.br",
  "auth.password": "Senha",
  "auth.showPassword": "Mostrar senha",
  "auth.hidePassword": "Ocultar senha",
  "auth.forgotPassword": "Esqueci minha senha",
  "auth.resetPassword": "Redefinir senha",
  "auth.resetPasswordDescription":
    "Enviaremos um link para o e-mail da conta, no idioma em que ela foi criada.",
  "auth.resetLinkDescription": "Defina uma nova senha para entrar no Tax Operations.",
  "auth.error.passwordMismatch": "As senhas não coincidem.",
  "auth.invite.title": "Configurar conta",
  "auth.invite.description":
    "Escolha sua senha primeiro. Na próxima etapa, você pode adicionar uma passkey ou entrar no seu espaço de trabalho.",
  "auth.invite.activationError":
    "Não foi possível ativar sua conta. Tente novamente. Se o problema continuar, fale com seu administrador.",
  "auth.invite.submit": "Ativar conta",
  "auth.invite.invalid": "Este convite é inválido ou já expirou. Peça um novo convite.",
  "auth.invite.invalidHelp": "Peça um novo convite a um superadministrador.",
  "auth.invite.displayName": "Como devemos te chamar",
  "auth.invite.expires": "Convite válido até {date}",
  "auth.invite.passkeyTitle": "Cadastrar uma passkey (opcional)",
  "auth.invite.passkeyDescription":
    "A passkey entra neste espaço sem senha. Você pode pular e cadastrar depois no perfil.",
  "auth.invite.passkeySkip": "Agora não",
  "auth.passwordPolicy": "Mínimo de 8 caracteres. Não exige maiúsculas, números ou símbolos.",
  "auth.error.passwordLength": "Use entre 8 e 128 caracteres.",
  "auth.sendResetLink": "Enviar link",
  "auth.resetMissing": "Este link de redefinição é inválido ou já expirou. Peça um novo em Entrar.",
  "auth.newPassword": "Nova senha",
  "auth.confirmPassword": "Confirmar nova senha",
  "auth.confirmReset": "Definir nova senha",
  "auth.backToSignIn": "Voltar para entrar",
  "auth.resetting": "Atualizando…",
  "auth.resetSent": "Se esta conta puder ser recuperada, enviamos um link de redefinição.",
  "auth.resetComplete": "Senha atualizada. Entre com sua nova senha.",
  "auth.signOut": "Sair",
  "auth.accountMenu": "Menu da conta",
  "auth.accountTrigger": "Abrir menu da conta de {name}",
  "auth.accountSection": "Sua conta",
  "auth.accountSettings": "Minha conta",
  "auth.enterDevelopers": "Ir para Developers",
  "auth.backToOperations": "Voltar para Operações",
  "auth.languagePreference": "Preferência de idioma",
  "auth.signingIn": "Autenticando…",
  "auth.loading.title": "Preparando seu espaço.",
  "auth.loading.description": "Um momento para abrir seu ambiente de trabalho.",
  "auth.loading.delayedDetail": "Você pode continuar aguardando.",
  "auth.loading.territory": "Brasil · Território fiscal",
  "auth.loading.country": "Brasil",
  "auth.loading.reconnect": "Restabelecendo sua conexão",
  "auth.loading.session": "Restaurando a sessão protegida",
  "auth.loading.identity": "Verificando sua identidade BackChannel",
  "auth.loading.workspace": "Você será direcionado assim que estiver pronto.",
  "auth.loading.delayed": "Está levando mais tempo que o habitual.",
  "auth.session": "Sessão",
  "auth.sessionUnavailable": "Não foi possível carregar sua sessão",
  "auth.sessionUnavailableDescription":
    "Sua identidade continua autenticada, mas o plano fiscal não respondeu. Tente novamente ou encerre a sessão.",
  "auth.role": "Perfil",
  "auth.permissions": "Permissões",
  "auth.mock": "Sessão simulada",
  "auth.callback.title": "Concluindo autenticação",
  "auth.callback.body": "Trocando o código de autorização por tokens de sessão.",
  "auth.error.title": "Falha na autenticação",
  "auth.error.state": "Parâmetro state inválido: possível tentativa de CSRF.",
  "auth.error.missingCode": "O provedor não retornou um código de autorização.",
  "auth.error.exchange": "A troca do código de autorização falhou.",
  "auth.error.config": "O acesso não está configurado: {reason}.",
  "auth.error.credentials": "Não foi possível entrar. Verifique o e-mail e a senha.",
  "auth.error.resetEmailRequired": "Informe seu e-mail primeiro para redefinir a senha.",
  "auth.error.resetMismatch": "As senhas não coincidem.",
  "auth.error.reset":
    "Não foi possível redefinir a senha. Solicite um novo link e tente novamente.",
  "auth.error.network":
    "O serviço de identidade está indisponível agora. Verifique sua conexão e tente novamente.",
  "auth.error.challenge":
    "Sua conta exige uma etapa adicional. Conclua a configuração da conta e tente novamente.",
  "auth.error.passwordResetRequired":
    "Sua senha precisa ser redefinida. Use “Esqueci minha senha?” para continuar.",
  "auth.passkey": "Entrar com passkey",
  "auth.passkeySigningIn": "Aguardando sua passkey…",
  "auth.google": "Continuar com Google",
  "auth.googleRedirecting": "Abrindo o Google…",
  "auth.googleReaderNote": "Primeiro acesso com Google: perfil Leitor.",
  "auth.continueWithEmail": "Continuar com e-mail",
  "auth.otherOptions": "Outras formas de entrar",
  "auth.emailFormLabel": "Entrar com e-mail e senha",
  "auth.lastUsed": "Último método usado neste navegador",
  "auth.callback.googleBody": "Confirmando seu login com Google.",
  "auth.callback.provisionedTitle": "Conta criada",
  "auth.callback.provisionedBody":
    "Conta criada como Leitor — peça a um administrador para ajustar seu acesso.",
  "auth.callback.provisionedHint":
    "Você já pode consultar as áreas de leitura. Um superadministrador pode alterar seu perfil em Administração → Usuários.",
  "auth.callback.provisionedContinue": "Continuar",
  "auth.error.google": "Não foi possível entrar com Google. Tente novamente.",
  "auth.error.googleNotInvited":
    "Esta conta Google não tem acesso a Operações Fiscais. Use sua conta @backchannel.com.br ou peça acesso a um superadministrador.",
  "auth.error.googleRejected": "O Google não confirmou este login. Tente novamente.",
  "auth.error.googleUnavailable":
    "O login com Google não está disponível agora. Entre com e-mail e senha ou passkey.",
  "auth.error.googleCancelled": "O login com Google foi cancelado.",
  "auth.or": "ou",
  "auth.passkeyHostHint": "Disponível em tax.backchannel.com.br ou neste localhost.",
  "auth.passkeyHostHintDeployed": "Disponível em tax.backchannel.com.br.",
  "auth.error.passkey": "Não foi possível verificar a passkey. Tente novamente.",
  "auth.error.passkeyUnsupported": "Este navegador não oferece passkeys.",
  "auth.error.passkeyCancelled":
    "A passkey não foi usada. Tente de novo ou escolha outra forma de entrar.",
  "auth.error.passkeyOrigin":
    "Abra as Operações Fiscais pelo domínio BackChannel para usar esta passkey.",
  "auth.error.passkeyUnavailable":
    "O login com passkey está temporariamente indisponível. Use sua senha ou tente novamente mais tarde.",
  "auth.error.passkeyTimeout":
    "A solicitação da passkey demorou demais. Tente novamente ou use sua senha.",
  "auth.accessPending.title": "Acesso ao espaço fiscal pendente",
  "auth.accessPending.body":
    "Sua identidade BackChannel foi validada, mas ainda não foi cadastrada como operador fiscal neste espaço. Solicite que um administrador faça o cadastro no registro de operadores.",
  "auth.accessPending.request": "Solicitar acesso ao espaço fiscal",
  "auth.expired": "Sua sessão expirou. Entre novamente para continuar.",
  "auth.tokenNotice":
    "O token de identidade fica apenas em memória; esta aba mantém um refresh token isolado e nunca grava credenciais em logs.",
  "auth.loginDescription": "Evidências, regras e cálculos fiscais do Brasil.",
  "auth.brand.secure": "Acesso protegido pela identidade BackChannel.",
  "auth.brand.help": "Precisa de ajuda?",
  "auth.map.title": "Mapa fiscal do Brasil",
  "auth.map.legend.label": "Legenda do mapa",
  "auth.map.legend.unwatched": "Fora da lista atual",
  "auth.map.stateLabel": "{state} ({uf}). Capital {capital}. {watch}.",
  "auth.map.watched": "SEFAZ acompanhada",
  "auth.map.unwatched": "Fora da lista atual de SEFAZ",
  "auth.map.fact.AC": "O nome vem do rio Aquiri; faz fronteira com o Peru e a Bolívia.",
  "auth.map.fact.AL": "Segundo menor estado do Brasil; Maceió vive entre lagoas e o mar.",
  "auth.map.fact.AP": "A linha do Equador atravessa o Amapá.",
  "auth.map.fact.AM": "O maior estado do país: a maior parte da Amazônia brasileira fica aqui.",
  "auth.map.fact.BA": "Salvador foi a primeira capital do Brasil.",
  "auth.map.fact.CE": "Fortaleza tem uma das orlas urbanas mais longas do país.",
  "auth.map.fact.DF": "Brasília foi inaugurada em 1960; é distrito federal, não estado.",
  "auth.map.fact.ES": "Vitória é uma capital-ilha, ligada ao continente por pontes.",
  "auth.map.fact.GO": "Coração do Cerrado; Goiânia nasceu planejada em 1933.",
  "auth.map.fact.MA": "Os Lençóis Maranhenses são dunas com lagoas de chuva.",
  "auth.map.fact.MT": "Abriga o norte do Pantanal e a Chapada dos Guimarães.",
  "auth.map.fact.MS": "Bonito e o sul do Pantanal ficam neste estado.",
  "auth.map.fact.MG": "Tem mais municípios do que qualquer outro estado.",
  "auth.map.fact.PA": "Belém fica na foz do Amazonas; a ilha de Marajó é enorme.",
  "auth.map.fact.PB": "A Ponta do Seixas é o extremo leste das Américas.",
  "auth.map.fact.PR": "As Cataratas do Iguaçu ficam na fronteira com a Argentina.",
  "auth.map.fact.PE": "Recife e Olinda formam o par colonial do litoral.",
  "auth.map.fact.PI": "Tem o menor litoral do Nordeste, no delta do Parnaíba.",
  "auth.map.fact.RJ": "Foi a capital do Brasil até 1960.",
  "auth.map.fact.RN": "Natal foi fundada no Natal de 1599.",
  "auth.map.fact.RS": "Único estado de maioria pampa; terra da cultura gaúcha.",
  "auth.map.fact.RO": "Nasceu do território da ferrovia Madeira-Mamoré.",
  "auth.map.fact.RR": "O estado mais ao norte; o Monte Roraima é um tepui.",
  "auth.map.fact.SC": "Florianópolis é capital-ilha, com forte imigração europeia.",
  "auth.map.fact.SP": "O estado mais populoso; a sede da BackChannel fica em Vila Olímpia.",
  "auth.map.fact.SE": "O menor estado do Brasil em área.",
  "auth.map.fact.TO": "O estado mais novo, criado em 1988 a partir do norte de Goiás.",
  "auth.map.hq.fact": "Rua Tenerife 31, conj. 31A — Edifício Tenerife, Vila Olímpia.",
  "auth.map.capital": "Capital",
  "auth.map.sefaz": "SEFAZ",
  "auth.map.close": "Fechar",
  "auth.map.illustrationKind": "Ilustração da região",
  "auth.map.regionArt.north": "Ilustração do Norte: território, rio e documento citado",
  "auth.map.regionArt.northeast":
    "Ilustração do Nordeste: território, sol no litoral e documento citado",
  "auth.map.regionArt.centralWest":
    "Ilustração do Centro-Oeste: território, chapadas e documento citado",
  "auth.map.regionArt.southeast": "Ilustração do Sudeste: território, cidade e documento citado",
  "auth.map.regionArt.south": "Ilustração do Sul: território, araucárias e documento citado",
  "auth.map.hq.name": "Sede BackChannel",
  "auth.map.hq.eyebrow": "São Paulo",
  "auth.map.hq.role": "Escritório · Vila Olímpia",
  "auth.map.hq.address": "Endereço",
  "auth.map.hq.phone": "Telefone",
  "auth.map.hq.openMaps": "Abrir no Google Maps",
  "auth.map.hq.pinLabel": "Sede BackChannel em Vila Olímpia, São Paulo",
  "auth.map.hq.illustrationAlt":
    "Ilustração da sede BackChannel: São Paulo no mapa e o edifício do conjunto 31A em Vila Olímpia",
  "auth.map.hq.label": "São Paulo · sede",
  "auth.domainHint": "Use sua conta @backchannel.com.br.",
  "auth.providersLoading": "Verificando as formas de entrar…",
  "auth.providersFailed": "Não foi possível verificar o login com Google.",
  "auth.error.emailRequired": "Informe seu e-mail.",
  "auth.error.emailInvalid": "Informe um e-mail válido, como nome@backchannel.com.br.",
  "auth.error.passwordRequired": "Informe sua senha.",
  "auth.atlas.title": "O território fiscal, UF por UF.",
  "auth.atlas.context": "{count} SEFAZ na lista de fontes acompanhadas",
  "auth.atlas.place": "Vila Olímpia",
  "auth.atlas.compactLabel": "Brasil, com a sede da BackChannel em São Paulo",
  "auth.value.label": "O que a plataforma faz",
  "auth.value.calculation": "Cálculo de ICMS, ST e IPI por NCM e rota",
  "auth.value.evidence": "Regras com evidência oficial",
  "auth.value.research": "Agente IOB e pesquisa nas SEFAZ",

  "overview.workspace.eyebrow": "Impostos de produtos",
  "overview.workspace.title": "Consulte, calcule e confira",
  "overview.workspace.description":
    "Encontre regras por produto e trajeto, calcule sua planilha e consulte os resultados.",
  "overview.mockNotice": "Demonstração local: os dados visíveis são simulados.",
  "overview.ledger.eyebrow": "Base fiscal",
  "overview.ledger.title": "O que a base já guarda, e o que ainda não governa",
  "overview.ledger.publishedOn": "Conjunto {version} publicado em {date}.",
  "overview.ledger.publishedEmpty":
    "Nenhum conjunto de regras publicado. Este sistema ainda não precifica listas.",
  "overview.ledger.unpublished": "Não publicado",
  "overview.ledger.noCount": "—",
  "overview.ledger.outsideBase": "fora desta base",
  "overview.ledger.ofCatalog": "de {catalog}",
  "overview.ledger.state.published": "publicado",
  "overview.ledger.state.draft": "em revisão",
  "overview.ledger.state.reference": "referência, não governada",
  "overview.ledger.state.absent": "ausente",
  "overview.ledger.state.notCollected": "não acompanhado aqui",
  "overview.ledger.family.ncm": "NCM",
  "overview.ledger.family.ncm.hint": "catálogo Siscomex, não alíquota",
  "overview.ledger.openCatalog": "Abrir catálogo NCM de referência",
  "overview.ledger.openCestCatalog": "Abrir catálogo CEST de referência",
  "overview.ledger.family.cest": "CEST",
  "overview.ledger.family.cest.hint": "catálogo CONFAZ, não alíquota",
  "overview.ledger.family.ipi": "IPI / TIPI",
  "overview.ledger.family.ipi.hint": "alíquota federal do IPI",
  "overview.ledger.family.pisCofins": "PIS / COFINS",
  "overview.ledger.family.pisCofins.hint":
    "catálogo legal V2 na calculadora · regime não acreditado",
  "overview.ledger.family.icms": "ICMS interno e interestadual",
  "overview.ledger.family.icms.hint": "alíquota interna e interestadual",
  "overview.ledger.family.icmsSt": "ICMS-ST",
  "overview.ledger.family.icmsSt.hint": "substituição tributária",
  "overview.ledger.family.mva": "MVA / IVA-ST",
  "overview.ledger.family.mva.hint": "margem de valor agregado",
  "overview.ledger.family.iss": "ISS",
  "overview.ledger.family.iss.hint":
    "fora desta base: revenda de mercadorias, não serviço municipal",
  "overview.ledger.openPublished": "Abrir regras publicadas",
  "overview.ledger.openDraft": "Abrir propostas em revisão",
  "overview.cycle.published": "Publicado",
  "overview.catalog.expiring": "Vencem em 30 dias",
  "overview.catalog.missingProvenance": "Sem proveniência",
  "overview.coverage.eyebrow": "Cobertura territorial",
  "overview.coverage.title": "Evidência e regras por UF",
  "overview.coverage.description":
    "Veja onde se concentram as regras de rota publicadas e as evidências capturadas. Selecione um estado para abrir o catálogo filtrado.",
  "overview.coverage.mode.label": "Dados de cobertura",
  "overview.coverage.mode.rules": "Regras publicadas",
  "overview.coverage.mode.evidence": "Evidências e notícias",
  "overview.coverage.map.title": "Mapa interativo da cobertura fiscal do Brasil",
  "overview.coverage.map.description":
    "Cada estado pode ser selecionado e sua cor representa a contagem relativa de registros. As contagens exatas aparecem nos detalhes do estado.",
  "overview.coverage.map.stateLabel":
    "{state}, {uf}: {count} registros. Selecione para ver detalhes.",
  "overview.coverage.legend.label": "Registros por UF nesta visão",
  "overview.coverage.legend.none": "0 registros",
  "overview.coverage.legend.low": "Menor",
  "overview.coverage.legend.mid": "Média",
  "overview.coverage.legend.high": "Maior",
  "overview.coverage.legend.unknown": "Sem dados",
  "overview.coverage.legend.explain.rules":
    "Cor = regras publicadas que citam a UF como origem ou destino, em faixas relativas entre as UF desta visão. Não é alíquota nem percentual nacional.",
  "overview.coverage.legend.explain.evidence":
    "Cor = evidências e notícias capturadas por UF, em faixas relativas entre as UF desta visão. Não é alíquota nem percentual nacional.",
  "overview.coverage.legend.ufCount": "{count} UF",
  "overview.coverage.legend.range": "{min}–{max} · {count} UF",
  "overview.coverage.map.stateLabelUnknown":
    "{state}, {uf}: sem dados nesta visão. Selecione para ver detalhes.",
  "overview.coverage.freshness.updated": "Atualizado em {time}",
  "overview.coverage.freshness.stale": "Não foi possível atualizar · dados de {time}",
  "overview.coverage.freshness.retry": "Tentar de novo",
  "overview.coverage.state.band": "{band} · {count} registros nesta visão",
  "overview.coverage.state.unknown": "Sem dados desta UF em “{mode}”",
  "overview.coverage.summary.unknown":
    "A leitura não trouxe cobertura por UF. Nenhum estado aparece como zero.",
  "overview.coverage.list.title": "Todas as UF",
  "overview.coverage.list.description": "Lista equivalente ao mapa · {mode}",
  "overview.coverage.list.sort": "Ordenar",
  "overview.coverage.list.sort.count": "Registros",
  "overview.coverage.list.sort.name": "A–Z",
  "overview.coverage.list.sort.region": "Região",
  "overview.coverage.list.row": "{state} ({uf}), {region}: {count} registros, faixa {band}",
  "overview.coverage.list.rowUnknown": "{state} ({uf}), {region}: sem dados",
  "overview.coverage.error.title": "Não foi possível carregar a cobertura por UF",
  "overview.coverage.error.body":
    "A base fiscal e o mapa dependem da mesma leitura. Nada é mostrado como zero enquanto ela falha.",
  "overview.coverage.error.retry": "Tentar de novo",
  "overview.coverage.attribution": "Geometria do mapa: @svg-maps/brazil · CC BY 4.0",
  "overview.coverage.clear": "Visão nacional",
  "overview.coverage.state.eyebrow": "Estado selecionado",
  "overview.coverage.state.rules": "Regras publicadas",
  "overview.coverage.state.evidence": "Evidências e notícias",
  "overview.coverage.state.origin": "Rotas de origem",
  "overview.coverage.state.destination": "Rotas de destino",
  "overview.coverage.state.pending": "evidências aguardam revisão neste estado.",
  "overview.coverage.region.north": "Norte",
  "overview.coverage.region.northeast": "Nordeste",
  "overview.coverage.region.centralWest": "Centro-Oeste",
  "overview.coverage.region.southeast": "Sudeste",
  "overview.coverage.region.south": "Sul",
  "overview.coverage.updates.eyebrow": "Evidências recentes da UF",
  "overview.coverage.updates.title": "Atualizações regionais recentes",
  "overview.coverage.updates.scope": "Evidência capturada",
  "overview.coverage.updates.error":
    "As atualizações regionais estão indisponíveis agora. Abra o catálogo de evidências do estado para continuar.",
  "overview.coverage.updates.empty": "Ainda não há evidências capturadas para este estado.",
  "overview.coverage.openRules": "Abrir regras de {uf}",
  "overview.coverage.openEvidence": "Abrir evidências de {uf}",
  "overview.coverage.summary.eyebrow": "Visão do país",
  "overview.coverage.summary.title": "Panorama nacional",
  "overview.coverage.summary.description":
    "As faixas comparam registros por UF dentro desta visão: regras com UF de origem ou destino, ou evidências capturadas. Não medem cobertura nacional nem alíquotas.",
  "overview.coverage.summary.nationalRules": "Regras sem UF de origem e destino",
  "overview.coverage.summary.federalEvidence": "Evidências federais",
  "overview.coverage.summary.federalPending": "Itens federais pendentes",
  "overview.coverage.summary.empty": "Não há registros estaduais disponíveis nesta visão.",
  "overview.coverage.ranking.title": "Maior concentração",
  "overview.coverage.ranking.description": "Relativa a esta visão",
  "overview.coverage.crossing.federal":
    "{family} é federal. As cores do mapa continuam sendo regras de rota ou evidências por UF. Não há alíquota desta família por estado.",
  "overview.coverage.crossing.convenio":
    "{family} vem do CONFAZ. O mapa não recorta esta família por UF.",
  "overview.coverage.crossing.state":
    "{watched} de {total} SEFAZ acompanhadas. As outras UFs ficam apagadas até revisão de URL. As cores não são alíquotas.",
  "overview.coverage.crossing.stateAll":
    "As {total} SEFAZ estão na lista de fontes observada. As cores seguem sendo registros por UF, não a alíquota de {family}.",
  "overview.coverage.crossing.municipal":
    "ISS é municipal. Esta base de mercadorias não acompanha ISS.",
  "overview.coverage.crossing.stateWatched":
    "{state} ({uf}) está na allow-list de SEFAZ. Os números abaixo são regras e evidências desta UF, não a alíquota de {family}.",
  "overview.coverage.crossing.stateUnwatched":
    "{state} ({uf}) ainda não tem host SEFAZ revisado. Sem URL revisada, não inventamos alíquota.",
  "overview.work.rules.action": "Consultar regras",
  "overview.route.label": "Rota do dia",
  "overview.route.calculator": "Calcular planilha",
  "overview.gaps.eyebrow": "O que ainda falta governar",
  "overview.gaps.title": "Lacunas da base",
  "overview.gaps.description":
    "Famílias desta base ainda sem regra publicada. PIS/COFINS ficam fora desta base e não pedem formulário. ISS municipal não entra: BackChannel precifica mercadoria com tributos federais e estaduais. Não inventamos alíquota.",
  "overview.gaps.empty":
    "As famílias desta base já têm regra publicada. PIS/COFINS permanecem fora desta base. ISS municipal não entra.",
  "overview.gaps.openProposals": "Abrir propostas",
  "overview.gaps.openRules": "Abrir regras",
  "overview.gaps.openOfficialSource": "Abrir fonte oficial",
  "overview.gaps.pisCofins.guidance":
    "A entidade legal da plataforma está fora do Simples Nacional (sócio PJ no QSA). Ainda faltam o regime Lucro Presumido ou Lucro Real, o tratamento do produto e evidência vigente para governar PIS/COFINS; não há alíquota única segura.",
  "overview.gaps.iss.guidance":
    "ISS é imposto municipal sobre serviços. BackChannel não cobra ISS: a operação é atacado de mercadorias, com IPI federal e ICMS estadual. Não modelamos município.",
  "overview.gaps.noForm": "Sem feed oficial aqui",
  "overview.priority.empty": "Este resumo não tem trabalho que exija ação agora.",
  "overview.priority.shownOf": "{shown} de {total}",
  "overview.changes.eyebrow": "Governança mensal",
  "overview.changes.title": "O que mudou neste ciclo",
  "overview.changes.description": "Diferença entre a versão ativa e sua base governada.",
  "overview.changes.added": "Adicionadas",
  "overview.changes.changed": "Alteradas",
  "overview.changes.removed": "Removidas",
  "overview.changes.total": "{count} mudanças de regras governadas nesta publicação",
  "overview.changes.noBaseline": "Esta versão não tem uma base publicada comparável.",
  "overview.changes.noRuleset": "Não há um conjunto publicado para comparar.",
  "overview.changes.openCatalog": "Abrir catálogo publicado",
  "overview.exceptions.window":
    "Sinais estruturados mais frequentes em cálculos concluídos nas últimas 24 horas.",
  "overview.exceptions.openReviews": "Abrir revisão financeira",
  "overview.technical.title": "Detalhes de ingestão e auditoria",
  "overview.technical.description":
    "Saúde técnica da entrega, secundária ao trabalho de decisão fiscal.",

  "overview.priority.eyebrow": "Trabalho decisório",
  "overview.priority.title": "Caixa de prioridades",
  "overview.priority.description":
    "Trabalho que pode alterar um resultado fiscal ou bloquear um cálculo seguro.",
  "overview.priority.open": "abertas",
  "overview.priority.more": " · {count} alertas adicionais não exibidos",
  "overview.ingestion.eyebrow": "Abastecimento de evidências",
  "overview.exceptions.eyebrow": "Qualidade do cálculo",
  "overview.section.instruments": "Indicadores operacionais",
  "overview.section.attention": "Requer atenção",
  "overview.section.recentRuns": "Execuções recentes",
  "overview.section.recentActivity": "Atividade de governança",
  "overview.section.issues": "Principais inconsistências",
  "overview.issues.hint": "Códigos de inconsistência mais frequentes nos cálculos recentes.",
  "overview.issues.relativeHint": "Relativo à inconsistência listada mais frequente.",
  "overview.ruleset.integrity": "Digest do conteúdo publicado",
  "overview.runs.stalled":
    "Esta execução ultrapassou a janela de processamento de duas horas. Verifique a fonte ou tente novamente.",
  "overview.runs.viewSources": "Ver todas as execuções de fonte",
  "overview.activity.viewAudit": "Ver o registro completo de auditoria",
  "overview.empty.priority": "Este resumo não retornou alertas operacionais.",
  "overview.empty.issues": "Nenhuma inconsistência estruturada de cálculo foi retornada.",
  "overview.empty.runs": "Nenhuma execução recente de fonte foi retornada.",
  "overview.empty.activity": "Nenhuma atividade governada recente foi retornada.",
  "overview.attention.evidenceAged.title": "{count} evidências aguardam triagem há mais de 24 h",
  "overview.attention.evidenceAged.detail":
    "A fila cresce mais rápido que a triagem nas fontes estaduais.",
  "overview.attention.proposalStuck.title": "{count} propostas aguardam o segundo aprovador",
  "overview.attention.proposalStuck.detail":
    "A segregação de funções exige um revisor diferente do autor.",
  "overview.attention.sourceDegraded.title": "Fonte degradada: {source}",
  "overview.attention.sourceDegraded.detail": "A fonte informou: {reason}",
  "overview.attention.sourceDegraded.failedRuns": "As execuções recentes desta fonte falharam.",
  "overview.attention.dlqDepth.title": "{count} falhas pendentes em {publisher}",
  "overview.attention.dlqDepth.detail":
    "Observação por fonte às {observedAt}. O Monitoring é a fonte de verdade da assinatura física compartilhada; faça uma prévia por fonte antes de reprocessar.",
  "overview.attention.refreshError":
    "A atualização não está disponível; a contagem de falhas pendentes foi ocultada até uma leitura bem-sucedida.",
  "overview.attention.kind.evidence": "Fila de evidências",
  "overview.attention.kind.proposal": "Revisão de regras",
  "overview.attention.kind.source": "Saúde das fontes",
  "overview.attention.kind.review": "Fila de revisão",
  "overview.attention.kind.dlq": "Fila de mensagens com falha",
  "overview.issue.taxConfigTableNotConfigured": "Tabela de configuração fiscal não configurada",
  "overview.issue.ncmMissingOrInvalid": "NCM ausente ou inválido",
  "overview.issue.originUfMissingOrInvalid": "UF de origem ausente ou inválida",
  "overview.issue.destinationUfMissingOrInvalid": "UF de destino ausente ou inválida",
  "overview.issue.fiscalParameterMissing": "Parâmetro fiscal ausente",
  "overview.issue.fiscalParameterAmbiguous": "Parâmetro fiscal ambíguo para a rota NCM",
  "overview.issue.baseCostMissingOrInvalid": "Custo-base ausente ou inválido",
  "overview.issue.baseCostInferred": "Custo-base inferido pelo preço",
  "overview.issue.originalMvaMissingOrInvalid": "MVA original (IVA-ST) ausente ou inválida",
  "overview.issue.destinationIcmsMissingOrInvalid":
    "Alíquota interna de ICMS no destino ausente ou inválida",
  "overview.issue.interstateIcmsInvalid": "Alíquota interestadual de ICMS inválida",
  "overview.issue.ipiMissingOrInvalid": "Alíquota de IPI ausente ou inválida",
  "overview.issue.takeRateMissingOrInvalid": "Taxa de intermediação ausente ou inválida",
  "overview.issue.operationalCostInvalid": "Custo operacional inválido",
  "overview.issue.saleLegMissingOrInvalid": "Sem regra para a rota de venda",
  "overview.issue.netMarginUnreachable": "Margem líquida inatingível",
  "overview.issue.resaleProfilePending": "Perfil de PIS/COFINS pendente",
  "overview.issue.icmsBenefitNotApplicable": "Benefício de ICMS não previsto na regra",
  "fiscalLines.source.PIS_COFINS_PROFILE": "perfil PIS/COFINS",
  "lotOps.group.pisCofinsProfile": "Perfil PIS/COFINS",
  "overview.issue.pisCofinsProfilePending": "Perfil PIS/COFINS a confirmar",
  "overview.issue.cbsIbsRatePending": "CBS/IBS: alíquota do ano não publicada",
  "overview.issue.cbsIbsClassPending": "CBS/IBS: confirmar a classificação (cClassTrib)",
  "issueHelp.pisCofinsProfilePending":
    "O catálogo legal não decide o PIS/COFINS deste NCM (bebida fria, condição a confirmar ou listas sobrepostas). Informe o tratamento confirmado; nenhuma alíquota é presumida e o item fica em revisão.",
  "issueHelp.cbsIbsRatePending":
    "Não há alíquota CBS/IBS publicada para o ano da data fiscal, ou a data é 2027 ou posterior (o regime devido ainda não é calculado). Publique a alíquota do ano ou aguarde o motor.",
  "issueHelp.cbsIbsClassPending":
    "A classificação CBS/IBS (cClassTrib) depende de confirmação. Informe a classe e o fundamento; nenhuma alíquota é presumida e o item fica em revisão.",
  "pisCofinsProfile.title": "Perfil PIS/COFINS",
  "pisCofinsProfile.profile.STANDARD": "Regime normal",
  "pisCofinsProfile.profile.SINGLE_STAGE": "Monofásico (revenda alíquota zero)",
  "pisCofinsProfile.profile.ZERO_RATE": "Alíquota zero",
  "pisCofinsProfile.profile.PENDING": "Pendente",
  "pisCofinsProfile.short.STANDARD": "Regime normal",
  "pisCofinsProfile.short.SINGLE_STAGE": "Monofásico",
  "pisCofinsProfile.short.ZERO_RATE": "Alíquota zero",
  "pisCofinsProfile.short.PENDING": "Pendente",
  "pisCofinsProfile.candidate.SINGLE_STAGE": "monofásico",
  "pisCofinsProfile.candidate.ZERO_RATE": "alíquota zero",
  "pisCofinsProfile.candidate.BEVERAGE": "bebida fria",
  "pisCofinsProfile.cst": "CST {cst}",
  "pisCofinsProfile.creditCst": "crédito CST {cst}",
  "pisCofinsProfile.field.profile": "Perfil",
  "pisCofinsProfile.field.saleCst": "CST de venda",
  "pisCofinsProfile.field.creditCst": "CST de crédito",
  "pisCofinsProfile.field.source": "Origem",
  "pisCofinsProfile.field.basis": "Base legal",
  "pisCofinsProfile.field.condition": "Condição legal",
  "pisCofinsProfile.field.candidate": "Perfil provável",
  "pisCofinsProfile.none": "sem CST",
  "pisCofinsProfile.source.CATALOG": "catálogo legal",
  "pisCofinsProfile.source.OPERATOR": "informado pelo operador",
  "pisCofinsProfile.source.REGIME": "regime",
  "pisCofinsProfile.validFrom": "vigente desde {date}",
  "pisCofinsProfile.validRange": "vigente de {from} a {to}",
  "pisCofinsProfile.regimeBasis": "Base do regime (nenhuma lista legal se aplica ao NCM)",
  "pisCofinsProfile.catalog": "Catálogo {catalog} · motor 1.8.0",
  "pisCofinsProfile.opensSource": "abre a lei no Planalto",
  "pisCofinsProfile.pending.BEVERAGE_PROFILE":
    "Bebida fria (Lei 13.097/2015): atacadista sem alíquota zero; informe o tratamento",
  "pisCofinsProfile.pending.REQUIRES_CONFIRMATION":
    "Condição legal que o NCM não comprova (Ex da TIPI ou descrição); confirme o tratamento",
  "pisCofinsProfile.pending.OVERLAPPING_LISTS":
    "NCM em mais de uma lista (monofásico e alíquota zero); confirme qual se aplica",
  "pisCofinsProfile.pending.NOT_IN_CATALOG":
    "O tratamento informado não está na lista legal deste NCM",
  "issueHelp.resaleProfilePending":
    "O NCM tem tratamento próprio de PIS/COFINS (monofásico, bebidas frias ou alíquota zero). Informe o tratamento confirmado; a margem fica pendente, nunca zero.",
  "issueHelp.icmsBenefitNotApplicable":
    "O cBenef informado não está na regra publicada da venda ou não está vigente. Confirme o código ou publique a regra com o benefício.",
  "wb.issue.NCM_WITH_SUFFIX.title": "NCM com complemento não mapeado",
  "wb.issue.NCM_WITH_SUFFIX.hint":
    "O campo tem 10 dígitos (NCM de 8 + complemento interno). Confirme o NCM de 8 dígitos e o atributo adicional no cadastro; a linha não é truncada automaticamente.",
  "issueHelp.taxConfigTableNotConfigured":
    "Não há regras fiscais publicadas. Publique um conjunto de regras antes de calcular.",
  "issueHelp.ncmMissingOrInvalid":
    "A linha não tem um NCM de 8 dígitos. Corrija a coluna NCM no arquivo ou na linha e recalcule.",
  "issueHelp.originUfMissingOrInvalid":
    "A UF de origem está vazia ou não é uma UF. Corrija a coluna de origem ou fixe a rota do lote.",
  "issueHelp.destinationUfMissingOrInvalid":
    "A UF de destino está vazia ou não é uma UF. Corrija a coluna de destino ou fixe a rota do lote.",
  "issueHelp.fiscalParameterMissing":
    "Nenhuma regra publicada informa o ICMS deste NCM nesta rota. Pesquise a regra (Pesquisar lacunas) e publique antes de recalcular.",
  "issueHelp.fiscalParameterAmbiguous":
    "Mais de uma regra serve a este NCM e rota. Informe o CEST da linha para escolher a regra certa.",
  "issueHelp.baseCostMissingOrInvalid":
    "O custo unitário está vazio, é zero ou não é um número. Corrija a coluna de custo e recalcule.",
  "issueHelp.baseCostInferred":
    "Não havia custo: o cálculo usou o preço de venda como base. Informe o custo de compra para um valor confiável.",
  "issueHelp.originalMvaMissingOrInvalid":
    "A regra de ICMS-ST não traz a MVA (IVA-ST) original. A regra precisa ser corrigida por proposta.",
  "issueHelp.destinationIcmsMissingOrInvalid":
    "A regra não traz a alíquota interna do destino. A regra precisa ser corrigida por proposta.",
  "issueHelp.interstateIcmsInvalid":
    "A alíquota interestadual da regra não confere com a rota. A regra precisa ser revisada.",
  "issueHelp.ipiMissingOrInvalid": "A regra não traz a alíquota de IPI deste NCM.",
  "issueHelp.takeRateMissingOrInvalid":
    "Não há taxa de intermediação configurada para esta categoria e forma de pagamento.",
  "issueHelp.operationalCostInvalid":
    "Não há custo operacional (logística, frete) configurado para esta categoria.",
  "issueHelp.saleLegMissingOrInvalid":
    "O preço precisa da regra da venda (centro → cliente) e nenhuma regra publicada informa o ICMS dessa rota. Escolha outro destino de venda ou publique a regra.",
  "issueHelp.netMarginUnreachable":
    "Com esta margem e os tributos da venda não existe preço positivo. Reduza a margem pedida.",

  "evidence.empty.title": "Nenhuma evidência na fila",
  "evidence.empty.body":
    "A descoberta roda a cada 3 horas (horário de Brasília) e alimenta esta fila com documentos oficiais.",
  "evidence.empty.action": "Ver fontes",
  "evidence.attention.lowConfidence": "Baixa confiança",
  "evidence.title": "Evidências",
  "evidence.description":
    "Documentos coletados das fontes oficiais. A extração propõe evidências; ela nunca aprova, publica ou calcula.",
  "evidence.tabs.label": "Área de evidências",
  "evidence.tabs.documents": "Fila de revisão",
  "evidence.tabs.tasks": "Tarefas",
  "evidence.tasks.title": "Tarefas de evidência",
  "evidence.tasks.description":
    "Organize o acompanhamento da evidência observada. Concluir uma tarefa não aprova o documento nem altera a regra publicada.",
  "evidence.tasks.agentEyebrow": "Fila do agente",
  "evidence.tasks.agentTitle": "Pesquisas fiscais em andamento",
  "evidence.tasks.agentDescription":
    "As tarefas enviadas ao agente de pesquisa ficam aqui com seu estado, citações e próximo passo de revisão.",
  "evidence.tasks.agentActive": "Em andamento",
  "evidence.tasks.agentReview": "Em revisão",
  "evidence.tasks.agentQueue": "Tarefas de pesquisa",
  "evidence.tasks.agentWindowHint": "Mostrando as 12 tarefas fiscais mais recentes.",
  "evidence.tasks.agentSearch": "Buscar por pergunta ou tarefa",
  "evidence.tasks.agentStatus": "Filtrar por situação",
  "evidence.tasks.agentEmpty":
    "Nenhuma pesquisa do agente foi enviada ainda. Use Pesquisar questão em Documentos para criar a primeira.",
  "evidence.tasks.agentSelected": "Pesquisa selecionada",
  "evidence.tasks.agentCitations": "Citações",
  "evidence.tasks.agentEvidence": "Na evidência",
  "evidence.tasks.agentProvider": "Motor fiscal",
  "evidence.tasks.agentNoSummary": "O agente ainda não publicou uma síntese.",
  "evidence.tasks.agentDetailStale":
    "Não foi possível atualizar o detalhe; a última situação conhecida está sendo mostrada.",
  "evidence.tasks.agentOpenDesk": "Abrir na Mesa",
  "evidence.tasks.agentOpenEvidence": "Abrir evidência",
  "evidence.tasks.results.one": "{count} tarefa",
  "evidence.tasks.results.other": "{count} tarefas",
  "evidence.tasks.results.many": "{count} tarefas",
  "evidence.tasks.create": "Criar tarefa",
  "evidence.tasks.edit": "Editar tarefa",
  "evidence.tasks.titleLabel": "Título",
  "evidence.tasks.descriptionLabel": "Descrição",
  "evidence.tasks.assignee": "Responsável",
  "evidence.tasks.dueDate": "Data de vencimento",
  "evidence.tasks.dueDateHint": "Data do calendário, sem horário.",
  "evidence.tasks.state": "Estado",
  "evidence.tasks.createdBy": "Criada por",
  "evidence.tasks.updated": "Atualizada",
  "evidence.tasks.evidence": "Abrir evidência",
  "evidence.tasks.run": "Abrir execução",
  "evidence.tasks.evidenceId": "Evidência vinculada (opcional)",
  "evidence.tasks.sourceRunId": "Execução vinculada (opcional)",
  "evidence.tasks.referenceHint":
    "Cole o link interno ou um identificador já usado nesta organização.",
  "evidence.tasks.referenceInvalid":
    "Use um link interno válido ou o identificador correspondente.",
  "evidence.tasks.noReference": "Sem referência",
  "evidence.tasks.empty": "Nenhuma tarefa de evidência ainda.",
  "evidence.tasks.emptyBody": "Crie uma tarefa para acompanhar uma verificação manual.",
  "evidence.tasks.save": "Salvar tarefa",
  "evidence.tasks.cancel": "Cancelar edição",
  "evidence.tasks.statusSaved": "Tarefa salva nesta conta.",
  "evidence.tasks.saving": "Salvando tarefa…",
  "evidence.tasks.loadError": "Não foi possível carregar as tarefas.",
  "evidence.tasks.saveError": "Não foi possível salvar. Tente novamente.",
  "evidence.tasks.retry": "Recarregar e tentar novamente",
  "evidence.tasks.conflict": "A tarefa mudou em outra sessão. Recarregue para continuar.",
  "evidence.tasks.terminal": "Tarefas concluídas ou canceladas não podem ser reabertas.",
  "evidence.tasks.state.OPEN": "Aberta",
  "evidence.tasks.state.IN_PROGRESS": "Em andamento",
  "evidence.tasks.state.BLOCKED": "Bloqueada",
  "evidence.tasks.state.DONE": "Concluída",
  "evidence.tasks.state.CANCELLED": "Cancelada",
  "evidence.extract.note":
    "O extrator lê o artefato e escreve um excerto para revisão. Não aprova evidência e não publica regra.",
  "evidence.column.title": "Documento",
  "evidence.column.source": "Fonte",
  "evidence.column.jurisdiction": "Jurisdição",
  "evidence.column.published": "Publicado",
  "evidence.column.fetched": "Coletado",
  "evidence.column.confidence": "Confiança",
  "evidence.column.status": "Situação",
  "evidence.column.tags": "Marcadores",
  "evidence.filter.status": "Situação da revisão",
  "evidence.filter.jurisdiction": "Jurisdição",
  "evidence.filter.tag": "Marcador fiscal",
  "evidence.filter.search": "Título, editor ou hash",
  "evidence.bulk.approve": "Aprovar selecionados",
  "evidence.bulk.reject": "Rejeitar selecionados",
  "evidence.bulk.markDuplicate": "Marcar como duplicado",
  "evidence.bulk.cap": "A triagem em lote está limitada a {max} documentos por operação.",
  "evidence.bulk.capReached": "Limite de {max} documentos atingido; a seleção parou aí.",
  "evidence.bulk.confirm.one": "Aplicar {action} a {count} documento?",
  "evidence.bulk.confirm.other": "Aplicar {action} a {count} documentos?",
  "evidence.bulk.done.one": "{count} documento atualizado.",
  "evidence.bulk.done.other": "{count} documentos atualizados.",
  "evidence.detail.title": "Revisão de evidência",
  "evidence.detail.canonicalUrl": "URL canônica",
  "evidence.detail.contentHash": "Hash do conteúdo",
  "evidence.locator.css": "Trecho da página",
  "evidence.locator.pdf-page": "Página do PDF",
  "evidence.locator.document": "Documento inteiro",
  "evidence.locator.value.excerpt": "trecho",
  "evidence.detail.rawArtifact": "Artefato bruto",
  "evidence.detail.normalizedArtifact": "Artefato normalizado",
  "evidence.detail.noNormalized": "Ainda não normalizado",
  "evidence.detail.storedDocument": "Documento armazenado",
  "evidence.detail.storedDocumentHint": "Texto preservado para revisão.",
  "evidence.detail.byteRange": "Bytes {start}–{end}",
  "evidence.detail.downloadRaw": "Baixar artefato bruto",
  "evidence.detail.rawDownloading": "Baixando artefato bruto…",
  "evidence.detail.rawDownloadUnavailable":
    "O artefato bruto não está disponível para download no momento.",
  "evidence.detail.artifactUnavailable": "O documento armazenado está indisponível no momento.",
  "evidence.detail.locators": "Localizadores do documento",
  "evidence.detail.previousPage": "Página anterior",
  "evidence.detail.nextPage": "Próxima página",
  "evidence.detail.decision": "Decisão de revisão",
  "evidence.detail.approve": "Aprovar evidência",
  "evidence.detail.reject": "Rejeitar",
  "evidence.detail.duplicate": "Duplicado",
  "evidence.detail.announce.APPROVED": "Evidência aprovada",
  "evidence.detail.announce.REJECTED": "Evidência rejeitada",
  "evidence.detail.announce.DUPLICATE": "Marcada como duplicada",
  "evidence.detail.reasonHint":
    "Escreva pelo menos 10 caracteres. A justificativa fica registrada na auditoria.",
  "evidence.detail.reasonRequired": "Digite pelo menos 10 caracteres para registrar a decisão.",
  "evidence.detail.proposeRule": "Criar proposta de regra",
  "evidence.detail.extract": "Trecho extraído",
  "evidence.detail.part.summary": "Parte {number} de {count} · páginas {pageFrom}–{pageTo}",
  "evidence.detail.part.link": "Parte {number} · páginas {pageFrom}–{pageTo}",
  "evidence.detail.part.html.summary": "Parte {number} de {count} · {sectionFrom} – {sectionTo}",
  "evidence.detail.part.html.link": "Parte {number} · {sectionFrom} – {sectionTo}",
  "evidence.detail.noExtract": "Nenhum trecho foi extraído desta fonte ainda.",
  "evidence.detail.relatedProposals": "Propostas relacionadas",
  "evidence.catalogue.label": "Catálogo de notícias e evidências fiscais",
  "evidence.catalogue.results": "Cerca de {count} documentos coletados",
  "evidence.catalogue.hint":
    "Revise o material de origem como um catálogo editorial, sem perder os controles de governança.",
  "evidence.catalogue.selectPage": "Selecionar esta página",
  "evidence.catalogue.sort.fetchedAt": "Coleta recente",
  "evidence.catalogue.sort.confidence": "Confiança",
  "evidence.catalogue.sort.jurisdiction": "Jurisdição",
  "evidence.catalogue.signals": "Sinais fiscais detectados",
  "evidence.catalogue.noSignals": "Ainda não há sinais fiscais estruturados",
  "evidence.catalogue.imageUnavailable": "Sem imagem da fonte",
  "evidence.catalogue.proposals": "Propostas",
  "evidence.detail.openOriginal": "Abrir original",
  "evidence.detail.opensNewTab": "abre em uma nova aba",
  "evidence.detail.imageUnavailable": "A fonte não publicou uma imagem",
  "evidence.detail.fiscalData": "Dados fiscais extraídos",
  "evidence.detail.detectedSignals": "Sinais fiscais detectados",
  "evidence.detail.keyFacts": "Dados-chave encontrados na fonte",
  "evidence.detail.integrity": "Integridade da evidência",
  "evidence.detail.technicalDetails": "Proveniência técnica",
  "evidence.detail.preserved": "Evidência preservada",
  "evidence.detail.noProposals": "Nenhuma proposta de regra foi derivada desta evidência.",
  "evidence.detail.insights": "Insights de revisão",
  "evidence.detail.reviewReadiness": "Prontidão para revisão",
  "evidence.detail.taxScope": "Escopo fiscal detectado",
  "evidence.detail.taxScopeCount": "{count} sinais fiscais estruturados encontrados",
  "evidence.detail.ruleImpact": "Impacto em regras",
  "evidence.detail.proposalImpact.one": "Vinculada a {count} proposta de regra",
  "evidence.detail.proposalImpact.other": "Vinculada a {count} propostas de regra",
  "evidence.detail.noProposalImpact": "Ainda não há impacto em regras proposto",
  "evidence.detail.noStructuredInsight": "Aguardando extração estruturada",
  "evidence.detail.insightDisclaimer":
    "Os insights resumem metadados capturados. Eles nunca aprovam evidências nem publicam uma regra fiscal.",
  "evidence.detail.readiness.approved": "Revisão humana concluída",
  "evidence.detail.readiness.closed": "Revisão encerrada",
  "evidence.detail.readiness.unscored": "Verificação manual necessária",
  "evidence.detail.readiness.low": "Baixa confiança — valide com a fonte",
  "evidence.detail.readiness.medium": "Pronta para revisão do analista",
  "evidence.detail.readiness.high": "Extração de alta confiança",
  "evidence.detail.candidates.title": "Candidatos de entrada fiscal",
  "evidence.detail.candidates.description":
    "Menções fiscais encontradas no documento e mantidas ligadas ao trecho original.",
  "evidence.detail.candidates.status": "CANDIDATO · não aplicado",
  "evidence.detail.candidates.empty":
    "Nenhum dado fiscal estruturado foi identificado. Faça a conferência manual no documento.",
  "evidence.detail.candidates.disclaimer":
    "Um candidato nunca altera uma regra. Aprove a evidência, monte a proposta e envie-a para revisão independente.",
  "evidence.detail.candidates.use": "Usar dados na proposta",
  "evidence.detail.candidates.kind.NCM": "NCM",
  "evidence.detail.candidates.kind.CEST": "CEST",
  "evidence.detail.candidates.kind.UF": "UF",
  "evidence.detail.candidates.kind.RATE": "Alíquota mencionada",

  "proposals.title": "Propostas de regra",
  "proposals.description":
    "Toda alteração fiscal passa por proposta, revisão, aprovação e publicação.",
  "proposals.column.summary": "Resumo",
  "proposals.column.scope": "Escopo",
  "proposals.column.impact": "Impacto",
  "proposals.column.status": "Situação",
  "proposals.column.author": "Autor",
  "proposals.column.age": "Idade",
  "proposals.detail.title": "Proposta {id}",
  "proposals.detail.evidence": "Evidência de suporte",
  "proposals.detail.change": "Alteração proposta",
  "proposals.detail.approve": "Aprovar proposta",
  "proposals.detail.reject": "Rejeitar proposta",
  "proposals.detail.approvals": "Aprovações",
  "proposals.fourEyes.badge": "Aprovação",
  "proposals.fourEyes.needed": "Uma aprovação registrada. O autor pode aprovar e publicar.",
  "proposals.fourEyes.selfBlocked": "Você redigiu esta proposta. Pode aprovar e publicar.",
  "proposals.fourEyes.youAreAuthor": "Você é o autor",
  "proposals.fourEyes.progress": "{approved} de {required} aprovações",
  "proposals.fourEyes.count.one": "{approved} de {required} aprovação",
  "proposals.fourEyes.count.other": "{approved} de {required} aprovações",
  "proposals.fourEyes.alreadyDecided": "Você já registrou sua decisão nesta proposta.",
  "proposals.next.pendingFirst": "Aguarda aprovação. O autor pode aprovar.",
  "proposals.next.pendingSecond": "Aguarda aprovação. O autor pode aprovar.",
  "proposals.next.approved": "Aprovada. Entrou na minuta atual. O autor pode publicar.",
  "proposals.next.rejected": "Rejeitada. Não entra na minuta até uma nova proposta.",
  "proposals.next.published":
    "Publicada neste conjunto de regras. O conteúdo publicado é imutável.",
  "proposals.next.title": "Próximo passo",
  "proposals.change.kind": "Tipo",
  "proposals.change.path": "Caminho",
  "proposals.change.before": "Antes",
  "proposals.change.after": "Depois",
  "proposals.change.ADDED": "Adicionado",
  "proposals.change.REMOVED": "Removido",
  "proposals.change.CHANGED": "Alterado",
  /* Governança — proposal detail, readable change table and decision bar (UX plan PR 5). */
  "proposals.change.field": "Campo",
  "proposals.change.rule": "Regra {id}",
  "proposals.change.item": "Alteração {index} de {total}",
  "proposals.detail.byline": "{reference} · proposta por {author} em {created}",
  "proposals.detail.supersedes": "Substitui a regra publicada",
  "proposals.detail.appliesTo": "Aplica-se a",
  "proposals.detail.noDecisions": "Nenhuma decisão registrada ainda.",
  "proposals.detail.evidenceItem": "Documento {index}",
  "proposals.decision.title": "Sua decisão",
  "proposals.decision.placeholder": "Ex.: Conferido no documento oficial, art. 52 do RICMS",
  "proposals.scope.category": "Categoria: {value}",
  "proposals.scope.paymentMethod": "Pagamento: {value}",
  "proposals.scope.transactionType": "Transação: {value}",
  "proposals.field.takeRate": "Taxa de intermediação",
  "proposals.field.originalMva": "MVA original",
  "proposals.field.adjustedMva": "MVA ajustada",
  "proposals.field.effectiveInternalRate": "Carga interna efetiva",
  "proposals.field.effectiveLegalReference": "Base legal da carga efetiva",
  "proposals.field.effectiveSourceUrl": "Fonte da carga efetiva",
  "proposals.field.effectiveValidFrom": "Carga efetiva vigente desde",
  "proposals.field.effectiveValidTo": "Carga efetiva vigente até",
  "proposals.field.destinationInternalIcmsRate": "Alíquota interna de ICMS no destino",
  "proposals.field.interstateIcmsRate": "Alíquota interestadual de ICMS",
  "proposals.field.ipiRate": "Alíquota de IPI",
  "proposals.field.stateBenefitBaseReductionPct": "Redução da base (benefício estadual)",
  "proposals.field.logistics": "Custo logístico",
  "proposals.field.freight": "Frete",
  "proposals.field.other": "Outros custos",
  "proposals.field.validFrom": "Vigência inicial",
  "proposals.field.validTo": "Vigência final",
  "proposals.field.treatmentOf": "Tratamento do {tax}",
  "proposals.field.rateOf": "Alíquota de {tax}",
  "proposals.field.icmsMode": "Modalidade do ICMS",
  "proposals.field.icmsMode.ST": "Substituição tributária (ST)",
  "proposals.field.icmsMode.STANDARD": "ICMS próprio",
  "proposals.field.tax.ipi": "IPI",
  "proposals.field.tax.icms": "ICMS",
  "proposals.field.tax.pis": "PIS",
  "proposals.field.tax.cofins": "COFINS",
  "proposals.field.tax.iss": "ISS",
  "proposals.field.treatment.TAXED": "Tributado",
  "proposals.field.treatment.EXEMPT": "Isento",
  "proposals.field.treatment.EXCLUDED": "Fora desta base",
  "proposals.empty.title": "Nenhuma proposta",
  "proposals.empty.body":
    "As propostas nascem de evidência aprovada. Revise um documento oficial e converta-o em alteração governada.",
  "proposals.empty.action": "Abrir evidência aprovada",
  "proposals.detail.minuta": "Minuta gerada",
  "proposals.matches.title": "Comparação com regras publicadas",
  "proposals.matches.description": "Consulta somente a versão publicada atual desta organização.",
  "proposals.matches.publishedVersion": "Versão publicada: {version}",
  "proposals.matches.openRuleset": "Abrir conjunto publicado",
  "proposals.matches.checked.one": "{count} regra desta categoria foi verificada.",
  "proposals.matches.checked.other": "{count} regras desta categoria foram verificadas.",
  "proposals.matches.exact": "Correspondência exata",
  "proposals.matches.exactHint":
    "Mesmo comportamento, validade e aplicabilidade; IDs e evidências não entram na comparação.",
  "proposals.matches.sameApplicability": "Mesma aplicabilidade",
  "proposals.matches.sameApplicabilityHint":
    "A rota e a vigência coincidem. Isso não significa tratamento tributário equivalente.",
  "proposals.matches.none": "Nenhuma correspondência encontrada",
  "proposals.matches.noneHint":
    "Nenhuma regra publicada desta categoria tem a mesma impressão digital.",
  "proposals.matches.noBase": "Não há base publicada disponível",
  "proposals.matches.noBaseHint":
    "A comparação consultiva ficará disponível quando existir uma versão publicada.",
  "proposals.matches.truncated":
    "A lista mostra as primeiras {count} correspondências; existem outras correspondências nesta categoria.",
  "proposalPlan.action": "Importar plano",
  "proposalPlan.title": "Importar plano de propostas",
  "proposalPlan.description":
    "Carregue um plano revisado (JSON), confira a simulação contra o conjunto em vigor e crie propostas pendentes de revisão. Nada é aprovado nem publicado.",
  "proposalPlan.noAccess":
    "Importar planos exige a permissão para criar propostas. Peça acesso a quem administra a plataforma.",
  "proposalPlan.steps.label": "Etapas da importação",
  "proposalPlan.step.file": "Arquivo",
  "proposalPlan.step.review": "Simulação",
  "proposalPlan.step.result": "Resultado",
  "proposalPlan.file.title": "Plano",
  "proposalPlan.file.drop": "Solte o plano aqui ou escolha o arquivo",
  "proposalPlan.file.dropActive": "Solte para carregar o plano",
  "proposalPlan.file.hint":
    "Arquivo JSON gerado pelo script de plano, que só lê e não cria nada. Até {size}.",
  "proposalPlan.file.pick": "Escolher arquivo",
  "proposalPlan.file.replace": "Trocar arquivo",
  "proposalPlan.file.sample": "Usar plano de exemplo",
  "proposalPlan.file.sampleHint":
    "Modo demonstração: um plano gerado a partir dos dados de exemplo.",
  "proposalPlan.file.reading": "Lendo o arquivo…",
  "proposalPlan.file.problem.EMPTY": "O arquivo está vazio.",
  "proposalPlan.file.problem.TOO_LARGE": "O arquivo é grande demais para importar.",
  "proposalPlan.file.problem.NOT_JSON": "O arquivo não é um JSON válido.",
  "proposalPlan.file.problem.NOT_A_PLAN":
    "O arquivo não é um plano de propostas: falta o campo kind.",
  "proposalPlan.file.problem.UNSUPPORTED_KIND": "Esta versão não importa planos do tipo {kind}.",
  "proposalPlan.file.problem.INVALID_PLAN": "O plano não segue o formato esperado.",
  "proposalPlan.kind.effective-burden-proposal-plan": "Carga efetiva do ICMS-ST",
  "proposalPlan.plan.kind": "Tipo",
  "proposalPlan.plan.source": "Gerado a partir de",
  "proposalPlan.plan.destination": "UF de destino",
  "proposalPlan.plan.segments": "Segmentos CEST",
  "proposalPlan.plan.burden": "Carga efetiva",
  "proposalPlan.plan.basis": "Base legal",
  "proposalPlan.plan.validUntil": "Vigente até",
  "proposalPlan.items.count.one": "{count} item",
  "proposalPlan.items.count.other": "{count} itens",
  "proposalPlan.plan.items": "Itens do plano",
  "proposalPlan.plan.skipped": "{count} regras deixadas de fora pelo gerador",
  "proposalPlan.plan.note": "Observação do plano",
  "proposalPlan.export.action": "Exportar ruleset ativo",
  "proposalPlan.export.exporting": "Exportando…",
  "proposalPlan.export.hint":
    "Baixa o conteúdo do conjunto de regras em vigor (somente leitura) para gerar o plano com o script a partir do conjunto real.",
  "proposalPlan.evidence.pickTitle": "Escolher evidência aprovada",
  "proposalPlan.evidenceSource.ACTIVE_RULE": "evidência herdada da regra ativa",
  "proposalPlan.evidenceSource.ADDITIONAL_ONLY": "somente a evidência adicional aprovada",
  "proposalPlan.evidenceSource.PLAN": "evidência do plano",
  "proposalPlan.evidence.title": "Evidência adicional (opcional)",
  "proposalPlan.evidence.body":
    "A evidência de cada regra cobre o MVA, não a carga efetiva. Cole os IDs das evidências aprovadas (por exemplo RICMS/SP art. 39 e DN CAT 8/2015) para anexá-las a todas as propostas criadas.",
  "proposalPlan.evidence.label": "IDs das evidências",
  "proposalPlan.evidence.placeholder": "Um ID por linha, ou separados por vírgula",
  "proposalPlan.evidence.browse": "Ver evidências aprovadas",
  "proposalPlan.evidence.count.one": "{count} evidência para anexar",
  "proposalPlan.evidence.count.other": "{count} evidências para anexar",
  "proposalPlan.evidence.invalid": "Não é um ID de evidência: {ids}",
  "proposalPlan.evidence.tooMany": "No máximo {max} evidências por importação.",
  "proposalPlan.note.label": "Nota para quem vai revisar (opcional)",
  "proposalPlan.note.hint": "Entra no início do motivo de cada proposta criada.",
  "proposalPlan.note.short": "Escreva ao menos 10 caracteres ou deixe em branco.",
  "proposalPlan.validate": "Simular importação",
  "proposalPlan.validating": "Simulando…",
  "proposalPlan.review.title": "Simulação contra o conjunto em vigor",
  "proposalPlan.review.hint":
    "Conjunto {version}. Nada foi criado: confira cada item antes de confirmar.",
  "proposalPlan.review.back": "Trocar plano",
  "proposalPlan.review.refresh": "Simular de novo",
  "proposalPlan.review.empty": "O plano não tem itens.",
  "proposalPlan.filter.legend": "Filtrar por situação",
  "proposalPlan.filter.all": "Todas",
  "proposalPlan.table.caption": "Itens do plano e situação de cada um",
  "proposalPlan.table.rule": "Regra",
  "proposalPlan.table.route": "Rota",
  "proposalPlan.table.key": "NCM / CEST",
  "proposalPlan.table.change": "Mudança",
  "proposalPlan.table.status": "Situação",
  "proposalPlan.change.effective": "carga efetiva {rate} — {article}",
  "proposalPlan.change.effectiveNoArticle": "carga efetiva {rate}",
  "proposalPlan.change.until": "até {date}",
  "proposalPlan.change.source": "Abrir a fonte oficial",
  "proposalPlan.tally.NEW": "Novas",
  "proposalPlan.tally.CREATED": "Criadas",
  "proposalPlan.tally.DUPLICATE": "Duplicadas",
  "proposalPlan.tally.STALE": "Obsoletas",
  "proposalPlan.tally.INVALID": "Inválidas",
  "proposalPlan.status.NEW": "Nova",
  "proposalPlan.status.CREATED": "Criada",
  "proposalPlan.status.DUPLICATE": "Duplicada",
  "proposalPlan.status.STALE": "Obsoleta",
  "proposalPlan.status.INVALID": "Inválida",
  "proposalPlan.status.help.NEW": "Será criada como proposta pendente de revisão.",
  "proposalPlan.status.help.CREATED": "Criada nesta importação, pendente de revisão.",
  "proposalPlan.status.help.DUPLICATE": "Este item deste plano já foi importado: nada será criado.",
  "proposalPlan.status.help.STALE": "A regra em vigor não é a que o plano supôs: não será criada.",
  "proposalPlan.status.help.INVALID": "Não pode virar proposta: veja o motivo.",
  "proposalPlan.reason.RULE_NOT_FOUND": "A regra não está mais no conjunto em vigor.",
  "proposalPlan.reason.RULE_CHANGED": "A regra em vigor mudou desde que o plano foi gerado.",
  "proposalPlan.reason.ALREADY_STATED": "A regra em vigor já declara a carga efetiva.",
  "proposalPlan.reason.EVIDENCE_REJECTED":
    "Evidência não aprovada ou diferente do registro aprovado.",
  "proposalPlan.reason.POLICY_VIOLATION": "A regra não atende à política exigida.",
  "proposalPlan.reason.changedFields": "Campos diferentes: {fields}",
  "proposalPlan.reason.alreadyImported": "Já importada",
  "proposalPlan.proposal.open": "Abrir proposta",
  "proposalPlan.confirm.action.one": "Criar {count} proposta",
  "proposalPlan.confirm.action.other": "Criar {count} propostas",
  "proposalPlan.confirm.none": "Nenhum item novo para criar.",
  "proposalPlan.confirm.title": "Criar propostas a partir do plano?",
  "proposalPlan.confirm.body.one":
    "{count} proposta será criada pendente de revisão. Ela precisa da aprovação de outra pessoa; nada é aprovado nem publicado por esta importação.",
  "proposalPlan.confirm.body.other":
    "{count} propostas serão criadas pendentes de revisão. Cada uma precisa da aprovação de outra pessoa; nada é aprovado nem publicado por esta importação.",
  "proposalPlan.confirm.skipped":
    "Ficam de fora: {stale} obsoletas, {invalid} inválidas e {duplicate} duplicadas.",
  "proposalPlan.confirm.evidence": "Evidência adicional anexada a cada proposta: {count}.",
  "proposalPlan.confirm.cancel": "Cancelar",
  "proposalPlan.confirm.submit": "Criar propostas",
  "proposalPlan.confirm.creating": "Criando…",
  "proposalPlan.result.title": "Propostas criadas",
  "proposalPlan.result.created.one": "{count} proposta criada, pendente de revisão.",
  "proposalPlan.result.created.other": "{count} propostas criadas, pendentes de revisão.",
  "proposalPlan.result.none":
    "Nenhuma proposta nova: tudo neste plano já tinha sido importado ou não se aplica mais.",
  "proposalPlan.result.skipped":
    "Não criadas: {stale} obsoletas, {invalid} inválidas e {duplicate} duplicadas.",
  "proposalPlan.result.review": "Revisar propostas pendentes",
  "proposalPlan.result.another": "Importar outro plano",
  "proposalPlan.next.title": "Próximo passo: usar política {policy} no rascunho",
  "proposalPlan.next.switchBody":
    "Estas propostas só podem ser publicadas com a política {policy}, que usa a carga efetiva como ALQ intra no ajuste do MVA. O rascunho {version} está na política {current}; trocar não altera cálculos anteriores.",
  "proposalPlan.next.switchAction": "Abrir o rascunho e trocar a política",
  "proposalPlan.next.readyBody":
    "O rascunho {version} já usa a política {policy}. Depois que as propostas forem aprovadas, prepare o rascunho para incluí-las e publique pelo fluxo normal.",
  "proposalPlan.next.readyAction": "Abrir o rascunho",
  "proposalPlan.next.prepareBody":
    "Ainda não há rascunho. Em Publicações, prepare o próximo rascunho: a política {policy} já vem selecionada.",
  "proposalPlan.next.prepareAction": "Ir para Publicações",
  "rulesets.policy.suggested":
    "O plano importado pede a política {policy}. Ela já está selecionada: escreva o motivo e salve.",
  "proposals.create.title": "Criar proposta de regra",
  "proposals.create.description":
    "Converta a evidência aprovada em uma alteração governada. A criação não publica a regra.",
  "proposals.create.evidence": "Evidência vinculada: {title}",
  "proposals.create.operation": "Tipo de alteração",
  "proposals.create.operation.upsert": "Adicionar nova regra",
  "proposals.create.operation.supersede": "Substituir regra existente",
  "proposals.create.supersedesRuleId": "ID da regra existente",
  "proposals.create.supersedesRuleIdHint": "Copie o ID nos detalhes da regra publicada.",
  "proposals.create.ruleType": "Tipo de regra",
  "proposals.create.ruleJson": "Regra proposta (JSON)",
  "proposals.create.ruleJsonHint":
    "A proveniência imutável da evidência será anexada automaticamente pela plataforma.",
  "proposals.create.validation": "Complete ou corrija o campo: {issue}",
  "proposals.create.reasonHint":
    "Explique a alteração em pelo menos 10 caracteres. O motivo entra no log de auditoria.",
  "proposals.create.submit": "Criar proposta",
  "proposals.create.created": "{reference} criada e enviada para revisão.",
  "proposals.create.requiresApprovedEvidence":
    "A evidência precisa ser aprovada antes de originar uma proposta.",
  "proposals.create.ncm": "NCM",
  "proposals.create.ncmHint": "Oito dígitos já rotulados na evidência. Não invente classificação.",
  "proposals.create.cest": "CEST",
  "proposals.create.unconfirmed": "A confirmar na fonte",
  "proposals.create.treatmentHint":
    "Confirme se há tributação, isenção ou exclusão. Ausência de informação não é exclusão.",
  "proposals.create.verifySource":
    "Confira a linha da fonte antes de criar a proposta. Menções no documento não confirmam a alíquota, a rota ou a vigência deste NCM.",
  "proposals.create.validFromHint":
    "Use a vigência indicada no ato. A data de publicação ou de coleta não confirma o início da regra.",
  "proposals.create.validFrom": "Vigência inicial",
  "proposals.create.validTo": "Vigência final",
  "proposals.create.originUf": "UF de origem",
  "proposals.create.destinationUf": "UF de destino",
  "proposals.create.treatment": "Tratamento",
  "proposals.create.taxed": "Tributado",
  "proposals.create.exempt": "Isento",
  "proposals.create.excluded": "Fora desta evidência",
  "proposals.create.rate": "Alíquota oficial",
  "proposals.create.rateHint":
    "Copie o valor da evidência. Use 0–1 ou percentual até 100. Campo vazio não inventa alíquota.",
  "proposals.create.componentReason": "Motivo do tratamento",
  "proposals.create.ipi": "IPI / TIPI",
  "proposals.create.icms": "ICMS",
  "proposals.create.mode": "Modalidade",
  "proposals.create.mode.standard": "Padrão",
  "proposals.create.mode.st": "Substituição (ST)",
  "proposals.create.interstate": "Alíquota interestadual",
  "proposals.create.internal": "Alíquota interna de destino",
  "proposals.create.mva": "MVA original (%)",
  "proposals.create.mvaHint":
    "Informe o percentual da evidência: 125 significa 125%. Pode superar 100%.",
  "proposals.create.effective.title": "Carga efetiva (opcional)",
  "proposals.create.effective.hint":
    "Só para o ajuste da MVA (tax-family-v2): a alíquota interna efetiva do substituto no destino, por exemplo 12% para alimentos (RICMS/SP, Anexo II, art. 39). O débito da ST continua na alíquota interna nominal. Sem ela, o motor usa a alíquota nominal e avisa no cálculo.",
  "proposals.create.effective.rate": "Alíquota interna efetiva",
  "proposals.create.effective.basis": "Base legal da carga efetiva",
  "proposals.create.effective.basisPlaceholder": "Ex.: RICMS/SP, Anexo II, art. 39; DN CAT 8/2015",
  "proposals.create.effective.url": "Link da fonte (opcional)",
  "proposals.create.effective.validFrom": "Carga efetiva: início da vigência (opcional)",
  "proposals.create.effective.validTo": "Carga efetiva: fim da vigência (opcional)",
  "proposals.create.effective.validToHint":
    "Depois desta data o motor volta à alíquota nominal e avisa no cálculo.",
  "proposals.create.locked":
    "PIS, COFINS e ISS ficam fora desta base. Este formulário não publica alíquota para essas famílias.",
  "proposals.create.advanced": "JSON avançado",

  "rulesets.title": "Conjuntos de regras",
  "rulesets.description":
    "Conjuntos publicados são imutáveis e identificados por hash de conteúdo. Cada cálculo fixa uma versão exata.",
  "rulesets.column.version": "Versão",
  "rulesets.column.status": "Situação",
  "rulesets.column.digest": "Hash",
  "rulesets.column.rules": "Regras",
  "rulesets.column.published": "Publicado",
  "rulesets.column.publishedBy": "Publicado por",
  "rulesets.immutable": "Imutável",
  "rulesets.immutable.hint":
    "Publicado e com hash de conteúdo. Não pode ser editado; apenas sucedido ou revertido.",
  "rulesets.active": "Ativo",
  "rulesets.compare": "Comparar",
  "rulesets.compare.mode": "Comparar duas versões",
  "rulesets.diff.title": "Diferenças de {from} para {to}",
  "rulesets.diff.added": "adicionado",
  "rulesets.diff.removed": "removido",
  "rulesets.diff.changed": "alterado",
  "rulesets.diff.summary": "{added} adicionadas, {removed} removidas, {changed} alteradas",
  "rulesets.diff.none": "Nenhuma diferença entre as versões escolhidas.",
  "fieldDiff.kind.added": "Adicionado",
  "fieldDiff.kind.changed": "Alterado",
  "fieldDiff.kind.removed": "Removido",
  "fieldDiff.kind.unchanged": "Sem alteração",
  "fieldDiff.col.field": "Campo",
  "fieldDiff.col.change": "Mudança",
  "fieldDiff.col.before": "Antes",
  "fieldDiff.col.after": "Depois",
  "fieldDiff.count.added.one": "{count} adicionado",
  "fieldDiff.count.added.other": "{count} adicionados",
  "fieldDiff.count.changed.one": "{count} alterado",
  "fieldDiff.count.changed.other": "{count} alterados",
  "fieldDiff.count.removed.one": "{count} removido",
  "fieldDiff.count.removed.other": "{count} removidos",
  "fieldDiff.unchanged.one": "{count} campo sem alteração",
  "fieldDiff.unchanged.other": "{count} campos sem alteração",
  "fieldDiff.unknownField": "Campo não mapeado",
  "fieldDiff.unknownField.hint": "Mostrado como está gravado; este campo ainda não tem rótulo.",
  "fieldDiff.unit": "Unidade: {unit}",
  "fieldDiff.technical": "Detalhes técnicos",
  "fieldDiff.technical.path": "Caminho gravado",
  "fieldDiff.validity": "Vigência",
  "fieldDiff.validity.none": "Não informada",
  "fieldDiff.evidence": "Evidência",
  "fieldDiff.evidence.none": "Sem evidência vinculada",
  "fieldDiff.route": "Rota",
  "fieldDiff.empty": "Nenhum campo mudou.",
  "fieldDiff.error": "Não foi possível carregar esta versão.",
  "auditTimeline.actor.human": "Pessoa",
  "auditTimeline.actor.machine": "Sistema",
  "auditTimeline.group": "Decisão em grupo · {count}",
  "auditTimeline.tz": "BRT",
  "auditTimeline.tz.title": "Horário de Brasília (UTC−3)",
  "auditTimeline.empty": "Nenhum evento registrado ainda.",
  "auditTimeline.partial": "Mostrando {shown} de {total}",
  "auditTimeline.error": "Não foi possível carregar o histórico.",
  "auditTimeline.technical": "Detalhes técnicos",
  "auditTimeline.current": "Este evento",
  "auditTimeline.summary.one": "{count} evento",
  "auditTimeline.summary.other": "{count} eventos",
  "auditTimeline.summary.success.one": "{count} concluído",
  "auditTimeline.summary.success.other": "{count} concluídos",
  "auditTimeline.summary.rejection.one": "{count} rejeitado",
  "auditTimeline.summary.rejection.other": "{count} rejeitados",
  "audit.detail.history": "Histórico deste recurso",
  "audit.detail.change": "Alteração registrada",
  "audit.detail.change.hint": "Campos da proposta {reference}, como estão gravados agora.",
  "audit.detail.change.none":
    "Este evento não registra valores antes e depois. Abra o recurso para ver o estado atual.",
  "audit.detail.change.missing": "A proposta {reference} não foi encontrada.",
  "proposals.detail.history": "Histórico",
  "trust.OFFICIAL_SOURCE": "Fonte oficial",
  "trust.OFFICIAL_SOURCE.off": "Fonte fora do catálogo",
  "trust.OFFICIAL_SOURCE.meaning":
    "Atesta só a procedência: a fonte está no catálogo revisado de fontes oficiais. Não aprova o conteúdo.",
  "trust.OFFICIAL_SOURCE.offMeaning":
    "O host citado não corresponde a nenhuma fonte do catálogo revisado.",
  "trust.OFFICIAL_SOURCE.basis": "Catálogo de fontes · {source}",
  "trust.VERIFIED": "Verificado",
  "trust.VERIFIED.off": "Sem revisão humana",
  "trust.VERIFIED.meaning": "Uma pessoa revisora confirmou este fato.",
  "trust.VERIFIED.offMeaning": "Nenhuma pessoa confirmou este fato ainda.",
  "trust.VERIFIED.basis": "Revisão humana",
  "trust.PUBLISHED_RULE": "Regra publicada",
  "trust.PUBLISHED_RULE.off": "Regra fora de vigência",
  "trust.PUBLISHED_RULE.meaning": "A regra está num conjunto publicado; é o que o cálculo usa.",
  "trust.PUBLISHED_RULE.offMeaning": "A regra foi publicada, mas a vigência terminou.",
  "trust.PUBLISHED_RULE.basis": "Conjunto publicado · {version}",
  "trust.tip.captured": "Capturado em {date}",
  "trust.tip.verifiedAt": "Confirmado em {date}",
  "trust.tip.citation": "Citação",
  "trust.tip.citation.available": "Disponível · {host}",
  "trust.tip.citation.absent": "Sem citação",
  "trust.tip.validity": "Vigência",
  "trust.tip.current": "em vigor",
  "trust.tip.expired": "vencida",
  "trust.tip.basis": "Base",
  "ruleDiff.field.legacyMva": "MVA ajustada (legado)",
  "ruleDiff.field.reasonOf": "Justificativa ({tax})",
  "ruleDiff.field.evidence": "Evidências",
  "ruleDiff.value.documents.one": "{count} documento",
  "ruleDiff.value.documents.other": "{count} documentos",
  "ruleDiff.change.removed": "Removida",
  "ruleDiff.count.added.one": "{count} nova",
  "ruleDiff.count.added.other": "{count} novas",
  "ruleDiff.count.changed.one": "{count} alterada",
  "ruleDiff.count.changed.other": "{count} alteradas",
  "ruleDiff.count.removed.one": "{count} removida",
  "ruleDiff.count.removed.other": "{count} removidas",
  "ruleDiff.listLabel": "Regras que mudaram",
  "ruleDiff.allRoutes": "Todas as rotas",
  "ruleDiff.anyUf": "Qualquer UF",
  "ruleDiff.anyNcm": "Qualquer NCM",
  "ruleDiff.family.operational": "Custo operacional",
  "ruleDiff.family.commercial": "Taxa comercial",
  "ruleDiff.scope.category": "Categoria {value}",
  "ruleDiff.scope.paymentMethod": "Pagamento {value}",
  "ruleDiff.scope.transactionType": "Transação {value}",
  "ruleDiff.openRule": "Abrir regra",
  "ruleDiff.more.one": "Mostrar mais {count} regra",
  "ruleDiff.more.other": "Mostrar mais {count} regras",
  "ruleDiff.other.title": "Outras alterações",
  "ruleDiff.noRuleChanges": "Nenhuma regra mudou entre as versões. Veja a diferença técnica.",
  "ruleDiff.technical.show": "Ver diferença técnica",
  "ruleDiff.technical.hide": "Ocultar diferença técnica",
  "ruleDiff.technical.title": "Diferença técnica",
  "ruleDiff.technical.hint": "Linhas originais do conjunto, como gravadas, para auditoria.",
  "rulesets.publish": "Publicar",
  "rulesets.publish.title": "Publicar conjunto de regras",
  "rulesets.publish.step.review": "Revisar diferenças",
  "rulesets.publish.step.impact": "Confirmar impacto",
  "rulesets.publish.step.confirm": "Confirmar publicação",
  "rulesets.publish.confirmHint": "Digite {version} para confirmar a publicação.",
  "rulesets.publish.effect":
    "A partir da publicação, novos cálculos passam a usar esta versão. Cálculos existentes mantêm a versão fixada.",
  "rulesets.rollback": "Reverter",
  "rulesets.rollback.title": "Reverter para {version}",
  "rulesets.rollback.step.select": "Escolher versão alvo",
  "rulesets.rollback.step.review": "Revisar diferenças",
  "rulesets.rollback.step.confirm": "Confirmar reversão",
  "rulesets.rollback.effect":
    "A reversão não apaga nada: publica novamente o conteúdo da versão alvo como uma nova versão.",
  "rulesets.rollback.confirmHint": "Digite {version} para confirmar a reversão.",
  "rulesets.staleBase": "A base desta minuta está desatualizada frente ao conjunto ativo.",
  "rulesets.publish.onlyDraft": "Apenas a minuta pode ser publicada.",
  "rulesets.publish.needsProposal": "A minuta precisa de pelo menos uma proposta aprovada.",
  "rulesets.publish.publisherConflict": "A minuta precisa de pelo menos uma proposta aprovada.",
  "rulesets.publish.segregation":
    "A publicação fica registrada na auditoria. O autor pode publicar.",
  "rulesets.publish.included": "Propostas incluídas",
  "rulesets.publish.includedMore": "e mais {count}",
  "rulesets.rollback.onlyPublished":
    "Só versões publicadas ou substituídas podem ser alvo de reversão.",
  "rulesets.rollback.target": "Alvo: {version}",
  "rulesets.empty.title": "Nenhum conjunto de regras",
  "rulesets.empty.body": "A minuta é gerada automaticamente quando uma proposta é aprovada.",
  "rulesets.empty.action": "Abrir propostas em revisão",
  "rulesets.column.basedOn": "Base",
  "rulesets.column.supersededBy": "Substituído por",
  "rulesets.included.author": "Autor",
  "rulesets.included.reviewers": "Revisores",

  "rules.title": "Regras",
  "rules.description": "Consulta das regras vigentes por rota (origem → destino), NCM e tipo.",
  "rules.browse.title": "Buscar regras publicadas",
  "rules.browse.hint":
    "Busque regras publicadas por NCM, origem ou destino. Cada filtro é opcional.",
  "rules.browse.prompt":
    "Filtre as regras publicadas abaixo. Abra um resultado para ver seu alcance e evidência.",
  "rules.browse.ncm": "NCM",
  "rules.browse.ncmPlaceholder": "Ex.: 2106.90.90",
  "rules.route.choose": "Escolher UF",
  "rules.route.swap": "Inverter origem e destino",
  "rules.route.applied": "{origin} → {destination} · {count} regras publicadas nesta rota",
  "rules.routes.priority": "Rotas prioritárias",
  "rules.catalogs": "Catálogos Siscomex e CEST",
  "rules.sources.title": "Fontes desta rota",
  "rules.sources.hint":
    "Fontes oficiais já ligadas à origem, ao destino ou à União. Sem fonte, não se inventa alíquota.",
  "rules.sources.empty": "Nenhuma fonte desta rota na allow-list.",
  "rules.sources.search": "Buscar esta rota na Mesa",
  "rules.sources.open": "Abrir fontes",
  "rules.sources.unwatched":
    "{origin} ou {destination} ainda não está na watchlist de SEFAZ. A coleta periódica não cobre essa ponta.",
  "rules.empty.route.title": "Nenhuma regra publicada em {origin} → {destination}",
  "rules.empty.route.body":
    "A rota está escolhida. Sem alíquota neste conjunto, não se inventa ICMS, ST nem MVA.",
  "rules.lookup.cest.title": "CEST {cest}",
  "rules.lookup.cest.segment": "Segmento",
  "rules.lookup.cest.ncm": "Prefixos NCM/SH",
  "rules.chapters.label": "Capítulos SH",
  "rules.chapters.note":
    "Capítulos SH de dois dígitos com o título oficial. Abra um capítulo para ver as regras publicadas. Não são alíquota nem conjunto publicado.",
  "rules.chapterDetail.eyebrow": "Capítulo SH",
  "rules.chapterDetail.honesty":
    "Este capítulo é classificação Siscomex. Não é alíquota nem conjunto publicado.",
  "rules.chapterDetail.notFound": "Este capítulo SH não existe.",
  "rules.chapterDetail.notFound.body":
    "Os capítulos oficiais vão de 01 a 97. Volte à lista de regras.",
  "rules.chapterDetail.published": "Regras publicadas neste capítulo",
  "rules.chapterDetail.empty.title": "Nenhuma regra publicada neste capítulo",
  "rules.chapterDetail.empty.body":
    "O catálogo classifica o capítulo. Sem ruleset com este prefixo NCM, não se inventa alíquota.",
  "rules.chapterDetail.seeAll": "Ver todas na lista de regras",
  "rules.chapterDetail.section": "Seção {section}",
  "rules.chapterDetail.section.label": "Seção SH",
  "rules.chapterDetail.prefix": "Prefixo NCM",
  "rules.chapterDetail.prefix.hint": "Oito dígitos. Só os dois primeiros estão fechados.",
  "rules.chapterDetail.published.hint": "Neste conjunto publicado. Não é o catálogo.",
  "rules.chapterDetail.catalog.asOf": "Classif em {asOf}: {catalog} códigos. Não é alíquota.",
  "rules.chapterDetail.structure": "Estrutura",
  "rules.chapterDetail.structure.chapter": "Capítulo",
  "rules.chapterDetail.structure.heading": "Posição",
  "rules.chapterDetail.structure.subheading": "Subposição",
  "rules.chapterDetail.structure.mercosur": "Mercosul",
  "rules.chapterDetail.structure.hint":
    "Recorte didático. O texto legal vigente está no Classif; isto não classifica um produto.",
  "rules.chapterDetail.classification": "Classificação",
  "rules.chapterDetail.titles": "Títulos oficiais",
  "rules.chapterDetail.sources": "Fontes oficiais",
  "rules.chapterDetail.openClassif": "Abrir Classif",
  "rules.chapterDetail.openNesh": "Abrir NESH",
  "rules.chapterDetail.openHub": "Hub da classificação",
  "rules.chapterDetail.neighbors": "Capítulos vizinhos",
  "rules.chapterDetail.previous": "Capítulo anterior, SH {chapter}",
  "rules.chapterDetail.next": "Próximo capítulo, SH {chapter}",
  "rules.chapterDetail.illustration.alt":
    "Ilustração cívica de {title}. Não é foto oficial nem alíquota.",
  "rules.chapterDetail.illustration.generated":
    "Ilustração Vertex do capítulo. Não é foto oficial nem alíquota.",
  "rules.chapterDetail.illustration.paper": "Papel cívico. Ainda não há ilustração deste capítulo.",
  "rules.empty.noRuleset.title": "Nenhuma regra publicada",
  "rules.empty.published.title": "Nenhuma regra fiscal neste conjunto",
  "rules.empty.published.body":
    "O conjunto publicado não tem regras deste tipo. O catálogo Siscomex continua sendo classificação, não alíquota.",
  "rules.lookup.title": "Consulta {ncm}",
  "rules.lookup.catalog": "Catálogo Siscomex",
  "rules.lookup.published": "Regras publicadas neste NCM",
  "rules.lookup.associated": "Regras associadas",
  "rules.ncm.all": "Todas as regras de {ncm}",
  "rules.lookup.proposals": "Propostas",
  "rules.lookup.evidence": "Evidências",
  "rules.lookup.state.reference": "referência (não é alíquota)",
  "rules.lookup.state.absent": "ausente",
  "rules.lookup.catalogMiss":
    "Este NCM de 8 dígitos não está no catálogo Siscomex desta organização.",
  "rules.lookup.honesty":
    "PIS e COFINS ficam fora desta base. ISS municipal não entra nesta operação. Sem ruleset publicado, ST, ICMS e MVA não se inventam.",
  "rules.lookup.openEvidence": "Abrir evidências deste NCM",
  "rules.lookup.openProposals": "Abrir propostas deste NCM",
  "rules.column.kind": "Tipo",
  "rules.column.ncm": "NCM",
  "rules.chapter": "Capítulo {chapter}",
  "rules.chapter.short": "SH {chapter}",
  "rules.column.route": "Rota",
  "rules.column.rate": "Alíquota",
  "rules.column.value": "Valor",
  "rules.column.validity": "Vigência",
  "rules.column.reference": "Referência legal",
  "rules.filter.kind": "Tipo de regra",
  "rules.filter.ncm": "NCM",
  "rules.filter.originUf": "UF de origem",
  "rules.filter.destinationUf": "UF de destino",
  "rules.filter.asOf": "Vigente em",
  "rules.filter.asOf.applied": "Vigente em {date}",
  "rules.filter.uf": "UF",
  "rules.validFrom": "Vigente desde {date}",
  "rules.validTo": "até {date}",
  "rules.openEnded": "sem termo final",
  "rules.kind.FISCAL": "Fiscal",
  "rules.kind.OPERATIONAL_COST": "Custo operacional",
  "rules.kind.COMMERCIAL_FEE": "Taxa comercial",
  "rules.route.any": "todas",
  "rules.activeRuleset": "Conjunto {version}, publicado em {date}",
  "rules.provenance": "Proveniência",
  "rules.provenance.legacyCommercialFee":
    "Taxa de intermediação da calculadora anterior (base 100)",
  "rules.provenance.retailCommercialFee": "Taxa comercial de varejo (base 100)",
  "rules.provenance.global": "global",
  "rules.empty.noRuleset.body": "As regras em vigor aparecem depois que uma minuta é publicada.",
  "rules.empty.noRuleset.action": "Abrir conjuntos de regras",
  "rules.detail.technicalId": "Identificador técnico",
  "rules.detail.title": "Detalhe da regra",
  "rules.detail.honesty":
    "A alíquota abaixo é a figura publicada neste conjunto. O catálogo Siscomex classifica; não calcula.",
  "rules.detail.notFound": "Esta regra não está no conjunto publicado.",
  "rules.detail.notFound.body":
    "O detalhe só mostra o registro vigente. Volte à lista ou abra o conjunto publicado.",
  "rules.detail.openRuleset": "Abrir conjunto {version}",
  "rules.detail.cest": "CEST",
  "rules.related.scope":
    "Regras vinculadas ao NCM {ncm} na versão {version}, em todas as rotas e vigências. Uma regra relacionada não é necessariamente aplicável à sua operação.",
  "rules.related.current": "Regra atual",
  "rules.detail.siblings": "Outras regras deste NCM",
  "record.id": "Id",
  "record.backToList": "Voltar à lista",
  "listing.figure.gazette": "Ilustração de um boletim oficial em papel",
  "listing.figure.ledger": "Ilustração de um registro cívico aberto",
  "listing.figure.portal": "Ilustração de um portal cívico",

  "calculations.empty.action": "Ver conjuntos de regras",
  "calculations.title": "Auditoria de cálculos",
  "calculations.description":
    "Todo cálculo registra a versão exata do conjunto de regras, o hash da requisição e as inconsistências detectadas.",
  "calculations.playground.eyebrow": "Ensaio",
  "calculations.playground.title": "Como um lote entra no cálculo",
  "calculations.playground.body":
    "O lote mora no marketplace. Aqui entra só o snapshot fiscal: NCM, rota, data e valor de entrada. Não é a base de lotes de produção.",
  "calculations.playground.honesty":
    "Mudar o lote no marketplace não altera a regra. Um novo CALCULATE contra um conjunto publicado gera outro recibo. Sem conjunto publicado, não há cálculo honesto.",
  "calculations.playground.openRules": "Ver regras que casam com este snapshot",
  "calculations.playground.matching": "Regras publicadas para este NCM",
  "calculations.playground.noRules":
    "Nenhuma regra publicada para este NCM. O catálogo classifica; o conjunto publicado é que calcula.",
  "calculations.playground.noRuleset":
    "Não há conjunto publicado. O ensaio mostra classificação e rota; não inventa alíquota.",
  "calculations.playground.ncm": "NCM",
  "calculations.playground.route": "Rota",
  "calculations.playground.cest": "CEST",
  "calculations.playground.date": "Data do cálculo",
  "calculations.playground.value": "Valor de entrada",
  "calculations.playground.quantity": "Quantidade",
  "calculations.playground.emptyCest": "sem CEST neste snapshot",
  "calculations.playground.snapshot.stationery": "Papelaria SP → RJ",
  "calculations.playground.snapshot.machinery": "Máquinas MG → SP",
  "calculations.playground.snapshot.beverages": "Bebidas RS → SC",
  "calculations.column.ruleset": "Conjunto",
  "calculations.column.items": "Itens",
  "calculations.column.review": "Revisão",
  "calculations.column.workflow": "Fluxo",
  "calculations.column.itemId": "Item",
  "calculations.column.baseCost": "Custo base",
  "calculations.column.ipi": "IPI",
  "calculations.column.icmsSt": "ICMS (ST ou próprio)",
  "calculations.column.landedUnitCost": "Custo unitário posto",
  "calculations.column.issues": "Inconsistências",
  "calculations.filter.issue": "Código de inconsistência",
  "calculations.detail.title": "Cálculo {id}",
  "calculations.detail.replayed": "Resposta reproduzida por idempotência",
  "calculations.detail.engine": "Motor",
  "calculations.detail.pinned": "Versão fixada",
  "calculations.detail.items": "Itens",
  "calculations.detail.explain": "Explicar",
  "calculations.detail.export": "Exportar",
  "calculations.detail.exported": "Exportação {filename} preparada.",
  "calculations.explain.title": "Como {item} foi calculado",
  "calculations.explain.inputs": "Entradas",
  "calculations.explain.steps": "Passos",
  "calculations.explain.provenance": "Proveniência das regras",
  "calculations.explain.issues": "Inconsistências",
  "calculations.explain.baseCost": "Custo base ({source})",
  "calculations.explain.lookup": "Modo de busca: {mode}",
  "calculations.explain.reviewRequired": "Este item exige revisão financeira antes de virar preço.",
  "calculations.explain.close": "Fechar explicação",

  "calculations.tabs.label": "Ferramentas da calculadora",
  "fiscalTasks.description":
    "Acompanhe lotes fiscais de longa duração, seu snapshot imutável, progresso e resultados calculados.",
  "fiscalTasks.summary.review": "Aguardando revisão",
  "fiscalTasks.summary.items": "Itens do lote",
  "fiscalTasks.summary.calculated": "Itens calculados",
  "fiscalTasks.summary.attempts": "Tentativas",
  "fiscalTasks.status.QUEUED": "Na fila",
  "fiscalTasks.status.RUNNING": "Em execução",
  "fiscalTasks.status.WAITING_REVIEW": "Requer revisão",
  "fiscalTasks.status.SUCCEEDED": "Concluído",
  "fiscalTasks.status.FAILED": "Falhou",
  "fiscalTasks.status.CANCELLED": "Cancelada",
  "fiscalTasks.column.lot": "Lote fiscal",
  "fiscalTasks.detail.title": "Importação {id}",
  "fiscalTasks.detail.description":
    "Registro operacional do lote: entradas, regras fixadas, execução e resultado auditável.",
  "fiscalTasks.record.title": "Registro",
  "fiscalTasks.record.hint":
    "Fatos fixados ao criar a importação. Correções posteriores não os alteram.",
  "fiscalTasks.detail.progress": "Progresso da execução",
  "fiscalTasks.detail.updated": "Atualizada em {date}",
  "fiscalTasks.detail.chunks": "etapas concluídas",
  "fiscalTasks.detail.polling": "Este estado se atualiza sozinho enquanto o cálculo roda.",
  "lotWait.title.queued": "Lote na fila",
  "lotWait.title.chunk": "Calculando bloco {current} de {total}",
  "lotWait.title.running": "Calculando o lote",
  "lotWait.seconds": "{count} s",
  "lotWait.minutes": "{count} min",
  "lotWait.waited": "na fila há {duration}",
  "lotWait.ahead.none": "Nenhum lote à frente: o seu é o próximo",
  "lotWait.ahead.one": "{count} lote à frente",
  "lotWait.ahead.other": "{count} lotes à frente",
  "lotWait.rows": "{done} de {total} linhas",
  "lotWait.stagesLabel": "Etapas do lote",
  "lotWait.stage.received": "Recebido",
  "lotWait.stage.queued": "Na fila",
  "lotWait.stage.running": "Calculando",
  "lotWait.stage.results": "Resultados",
  "lotWait.state.done": "concluído",
  "lotWait.state.active": "agora",
  "lotWait.state.pending": "a seguir",
  "lotWait.chunks.one": "{count} bloco",
  "lotWait.chunks.other": "{count} blocos",
  "lotWait.chunksLabel": "Blocos do cálculo",
  "lotWait.chunksDone": "{done} de {total} blocos concluídos",
  "lotWait.chunk": "Bloco {index} de {total}",
  "lotWait.chunkState.done": "concluído",
  "lotWait.chunkState.active": "calculando agora",
  "lotWait.chunkState.pending": "a seguir",
  "lotWait.chunkState.failed": "com falha",
  "lotWait.count.calculated": "Calculadas",
  "lotWait.count.review": "Para revisar",
  "lotWait.count.failedChunks": "Blocos com falha",
  "lotWait.next.title": "O que acontece agora",
  "lotWait.next.start":
    "O cálculo começa sozinho: os lotes na fila são retomados automaticamente, em geral em até 1 minuto.",
  "lotWait.next.chunks.one":
    "Calculamos em {count} bloco; os resultados aparecem quando ele termina.",
  "lotWait.next.chunks.other":
    "Calculamos em {count} blocos; os resultados parciais aparecem a cada bloco concluído.",
  "lotWait.next.leave":
    "Pode sair desta tela: o cálculo continua no servidor e o lote fica em Lotes.",
  "lotWait.attempt":
    "Tentativa {current} de {max}: uma tentativa anterior não terminou e o lote foi retomado.",
  "lotWait.follow": "Acompanhar em Lotes",
  "lotWait.partialTitle": "Subtotal parcial · atualiza a cada bloco",
  "fiscalTasks.detail.results": "Resultados por item",
  "fiscalTasks.detail.resultsHint": "{count} itens já têm um resultado persistido",
  "fiscalTasks.detail.sourceSystem": "Sistema de origem",
  "fiscalTasks.detail.lotId": "ID do lote",
  "fiscalTasks.detail.listId": "ID da lista",
  "fiscalTasks.detail.calculationDate": "Data fiscal",
  "fiscalTasks.detail.snapshotRows": "Linhas capturadas",
  "fiscalTasks.detail.snapshotHash": "Hash do snapshot",
  "fiscalTasks.detail.ruleset": "Conjunto usado",
  "fiscalTasks.detail.selector": "Seletor solicitado",
  "fiscalTasks.detail.resolvedVersion": "Versão resolvida",
  "fiscalTasks.detail.digest": "Digest do conjunto",
  "fiscalTasks.detail.artifact": "Artefato de entrada",
  "fiscalTasks.detail.noArtifact": "Nenhum artefato anexado",
  "fiscalTasks.detail.issues": "Inconsistências encontradas",
  "fiscalTasks.detail.noIssues": "Nenhuma inconsistência registrada neste snapshot.",
  "fiscalTasks.detail.trace": "Rastro operacional",
  "fiscalTasks.detail.workflow": "Workflow de origem",
  "fiscalTasks.detail.requestId": "requestId",
  "fiscalTasks.detail.created": "Criada em",
  "fiscalTasks.detail.started": "Iniciada em",
  "fiscalTasks.detail.completed": "Concluída em",
  "fiscalTasks.detail.revision": "Revisão de concorrência",
  "fiscalTasks.action.cancel": "Cancelar tarefa",
  "fiscalTasks.action.retry": "Reprocessar",
  "fiscalTasks.action.cancelDisabled":
    "Só é possível cancelar uma tarefa na fila, em execução ou aguardando revisão.",
  "fiscalTasks.action.retryDisabled": "Só é possível reprocessar uma tarefa falha ou cancelada.",
  "fiscalTasks.action.cancelled": "Solicitação de cancelamento enviada.",
  "fiscalTasks.action.requeued": "Tarefa recolocada na fila.",
  "fiscalTasks.retry.defaultReason": "Reprocessar após revisar a entrada fiscal do lote.",
  "fiscalTasks.resultStatus.CALCULATED": "Calculado",
  "fiscalTasks.resultStatus.REVIEW_REQUIRED": "Requer revisão",
  "fiscalTasks.results.item": "Item",
  "fiscalTasks.results.route": "Rota",
  "fiscalTasks.results.taxes": "IPI + ICMS-ST",
  "fiscalTasks.results.landed": "Custo posto",
  "fiscalTasks.results.issues": "Inconsistências",
  "fiscalTasks.results.calculation": "Cálculo",
  "fiscalTasks.results.openCalculation": "Abrir recibo",
  "fiscalTasks.results.search": "Filtrar por item",
  "fiscalTasks.results.empty.title": "Nenhum resultado persistido",
  "fiscalTasks.results.empty.filtered": "Nenhum item corresponde a este filtro.",
  "fiscalTasks.results.empty.body": "Os resultados aparecem conforme o cálculo avança.",
  "fiscalTasks.dialog.cancel.title": "Cancelar esta tarefa fiscal?",
  "fiscalTasks.dialog.cancel.body":
    "Nenhuma linha nova será calculada. Uma etapa já em andamento pode terminar.",
  "fiscalTasks.dialog.cancel.warning":
    "O snapshot e os resultados já persistidos continuam preservados para auditoria.",
  "fiscalTasks.dialog.cancel.confirm": "Confirmar cancelamento",
  "fiscalTasks.dialog.retry.title": "Reprocessar tarefa fiscal",
  "fiscalTasks.dialog.retry.body":
    "As etapas concluídas ficam imutáveis; só o que falta calcular volta à fila.",
  "fiscalTasks.dialog.retry.reason": "Motivo do reprocessamento",
  "fiscalTasks.dialog.retry.reasonHint":
    "Informe pelo menos 10 caracteres para registrar a decisão.",
  "fiscalTasks.dialog.retry.confirm": "Colocar na fila",

  "sources.empty.title": "Nenhuma fonte cadastrada",
  "sources.empty.body":
    "As fontes vêm do registro oficial; não é possível adicionar URLs pela interface.",
  "sources.title": "Fontes oficiais",
  "sources.description":
    "Confira quais fontes estão em dia e abra os documentos que precisam de revisão.",
  "sources.registry.eyebrow": "Registro oficial",
  "sources.registry.title": "Fontes que sustentam cada pesquisa",
  "sources.registry.description":
    "O catálogo define onde o agente pode buscar. Uma fonte não é uma regra fiscal: ela entrega documentos para revisão.",
  "sources.registry.flow": "Como uma fonte chega à evidência",
  "sources.registry.step.review": "Fonte revisada",
  "sources.registry.step.reviewHint": "Domínio, jurisdição e cadência ficam sob controle.",
  "sources.registry.step.grounding": "Busca fundamentada",
  "sources.registry.step.groundingHint": "A pesquisa se limita às fontes oficiais autorizadas.",
  "sources.registry.step.evidence": "Evidência para revisar",
  "sources.registry.step.evidenceHint": "Nada vira regra ou alíquota automaticamente.",
  "sources.registry.note":
    "URLs livres não entram diretamente no registro; peça a revisão de uma nova fonte à equipe.",
  "sources.action.requestReview": "Solicitar nova fonte",
  "sources.request.title": "Solicitar incorporação de uma fonte",
  "sources.request.titlePrefix": "Revisar fonte",
  "sources.request.notice":
    "Esta ação cria uma tarefa de revisão; não ativa a URL nem modifica o registro oficial.",
  "sources.request.name": "Nome da fonte",
  "sources.request.publisher": "Publicador",
  "sources.request.jurisdiction": "Jurisdição",
  "sources.request.url": "URL oficial",
  "sources.request.reasonHint":
    "Explique por que esta fonte deve ser revisada e que informação fiscal ela pode sustentar.",
  "sources.request.submit": "Criar tarefa de revisão",
  "sources.request.created": "Solicitação registrada como tarefa de revisão.",
  "sources.request.openTasks": "Ver tarefas",
  "sources.request.payload.name": "Nome",
  "sources.request.payload.publisher": "Publicador",
  "sources.request.payload.jurisdiction": "Jurisdição",
  "sources.request.payload.url": "URL oficial",
  "sources.request.payload.reason": "Motivo",
  "sources.request.payload.governance":
    "O registro oficial só deve ser atualizado após revisão e configuração governada.",
  "sources.discovery.note":
    "A coleta automática verifica a cada 3 horas (horário de Brasília) quando não está pausada e visita cada fonte uma vez por frequência (hoje diária), da mais antiga para a mais recente; uma fonte degradada é tentada de novo uma vez por frequência. “Executar agora” não espera o próximo horário. A coluna “Última execução” mostra o que de fato rodou.",
  "sources.extract.note":
    "O extrator só escreve evidência para revisão. A fonte Siscomex (NCM) fica pausada até o Classif ser publicado como catálogo de referência, nunca como alíquota.",
  "sources.intro.summary": "Como os documentos são coletados",
  "sources.filter.dlq": "Com falhas pendentes",
  "sources.filter.search": "Nome, editor ou jurisdição",
  "sources.status.ACTIVE": "Ativa",
  "sources.status.PAUSED": "Pausada",
  "sources.status.DEGRADED": "Degradada",
  "sources.status.DISABLED": "Desativada",
  "sources.catalogue.results": "{count} fontes",
  "sources.catalogue.degraded.one": "{count} degradada",
  "sources.catalogue.degraded.other": "{count} degradadas",
  "sources.fact.rate": "Sucesso 7 d",
  "sources.fact.documents": "Documentos",
  "sources.column.name": "Fonte",
  "sources.column.status": "Situação",
  "sources.column.lastRun": "Última execução",
  "sources.column.nextDue": "Próxima busca",
  "sources.column.successRate": "Taxa de sucesso",
  "sources.column.documents": "Documentos (7 d)",
  "sources.column.cadence": "Cadência",
  "sources.column.baseUrl": "URL base",
  "sources.dlq.label": "Falhas pendentes",
  "sources.health.current": "Falhas pendentes da fonte: {count}",
  "sources.health.observedAt": "Observada em {when}",
  "sources.health.stale": "A contagem de falhas pendentes da fonte está desatualizada",
  "sources.health.unavailable": "Contagem de falhas pendentes da fonte indisponível",
  "sources.health.lastObserved": "Última observação: {when}",
  "sources.health.diagnostic":
    "O monitoramento da nuvem é a referência para a contagem compartilhada de falhas. Faça uma prévia por fonte para revisar os IDs exatos.",
  "sources.health.failedRuns": "Falhas recentes nas execuções da fonte",
  "sources.health.compact.current": "{count}",
  "sources.health.compact.stale": "⚠ {count}",
  "sources.health.compact.unavailable": "—",
  "sources.cadence.daily": "Diária",
  "sources.cadence.weekly": "Semanal",
  "sources.due.now": "Na próxima passagem",
  "sources.run.detail.title": "Execução {id}",
  "sources.run.detail.description": "Resultado da coleta e documentos vinculados a esta execução.",
  "sources.run.detail.identity": "{name} · {publisher} · {jurisdiction}",
  "sources.run.detail.notFound": "Execução não encontrada",
  "sources.run.detail.invalid":
    "O identificador é inválido ou a execução não pertence a esta fonte.",
  "sources.run.detail.sourceError": "Não foi possível ler a fonte",
  "sources.run.detail.readError": "Não foi possível ler a execução",
  "sources.run.detail.result": "Resultado da execução",
  "sources.run.detail.live": "Acompanhando a execução · atualização automática",
  "sources.run.detail.ageNotice": "Sem conclusão registrada após duas horas",
  "sources.run.detail.staleNotice":
    "Sem atualização registrada há mais de 24 horas. Encerre esta execução para liberar novas consultas. Os documentos já extraídos serão preservados.",
  "sources.run.detail.cancelStale": "Encerrar execução estagnada",
  "sources.run.detail.cancelling": "Solicitando encerramento…",
  "sources.run.detail.cancelRequested":
    "Encerramento solicitado. Aguardando a confirmação do estado da execução.",
  "sources.run.detail.created": "Criados",
  "sources.run.detail.reused": "Reutilizados",
  "sources.run.detail.countNote":
    "Criados e reutilizados contam documentos vinculados a esta execução. Um documento reutilizado não comprova a aprovação de regras fiscais.",
  "sources.run.detail.documents": "Documentos desta execução",
  "sources.run.detail.review": "Revisar documento",
  "sources.run.detail.waiting": "Aguardando documentos",
  "sources.run.detail.waitingBody":
    "Ainda não há documentos vinculados. Esta página consulta o estado e os recibos.",
  "sources.run.detail.empty": "Nenhum documento vinculado",
  "sources.run.detail.emptyBody":
    "Não há vínculos de documentos registrados para esta execução. Isso não permite concluir que a fonte nunca foi coletada.",
  "sources.run.detail.timing": "Quando aconteceu",
  "sources.run.detail.started": "Início",
  "sources.run.detail.finished": "Conclusão",
  "sources.run.detail.technical": "Identificadores técnicos",
  "sources.run.detail.runId": "ID da execução",
  "sources.run.detail.sourceId": "ID da fonte",
  "sources.runs": "Execuções",
  "sources.run.duration": "Duração",
  "sources.run.discovered": "Descobertos",
  "sources.run.ingested": "Ingeridos",
  "sources.run.failed": "Falhas",
  "sources.run.compact.discovered.one": "{count} descoberto",
  "sources.run.compact.discovered.other": "{count} descobertos",
  "sources.run.compact.failed.one": "{count} falha",
  "sources.run.compact.failed.other": "{count} falhas",
  "sources.action.runNow": "Executar agora",
  "sources.action.pause": "Pausar",
  "sources.action.resume": "Retomar",
  "sources.action.replayDlq": "Reprocessar falhas pendentes",
  "sources.action.inspectDlq": "Inspecionar falhas pendentes",
  "sources.run.accepted": "Execução fiscal enfileirada com o identificador {id}.",
  "sources.dlq.title": "Recuperação de falhas pendentes — {source}",
  "sources.dlq.previewNotice":
    "A prévia é assíncrona: não publica nem confirma mensagens. Consulte os logs da execução e copie somente os IDs revisados.",
  "sources.dlq.executeNotice":
    "A execução republicará somente os IDs informados e confirmará cada falha pendente após a publicação.",
  "sources.dlq.maxMessages": "Limite da leitura (1–100)",
  "sources.dlq.rate": "Mensagens por segundo (0,1–10)",
  "sources.dlq.execute": "Executar os IDs previamente revisados",
  "sources.dlq.messageIds": "IDs exatos das mensagens",
  "sources.dlq.messageIdsHint":
    "Um ID por linha, copiado da prévia. Duplicatas, espaços e mais de 100 IDs são recusados.",
  "sources.dlq.reasonHint":
    "Informe o chamado ou registro de mudança e a aprovação (10–256 caracteres).",
  "sources.dlq.queuePreview": "Enfileirar prévia segura",
  "sources.dlq.confirmExecute": "Enfileirar reprocessamento selecionado",
  "sources.dlq.acceptedPreview":
    "Prévia enfileirada ({id}). Consulte os logs antes de selecionar qualquer mensagem.",
  "sources.dlq.acceptedExecute":
    "Reprocessamento selecionado enfileirado ({id}); o resultado deve ser verificado nos logs e métricas.",
  "sources.degraded": "Fonte degradada: {reason}",
  "sources.degraded.noRun": "Ainda não há execução registrada",
  "sources.degraded.technical": "Detalhe técnico",
  "sources.degraded.timeout": "Tempo esgotado ao conectar",
  "sources.degraded.timeoutHost": "Tempo esgotado ao conectar a {host}",
  "sources.degraded.dns": "Falha de DNS",
  "sources.degraded.dnsHost": "Falha de DNS em {host}",
  "sources.degraded.tls": "Erro de certificado TLS",
  "sources.degraded.tlsHost": "Erro de certificado TLS em {host}",
  "sources.degraded.http": "A fonte respondeu HTTP {status}",
  "sources.degraded.httpHost": "A fonte {host} respondeu HTTP {status}",
  "sources.degraded.reset": "A conexão foi interrompida",
  "sources.degraded.resetHost": "A conexão com {host} foi interrompida",
  "sources.degraded.connect": "Não foi possível conectar",
  "sources.degraded.connectHost": "Não foi possível conectar a {host}",
  "sources.degraded.security": "Bloqueada pela política de segurança",
  "sources.degraded.robots": "Bloqueada por robots.txt",
  "sources.degraded.unsupported": "Formato de documento não suportado",
  "sources.degraded.parse": "Falha ao ler o documento",
  "sources.degraded.unknown": "Falha ao coletar a fonte · {raw}",

  "discovery.title": "Lançar uma busca fiscal",
  "discovery.description":
    "Faça uma pergunta ao agente ou extraia uma URL oficial; acompanhe tudo até a revisão humana.",
  "discovery.mode.label": "Tipo de tarefa fiscal",
  "discovery.mode.research": "Investigar uma pergunta",
  "discovery.mode.researchHint": "Sem URL: o agente pesquisa nas fontes oficiais escolhidas.",
  "discovery.mode.url": "Extrair de uma URL",
  "discovery.mode.urlHint": "Com URL: preserve o documento e revise candidatos.",
  "discovery.queryHint": "Descreva a pergunta, o imposto, a UF ou o NCM que você quer pesquisar.",
  "discovery.sourcesHint":
    "A tarefa fica limitada às fontes ativas ou degradadas do registro revisado.",
  "discovery.degraded.badge": "Fonte degradada",
  "discovery.degraded.hint": "A última captura falhou; as citações continuam sujeitas à revisão.",
  "discovery.degraded.hintWithReason":
    "A última captura falhou ({reason}); as citações continuam sujeitas à revisão.",
  "discovery.stage.eyebrow": "Área de trabalho",
  "discovery.stage.title": "Acompanhe o que entrou",
  "discovery.stage.description":
    "Veja a execução, as evidências e o que ainda precisa de revisão humana.",
  "discovery.stage.urlEmpty":
    "Envie uma URL oficial para acompanhar sua recepção e candidatos aqui.",
  "discovery.research.retryDispatch": "Reenviar pesquisa",
  "discovery.research.retryReason": "Motivo da nova tentativa",
  "discovery.research.retryHint":
    "Envia as citações pendentes desta tarefa. Preserva as evidências já recebidas.",
  "discovery.research.eyebrow": "Agente fiscal",
  "discovery.research.title": "Pesquisar fontes oficiais online",
  "discovery.research.description":
    "O agente pesquisa na web, filtra os domínios autorizados e guarda as citações para revisão.",
  "discovery.research.provider": "Provedor de IA",
  "discovery.research.defaultModel": "gemini-4-argon",
  "discovery.research.grounding": "Fundamentação com Google Search",
  "discovery.research.taskMode": "Cada envio cria uma tarefa auditável",
  "discovery.research.conversation": "Conversa com o agente fiscal",
  "discovery.research.operator": "Solicitação do operador",
  "discovery.research.agent": "Agente de pesquisa",
  "discovery.research.noUrl": "Você não precisa colar uma URL para começar.",
  "discovery.research.emptyPrompt": "Escreva uma pergunta ou tarefa fiscal acima.",
  "discovery.research.waitingAnswer":
    "O agente está processando a tarefa e guardará a resposta aqui.",
  "discovery.research.resultReady":
    "A síntese ficou abaixo; revise as citações antes de propor uma alteração.",
  "discovery.research.chatHint":
    "A resposta, as citações oficiais e os links para evidências aparecerão aqui quando terminar.",
  "discovery.research.launch": "Pesquisar com agente",
  "discovery.research.launchTask": "Enviar ao agente de pesquisa",
  "discovery.research.pending": "Pesquisando fontes oficiais…",
  "discovery.research.failed": "A pesquisa fiscal não foi concluída.",
  "discovery.research.summary": "Síntese do agente",
  "discovery.research.noSummary": "Ainda não há síntese disponível.",
  "discovery.research.candidates": "Resultados",
  "discovery.research.accepted": "Aceitos",
  "discovery.research.ingested": "Na evidência",
  "discovery.research.rejected": "Descartados",
  "discovery.research.citations": "Citações oficiais",
  "discovery.research.citationStatus.QUEUED": "Na fila de ingestão",
  "discovery.research.citationStatus.FETCHING": "Incorporando",
  "discovery.research.citationStatus.INGESTED": "Na evidência",
  "discovery.research.citationStatus.REJECTED": "Descartada",
  "discovery.research.rejectionReason": "Motivo do descarte: {reason}",
  "discovery.research.noCitations": "Nenhuma citação oficial foi aceita para esta pesquisa.",
  "discovery.research.openSourceRun": "Abrir execução",
  "discovery.research.openEvidence": "Abrir evidência",
  "discovery.research.disclaimer":
    "A síntese e as citações não alteram regras nem alíquotas. A evidência precisa ser revisada antes de qualquer proposta.",
  "discovery.research.execution": "Execução da tarefa",
  "discovery.research.step.request": "Tarefa persistida",
  "discovery.research.step.requestHint":
    "A solicitação fica guardada no Tax Platform com correlação e idempotência.",
  "discovery.research.step.vertex": "Pesquisa do agente",
  "discovery.research.step.vertexHint": "O agente recebe a consulta e busca nas fontes oficiais.",
  "discovery.research.step.grounding": "Fontes e citações",
  "discovery.research.step.groundingHint":
    "As citações são filtradas pelo registro de fontes autorizadas e seguem para o pipeline de evidências.",
  "discovery.research.step.review": "Revisão humana",
  "discovery.research.step.reviewHint":
    "Uma pessoa precisa revisar a evidência antes de criar uma proposta ou alterar regras.",
  "discovery.research.step.done": "Concluído",
  "discovery.research.step.active": "Em andamento",
  "discovery.research.step.pending": "Pendente",
  "discovery.research.step.failed": "Falhou",
  "discovery.research.error.VERTEX_QUOTA": "A cota do Vertex se esgotou (HTTP 429).",
  "discovery.research.error.VERTEX_UNAVAILABLE":
    "O Vertex estava indisponível (HTTP 408, 425 ou 5xx).",
  "discovery.research.error.VERTEX_TIMEOUT": "A pesquisa no Vertex excedeu o tempo limite.",
  "discovery.research.error.VERTEX_NETWORK": "A conexão com o Vertex falhou.",
  "discovery.research.error.VERTEX_OUTPUT_BUDGET":
    "A resposta do Vertex estourou o limite de tokens de saída.",
  "discovery.research.error.VERTEX_BLOCKED":
    "O Vertex bloqueou a resposta (segurança ou recitação).",
  "discovery.research.error.VERTEX_REJECTED": "O Vertex recusou o pedido de pesquisa.",
  "discovery.research.error.VERTEX_INVALID_RESPONSE": "O Vertex devolveu uma resposta inválida.",
  "discovery.research.error.RUNTIME_UNAVAILABLE": "O registro da tarefa ainda não está disponível.",
  "discovery.research.error.CITATION_DISPATCH_FAILED":
    "Não foi possível enviar as citações para a fila de evidências.",
  "discovery.research.error.INTERNAL_ERROR": "A pesquisa fiscal falhou por um erro interno.",
  "discovery.research.error.retryable": "Será tentada novamente automaticamente.",
  "discovery.research.taskId": "ID da tarefa",
  "discovery.research.requestId": "ID da solicitação do provedor",
  "discovery.research.searchQueries": "Consultas executadas",
  "discovery.research.trace": "Ver rastreabilidade técnica",
  "discovery.research.history": "Histórico de pesquisas do agente",
  "discovery.query": "O que buscar",
  "discovery.placeholder": "ICMS SP papelaria, NCM 84713012, MVA MG…",
  "discovery.sources": "Fontes oficiais correspondentes",
  "discovery.noSources": "Nenhuma fonte oficial autorizada corresponde a esta consulta.",
  "discovery.needQuery": "Digite uma pergunta fiscal com pelo menos 3 caracteres.",
  "discovery.needSource": "Selecione ao menos uma fonte ativa.",
  "discovery.needReason":
    "A justificativa fica no registro de auditoria. Use pelo menos 10 caracteres.",
  "discovery.excluded":
    "PIS, COFINS e ISS ficam fora desta base. A busca não inventa alíquota e não dispara fonte.",
  "discovery.reasonHint": "Registre o motivo da busca para a equipe.",
  "discovery.launch": "Lançar extração",
  "discovery.harvest": "Evidências extraídas para esta consulta",
  "discovery.openEvidence": "Abrir",
  "discovery.awaitingFigure": "Selecione uma evidência da fila para consultar seu recorte.",
  "discovery.timelineEmpty": "As fontes escolhidas aparecem aqui quando a consulta fecha.",
  "discovery.idle": "Sem execução",
  "discovery.ncmChip": "NCM {ncm}",
  "discovery.disclaimer":
    "Os documentos recebidos seguem para revisão antes de qualquer proposta de regra.",
  "discovery.figure.note":
    "Recorte do documento armazenado. Abra a fonte para consultar a publicação.",
  "discovery.figure.unavailable": "Figura oficial indisponível",
  "discovery.figure.noHost": "host oficial",
  "discovery.figure.emptyExcerpt": "O extrator ainda não devolveu texto deste artefato.",
  "discovery.harvestNew": "desta corrida",
  "discovery.harvestKnown": "já na fila",
  "discovery.findings.claim": "O que a fonte afirma",
  "discovery.findings.vigencia": "Vigência",
  "discovery.findings.pending": "Pendências",
  "discovery.findings.noDate": "O artefato não trouxe data de vigência",
  "discovery.findings.needsTriage": "Ainda não triada",
  "discovery.findings.noRate": "Nenhuma alíquota foi copiada",
  "discovery.maxDocuments": "No máximo {count} documentos por fonte.",
  "discovery.retryPending": "Repetir fontes pendentes",
  "discovery.accepted": "{source}: execução recebida ({id}).",
  "discovery.dispatchFailed":
    "{source}: não foi possível confirmar o pedido. As execuções aceitas continuam.",
  "discovery.linkDisclosure": "Extrair dados fiscais de uma URL",
  "discovery.linkTitle": "Extrair dados de um link oficial",
  "discovery.linkHint":
    "Informe a URL de uma fonte revisada. O sistema preserva o documento, extrai candidatos fiscais e aguarda a aprovação humana.",
  "discovery.linkFlow": "Fluxo da extração fiscal por URL",
  "discovery.linkFlow.url": "URL",
  "discovery.linkFlow.evidence": "Evidência",
  "discovery.linkFlow.candidate": "Candidato",
  "discovery.linkFlow.approval": "Aprovação",
  "discovery.linkSource": "Fonte revisada",
  "discovery.linkSelectSource": "Selecione uma fonte revisada",
  "discovery.linkUrl": "URL oficial",
  "discovery.linkSubmit": "Extrair dados fiscais",
  "discovery.linkNeedSource": "Selecione uma fonte revisada.",
  "discovery.linkNeedUrl": "Informe o link oficial revisado.",
  "discovery.linkInvalidUrl": "Informe um link HTTPS válido.",
  "discovery.linkHttps": "O link deve usar HTTPS.",
  "discovery.linkNeedReason": "A justificativa deve ter pelo menos 10 caracteres.",
  "discovery.linkFailed": "O link direcionado não foi aceito.",
  "discovery.linkAccepted": "URL aceita. Extração fiscal em andamento.",
  "discovery.linkProgress": "Progresso da extração por URL",
  "discovery.linkProgressHint":
    "Quando o documento chegar, abra a evidência para revisar os candidatos e criar uma proposta.",
  "discovery.linkCandidateReady": "candidato disponível",
  "discovery.linkWaiting": "A execução está buscando e normalizando o documento oficial…",
  "discovery.linkNoDocuments":
    "A execução terminou sem documentos. Abra os detalhes para investigar.",
  "discovery.linkOpenRun": "Abrir execução",
  "discovery.runUnavailable": "Estado indisponível",
  "discovery.receipts.created": "Documento novo",
  "discovery.receipts.reused": "Já guardado",
  "discovery.receipts": "Documentos da execução {source}",
  "discovery.receipts.hasMore": "Há mais documentos nesta execução.",
  "discovery.receipts.endedEmpty": "Esta execução foi encerrada sem documentos recebidos.",
  "discovery.failedDocuments": "{count} documentos com falha",
  "discovery.receipts.empty": "Esta execução ainda não devolveu documentos.",
  "discovery.counts": "{created} criados · {reused} reutilizados",
  "discovery.reusedNotRate": "Documento reutilizado. Não é alíquota aprovada nem regra publicada.",

  "audit.empty.title": "Nenhum evento ainda",
  "audit.empty.body": "Cada decisão, publicação e execução gera um evento imutável.",
  "audit.access.roleRequired":
    "A auditoria pertence ao módulo Desenvolvedores. É necessário um perfil de desenvolvedor fiscal ou de superadministrador autorizado.",
  "audit.title": "Auditoria",
  "audit.description":
    "Registro imutável de decisões: quem fez, quando, sobre qual recurso e com qual correlação.",
  "audit.column.when": "Quando",
  "audit.column.actor": "Autor da ação",
  "audit.column.action": "Ação",
  "audit.column.resource": "Recurso",
  "audit.column.correlation": "Correlação",
  "audit.filter.actor": "Autor",
  "audit.filter.action": "Ação",
  "audit.action.EVIDENCE_APPROVED": "Evidência aprovada",
  "audit.action.EVIDENCE_REJECTED": "Evidência recusada",
  "audit.action.EVIDENCE_BULK_REVIEWED": "Evidências revisadas em lote",
  "audit.action.PROPOSAL_CREATED": "Proposta criada",
  "audit.action.PROPOSAL_APPROVED": "Proposta aprovada",
  "audit.action.PROPOSAL_REJECTED": "Proposta recusada",
  "audit.action.RULESET_PUBLISHED": "Conjunto publicado",
  "audit.action.RULESET_ROLLED_BACK": "Conjunto revertido",
  "audit.action.SOURCE_RUN_TRIGGERED": "Coleta iniciada",
  "audit.action.SOURCE_PAUSED": "Fonte pausada",
  "audit.action.DLQ_REPLAYED": "Falhas pendentes reprocessadas",
  "audit.action.CALCULATION_EXPORTED": "Cálculo exportado",
  "audit.immutable": "Somente leitura. Entradas de auditoria não podem ser editadas nem apagadas.",
  "audit.detail.title": "Evento de auditoria",
  "audit.detail.notFound": "Este evento não está no registro.",
  "audit.detail.notFound.body":
    "O detalhe só mostra o evento imutável. Volte à lista para procurar por ação, autor ou correlação.",
  /* Auditoria — readable resource labels and record byline (UX plan PR 5). */
  "audit.detail.byline": "{actor} · {when}",
  "audit.detail.technical": "Identificadores técnicos",
  "audit.resource.evidence": "Documento",
  "audit.resource.evidence_documents": "Documentos",
  "audit.resource.evidence_task": "Tarefa de documento",
  "audit.resource.fiscal_task": "Tarefa fiscal",
  "audit.resource.rule_proposal": "Proposta",
  "audit.resource.proposal": "Proposta",
  "audit.resource.ruleset": "Publicação",
  "audit.resource.rule": "Regra",
  "audit.resource.source": "Fonte",
  "audit.resource.calculation": "Cálculo",
  "audit.resource.principal": "Usuário",
  "audit.resource.principal_allowlist": "Convite de usuário",
  "audit.resource.tax_integration_key": "Chave de API",
  "audit.resource.ncm_catalog": "Catálogo NCM",
  "audit.resource.cest_catalog": "Catálogo CEST",
  "audit.action.admin-command.requested": "Comando administrativo solicitado",
  "audit.action.admin-command.dispatched": "Comando administrativo enviado",
  "audit.action.admin-command.dispatch-failed": "Falha ao enviar comando administrativo",
  "audit.action.browser-agent.credentials-updated": "Credenciais do agente IOB atualizadas",
  "audit.action.browser-agent.demo-created": "Demonstração do agente gravada",
  "audit.action.browser-agent.demo-deleted": "Demonstração do agente excluída",
  "audit.action.browser-agent.settings-updated": "Configurações do agente IOB atualizadas",
  "audit.action.browser-agent.stop-requested": "Parada do agente IOB solicitada",
  "audit.action.browser-agent.task-created": "Tarefa do agente IOB criada",
  "audit.action.browser-agent.task-pause": "Tarefa do agente IOB pausada",
  "audit.action.browser-agent.task-resume": "Tarefa do agente IOB retomada",
  "audit.action.browser-agent.task-cancel": "Tarefa do agente IOB cancelada",
  "audit.action.browser-agent.task-move-up": "Tarefa do agente IOB movida para cima",
  "audit.action.browser-agent.task-move-down": "Tarefa do agente IOB movida para baixo",
  "audit.action.browser-agent.task-move-to-front":
    "Tarefa do agente IOB movida para o início da fila",
  "audit.action.calculation.completed": "Cálculo concluído",
  "audit.action.evidence-task.assigned": "Tarefa de documento atribuída",
  "audit.action.evidence-task.created": "Tarefa de documento criada",
  "audit.action.evidence-task.status-changed": "Situação da tarefa de documento alterada",
  "audit.action.evidence-task.updated": "Tarefa de documento atualizada",
  "audit.action.evidence.artifact-read": "Arquivo original do documento consultado",
  "audit.action.evidence.bulk-reviewed": "Documentos revisados em lote",
  "audit.action.evidence.normalized-ingested": "Documento coletado",
  "audit.action.evidence.normalized-reused": "Documento reaproveitado",
  "audit.action.evidence.reviewed": "Documento revisado",
  "audit.action.fiscal-facts.revoked": "Fato fiscal revogado",
  "audit.action.fiscal-facts.settings-updated": "Configurações de fatos fiscais atualizadas",
  "audit.action.fiscal-research-citation.stale-update-ignored":
    "Atualização antiga de citação ignorada",
  "audit.action.fiscal-research-citation.updated": "Citação da pesquisa atualizada",
  "audit.action.fiscal-research.dispatch-failed": "Falha ao enviar pesquisa fiscal",
  "audit.action.fiscal-research.dispatch-retry-requested":
    "Novo envio da pesquisa fiscal solicitado",
  "audit.action.fiscal-research.dispatch-retry-updated": "Novo envio da pesquisa fiscal atualizado",
  "audit.action.fiscal-research.dispatched": "Pesquisa fiscal enviada",
  "audit.action.fiscal-research.requested": "Pesquisa fiscal solicitada",
  "audit.action.fiscal-research.research-retry-updated":
    "Nova tentativa da pesquisa fiscal atualizada",
  "audit.action.fiscal-research.retry-restarted": "Pesquisa fiscal reiniciada",
  "audit.action.fiscal-research.stale-update-ignored": "Atualização antiga da pesquisa ignorada",
  "audit.action.fiscal-research.updated": "Pesquisa fiscal atualizada",
  "audit.action.fiscal-task.cancel-requested": "Cancelamento de tarefa fiscal solicitado",
  "audit.action.fiscal-task.cancelled": "Tarefa fiscal cancelada",
  "audit.action.fiscal-task.chunk-completed": "Parte da tarefa fiscal concluída",
  "audit.action.fiscal-task.completed": "Tarefa fiscal concluída",
  "audit.action.fiscal-task.created": "Tarefa fiscal criada",
  "audit.action.fiscal-task.failed": "Tarefa fiscal falhou",
  "audit.action.fiscal-task.requeued": "Tarefa fiscal colocada de novo na fila",
  "audit.action.fiscal-task.retry-resolved": "Nova tentativa da tarefa fiscal resolvida",
  "audit.action.fiscal-task.retry-scheduled": "Nova tentativa da tarefa fiscal agendada",
  "audit.action.integration-key.created": "Chave de API criada",
  "audit.action.integration-key.revoked": "Chave de API revogada",
  "audit.action.integration-key.rotated": "Chave de API rotacionada",
  "audit.action.principal.allowlist.created": "Convite de usuário criado",
  "audit.action.principal.allowlist.updated": "Convite de usuário atualizado",
  "audit.action.principal.updated": "Usuário atualizado",
  "audit.action.rule-proposal.created": "Proposta criada",
  "audit.action.rule-proposal.approved": "Proposta aprovada",
  "audit.action.rule-proposal.rejected": "Proposta rejeitada",
  "audit.action.ruleset.policy-changed": "Política de cálculo alterada",
  "audit.action.ruleset.published": "Conjunto de regras publicado",
  "audit.action.ruleset.rolled-back": "Conjunto de regras revertido",
  "audit.action.source-run.cancellation-requested": "Encerramento de execução solicitado",
  "audit.action.source-run.stale-cancelled": "Execução estagnada encerrada",
  "audit.action.source-run.worker-updated": "Execução da fonte atualizada",
  "audit.action.source.paused": "Fonte pausada",
  "audit.action.source.resumed": "Fonte retomada",
  "audit.action.tax-lookup-job.submitted": "Consulta fiscal enviada",
  "audit.action.web-research.settings-updated": "Configurações da pesquisa web atualizadas",
  "audit.action.web-research.sweep-created": "Varredura de pesquisa web criada",
  "audit.action.EVIDENCE_TASK_ASSIGNED": "Tarefa de documento atribuída",
  "audit.action.EVIDENCE_TASK_CREATED": "Tarefa de documento criada",
  "audit.action.EVIDENCE_TASK_STATUS_CHANGED": "Situação da tarefa de documento alterada",
  "audit.action.EVIDENCE_TASK_UPDATED": "Tarefa de documento atualizada",
  "audit.action.FISCAL_TASK_CANCEL_REQUESTED": "Cancelamento de tarefa fiscal solicitado",
  "audit.action.FISCAL_TASK_CREATED": "Tarefa fiscal criada",
  "audit.action.FISCAL_TASK_REQUEUED": "Tarefa fiscal colocada de novo na fila",
  "audit.resource.admin_command": "Comando administrativo",
  "audit.resource.browser_agent_credentials": "Credenciais do agente IOB",
  "audit.resource.browser_agent_demo": "Demonstração do agente",
  "audit.resource.browser_agent_run": "Execução do agente IOB",
  "audit.resource.browser_agent_settings": "Configurações do agente IOB",
  "audit.resource.browser_agent_task": "Tarefa do agente IOB",
  "audit.resource.coverage_gap": "Lacuna de cobertura",
  "audit.resource.evidence_artifact": "Arquivo do documento",
  "audit.resource.fiscal_fact": "Fato fiscal",
  "audit.resource.fiscal_facts_settings": "Configurações de fatos fiscais",
  "audit.resource.fiscal_research_citation": "Citação de pesquisa",
  "audit.resource.fiscal_research_task": "Pesquisa fiscal",
  "audit.resource.source_run": "Execução da fonte",
  "audit.resource.tax_lookup_job": "Consulta fiscal",
  "audit.resource.web_research_settings": "Configurações da pesquisa web",
  "audit.resource.web_research_sweep": "Varredura de pesquisa web",
  "audit.column.actorId": "Identidade",
  "audit.column.request": "Pedido",
  "audit.column.reason": "Motivo",

  "legal.title": "Dados da empresa",
  "legal.description":
    "Identidade cadastral da BackChannel. Não é uma alíquota publicada e não substitui um conjunto de regras.",
  "legal.section.entity": "Entidade legal da plataforma",
  "legal.entity.hint": "Identidade cadastral da BackChannel. Não é uma alíquota publicada.",
  "legal.entity.legalName": "Razão social",
  "legal.entity.tradeName": "Nome fantasia",
  "legal.entity.cnpj": "CNPJ",
  "legal.entity.status": "Situação cadastral",
  "legal.entity.status.active": "Ativa",
  "legal.entity.nature": "Natureza jurídica",
  "legal.entity.registeredAddress": "Endereço no cadastro da Receita",
  "legal.entity.commercialOffice": "Escritório comercial",
  "legal.entity.simples": "Simples Nacional",
  "legal.entity.simples.badge": "Fora do Simples",
  "legal.entity.simples.excluded":
    "Fora do Simples Nacional: sócio pessoa jurídica no QSA (LC 123/2006 art. 3º, §4º, I). Não calculamos alíquota DAS.",
  "legal.entity.federalRegime": "Regime federal de apuração",
  "legal.entity.federalRegime.unaccredited":
    "O cadastro da Receita não comprova o regime PIS/COFINS. A política confirmada pela contabilidade, quando registrada, aparece nesta página.",
  "legal.entity.notice":
    "Este quadro identifica a empresa. Não calcula imposto e não substitui um conjunto de regras publicado.",
  "legal.entity.uf": "UF",
  "legal.entity.cnae": "CNAE principal",
  "settings.title": "Perfil",
  "settings.description": "Seu nome, idioma e passkeys neste espaço.",
  "users.title": "Usuários",
  "users.description":
    "Convide operadores, escolha o perfil e o idioma, e reenvie o e-mail de configuração.",
  "users.missingOrganization":
    "Esta conta não tem organização, então convites não podem ser criados.",
  "settings.passkeys.title": "Passkeys",
  "settings.passkeys.description":
    "Cadastre uma passkey só para Operações Fiscais. Ela não substitui a passkey do Internal Tool.",
  "settings.passkeys.add": "Adicionar passkey",
  "settings.passkeys.adding": "Aguardando o autenticador…",
  "settings.passkeys.remove": "Revogar",
  "settings.passkeys.loading": "Carregando passkeys…",
  "settings.passkeys.empty": "Nenhuma passkey cadastrada neste espaço fiscal.",
  "settings.passkeys.added": "Passkey cadastrada. Use-a na próxima entrada.",
  "settings.passkeys.removed": "Passkey revogada.",
  "settings.passkeys.error": "Não foi possível atualizar as passkeys. Tente novamente.",
  "settings.passkeys.unsupported": "Este navegador não oferece passkeys.",
  "settings.passkeys.hostHint":
    "Cadastre passkeys em tax.backchannel.com.br ou no localhost da API local.",
  "settings.passkeys.hostHintDeployed": "Cadastre passkeys em tax.backchannel.com.br.",
  "settings.passkeys.created": "Criada em {date}",
  "settings.passkeys.lastUsed": "Último uso {date}",
  "settings.passkeys.neverUsed": "ainda não usada",
  "settings.apiBase": "Origem da API",
  "settings.buildInfo": "Build",
  "settings.technical.summary": "Mostrar detalhes técnicos",
  "settings.technical.identity": "Detalhes de identidade",
  "settings.principalId": "ID principal",
  "settings.organizationScopes": "Escopo da organização",
  "settings.tokenPresent": "Token disponível",
  "settings.expiresIn": "Expira em",
  "settings.bulkCap": "Limite de triagem em lote",
  "settings.access.inviteError":
    "Não foi possível concluir o convite. O usuário pendente pode já existir. Feche o painel e confira a lista antes de tentar novamente; use Reenviar convite se ele já aparecer.",
  "settings.access.editHelp":
    "As alterações se aplicam ao acesso do usuário. O reenvio usa o último perfil e idioma salvos.",
  "settings.access.search": "Nome, e-mail ou perfil",
  "settings.access.noMatches": "Nenhum usuário corresponde à busca.",
  "settings.access.inviteHelp":
    "Escolha um perfil e um idioma. A pessoa recebe um link seguro para configurar a conta.",
  "settings.access.resent": "Convite reenviado. O link anterior não funciona mais.",
  "settings.access.resendError":
    "Não foi possível reenviar o convite. Tente novamente; o envio não foi confirmado.",
  "settings.access.title": "Acesso ao espaço fiscal",
  "settings.access.hint": "Gerencie perfis e acesso às contas",
  "settings.access.new": "Convidar usuário",
  "settings.access.description":
    "Crie contas, envie convites por e-mail e escolha o idioma do convite. Só o superadministrador vê este módulo.",
  "settings.access.singleEnvironment":
    "Espaço controlado único: os escopos são limitados à organização selecionada e cada alteração gera auditoria.",
  "settings.access.tableCaption": "Principais autorizados e convites pendentes",
  "settings.access.email": "E-mail",
  "settings.access.status": "Situação",
  "settings.access.role": "Perfil",
  "settings.access.role.platformAdmin": "Superadministrador",
  "settings.access.role.taxOperator": "Gestor fiscal",
  "settings.access.role.superAdmin": "Superadministrador",
  "settings.access.role.taxManager": "Gestor fiscal",
  "settings.access.role.taxCommercial": "Comercial",
  "settings.access.commercialRoleHint":
    "Calculadora, lotes e consulta e envio de notas fiscais da sua organização. Sem revisão ou publicação fiscal.",
  "settings.access.role.taxReader": "Leitor fiscal",
  "settings.access.role.taxDeveloper": "Desenvolvedor fiscal",
  "settings.access.origin": "Origem",
  "settings.access.origin.googleAuto": "Google (automático)",
  "settings.access.origin.manual": "Cadastro manual",
  "settings.access.origin.invite": "Convite",
  "settings.access.origin.googleLinked": "Google vinculado",
  "settings.access.readerUntilPromoted": "Leitor até ser promovido",
  "settings.access.googleAutoNotice":
    "Criado automaticamente no primeiro login com Google, como Leitor. Altere o perfil para promovê-lo (por exemplo, Gestor fiscal, Desenvolvedor fiscal ou Superadministrador).",
  "settings.access.locale": "Idioma do convite",
  "settings.access.localeHint": "O convite e a configuração da conta chegam neste idioma.",
  "settings.access.resendInvite": "Reenviar convite",
  "settings.access.superAdminRoleHint": "Acesso completo, inclusive Usuários e Developers.",
  "settings.access.managerRoleHint":
    "Consulta fiscal, calculadora, lotes e fontes. Não vê Usuários nem Developers.",
  "settings.access.readerRoleHint":
    "Somente leitura. Não executa cálculos, publicações nem ingestão.",
  "settings.access.developerRoleHint":
    "Chaves de API, documentação do consumidor e ferramentas MCP. Não publica regras nem convida usuários.",
  "settings.access.permissionsCount": "Permissões",
  "settings.access.active": "Ativo",
  "settings.access.pending": "Convite pendente",
  "settings.access.inactive": "desativado",
  "settings.access.empty": "Nenhum acesso cadastrado.",
  "settings.access.edit": "Editar acesso",
  "settings.access.invite": "Convidar operador",
  "settings.access.displayName": "Nome de exibição",
  "settings.access.yourAreas": "Áreas disponíveis para você",
  "settings.access.activeToggle": "Permitir login neste espaço",
  "settings.access.permissions": "Permissões explícitas",
  "settings.access.permissionsHint":
    "As permissões são explícitas. Administradores da plataforma sempre mantêm a permissão de administrador.",
  "settings.access.adminRoleHint": "Acesso completo ao espaço e gestão da allowlist.",
  "settings.access.operatorRoleHint": "Acesso somente às áreas selecionadas abaixo.",
  "settings.access.preview": "Ver acessos",
  "settings.access.previewEyebrow": "Prévia segura de acesso",
  "settings.access.previewTitle": "O que este usuário pode ver",
  "settings.access.previewNotice":
    "Somente prévia. Sua sessão de administrador não muda e nenhuma ação é executada como este usuário.",
  "settings.access.previewInactive":
    "Este acesso está inativo ou pendente; todos os destinos permanecem indisponíveis até concluir o cadastro.",
  "settings.access.previewAllowed": "Disponível",
  "settings.access.previewDenied": "Indisponível",
  "settings.access.auditHint": "A ação será registrada na auditoria imutável.",
  "settings.access.createAccount": "Enviar convite",
  "settings.access.invited": "Conta criada. Confira o status do convite na lista de usuários.",
  "settings.access.saved":
    "Acesso atualizado. O usuário poderá entrar conforme as permissões atribuídas.",
  "settings.access.saveError":
    "Não foi possível salvar o acesso. Verifique os dados e tente novamente.",
  "settings.access.unavailableEdit":
    "A lista de acessos não está disponível. Aguarde a leitura ser concluída antes de editar.",

  "settings.integrations.title": "Chaves emitidas",
  "settings.integrations.hint": "Credenciais atribuíveis e com escopo",
  "settings.integrations.description":
    "Crie chaves individuais para sistemas autorizados. A organização, os fluxos e os escopos ficam vinculados à integração.",
  "settings.integrations.new": "Nova chave",
  "settings.integrations.currentOrganization": "Organização atual",
  "settings.integrations.tableCaption": "Chaves de integração registradas",
  "settings.integrations.empty": "Nenhuma chave de integração foi criada.",
  "settings.integrations.name": "Nome",
  "settings.integrations.owner": "Responsável",
  "settings.integrations.organization": "Organização",
  "settings.integrations.environment": "Ambiente",
  "settings.integrations.scopes": "Escopos",
  "settings.integrations.scope.READ_RULES": "Ler regras publicadas",
  "settings.integrations.scope.READ_RULES.description":
    "Consulte as regras governadas de uma versão fixada.",
  "settings.integrations.scope.READ_NCM_CATALOG": "Ler catálogo NCM",
  "settings.integrations.scope.READ_NCM_CATALOG.description":
    "Consulte a classificação e a procedência do NCM.",
  "settings.integrations.scope.CALCULATE": "Executar cálculos",
  "settings.integrations.scope.CALCULATE.description": "Envie lotes limitados ao motor fiscal.",
  "settings.integrations.scope.READ_CALCULATION": "Ler cálculos da integração",
  "settings.integrations.scope.READ_CALCULATION.description":
    "Consulte resultados criados por esta integração.",
  "settings.integrations.workflows": "Fluxos permitidos",
  "settings.integrations.expiry": "Expiração",
  "settings.integrations.lastUsed": "Último uso",
  "settings.integrations.status": "Situação",
  "settings.integrations.active": "Ativa",
  "settings.integrations.revoked": "Revogada",
  "settings.integrations.expired": "Expirada",
  "settings.integrations.created": "Criada",
  "settings.integrations.rotate": "Rotacionar",
  "settings.integrations.revoke": "Revogar",
  "settings.integrations.form.title": "Registrar chave de integração",
  "settings.integrations.form.nameHint": "Use um nome que identifique o sistema consumidor.",
  "settings.integrations.form.workflowHint":
    "Separe os IDs por vírgula. Pelo menos um fluxo é obrigatório.",
  "settings.integrations.form.scopeHint":
    "A chave só pode chamar operações dos escopos selecionados.",
  "settings.integrations.form.expiryDays": "Expira em (dias)",
  "settings.integrations.form.expiryHint": "Padrão: 30 dias · máximo: 90 dias.",
  "settings.integrations.form.reason": "Justificativa",
  "settings.integrations.form.reasonHint":
    "Mínimo de 10 caracteres. A justificativa entra na auditoria.",
  "settings.integrations.form.submit": "Criar chave",
  "settings.integrations.form.cancel": "Cancelar",
  "settings.integrations.form.overlap": "Sobreposição da rotação (horas)",
  "settings.integrations.form.overlapHint":
    "A chave anterior permanece válida por no máximo 24 horas.",
  "settings.integrations.form.secretTitle": "Guarde esta chave agora",
  "settings.integrations.form.secretNotice":
    "O segredo aparece uma única vez e não é salvo no console. Copie-o para o cofre do seu sistema antes de fechar.",
  "settings.integrations.form.secretReplay":
    "Esta foi uma repetição idempotente. Por segurança, o segredo não pode ser recuperado; crie uma rotação quando estiver pronto.",
  "settings.integrations.form.secretCopy": "Segredo da chave",
  "settings.integrations.form.secretClose": "Fechar e manter a cópia",
  "settings.integrations.form.secretDiscardTitle": "Descartar o segredo exibido?",
  "settings.integrations.form.secretDiscardBody":
    "Depois de fechar, o console não poderá mostrar este segredo novamente. Confirme somente depois de copiá-lo.",
  "settings.integrations.form.secretDiscard": "Fechar e descartar",
  "settings.integrations.form.secretKeep": "Voltar ao segredo",
  "settings.integrations.form.recovery":
    "Segredo indisponível nesta repetição. Rotacione a chave para emitir um novo segredo.",
  "settings.integrations.form.rotateTitle": "Rotacionar chave de integração",
  "settings.integrations.form.rotateBody":
    "Uma nova chave mantém os mesmos escopos e fluxos. A chave atual expira após a sobreposição escolhida.",
  "settings.integrations.form.revokeTitle": "Revogar chave de integração",
  "settings.integrations.form.revokeBody":
    "A revogação bloqueia novas requisições imediatamente e não pode ser desfeita.",
  "settings.integrations.form.confirmRevoke": "Confirmar revogação",
  "settings.integrations.action.success": "Alteração registrada e auditada.",
  "settings.integrations.action.error": "Não foi possível concluir a alteração. Tente novamente.",
  "settings.integrations.action.replay": "Requisição repetida: os metadados foram reapresentados.",
  "settings.integrations.more": "Escopos e detalhes",
  "settings.mcp.title": "Conexão MCP",
  "settings.mcp.hint": "Cinco operações para um cliente de IA com chave atribuível",
  "settings.mcp.description":
    "O servidor MCP responde em POST /v1/mcp. Configure seu cliente de IA (por exemplo, o Cursor) com a URL abaixo e o cabeçalho X-Tax-Api-Key. Ele consulta o conjunto publicado, o catálogo NCM e o cálculo em lote. Nunca use a sessão de um operador; tarefas fiscais e fontes ficam fora desta chave.",
  "settings.mcp.auth":
    "Cabeçalho X-Tax-Api-Key · escopos READ_RULES, READ_NCM_CATALOG, CALCULATE e READ_CALCULATION",
  "settings.mcp.config": "Exemplo de configuração MCP",
  "settings.mcp.tools": "Ferramentas",
  "settings.mcp.tool.current": "tax_current_ruleset",
  "settings.mcp.tool.current.body": "Versão publicada fixada para o cálculo.",
  "settings.mcp.tool.rules": "tax_lookup_rules",
  "settings.mcp.tool.rules.body":
    "Regras publicadas na rota origem → destino, com a versão do conjunto.",
  "settings.mcp.tool.ncm": "tax_ncm_catalog",
  "settings.mcp.tool.ncm.body": "Classificação Siscomex. Não é alíquota.",
  "settings.mcp.tool.batch": "tax_calculate_batch",
  "settings.mcp.tool.batch.body": "Aplica o conjunto publicado a um lote.",
  "settings.mcp.tool.calculation": "tax_get_calculation",
  "settings.mcp.tool.calculation.body": "Memória fiscal de um cálculo desta integração.",
  "settings.apiDocs.title": "Documentação para consumidores",
  "settings.apiDocs.hint": "Cinco operações governadas · exemplos prontos para copiar",
  "settings.apiDocs.description":
    "Use a chave no cabeçalho X-Tax-Api-Key. A chave nunca deve aparecer na URL, em query cache ou em logs.",
  "settings.apiDocs.baseUrl": "URL base da API deste espaço: {baseUrl}",
  "settings.apiDocs.auth": "Autenticação e escopos",
  "settings.apiDocs.scopes":
    "READ_RULES consulta regras publicadas; READ_NCM_CATALOG consulta classificação e procedência; CALCULATE envia lotes; READ_CALCULATION consulta resultados da própria integração.",
  "settings.apiDocs.requestIdentity":
    "Identidade da requisição: X-Tax-Attempt-Id é um UUID gerado pelo servidor para cada tentativa. X-Request-Id e X-Correlation-Id podem ser enviados pelo cliente e não são únicos; guarde os três IDs para suporte. O histórico inclui somente tentativas autenticadas nas cinco rotas de integração; 401 sem identidade e falhas do gateway não aparecem.",
  "settings.apiDocs.errors": "Erros",
  "settings.apiDocs.endpoints": "Referência de endpoints",
  "settings.apiDocs.requiredScope": "Escopo obrigatório",
  "settings.apiDocs.parameters": "Parâmetros",
  "settings.apiDocs.endpoint.current.parameters": "Nenhum.",
  "settings.apiDocs.endpoint.current.output":
    "Metadados do conjunto publicado atual: versão, versão da política, digest e horário de publicação.",
  "settings.apiDocs.endpoint.rules.parameters":
    "Consulta: rulesetVersion é obrigatório e deve ser PUBLISHED ou SUPERSEDED; cursor, limit (máximo 100) e q são opcionais.",
  "settings.apiDocs.endpoint.rules.output":
    "Uma página limitada dos payloads completos das regras, com validade, aplicabilidade NCM e procedência das evidências.",
  "settings.apiDocs.endpoint.ncm.parameters":
    "Consulta: cursor, limit (máximo 100) e q são opcionais.",
  "settings.apiDocs.endpoint.ncm.output":
    "Uma página limitada de classificação e procedência NCM. Não contém alíquotas.",
  "settings.apiDocs.endpoint.batch.parameters":
    "Cabeçalho: Idempotency-Key. Corpo JSON abaixo; um fluxo permitido e no máximo 500 itens.",
  "settings.apiDocs.endpoint.batch.output":
    "O resultado determinístico do cálculo armazenado, com o ID do cálculo e os resultados dos itens.",
  "settings.apiDocs.endpoint.calculation.parameters":
    "Rota: id é o UUID do cálculo retornado pela operação em lote.",
  "settings.apiDocs.endpoint.calculation.output":
    "O resultado somente quando o cálculo pertence a esta integração e organização.",
  "settings.apiDocs.error.400":
    "Requisição inválida: JSON malformado, rulesetVersion fixado ausente, campos inválidos ou limit acima de 100.",
  "settings.apiDocs.error.401":
    "X-Tax-Api-Key ausente, malformada, duplicada, expirada ou revogada, ou o responsável pela integração deixou de estar autorizado. Envie exatamente um cabeçalho.",
  "settings.apiDocs.error.403":
    "A chave não tem o escopo obrigatório ou o fluxo não está na lista permitida.",
  "settings.apiDocs.error.404":
    "O conjunto de regras ou o cálculo não existe, ou o cálculo pertence a outra integração.",
  "settings.apiDocs.error.409":
    "Não há conjunto publicado atual, ou o mesmo Idempotency-Key foi reutilizado com outro corpo. Mantenha a versão fixada e o corpo estáveis.",
  "settings.apiDocs.error.413": "A requisição JSON ultrapassa o limite de 5 MiB.",
  "settings.apiDocs.error.429":
    "A integração excedeu 120 leituras ou 10 lotes no minuto. Aguarde os segundos de Retry-After e repita o lote com o mesmo Idempotency-Key.",
  "settings.apiDocs.error.500":
    "Falha inesperada do serviço. Guarde os IDs de requisição e correlação; repita um lote somente com o mesmo Idempotency-Key.",
  "settings.apiDocs.ncm":
    "O catálogo NCM contém classificação e procedência. Ele não é uma tabela de alíquotas.",
  "settings.apiDocs.operations": "Operações",
  "settings.apiDocs.explorerHint":
    "Escolha uma operação para ver o contrato e um exemplo seguro de requisição.",
  "settings.apiDocs.path": "Rota",
  "settings.apiDocs.method": "Método",
  "settings.apiDocs.limits": "Limites",
  "settings.apiDocs.more": "Parâmetros, limites e erros",
  "settings.apiDocs.example": "Exemplo de requisição",
  "settings.apiDocs.copyExample": "Copiar exemplo",
  "settings.apiDocs.copyJson": "Copiar JSON",
  "settings.apiDocs.baseUrlLabel": "URL base da API",
  "settings.apiDocs.endpoint.current.name": "Conjunto publicado atual",
  "settings.apiDocs.endpoint.current.purpose":
    "Ler os metadados do conjunto de regras publicado atual.",
  "settings.apiDocs.endpoint.current.limits":
    "120 leituras por minuto por integração. Sem parâmetros de consulta.",
  "settings.apiDocs.endpoint.rules.name": "Regras publicadas",
  "settings.apiDocs.endpoint.rules.purpose":
    "Ler regras governadas de uma versão publicada ou substituída, sempre com a versão fixada.",
  "settings.apiDocs.endpoint.rules.limits":
    "120 leituras por minuto. rulesetVersion é obrigatório; limit é no máximo 100.",
  "settings.apiDocs.endpoint.ncm.name": "Catálogo NCM",
  "settings.apiDocs.endpoint.ncm.purpose":
    "Ler classificação e procedência NCM. Isto é um catálogo, não uma tabela de alíquotas.",
  "settings.apiDocs.endpoint.ncm.limits":
    "120 leituras por minuto. cursor, limit (máximo 100) e q são opcionais. O catálogo não contém alíquotas.",
  "settings.apiDocs.endpoint.batch.name": "Cálculo em lote",
  "settings.apiDocs.endpoint.batch.purpose":
    "Enviar um lote limitado de cálculo contra um fluxo permitido.",
  "settings.apiDocs.endpoint.batch.limits":
    "10 lotes por minuto. No máximo 500 itens e 5 MiB. Idempotency-Key é obrigatório.",
  "settings.apiDocs.endpoint.calculation.name": "Resultado do cálculo",
  "settings.apiDocs.endpoint.calculation.purpose":
    "Ler um cálculo criado por esta integração e organização.",
  "settings.apiDocs.endpoint.calculation.limits":
    "120 leituras por minuto. O cálculo deve pertencer a esta integração e organização.",
  "settings.apiDocs.batchJson": "Corpo da requisição: batch.json",
  "settings.developers.title": "Desenvolvedores",
  "settings.developers.description.integrations":
    "Crie e gerencie a chave individual de cada sistema integrado.",
  "settings.developers.description.api-docs":
    "Endpoints, formatos e exemplos para integrar sistemas à API fiscal.",
  "settings.developers.description.mcp":
    "Ferramentas que assistentes de IA podem usar com uma chave de integração.",
  "settings.developers.description.requests":
    "Diagnóstico seguro das requisições recentes feitas pelas integrações.",
  "settings.requests.title": "Requisições recentes",
  "settings.requests.hint": "Somente metadados · últimos 30 dias",
  "settings.requests.description":
    "Veja tentativas autenticadas das integrações para investigar status, duração e correlação sem expor credenciais ou conteúdo.",
  "settings.requests.demoNotice":
    "Demonstração local: estas linhas vêm de fixtures do mock e não representam registros reais.",
  "settings.requests.liveNotice":
    "O histórico é limitado aos últimos 30 dias e contém somente metadados da tentativa.",
  "settings.requests.authenticatedNotice":
    "Somente tentativas autenticadas nas cinco rotas de integração aceitas são registradas; 401 sem identidade e falhas do gateway não aparecem. Janela visível: últimos 30 dias.",
  "settings.requests.filter.status": "Status HTTP",
  "settings.requests.filter.statusHint": "Informe um status entre 100 e 599.",
  "settings.requests.filter.integration": "Integração",
  "settings.requests.filter.key": "Chave de integração",
  "settings.requests.filter.method": "Método",
  "settings.requests.filter.route": "Rota",
  "settings.requests.filter.problem": "Código do problema",
  "settings.requests.filter.all": "Todos",
  "settings.requests.filter.get": "GET",
  "settings.requests.filter.post": "POST",
  "settings.requests.filter.replayed": "Repetição idempotente",
  "settings.requests.filter.replayedOnly": "Somente repetidas",
  "settings.requests.filter.notReplayed": "Sem repetição",
  "settings.requests.column.when": "Quando",
  "settings.requests.column.operation": "Operação",
  "settings.requests.column.status": "Status HTTP",
  "settings.requests.column.duration": "Duração",
  "settings.requests.column.integration": "Integração",
  "settings.requests.column.key": "Chave",
  "settings.requests.column.replay": "Repetição",
  "settings.requests.replayed": "Sim",
  "settings.requests.notReplayed": "Não",
  "settings.requests.tableCaption": "Requisições de integração dos últimos 30 dias",
  "settings.requests.empty.title": "Nenhuma requisição recente",
  "settings.requests.empty.body":
    "Não há tentativas que correspondam aos filtros nesta janela de 30 dias.",
  "settings.requests.details.title": "Detalhes da requisição",
  "settings.requests.details.notice":
    "Somente metadados. O UUID da tentativa no servidor identifica esta tentativa registrada; requestId e correlationId podem ser enviados pelo cliente e são opcionais. Nenhuma chave, corpo, query string ou stack trace é exibido.",
  "settings.requests.details.attemptId": "UUID da tentativa no servidor",
  "settings.requests.details.organization": "Organização",
  "settings.requests.details.integration": "ID da integração",
  "settings.requests.details.key": "ID da chave",
  "settings.requests.details.environment": "Ambiente",
  "settings.requests.details.method": "Método",
  "settings.requests.details.route": "Rota",
  "settings.requests.details.when": "Quando",
  "settings.requests.details.duration": "Duração",
  "settings.requests.details.status": "Status HTTP",
  "settings.requests.details.problem": "Código do problema",
  "settings.requests.details.requestId": "requestId",
  "settings.requests.details.correlationId": "correlationId",
  "settings.requests.details.replay": "Repetição idempotente",
  "settings.requests.details.available": "Disponível",
  "settings.requests.details.unavailable": "Não disponível",
  "settings.requests.details.cause": "Causa",
  "settings.requests.details.diagnostic": "Diagnóstico",
  "settings.requests.details.noCause": "Concluída sem código de problema",
  "settings.requests.details.nextStep": "Próximo passo",
  "settings.requests.details.nextStep.retryWrite":
    "Repita com a mesma chave de idempotência e guarde os IDs para o suporte.",
  "settings.requests.details.nextStep.retryRead":
    "Repita a requisição e guarde os IDs para o suporte se o erro do serviço continuar.",
  "settings.requests.details.nextStep.rateLimited":
    "Aguarde o valor Retry-After da resposta e repita a mesma operação idempotente.",
  "settings.requests.details.nextStep.permission":
    "Confira o escopo da chave de API e o fluxo permitido para esta integração.",
  "settings.requests.details.nextStep.validation":
    "Confira os parâmetros e o ambiente da requisição; depois tente novamente.",
  "settings.requests.details.nextStep.idempotency":
    "Reutilize a chave somente com o mesmo corpo ou envie o corpo alterado com uma nova chave de idempotência.",
  "settings.requests.details.nextStep.notFound":
    "Confira o ID do recurso ou a versão publicada do conjunto de regras.",
  "settings.requests.details.nextStep.check":
    "Confira o escopo, o fluxo e os parâmetros; depois tente novamente.",
  "settings.requests.details.nextStep.continue":
    "Nenhuma ação necessária. Guarde o UUID da tentativa para rastreabilidade.",
  "settings.requests.details.identifiers": "Identificadores",
  "settings.requests.details.more": "Mais metadados",
  "settings.requests.recordingDetails": "O que é registrado",
  "settings.requests.status.invalid": "O status deve estar entre 100 e 599.",
  "settings.requests.status.http": "HTTP {code}",

  "a11y.skipToContent": "Ir para o conteúdo principal",
  "a11y.breadcrumb": "Trilha de navegação",
  "a11y.mainLandmark": "Conteúdo principal",
  "a11y.routeAnnounce": "{title} carregado",
  "a11y.sortState": "ordenado {direction}",
  "a11y.rowActions": "Ações da linha",
  "a11y.drawerOpened": "Painel de detalhes aberto",
  "a11y.drawerClosed": "Painel de detalhes fechado",
  "a11y.statusLabel": "Situação: {label}",
  "status.evidence.NEW": "Novo",
  "status.evidence.IN_REVIEW": "Em revisão",
  "status.evidence.APPROVED": "Aprovado",
  "status.evidence.REJECTED": "Rejeitado",
  "status.evidence.DUPLICATE": "Duplicado",
  "status.proposal.DRAFT": "Rascunho",
  "status.proposal.PENDING_REVIEW": "Aguardando revisão",
  "status.proposal.APPROVED": "Aprovada",
  "status.proposal.REJECTED": "Rejeitada",
  "status.proposal.PUBLISHED": "Publicada",
  "status.ruleset.DRAFT": "Rascunho",
  "status.ruleset.PENDING_REVIEW": "Aguardando revisão",
  "status.ruleset.IN_REVIEW": "Em revisão",
  "status.ruleset.APPROVED": "Aprovado",
  "status.ruleset.PUBLISHED": "Publicado",
  "status.ruleset.SUPERSEDED": "Substituído",
  "status.ruleset.REJECTED": "Rejeitado",
  "status.source.ACTIVE": "Ativa",
  "status.source.PAUSED": "Pausada",
  "status.source.DEGRADED": "Degradada",
  "status.source.DISABLED": "Desativada",
  "status.run.QUEUED": "Na fila",
  "status.run.DISCOVERING": "Descobrindo",
  "status.run.FETCHING": "Baixando",
  "status.run.EXTRACTING": "Extraindo",
  "status.run.WAITING_REVIEW": "Aguardando revisão",
  "status.run.STALLED": "Travada",
  "status.run.SUCCEEDED": "Concluída",
  "status.run.PARTIAL": "Parcial",
  "status.run.FAILED": "Falhou",
  "status.run.CANCELLED": "Cancelada",
  "status.run.CREATED": "Criado",
  "status.run.REUSED": "Reaproveitado",
  "status.calculation.CALCULATED": "Calculado",
  "status.calculation.REVIEW_REQUIRED": "Requer revisão",
  "status.audit.ALLOWED": "Permitido",
  "status.audit.DENIED": "Negado",
  "a11y.keyboardHint": "Use {key} para abrir o item em foco.",

  "rules.guide.link": "Guia da matriz fiscal",
  "rules.guide.eyebrow": "Como ler uma rota",
  "rules.guide.title": "Matriz fiscal por produto e trajeto",
  "rules.guide.description":
    "Use esta página para entender quais fatos precisam coincidir antes de uma regra ICMS ou ICMS-ST entrar em revisão.",
  "rules.guide.back": "Voltar à consulta",
  "rules.guide.equationLabel": "A chave de leitura",
  "rules.guide.equationTitle": "Quatro fatos fecham o contexto da operação",
  "rules.guide.formula": "NCM × CEST × origem → destino",
  "rules.guide.equationAria": "Fluxo NCM, CEST, origem, destino e resultado de revisão",
  "rules.guide.equationNote":
    "A combinação encontra evidências aplicáveis. Ela não cria uma alíquota por si só: vigência, descrição legal, operação e proveniência ainda precisam ser conferidas.",
  "rules.guide.result.code": "REVISÃO",
  "rules.guide.variable.ncm.title": "Produto",
  "rules.guide.variable.ncm.detail": "Classificação NCM de 8 dígitos",
  "rules.guide.variable.cest.title": "Substituição",
  "rules.guide.variable.cest.detail": "CEST e descrição do item",
  "rules.guide.variable.origin.title": "Origem",
  "rules.guide.variable.origin.detail": "UF de saída da operação",
  "rules.guide.variable.destination.title": "Destino",
  "rules.guide.variable.destination.detail": "UF de chegada da operação",
  "rules.guide.variable.result.title": "Regra candidata",
  "rules.guide.variable.result.detail": "Evidência, vigência e revisão humana",
  "rules.guide.stepsTitle": "Como a matriz é aplicada",
  "rules.guide.stepsHint": "A ordem evita transformar classificação em imposto.",
  "rules.guide.step.1.title": "Classifique o produto",
  "rules.guide.step.1.detail":
    "Confirme o NCM oficial e preserve a descrição e a data da classificação.",
  "rules.guide.step.2.title": "Valide o CEST",
  "rules.guide.step.2.detail":
    "Relacione o CEST e a descrição legal; NCM sozinho não confirma ICMS-ST.",
  "rules.guide.step.3.title": "Defina a rota",
  "rules.guide.step.3.detail": "Informe origem, destino, tipo de operação e data do fato gerador.",
  "rules.guide.step.4.title": "Junte a legislação",
  "rules.guide.step.4.detail":
    "Procure RICMS, convênio, protocolo, MVA/PMPF e atos de alteração ou revogação.",
  "rules.guide.step.5.title": "Envie para revisão",
  "rules.guide.step.5.detail":
    "Só uma proposta aprovada e publicada pode ser usada como regra executável.",
  "rules.guide.matrixTitle": "O que cada campo responde",
  "rules.guide.matrixHint": "A tabela orienta a investigação; não substitui a fonte oficial.",
  "rules.guide.matrixAria": "Matriz de fatos fiscais",
  "rules.guide.matrix.variable": "Campo",
  "rules.guide.matrix.question": "Pergunta",
  "rules.guide.matrix.output": "Saída esperada",
  "rules.guide.matrix.ncm.variable": "NCM",
  "rules.guide.matrix.ncm.question": "Que mercadoria é esta, exatamente?",
  "rules.guide.matrix.ncm.output": "Código e descrição oficial; não uma alíquota.",
  "rules.guide.matrix.cest.variable": "CEST",
  "rules.guide.matrix.cest.question": "Há item e descrição de ST compatíveis?",
  "rules.guide.matrix.cest.output": "Catálogo e aplicabilidade a confirmar na legislação.",
  "rules.guide.matrix.origin.variable": "Origem",
  "rules.guide.matrix.origin.question": "De qual UF parte a operação?",
  "rules.guide.matrix.origin.output": "Alíquota interestadual e benefícios de saída a investigar.",
  "rules.guide.matrix.destination.variable": "Destino",
  "rules.guide.matrix.destination.question": "Para qual UF e tipo de destinatário?",
  "rules.guide.matrix.destination.output": "Alíquota interna, protocolo e exceções a conferir.",
  "rules.guide.matrix.result.variable": "Resultado",
  "rules.guide.matrix.result.question": "Existe evidência suficiente e vigente?",
  "rules.guide.matrix.result.output": "Candidato, revisão necessária ou regra publicada.",
  "rules.guide.routes.column.detail": "O que muda",
  "rules.guide.routesTitle": "Rotas prioritárias",
  "rules.guide.routesHint": "O estado de distribuição e o destino mudam a pesquisa jurídica.",
  "rules.guide.route.esSp.name": "ES → SP",
  "rules.guide.route.esSp.status": "Prioridade P0",
  "rules.guide.route.esSp.detail":
    "Cruzar GETRI, ST, MVA/CEST de ES com a legislação de destino de SP.",
  "rules.guide.route.spSp.name": "SP → SP",
  "rules.guide.route.spSp.status": "Prioridade P0",
  "rules.guide.route.spSp.detail":
    "Verificar RICMS, Portarias SRE, vigência e revogações dentro de SP.",
  "rules.guide.route.rj.name": "SP/ES → RJ",
  "rules.guide.route.rj.status": "Fonte bloqueada",
  "rules.guide.route.rj.detail":
    "A fonte oficial de RJ precisa estar acessível antes de propor uma regra para essa rota.",
  "rules.guide.sourcesTitle": "Fontes para começar",
  "rules.guide.sourcesHint": "Abra a fonte e guarde URL, ato, vigência e trecho usado.",
  "rules.guide.source.ncm.title": "Receita Federal · Classif",
  "rules.guide.source.ncm.detail": "NCM, notas legais e histórico de classificação.",
  "rules.guide.source.cest.title": "CONFAZ · Convênio 142/18",
  "rules.guide.source.cest.detail": "Catálogo CEST de referência; não prova incidência sozinho.",
  "rules.guide.source.es.title": "SEFAZ-ES · MVA/PMPF/PCF/PMC",
  "rules.guide.source.es.detail": "Parâmetros e atos estaduais para ST em ES.",
  "rules.guide.source.sp.title": "SEFAZ-SP · Portaria SRE 12/2026",
  "rules.guide.source.sp.detail": "NCM, CEST, IVA-ST e condições de vigência em SP.",
  "rules.guide.guardrailTitle": "Regra de segurança",
  "rules.guide.guardrailBody":
    "NCM e CEST são identificadores de referência. Não copie uma taxa de uma fonte genérica nem trate um CEST como prova automática de ST.",
  "rules.guide.guardrailNote":
    "Quando faltar NCM, CEST, UF, data ou fundamento legal, o resultado fica em revisão fiscal.",
  "rules.guide.openLookup": "Abrir consulta por NCM e rota",
  "errors.PERMISSION_DENIED": "Você não tem permissão para esta operação.",
  "errors.UNAUTHENTICATED": "Sessão ausente ou expirada.",
  "errors.SEPARATION_OF_DUTIES_VIOLATION": "Já existe uma decisão sua nesta proposta.",
  "errors.VERSION_PRECONDITION_FAILED": "O registro mudou desde o carregamento. Recarregue.",
  "errors.IDEMPOTENCY_KEY_REUSED": "Esta tentativa já foi usada com dados diferentes.",
  "errors.RULESET_STALE_BASE": "A base da minuta está desatualizada.",
  "errors.BATCH_TOO_LARGE": "Lote acima do limite permitido.",
  "errors.RATE_LIMITED": "Muitas requisições. Aguarde e tente novamente.",
  "errors.DEPENDENCY_UNAVAILABLE": "Uma dependência do serviço está indisponível.",
  "errors.ARTIFACT_UNAVAILABLE": "O documento de evidência armazenado está indisponível.",
  "errors.OPERATION_NOT_AVAILABLE": "Esta operação não está habilitada neste espaço.",
  "errors.NOT_FOUND": "Registro não encontrado.",
  "errors.NO_PUBLISHED_RULESET": "Não há um conjunto de regras publicado.",
  "errors.VALIDATION_FAILED": "Dados inválidos na requisição.",
  "errors.ENVIRONMENT_MISMATCH": "Contexto da requisição diferente do serviço.",
  "errors.INTERNAL_ERROR": "Erro interno do serviço.",
  "errors.NETWORK": "Falha de rede ao contatar a API.",
  "errors.TIMEOUT": "A API demorou demais para responder.",
  "errors.GATEWAY_TIMEOUT": "O servidor passou do tempo limite.",
  "errors.UNEXPECTED_RESPONSE": "A resposta do servidor veio em formato inesperado.",
  "failure.offline.what": "Você está sem conexão com a internet.",
  "failure.offline.todo": "Reconecte e tente novamente. Nada foi enviado.",
  "failure.network.what": "Não foi possível falar com a API fiscal.",
  "failure.network.todo": "Verifique sua conexão ou VPN e tente novamente.",
  "failure.timeout.what": "A API demorou demais para responder.",
  "failure.timeout.todo":
    "Aguarde um instante e tente novamente. Operações longas continuam no servidor.",
  "failure.gatewayTimeout.what": "O servidor passou do tempo limite ao processar.",
  "failure.gatewayTimeout.todo":
    "Tente novamente em instantes. Se for um lote grande, divida o arquivo.",
  "failure.unavailable.what": "Um serviço necessário está indisponível no momento.",
  "failure.unavailable.todo":
    "Tente novamente em alguns instantes. Se persistir, fale com o suporte e informe o código de suporte, se houver.",
  "failure.notAvailable.what": "Esta operação não está disponível neste ambiente.",
  "failure.notAvailable.todo": "Use outra opção ou peça a um administrador para habilitá-la.",
  "failure.rateLimited.what": "Muitas requisições em pouco tempo.",
  "failure.rateLimited.todo": "Aguarde alguns segundos e tente novamente.",
  "failure.inProgress.what": "Esta operação ainda está em andamento.",
  "failure.inProgress.todo": "Aguarde alguns segundos e confira de novo; não é preciso reenviar.",
  "failure.validation.what": "Alguns dados não foram aceitos.",
  "failure.validation.todo": "Corrija os campos ou o arquivo indicado e envie de novo.",
  "failure.unauthenticated.what": "Sua sessão expirou.",
  "failure.unauthenticated.todo": "Entre novamente e repita a ação.",
  "failure.forbidden.what": "Você não tem permissão para esta ação.",
  "failure.forbidden.todo":
    "Peça acesso a um administrador e informe o código de suporte, se houver.",
  "failure.notFound.what": "O registro não foi encontrado.",
  "failure.notFound.todo": "Ele pode ter sido removido. Volte à lista e abra de novo.",
  "failure.conflict.what": "O registro mudou enquanto você trabalhava.",
  "failure.conflict.todo": "Recarregue a página para ver a versão atual e repita a ação.",
  "failure.tooLarge.what": "O arquivo ou lote é maior que o limite aceito.",
  "failure.tooLarge.todo": "Divida a planilha em arquivos menores e envie de novo.",
  "failure.server.what": "O servidor encontrou um erro inesperado.",
  "failure.server.todo":
    "Tente novamente. Se persistir, fale com o suporte e informe o código de suporte, se houver.",
  "failure.unexpected.what": "A resposta do servidor veio em formato inesperado.",
  "failure.unexpected.todo":
    "Tente novamente. Se persistir, atualize a página ou fale com o suporte e informe o código de suporte, se houver.",
  "failure.committed.what": "Pode ter sido concluído — confira antes de repetir.",
  "failure.committed.todo":
    "A resposta não chegou a tempo. Verifique em Lotes se o item já existe antes de enviar de novo, para não duplicar.",
  "failure.verifying": "Pode ter sido concluído — verificando…",
  "failure.verifyingBody":
    "A resposta demorou, mas o servidor pode ter terminado. Estamos confirmando sem duplicar nada.",
  "failure.supportId": "Código para o suporte: {id}",
  "failure.openLots": "Verificar em Lotes",
  "failure.longRunning":
    "Operações longas continuam no servidor: você pode sair desta tela e retomar depois em Lotes.",
  "calc.boundary.title": "A calculadora parou de responder",
  "calc.boundary.body":
    "Esta tela encontrou um erro inesperado e nada foi salvo por ela. Recarregue a tela; se persistir, informe o código ao suporte.",
  "calc.boundary.reload": "Recarregar a tela",
  "calc.boundary.home": "Voltar ao início",
  "errors.notFoundRoute": "Página não encontrada.",
  "errors.notFoundBody": "A rota solicitada não existe ou não está disponível neste espaço.",
  "errors.unexpectedTitle": "A operação foi interrompida",
  "errors.unexpectedBody":
    "O console encontrou um erro inesperado. Tente novamente ou volte para a visão geral; nenhuma alteração foi confirmada.",
  "legacy.band.excellent": "Excelente",
  "legacy.band.healthy": "Saudável",
  "legacy.band.fair": "Justa",
  "legacy.band.critical": "Crítica",
  "legacy.yes": "Sim",
  "legacy.no": "Não",
  "legacy.blocked": "Cálculo bloqueado",
  "legacy.wf.title": "Waterfall do CMV — 12 passos",
  "legacy.wf.benchmark": "Referência: Mondial_BackChannel_VFinal_9_EN.xlsx",
  "legacy.wf.entry": "Valor do item com ICMS/PIS/COFINS",
  "legacy.wf.icmsEmbedded": "↳ ICMS embutido (NF × {rate} bruto)",
  "legacy.wf.pisEmbedded": "↳ PIS embutido ((NF − {own}) × 1,65%)",
  "legacy.wf.cofinsEmbedded": "↳ COFINS embutido ((NF − {own}) × 7,6%)",
  "legacy.wf.purchaseValue": "Valor final de compra",
  "legacy.wf.icmsCreditClosed": "(−) Crédito de ICMS [∅ Caso A — cadeia ST fechada]",
  "legacy.wf.icmsCredit": "(−) Crédito de ICMS [NF × {rate} bruto]",
  "legacy.wf.pisCredit": "(−) Crédito de PIS [(NF − {own}) × 1,65%]",
  "legacy.wf.cofinsCredit": "(−) Crédito de COFINS [(NF − {own}) × 7,6%]",
  "legacy.wf.totalCredits": "(−) Créditos totais",
  "legacy.wf.fiscalCMV": "CMV fiscal",
  "legacy.wf.salePriceZero": "Preço de venda (markup 0% — repasse do custo)",
  "legacy.wf.salePrice": "Preço de venda ({markup}% de margem sobre a venda ÷ {rest}%)",
  "legacy.wf.freightRevenue": "(+) Frete cobrado do comprador",
  "legacy.wf.bcIcms": "↳ BC ICMS = venda + frete = {value}",
  "legacy.wf.icmsSaleClosed": "(−) ICMS na venda [∅ cadeia ST fechada]",
  "legacy.wf.icmsSale": "(−) ICMS na venda (BC_ICMS × {rate}%)",
  "legacy.wf.pisSale": "(−) PIS na venda [(BC_ICMS − ICMS) × 1,65%] base {base}",
  "legacy.wf.cofinsSale": "(−) COFINS na venda [(BC_ICMS − ICMS) × 7,6%]",
  "legacy.wf.protocol": "Protocolo ST ({route}): {status}",
  "legacy.wf.protocolClosed": "FECHADO",
  "legacy.wf.protocolOpen": "ABERTO — crédito de ICMS aplica",
  "legacy.wf.difal": "(−) DIFAL ({uf} destino)",
  "legacy.wf.fcp": "(−) FCP ({uf})",
  "legacy.wf.logistics": "(−) Logística (custo do transportador)",
  "legacy.wf.freightCost": "(−) Custo logístico do frete",
  "legacy.wf.commission": "(−) Comissão",
  "legacy.wf.paymentFee": "(−) Tarifa de pagamento ({fee})",
  "legacy.wf.marginValue": "Margem",
  "legacy.ncm.missing":
    "NCM não encontrado na tabela fiscal da calculadora anterior. Cálculo automático bloqueado; revise manualmente.",
  "legacy.ncm.found": "{description} · CEST {cest} · IPI {ipi}% · IVA {iva}% · ST em SP: {st}",
  "legacy.buyerInfo":
    "O regime do comprador não entra nos tributos de saída da BCH; apenas define se o DIFAL se aplica.",
  "legacy.difal.applies":
    "DIFAL interestadual se aplica. UF destino {uf}: {base}% + FCP {fcp}% = {total}% sobre o preço de venda BCH.",
  "legacy.getnet.mdr": "MDR Getnet",
  "legacy.getnet.anticipation": "Antecipação ({n}× × 1,59%)",
  "legacy.getnet.effective": "Taxa efetiva",
  "legacy.getnet.contract": "Tabela Getnet do contrato 3313293 (Tabela 2).",
  "legacy.boleto.total": "{n} boleto(s) × {fee} = {total}",
  "legacy.pix.free": "PIX sem tarifa no acordo B2B atual da BCH (R$ 0,00 / 0,00%).",
  "legacy.result.salePrice": "Preço de venda (NF saída)",
  "legacy.result.difal": "DIFAL + FCP (UF destino)",
  "legacy.result.marginPct": "Margem %",
  "legacy.st.caseA": "Caso A",
  "legacy.st.caseB": "Caso B",
  "legacy.st.paidBySupplier": "ICMS-ST pago pelo fornecedor (conferir com a NF)",
  "legacy.st.payableByBch": "ICMS-ST a pagar pela BCH",
  "legacy.st.adjusted": "MVA ajustada",
  "legacy.st.base": "base ST",
  "legacy.st.creditClosed": "Crédito de ICMS = R$ 0,00 (cadeia ST fechada)",
  "legacy.st.creditOpen": "Crédito de ICMS = {value} (cadeia aberta)",
  "legacy.ipi.gross": "Base IPI bruta (padrão Mondial): {base} × {rate}% = {value}",
  "legacy.ipi.net": "Base IPI líquida (legado): {base} × {rate}% = {value}",
  "legacy.v15Fields": "Campos v15: NF, antecipação e repasse",
  "legacy.spReimbursement": "Ressarcimento de ICMS-ST SP pendente: {value}",
  "legacy.memory": "Memória de cálculo",
  "legacy.memoryGenerated": "Gerada em {at}",
  "legacy.bestCenter": "Melhor centro: {center}",
  "legacy.serviceResult.cm1": "CM1 / GMV",
  "legacy.int.pl": "P&L — Intermediação",
  "legacy.int.gmv": "GMV (total da NF)",
  "legacy.int.serviceValue": "Valor do serviço (taxa de intermediação)",
  "legacy.int.irrf": "(−) IRRF retido",
  "legacy.int.csll": "(−) CSLL retida",
  "legacy.int.cofins": "(−) COFINS retida",
  "legacy.int.pis": "(−) PIS retido",
  "legacy.int.netCash": "(=) Líquido a receber",
  "legacy.int.valueForMargin": "(=) Valor para margem",
  "legacy.int.operations": "(−) Operações",
  "legacy.int.cm1": "(=) CM1 (antes de comissões)",
  "legacy.int.approved": "Aprovado para vender",
  "legacy.int.notApproved": "Não aprovado (< 8%)",
  "legacy.int.sellerUF": "UF do vendedor",
  "legacy.int.buyerUF": "UF do comprador",
  "legacy.int.sellerTerms": "Condição — vendedor",
  "legacy.int.buyerTerms": "Condição — comprador",
  "legacy.int.ownPis": "PIS próprio",
  "legacy.int.ownCofins": "COFINS próprio",
  "legacy.int.revenueTaxes": "Tributos sobre a receita",
  "legacy.int.withholdingTotal": "Retenção total",
  "legacy.int.cashFlow": "Fluxo de caixa — obrigações a recolher",
  "legacy.int.ownPisCofins": "PIS + COFINS próprios",
  "legacy.int.onService": "6,15% sobre o serviço",
  "legacy.terms.Upfront": "À vista",
  "legacy.terms.30": "30 dias",
  "legacy.terms.60": "60 dias",
  "legacy.terms.90": "90 dias",
  "legacy.batch.noDefaults": "sem padrão",
  "legacy.batch.commission": "{pct}% comissão",
  "legacy.batch.exportReport": "Exportar relatório (formato v8 original)",
  "legacy.batch.route": "NCM / UF",
  "legacy.batch.purchase": "= Compra",
  "legacy.batch.saleTaxes": "Imp. saída",
  "legacy.batch.profit": "Lucro",
  "legacy.batch.total": "Total ({count} linhas)",
  "legacy.batch.kpi.revenue": "Receita total",
  "legacy.batch.kpi.profit": "Lucro líquido",
  "legacy.batch.kpi.margin": "Margem média",
  "legacy.batch.kpi.critical": "Zona crítica",
  "legacy.batch.kpi.products": "{count} produto(s)",
  "legacy.batch.kpi.review": "{count} em revisão",
  "legacy.batch.kpi.merch": "Compra/venda (mercadoria) · {count}",
  "legacy.batch.kpi.int": "Intermediação (GMV × taxa de intermediação) · {count}",
  "legacy.batch.showWaterfall": "Ver waterfall",
  "legacy.batch.hideWaterfall": "Ocultar waterfall",
  "legacy.option.ecommerce": "Comércio eletrônico",
  "legacy.wf.ipiGross": "(+) IPI ({rate}% bruta)",
  "legacy.wf.ipiNet": "(+) IPI ({rate}% líquida)",
  "legacy.wf.icmsStPaid": "(+) ICMS-ST pago pelo fornecedor",
  "legacy.wf.icmsStAnticipation": "(+) Antecipação ICMS-ST entrada (RICMS/SP Art. 426-A)",
  "legacy.wf.icmsStPayable": "(+) ICMS-ST a pagar pela BCH",
  "legacy.wf.feeBoleto": "Boleto ×{n}",
  "legacy.wf.feePix": "PIX",
  "legacy.wf.protocolNa": "N/A",
  "legacy.wf.feeGetnet": "Getnet {pct}%",
  "legacy.alert.OPERATION_DATE_MISSING.info":
    "Sem data da operação: usando hoje. Parâmetros por data podem ser diferentes.",
  "legacy.alert.NCM_MISSING.error": "O NCM é obrigatório para o cálculo automático.",
  "legacy.alert.NCM_NOT_IN_TABLE.error":
    "NCM {ncm} não está na tabela de parâmetros fiscais. Revisão manual necessária.",
  "legacy.alert.CEST_MISSING.warning": "O NCM {ncm} exige CEST, mas nenhum está configurado.",
  "legacy.alert.CEST_MISSING.error":
    "O NCM {ncm} tem CEST pendente de confirmação (VALIDAR). O cálculo fica bloqueado até o fiscal/jurídico confirmar o CEST.",
  "legacy.alert.ST_REVOKED_BY_PORTARIA.info": "ST de SP revogada para este CEST: {detail}",
  "legacy.alert.ST_EVIDENCE_MISSING.error":
    "ST marcado como pago sem valor informado (DQ-01). Cálculo bloqueado.",
  "legacy.alert.ST_EVIDENCE_MISSING.warning":
    "ST marcado como pago sem valor do fornecedor. Usando R$ 0 — confira manualmente.",
  "legacy.alert.ST_COLLECTED.warning":
    "ST já cobrado: ICMS-ST = R$ 0 · crédito de ICMS = R$ 0 · débito de ICMS na saída = R$ 0",
  "legacy.alert.CALCULATION_DEVIATION.error":
    "O markup deve ser menor que 100% (recebido {pct}%). Cálculo bloqueado.",
  "legacy.alert.ST_PROTOCOL_REVOKED.info": "Protocolo SP→{uf}: {detail}. Sem ST na NF da BCH.",
  "legacy.alert.ICMS_DOUBLE_TAX.error":
    "Débito de ICMS na saída > 0 com ST já cobrado: dupla tributação detectada.",
  "legacy.alert.ST_PROTOCOL_VERIFY.warning":
    "Protocolo de ST SP → {uf}: precisa de verificação no CONFAZ.",
  "legacy.batch.supplierOther": "Outro fornecedor (sem configuração)",
  "legacy.batch.kind.int": "INT",
  "legacy.batch.kind.resale": "C/V",
  "legacy.batch.takeIss": "Taxa {take}% · ISS {iss}%",
  "legacy.batch.gmv": "GMV {value}",
  "legacy.batch.kpi.intSplit": "GMV {gmv} · CM1 {cm1} · {pct}",
  "legacy.ncm.pRedBC": "pRedBC {pct}%",
  "overview.home.eyebrow": "Visão geral",
  "overview.home.title": "Calcule e acompanhe seus lotes",
  "overview.home.description":
    "Calculadora, regras publicadas e o histórico de cada lote em um só lugar.",
  "overview.home.cta.eyebrow": "Calcular",
  "overview.home.cta.title": "Calculadora fiscal",
  "overview.home.cta.body": "Calcule um produto pelo NCM ou envie uma planilha com o lote inteiro.",
  "overview.home.cta.upload": "Enviar planilha",
  "overview.home.cta.single": "Calcular um produto",
  "overview.home.cta.ncmLabel": "NCM (8 dígitos)",
  "overview.home.cta.ncmPlaceholder": "Ex.: 8471.30.12",
  "overview.home.cta.ncmSubmit": "Calcular",
  "overview.home.cta.ncmInvalid": "Informe os 8 dígitos do NCM.",
  "overview.home.cta.readerTitle": "Consultar regra por NCM",
  "overview.home.cta.readerBody":
    "Seu perfil é de leitura. Consulte a regra publicada para um NCM e rota.",
  "overview.home.cta.readerSubmit": "Consultar",
  "overview.home.rules.eyebrow": "Regras publicadas",
  "overview.home.rules.count": "regras fiscais vigentes",
  "overview.home.rules.ncms": "{count} NCMs",
  "overview.home.rules.routes": "{count} rotas UF → UF",
  "overview.home.rules.st": "{count} com ICMS-ST",
  "overview.home.rules.expiring": "{count} vencem em 30 dias",
  "overview.home.rules.version": "Versão {version} · publicada em {date}",
  "overview.home.rules.coverage": "Cobertura por família",
  "overview.home.rules.openLibrary": "Ver todas as regras",
  "overview.home.rules.openCoverage": "Ver cobertura por UF",
  "overview.home.rules.none": "Ainda não há um conjunto de regras publicado.",
  "overview.home.new.eyebrow": "Novas regras",
  "overview.home.new.title": "O que mudou na versão {version}",
  "overview.home.new.since": "Comparado com {from} · publicada {relative}",
  "overview.home.new.sinceDate": "Comparado com {from} · última publicação em {date}",
  "overview.home.new.added": "Nova",
  "overview.home.new.changed": "Alterada",
  "overview.home.new.addedCount": "+{count} novas",
  "overview.home.new.changedCount": "{count} alteradas",
  "overview.home.new.removedCount": "−{count} removidas",
  "overview.home.new.national": "Nacional",
  "overview.home.new.validFrom": "vigente desde {date}",
  "overview.home.new.more.one": "Ver mais {count} mudança",
  "overview.home.new.more.other": "Ver mais {count} mudanças",
  "overview.home.new.openDiff": "Ver diferenças completas",
  "overview.home.new.openHistory": "Histórico de publicações",
  "overview.home.new.empty": "Nenhuma regra nova ou alterada nesta versão.",
  "overview.home.new.noBaseline": "Esta é a primeira versão publicada; não há base para comparar.",
  "overview.home.jobs.eyebrow": "Histórico de lotes",
  "overview.home.jobs.title": "Últimos lotes processados",
  "overview.home.jobs.items.one": "{count} item",
  "overview.home.jobs.items.other": "{count} itens",
  "overview.home.jobs.review": "{count} para revisão",
  "overview.home.jobs.single": "Cálculo individual",
  "overview.home.jobs.openAll": "Ver histórico completo",
  "overview.home.jobs.empty": "Nenhum lote processado nos últimos 30 dias.",
  "overview.home.jobs.emptyCta": "Enviar planilha",
  "overview.home.jobs.origin.LOT_UPLOAD": "Planilha",
  "overview.home.jobs.origin.FISCAL_TASK": "Tarefa fiscal",
  "overview.home.jobs.origin.CALCULATOR": "Calculadora",
  "overview.home.jobs.origin.INTEGRATION": "Integração",
  "overview.home.jobs.origin.DYNAMIC_LIST": "Lista dinâmica",
  "overview.home.jobs.origin.RUNTIME": "Workflow automático",
  "overview.home.admin.title": "Operação da plataforma",
  "overview.home.admin.description": "Pendências de evidências, fontes, filas e atividade técnica.",
  /* -- UX PR 4: Início and Regras ---------------------------------------- */
  "overview.pulse.agent.trendLabel": "Achados por dia nos últimos {days} dias: {values}",
  "overview.pulse.agent.trend": "{count} achados em {days} dias",
  "overview.pulse.research.one": "varredura ativa",
  "overview.pulse.research.other": "varreduras ativas",
  "overview.pulse.research.lastDone": "Última concluída {when}",
  "overview.pulse.research.none": "Nenhuma varredura ainda",
  "overview.activity.denied": "negado",
  "home.title": "Início",
  "home.commercial.title": "Início comercial",
  "home.commercial.description": "Calcule uma operação, envie uma planilha ou confira suas notas.",
  "home.commercial.hero.context": "Compra → centro de operação → venda",
  "home.commercial.hero.title": "Da compra ao preço de venda, com um próximo passo claro.",
  "home.commercial.hero.description":
    "Declare a compra, a venda e os custos. Confira o resultado e as pendências da operação.",
  "home.commercial.hero.action": "Calcular nova operação",
  "home.commercial.priority.title": "Prioridade operacional",
  "home.commercial.priority.route": "Todas as UF, passando por São Paulo, para todas as UF.",
  "home.commercial.priority.description": "Fornecedor e cliente são definidos em cada operação.",
  "home.commercial.priority.next": "Espírito Santo fica para uma próxima fase.",
  "home.commercial.priority.qualification":
    "A prioridade operacional não certifica cobertura fiscal.",
  "home.commercial.destinations": "Acessos do trabalho comercial",
  "home.commercial.calculate.title": "Calculadora",
  "home.commercial.calculate.description": "Uma compra, uma venda e os custos declarados.",
  "home.commercial.calculate.action": "Simular operação",
  "home.commercial.calculate.readAction": "Abrir calculadora",
  "home.commercial.upload.title": "Lotes e planilhas",
  "home.commercial.upload.description":
    "Envie vários itens e acompanhe o processamento e a revisão de cada lote.",
  "home.commercial.lots.action": "Ver lotes",
  "home.commercial.invoices.help":
    "Consulte notas emitidas e recebidas e as análises disponíveis para a operação.",
  "home.commercial.invoices.title": "Notas fiscais",
  "home.commercial.invoices.action": "Abrir notas fiscais",
  "home.jobs.description":
    "Acompanhe os envios e abra um lote para conferir o resultado ou revisar pendências.",
  "home.jobs.loading": "Carregando os últimos lotes…",
  "home.jobs.empty":
    "Ainda não há lotes para mostrar. Depois do primeiro envio, acompanhe o andamento aqui.",
  "home.jobs.stale":
    "Não foi possível atualizar os lotes. A lista abaixo mostra a última consulta disponível.",
  "home.jobs.paused":
    "A atualização dos lotes está pausada. Você pode abrir Lotes e tentar novamente quando a conexão voltar.",
  "home.description": "Comece um cálculo, retome seus lotes e confira as regras em vigor.",
  "home.cta.body":
    "Digite o NCM para calcular um produto ou envie uma planilha com o lote inteiro.",
  "home.cta.ncmLabel": "NCM",
  "home.cta.ncmHint": "8 dígitos, no formato 0000.00.00.",
  "home.cta.or": "ou",
  "home.cta.openCalculator": "Abrir a calculadora completa",
  "home.rules.title": "Regras em vigor",
  "home.rules.inVersion": "regras no conjunto {version}",
  "home.rules.fiscalInVersion": "regras fiscais no conjunto {version}",
  "home.rules.published": "Publicado em {date}",
  "home.rules.byKind": "Por tipo de regra",
  "home.rules.fiscalFacts": "Nas regras fiscais",
  "home.rules.kindLink": "{kind}: {count} regras. Abrir na biblioteca",
  "home.rules.openLibrary": "Abrir biblioteca",
  "home.new.title": "Mudanças da versão",
  "home.new.versus": "comparado com {from}",
  "home.new.openTab": "Ver novas regras",
  "home.jobs.title": "Últimos lotes",
  "home.jobs.openAll": "Ver todos",
  "rules.new.tab": "Novas regras",
  "rules.new.title": "Novas regras",
  "rules.new.description":
    "O que entrou e o que mudou no conjunto em vigor, comparado com a versão anterior.",
  "rules.new.none.title": "Nada para comparar",
  "rules.new.rulesTitle": "Regras novas e alteradas",
  "rules.new.rulesHint": "Cada linha abre a regra publicada nesta versão.",
  "rules.new.noItems": "A lista por regra não está disponível; veja os campos alterados abaixo.",
  "rules.new.truncated.one":
    "Mostrando {shown} regras. Mais {count} mudança aparece nos campos alterados abaixo.",
  "rules.new.truncated.other":
    "Mostrando {shown} regras. Mais {count} mudanças aparecem nos campos alterados abaixo.",
  "rules.new.fieldsTitle": "Campos alterados",
  "rules.new.fieldsHint": "Diferença campo a campo entre as duas versões.",
  "rules.new.openRuleset": "Abrir publicação",
  "rules.help.short": "Guia",
  "rules.library.count.all.one": "{count} regra no conjunto {version}",
  "rules.library.count.all.other": "{count} regras no conjunto {version}",
  "rules.library.count.filtered": "{count} de {total} regras no conjunto {version}",
  "quick.chapters.title": "Ou navegue pelo catálogo por capítulo SH",
  "quick.chapters.body":
    "Escolha um capítulo para ver os produtos do catálogo Siscomex. O catálogo identifica a classificação; não é alíquota.",
  "quick.chapters.open": "Ver produtos do capítulo SH {chapter} · {title}",
  "quick.chapters.results": "Produtos do capítulo SH {chapter} · {title}",
  "quick.chapters.resultsBody": "Catálogo Siscomex. Escolha o NCM para ver as regras publicadas.",
  "quick.chapters.clear": "Remover o filtro do capítulo SH {chapter}",
  "quick.chapters.openRules": "Regras publicadas do capítulo {chapter}",
  "quick.value.ipiMissing": "Sem IPI publicado",
  "quick.fact.fromTipi": "TIPI nacional",
  "status.job.QUEUED": "Na fila",
  "status.job.RUNNING": "Em execução",
  "status.job.COMPLETED": "Concluído",
  "status.job.SUCCEEDED": "Concluído",
  "status.job.REVIEW_REQUIRED": "Requer revisão",
  "status.job.WAITING_REVIEW": "Requer revisão",
  "status.job.FAILED": "Falhou",
  "status.job.CANCELLED": "Cancelado",
  "nav.governance": "Governança",
  "nav.publications": "Publicações",
  "coverage.tab": "Cobertura",
  "coverage.title": "Cobertura por família e UF",
  "coverage.description":
    "O que a base publicada guarda por família fiscal e onde as regras se concentram no mapa.",
  "nav.jobs": "Histórico de lotes",
  "lots.title": "Lotes",
  "lots.description":
    "Acompanhe planilhas, cenários e pesquisas. Da origem à memória fiscal de cada linha.",
  "lots.status.reviewRows": "{count} linhas para revisar",
  "lots.filter.period": "Período",
  "lots.period.today": "Hoje",
  "lots.period.7d": "7 dias",
  "lots.period.30d": "30 dias",
  "lots.period.custom": "Personalizado",
  "lots.filter.from": "De",
  "lots.filter.to": "Até",
  "lots.filter.status": "Status",
  "lots.filter.origin": "Origem",
  "lots.filter.review": "Revisão",
  "lots.filter.reviewOnly": "Somente com revisão",
  "lots.filter.search": "Buscar",
  "lots.filter.placeholder": "Buscar por lote, ID ou integração",
  "lots.window.incomplete": "Escolha as duas datas do período personalizado.",
  "lots.window.order": "A data inicial precisa ser anterior à final.",
  "lots.window.tooLong": "O período pode ter no máximo 90 dias.",
  "lots.column.lot": "Lote / origem",
  "lots.column.submittedBy": "Enviado por",
  "lots.column.when": "Quando",
  "lots.column.status": "Status",
  "lots.column.items": "Itens",
  "lots.column.review": "Revisão",
  "lots.column.rulesetVersion": "Versão",
  "lots.column.correlation": "Correlação",
  "lots.column.taxTotal": "Imposto total",
  "lots.empty.title": "Nenhum lote neste período",
  "lots.empty.body": "Envie uma planilha ou amplie o período para ver execuções anteriores.",
  "lots.submitter.unrecorded": "Origem não registrada",
  "lots.batches": "{received} de {expected} partes recebidas",
  "lots.invalidRows": "{count} linhas inválidas",
  "lots.running": "Em cálculo",
  "lots.openJob": "Abrir detalhes de {name}",
  "lots.drawer.subtitle": "{origin} · enviado {relative}",
  "lots.drawer.exportCsv": "Exportar CSV",
  "lots.drawer.exportJson": "Exportar JSON",
  "lots.drawer.exporting": "Exportando {loaded} de {total} itens…",
  "lots.drawer.cancelExport": "Cancelar exportação",
  "lots.drawer.exportCancelled": "Exportação cancelada.",
  "lots.drawer.exportDone": "Arquivo pronto com {count} itens.",
  "lots.drawer.exportTruncated": "O arquivo parou em {cap} itens, o limite de exportação.",
  "lots.drawer.exportFailed": "Não foi possível exportar. Tente novamente.",
  "lots.drawer.openTask": "Abrir tarefa fiscal",
  "lots.drawer.openCalculation": "Abrir cálculo",
  "lots.drawer.downloadOriginal": "Baixar arquivo original",
  "lots.drawer.downloadFailed": "O arquivo original não está disponível.",
  "lots.drawer.notFound":
    "Este lote não aparece no período filtrado. Amplie o período para abri-lo.",
  "lots.drawer.notFoundTitle": "Lote fora do período",
  "lots.section.summary": "Resumo",
  "lots.section.items": "Itens devolvidos",
  "lots.section.origin": "Origem",
  "lots.section.trace": "Rastreabilidade",
  "lots.section.audit": "Eventos de auditoria",
  "lots.summary.submittedAt": "Enviado em",
  "lots.summary.startedAt": "Início",
  "lots.summary.completedAt": "Concluído em",
  "lots.summary.submittedBy": "Enviado por",
  "lots.summary.workflow": "Origem",
  "lots.summary.ruleset": "Versão das regras",
  "lots.summary.counts": "Itens",
  "lots.summary.countsValue":
    "{items} itens · {calculated} calculados · {review} para revisão · {rejected} rejeitados",
  "lots.summary.taxTotal": "Imposto total",
  "lots.summary.landed": "Custo fiscal total",
  "lots.summary.topIssues": "Principais pendências",
  "lots.summary.noIssues": "Nenhuma pendência registrada.",
  "lots.summary.notYet": "Disponível ao concluir",
  "lots.summary.partial":
    "Recebemos {received} de {expected} partes deste lote. Os totais somam apenas as partes recebidas.",
  "lots.summary.lastError": "Último erro",
  "lots.summary.invalid":
    "{count} de {total} linhas não passaram na validação. Corrija o arquivo e envie de novo.",
  "lots.summary.imported": "Arquivo importado e ainda não calculado.",
  "lots.items.position": "#",
  "lots.items.item": "Item / SKU",
  "lots.items.ncm": "NCM",
  "lots.items.route": "UF origem → destino",
  "lots.items.status": "Status",
  "lots.items.ipi": "IPI",
  "lots.items.icmsSt": "ICMS (ST ou próprio)",
  "lots.items.taxTotal": "Imposto total",
  "lots.items.landed": "Custo final",
  "lots.items.issues": "Pendências",
  "lots.items.actions": "Ações",
  "lots.items.empty": "Nenhum item devolvido ainda.",
  "lots.items.part": "Parte",
  "lots.items.more": "Mais itens",
  "lots.items.partOption": "Parte {index} de {count}",
  "lots.items.explain": "Explicar {item}",
  "lots.items.row": "Linha",
  "lots.items.rowValid": "Válida",
  "lots.items.rowErrors": "Erros",
  "lots.origin.filename": "Arquivo",
  "lots.origin.rows": "Linhas",
  "lots.origin.uploadedAt": "Importado em",
  "lots.origin.parser": "Leitor",
  "lots.origin.integration": "Integração",
  "lots.origin.attempts": "Tentativas da integração",
  "lots.origin.noAttempts":
    "Nenhuma tentativa registrada nos últimos 30 dias para esta correlação.",
  "lots.origin.attemptLine": "{method} {route} · {status} · {duration} ms",
  "lots.origin.replayed": "reaproveitada",
  "lots.origin.operator": "Enviado por {name} na plataforma.",
  "lots.origin.unrecorded": "Este cálculo é anterior ao registro de quem chamou a API.",
  "lots.trace.jobId": "ID do lote",
  "lots.trace.correlation": "ID de correlação",
  "lots.trace.request": "ID da requisição",
  "lots.trace.calculations": "Cálculos armazenados ({count})",
  "lots.trace.replayed": "Reaproveitado por idempotência",
  "lots.trace.sourceStatus": "Status armazenado",
  "lots.trace.moreIds": "e mais {count}",
  "lots.trace.workflow": "Fluxo (ID técnico)",
  "lots.origin.automatic": "Enviado automaticamente · {origin}.",
  "lots.trace.none": "Nenhum cálculo armazenado.",
  "lots.audit.empty": "Nenhum evento de auditoria para esta correlação.",
  "lots.audit.open": "Abrir na auditoria",
  "overview.home.jobs.origin.UNKNOWN": "Origem não registrada",
  "overview.home.new.icms.ST": "ICMS-ST",
  "overview.home.new.icms.STANDARD": "ICMS próprio",
  "overview.home.new.icms.NOT_TAXED": "Sem ICMS",
  "overview.home.new.noNcm": "Sem NCM",
  "overview.home.new.openRule": "Abrir regra {ncm}",
  "status.job.IMPORTED": "Importado",
  "status.job.INVALID": "Inválido",
  "status.job.PARTIAL": "Parcial",
  "settings.requests.details.openLot": "Ver lote",
  "nav.webResearch": "Pesquisa web",
  "agents.create.webHint": "Esta fila é só do IOB. Para pesquisa na web, use",
  "agents.create.webHintLink": "Pesquisa web",
  "webResearch.title": "Pesquisa web",
  "webResearch.description":
    "Planeje varreduras de fontes oficiais na web (SEFAZ, CONFAZ, Senado), acompanhe etapas, custo e documentos encontrados, e ajuste o ritmo da pesquisa.",
  "webResearch.new": "Nova pesquisa",
  "webResearch.tabs": "Seções da pesquisa web",
  "webResearch.tab.sweeps": "Pesquisas",
  "webResearch.tab.settings": "Configurações",
  "webResearch.boundary":
    "Anexos e achados são material de revisão. Nenhuma pesquisa aprova, publica ou calcula regras.",
  "webResearch.list.title": "Pesquisas",
  "webResearch.empty.title": "Nenhuma pesquisa web ainda",
  "webResearch.empty.body":
    "Crie uma pesquisa para localizar, baixar e extrair os anexos oficiais de ST por segmento e UF. A prévia mostra chamadas, custo e prazo antes de criar.",
  "webResearch.empty.infra":
    "A pesquisa web fica desligada até o serviço de execução ser ativado. Até lá, as pesquisas criadas ficam na fila e não gastam nada.",
  "webResearch.empty.action": "Planejar primeira pesquisa",
  "webResearch.lane.label": "Estado da pesquisa web",
  "webResearch.lane.PAUSED": "Pausada",
  "webResearch.lane.PAUSED.detail":
    "O interruptor geral está ligado: nenhuma unidade é entregue ao executor.",
  "webResearch.lane.RUNNING": "Executando",
  "webResearch.lane.RUNNING.detail":
    "Há pesquisa em andamento, dentro dos limites de ritmo e orçamento.",
  "webResearch.lane.WAITING": "Na fila",
  "webResearch.lane.WAITING.detail":
    "Há pesquisas aguardando o executor. Se nada começar, a infraestrutura ainda não foi ativada.",
  "webResearch.lane.IDLE": "Ociosa",
  "webResearch.lane.IDLE.detail": "Nenhuma pesquisa ativa.",
  "webResearch.lane.grounded": "Buscas",
  "webResearch.lane.extraction": "Extrações",
  "webResearch.lane.dailyCap": "Teto diário de buscas",
  "webResearch.lane.monthly": "Orçamento mensal",
  "webResearch.lane.infra":
    "A execução depende do serviço de pesquisa web estar ativado. Enquanto estiver desligado, as pesquisas são aceitas e ficam na fila, sem gastar nada.",
  "webResearch.perMinute": "{count}/min",
  "webResearch.status.QUEUED": "Na fila",
  "webResearch.status.RUNNING": "Executando",
  "webResearch.status.PAUSED": "Pausada",
  "webResearch.status.COMPLETED": "Concluída",
  "webResearch.status.CANCELLED": "Cancelada",
  "webResearch.status.BUDGET_EXHAUSTED": "Orçamento esgotado",
  "webResearch.scope.USED": "Usados",
  "webResearch.scope.USED.body":
    "NCMs e rotas que a BackChannel calculou no período. Cobre o que importa primeiro.",
  "webResearch.scope.USED.short": "Usados {days} d",
  "webResearch.scope.CATALOG": "Catálogo inteiro",
  "webResearch.scope.CATALOG.body":
    "NCMs ativos do catálogo oficial, opcionalmente só alguns capítulos.",
  "webResearch.scope.CATALOG.short": "Catálogo inteiro",
  "webResearch.scope.CATALOG.chapters.one": "Catálogo · {count} capítulo",
  "webResearch.scope.CATALOG.chapters.other": "Catálogo · {count} capítulos",
  "webResearch.scope.LIST": "Lista",
  "webResearch.scope.LIST.body": "Cole NCMs (até 10.000), um por linha ou separados por vírgula.",
  "webResearch.scope.LIST.short.one": "Lista de {count} NCM",
  "webResearch.scope.LIST.short.other": "Lista de {count} NCMs",
  "webResearch.routes.USED": "Rotas usadas",
  "webResearch.routes.USED.body": "Só as rotas origem → destino vistas em cálculos para cada NCM.",
  "webResearch.routes.USED.short": "rotas usadas",
  "webResearch.routes.ALL_DESTINATIONS": "Todas as UFs de destino",
  "webResearch.routes.ALL_DESTINATIONS.body":
    "As 27 UFs como destino; a origem não importa. Só com a estratégia Segmento.",
  "webResearch.routes.ALL_DESTINATIONS.short": "todas as UFs",
  "webResearch.routes.UF_ALL": "Todas de/para uma UF",
  "webResearch.routes.UF_ALL.body":
    "Cada rota que sai de, chega a, ou envolve uma UF (26 ou 52 rotas).",
  "webResearch.routes.UF_ALL.FROM": "saindo de {uf}",
  "webResearch.routes.UF_ALL.TO": "chegando em {uf}",
  "webResearch.routes.UF_ALL.BOTH": "de e para {uf}",
  "webResearch.routes.EXPLICIT": "Rotas explícitas",
  "webResearch.routes.EXPLICIT.body": "Escolha rota por rota (origem → destino).",
  "webResearch.routes.EXPLICIT.short.one": "{count} rota",
  "webResearch.routes.EXPLICIT.short.other": "{count} rotas",
  "webResearch.strategy.SEGMENT": "Segmento",
  "webResearch.strategy.SEGMENT.body":
    "Pesquisa onde a lei é escrita: um anexo por segmento × UF de destino cobre todos os NCMs daquele segmento. Muito mais barato.",
  "webResearch.strategy.PAIR": "Par",
  "webResearch.strategy.PAIR.body":
    "Verifica cada NCM × rota separadamente. Só para Lista ou Usados, até 2.000 unidades.",
  "webResearch.card.progress": "{percent} concluído",
  "webResearch.card.failed": "{count} com falha",
  "webResearch.detail.created": "Criada",
  "webResearch.detail.started": "Iniciada",
  "webResearch.detail.completed": "Encerrada",
  "webResearch.detail.queuedInfra":
    "Esta pesquisa ainda não começou. Ela roda quando o executor da pesquisa web estiver ativado; até lá não gasta nada.",
  "webResearch.detail.budgetExhausted":
    "A pesquisa parou no limite de chamadas ou orçamento. Unidades pendentes ficam como estão; crie outra pesquisa com limites maiores para continuar.",
  "webResearch.action.PAUSE": "Pausar",
  "webResearch.action.RESUME": "Retomar",
  "webResearch.action.CANCEL": "Cancelar pesquisa",
  "webResearch.action.RETRY_FAILED": "Reprocessar falhas",
  "webResearch.status.COMPLETED_WITH_FAILURES": "Concluída com falhas",
  "webResearch.action.RETRY_STALLED": "Baixar de novo",
  "webResearch.action.CLOSE": "Encerrar varredura",
  "webResearch.action.refetched":
    "Os downloads foram solicitados de novo. As unidades em espera retomam quando os documentos chegarem.",
  "webResearch.action.closed":
    "A varredura foi encerrada. O que ela encontrou continua disponível para revisão.",
  "webResearch.stalled.title": "Aguardando documentos",
  "webResearch.stalled.body":
    "Nada mais pode rodar: {count} unidades aguardam documentos que não foram baixados. Uma unidade falha sozinha assim que o download ou a leitura falha, ou {minutes} min após a solicitação do download (no máximo {hours} h). Baixe de novo ou encerre a varredura agora.",
  "webResearch.close.title": "Encerrar esta varredura?",
  "webResearch.close.body":
    "{count} unidades que ainda não rodaram são marcadas como falhas (encerradas por um operador) e a varredura é concluída. O que ela encontrou continua disponível para revisão, e Reprocessar falhas as reabre depois.",
  "webResearch.close.confirm": "Encerrar varredura",
  "webResearch.completion.ok": "Concluída: todas as unidades terminaram.",
  "webResearch.completion.closed": "Encerrada por um operador: todas as unidades tinham terminado.",
  "webResearch.outcome.title.one": "Concluída com 1 falha",
  "webResearch.outcome.title.other": "Concluída com {count} falhas",
  "webResearch.outcome.lead":
    "{finished} de {total} unidades terminaram ({percent}). O que foi encontrado já segue para revisão; as falhas abaixo não bloqueiam esse material.",
  "webResearch.outcome.leadOperator":
    "Encerrada por um operador: {finished} de {total} unidades tinham terminado ({percent}).",
  "webResearch.outcome.more": "+{count}",
  "webResearch.outcome.blockedDownloads.one": "download bloqueado pelo site oficial",
  "webResearch.outcome.blockedDownloads.other": "downloads bloqueados pelo site oficial",
  "webResearch.outcome.missingDownloads.one": "download não chegou",
  "webResearch.outcome.missingDownloads.other": "downloads não chegaram",
  "webResearch.outcome.noOfficialSource.one": "busca sem fonte oficial citada",
  "webResearch.outcome.noOfficialSource.other": "buscas sem fonte oficial citada",
  "webResearch.outcome.extraction.one": "leitura de documento rejeitada",
  "webResearch.outcome.extraction.other": "leituras de documento rejeitadas",
  "webResearch.outcome.providerLimits.one": "unidade parou em limite do provedor",
  "webResearch.outcome.providerLimits.other": "unidades pararam em limites do provedor",
  "webResearch.outcome.closedByOperator.one": "unidade encerrada antes de terminar",
  "webResearch.outcome.closedByOperator.other": "unidades encerradas antes de terminar",
  "webResearch.outcome.other.one": "outra falha",
  "webResearch.outcome.other.other": "outras falhas",
  "webResearch.outcome.next.blockedDownloads":
    "Reprocessar tenta de novo, o que resolve bloqueios temporários. Se persistir, cadastre ou revise uma fonte alternativa para essas UFs.",
  "webResearch.outcome.next.missingDownloads":
    "Costuma ser temporário: reprocessar solicita os downloads de novo.",
  "webResearch.outcome.next.noOfficialSource":
    "A busca não citou um host do catálogo de fontes. Revise as fontes dessas UFs; reprocessar busca de novo.",
  "webResearch.outcome.next.extraction":
    "A leitura não passou nas verificações; reprocessar lê o documento de novo. Se persistir, confira o documento na lista abaixo.",
  "webResearch.outcome.next.providerLimits":
    "Temporário: reprocessar recoloca na fila respeitando o ritmo configurado.",
  "webResearch.outcome.next.closedByOperator":
    "Reprocessar reabre a pesquisa e retoma essas unidades.",
  "webResearch.outcome.next.other": "Veja o erro de cada unidade na tabela abaixo.",
  "webResearch.outcome.partial":
    "UFs e hosts nomeados a partir das primeiras 200 unidades com falha; as contagens incluem todas.",
  "webResearch.outcome.retry.one": "Reprocessar 1 falha",
  "webResearch.outcome.retry.other": "Reprocessar {count} falhas",
  "webResearch.outcome.sources": "Fontes alternativas",
  "webResearch.error.FETCH_FAILED": "Não foi possível baixar ou ler o documento",
  "webResearch.error.FETCH_TIMEOUT": "O documento não chegou a tempo",
  "webResearch.error.NO_REVIEWED_SOURCE": "Nenhuma fonte revisada cobre esta unidade",
  "webResearch.error.CLOSED_BY_OPERATOR": "Varredura encerrada antes de esta unidade rodar",
  "webResearch.action.conflict":
    "A pesquisa mudou desde que você a abriu. Recarregamos o estado atual; confira e tente de novo.",
  "webResearch.action.error": "Não foi possível aplicar a ação. Tente novamente.",
  "webResearch.action.retried": "As unidades com falha voltaram para a fila.",
  "webResearch.cancel.title": "Cancelar esta pesquisa?",
  "webResearch.cancel.body":
    "Unidades pendentes e bloqueadas são puladas e a pesquisa não pode ser retomada. O que já foi encontrado continua disponível para revisão.",
  "webResearch.cancel.keep": "Manter",
  "webResearch.cancel.confirm": "Cancelar pesquisa",
  "webResearch.stages.title": "Etapas",
  "webResearch.stages.units": "{count} unidades",
  "webResearch.stages.none": "sem unidades",
  "webResearch.stages.error": "Não foi possível carregar o progresso por etapa.",
  "webResearch.stages.of": "de {total}",
  "webResearch.stages.open": "{count} em aberto",
  "webResearch.stages.closed": "nenhuma em aberto",
  "webResearch.stage.state.active": "Em andamento",
  "webResearch.stage.state.attention": "Com falhas",
  "webResearch.stage.state.done": "Concluída",
  "webResearch.stage.review": "Revisar",
  "webResearch.stage.review.unit": "leituras de anexo",
  "webResearch.stage.review.hint":
    "Os valores lidos entram como fatos não verificados; uma pessoa decide em Regras → Verificação.",
  "webResearch.stage.review.open": "Abrir Verificação",
  "webResearch.stage.locate": "Localizar",
  "webResearch.stage.locate.hint":
    "Busca na web os anexos por segmento × UF, convênios CONFAZ, alíquotas internas e a tabela interestadual.",
  "webResearch.stage.fetch": "Baixar",
  "webResearch.error.NO_OFFICIAL_CITATION": "Nenhuma fonte oficial citada",
  "webResearch.error.GROUNDED_RESPONSE_INVALID": "Resposta da busca inválida",
  "webResearch.error.PROVIDER_RATE_LIMITED": "Limite de buscas atingido",
  "webResearch.error.PROVIDER_UNAVAILABLE": "Serviço de busca indisponível",
  "webResearch.error.URL_NOT_ALLOWED": "Endereço fora das fontes permitidas",
  "webResearch.error.FETCH_ROBOTS_DENIED":
    "O site oficial não permite downloads automatizados pela sua política de robôs",
  "webResearch.error.FETCH_HTTP": "O site oficial recusou o download (HTTP {status})",
  "webResearch.error.FETCH": "Não foi possível baixar o documento",
  "webResearch.error.DOCUMENT_CHANGED": "O documento mudou durante a leitura",
  "webResearch.error.EXTRACT_CHECKS_FAILED":
    "Linhas extraídas não passaram na conferência CEST/NCM",
  "webResearch.error.EXTRACTION_INVALID": "Extração com formato inválido",
  "webResearch.error.EXTRACTION_REJECTED": "Extração recusada pelo serviço de leitura",
  "webResearch.error.EXTRACTION_TOO_LARGE": "Resultado da extração grande demais",
  "webResearch.error.CHUNK_TOO_LARGE": "Trecho do documento grande demais para ler",
  "webResearch.error.RESULT_INVALID": "Resultado recusado pela validação",
  "webResearch.error.FETCH_BLOCKED":
    "Site oficial bloqueia nosso endereço de saída; aguardando liberação do órgão",
  "webResearch.error.DOCUMENT_UNSUPPORTED":
    "Documento baixado, mas em formato que não conseguimos ler",
  "webResearch.error.WORKER_ERROR": "Falha interna do executor; será tentado de novo",
  "webResearch.error.LEASE_EXPIRED": "Tempo de processamento esgotado",
  "webResearch.error.INVALID_UNIT_KEY": "Unidade de pesquisa incompleta",
  "webResearch.error.UNSUPPORTED_KIND": "Etapa não suportada pelo executor",
  "webResearch.error.unknown": "Falha técnica",
  "webResearch.stage.fetch.hint": "Baixa nossa própria cópia de cada documento oficial localizado.",
  "webResearch.stage.extract": "Extrair",
  "webResearch.stage.extract.hint":
    "Lê as linhas do anexo (CEST, NCM, MVA, vigência) da cópia baixada, com a citação literal.",
  "webResearch.stage.verify": "Verificar pares",
  "webResearch.stage.verify.hint":
    "Confere NCM × rota só quando o segmento é ambíguo ou a estratégia é Par.",
  "webResearch.cost.title": "Custo",
  "webResearch.cost.live": "ao vivo",
  "webResearch.cost.spent": "Gasto vs. orçamento",
  "webResearch.cost.grounded": "Buscas vs. limite",
  "webResearch.cost.extraction": "Extrações",
  "webResearch.cost.estimated": "{count} estimadas",
  "webResearch.cost.eta": "Previsão",
  "webResearch.cost.etaNone": "encerrada",
  "webResearch.cost.etaPaused": "pausada",
  "webResearch.cost.throughput": "Vazão",
  "webResearch.cost.throughputValue": "{units} unidades/min · {searches} buscas/min",
  "webResearch.cost.throughputMeta": "últimos {minutes} min · {inFlight} em andamento",
  "webResearch.cost.etaRate": "no ritmo real, {units} unidades abertas",
  "webResearch.cost.etaPace": "no ritmo configurado",
  "webResearch.cost.estimate": "Reserva de planejamento na criação",
  "webResearch.cost.iob": "Certificar com IOB",
  "webResearch.failed.title": "Unidades com falha",
  "webResearch.failed.hint":
    "Desistiram após 3 tentativas ou erro permanente. Reprocessar zera as tentativas e as recoloca na fila.",
  "webResearch.failed.retry": "Reprocessar falhas",
  "webResearch.failed.none": "Nenhuma unidade com falha.",
  "webResearch.col.kind": "Etapa",
  "webResearch.col.subject": "Alvo",
  "webResearch.col.error": "Erro",
  "webResearch.col.attempts": "Tentativas",
  "webResearch.col.updated": "Atualizada",
  "webResearch.col.host": "Documento",
  "webResearch.col.uf": "UF",
  "webResearch.col.segments": "Segmentos",
  "webResearch.col.hash": "Hash",
  "webResearch.col.change": "Desde a última execução",
  "webResearch.kind.LOCATE_SEGMENT_UF": "Localizar segmento × UF",
  "webResearch.kind.LOCATE_CONFAZ_SEGMENT": "Localizar convênio CONFAZ",
  "webResearch.kind.LOCATE_INTERNAL_RATE_UF": "Localizar alíquota interna",
  "webResearch.kind.LOCATE_INTERSTATE_TABLE": "Localizar tabela interestadual",
  "webResearch.kind.FETCH_DOCUMENT": "Baixar documento",
  "webResearch.kind.EXTRACT_DOCUMENT_SEGMENT": "Extrair anexo",
  "webResearch.kind.VERIFY_PAIR": "Verificar par",
  "webResearch.docs.title": "Documentos encontrados",
  "webResearch.docs.hint": "Hash comparado com a pesquisa anterior, “{name}”.",
  "webResearch.docs.hintFirst":
    "Primeira pesquisa: todos os documentos baixados aparecem como novos.",
  "webResearch.docs.filter": "Filtrar documentos por mudança",
  "webResearch.docs.all": "Todos",
  "webResearch.docs.change.CHANGED": "Mudou",
  "webResearch.docs.change.NEW": "Novo",
  "webResearch.docs.change.SAME": "Sem mudança",
  "webResearch.docs.change.PENDING": "Aguardando download",
  "webResearch.docs.failed": "Uma unidade deste documento falhou",
  "webResearch.docs.none": "Nenhum documento localizado ainda.",
  "webResearch.docs.more": "Mostrar mais {count}",
  "webResearch.docs.less": "Mostrar menos",
  "webResearch.docs.truncated":
    "Mostrando os primeiros 200 registros de documentos desta pesquisa.",
  "webResearch.wizard.title": "Nova pesquisa web",
  "webResearch.wizard.steps": "Etapas da nova pesquisa",
  "webResearch.wizard.step.scope": "Escopo",
  "webResearch.wizard.step.routes": "Rotas",
  "webResearch.wizard.step.strategy": "Estratégia",
  "webResearch.wizard.step.caps": "Limites",
  "webResearch.wizard.step.preview": "Pré-visualizar",
  "webResearch.wizard.summary.caps": "{calls} buscas · US$ {budget}",
  "webResearch.wizard.summary.preview": "prévia atual · {cost}",
  "webResearch.wizard.summary.stale": "prévia desatualizada",
  "webResearch.wizard.summary.notYet": "ainda não calculada",
  "webResearch.wizard.summary.blocked": "bloqueada",
  "webResearch.wizard.plan.title": "Plano desta prévia",
  "webResearch.wizard.plan.edit": "Editar",
  "webResearch.wizard.name": "Nome",
  "webResearch.wizard.scope": "O que pesquisar",
  "webResearch.wizard.recommended": "Recomendado",
  "webResearch.wizard.days": "Período",
  "webResearch.wizard.daysValue": "{days} dias",
  "webResearch.wizard.routes": "Quais rotas",
  "webResearch.wizard.routes.uf": "UF",
  "webResearch.wizard.routes.direction": "Sentido",
  "webResearch.wizard.routes.direction.FROM": "Saindo da UF",
  "webResearch.wizard.routes.direction.TO": "Chegando na UF",
  "webResearch.wizard.routes.direction.BOTH": "Ambos",
  "webResearch.wizard.routes.list": "Rotas (origem → destino)",
  "webResearch.wizard.routes.add": "Adicionar rota",
  "webResearch.wizard.routes.remove": "Remover rota {route}",
  "webResearch.wizard.routes.explicitEmpty": "Adicione ao menos uma rota.",
  "webResearch.wizard.strategy": "Como pesquisar",
  "webResearch.wizard.strategy.pairNotAllowed":
    "Par não está disponível para Catálogo inteiro nem para Todas as UFs de destino.",
  "webResearch.wizard.skipFresh": "Reaproveitar respostas dos últimos 30 dias",
  "webResearch.wizard.skipFreshHint":
    "Buscas já respondidas por outra pesquisa há menos de 30 dias entram como “em cache” e não gastam.",
  "webResearch.wizard.caps.calls": "Máximo de buscas (grounded)",
  "webResearch.wizard.caps.callsHint": "≈ {time} a {pace} buscas/min.",
  "webResearch.wizard.caps.callsRange": "Entre 1 e 100.000.",
  "webResearch.wizard.caps.budget": "Orçamento",
  "webResearch.wizard.caps.budgetHint": "A pesquisa para ao atingir este gasto estimado.",
  "webResearch.wizard.caps.budgetInvalid":
    "Informe um valor em dólares maior que zero (ex.: 80 ou 12.50).",
  "webResearch.wizard.caps.campaign": "ID da campanha de financiamento",
  "webResearch.wizard.caps.campaignHint":
    "Copie o ID da campanha exibido nesta página. O Google Grounding exige uma campanha verificada; selecioná-la não aumenta o orçamento.",
  "webResearch.wizard.caps.campaignInvalid":
    "Informe o UUID da campanha verificada que financiará esta pesquisa.",
  "webResearch.wizard.caps.iob": "Certificar top N com IOB",
  "webResearch.wizard.caps.iobHint":
    "Enfileira tarefas IOB para os N pares mais usados. 0 desliga.",
  "webResearch.wizard.caps.iobUsedOnly": "Só disponível no escopo Usados.",
  "webResearch.wizard.caps.iobRange": "Entre 0 e 3.000.",
  "webResearch.wizard.caps.note":
    "Os limites valem por pesquisa. O teto diário e o orçamento mensal da seção Configurações também se aplicam.",
  "webResearch.wizard.back": "Voltar",
  "webResearch.wizard.next": "Avançar",
  "webResearch.wizard.toPreview": "Pré-visualizar",
  "webResearch.wizard.create": "Criar pesquisa",
  "webResearch.wizard.creating": "Criando…",
  "webResearch.wizard.createNeedsPreview": "Pré-visualize o plano atual antes de criar.",
  "webResearch.wizard.createError":
    "Não foi possível criar a pesquisa. Tente novamente; o mesmo plano não é criado duas vezes.",
  "webResearch.wizard.createConflict":
    "Esta chave já foi usada para outro plano. Atualize a prévia e tente de novo.",
  "webResearch.wizard.preview.lead":
    "Nada é gravado até você criar. Confira o que será pesquisado e quanto deve custar.",
  "webResearch.wizard.preview.loading": "Calculando o plano…",
  "webResearch.wizard.preview.refresh": "Atualizar prévia",
  "webResearch.wizard.preview.run": "Pré-visualizar plano",
  "webResearch.wizard.preview.stale": "O plano mudou desde a última prévia.",
  "webResearch.wizard.preview.error":
    "Não foi possível pré-visualizar. Revise os passos e tente novamente.",
  "webResearch.wizard.preview.invalid": "Corrija o passo “{step}” antes de pré-visualizar.",
  "webResearch.wizard.preview.fix": "Ir para o passo",
  "webResearch.preview.ncms": "NCMs",
  "webResearch.preview.routes.one": "{count} rota",
  "webResearch.preview.routes.other": "{count} rotas",
  "webResearch.preview.withCest": "Candidatos a CEST",
  "webResearch.preview.withoutCest": "{count} fora do Conv. 142/18",
  "webResearch.preview.ambiguous": "{count} ambíguos",
  "webResearch.preview.segmentsUfs": "Segmentos × UFs",
  "webResearch.preview.locates.one": "{count} localização",
  "webResearch.preview.locates.other": "{count} localizações",
  "webResearch.preview.cached": "{count} em cache",
  "webResearch.preview.pairs": "Pares a verificar",
  "webResearch.preview.pairsHint": "Só ambíguos ou estratégia Par.",
  "webResearch.preview.grounded": "Buscas estimadas",
  "webResearch.preview.extraction": "Extrações estimadas",
  "webResearch.preview.usageForecast": "Projeção pelo consumo confirmado",
  "webResearch.preview.forecastUnavailable": "Consumo confirmado insuficiente",
  "webResearch.preview.reservationHint":
    "A reserva considera o contexto completo do modelo em cada chamada planejada. Não é o gasto esperado nem um teto garantido da fatura. A admissão orçamentária continua usando reservas.",
  "webResearch.preview.forecastHint":
    "Projeção com {searches} chamadas de busca e {extractions} de extração em {days} dias. Exclui {unresolved} chamadas sem consumo confirmado; novas tentativas e falhas podem alterar o custo. Preços da plataforma antes de franquias ou créditos; não é uma fatura do Google.",
  "webResearch.preview.cost": "Reserva conservadora de planejamento",
  "webResearch.preview.eta": "Duração estimada",
  "webResearch.preview.withinCaps":
    "A reserva de planejamento cabe nos limites de buscas e orçamento.",
  "webResearch.preview.fitCaps": "Ajustar limites à reserva de planejamento (+20%)",
  "webResearch.warning.cestEmpty":
    "O catálogo CEST está vazio: todo NCM conta como fora do Conv. 142/18.",
  "webResearch.warning.noRoutes":
    "Nenhuma rota encontrada para estes NCMs (rotas usadas dependem de cálculos).",
  "webResearch.warning.nothing": "Nada a pesquisar neste escopo.",
  "webResearch.warning.pairOver":
    "O plano Par precisa de {units} unidades, acima do limite de {max}.",
  "webResearch.preview.overCaps":
    "A reserva de planejamento excede os limites. A execução pode parar antes; isso não significa que o custo previsto foi gasto.",
  "webResearch.preview.segmentsList.one": "{count} segmento do Conv. 142/18",
  "webResearch.preview.segmentsList.other": "{count} segmentos do Conv. 142/18",
  "webResearch.preview.segmentMeta": "{ncms} NCMs · {cests} CESTs",
  "webResearch.preview.unitsList": "Unidades planejadas por tipo",
  "webResearch.preview.warnings": "Avisos da API",
  "webResearch.settings.title": "Ritmo e orçamento",
  "webResearch.settings.hint":
    "Valem para todas as pesquisas web. A API aplica os limites a cada unidade entregue.",
  "webResearch.settings.kill": "Pausar pesquisa web",
  "webResearch.settings.killOn": "Pausada: nenhuma unidade é entregue, em nenhuma pesquisa.",
  "webResearch.settings.killOff":
    "Ligada: as pesquisas ativas seguem dentro do ritmo e dos limites.",
  "webResearch.settings.pace": "Ritmo",
  "webResearch.settings.grounded": "Buscas por minuto",
  "webResearch.settings.groundedHint":
    "De 1 a 30. Comece baixo e suba após uma semana sem erros 429.",
  "webResearch.settings.extraction": "Extrações por minuto",
  "webResearch.settings.extractionHint":
    "De 1 a 60 chamadas ao modelo; páginas sem nada para ler não contam.",
  "webResearch.settings.workers": "Trabalhadores em paralelo",
  "webResearch.settings.workersHint":
    "De 1 a {max}. Unidades processadas ao mesmo tempo; os ritmos e limites acima continuam globais.",
  "webResearch.settings.caps": "Limites",
  "webResearch.settings.daily": "Teto diário de buscas",
  "webResearch.settings.dailyHint": "Dia de Brasília. De 1 a 100.000.",
  "webResearch.settings.monthly": "Orçamento mensal",
  "webResearch.settings.monthlyHint":
    "Ao atingir, nenhuma pesquisa recebe trabalho até o mês seguinte.",
  "webResearch.settings.perDay": "Buscas por dia",
  "webResearch.settings.perDayMeta": "menor entre ritmo e teto diário",
  "webResearch.settings.perHour": "Buscas por hora",
  "webResearch.settings.perHourMeta": "no ritmo configurado",
  "webResearch.settings.budgetMonth": "Orçamento do mês",
  "webResearch.settings.budgetMonthMeta": "todas as pesquisas somadas",
  "webResearch.settings.prices": "Tabela de preços (estimativas)",
  "webResearch.settings.pricesHint":
    "Usada para converter o uso informado pelo executor em US$. Atualize quando o preço do provedor mudar.",
  "webResearch.settings.price.groundedPromptUsdPer1000": "Por 1.000 prompts com busca",
  "webResearch.settings.price.searchQueryUsdPer1000": "Por 1.000 consultas de busca",
  "webResearch.settings.price.inputTokensUsdPerMillion": "Por milhão de tokens de entrada",
  "webResearch.settings.price.outputTokensUsdPerMillion": "Por milhão de tokens de saída",
  "webResearch.calculatorBudget.title": "Orçamento por investigação da calculadora",
  "webResearch.calculatorBudget.hint":
    "Aplica-se a novas investigações de lacunas fiscais, inclusive as criadas automaticamente. Os limites diário, mensal e da campanha continuam independentes.",
  "webResearch.calculatorBudget.label": "Limite individual (US$)",
  "webResearch.calculatorBudget.fieldHint":
    "Reserva estimada para busca e extração. O consumo real é registrado; uma chamada em andamento pode superar a estimativa. Investigações existentes mantêm o orçamento original.",
  "webResearch.calculatorBudget.unavailable":
    "A pesquisa da calculadora não está disponível neste ambiente.",
  "webResearch.settings.saved": "Configurações salvas.",
  "webResearch.settings.conflict":
    "Outra pessoa alterou estas configurações. Recarregamos a versão atual; refaça sua alteração.",
  "webResearch.settings.error": "Não foi possível salvar. Tente novamente.",
  "webResearch.settings.pauseTitle": "Pausar a pesquisa web?",
  "webResearch.settings.pauseBody":
    "Todas as pesquisas param de receber trabalho na próxima solicitação do executor. Unidades em andamento terminam; nada é perdido.",
  "webResearch.settings.pauseConfirm": "Pausar pesquisa web",
  "certification.badge.PUBLISHED_RULE": "Regra publicada",
  "certification.badge.CERTIFIED": "Certificado IOB",
  "certification.badge.VERIFIED": "Verificado",
  "certification.badge.UNVERIFIED": "Não verificado",
  "certification.badge.EXPIRED": "Vencido",
  "certification.badge.CONFLICTING": "Em conflito",
  "certification.badge.REJECTED": "Rejeitado",
  "certification.badge.SUPERSEDED": "Substituído",
  "certification.meaning.PUBLISHED_RULE":
    "Valor de um conjunto de regras publicado; sempre prevalece sobre fatos.",
  "certification.meaning.CERTIFIED": "Lido no simulador IOB com o quadro do resultado registrado.",
  "certification.meaning.VERIFIED": "Confirmado por um revisor ou corroborado por um fato IOB.",
  "certification.meaning.UNVERIFIED":
    "Extraído de fonte oficial na web; ainda sem confirmação humana ou IOB.",
  "certification.meaning.EXPIRED": "A vigência terminou e não há sucessor.",
  "certification.meaning.CONFLICTING":
    "Discorda de outro fato do mesmo nível; não é usado até alguém decidir.",
  "certification.meaning.REJECTED": "Rejeitado por um revisor ou revogado; nunca é usado.",
  "certification.meaning.SUPERSEDED":
    "Um fato mais novo da mesma chave substituiu este a partir da nova vigência.",
  "certification.source.IOB_SIMULADOR": "Simulador IOB",
  "certification.source.WEB_RESEARCH": "Pesquisa web",
  "certification.source.OPERATOR": "Revisor",
  "certification.source.CATALOG_DERIVATION": "Catálogo CEST",
  "certification.source.PUBLISHED_RULESET": "Conjunto de regras publicado",
  "certification.tip.source": "Fonte",
  "certification.tip.ruleset": "Versão",
  "certification.tip.checked": "Checado em",
  "certification.tip.validity": "Vigência",
  "certification.tip.validRange": "{from} a {to}",
  "certification.tip.validFrom": "desde {from}",
  "certification.tip.host": "Citação",
  "certification.inferred": "vigência inferida",
  "revalidation.awaiting":
    "Checagem no IOB: entra na fila na próxima consulta do agente · próxima janela {window}",
  "revalidation.queued": "Checagem no IOB na fila · {ahead} · previsão {eta}",
  "revalidation.queuedHeld": "Checagem no IOB na fila · {ahead} · a tarefa está pausada",
  "revalidation.ahead.one": "{count} consulta à frente",
  "revalidation.ahead.other": "{count} consultas à frente",
  "revalidation.running": "Checagem no IOB em andamento",
  "revalidation.checked": "IOB consultado {age}: revise o resultado",
  "revalidation.ended": "A checagem no IOB terminou sem resposta: envie ao IOB de novo",
  "revalidation.notQueueable": "O IOB checa apenas fatos de NCM × rota: confirme ou rejeite este",
  "revalidation.paused": "Agente IOB pausado: a checagem aguarda um admin retomá-lo",
  "certification.revalidation": "Revalidação pendente",
  "certification.revalidation.hint": "O fato continua utilizável enquanto o IOB confere de novo.",
  "verification.tab": "Verificação",
  "verification.title": "Verificação de fatos fiscais",
  "verification.description":
    "Confirme, rejeite ou envie ao IOB os fatos que a pesquisa encontrou, no nível em que foram extraídos: uma linha de anexo verifica todas as rotas que ela cobre.",
  "verification.boundary":
    "Fatos fiscais ainda não entram em nenhum cálculo e nunca publicam uma regra. Verificar aqui prepara a base para quando o motor passar a consultá-los.",
  "verification.queue.title": "Fila de verificação",
  "verification.tabs": "Filas de verificação",
  "verification.tab.unverified": "Não verificados",
  "verification.tab.conflicting": "Em conflito",
  "verification.tab.drift": "Divergências com regra publicada",
  "verification.tab.revalidation": "Revalidação pendente",
  "verification.tab.expired": "Vencidos",
  "verification.tabHint.unverified":
    "Ordenados por impacto: ocorrências das lacunas abertas que cada fato responderia.",
  "verification.tabHint.conflicting":
    "Fatos do mesmo nível que discordam. Nenhum lado é usado até alguém decidir.",
  "verification.tabHint.drift":
    "Fatos certificados ou verificados que discordam da regra publicada. A regra continua valendo.",
  "verification.tabHint.revalidation":
    "Fatos ainda utilizáveis que o IOB precisa conferir de novo: a web discordou, a fonte mudou ou a vigência está no fim.",
  "verification.tabHint.expired":
    "Vigência encerrada sem sucessor. Não valem para datas depois do fim.",
  "verification.queue.count": "{shown} de {total}",
  "verification.queue.first": "Início",
  "verification.queue.next": "Próxima página",
  "verification.empty.unverified": "Nenhum fato aguardando verificação",
  "verification.empty.conflicting": "Nenhum conflito aberto",
  "verification.empty.drift": "Nenhuma divergência com a regra publicada",
  "verification.empty.revalidation": "Nenhuma revalidação pendente",
  "verification.empty.expired": "Nenhum fato vencido",
  "verification.empty.body":
    "Fatos chegam do simulador IOB e da pesquisa web. Quando houver algo para revisar, aparece aqui.",
  "verification.detail.none": "Selecione um fato para ver os campos e a evidência.",
  "verification.item.drift": "Diverge em {fields} · regra {version}",
  "verification.item.conflicts.one": "{count} fato em conflito",
  "verification.item.conflicts.other": "{count} fatos em conflito",
  "verification.item.impact": "{gaps} · {occurrences}",
  "verification.gaps.one": "{count} lacuna",
  "verification.gaps.other": "{count} lacunas",
  "verification.occurrences.one": "{count} ocorrência",
  "verification.occurrences.other": "{count} ocorrências",
  "verification.item.noImpact": "Sem lacunas abertas",
  "verification.field.stApplicable": "ST aplicável",
  "verification.field.originalMva": "MVA original",
  "verification.field.destinationInternalRate": "Alíquota interna",
  "verification.field.interstateRate": "Alíquota interestadual",
  "verification.field.ncmPrefixes": "NCMs do anexo",
  "verification.field.segment": "Destino e origens",
  "verification.field.uf": "UF",
  "verification.field.route": "Rota",
  "verification.field.kind": "Tipo",
  "verification.field.validity": "Vigência",
  "verification.field.effectiveTo": "Vale até",
  "verification.field.legalBasis": "Fundamento",
  "verification.field.checked": "Última checagem",
  "verification.field.verified": "Verificação",
  "verification.field.id": "Fato",
  "verification.value.yes": "Sim",
  "verification.value.no": "Não",
  "verification.scope.ORIGINS": "origens {ufs}",
  "verification.scope.ALL_ORIGINS": "todas as origens",
  "verification.scope.INTERNAL_ONLY": "somente operações internas",
  "verification.kind.ST_ROUTE": "Rota NCM",
  "verification.kind.ST_SEGMENT": "Segmento de anexo",
  "verification.kind.NO_ST_CATALOG": "Sem ST no catálogo",
  "verification.kind.INTERNAL_RATE": "Alíquota interna",
  "verification.kind.INTERSTATE_RATE": "Alíquota interestadual",
  "verification.subject.internal": "Interna {uf}",
  "verification.subject.modal": "modal da UF",
  "verification.short.st": "ST",
  "verification.value.internalSt": "ST interna no destino ({uf})",
  "verification.short.mva": "MVA",
  "verification.short.internal": "Interna",
  "verification.short.interstate": "Interestadual",
  "verification.bootstrap.title": "Configuração da base",
  "verification.bootstrap.hint":
    "Comece pelo que mais se expande: as 27 alíquotas internas modais e a tabela interestadual valem para todas as rotas.",
  "verification.bootstrap.internal": "Alíquotas internas por UF",
  "verification.bootstrap.internalTally":
    "{confirmed} de {total} verificadas · {pending} aguardando",
  "verification.bootstrap.interstate": "Tabela interestadual",
  "verification.bootstrap.interstateTally":
    "{confirmed} de {total} rotas verificadas · {pending} aguardando",
  "verification.bootstrap.interstateNote":
    "Cada rota origem → destino é um fato próprio; confirme a partir da aba Não verificados.",
  "verification.bootstrap.legend": "Legenda",
  "verification.bootstrap.cell.CONFIRMED": "verificada ou certificada",
  "verification.bootstrap.cell.PENDING": "aguardando verificação",
  "verification.bootstrap.cell.CONFLICT": "em conflito",
  "verification.bootstrap.cell.NONE": "sem fato",
  "verification.settings.title": "Uso dos fatos no cálculo",
  "verification.settings.hint":
    "Modo e chaves de corte da camada de fatos. Somente administradores alteram.",
  "verification.settings.loading": "Carregando configuração…",
  "verification.settings.dormant":
    "Os valores dos cálculos nunca usam fatos fiscais. No modo Sombra, a calculadora e as planilhas guardam uma comparação com os fatos verificados e certificados; o modo Ligado ainda não muda resultados.",
  "verification.settings.effective": "Modo efetivo",
  "verification.settings.environment": "Ambiente",
  "verification.settings.restricted":
    "Salvo como {mode}, mas o ambiente limita a {environment}: vale sempre o mais restritivo.",
  "verification.settings.effectiveHint":
    "O modo efetivo é o mais restritivo entre o salvo aqui e o do ambiente (FISCAL_FACTS_MODE).",
  "verification.settings.mode": "Modo",
  "verification.mode.OFF": "Desligado",
  "verification.mode.SHADOW": "Sombra",
  "verification.mode.ON": "Ligado",
  "verification.mode.OFF.hint": "Fatos não são consultados.",
  "verification.mode.SHADOW.hint":
    "O motor calcula também com fatos verificados e certificados e guarda a diferença por item, sem mudar resultados.",
  "verification.mode.ON.hint":
    "Fatos preencheriam itens sem regra publicada, sempre com o nível de certificação.",
  "verification.settings.useCertified": "Usar fatos certificados e verificados",
  "verification.settings.useCertifiedHint": "IOB e fatos confirmados por revisores.",
  "verification.settings.useUnverified": "Usar fatos não verificados",
  "verification.settings.useUnverifiedHint":
    "Chave de corte dos dados da web: desligue para ignorá-los na hora.",
  "verification.settings.saved": "Configuração salva.",
  "verification.settings.conflict":
    "Alguém alterou esta configuração — recarregamos a versão atual. Revise e salve de novo.",
  "verification.settings.error": "Não foi possível salvar. Tente de novo.",
  "verification.settings.save": "Salvar",
  "verification.action.CONFIRM": "Confirmar",
  "verification.action.REVALIDATE": "Confirmar valores",
  "verification.action.REJECT": "Rejeitar",
  "verification.action.REQUEST_IOB": "Pedir IOB",
  "verification.done.CONFIRM": "Fato confirmado.",
  "verification.done.REJECT": "Fato rejeitado. Ele não será usado.",
  "verification.done.REQUEST_IOB":
    "Pedido de conferência IOB registrado; o fato fica em Revalidação pendente.",
  "verification.error.stale": "Alguém alterou este fato — recarregue antes de decidir.",
  "verification.error.notAllowed":
    "Esta ação não é permitida no estado atual do fato. Recarregue para ver o estado mais recente.",
  "verification.error.generic": "Não foi possível registrar a decisão. Tente de novo.",
  "verification.reload": "Recarregar",
  "verification.dialog.CONFIRM.title": "Confirmar fato",
  "verification.dialog.CONFIRM.body":
    "Você conferiu os valores na fonte citada. O fato passa a Verificado e vale para todas as rotas que ele cobre.",
  "verification.dialog.REVALIDATE.title": "Confirmar valores atuais",
  "verification.dialog.REVALIDATE.body":
    "Você conferiu que os valores continuam corretos. A revalidação pendente é encerrada.",
  "verification.dialog.REJECT.title": "Rejeitar fato",
  "verification.dialog.REJECT.body":
    "O fato deixa de ser usado. O motivo fica na trilha de auditoria.",
  "verification.dialog.REQUEST_IOB.title": "Pedir conferência no IOB",
  "verification.dialog.REQUEST_IOB.body":
    "Marca o fato para o simulador IOB conferir. Ele continua com o nível atual até o resultado chegar.",
  "verification.dialog.sending": "Enviando…",
  "verification.dialog.reason": "Motivo",
  "verification.dialog.note": "Nota (opcional)",
  "verification.dialog.reasonHint": "Mínimo de {min} caracteres · {count} digitados",
  "verification.dialog.noteHint": "Fica registrada no histórico do fato.",
  "verification.detail.fact": "Fato",
  "verification.detail.history": "Histórico",
  "verification.detail.evidence": "Evidência",
  "verification.validity.range": "{from} a {to}",
  "verification.validity.open": "desde {from} · em aberto",
  "verification.validity.inferredHint": "A fonte não declarou o início; usamos a data da captura.",
  "verification.verifiedBy": "{who} · {time}",
  "verification.event.DERIVED": "Derivado",
  "verification.event.RECHECKED": "Checado de novo",
  "verification.event.CORROBORATED": "Corroborado",
  "verification.event.CONFLICT_DETECTED": "Conflito detectado",
  "verification.event.SUPERSEDED": "Substituído",
  "verification.event.REVALIDATION_REQUESTED": "Revalidação pedida",
  "verification.event.CONFIRMED": "Confirmado",
  "verification.event.REJECTED": "Rejeitado",
  "verification.event.IOB_REQUESTED": "IOB pedido",
  "verification.event.REVOKED": "Revogado",
  "verification.event.EXPIRED": "Vencido",
  "verification.event.related": "Ver fato relacionado",
  "verification.evidence.iob": "Quadro registrado no simulador IOB",
  "verification.evidence.enlarge": "Ampliar o quadro do simulador",
  "verification.evidence.frameAdmin": "O quadro do simulador é visível para administradores.",
  "verification.evidence.noFrame": "Sem quadro registrado para este achado.",
  "verification.evidence.openRun": "Abrir execução do agente",
  "verification.evidence.frameTitle": "Resultado IOB · {ncm} · {route}",
  "verification.evidence.annex": "Linha do anexo",
  "verification.evidence.checksPassed": "checagens aprovadas",
  "verification.evidence.checksFailed": "checagens com falha",
  "verification.evidence.locator": "Posição {start}–{end} no texto normalizado",
  "verification.evidence.noLocator": "Sem localizador no texto",
  "verification.evidence.extracted": "extraída em {time}",
  "verification.evidence.none": "Nenhuma evidência anexada a este fato.",
  "verification.evidence.allowlisted": "Fonte oficial · {source}",
  "verification.evidence.notAllowlisted": "Fora da lista de fontes",
  "verification.evidence.openDocument": "Abrir documento",
  "verification.evidence.newTab": "(abre em nova aba)",
  "verification.evidence.openEvidence": "Ver evidência",
  "verification.compare.conflictTitle": "Lado a lado",
  "verification.compare.field": "Campo",
  "verification.compare.this": "Este fato",
  "verification.compare.open": "Abrir",
  "verification.compare.differs": "(diverge)",
  "verification.compare.host": "Fonte",
  "verification.compare.driftTitle": "Fato × regra publicada",
  "verification.compare.driftHint":
    "A regra publicada continua valendo. Se o fato estiver certo, proponha a correção da regra pelo fluxo de propostas.",
  "verification.compare.rule": "Regra {version}",
  /* Shell and navigation (UX plan PR 1). */
  "shell.nav.home": "Início",
  "shell.nav.lots": "Lotes",
  "shell.nav.rules": "Regras",
  "shell.nav.documents": "Documentos",
  "shell.nav.productSearch": "Pesquisa por produto",
  "shell.nav.agentsGroup": "Agentes",
  "shell.nav.agentIob": "Agente IOB",
  "shell.nav.agentLogs": "Registros",
  "shell.nav.collapse": "Recolher menu",
  "shell.nav.expand": "Expandir menu",
  "shell.search.trigger": "Buscar NCM, regras, documentos…",
  "shell.viewAs.self": "{role} (você)",
  "nav.howItWorks": "Como funciona",
  "howItWorks.title": "Como funciona",
  "howItWorks.description":
    "Veja, com números reais do motor, o que o sistema procura e aplica quando um produto viaja de uma UF para outra.",
  "howItWorks.sections": "Seções",
  "howItWorks.section.run": "Execução guiada",
  "howItWorks.section.runHint":
    "Uma simulação real, passo a passo: cada fórmula mostra os números que o motor usou e de onde veio cada valor.",
  "howItWorks.section.map": "Mapa do sistema",
  "howItWorks.onboarding.title": "Em três passos",
  "howItWorks.onboarding.source": "Fonte oficial",
  "howItWorks.onboarding.sourceBody": "Um site do catálogo (SEFAZ, CONFAZ, Senado) publica o ato.",
  "howItWorks.onboarding.evidence": "Evidência",
  "howItWorks.onboarding.evidenceBody":
    "Guardamos nossa cópia com hash e a citação de cada valor lido.",
  "howItWorks.onboarding.review": "Revisão",
  "howItWorks.onboarding.reviewBody":
    "Uma pessoa confirma antes de qualquer regra ser proposta e publicada.",
  "howItWorks.onboarding.dismiss": "Entendi",
  "howItWorks.onboarding.dismissLabel": "Fechar a introdução",
  "howItWorks.section.mapHint":
    "De onde vêm os dados e o caminho que percorrem até virar cálculo. Selecione uma etapa para ver o que entra, o que sai e quem decide.",
  "howItWorks.section.glossary": "Glossário",
  "howItWorks.section.glossaryHint":
    "Os termos que aparecem no cálculo, com um exemplo ilustrativo cada.",
  "howItWorks.form.title": "Operação",
  "howItWorks.form.presets": "Exemplos",
  "howItWorks.form.ncm": "NCM",
  "howItWorks.form.origin": "Origem",
  "howItWorks.form.destination": "Destino",
  "howItWorks.form.cost": "Custo do produto",
  "howItWorks.form.taxpayer": "Destinatário contribuinte de ICMS?",
  "howItWorks.form.taxpayerYes": "Sim — revenda ou indústria",
  "howItWorks.form.taxpayerNo": "Não — consumidor final",
  "howItWorks.form.date": "Data do cálculo",
  "howItWorks.form.run": "Executar",
  "howItWorks.form.running": "Executando…",
  "howItWorks.form.invalid": "Informe NCM com 8 dígitos, origem, destino, custo e data.",
  "howItWorks.form.stateless":
    "Simulação sem gravação: usa o mesmo motor da Calculadora (modo Operação) sobre o conjunto de regras em vigor. Nada é salvo no histórico.",
  "howItWorks.form.permission":
    "A permissão de executar cálculos é necessária para rodar a simulação.",
  "howItWorks.preset.tyre": "Pneu SP → RJ",
  "howItWorks.preset.tyreHint": "4011.10.00 · ICMS-ST com MVA",
  "howItWorks.preset.soda": "Refrigerante SP → MG",
  "howItWorks.preset.sodaHint": "2202.10.00 · ICMS-ST",
  "howItWorks.preset.notebook": "Notebook SP → SP",
  "howItWorks.preset.notebookHint": "8471.30.12 · operação interna",
  "howItWorks.preset.airFryer": "Air fryer BA → MG",
  "howItWorks.preset.airFryerHint": "8516.60.00 · ST revogada · consumidor final",
  "howItWorks.player.empty":
    "Escolha um exemplo ou preencha a operação e clique em Executar para ver o motor trabalhar.",
  "howItWorks.player.loading": "Consultando catálogo, regras e fatos fiscais…",
  "howItWorks.player.controls": "Controles da animação",
  "howItWorks.player.play": "Reproduzir",
  "howItWorks.player.pause": "Pausar",
  "howItWorks.player.back": "Passo anterior",
  "howItWorks.player.forward": "Próximo passo",
  "howItWorks.player.restart": "Recomeçar",
  "howItWorks.player.showAll": "Mostrar tudo",
  "howItWorks.player.speed": "Velocidade",
  "howItWorks.player.progress": "Passo {current} de {total}",
  "howItWorks.player.progressLabel": "Progresso da execução",
  "howItWorks.perspective.entry":
    "Destinatário contribuinte: o motor calcula a entrada {origin} → {destination} — IPI, ICMS próprio e ICMS-ST, como no custo da Calculadora.",
  "howItWorks.perspective.consumer":
    "Consumidor final: o motor calcula a venda {origin} → {destination} — ICMS próprio e DIFAL (EC 87/2015). Não há ICMS-ST para consumidor final.",
  "howItWorks.tone.done": "Aplicado",
  "howItWorks.tone.skip": "Não se aplica",
  "howItWorks.tone.gap": "Requer revisão",
  "howItWorks.tone.warn": "Consulta parcial",
  "howItWorks.stepTitle.ncm": "NCM validado no catálogo",
  "howItWorks.stepTitle.cest": "CEST e segmento (Conv. ICMS 142/18)",
  "howItWorks.stepTitle.ruleset": "Conjunto de regras em vigor",
  "howItWorks.stepTitle.rule": "Regra para NCM × rota",
  "howItWorks.stepTitle.ipi": "IPI (TIPI)",
  "howItWorks.stepTitle.ownIcms": "ICMS próprio",
  "howItWorks.stepTitle.mva": "ST se aplica? MVA original → ajustada",
  "howItWorks.stepTitle.icmsSt": "Base ST e ICMS-ST",
  "howItWorks.stepTitle.difal": "DIFAL e FCP",
  "howItWorks.stepTitle.total": "Custo final",
  "howItWorks.step.ncm.found":
    "O código existe no catálogo oficial Siscomex. O catálogo identifica o produto; não traz alíquota.",
  "howItWorks.step.ncm.missing":
    "Código fora do catálogo Siscomex. O motor ainda procura regras por ele, mas confira a classificação.",
  "howItWorks.step.ncm.error":
    "Não foi possível consultar o catálogo NCM agora. O cálculo segue pelas regras.",
  "howItWorks.step.cest.none":
    "Nenhum CEST nas regras deste NCM × rota. Sem CEST, o motor exige uma única regra para NCM + rota.",
  "howItWorks.step.cest.rule":
    "A regra encontrada é específica do CEST {cest}; o segmento vem do Convênio ICMS 142/18.",
  "howItWorks.step.cest.candidates":
    "{count} CEST aparecem nas regras e fatos deste NCM. Informar o CEST desempata regras concorrentes.",
  "howItWorks.step.ruleset.body":
    "O motor fixa o conjunto publicado {version} e só considera regras vigentes na data do cálculo. O resultado sempre cita essa versão.",
  "howItWorks.step.rule.found": "Uma regra publicada cobre este NCM nesta rota e nesta data.",
  "howItWorks.step.rule.specific":
    "{count} regras servem para esta rota; o motor escolheu a mais específica (CEST, origem, destino).",
  "howItWorks.step.rule.ambiguous":
    "{count} regras empatam para NCM + rota sem CEST. O motor não escolhe: o item vai para revisão e a rota vira lacuna de cobertura.",
  "howItWorks.step.rule.missing":
    "Nenhuma regra publicada cobre este NCM nesta rota e data. O motor não inventa alíquota: o item vai para revisão e a rota vira lacuna de cobertura.",
  "howItWorks.step.ipi.body":
    "O IPI vem da linha nacional da TIPI para o NCM, aplicada sobre o custo.",
  "howItWorks.step.ipi.none": "Nenhuma linha TIPI publicada para este NCM: o motor não soma IPI.",
  "howItWorks.step.ownIcms.internal": "Operação interna em {uf}: vale a alíquota interna da UF.",
  "howItWorks.step.ownIcms.notTaxed":
    "A regra não tributa o ICMS nesta operação. Abra a regra para ver se é isenção declarada ou silêncio.",
  "howItWorks.step.ownIcms.noRule": "Sem regra de ICMS, o motor não calcula ICMS próprio.",
  "howItWorks.step.ownIcms.closed":
    "O ICMS-ST pago na entrada já encerrou a cadeia desta venda interna.",
  "howItWorks.band.4":
    "{origin} → {destination}: 4%, a alíquota de importados (Resolução do Senado 13/2012).",
  "howItWorks.band.7":
    "{origin} → {destination}: 7%, do Sul/Sudeste (exceto ES) para Norte, Nordeste, Centro-Oeste e ES (Resolução do Senado 22/89).",
  "howItWorks.band.12":
    "{origin} → {destination}: 12%, a alíquota interestadual geral (Resolução do Senado 22/89).",
  "howItWorks.band.other":
    "{origin} → {destination}: alíquota interestadual declarada pela regra publicada.",
  "howItWorks.step.mva.adjusted":
    "ST se aplica. Como a alíquota interestadual é menor que a interna, a MVA original é ajustada para não favorecer quem compra de fora.",
  "howItWorks.step.mva.intrastate":
    "ST se aplica. Em operação interna, a MVA original vale sem ajuste.",
  "howItWorks.step.mva.materialized":
    "ST se aplica. Esta política usa a MVA ajustada já materializada na regra.",
  "howItWorks.step.mva.standard":
    "A regra não prevê substituição tributária nesta rota: sem MVA e sem ICMS-ST.",
  "howItWorks.step.mva.revoked":
    "A regra registra ST não aplicável nesta rota (revogada): o produto segue pelo ICMS normal.",
  "howItWorks.step.mva.consumer":
    "Consumidor final não revende: o motor não retém ICMS-ST nesta venda.",
  "howItWorks.step.mva.noRule": "Sem regra publicada, o motor não sabe se há ST.",
  "howItWorks.step.icmsSt.body":
    "O ICMS-ST antecipa o imposto das próximas etapas: base presumida × alíquota interna do destino, menos o ICMS próprio já destacado.",
  "howItWorks.step.icmsSt.none":
    "Sem substituição tributária nesta operação: ICMS-ST não entra no custo.",
  "howItWorks.step.icmsSt.noRule": "Sem regra publicada, o ICMS-ST não é calculado.",
  "howItWorks.step.difal.body":
    "Venda a consumidor final em outra UF: o remetente recolhe a {uf} a diferença entre a alíquota interna e a interestadual.",
  "howItWorks.step.difal.taxpayer":
    "Destinatário contribuinte: não há DIFAL de consumidor final; a diferença é tratada pelo ICMS-ST ou pelo crédito.",
  "howItWorks.step.difal.intrastate": "Operação interna: não existe diferencial de alíquota.",
  "howItWorks.step.difal.noRule": "Sem regra publicada, o DIFAL não é calculado.",
  "howItWorks.step.total.entry":
    "Custo com os tributos que ficam no produto: IPI e ICMS-ST (o ICMS próprio vira crédito).",
  "howItWorks.step.total.consumer":
    "Custo com IPI e o DIFAL recolhido ao destino (o ICMS próprio está no preço).",
  "howItWorks.step.total.review":
    "Resultado não autoritativo: falta regra para esta rota. Publique a regra antes de usar este valor.",
  "howItWorks.step.rule.icmsSilent":
    "A regra selecionada é a linha nacional da TIPI: declara o IPI e é silente sobre o ICMS (EXCLUDED). Sob a política {policy} o motor usa a regra inteira e responde ICMS 0. Isso é uma lacuna a revisar, não uma isenção.",
  "howItWorks.step.ownIcms.silent":
    "A regra não declara ICMS (EXCLUDED significa silente, não isento). O motor zera o ICMS próprio; falta uma regra de rota que declare o ICMS.",
  "howItWorks.step.ownIcms.exempt": "A regra declara o ICMS isento nesta operação.",
  "howItWorks.step.mva.silent":
    "A regra não diz se há ST. O motor aplicou “sem ST”; confira os fatos fiscais e publique a regra da rota.",
  "howItWorks.step.icmsSt.silent":
    "ICMS-ST não calculado porque a regra é silente sobre ICMS. O custo abaixo pode estar subestimado.",
  "howItWorks.step.total.icmsSilent":
    "Valor do motor sem ICMS próprio nem ICMS-ST: a regra é silente sobre ICMS. Não use este custo antes de publicar a regra da rota.",
  "howItWorks.value.notStated": "Não declarado",
  "howItWorks.summary.icmsSilent":
    "Regra silente sobre ICMS: o motor devolveu ICMS 0 pela política do conjunto. Trate como lacuna e revise.",
  "ruleDivergence.source.IOB_SIMULADOR": "IOB",
  "ruleDivergence.source.WEB_RESEARCH": "Pesquisa web",
  "ruleDivergence.source.OPERATOR": "Operador",
  "ruleDivergence.source.CATALOG_DERIVATION": "Catálogo",
  "ruleDivergence.certified": "certificou",
  "ruleDivergence.verified": "verificou",
  "ruleDivergence.stMva": "Diverge da regra — {source} {verb} ST MVA {mva}",
  "ruleDivergence.st": "Diverge da regra — {source} {verb} ST",
  "ruleDivergence.noSt": "Diverge da regra — {source} {verb} sem ST",
  "ruleDivergence.hint":
    "Um fato fiscal certificado ou verificado discorda da regra publicada. Abra em Verificação → Divergências e prepare a proposta de correção.",
  "verification.item.driftSilent": "Regra silente sobre ICMS (linha TIPI): o motor responde ICMS 0",
  "calc.result.icmsSilent":
    "A regra aplicada é silente sobre ICMS (linha TIPI, EXCLUDED). O motor zerou ICMS e ICMS-ST pela política do conjunto; isso não é isenção. Trate como lacuna e revise antes de usar este custo.",
  "howItWorks.fact.ncm": "NCM",
  "howItWorks.fact.description": "Descrição oficial",
  "howItWorks.fact.cest": "CEST",
  "howItWorks.fact.version": "Versão",
  "howItWorks.fact.policy": "Política do motor",
  "howItWorks.fact.digest": "Conteúdo (hash)",
  "howItWorks.fact.date": "Data",
  "howItWorks.fact.ruleId": "Regra",
  "howItWorks.fact.route": "Rota",
  "howItWorks.fact.validFrom": "Vigente desde",
  "howItWorks.fact.validTo": "Vigente até",
  "howItWorks.fact.legalReference": "Base legal",
  "howItWorks.fact.lookup": "Resultado da busca",
  "howItWorks.fact.stApplicable": "ST se aplica",
  "howItWorks.fact.fcp": "FCP",
  "howItWorks.value.openEnded": "sem data final",
  "howItWorks.value.yes": "Sim",
  "howItWorks.value.no": "Não",
  "howItWorks.value.fcpNotModeled": "não calculado nesta base (sem alíquota publicada)",
  "howItWorks.term.cost": "custo",
  "howItWorks.term.ipiRate": "alíquota IPI",
  "howItWorks.term.internalRate": "interna destino",
  "howItWorks.term.interstateRate": "interestadual",
  "howItWorks.term.originalMva": "MVA original",
  "howItWorks.term.adjustedMva": "MVA ajustada",
  "howItWorks.term.ipi": "IPI",
  "howItWorks.term.reduction": "redução de base",
  "howItWorks.term.stBase": "base ST",
  "howItWorks.term.ownIcms": "ICMS próprio",
  "howItWorks.term.icmsSt": "ICMS-ST",
  "howItWorks.term.difal": "DIFAL",
  "howItWorks.formula.ipi": "IPI",
  "howItWorks.formula.ownIcms": "ICMS próprio",
  "howItWorks.formula.adjustedMva": "MVA ajustada",
  "howItWorks.formula.stBase": "Base ST",
  "howItWorks.formula.icmsSt": "ICMS-ST",
  "howItWorks.formula.difal": "DIFAL",
  "howItWorks.formula.total": "Custo final",
  "howItWorks.source.label": "Fonte",
  "howItWorks.source.catalogNcm": "Catálogo Siscomex",
  "howItWorks.source.catalogCest": "CEST · Conv. ICMS 142/18",
  "howItWorks.source.tipi": "TIPI · linha nacional",
  "howItWorks.source.rule": "Regra {id}",
  "howItWorks.source.engine": "Motor de cálculo",
  "howItWorks.source.factAgrees": "confere com a regra",
  "howItWorks.source.factDiffers": "diverge da regra",
  "howItWorks.source.factOnly": "fato fiscal, não usado no cálculo",
  "howItWorks.summary.title": "Resultado",
  "howItWorks.summary.taxes": "Tributos no custo: {value}",
  "howItWorks.summary.ruleset": "Conjunto {version} · {date}",
  "howItWorks.summary.openCalculator": "Abrir na Calculadora",
  "howItWorks.summary.openGaps": "Ver lacunas de cobertura",
  "howItWorks.summary.openRule": "Ver regra",
  "howItWorks.summary.pisCofins": "PIS/COFINS ficam fora desta base.",
  "howItWorks.map.tour": "Percorrer o fluxo",
  "howItWorks.map.stop": "Parar",
  "howItWorks.map.bandData": "De onde vêm os dados",
  "howItWorks.map.bandRules": "Como vira regra e cálculo",
  "howItWorks.map.laneWeb": "Pesquisa pública",
  "howItWorks.map.laneIob": "Simulador IOB",
  "howItWorks.map.promotion":
    "Fatos certificados ou verificados podem virar proposta (ADR 0013, em proposta). Fato nenhum publica sozinho.",
  "howItWorks.map.count.facts": "{count} fatos",
  "howItWorks.map.count.sources": "{count} fontes",
  "howItWorks.map.count.queue": "{count} na fila",
  "howItWorks.map.count.inReview": "{count} em revisão",
  "howItWorks.map.count.rules": "{count} regras",
  "howItWorks.map.count.calculations": "{count} cálculos em 24 h",
  "howItWorks.map.node.sources": "Fontes oficiais",
  "howItWorks.map.node.sourcesSub": "CONFAZ · SEFAZ · Senado",
  "howItWorks.map.node.sourcesBody":
    "O sistema observa as publicações oficiais das 27 SEFAZ, do CONFAZ e do Senado. Cada documento capturado guarda hash e data.",
  "howItWorks.map.node.webResearch": "Pesquisa web",
  "howItWorks.map.node.webResearchSub": "localizar → baixar → extrair",
  "howItWorks.map.node.webResearchBody":
    "Varreduras localizam o anexo certo, baixam o documento e extraem linhas NCM/CEST, MVA e alíquotas, sempre com citação.",
  "howItWorks.map.node.unverified": "Fato fiscal",
  "howItWorks.map.node.unverifiedSub": "Não verificado",
  "howItWorks.map.node.unverifiedBody":
    "O que a pesquisa extraiu vira fato fiscal não verificado: útil para orientar, rotulado e nunca tratado como regra.",
  "howItWorks.map.node.verification": "Verificação humana",
  "howItWorks.map.node.verificationSub": "Regras → Verificação",
  "howItWorks.map.node.verificationBody":
    "Um revisor confere o fato contra o documento citado e confirma ou rejeita. Divergências com o IOB aparecem como conflito.",
  "howItWorks.map.node.verified": "Fato fiscal",
  "howItWorks.map.node.verifiedSub": "Verificado",
  "howItWorks.map.node.verifiedBody":
    "Fato confirmado por uma pessoa, com a citação que o sustenta.",
  "howItWorks.map.node.iob": "Agente IOB",
  "howItWorks.map.node.iobSub": "navegador em VM",
  "howItWorks.map.node.iobBody":
    "Um agente opera o Simulador IOB numa máquina virtual, consulta NCM × rota e grava a tela do resultado.",
  "howItWorks.map.node.iobFindings": "Registros do agente",
  "howItWorks.map.node.iobFindingsSub": "ST, MVA e quadros",
  "howItWorks.map.node.iobFindingsBody":
    "Cada consulta vira um registro com o resultado e os quadros gravados.",
  "howItWorks.map.node.certified": "Fato fiscal",
  "howItWorks.map.node.certifiedSub": "Certificado IOB",
  "howItWorks.map.node.certifiedBody":
    "O resultado do IOB é certificado por padrão e vale até surgir nova vigência.",
  "howItWorks.map.node.documents": "Documentos",
  "howItWorks.map.node.documentsSub": "evidência aprovada",
  "howItWorks.map.node.documentsBody":
    "Toda regra publicada precisa de um documento oficial aprovado como evidência.",
  "howItWorks.map.node.proposals": "Propostas",
  "howItWorks.map.node.proposalsSub": "mudança com evidência",
  "howItWorks.map.node.proposalsBody":
    "Uma proposta descreve a mudança de regra (MVA, alíquotas, vigência) e aponta a evidência.",
  "howItWorks.map.node.review": "Revisão",
  "howItWorks.map.node.reviewSub": "duas aprovações",
  "howItWorks.map.node.reviewBody":
    "Duas pessoas diferentes aprovam; quem propõe não aprova a própria mudança.",
  "howItWorks.map.node.publication": "Publicação",
  "howItWorks.map.node.publicationSub": "versão imutável",
  "howItWorks.map.node.publicationBody":
    "Publicar gera uma nova versão do conjunto com hash de conteúdo. Versões publicadas nunca mudam.",
  "howItWorks.map.node.ruleset": "Conjunto de regras",
  "howItWorks.map.node.rulesetSub": "em vigor",
  "howItWorks.map.node.rulesetBody":
    "A versão em vigor é a única fonte que o motor lê para calcular.",
  "howItWorks.map.node.engine": "Motor de cálculo",
  "howItWorks.map.node.engineSub": "determinístico",
  "howItWorks.map.node.engineBody":
    "Mesma entrada e mesma versão dão sempre o mesmo resultado, com memória de cálculo e versão citada.",
  "howItWorks.map.node.outputs": "Calculadora · Lotes · API",
  "howItWorks.map.node.outputsSub": "quem consome",
  "howItWorks.map.node.outputsBody":
    "A Calculadora, os lotes de planilha e as integrações por API usam o mesmo motor e a mesma versão.",
  "howItWorks.map.detail.label": "Etapa selecionada",
  "howItWorks.map.detail.hint":
    "Selecione uma etapa para ver o que entra, o que sai e quem decide ali.",
  "howItWorks.map.detail.open": "Abrir {name}",
  "howItWorks.map.detail.In": "Entra",
  "howItWorks.map.detail.Out": "Sai",
  "howItWorks.map.detail.Who": "Quem decide",
  "howItWorks.map.node.sourcesIn":
    "Sites oficiais cadastrados (CONFAZ, SEFAZ, Senado) e os hosts permitidos de cada um.",
  "howItWorks.map.node.sourcesOut":
    "O catálogo de onde a pesquisa pode buscar e baixar, com hash e data de cada captura.",
  "howItWorks.map.node.sourcesWho": "Administradores cadastram e revisam cada fonte.",
  "howItWorks.map.node.webResearchIn":
    "Escopo de NCMs e rotas, estratégia, limite de buscas e orçamento.",
  "howItWorks.map.node.webResearchOut":
    "Documentos oficiais baixados e linhas de anexo lidas, cada uma com a citação literal.",
  "howItWorks.map.node.webResearchWho":
    "O sistema executa; um administrador cria, pausa, cancela ou encerra a pesquisa.",
  "howItWorks.map.node.unverifiedIn":
    "Valores lidos dos anexos: CEST, NCM, MVA, alíquota e vigência.",
  "howItWorks.map.node.unverifiedOut":
    "Fatos rotulados como não verificados, na fila de Verificação.",
  "howItWorks.map.node.unverifiedWho":
    "Ninguém ainda: um fato não verificado nunca entra em cálculo.",
  "howItWorks.map.node.verificationIn":
    "O fato não verificado, o documento conservado e a citação.",
  "howItWorks.map.node.verificationOut":
    "Fato verificado ou rejeitado, com o motivo registrado na auditoria.",
  "howItWorks.map.node.verificationWho":
    "Uma pessoa revisora. Verificar um fato não publica regra.",
  "howItWorks.map.node.verifiedIn": "Fatos confirmados por revisão humana.",
  "howItWorks.map.node.verifiedOut": "Base para uma proposta de regra (ADR 0013, em proposta).",
  "howItWorks.map.node.verifiedWho":
    "A decisão já está registrada; o fato não publica nada sozinho.",
  "howItWorks.map.node.iobIn": "A fila de NCM × rota e a agenda semanal do agente.",
  "howItWorks.map.node.iobOut": "Consultas ao Simulador IOB, gravadas quadro a quadro.",
  "howItWorks.map.node.iobWho":
    "O agente executa; um administrador organiza a fila e a agenda e pode parar a execução.",
  "howItWorks.map.node.iobFindingsIn": "As telas de resultado capturadas pelo agente.",
  "howItWorks.map.node.iobFindingsOut":
    "Registros: ST encontrada, sem ST, só ST interna ou ilegível, com os quadros.",
  "howItWorks.map.node.iobFindingsWho": "O sistema registra o que a tela mostrou.",
  "howItWorks.map.node.certifiedIn": "Registros do IOB para um NCM × rota.",
  "howItWorks.map.node.certifiedOut":
    "Fatos certificados pelo IOB, válidos até surgir nova vigência.",
  "howItWorks.map.node.certifiedWho":
    "A regra de certificação; divergências com a pesquisa web vão para revisão humana.",
  "howItWorks.map.node.documentsIn": "Documentos oficiais coletados das fontes.",
  "howItWorks.map.node.documentsOut": "Evidência aprovada que pode sustentar uma proposta.",
  "howItWorks.map.node.documentsWho": "Operadores aprovam ou rejeitam cada documento.",
  "howItWorks.map.node.proposalsIn":
    "Uma mudança de regra (MVA, alíquotas, vigência) e a evidência aprovada.",
  "howItWorks.map.node.proposalsOut": "Uma proposta em revisão, com o diff antes/depois.",
  "howItWorks.map.node.proposalsWho": "Um operador propõe; propor não altera nenhuma regra.",
  "howItWorks.map.node.reviewIn": "A proposta, seu diff e a evidência citada.",
  "howItWorks.map.node.reviewOut": "Aprovação ou rejeição, cada uma com motivo.",
  "howItWorks.map.node.reviewWho": "Duas pessoas diferentes de quem propôs.",
  "howItWorks.map.node.publicationIn": "Propostas aprovadas para o próximo conjunto.",
  "howItWorks.map.node.publicationOut":
    "Uma nova versão imutável do conjunto, com hash de conteúdo.",
  "howItWorks.map.node.publicationWho": "Quem tem permissão de publicar, com motivo registrado.",
  "howItWorks.map.node.rulesetIn": "A versão publicada.",
  "howItWorks.map.node.rulesetOut":
    "As regras vigentes em cada data, a única fonte que o motor lê.",
  "howItWorks.map.node.rulesetWho": "Ninguém edita uma versão publicada; muda-se publicando outra.",
  "howItWorks.map.node.engineIn":
    "A operação (NCM, rota, valor, data) e a versão de regras em vigor.",
  "howItWorks.map.node.engineOut":
    "Um cálculo determinístico com memória de cálculo e a versão citada.",
  "howItWorks.map.node.engineWho": "Ninguém: o motor só aplica regras publicadas.",
  "howItWorks.map.node.outputsIn": "Resultados do motor para a versão fixada.",
  "howItWorks.map.node.outputsOut": "Calculadora, lotes de planilha e respostas da API.",
  "howItWorks.map.node.outputsWho": "Quem consome decide como usar o resultado.",
  "howItWorks.glossary.example": "Exemplo ilustrativo",
  "howItWorks.glossary.internal.term": "Alíquota interna",
  "howItWorks.glossary.internal.body":
    "O percentual que a UF cobra nas operações dentro dela; no ICMS-ST e no DIFAL é a do destino.",
  "howItWorks.glossary.internal.example": "Interna 18% sobre R$ 100,00 = R$ 18,00.",
  "howItWorks.glossary.interstate.term": "Interestadual 4 / 7 / 12%",
  "howItWorks.glossary.interstate.body":
    "Alíquota entre UFs fixada pelo Senado: 12% em geral, 7% do Sul/Sudeste (exceto ES) para N, NE, CO e ES, 4% para importados.",
  "howItWorks.glossary.interstate.example": "SP → BA: 7%. BA → SP: 12%. Produto importado: 4%.",
  "howItWorks.glossary.mvaOriginal.term": "MVA original",
  "howItWorks.glossary.mvaOriginal.body":
    "Margem de valor agregado presumida que o convênio ou protocolo publica para o produto.",
  "howItWorks.glossary.mvaOriginal.example":
    "MVA 40% sobre R$ 100,00 → base presumida de R$ 140,00.",
  "howItWorks.glossary.mvaAdjusted.term": "MVA ajustada",
  "howItWorks.glossary.mvaAdjusted.body":
    "Corrige a MVA quando a interestadual é menor que a interna: ((1 + MVA) × (1 − inter) ÷ (1 − interna)) − 1.",
  "howItWorks.glossary.mvaAdjusted.example": "((1,40 × 0,88) ÷ 0,82) − 1 = 50,24%.",
  "howItWorks.glossary.icmsSt.term": "ICMS-ST",
  "howItWorks.glossary.icmsSt.body":
    "Substituição tributária: um contribuinte recolhe antecipado o ICMS das etapas seguintes. Base ST × interna − ICMS próprio.",
  "howItWorks.glossary.icmsSt.example": "R$ 150,24 × 18% − R$ 12,00 = R$ 15,04.",
  "howItWorks.glossary.difal.term": "DIFAL",
  "howItWorks.glossary.difal.body":
    "Diferencial de alíquota na venda a consumidor final de outra UF (EC 87/2015): valor × (interna destino − interestadual).",
  "howItWorks.glossary.difal.example": "R$ 100,00 × (18% − 12%) = R$ 6,00.",
  "howItWorks.glossary.fcp.term": "FCP",
  "howItWorks.glossary.fcp.body":
    "Fundo de Combate à Pobreza: adicional de até 2 pontos na alíquota interna de alguns produtos em algumas UFs. Não é calculado nesta base.",
  "howItWorks.glossary.fcp.example":
    "Interna 18% + FCP 2% = 20%; em R$ 100,00, R$ 2,00 vão ao fundo.",
  "howItWorks.glossary.cest.term": "CEST",
  "howItWorks.glossary.cest.body":
    "Código Especificador da Substituição Tributária (Conv. ICMS 142/18): identifica os bens sujeitos a ST por segmento.",
  "howItWorks.glossary.cest.example":
    "16.001.00 — pneus novos para automóveis (NCM 4011.10.00), segmento 16.",
  "howItWorks.glossary.validity.term": "Vigência",
  "howItWorks.glossary.validity.body":
    "O período em que a regra vale. O motor usa apenas regras vigentes na data do cálculo.",
  "howItWorks.glossary.validity.example":
    "Regra desde 01/03/2026, sem fim: vale em 28/09/2026, não em 15/02/2026.",
  /* -- Home v3: attention strip, operations, shell help ------------------ */
  "home.env.tag": "Demonstração",
  "home.attention.label": "Pendências",
  "home.attention.clear": "Nada pendente",
  "home.attention.clearDetail": "Lotes, verificação e vencimentos em dia.",
  "home.attention.checking": "verificando…",
  "home.attention.unavailable": "indisponível",
  "home.attention.period7d": "últimos 7 dias",
  "home.attention.lotsReview.name": "Lotes para revisão",
  "home.attention.lotsReview.one": "lote para revisão",
  "home.attention.lotsReview.other": "lotes para revisão",
  "home.attention.lotsReview.action": "Revisar",
  "home.attention.lotsFailed.name": "Lotes com falha",
  "home.attention.lotsFailed.one": "lote com falha",
  "home.attention.lotsFailed.other": "lotes com falha",
  "home.attention.lotsFailed.action": "Ver falhas",
  "home.attention.verification.name": "Verificação",
  "home.attention.verification.one": "fato a verificar",
  "home.attention.verification.other": "fatos a verificar",
  "home.attention.verification.meta": "Sem divergências nem conflitos",
  "home.attention.verification.action": "Verificar",
  "home.attention.drift.one": "{count} divergência",
  "home.attention.drift.other": "{count} divergências",
  "home.attention.conflicting.one": "{count} em conflito",
  "home.attention.conflicting.other": "{count} em conflito",
  "home.attention.rulesExpiring.name": "Vencimentos",
  "home.attention.rulesExpiring.one": "regra a vencer",
  "home.attention.rulesExpiring.other": "regras a vencer",
  "home.attention.rulesExpiring.meta": "próximos 30 dias · conjunto em vigor",
  "home.attention.rulesExpiring.action": "Ver regras",
  "home.cta.title": "Iniciar cálculo",
  "home.cta.continue": "Continuar cálculo",
  "home.cta.continueHint": "8 dígitos. Na calculadora você completa rota e custo.",
  "home.jobs.next.review": "Revisar",
  "home.jobs.next.failure": "Ver falha",
  "home.jobs.next.open": "Abrir",
  "home.rules.openCoverage": "Cobertura por família e UF",
  "home.ops.description": "Agentes, pesquisa web e atividade de governança.",
  "home.ops.openAgent": "Abrir Agente IOB",
  "home.ops.openResearch": "Abrir Pesquisa web",
  "home.ops.research.units": "{done} de {total} unidades concluídas",
  "nav.help": "Ajuda",
  "shell.nav.collapseTooltip": "Recolher menu · {shortcut}",
  "shell.nav.expandTooltip": "Expandir menu · {shortcut}",
  "verification.bootstrap.summaryInternal": "Alíquotas internas",
  "verification.bootstrap.summaryInterstate": "Tabela interestadual",
  "verification.bootstrap.summaryOf": "{confirmed} de {total}",
  "verification.bootstrap.showDetail": "Detalhes",
  "agents.lookupRelation.task": "parte da tarefa em andamento",
  "agents.lookupRelation.gap": "lacuna de cobertura, fora da rota da tarefa ({route})",
  "agents.lookupRelation.direct": "consulta avulsa, fora da rota da tarefa ({route})",
  "calc.result.waiting": "Aguardando dados",
  "ruleDrafts.next.action": "Preparar próximo rascunho",
  "ruleDrafts.next.open": "Abrir rascunho {version}",
  "ruleDrafts.next.title": "Preparar o próximo rascunho de versão",
  "ruleDrafts.next.body":
    "O rascunho parte da versão publicada {version} e de todas as propostas aprovadas (pode não haver nenhuma). Nada é publicado: publicar continua exigindo ao menos uma proposta aprovada e o fluxo de publicação.",
  "ruleDrafts.next.noActive": "Não há versão publicada: o rascunho nasce das propostas aprovadas.",
  "ruleDrafts.next.policy": "Política do rascunho",
  "ruleDrafts.next.recommended": "recomendada (ADR 0011, 0015)",
  "ruleDrafts.next.reason": "Motivo",
  "ruleDrafts.next.reasonDefault":
    "Adotar tax-family-v1 (ADR 0011): rotas sem regra de ICMS viram revisão e lacuna, não ICMS 0.",
  "ruleDrafts.next.create": "Criar rascunho",
  "ruleDrafts.next.created": "Rascunho {version} criado com {policy}.",
  "ruleDrafts.readiness.loading": "Verificando o conteúdo sob {policy}…",
  "ruleDrafts.readiness.blocking":
    "{count} violações impedem adotar {policy}. Corrija-as por proposta antes.",
  "ruleDrafts.readiness.ok": "O conteúdo satisfaz {policy}.",
  "ruleDrafts.readiness.ipiSummary":
    "{total} regras de rota marcam IPI EXCLUDED: {review} para revisar e {placeholder} placeholders. Sob tax-family-v1, EXCLUDED significa silente e o IPI vem da TIPI. A lista para revisar aparece no rascunho.",
  "ruleDrafts.adoption.title": "Adoção do tax-family-v1 (ADR 0011)",
  "ruleDrafts.adoption.hint": "revisão antes de publicar",
  "ruleDrafts.adoption.body":
    "Sob tax-family-v1, uma regra de rota com IPI EXCLUDED é silente: o IPI vem da linha TIPI e entra no custo e na base do ST. Se a exclusão é um tratamento revisado, reescreva-a como EXEMPT. Placeholders (a planilha não cotou a TIPI) podem ficar como estão.",
  "ruleDrafts.adoption.none": "Nenhuma regra de rota marca IPI EXCLUDED.",
  "ruleDrafts.adoption.column.rule": "NCM · CEST",
  "ruleDrafts.adoption.column.route": "Rota",
  "ruleDrafts.adoption.column.reason": "Motivo do IPI EXCLUDED",
  "ruleDrafts.adoption.column.kind": "Classificação",
  "ruleDrafts.adoption.column.change": "IPI sob tax-family-v1",
  "ruleDrafts.adoption.column.draft": "Rascunho",
  "ruleDrafts.adoption.kind.REVIEW": "Revisar",
  "ruleDrafts.adoption.kind.PLACEHOLDER": "Placeholder",
  "ruleDrafts.adoption.fromTipi": "EXCLUDED → TIPI {rate}",
  "ruleDrafts.adoption.tipiExempt": "EXCLUDED → TIPI isento",
  "ruleDrafts.adoption.noTipi": "EXCLUDED → sem IPI (nenhuma TIPI)",
  "ruleDrafts.adoption.restated": "→ EXEMPT (reescrita)",
  "ruleDrafts.adoption.select": "Selecionar {rule}",
  "ruleDrafts.adoption.reason": "Motivo da reescrita",
  "ruleDrafts.adoption.restate": "Reescrever como EXEMPT ({count})",
  "ruleDrafts.adoption.result":
    "{created} rascunhos criados, {existing} já existiam. Anexe a evidência e submeta em Rascunhos de proposta.",
  "ruleDrafts.adoption.truncated": "Mostrando {shown} de {total}.",
  "ruleDrafts.adoption.violations": "Violações sob {policy}",
  "ruleDrafts.status.EVIDENCE_REQUIRED": "Evidência pendente",
  "ruleDrafts.status.READY": "Pronto para submeter",
  "ruleDrafts.status.SUBMITTED": "Submetido",
  "ruleDrafts.status.DISCARDED": "Descartado",
  "ruleDrafts.origin.FISCAL_FACT": "Fato certificado",
  "ruleDrafts.origin.IPI_RESTATEMENT": "Reescrita de IPI",
  "ruleDrafts.panel.title": "Rascunhos de proposta",
  "ruleDrafts.panel.hint": "{count} rascunhos",
  "ruleDrafts.panel.body":
    "Rascunhos não são propostas. Cada um vira proposta (Aguardando revisão) só depois de anexar evidência aprovada em Documentos; revisão, aprovação e publicação seguem as regras atuais.",
  "ruleDrafts.panel.empty":
    "Nenhum rascunho para esta versão. Use Verificação → Divergências → Propor regras, ou a reescrita de IPI acima.",
  "ruleDrafts.group": "Grupo {group}",
  "ruleDrafts.group.submit": "Anexar evidência ao grupo ({count})",
  "ruleDrafts.values":
    "ST {st} · MVA original {mva} · interestadual {interstate} · interna {internal}",
  "ruleDrafts.value.blank": "em branco",
  "ruleDrafts.value.yes": "sim",
  "ruleDrafts.value.no": "não",
  "ruleDrafts.operation.SUPERSEDE": "Substitui a regra {rule}",
  "ruleDrafts.operation.UPSERT": "Nova regra de rota",
  "ruleDrafts.checklist.title": "Documentos oficiais a anexar",
  "ruleDrafts.checklist.CONV_142_18_ANNEX":
    "Conv. ICMS 142/18, Anexo {annex} (segmento {segment}, CEST {cest})",
  "ruleDrafts.checklist.CONV_142_18_ANNEX.noCest":
    "Conv. ICMS 142/18: identifique o CEST do NCM {ncm}",
  "ruleDrafts.checklist.ST_AGREEMENT":
    "Convênio ou protocolo ICMS que vincula {originUf} e {destinationUf} no segmento",
  "ruleDrafts.checklist.hint": "sugestão: {hint}; confirme a adesão das duas UFs",
  "ruleDrafts.checklist.RICMS_DESTINATION":
    "RICMS/{destinationUf}: item do anexo de ST para o NCM {ncm}",
  "ruleDrafts.checklist.INTERNAL_RATE":
    "Alíquota interna de {destinationUf}: artigo do RICMS/{destinationUf}",
  "ruleDrafts.checklist.INTERNAL_RATE.fact":
    "Alíquota interna de {destinationUf}: do fato VERIFICADO; anexe o ato que ele cita",
  "ruleDrafts.checklist.INTERSTATE_RATE":
    "Res. Senado 22/89: {rate} de {originUf} para {destinationUf}; 4% para importados (Res. Senado 13/2012)",
  "ruleDrafts.checklist.IPI_EXEMPTION_ACT":
    "Ato que concede a isenção de IPI ao NCM {ncm} (nota TIPI, lei ou decreto)",
  "ruleDrafts.checklist.optional": "informativo",
  "ruleDrafts.flag.INTERNAL_RATE_MISSING": "Interna em branco: nenhum fato VERIFICADO",
  "ruleDrafts.flag.FACT_INTERSTATE_DIFFERS": "O fato declara outra interestadual",
  "ruleDrafts.flag.IMPORTED_GOODS_CHECK": "Confirme a origem da mercadoria (4% se importada)",
  "ruleDrafts.flag.INTERNAL_OPERATION": "Operação interna: informe a alíquota",
  "ruleDrafts.flag.IPI_FROM_TIPI": "IPI silente: vem da TIPI",
  "ruleDrafts.flag.IPI_COPIED_FROM_TIPI": "IPI copiado da TIPI (política legada)",
  "ruleDrafts.flag.IPI_NOT_STATED": "Nenhuma TIPI declara IPI",
  "ruleDrafts.flag.NO_ST_EXPRESSION": "Sem ST: ST com stApplicable=false (decisão aberta ADR 0013)",
  "ruleDrafts.flag.SUPERSEDES_ROUTE_RULE": "Substitui a regra de rota da mesma chave",
  "ruleDrafts.flag.MERGED_FACTS": "Vários fatos na mesma chave",
  "ruleDrafts.missing": "Pendente: {fields}",
  "ruleDrafts.missing.evidence": "evidência",
  "ruleDrafts.missing.originalMva": "MVA original",
  "ruleDrafts.missing.destinationInternalRate": "alíquota interna",
  "ruleDrafts.missing.interstateRate": "alíquota interestadual",
  "ruleDrafts.facts": "{count} fato(s) · {findings} achado(s) IOB",
  "ruleDrafts.submit.title": "Anexar evidência e submeter",
  "ruleDrafts.submit.groupTitle": "Anexar evidência ao grupo {group}",
  "ruleDrafts.submit.body":
    "A evidência precisa estar aprovada em Documentos; o achado do IOB não é evidência. Cada rascunho vira uma proposta Aguardando revisão.",
  "ruleDrafts.submit.evidence": "Evidências selecionadas",
  "ruleDrafts.submit.noEvidence": "Nenhuma evidência selecionada.",
  "ruleDrafts.submit.remove": "Remover",
  "ruleDrafts.submit.internal": "Alíquota interna (fração, ex.: 0.20)",
  "ruleDrafts.submit.interstate": "Alíquota interestadual (fração)",
  "ruleDrafts.submit.mva": "MVA original (fração)",
  "ruleDrafts.submit.action": "Submeter para revisão",
  "ruleDrafts.submit.done": "{count} proposta(s) criada(s), aguardando revisão.",
  "ruleDrafts.submit.failed": "{count} não submetido(s): {detail}",
  "ruleDrafts.submit.blocked": "Anexe ao menos uma evidência aprovada.",
  "ruleDrafts.submit.rateInvalid": "Use uma fração decimal, por exemplo 0.18.",
  "ruleDrafts.submit.effective.title": "Carga efetiva da MVA (opcional)",
  "ruleDrafts.submit.effective.hint":
    "Só vale sob tax-family-v2 e só ajusta a MVA; o débito da ST segue na alíquota interna nominal. Informe a base legal, por exemplo RICMS/SP, Anexo II, art. 39 (12% para alimentos).",
  "ruleDrafts.submit.effective.rate": "Alíquota interna efetiva (fração, ex.: 0.12)",
  "ruleDrafts.submit.effective.legal": "Base legal",
  "ruleDrafts.submit.effective.validFrom": "Vigente desde (opcional)",
  "ruleDrafts.submit.effective.validTo": "Vigente até (opcional)",
  "ruleDrafts.submit.effective.invalid":
    "Informe a alíquota como fração e a base legal juntas; a vigência final não pode ser anterior à inicial.",
  "ruleDrafts.discard.action": "Descartar",
  "ruleDrafts.discard.title": "Descartar rascunho",
  "ruleDrafts.discard.reason": "Motivo (mín. 10 caracteres)",
  "ruleDrafts.openProposal": "Abrir proposta",
  "ruleDrafts.propose.action": "Propor regras ({count})",
  "ruleDrafts.propose.title": "Propor regras a partir dos fatos certificados",
  "ruleDrafts.propose.body":
    "Cria um rascunho de proposta por NCM × CEST × rota para as {count} divergências, no rascunho {version} ({policy}). ST e MVA original vêm do fato; a interestadual segue a Res. Senado 22/89; a interna só vem de um fato VERIFICADO, senão fica em branco e sinalizada.",
  "ruleDrafts.propose.evidence":
    "Achados do IOB não são evidência. Cada rascunho traz a lista dos atos oficiais a anexar (Conv. ICMS 142/18, convênio ou protocolo do segmento, RICMS da UF de destino) e não pode ser submetido sem evidência aprovada.",
  "ruleDrafts.propose.idempotent":
    "Rodar de novo não duplica: cada fato é rascunhado uma vez por versão. Até 200 fatos por execução.",
  "ruleDrafts.propose.noDraft":
    "Não há rascunho de versão. Prepare o próximo rascunho em Publicações antes de propor.",
  "ruleDrafts.propose.goPublications": "Ir para Publicações",
  "ruleDrafts.propose.confirm": "Criar rascunhos",
  "ruleDrafts.propose.result":
    "{created} rascunhos criados · {existing} fatos já rascunhados · {skipped} ignorados.",
  "ruleDrafts.propose.open": "Abrir rascunhos em {version}",
  "ruleDrafts.adoption.selectHint": "Selecione ao menos uma regra.",
  "evidenceViewer.title": "Evidência",
  "evidenceViewer.untitled": "Documento sem título",
  "evidenceViewer.captured": "capturado em {time}",
  "evidenceViewer.official": "Fonte oficial · {source}",
  "evidenceViewer.notOfficial": "Fora da lista de fontes",
  "evidenceViewer.historical": "Captura histórica",
  "evidenceViewer.openDocument": "Abrir documento",
  "evidenceViewer.openEvidence": "Ver documento preservado",
  "evidenceViewer.locator": "Localizador",
  "evidenceViewer.locatorRange": "caracteres {start}–{end} do texto preservado",
  "evidenceViewer.noLocator": "Sem localizador",
  "evidenceViewer.noLocatorHint":
    "A citação não está ancorada no documento: confira a linha no documento original antes de decidir.",
  "evidenceViewer.noQuote": "Sem citação literal para este fato.",
  "evidenceViewer.expand": "Ampliar contexto",
  "evidenceViewer.notFound":
    "A citação não aparece no texto preservado nesta posição. Trate como discrepância.",
  "evidenceViewer.unavailable.forbidden":
    "O texto preservado exige permissão de leitura de documentos; a citação abaixo é a registrada na extração.",
  "evidenceViewer.unavailable.missing":
    "Documento preservado indisponível; a citação abaixo é a registrada na extração.",
  "evidenceViewer.unavailable.error": "Não foi possível ler o documento preservado agora.",
  "evidenceViewer.folded": "Encontrada com espaços normalizados (quebras de linha do documento).",
  "evidenceViewer.hashDiffers":
    "O texto lido tem outro hash que o da extração: há versão mais recente do documento.",
  "evidenceViewer.checks": "Checagens do extrator: {checks}",
  "evidenceViewer.linkedFields": "Campos vinculados à citação",
  "evidenceViewer.inQuote": "na citação",
  "evidenceViewer.notInQuote": "não encontrado na citação",
  "factReview.view.label": "Agrupar",
  "factReview.view.document": "Documento / anexo",
  "factReview.view.segment": "Segmento × UF",
  "factReview.view.facts": "Fatos individuais",
  "factReview.key.inferred": "vigência inferida (sem início declarado)",
  "factReview.key.segment": "Segmento {segment}",
  "factReview.key.segmentNamed": "Seg. {segment} · {name}",
  "factReview.key.segmentUf": "{segment} → {uf}",
  "factReview.filter.search": "Buscar",
  "factReview.filter.searchPlaceholder": "Ex.: Anexo 1, 17.031.00, sefaz.ba",
  "factReview.filter.uf": "UF destino",
  "factReview.filter.segment": "Segmento",
  "factReview.filter.all": "Todos",
  "factReview.filter.scope": "Alcance de origem",
  "factReview.filter.scope.ALL_ORIGINS": "Todas as origens",
  "factReview.filter.scope.ORIGINS": "Origens listadas",
  "factReview.filter.scope.INTERNAL_ONLY": "Somente internas",
  "factReview.filter.validity": "Vigência",
  "factReview.filter.validity.STATED": "Início declarado",
  "factReview.filter.validity.INFERRED": "Início inferido",
  "factReview.filter.exceptions": "Exceções e sinais",
  "factReview.filter.exceptions.WITH": "Com exceções ou sinais",
  "factReview.filter.exceptions.WITHOUT": "Sem exceções nem sinais",
  "factReview.filter.desk.all": "Todos os fatos",
  "factReview.filter.desk.sample": "Amostra",
  "factReview.filter.desk.pending": "A inspecionar",
  "factReview.filter.desk.exceptions": "Exceções",
  "factReview.filter.desk.flagged": "Com sinais",
  "factReview.sort.label": "Ordenar por",
  "factReview.sort.IMPACT": "Impacto (ocorrências, depois alcance) ↓",
  "factReview.sort.AGE": "Mais antigos primeiro",
  "factReview.sort.SIZE": "Mais fatos primeiro",
  "factReview.empty.title": "Nenhum fato não verificado para agrupar",
  "factReview.empty.body":
    "Quando a pesquisa web extrair linhas de anexos, os fatos aparecem aqui agrupados por documento.",
  "factReview.empty.filtered": "Nenhum grupo com estes filtros",
  "factReview.summary": "{groups} · {facts}",
  "factReview.groups.one": "{count} grupo",
  "factReview.groups.other": "{count} grupos",
  "factReview.pendingFacts.one": "{count} fato pendente",
  "factReview.pendingFacts.other": "{count} fatos pendentes",
  "factReview.documents.one": "{count} documento",
  "factReview.documents.other": "{count} documentos",
  "factReview.flagged.one": "{count} com sinal",
  "factReview.flagged.other": "{count} com sinais",
  "factReview.factsCount.one": "{count} fato",
  "factReview.factsCount.other": "{count} fatos",
  "factReview.resume": "Retomar revisão",
  "factReview.caption": "Grupos de fatos não verificados",
  "factReview.col.group": "Documento / grupo",
  "factReview.col.facts": "Fatos",
  "factReview.col.reviewed": "Revisados",
  "factReview.col.exceptions": "Exceções",
  "factReview.col.impact": "Impacto · alcance",
  "factReview.col.action": "Ação",
  "factReview.reach": "{ncms} NCM × {routes} origens",
  "factReview.reach.oneOrigin": "{ncms} NCM × 1 origem",
  "factReview.reach.none": "Sem NCM no catálogo",
  "factReview.reach.hint": "sem lacunas abertas",
  "factReview.reach.title":
    "Nenhum cálculo pediu estes fatos ainda (0 lacunas abertas). Alcance: NCMs ativos do catálogo que o grupo cobre × UFs de origem a que se aplica.",
  "factReview.impact.gaps.one": "{count} lacuna aberta",
  "factReview.impact.gaps.other": "{count} lacunas abertas",
  "factReview.signals.title": "Sinais do grupo",
  "factReview.signals.hint":
    "Todos os fatos compartilham: você reconhece uma vez ao confirmar, não fato a fato.",
  "factReview.signal.INFERRED_VALIDITY": "Vigência inferida em todo o documento",
  "factReview.signal.ORIGIN_SCOPE": "Mesmo âmbito de origem: {scope}",
  "factReview.signal.ack.INFERRED_VALIDITY":
    "Vigência inferida: o documento não declara início; a data de captura/publicação é usada como início — confirmo.",
  "factReview.signal.ack.ORIGIN_SCOPE":
    "Âmbito de origem: a decisão vale para {scope} em todo o grupo — confirmo.",
  "factReview.decision.signals": "Propriedades do grupo (reconheça uma vez)",
  "factReview.blocker.SIGNALS": "Reconheça as propriedades do grupo acima.",
  "factReview.bar.complete": "Amostra completa, sem discrepâncias",
  "factReview.bar.confirmGroup": "Confirmar grupo · {count} fatos",
  "factReview.state.IN_REVIEW": "Em revisão",
  "factReview.state.REVIEW_REQUIRED": "Revisão necessária",
  "factReview.age": "extraído {time}",
  "factReview.ofTotal": "de {total}",
  "factReview.conflicting": "{count} em conflito",
  "factReview.review": "Revisar",
  "factReview.continue": "Continuar",
  "factReview.footnote":
    "As contagens cobrem todos os fatos pendentes do filtro, não só esta página. Selecionar esta página não seleciona todos os resultados.",
  "factReview.back": "Grupos",
  "factReview.backToFacts": "Fatos",
  "factReview.facts": "Fatos do grupo",
  "factReview.method.label": "Método de revisão",
  "factReview.method.FULL": "Revisão integral",
  "factReview.method.SAMPLE": "Amostragem",
  "factReview.method.sampleDocumentOnly": "Amostragem só vale para um grupo de documento/anexo.",
  "factReview.shortcuts.open": "Atalhos",
  "factReview.shortcuts.title": "Atalhos da mesa de revisão",
  "factReview.shortcuts.walk": "Próximo / anterior fato",
  "factReview.shortcuts.agree": "Concorda com a evidência e segue",
  "factReview.shortcuts.evidence": "Levar o foco à evidência",
  "factReview.shortcuts.exception": "Marcar exceção ou discrepância",
  "factReview.shortcuts.decision": "Abrir a revisão da decisão (não confirma)",
  "factReview.shortcuts.escape": "Fechar a superfície de cima ou voltar aos grupos",
  "factReview.shortcuts.help": "Mostrar esta lista",
  "factReview.shortcuts.scope": "Os atalhos valem só nesta mesa e nunca dentro de campos de texto.",
  "factReview.shortcuts.toggle": "Atalhos de teclado ativados",
  "factReview.nav.label": "Resumo do grupo",
  "factReview.nav.facts": "Fatos",
  "factReview.nav.inspected": "Revisados",
  "factReview.nav.exceptions": "Exceções",
  "factReview.nav.progress": "{done} de {total} a inspecionar",
  "factReview.nav.show": "Mostrar",
  "factReview.sample.title": "Amostra do revisor",
  "factReview.sample.size": "{size} de {population} fatos",
  "factReview.sample.mandatory": "Obrigatórios (com sinal)",
  "factReview.sample.representatives": "Representantes",
  "factReview.sample.random": "Aleatórios reproduzíveis",
  "factReview.sample.policy": "Política {policy} · semente",
  "factReview.sample.expansions.one": "ampliada {count} vez",
  "factReview.sample.expansions.other": "ampliada {count} vezes",
  "factReview.sample.expand": "Ampliar amostra",
  "factReview.sample.full": "Passar à revisão integral",
  "factReview.sample.startFirst": "Inspecione um fato para iniciar a sessão.",
  "factReview.sample.how": "Como a amostra é escolhida",
  "factReview.sample.rule.mandatory":
    "Entram sempre os fatos com sinal próprio: checagem falha ou escalada, sem localizador, discrepância, documento alterado ou divergência do IOB. O que todo o grupo compartilha (vigência inferida, mesmo âmbito de origem) é reconhecido uma vez ao confirmar.",
  "factReview.sample.rule.representatives":
    "Um representante fixo por combinação de campos e alcance de origem e por capítulo NCM, para cobrir as variantes de CEST/NCM.",
  "factReview.sample.rule.random":
    "O restante sai de um sorteio com semente fixa do grupo e do manifesto: 15 % do grupo (10 a 60 fatos); grupos até 10 fatos são revisados inteiros.",
  "factReview.sample.rule.discrepancy":
    "Uma discrepância leva o grupo a «Revisão necessária» e amplia a amostra; com duas, só a revisão integral confirma.",
  "factReview.sample.rule.exceptions":
    "Exceções ficam fora da decisão e são decididas uma a uma na fila de fatos.",
  "factReview.sample.notCertification":
    "Amostragem é uma política do revisor, não uma certificação automática: os fatos incluídos passam a Verificado com o registro «incluído por amostragem».",
  "factReview.sample.required":
    "Revisão necessária: {count} discrepância(s). A amostra foi ampliada e os fatos com discrepância serão decididos individualmente.",
  "factReview.sample.closed":
    "Amostragem encerrada neste grupo: há discrepâncias demais. Passe à revisão integral para confirmar.",
  "factReview.iob.title": "Corroboração IOB",
  "factReview.iob.match": "Confere com o IOB",
  "factReview.iob.mismatch": "Diverge do IOB",
  "factReview.iob.none": "Sem resultado IOB",
  "factReview.iob.never":
    "O IOB nunca confirma um fato: o resultado certificado aparece ao lado da amostra para o revisor decidir.",
  "factReview.iob.request": "Pedir corroboração IOB",
  "factReview.iob.reason.NO_NCM": "Nenhum NCM do catálogo para consultar nesta amostra.",
  "factReview.iob.reason.INTERNAL_ONLY":
    "Operações internas não têm rota interestadual para o IOB.",
  "factReview.iob.reason.NOT_ST": "O IOB só consulta ST por NCM × rota.",
  "factReview.iob.state.MATCH": "IOB certificado confere",
  "factReview.iob.state.MISMATCH": "IOB certificado diverge",
  "factReview.iob.dialog": "Pedir corroboração ao agente IOB",
  "factReview.iob.body":
    "Enfileira consultas LIST de {ncms} NCM(s) da amostra nas rotas {routes}, no fim da fila do agente. Resultados recentes são reaproveitados.",
  "factReview.iob.enqueue": "Enfileirar {count} tarefa(s)",
  "factReview.iob.done": "{count} tarefa(s) enfileirada(s). Acompanhe em Agente IOB → Fila.",
  "factReview.iob.partial": "{count} tarefa(s) enfileirada(s); outras falharam. Tente de novo.",
  "factReview.iob.taskName": "Corroboração · seg. {segment} · {route}",
  "factReview.session.started": "Sessão de {who} desde {time}",
  "factReview.session.abandon": "Abandonar sessão",
  "factReview.list.empty": "Nenhum fato neste filtro.",
  "factReview.list.count": "{shown} de {total} fatos",
  "factReview.mark.AGREES": "Concorda",
  "factReview.mark.DISCREPANCY": "Discrepância",
  "factReview.mark.EXCEPTION": "Exceção",
  "factReview.mark.PENDING": "A inspecionar",
  "factReview.mark.sampled": "na amostra",
  "factReview.flag.CHECKS_FAILED": "Checagem falha ou escalada no extrator",
  "factReview.flag.INFERRED_VALIDITY": "Vigência inferida (sem início declarado)",
  "factReview.flag.MISSING_LOCATOR": "Sem localizador no documento",
  "factReview.flag.DISCREPANCY": "Conflito ou revalidação pendente",
  "factReview.flag.DOCUMENT_CHANGED": "Há versão mais recente do documento",
  "factReview.flag.IOB_MISMATCH": "O IOB certificado diverge deste valor",
  "factReview.field.validFrom": "Início da vigência",
  "factReview.field.origin": "Origem do dado",
  "factReview.undo": "Desfazer marcação",
  "factReview.pane.label": "Mostrar",
  "factReview.pane.fact": "Fato",
  "factReview.pane.evidence": "Evidência",
  "factReview.bar.label": "Decisão",
  "factReview.bar.progress": "{done} de {total} revisados",
  "factReview.bar.progressSample": "{done} de {total} da amostra",
  "factReview.bar.exception": "Marcar exceção",
  "factReview.bar.skip": "Pular",
  "factReview.bar.agree": "Concorda · próximo",
  "factReview.bar.review": "Revisar decisão",
  "factReview.bar.reviewReady": "Revisar decisão · {count}",
  "factReview.bar.startFirst": "Inspecione um fato para iniciar a sessão.",
  "factReview.bar.readOnly": "Leitura: confirmar exige a permissão de revisão de regras.",
  "factReview.error.changed": "O grupo mudou desde que foi aberto. Recarregue para continuar.",
  "factReview.error.generic": "Não foi possível registrar esta ação. Recarregue e tente de novo.",
  "factReview.stale":
    "Desde o início da sessão: {changed} fato(s) mudaram, {added} entraram e {removed} saíram do grupo. Os que mudaram serão ignorados ao confirmar.",
  "factReview.refresh": "Atualizar revisão do grupo",
  "factReview.truncated":
    "O grupo tem mais de 500 fatos pendentes: filtre por segmento ou UF para revisar o restante.",
  "factReview.exception.title": "Exceção ou discrepância",
  "factReview.exception.kind": "Tipo de marcação",
  "factReview.exception.DISCREPANCY.title": "Discrepância com o documento",
  "factReview.exception.DISCREPANCY.hint":
    "O valor não confere com a linha. O grupo passa a «Revisão necessária» e a amostra é ampliada.",
  "factReview.exception.EXCEPTION.title": "Exceção (decidir individualmente)",
  "factReview.exception.EXCEPTION.hint":
    "Fica fora da decisão do grupo, sem afirmar que está errado.",
  "factReview.exception.presets": "Motivos frequentes",
  "factReview.exception.preset.unreadable": "Linha ilegível no documento",
  "factReview.exception.preset.otherSegment": "Item de outro segmento",
  "factReview.exception.preset.valueDiffers": "Valor difere do documento",
  "factReview.exception.preset.validity": "Vigência a confirmar",
  "factReview.exception.note": "O que difere (opcional)",
  "factReview.exception.noteHint": "Fica no histórico da sessão e no fato.",
  "factReview.exception.reason": "Motivo",
  "factReview.exception.reasonHint": "Mínimo de {min} caracteres.",
  "factReview.exception.submit": "Marcar exceção",
  "factReview.exception.submitDiscrepancy": "Registrar discrepância",
  "factReview.decision.title": "Confirmar grupo",
  "factReview.decision.inGroup": "Fatos no manifesto",
  "factReview.decision.inspected": "Inspecionados diretamente",
  "factReview.decision.sampled": "Incluídos por amostragem",
  "factReview.decision.excluded": "Exceções excluídas",
  "factReview.decision.included": "Incluídos nesta decisão",
  "factReview.decision.list": "Ver lista completa dos {count} fatos",
  "factReview.decision.stale":
    "{count} fato(s) mudaram desde o início da sessão e serão ignorados (resultado parcial).",
  "factReview.decision.blocked": "Ainda não é possível confirmar",
  "factReview.decision.note": "Nota da revisão",
  "factReview.decision.boundary":
    "Esta ação verifica fatos. Não publica regras nem altera cálculos.",
  "factReview.decision.back": "Voltar à revisão",
  "factReview.decision.confirm": "Confirmar {count} fatos",
  "factReview.decision.problem.changed":
    "O escopo mudou (amostra, exceções ou manifesto). Recarregue o grupo e revise de novo o que mudou.",
  "factReview.decision.problem.incomplete":
    "Faltam inspeções exigidas pela política. Recarregue o grupo.",
  "factReview.decision.problem.error": "Não foi possível confirmar agora. Nada foi alterado.",
  "factReview.blocker.SESSION_NOT_OPEN": "A sessão não está aberta.",
  "factReview.blocker.NOTHING_TO_CONFIRM": "Nenhum fato incluído: todos são exceções.",
  "factReview.blocker.SAMPLE_NOT_ALLOWED": "Grupos segmento × UF não aceitam amostragem.",
  "factReview.blocker.TOO_MANY_DISCREPANCIES":
    "Discrepâncias demais para amostragem: revise integralmente.",
  "factReview.blocker.UNINSPECTED": "{count} fato(s) ainda a inspecionar.",
  "factReview.inclusion.INSPECTED": "inspecionado diretamente",
  "factReview.inclusion.SAMPLED": "incluído por amostragem",
  "factReview.history.GROUP_REVIEW_INSPECTED": "Revisão por grupo · inspecionado diretamente",
  "factReview.history.GROUP_REVIEW_SAMPLED": "Revisão por grupo · incluído por amostragem",
  "factReview.result.title": "Grupo confirmado",
  "factReview.result.summary": "{applied} passaram a Verificado. Nenhuma regra foi publicada.",
  "factReview.result.inspected": "Inspecionados diretamente",
  "factReview.result.sampled": "Incluídos por amostragem",
  "factReview.result.excluded": "Exceções (pendentes)",
  "factReview.result.skipped": "Ignorados",
  "factReview.result.exceptionsNext":
    "As exceções continuam não verificadas: decida cada uma na lista de fatos individuais.",
  "factReview.result.when": "Confirmado em {time}",
  "factReview.scopeChoice.reason.AGREEMENT_SIGNATORIES":
    "A matriz CONFAZ ({agreements}) deriva as origens: o anexo de {uf} cobre as operações internas e a retenção interestadual vale só para as UFs signatárias na data da operação.",
  "factReview.scopeChoice.AGREEMENT_ORIGINS.label":
    "Confirmar internas + origens signatárias ({count} UFs)",
  "factReview.scopeChoice.AGREEMENT_ORIGINS.hint":
    "Derivadas de {agreements} em {date}. Adesões, denúncias e exclusões passam a valer nas suas datas; origens fora do acordo não retêm ST para {uf} (o destino pode cobrar antecipação).",
  "factReview.scopeChoice.agreementShort":
    "operações internas de {uf} + {count} origens signatárias",
  "factReview.scopeChoice.proposedAgreement": "proposto: internas + {count} origens signatárias",
  "factReview.scopeChoice.agreementUnverified":
    "O acordo ainda não está verificado: as rotas interestaduais só entram no SHADOW depois de confirmá-lo em Acordos CONFAZ.",
  "factReview.scopeChoice.partial":
    "{known} de {total} fatos têm CEST coberto pelo acordo; os demais ficam só com operações internas.",
  "factReview.scopeChoice.change.JOINS": "{uf} entra em {date} ({agreement})",
  "factReview.scopeChoice.change.LEAVES": "{uf} sai em {date} ({agreement})",
  "factReview.result.scopeAgreement":
    "Confirmado para as operações internas de {uf} e para as origens signatárias do acordo CONFAZ em cada data.",
  "verification.scope.verifiedAgreement":
    "verificado: internas de {uf} + signatários ({agreements})",
  "verification.tab.agreements": "Acordos CONFAZ",
  "stAgreements.hint":
    "Signatários dos convênios e protocolos de ST por segmento. Deles saem as origens interestaduais dos fatos de anexo.",
  "stAgreements.counts": "{unverified} a verificar · {verified} verificados · {total} no catálogo",
  "stAgreements.membersToday": "{count} signatários hoje",
  "stAgreements.checksFailed": "{count} checagem(ns) a revisar",
  "stAgreements.status.UNVERIFIED": "Não verificado",
  "stAgreements.status.VERIFIED": "Verificado",
  "stAgreements.status.REJECTED": "Rejeitado",
  "stAgreements.status.SUPERSEDED": "Substituído",
  "stAgreements.status.MISSING": "Não lido",
  "stAgreements.missing.title": "Acordo ainda não lido",
  "stAgreements.missing.body":
    "Rode uma pesquisa de Acordos CONFAZ em Administração → Pesquisa web → Nova pesquisa para ler a página oficial.",
  "stAgreements.action.CONFIRM": "Confirmar acordo",
  "stAgreements.action.REJECT": "Rejeitar",
  "stAgreements.meta.segments": "Segmentos (Conv. 142/18)",
  "stAgreements.meta.validity": "Vigência",
  "stAgreements.meta.published": "Publicado no DOU",
  "stAgreements.meta.document": "Documento",
  "stAgreements.validity.open": "desde {from}",
  "stAgreements.validity.range": "{from} a {to}",
  "stAgreements.checks.title": "Checagens do extrator a revisar:",
  "stAgreements.members.title": "Signatários em {date} ({count})",
  "stAgreements.members.none": "Nenhuma UF vinculada nesta data.",
  "stAgreements.excluded": "CEST excetuados: {cests}",
  "stAgreements.matrix.title": "Matriz de adesão",
  "stAgreements.matrix.uf": "UF",
  "stAgreements.matrix.from": "Desde",
  "stAgreements.matrix.to": "Até",
  "stAgreements.matrix.how": "Entrada → saída",
  "stAgreements.matrix.act": "Ato",
  "stAgreements.matrix.quote": "Trecho",
  "stAgreements.matrix.open": "em vigor",
  "stAgreements.joined.ORIGINAL": "Signatário original",
  "stAgreements.joined.ADHESION": "Adesão",
  "stAgreements.joined.PLENARY": "Convênio (todas as UFs)",
  "stAgreements.joined.OBSERVED": "Cláusula vigente",
  "stAgreements.left.DENUNCIA": "Denúncia",
  "stAgreements.left.EXCLUSAO": "Exclusão",
  "stAgreements.left.REVOGACAO": "Revogação",
  "stAgreements.history": "Histórico",
  "stAgreements.event.DERIVED": "Lido da página oficial",
  "stAgreements.event.RECHECKED": "Relido (mesma versão)",
  "stAgreements.event.CONFIRMED": "Confirmado",
  "stAgreements.event.REJECTED": "Rejeitado",
  "stAgreements.event.SUPERSEDED": "Substituído por versão mais nova",
  "stAgreements.boundary":
    "Confirmar um acordo não publica regra: ele passa a derivar as origens interestaduais dos fatos de segmento em cada data.",
  "stAgreements.dialog.CONFIRM.title": "Confirmar {agreement}",
  "stAgreements.dialog.CONFIRM.body":
    "Confira signatários, adesões, denúncias, exclusões e vigência com a página oficial preservada. A versão verificada anterior deste acordo passa a Substituída.",
  "stAgreements.dialog.REJECT.title": "Rejeitar {agreement}",
  "stAgreements.dialog.REJECT.body":
    "O acordo sai da matriz; os fatos de segmento voltam a valer só para operações internas enquanto não houver outra versão verificada.",
  "stAgreements.retire.open": "Retirar leituras divergentes ({count})",
  "stAgreements.retire.title": "Retirar leituras com identidade divergente",
  "stAgreements.retire.body":
    "Estas observações não verificadas foram gravadas com um número que a própria página não traz (uma linha de listagem lida como cabeçalho). Elas serão rejeitadas com o motivo abaixo e o registro fica na auditoria. Acordos verificados e semeados não são alterados.",
  "stAgreements.retire.none": "Nenhuma leitura divergente.",
  "stAgreements.retire.readFor": "página lida para {agreement}",
  "stAgreements.retire.urlOnly": "sem cabeçalho, identificada só pelo endereço",
  "stAgreements.retire.submit": "Rejeitar ({count})",
  "stAgreements.dialog.changed": "O acordo mudou desde que você abriu: recarregue.",
  "stAgreements.dialog.error": "Não foi possível registrar agora. Nada foi alterado.",
  "webResearch.scope.CONFAZ_AGREEMENTS": "Acordos CONFAZ (signatários)",
  "webResearch.scope.CONFAZ_AGREEMENTS.body":
    "Lê a página oficial de cada convênio/protocolo de ST do catálogo revisado (signatários, adesões, denúncias, vigência) para a matriz de origens.",
  "webResearch.scope.CONFAZ_AGREEMENTS.short": "Acordos CONFAZ",
  "webResearch.scope.CONFAZ_AGREEMENTS.segments": "Acordos CONFAZ · seg. {segments}",
  "webResearch.scope.CONFAZ_AGREEMENTS.route": "páginas oficiais",
  "webResearch.wizard.agreements.segments": "Segmentos",
  "webResearch.wizard.agreements.all": "Todos os {count} acordos do catálogo",
  "webResearch.wizard.agreements.some": "{count} acordo(s) dos segmentos marcados",
  "webResearch.wizard.agreements.segment": "Segmento {segment}",
  "webResearch.wizard.agreements.locate": "Procurar outros acordos e alterações",
  "webResearch.wizard.agreements.locateHint":
    "Uma busca CONFAZ por segmento (chamada com busca): páginas de convênio/protocolo encontradas também são lidas como acordos.",
  "webResearch.wizard.agreements.noRoutes":
    "Acordos CONFAZ não usam rotas: cada página oficial é baixada e lida uma vez.",
  "verification.scope.verifiedInternal": "verificado só para operações internas ({uf}→{uf})",
  "factReview.scopeChoice.title": "Âmbito de origem da decisão",
  "factReview.scopeChoice.reason.AGREEMENTS_UNKNOWN":
    "Os signatários do convênio ou protocolo CONFAZ deste segmento ainda não estão verificados. O anexo de {uf} cobre as operações internas; a retenção interestadual só existe quando a UF de origem assinou o acordo.",
  "factReview.scopeChoice.default": "sugerido",
  "factReview.scopeChoice.INTERNAL_ONLY.label": "Confirmar só operações internas ({uf}→{uf})",
  "factReview.scopeChoice.INTERNAL_ONLY.hint":
    "As rotas interestaduais para {uf} continuam não verificadas, à espera do IOB e da matriz de signatários CONFAZ.",
  "factReview.scopeChoice.AS_EXTRACTED.label": "Confirmar como extraído: {scope}",
  "factReview.scopeChoice.AS_EXTRACTED.hint": "Vale para as origens que o anexo lista.",
  "factReview.scopeChoice.AS_EXTRACTED.hintAll":
    "Use só se o documento comprovar retenção vinda de todas as UFs: sem acordo CONFAZ a UF de origem não retém o ICMS-ST para {uf}.",
  "factReview.scopeChoice.allUfs": "{count} UFs de origem",
  "factReview.scopeChoice.origins": "UFs de origem cobertas",
  "factReview.scopeChoice.internalShort": "operações internas ({uf}→{uf})",
  "factReview.scopeChoice.proposedInternal": "proposto: só internas ({uf}→{uf})",
  "factReview.result.scopeInternal":
    "Confirmado só para operações internas ({uf}→{uf}); as rotas interestaduais seguem não verificadas.",
  "factReview.result.groups": "Voltar aos grupos",
  "factReview.result.next": "Próximo grupo",
  "factReview.skip.STALE_REVISION": "mudou desde o início da sessão",
  "factReview.skip.NOT_UNVERIFIED": "já está {status}",
  "factReview.skip.NOT_FOUND": "não encontrado",
  "scopeFix.scope.INTERNAL_ONLY": "Só operações internas ({uf}→{uf})",
  "scopeFix.scope.AGREEMENT_ORIGINS": "Internas de {uf} + {count} origens signatárias",
  "scopeFix.scope.ORIGINS": "Origens restritas: {ufs}",
  "scopeFix.scope.ALL": "Todas as origens ({count} UFs)",
  "scopeFix.scope.LISTED": "Origens listadas no documento ({count} UFs): {ufs}",
  "scopeFix.summary.chosen": "Escopo que será confirmado",
  "scopeFix.summary.confirmed": "Escopo confirmado",
  "scopeFix.summary.internalOnly": "Nenhuma rota interestadual passa a Verificado: só {uf}→{uf}.",
  "scopeFix.summary.interstate": "{count} UFs de origem interestaduais passam a Verificado.",
  "scopeFix.summary.wide":
    "Mais amplo que o proposto: a ST interestadual depende dos signatários CONFAZ do segmento.",
  "scopeFix.ack.title": "Todas as origens exigem confirmação explícita",
  "scopeFix.ack.why":
    "O proposto é {proposed}. A ST interestadual depende dos signatários CONFAZ do segmento: só confirme todas as origens se o próprio documento provar a retenção vinda de cada UF.",
  "scopeFix.ack.proven": "O documento prova retenção de todas as UFs",
  "scopeFix.ack.justification": "Justificativa (onde o documento prova isso)",
  "scopeFix.ack.missing": "Faltam {count} caracteres",
  "scopeFix.ack.ok": "Fica registrada na auditoria e no resultado.",
  "scopeFix.ack.recorded": "Justificativa de todas as origens:",
  "scopeFix.action.group": "Corrigir escopo",
  "scopeFix.action.fact": "Restringir escopo de origem",
  "scopeFix.dialog.title": "Restringir escopo de origem",
  "scopeFix.dialog.current": "Cobre hoje",
  "scopeFix.dialog.to": "Restringir para",
  "scopeFix.dialog.internalHint":
    "As rotas interestaduais para {uf} voltam a não verificadas (ficam para o IOB e a matriz CONFAZ).",
  "scopeFix.dialog.listLabel": "Só estas UFs de origem",
  "scopeFix.dialog.listHint":
    "Marque as origens que o documento prova; as demais voltam a não verificadas.",
  "scopeFix.dialog.listProblem": "Mantenha ao menos uma UF e retire ao menos uma.",
  "scopeFix.dialog.reason": "Motivo da correção",
  "scopeFix.dialog.boundary":
    "Cria uma nova revisão de cada fato e mantém todo o histórico. O cálculo em sombra usa o novo escopo na hora. Ampliar de novo exige uma nova revisão do grupo ou do fato.",
  "scopeFix.dialog.submit": "Restringir escopo",
  "scopeFix.dialog.doneTitle": "Escopo corrigido",
  "scopeFix.dialog.done": "{restricted} de {facts} fatos com o escopo restringido.",
  "scopeFix.dialog.doneHint":
    "Cada fato ganhou uma nova revisão com o evento “Escopo restringido”; a confirmação original segue no histórico.",
  "scopeFix.dialog.correction": "Correção",
  "scopeFix.dialog.replayed": "já aplicada antes (repetição)",
  "scopeFix.dialog.problem.stale": "O fato mudou desde que foi aberto. Recarregue e tente de novo.",
  "scopeFix.dialog.problem.notAllowed":
    "Nada a restringir para esse escopo (já está dentro dele, ou ampliaria).",
  "scopeFix.dialog.problem.error": "Não foi possível corrigir o escopo. Tente de novo.",
  "scopeFix.skip.NOT_VERIFIED": "não está mais verificado",
  "scopeFix.skip.NOT_FOUND": "não encontrado",
  "scopeFix.skip.NOT_ST_SEGMENT": "sem escopo de origem",
  "scopeFix.skip.ALREADY_WITHIN": "já dentro desse escopo",
  "scopeFix.skip.OUTSIDE_EXTRACTED": "o fato não cita essas origens",
  "scopeFix.skip.WIDENS": "ampliaria o escopo (use uma nova revisão)",
  "scopeFix.history.hint":
    "Grupos já confirmados, com o escopo que decidiram e o que seus fatos cobrem hoje. Corrija aqui um grupo confirmado com origens demais.",
  "scopeFix.history.empty": "Nenhum grupo confirmado ainda",
  "scopeFix.history.emptyBody": "Os grupos aparecem aqui depois de “Confirmar grupo”.",
  "scopeFix.history.confirmed": "{who} · {when} · {count} fatos",
  "scopeFix.history.decision": "Decisão:",
  "scopeFix.history.facts": "{count} fatos",
  "scopeFix.history.restricted": "corrigido",
  "scopeFix.history.noneVerified": "Nenhum fato segue verificado.",
  "scopeFix.history.wide":
    "Cobre origens interestaduais sem acordo CONFAZ verificado: revise o escopo.",
  "scopeFix.history.correction": "{scope} · {who} · {when} · {count} fatos",
  "scopeFix.history.first": "Mais recentes",
  "scopeFix.history.more": "Mais antigos",
  "scopeFix.decision.AS_EXTRACTED": "Como extraído",
  "scopeFix.decision.INTERNAL_ONLY": "Só operações internas",
  "scopeFix.decision.AGREEMENT_ORIGINS": "Internas + origens signatárias",
  "scopeFix.event.restricted": "Escopo verificado agora: {ufs}",
  "factReview.blocker.ALL_ORIGINS":
    "Confirme que o documento prova a retenção de todas as UFs e justifique.",
  "verification.tab.confirmed": "Grupos confirmados",
  "verification.event.SCOPE_RESTRICTED": "Escopo restringido",
  "verification.scope.verifiedOrigins": "verificado só para as origens: {ufs}",
  "audit.scope.title": "Escopo de origem",
  "audit.scope.decision": "Escopo decidido",
  "audit.scope.proposed": "Escopo proposto",
  "audit.scope.restriction": "Restringido para",
  "audit.scope.previous": "Cobria antes",
  "audit.scope.origins": "UFs de origem cobertas",
  "audit.scope.acknowledged": "Todas as origens: justificativa",
  "audit.scope.allUfs": "todas as {count} UFs",
  "audit.action.fiscal-fact.confirm": "Fato fiscal confirmado",
  "audit.action.fiscal-fact.scope-restricted": "Escopo de origem do fato restringido",
  "audit.action.fiscal-fact-review.confirmed": "Grupo de fatos confirmado",
  "audit.action.fiscal-fact-review.scope-restricted": "Escopo do grupo confirmado corrigido",
  "audit.resource.fiscal_fact_review_session": "Revisão de grupo",
  "verification.tab.nfe": "Notas fiscais",
  "ruleDrafts.origin.NFE_OBSERVATION": "Observação de NF-e",
  "ruleDrafts.flag.NFE_CORROBORATION_ONLY":
    "NF-e só corrobora: não é fonte legal; alíquotas em branco até o ato oficial",
  "ruleDrafts.corroboration":
    "Corroboração NF-e: {invoices} notas, {items} itens, CFOP {cfop} ({status}). Não é fonte legal.",
  "nfe.boundary":
    "Notas fiscais corroboram como fornecedores reais tributaram operações reais. Não são fonte legal: nada aqui certifica um fato, altera ou publica uma regra. A comparação com a plataforma é só leitura.",
  "nfe.privacy":
    "Privacidade: o XML bruto, nomes, endereços, e-mails e telefones não são guardados. Ficam só os campos fiscais, a chave de acesso e o CNPJ do emitente.",
  "nfe.upload.title": "Enviar notas fiscais",
  "nfe.upload.hint":
    "XML autorizados da NF-e (layout 4.00), um a um ou dentro de um .zip com milhares de notas. Eventos de cancelamento (procEventoNFe 110111) podem ir no mesmo envio; notas canceladas e cópias Omie XML_Invertido nunca chegam aos caminhos.",
  "nfe.upload.drop": "Arraste arquivos .xml ou .zip para cá",
  "nfe.upload.dropActive": "Solte para adicionar",
  "nfe.upload.limits":
    "XML até {xml} cada · um .zip de até {zip} vai em um envio; maior que isso é descompactado neste navegador e enviado em partes · XML soltos em envios de até {files} arquivos e {chunk}.",
  "nfe.upload.unpacking": "Lendo {name}…",
  "nfe.upload.unpackFailed": "Não foi possível ler {name} no navegador: {reason}",
  "nfe.upload.pick": "Escolher arquivos",
  "nfe.upload.addMore": "Adicionar mais",
  "nfe.upload.selected": "{count} arquivos selecionados",
  "nfe.upload.ready.one": "{count} arquivo pronto",
  "nfe.upload.ready.other": "{count} arquivos prontos",
  "nfe.upload.readyDetail": "· {xml} XML, {zip} ZIP · {size} · {requests} envios",
  "nfe.upload.rejected.one": "{count} arquivo não será enviado:",
  "nfe.upload.rejected.other": "{count} arquivos não serão enviados:",
  "nfe.upload.reject.EXTENSION": "só .xml ou .zip",
  "nfe.upload.reject.EMPTY": "arquivo vazio",
  "nfe.upload.reject.XML_TOO_LARGE": "XML acima de 3 MB",
  "nfe.upload.reject.ZIP_TOO_LARGE":
    "zip acima de 8 MB e este navegador não consegue descompactá-lo: divida em arquivos menores",
  "nfe.upload.more": "e mais {count}",
  "nfe.upload.send.one": "Enviar {count} arquivo",
  "nfe.upload.send.other": "Enviar {count} arquivos",
  "nfe.upload.clear": "Limpar seleção",
  "nfe.upload.progress": "Envio {done} de {total}",
  "nfe.upload.progressFiles": "{done} de {total} arquivos processados",
  "nfe.upload.progressLabel": "Progresso do envio de notas fiscais",
  "nfe.upload.cancel": "Parar após o envio atual",
  "nfe.upload.cancelled":
    "Envio interrompido. Os envios concluídos foram importados; os demais podem ser retomados.",
  "nfe.upload.failedRequests.one": "{count} envio falhou.",
  "nfe.upload.failedRequests.other": "{count} envios falharam.",
  "nfe.upload.retry.one": "Retomar {count} envio",
  "nfe.upload.retry.other": "Retomar {count} envios",
  "nfe.upload.openBatch": "Abrir lote",
  "nfe.upload.again": "Novo envio",
  "nfe.upload.toast": "{imported} de {total} notas importadas",
  "nfe.outcome.IMPORTED": "Importada",
  "nfe.outcome.IMPORTED.plural": "Importadas",
  "nfe.outcome.DUPLICATE": "Duplicada",
  "nfe.outcome.DUPLICATE.plural": "Duplicadas",
  "nfe.outcome.INVALID": "Inválida",
  "nfe.outcome.INVALID.plural": "Inválidas",
  "nfe.outcome.SKIPPED": "Ignorada",
  "nfe.outcome.SKIPPED.plural": "Ignoradas",
  "nfe.outcome.CANCELLED": "Cancelada",
  "nfe.outcome.CANCELLED.plural": "Canceladas",
  "nfe.tally.items": "Itens",
  "nfe.tally.paths": "Caminhos afetados",
  "nfe.files.file": "Arquivo",
  "nfe.files.inside": "em {container}",
  "nfe.files.outcome": "Resultado",
  "nfe.files.reason": "Motivo",
  "nfe.files.accessKey": "Chave de acesso",
  "nfe.files.items": "Itens",
  "nfe.files.filter": "Filtrar por resultado",
  "nfe.files.all": "Todos",
  "nfe.files.none": "Nenhum arquivo com este resultado.",
  "nfe.files.caption": "Resultado por arquivo",
  "nfe.files.showMore": "Mostrar mais ({shown} de {total})",
  "nfe.reason.ALREADY_IMPORTED": "Chave já importada antes",
  "nfe.reason.REPEATED_IN_UPLOAD": "Repetida neste envio",
  "nfe.reason.REPLACED_INVERTED_COPY":
    "O original substituiu uma cópia invertida do ERP guardada antes",
  "nfe.reason.PROTOCOL_CANCELLED": "Cancelada: o protocolo indica (cStat 101/135/155)",
  "nfe.reason.CANCELLATION_EVENT": "Evento de cancelamento (110111); a nota fica fora dos caminhos",
  "nfe.reason.NOT_NFE_DOCUMENT": "Não é NF-e (CT-e, MDF-e ou inutilização)",
  "nfe.reason.EVENT_IGNORED": "Evento de NF-e que não é cancelamento",
  "nfe.reason.INVERTED_ERP_COPY":
    "Cópia invertida do ERP (Omie XML_Invertido), não a nota autorizada",
  "nfe.reason.NOT_XML": "Não é XML (ex.: DANFE em PDF)",
  "nfe.reason.DIRECTORY": "Pasta dentro do zip",
  "nfe.reason.SYSTEM_FILE": "Arquivo de sistema (ex.: __MACOSX)",
  "nfe.reason.NESTED_ZIP": "Zip dentro de zip não é aberto",
  "nfe.reason.FOREIGN_OPERATION": "Operação com o exterior (idDest 3)",
  "nfe.reason.FILE_TOO_LARGE": "Arquivo grande demais",
  "nfe.reason.ZIP_INVALID": "Zip ilegível",
  "nfe.reason.ZIP_TOO_MANY_ENTRIES": "Zip com entradas demais",
  "nfe.reason.ZIP_TOO_LARGE": "Zip expande além do limite",
  "nfe.reason.ZIP_ENTRY_UNSAFE_PATH": "Caminho inseguro dentro do zip",
  "nfe.reason.ZIP_ENTRY_ENCRYPTED": "Entrada protegida por senha",
  "nfe.reason.ZIP_ENTRY_UNSUPPORTED": "Compressão não suportada",
  "nfe.reason.ZIP_ENTRY_TOO_LARGE": "XML grande demais dentro do zip",
  "nfe.reason.ZIP_ENTRY_RATIO": "Taxa de compressão suspeita",
  "nfe.reason.ZIP_ENTRY_CORRUPT": "Entrada corrompida",
  "nfe.reason.TOO_MANY_DOCUMENTS": "Documentos demais neste envio",
  "nfe.reason.XML_MALFORMED": "XML malformado",
  "nfe.reason.XML_DTD_FORBIDDEN": "XML com DTD não é aceito",
  "nfe.reason.NOT_NFE": "Não é uma NF-e",
  "nfe.reason.UNSUPPORTED_VERSION": "Layout diferente do 4.00",
  "nfe.reason.UNSUPPORTED_MODEL": "Modelo diferente de 55",
  "nfe.reason.INVALID_ACCESS_KEY": "Chave de acesso inválida (dígito verificador)",
  "nfe.reason.ACCESS_KEY_MISMATCH": "Chave não confere com os dados da nota",
  "nfe.reason.NOT_AUTHORIZED": "Sem protocolo de autorização",
  "nfe.reason.HOMOLOGATION": "Nota de homologação (teste)",
  "nfe.reason.MISSING_FIELD": "Campo obrigatório ausente",
  "nfe.reason.INVALID_FIELD": "Campo com valor inválido",
  "nfe.reason.TOO_MANY_ITEMS": "Itens acima de 990",
  "nfe.batches.title": "Lotes importados",
  "nfe.batches.empty":
    "Nenhum lote ainda. Os envios aparecem aqui com o resultado de cada arquivo.",
  "nfe.batch.status.COMPLETED": "Concluído",
  "nfe.batch.status.COMPLETED_WITH_ERRORS": "Com inválidas",
  "nfe.batch.files.one": "{count} arquivo",
  "nfe.batch.files.other": "{count} arquivos",
  "nfe.batch.entries.one": "{count} documento",
  "nfe.batch.entries.other": "{count} documentos",
  "nfe.batch.byYou": "por você",
  "nfe.batch.by": "por operador {id}",
  "nfe.batch.result": "{items} itens · {paths} caminhos",
  "nfe.batch.title": "Lote de {when}",
  "nfe.paths.title": "Caminhos fiscais observados",
  "nfe.paths.hint":
    "Itens com a mesma rota, NCM, CFOP, operação e tratamento formam um caminho, comparado com a regra publicada, os fatos CERTIFICADOS/VERIFICADOS e o IOB.",
  "nfe.paths.count.one": "{count} caminho",
  "nfe.paths.count.other": "{count} caminhos",
  "nfe.paths.truncated":
    "Há mais caminhos do que uma comparação lê de uma vez. Refine por UF ou NCM para ver todos.",
  "nfe.paths.empty.title": "Nenhuma nota fiscal importada ainda",
  "nfe.paths.empty.body":
    "Envie XML ou um .zip de NF-e acima. Cada item vira evidência de corroboração, nunca uma regra.",
  "nfe.paths.empty.readOnly":
    "Quando notas forem importadas, os caminhos observados aparecem aqui.",
  "nfe.column.route": "Rota",
  "nfe.column.operation": "Operação",
  "nfe.column.treatment": "Tratamento",
  "nfe.column.invoices": "Notas",
  "nfe.column.items": "Itens",
  "nfe.column.emitters": "Emitentes",
  "nfe.column.period": "Período",
  "nfe.column.status": "Comparação",
  "nfe.column.inconsistent.one": "{count} item com valores inconsistentes",
  "nfe.column.inconsistent.other": "{count} itens com valores inconsistentes",
  "nfe.status.MATCHES": "Confere",
  "nfe.status.DIVERGES": "Diverge",
  "nfe.status.NOT_COVERED": "Sem cobertura",
  "nfe.scope.INTERNAL": "Interna",
  "nfe.scope.INTERSTATE": "Interestadual",
  "nfe.recipient.CONTRIBUTOR": "Contribuinte",
  "nfe.recipient.EXEMPT_CONTRIBUTOR": "Contribuinte isento",
  "nfe.recipient.NON_CONTRIBUTOR": "Não contribuinte",
  "nfe.operation.finalConsumer": "consumidor final",
  "nfe.operation.entry": "entrada",
  "nfe.operation.fin.1": "normal",
  "nfe.operation.fin.2": "complementar",
  "nfe.operation.fin.3": "ajuste",
  "nfe.operation.fin.4": "devolução",
  "nfe.filter.origin": "UF de origem",
  "nfe.filter.destination": "UF de destino",
  "nfe.filter.anyUf": "Todas",
  "nfe.filter.ncm": "NCM (prefixo)",
  "nfe.filter.ncmPlaceholder": "Ex.: 2202",
  "nfe.filter.ncmHint": "Use de 2 a 8 dígitos.",
  "nfe.filter.status": "Comparação",
  "nfe.treatment.title": "Tratamento observado",
  "nfe.treatment.reduced": "base reduzida {rate}",
  "nfe.treatment.st": "ST",
  "nfe.treatment.retained": "ST retida anteriormente",
  "nfe.treatment.difal": "DIFAL",
  "nfe.treatment.group": "Grupo",
  "nfe.treatment.orig": "Origem",
  "nfe.treatment.stTitle": "ICMS-ST",
  "nfe.treatment.notStated": "Não informado nas notas.",
  "nfe.treatment.ibsNote":
    "IBS/CBS aparecem como informados na nota; só observados, nunca comparados.",
  "nfe.orig.0": "nacional",
  "nfe.orig.1": "estrangeira, importação direta",
  "nfe.orig.2": "estrangeira, mercado interno",
  "nfe.orig.3": "nacional, conteúdo importado > 40%",
  "nfe.orig.4": "nacional, processo produtivo básico",
  "nfe.orig.5": "nacional, conteúdo importado ≤ 40%",
  "nfe.orig.6": "estrangeira sem similar (CAMEX), direta",
  "nfe.orig.7": "estrangeira sem similar (CAMEX), interno",
  "nfe.orig.8": "nacional, conteúdo importado > 70%",
  "nfe.volume.title": "Volume observado",
  "nfe.value.yes": "Sim",
  "nfe.value.no": "Não",
  "nfe.detail.boundary":
    "Comparação só leitura. As notas corroboram; não substituem a evidência legal nem alteram a regra.",
  "nfe.compare.title": "Esperado × observado",
  "nfe.compare.field": "Campo",
  "nfe.compare.expected": "Esperado pela plataforma",
  "nfe.compare.observed": "Observado nas notas",
  "nfe.compare.result": "Resultado",
  "nfe.compare.state.diverges": "diverge",
  "nfe.compare.state.matches": "confere",
  "nfe.compare.state.skipped": "não comparado",
  "nfe.compare.notStated": "Não declarado",
  "nfe.compare.notComparable": "Não comparável",
  "nfe.compare.adjusted": "MVA original {original} · ajustada {adjusted}",
  "nfe.compare.rule": "Regra publicada",
  "nfe.compare.noRule": "Nenhuma regra publicada cobre esta rota",
  "nfe.compare.factLevel": "Nível dos fatos",
  "nfe.compare.facts.one": "{count} fato",
  "nfe.compare.facts.other": "{count} fatos",
  "nfe.compare.comparedOn": "Comparado com o estado de",
  "nfe.factLevel.PUBLISHED_RULE": "Regra publicada",
  "nfe.factLevel.CERTIFIED": "Certificado",
  "nfe.factLevel.VERIFIED": "Verificado",
  "nfe.factLevel.UNVERIFIED": "Não verificado (não usado)",
  "nfe.factLevel.NONE": "Nenhum fato",
  "nfe.source.PUBLISHED_RULE": "Regra publicada",
  "nfe.source.FISCAL_FACT": "Fato fiscal",
  "nfe.source.FISCAL_FACT.CERTIFIED": "Fato certificado",
  "nfe.source.FISCAL_FACT.VERIFIED": "Fato verificado",
  "nfe.source.IOB_FINDING": "IOB",
  "nfe.source.SENATE_RESOLUTION_13_2012": "Res. Senado 13/2012",
  "nfe.field.stApplicable": "ST",
  "nfe.field.mva": "MVA",
  "nfe.field.destinationInternalRate": "Alíquota interna destino",
  "nfe.field.interstateRate": "Alíquota interestadual",
  "nfe.field.fcpRate": "FCP",
  "nfe.stMode.RETAINED": "retida pelo remetente",
  "nfe.stMode.PREVIOUSLY_RETAINED": "retida anteriormente",
  "nfe.stMode.NONE": "sem ST",
  "nfe.note.ST_PREVIOUSLY_RETAINED":
    "CST 60 / CSOSN 500: a ST foi retida antes; em operação interestadual o ST sim/não não é comparado.",
  "nfe.note.FINAL_CONSUMER":
    "Consumidor final: ST e MVA não são comparados (a ST trata da cadeia de revenda).",
  "nfe.note.ST_BASE_NOT_MVA": "A base da ST não é MVA (pauta, preço de lista): MVA não comparada.",
  "nfe.note.SIMPLES_NACIONAL":
    "Simples Nacional (CSOSN): a alíquota própria do ICMS não consta no item.",
  "nfe.note.IMPORTED_GOODS":
    "Origem 1, 2, 3 ou 8: vale a interestadual de 4% (Res. Senado 13/2012).",
  "nfe.note.INTERNAL_ST_ONLY": "O IOB indicou ST só interna: sem retenção pelo remetente.",
  "nfe.note.ADJUSTED_MVA": "A MVA observada confere com a MVA ajustada, não com a original.",
  "nfe.note.RULE_FACT_DISAGREE":
    "Regra publicada e fatos certificados discordam; a regra foi usada.",
  "nfe.note.NOT_ORDINARY_SALE":
    "Entrada, complementar, ajuste ou devolução: não é uma venda comum.",
  "nfe.note.REDUCED_BASE": "Base reduzida (pRedBC / pRedBCST): comparadas as alíquotas nominais.",
  "nfe.note.INCONSISTENT_ITEMS": "Alguns itens falharam nas verificações internas de valor.",
  "nfe.note.FACTS_UNRESOLVED":
    "Os fatos certificados são ambíguos ou conflitantes para esta chave.",
  "nfe.consistency.title": "Consistência dos itens",
  "nfe.consistency.body.one":
    "{count} de {items} itens tem valor diferente de base × alíquota além do arredondamento.",
  "nfe.consistency.body.other":
    "{count} de {items} itens têm valor diferente de base × alíquota além do arredondamento.",
  "nfe.consistency.sample": "Amostra de itens inconsistentes",
  "nfe.consistency.item": "Item nº",
  "nfe.consistency.issues": "Verificações",
  "nfe.issue.ICMS_VALUE_MISMATCH": "vICMS ≠ base × pICMS",
  "nfe.issue.FCP_VALUE_MISMATCH": "vFCP ≠ base × pFCP",
  "nfe.issue.ICMS_ST_BASE_MISMATCH": "Base da ST não confere com a MVA",
  "nfe.issue.ICMS_ST_VALUE_MISMATCH": "vICMSST não confere",
  "nfe.issue.FCP_ST_VALUE_MISMATCH": "vFCPST não confere",
  "nfe.issue.ST_RETAINED_VALUE_MISMATCH": "ST retida (vICMSSTRet) não confere",
  "nfe.issue.DIFAL_VALUE_MISMATCH": "DIFAL (vICMSUFDest) não confere",
  "nfe.issue.IPI_VALUE_MISMATCH": "vIPI ≠ base × pIPI",
  "nfe.issue.PIS_VALUE_MISMATCH": "vPIS ≠ base × alíquota",
  "nfe.issue.COFINS_VALUE_MISMATCH": "vCOFINS ≠ base × alíquota",
  "nfe.issue.IBS_CBS_VALUE_MISMATCH": "IBS/CBS ≠ base × alíquota",
  "nfe.invoices.title": "Notas de amostra {count}",
  "nfe.invoices.hint":
    "Mais recentes primeiro. Só chave de acesso, data de emissão e CNPJ do emitente.",
  "nfe.invoices.none": "Sem notas de amostra.",
  "nfe.invoices.issuedAt": "Emissão",
  "nfe.invoices.emitter": "CNPJ do emitente",
  "nfe.invoices.cpf": "Emitente pessoa física (não guardado)",
  "nfe.drafts.title": "Rascunhos criados a partir deste caminho",
  "nfe.drafts.none": "Nenhum rascunho ainda.",
  "nfe.drafts.open": "Abrir no rascunho do conjunto",
  "nfe.drafts.publications": "Ver Publicações",
  "nfe.draft.action": "Criar rascunho de proposta",
  "nfe.draft.title": "Criar rascunho de proposta a partir das notas",
  "nfe.draft.volume": "{invoices} notas · {items} itens",
  "nfe.draft.body":
    "Prepara um rascunho no próximo conjunto em rascunho ({version}) com esta observação anexada como corroboração NF-e (tipo NFE_OBSERVATION).",
  "nfe.draft.bodyNoVersion":
    "Prepara um rascunho no próximo conjunto em rascunho com esta observação anexada como corroboração NF-e (tipo NFE_OBSERVATION).",
  "nfe.draft.point.corroboration": "As notas entram como corroboração, nunca como fonte legal.",
  "nfe.draft.point.rates": "As alíquotas ficam em branco até serem lidas do ato oficial.",
  "nfe.draft.point.nothingAutomatic": "Nada é aprovado nem publicado automaticamente.",
  "nfe.draft.evidence":
    "A evidência legal oficial ainda precisa ser anexada e aprovada em Documentos antes que a proposta possa ser aprovada.",
  "nfe.draft.noDraft":
    'Não há conjunto em rascunho. Em Publicações, use "Preparar próximo rascunho" e volte aqui.',
  "nfe.draft.matches": "Este caminho confere com a plataforma: não há o que propor.",
  "nfe.draft.reason": "Motivo (opcional)",
  "nfe.draft.reasonHint":
    "Se informar, use ao menos 10 caracteres. Fica no rascunho e na auditoria.",
  "nfe.draft.confirm": "Criar rascunho",
  "nfe.draft.creating": "Criando…",
  "nfe.draft.created": "Rascunho criado em {version}",
  "nfe.draft.existing": "Este caminho já tinha rascunho em {version}",
  "nfe.draft.toastBody":
    "Anexe e aprove a evidência oficial em Documentos antes de enviar a proposta.",
  "nfe.draft.open": "Abrir rascunhos de {version}",
  /* Insights — calculation / lot summary + header inbox */
  "insights.eyebrow": "Insights",
  "insights.title.calculation": "O que este cálculo mostra",
  "insights.title.lot": "O que este lote mostra",
  "insights.headline.driver":
    "{driver} representa {share} dos tributos em {calculated} linhas calculadas",
  "insights.headline.review.one": "{count} linha precisa de revisão",
  "insights.headline.review.other": "{count} linhas precisam de revisão",
  "insights.headline.empty": "Aguardando linhas calculadas com regra publicada.",
  "insights.kpi.purchaseTax": "Tributos na compra",
  "insights.kpi.effectiveRate": "Alíquota efetiva",
  "insights.kpi.effectiveRateCaption": "sobre o valor das mercadorias {amount}",
  "insights.kpi.linesCalculated": "Linhas calculadas",
  "insights.kpi.linesCalculatedValue": "{calculated} / {total}",
  "insights.kpi.valueAtRisk": "Valor em risco",
  "insights.kpi.valueAtRiskCaption": "valor das mercadorias nas linhas em revisão",
  "insights.kpi.saleTax": "Tributos na venda",
  "insights.drivers.title": "Principais tributos",
  "insights.drivers.empty":
    "Nenhuma linha calculada ainda — os tributos aparecem quando uma linha tem regra.",
  "insights.drivers.saleHeading": "Na venda",
  "insights.drivers.onLines.one": "em {count} linha",
  "insights.drivers.onLines.other": "em {count} linhas",
  "insights.drivers.a11y": "{name}: {amount}, {share}, em {lines} linhas",
  "insights.driver.ICMS_ST": "ICMS-ST",
  "insights.driver.IPI": "IPI",
  "insights.driver.FCP": "FCP/FECP",
  "insights.driver.OTHER_PURCHASE": "Outros tributos na compra",
  "insights.driver.PIS_COFINS": "PIS/COFINS na venda",
  "insights.driver.DIFAL": "DIFAL na venda",
  "insights.review.title": "Precisa de revisão",
  "insights.review.reason.NO_RULE": "Sem regra",
  "insights.review.reason.AMBIGUOUS_RULE": "Regra ambígua",
  "insights.review.reason.STALE_RULE": "Regra vencida",
  "insights.review.reason.UNVERIFIED_DATA": "Dados não verificados",
  "insights.review.reason.INPUT_DATA": "Dados de entrada",
  "insights.review.reason.PENDING_CONFIRMATION": "Confirmação pendente",
  "insights.review.reason.OTHER": "Outro",
  "insights.review.explain.NO_RULE": "Não há regra publicada para este NCM e rota",
  "insights.review.explain.AMBIGUOUS_RULE": "Mais de uma regra coincide — escolha uma",
  "insights.review.explain.STALE_RULE": "A regra usada venceu na data fiscal",
  "insights.review.explain.UNVERIFIED_DATA":
    "Os dados foram encontrados, mas aguardam verificação — os valores ficam iguais até a revisão",
  "insights.review.explain.INPUT_DATA":
    "Faltam dados de entrada ou estão inválidos (NCM, UF, custo ou alíquotas)",
  "insights.review.explain.PENDING_CONFIRMATION":
    "Um perfil ou classificação precisa da sua confirmação",
  "insights.review.explain.OTHER": "Precisa de uma checagem financeira",
  "insights.review.lines.one": "{count} linha",
  "insights.review.lines.other": "{count} linhas",
  "insights.review.valueAtRisk": "Valor em risco: {amount}",
  "insights.review.action": "Revisar linhas",
  "insights.review.staleNote.one":
    "{count} linha calculada usa uma regra que venceu na data fiscal",
  "insights.review.staleNote.other":
    "{count} linhas calculadas usam uma regra que venceu na data fiscal",
  "insights.savings.title": "Oportunidade de economia",
  "insights.savings.headline": "Até {amount} a menos de ICMS-ST em uma rota comparável",
  "insights.savings.row":
    "NCM {ncm} · {origin} → {destination} paga {rate} de ST; de {comparable} → {destination} é {comparableRate}",
  "insights.savings.footnote":
    "Estimativa a partir das linhas deste cálculo com o mesmo NCM e destino; não é aconselhamento tributário.",
  "insights.research.title": "Em pesquisa",
  "insights.research.chip.running": "{count} em execução",
  "insights.research.chip.queued": "{count} na fila",
  "insights.research.chip.found": "{count} encontradas",
  "insights.research.chip.needsReview": "{count} para revisar",
  "insights.research.chip.notFoundFailed": "{count} sem achado / falha",
  "insights.research.gap": "{ncm} · {origin} → {destination} — {status}, previsão {eta}",
  "insights.research.status.QUEUED": "na fila",
  "insights.research.status.RUNNING": "em execução",
  "insights.research.idle": "Nenhuma busca em execução agora",
  "insights.research.open": "Abrir pesquisa",
  "insights.revision.title": "O que mudou na revisão {number}",
  "insights.revision.noValueBefore": "Sem valor antes",
  "insights.revision.noValueYet": "Ainda sem valor",
  "insights.revision.summary":
    "A revisão {number} alterou {changed} de {total} linhas; tributos nas linhas com valor antes e depois: {delta}.",
  "insights.revision.newlyCalculated.one":
    "{count} linha foi calculada pela primeira vez ({amount} em tributos)",
  "insights.revision.newlyCalculated.other":
    "{count} linhas foram calculadas pela primeira vez ({amount} em tributos)",
  "insights.revision.cause.NEW_RULE": "Nova regra publicada",
  "insights.revision.cause.RULE_CHANGED": "Regra alterada",
  "insights.revision.cause.UNVERIFIED_PENDING": "Dados encontrados, pendentes de verificação",
  "insights.revision.cause.FACTS_NOT_APPLIED": "Fatos comparados, não aplicados",
  "insights.revision.cause.RULESET_UPDATED": "Conjunto de regras atualizado",
  "insights.revision.cause.STATUS_CHANGED": "Status alterado",
  "insights.revision.ruleset": "Regras v{before} → v{after}",
  "insights.inbox.trigger": "Insights",
  "insights.inbox.triggerUnread": "Insights, {count} não lidos",
  "insights.inbox.unread": "Não lido",
  "insights.inbox.title": "Insights",
  "insights.inbox.empty": "Nada novo — insights dos seus cálculos aparecem aqui.",
  "insights.inbox.generic": "Novo insight",
  "insights.inbox.atRisk": "{amount} em risco",
  "insights.inbox.badgeMore": "9+",
  "insights.inbox.kind.RECALCULATION_READY.one":
    "{count} linha pode ser recalculada com novas regras",
  "insights.inbox.kind.RECALCULATION_READY.other":
    "{count} linhas podem ser recalculadas com novas regras",
  "insights.inbox.kind.RESEARCH_FOUND.one": "A pesquisa encontrou dados para {count} linha",
  "insights.inbox.kind.RESEARCH_FOUND.other": "A pesquisa encontrou dados para {count} linhas",
  "insights.inbox.kind.RESEARCH_NEEDS_REVIEW.one":
    "{count} resultado de pesquisa aguarda verificação",
  "insights.inbox.kind.RESEARCH_NEEDS_REVIEW.other":
    "{count} resultados de pesquisa aguardam verificação",
  "insights.inbox.kind.RESEARCH_RUNNING.one": "{count} busca em execução",
  "insights.inbox.kind.RESEARCH_RUNNING.other": "{count} buscas em execução",
  "insights.inbox.kind.REVIEW_REQUIRED.one": "{count} linha precisa de revisão",
  "insights.inbox.kind.REVIEW_REQUIRED.other": "{count} linhas precisam de revisão",
  "insights.inbox.kind.RULE_PUBLISHED.one": "Nova regra publicada afetando {count} linha",
  "insights.inbox.kind.RULE_PUBLISHED.other": "Nova regra publicada afetando {count} linhas",
  "insights.inbox.kind.SAVINGS_OPPORTUNITY": "Possível economia de {amount}",
  /* Notas fiscais workspace (tax managers) */
  "shell.nav.invoices": "Notas fiscais",
  "inv.title": "Notas fiscais",
  "inv.description":
    "Envie as notas fiscais da empresa, veja-as por mês, valide cada mês e leia os achados.",
  "inv.upload.open": "Enviar notas fiscais",
  "inv.upload.hide": "Fechar envio",
  "inv.views.label": "Áreas das notas fiscais",
  "inv.views.months": "Meses",
  "inv.views.batches": "Lotes de envio",
  "inv.batches.hint":
    "Um envio pode misturar meses: cada nota vai para o mês da sua data de emissão. Aqui estão os lotes enviados e o que aconteceu com cada arquivo.",
  "inv.readOnly":
    "Somente leitura: revisar e validar meses exige a permissão de revisão de regras.",
  "inv.empty.title": "Nenhuma nota fiscal ainda",
  "inv.empty.body":
    "Envie os XML ou ZIP das notas da empresa. Elas são organizadas por mês de emissão, emitidas e recebidas.",
  "inv.empty.readOnly":
    "Ainda não há notas fiscais. Quem pode enviar arquivos precisa fazer o primeiro envio.",
  "inv.direction.label": "Direção",
  "inv.direction.ALL": "Todas as notas",
  "inv.direction.EMITIDA": "Emitidas",
  "inv.direction.RECEBIDA": "Recebidas",
  "inv.direction.EMITIDA.tag": "Emitida",
  "inv.direction.RECEBIDA.tag": "Recebida",
  "inv.status.NOT_REVIEWED": "Não revisado",
  "inv.status.IN_REVIEW": "Em revisão",
  "inv.status.VALIDATED": "Validado",
  "inv.severity.HIGH": "Alta",
  "inv.severity.MEDIUM": "Média",
  "inv.severity.LOW": "Baixa",
  "inv.nav.label": "Períodos",
  "inv.nav.title": "Períodos",
  "inv.nav.change": "Mudar de mês",
  "inv.nav.choose": "Escolher um mês",
  "inv.nav.yearLabel": "Meses de {year}",
  "inv.nav.months.one": "{count} mês",
  "inv.nav.months.other": "{count} meses",
  "inv.nav.pending.one": "{count} a validar",
  "inv.nav.pending.other": "{count} a validar",
  "inv.nav.invoices.one": "{count} nota",
  "inv.nav.invoices.other": "{count} notas",
  "inv.nav.diverging.one": "{count} diverge",
  "inv.nav.diverging.other": "{count} divergem",
  "inv.nav.high.one": "{count} alto",
  "inv.nav.high.other": "{count} altos",
  "inv.nav.reopened": "Reaberto",
  "inv.nav.outside.one":
    "{count} nota na base não é emitida nem recebida pela empresa e fica fora desta área.",
  "inv.nav.outside.other":
    "{count} notas na base não são emitidas nem recebidas pela empresa e ficam fora desta área.",
  "inv.affected.title.one": "O envio tocou {count} mês",
  "inv.affected.title.other": "O envio tocou {count} meses",
  "inv.affected.text.one": "{count} nota nova ou alterada, colocada no mês da sua data de emissão.",
  "inv.affected.text.other":
    "{count} notas novas ou alteradas, colocadas no mês da sua data de emissão.",
  "inv.affected.changed.one": "{count} nota",
  "inv.affected.changed.other": "{count} notas",
  "inv.affected.reopened": "Voltou para revisão",
  "inv.month.older": "Mês anterior",
  "inv.month.newer": "Próximo mês",
  "inv.month.openBatch": "Ver o lote",
  "inv.month.reopened.one":
    "Este mês estava validado e voltou para revisão: um envio em {when} trouxe {count} nota nova ou alterada. Revise antes de validar de novo.",
  "inv.month.reopened.other":
    "Este mês estava validado e voltou para revisão: um envio em {when} trouxe {count} notas novas ou alteradas. Revise antes de validar de novo.",
  "inv.dashboard.label": "Números do mês",
  "inv.dashboard.bothDirections": "emitidas e recebidas",
  "inv.dashboard.invoices": "Notas",
  "inv.dashboard.items": "Itens",
  "inv.dashboard.value": "Valor total",
  "inv.dashboard.cancelled": "Canceladas",
  "inv.dashboard.cancelledScope": "não entram nas demais contas",
  "inv.dashboard.cancelledShare": "{share} das notas do mês",
  "inv.dashboard.paths": "Caminhos",
  "inv.dashboard.findings": "Achados",
  "inv.dashboard.aiSuggestions.one": "{count} sugestão da IA",
  "inv.dashboard.aiSuggestions.other": "{count} sugestões da IA",
  "inv.dashboard.byDirection": "Por direção",
  "inv.dashboard.itemsCount.one": "{count} item",
  "inv.dashboard.itemsCount.other": "{count} itens",
  "inv.validation.title": "Validação do mês",
  "inv.validation.notReviewed":
    "Este mês ainda não foi revisado. Inicie a revisão para registrar decisões e validar.",
  "inv.validation.blocked": "Faltam decisões registradas antes de validar o mês.",
  "inv.validation.ready": "Pronto para validar: nada pendente de decisão.",
  "inv.validation.validated": "Mês validado em {when}.",
  "inv.validation.nothingBlocks": "Nada impede a validação deste mês.",
  "inv.validation.bothDirections":
    "A contagem considera emitidas e recebidas, qualquer que seja o filtro de direção.",
  "inv.validation.blocker.paths.one": "{open} de {total} caminho divergente sem decisão",
  "inv.validation.blocker.paths.other": "{open} de {total} caminhos divergentes sem decisão",
  "inv.validation.blocker.findings.one": "{open} de {total} achado alto sem decisão",
  "inv.validation.blocker.findings.other": "{open} de {total} achados altos sem decisão",
  "inv.validation.show.paths": "Ver caminhos",
  "inv.validation.show.findings": "Ver achados",
  "inv.validation.start": "Iniciar revisão",
  "inv.validation.validate": "Validar mês",
  "inv.validation.blockedReason":
    "Registre uma decisão para cada caminho divergente e cada achado alto antes de validar.",
  "inv.validation.reopen": "Reabrir mês",
  "inv.validation.stale":
    "O mês mudou desde que foi carregado. Atualizamos a tela; confira e tente de novo.",
  "inv.validation.done.START_REVIEW": "Revisão de {month} iniciada",
  "inv.validation.done.VALIDATE": "{month} validado",
  "inv.validation.done.REOPEN": "{month} reaberto para revisão",
  "inv.reopen.title": "Reabrir {month}",
  "inv.reopen.body":
    "O mês volta para revisão e precisa ser validado de novo. A reabertura fica no histórico com o motivo.",
  "inv.reopen.reason": "Motivo da reabertura",
  "inv.reopen.confirm": "Reabrir mês",
  "inv.reopen.saving": "Reabrindo…",
  "inv.tabs.label": "Seções do mês",
  "inv.tabs.paths": "Caminhos observados",
  "inv.tabs.findings": "Achados",
  "inv.tabs.ai": "Sugestões da IA",
  "inv.tabs.analysis": "Análise",
  "inv.tabs.history": "Histórico",
  "inv.paths.title": "Caminhos observados no mês",
  "inv.paths.hint":
    "Cada caminho é um tratamento fiscal visto nas notas do mês, comparado com o que a plataforma conhece. Divergências precisam de uma decisão antes da validação.",
  "inv.paths.decision": "Decisão",
  "inv.paths.empty.title": "Nenhum caminho neste mês",
  "inv.paths.empty.body": "Quando houver notas neste mês, os caminhos fiscais aparecem aqui.",
  "inv.filter.all": "Todos",
  "inv.filter.pending": "Pendentes",
  "inv.filter.decided": "Com decisão",
  "inv.filter.decision": "Decisão",
  "inv.filter.review": "Revisão",
  "inv.filter.toReview": "Para revisar",
  "inv.filter.dismissed": "Descartadas",
  "inv.filter.severity": "Gravidade",
  "inv.filter.code": "Verificação",
  "inv.filter.anyCode": "Todas as verificações",
  "inv.findings.title": "Achados das verificações automáticas",
  "inv.findings.hint":
    "Verificações fixas sobre as notas do mês, sempre ativas. Cada achado diz o que vê, o que fazer e quanto está em jogo.",
  "inv.findings.count.one": "{count} achado",
  "inv.findings.count.other": "{count} achados",
  "inv.findings.empty.title": "Nenhum achado em aberto",
  "inv.findings.empty.body": "As verificações automáticas não apontaram nada neste mês.",
  "inv.findings.aiPointer.one": "{count} sugestão da IA aguarda revisão.",
  "inv.findings.aiPointer.other": "{count} sugestões da IA aguardam revisão.",
  "inv.findings.aiPointerAction": "Ver sugestões",
  "inv.finding.action": "O que fazer:",
  "inv.finding.value": "Valor em jogo",
  "inv.finding.valueUnknown": "Não estimado",
  "inv.finding.invoice": "Nota",
  "inv.finding.related": "Nota relacionada",
  "inv.finding.items": "Itens",
  "inv.finding.openPath": "Ver caminho",
  "inv.code.ICMS_ZERO_RATE_ON_TAXED_CST": "ICMS com alíquota zero em CST tributado",
  "inv.code.DIFAL_MISSING_NON_CONTRIBUTOR": "DIFAL ausente para não contribuinte",
  "inv.code.INTERSTATE_RATE_INCONSISTENT": "Alíquota interestadual incoerente com a rota",
  "inv.code.ST_CFOP_WITHOUT_ST_GROUP": "CFOP de ST sem o grupo de ST",
  "inv.code.ST_CST_WITHOUT_ST_VALUES": "CST de ST sem valores de ST",
  "inv.code.REDUCTION_WITHOUT_PRED_BC": "CST de redução sem pRedBC",
  "inv.code.PRED_BC_WITHOUT_REDUCTION_CST": "pRedBC em CST sem redução",
  "inv.code.ICMS_VALUE_MISMATCH": "ICMS diferente de base × alíquota",
  "inv.code.ICMS_ST_BASE_MISMATCH": "Base de ICMS-ST fora da fórmula",
  "inv.code.ICMS_ST_VALUE_MISMATCH": "Valor de ICMS-ST fora da fórmula",
  "inv.code.OTHER_TAX_VALUE_MISMATCH": "Outro tributo fora de base × alíquota",
  "inv.code.PIS_COFINS_ZERO_RATE_CST01": "PIS/COFINS com CST 01 a 0%",
  "inv.code.MONOPHASIC_CHARGED_AS_CST01": "NCM monofásico tributado como CST 01",
  "inv.code.POSSIBLE_DUPLICATE_EMITTED": "Possível duplicidade em nota emitida",
  "inv.code.PLATFORM_RULE_DIVERGENCE": "Caminho diverge do que a plataforma conhece",
  "inv.ack.action": "Registrar decisão",
  "inv.ack.change": "Alterar decisão",
  "inv.ack.pending": "Sem decisão",
  "inv.ack.open": "Em aberto",
  "inv.ack.stale": "Decisão desatualizada",
  "inv.ack.staleHint": "A divergência mudou depois desta decisão. Registre uma nova.",
  "inv.ack.title": "Registrar decisão",
  "inv.ack.titleAi": "Descartar sugestão da IA",
  "inv.ack.resolution": "O que você decidiu?",
  "inv.ack.reason": "Motivo",
  "inv.ack.reasonHint":
    "Obrigatório: de {min} a {max} caracteres. Fica no histórico do mês. ({count})",
  "inv.ack.submit": "Registrar decisão",
  "inv.ack.saving": "Registrando…",
  "inv.ack.convertNote":
    "Cria ou reaproveita um rascunho de proposta de regra. Ele continua precisando de evidência oficial, revisão e aprovação: nada é publicado.",
  "inv.ack.conflict": "Não foi possível registrar agora: o estado do mês não permite esta decisão.",
  "inv.ack.replaces": "Substitui a decisão de {who} em {when}: {resolution}.",
  "inv.ack.done.ACCEPTED_ISSUER_ERROR": "Decisão registrada: erro do emitente",
  "inv.ack.done.ACCEPTED_CORRECT": "Decisão registrada: tratamento correto",
  "inv.ack.done.CONVERTED_TO_DRAFT": "Rascunho de proposta criado",
  "inv.ack.done.DISMISSED": "Sugestão descartada",
  "inv.resolution.ACCEPTED_ISSUER_ERROR": "Erro do emitente",
  "inv.resolution.ACCEPTED_ISSUER_ERROR.short": "Erro do emitente",
  "inv.resolution.ACCEPTED_ISSUER_ERROR.hint":
    "A nota está errada. Registro o motivo e sigo; a plataforma não muda.",
  "inv.resolution.ACCEPTED_CORRECT": "Tratamento correto",
  "inv.resolution.ACCEPTED_CORRECT.short": "Tratamento correto",
  "inv.resolution.ACCEPTED_CORRECT.hint":
    "A nota está certa. Aceito o tratamento observado como válido neste mês.",
  "inv.resolution.CONVERTED_TO_DRAFT": "Criar rascunho de proposta de regra",
  "inv.resolution.CONVERTED_TO_DRAFT.short": "Rascunho criado",
  "inv.resolution.CONVERTED_TO_DRAFT.hint":
    "Prepara um rascunho com este caminho como corroboração. Não aprova nem publica nada.",
  "inv.resolution.DISMISSED": "Descartar sugestão",
  "inv.resolution.DISMISSED.short": "Descartada",
  "inv.resolution.DISMISSED.hint": "Revisei e não vou seguir esta sugestão.",
  "inv.drawer.decision": "Decisão registrada",
  "inv.drawer.decisionWhat": "O quê",
  "inv.drawer.decisionWho": "Quem e quando",
  "inv.drawer.issuerRoot": "Raiz do CNPJ do emitente",
  "inv.ai.title": "Sugestões da IA — precisam de revisão",
  "inv.ai.hint":
    "Hipóteses levantadas por um modelo de IA sobre os dados agregados do mês. Ficam separadas dos achados das verificações automáticas.",
  "inv.ai.boundary":
    "O modelo vê só dados agregados e sem identificação das notas. As sugestões nunca são aplicadas sozinhas, não são evidência e não viram regra: a base legal citada é um ponteiro para verificar em fonte oficial.",
  "inv.ai.analyze": "Analisar com IA",
  "inv.ai.running": "Analisando…",
  "inv.ai.running.reason": "Já existe uma análise de IA deste mês em andamento.",
  "inv.ai.queued": "Análise com IA de {month} na fila",
  "inv.ai.lastRun": "Última análise com IA:",
  "inv.ai.neverRun": "Este mês ainda não teve análise com IA.",
  "inv.ai.cost": "custo {cost}",
  "inv.ai.followUp": "acompanhando o andamento",
  "inv.ai.reason.ARGON_COST_BOUND_UNAVAILABLE":
    "Argon requer qualificação de capacidades e preços para Taxes antes da análise com IA.",
  "inv.ai.reason.NOT_DEPLOYED": "A análise com IA não está habilitada neste ambiente.",
  "inv.ai.reason.SWITCHED_OFF": "Um administrador desligou a análise com IA nas configurações.",
  "inv.ai.reason.MONTHLY_BUDGET_REACHED": "O orçamento mensal da IA foi atingido.",
  "inv.ai.reason.DAILY_CAP_REACHED": "O limite diário de análises de IA foi atingido.",
  "inv.ai.empty.title": "Nenhuma sugestão da IA neste mês",
  "inv.ai.empty.body":
    "Use “Analisar com IA” para pedir hipóteses sobre este mês. Nada é aplicado.",
  "inv.ai.empty.unavailable":
    "A análise com IA está indisponível agora. As verificações automáticas continuam ativas.",
  "inv.ai.toReview": "Para revisar",
  "inv.ai.dismiss": "Descartar",
  "inv.ai.kind.CANDIDATE_RULE": "Regra candidata",
  "inv.ai.kind.SUSPECTED_ISSUER_ERROR": "Provável erro do emitente",
  "inv.ai.kind.COMPLIANCE_RISK": "Risco de conformidade",
  "inv.ai.kind.RESEARCH_SUGGESTION": "Sugestão de pesquisa",
  "inv.ai.confidence": "Confiança informada pelo modelo",
  "inv.ai.confidenceValue": "Confiança de {percent}%",
  "inv.ai.confidenceNote": "É o número que o modelo declara, não uma probabilidade.",
  "inv.ai.candidate": "Regra candidata (não aplicada)",
  "inv.ai.candidateNote":
    "Uma regra só nasce de uma proposta com evidência oficial, revisão e aprovação.",
  "inv.ai.legal": "Base legal citada pelo modelo — a verificar, não é evidência",
  "inv.ai.query": "Pesquisa sugerida:",
  "inv.settings.open": "Configurações da IA",
  "inv.analysis.title": "Análise do mês",
  "inv.analysis.hint":
    "Execute as verificações automáticas de novo ou peça uma análise com IA, e veja as execuções anteriores e o custo.",
  "inv.analysis.rules": "Verificações automáticas",
  "inv.analysis.rulesText":
    "Regras fixas sobre cada nota e item do mês. Rodam sempre que notas entram e podem ser repetidas aqui.",
  "inv.analysis.rulesLast": "Última execução: {when}",
  "inv.analysis.rulesNever": "Ainda não executadas neste mês.",
  "inv.analysis.runRules": "Executar verificações",
  "inv.analysis.running": "Executando…",
  "inv.analysis.rulesDone.one": "Verificações executadas: {count} achado",
  "inv.analysis.rulesDone.other": "Verificações executadas: {count} achados",
  "inv.analysis.ai": "Análise com IA",
  "inv.analysis.aiText":
    "Opcional. Um modelo lê só os dados agregados do mês e levanta hipóteses para revisão.",
  "inv.analysis.runs": "Execuções",
  "inv.analysis.runsEmpty": "Nenhuma execução registrada",
  "inv.analysis.runCount.one": "{count} execução",
  "inv.analysis.runCount.other": "{count} execuções",
  "inv.run.when": "Quando",
  "inv.run.kind": "Tipo",
  "inv.run.statusLabel": "Situação",
  "inv.run.trigger": "Origem",
  "inv.run.findings": "Achados",
  "inv.run.cost": "Custo",
  "inv.run.tokens": "Tokens (entrada / saída)",
  "inv.run.kind.RULES": "Regras",
  "inv.run.kind.AI": "IA",
  "inv.run.trigger.IMPORT": "Envio de notas",
  "inv.run.trigger.MANUAL": "Manual",
  "inv.run.trigger.AUTO_AFTER_IMPORT": "Automática após envio",
  "inv.run.status.QUEUED": "Na fila",
  "inv.run.status.RUNNING": "Em análise",
  "inv.run.status.COMPLETED": "Concluída",
  "inv.run.status.FAILED": "Falhou",
  "inv.run.status.CANCELLED": "Cancelada",
  "inv.history.title": "Histórico do mês",
  "inv.history.hint":
    "Quem fez o quê, quando e por quê: revisão, decisões, validação, reaberturas e análises.",
  "inv.history.empty": "Nada registrado neste mês ainda.",
  "inv.event.system": "Sistema",
  "inv.event.importer": "Importação de notas",
  "inv.event.REVIEW_STARTED": "Revisão iniciada",
  "inv.event.VALIDATED": "Mês validado",
  "inv.event.REOPENED": "Mês reaberto",
  "inv.event.REOPENED_BY_UPLOAD": "Reaberto por um envio de notas",
  "inv.event.ACKNOWLEDGED": "Decisão registrada",
  "inv.event.RULES_ANALYSIS_RUN": "Verificações automáticas executadas",
  "inv.event.AI_ANALYSIS_REQUESTED": "Análise com IA solicitada",
  "inv.event.AI_ANALYSIS_COMPLETED": "Análise com IA concluída",
  "inv.event.meta.resolution": "Decisão",
  "inv.event.meta.target": "Alvo",
  "inv.event.meta.code": "Verificação",
  "inv.event.meta.runId": "Execução",
  "inv.event.meta.batchId": "Lote",
  "inv.event.meta.changedInvoices": "Notas alteradas",
  "inv.event.meta.findings": "Achados",
  "inv.settings.title": "Configurações da análise com IA",
  "inv.settings.intro":
    "Controle da faixa de IA das notas fiscais: interruptor geral, execução automática, orçamento mensal, limite diário e a tabela de preços usada para calcular o custo.",
  "inv.settings.notDeployed":
    "Este ambiente não tem a faixa de IA instalada. As configurações ficam salvas, mas nenhuma análise roda.",
  "inv.settings.enabled": "Análise com IA ligada",
  "inv.settings.enabledHint":
    "Interruptor geral. Desligado, nada entra na fila e nenhum botão de IA funciona.",
  "inv.settings.autoRun": "Rodar após cada envio",
  "inv.settings.autoRunHint":
    "Enfileira uma análise por mês afetado depois de cada envio, enquanto houver orçamento.",
  "inv.settings.budget": "Orçamento mensal (US$)",
  "inv.settings.budgetHint": "Ao atingir, a IA fica indisponível até o mês seguinte.",
  "inv.settings.cap": "Limite diário de análises",
  "inv.settings.capHint": "De 1 a 1.000 análises por dia.",
  "inv.settings.priceIn": "Preço de entrada (US$ por milhão de tokens)",
  "inv.settings.priceOut": "Preço de saída (US$ por milhão de tokens)",
  "inv.settings.spent": "Gasto no mês / orçamento",
  "inv.settings.runsToday": "Análises hoje / limite",
  "inv.settings.availability": "Situação agora",
  "inv.settings.available": "Disponível",
  "inv.settings.save": "Salvar",
  "inv.settings.saving": "Salvando…",
  "inv.settings.saved": "Configurações da IA salvas",
  "inv.settings.conflict":
    "As configurações mudaram desde que foram carregadas. Recarregamos os valores; confira e salve de novo.",
  "nfe.workspaceLink.body":
    "Gestão fiscal: organize as notas da empresa por mês, valide cada mês e leia os achados na área dedicada.",
  "nfe.workspaceLink.action": "Abrir Notas fiscais",
  "inv.ft.affected": "{count} itens são afetados; os valores citados são os do primeiro.",
  "inv.ft.ICMS_ZERO_RATE_ON_TAXED_CST.explain":
    "O CST {cst} informa base de cálculo de {vBC}, mas o pICMS é 0% em uma venda (CFOP {cfop}, NCM {ncm}). Um CST tributado com base e sem alíquota não recolhe ICMS.",
  "inv.ft.ICMS_ZERO_RATE_ON_TAXED_CST.reference":
    "A alíquota de referência desta operação é {rate}.",
  "inv.ft.ICMS_ZERO_RATE_ON_TAXED_CST.action":
    "Confirme com o emitente se a operação é tributada. Se for, peça a nota de correção ou recalcule; se for isenta ou não tributada, o CST deveria ser 40/41 (ou o benefício informado em cBenef).",
  "inv.ft.DIFAL_MISSING_NON_CONTRIBUTOR.explain.nonContributor":
    "O CFOP {cfop} (NCM {ncm}) para um destinatário não contribuinte (indIEDest 9) não traz o grupo ICMSUFDest. A EC 87/2015 torna devida a partilha do DIFAL; a operação deveria usar CFOP 6108 ou 6107 com os campos do ICMSUFDest.",
  "inv.ft.DIFAL_MISSING_NON_CONTRIBUTOR.explain.finalConsumer":
    "O CFOP {cfop} (NCM {ncm}) para um consumidor final (indFinal 1) não traz o grupo ICMSUFDest. A EC 87/2015 torna devida a partilha do DIFAL; a operação deveria usar CFOP 6108 ou 6107 com os campos do ICMSUFDest.",
  "inv.ft.DIFAL_MISSING_NON_CONTRIBUTOR.rates":
    "pICMS informado: {stated}; alíquota interna de referência do destino: {internal}.",
  "inv.ft.DIFAL_MISSING_NON_CONTRIBUTOR.action":
    "Verifique o tipo de operação: para não contribuinte ou consumidor final, emita (ou peça) a nota com CFOP 6108/6107 e o grupo do DIFAL; caso contrário, confirme o indIEDest do destinatário.",
  "inv.ft.INTERSTATE_RATE_INCONSISTENT.explain.NATIONAL_AT_4":
    "O pICMS de {pICMS} é a alíquota de mercadoria importada (Res. SF 13/2012), mas a origem {orig} não é 1, 2, 3 nem 8. Mercadoria nacional paga {expected} na rota {from} → {to} (Res. SF 22/89).",
  "inv.ft.INTERSTATE_RATE_INCONSISTENT.explain.OTHER":
    "Foi cobrado pICMS de {pICMS} onde se aplica {expected} na rota {from} → {to} ({basis}).",
  "inv.ft.INTERSTATE_RATE_INCONSISTENT.basis.imported": "Res. SF 13/2012, mercadoria importada",
  "inv.ft.INTERSTATE_RATE_INCONSISTENT.basis.route":
    "Res. SF 22/89, tabela de rotas: 7% do Sul/Sudeste, exceto ES, para os demais; senão 12%",
  "inv.ft.INTERSTATE_RATE_INCONSISTENT.action":
    "Confira a origem da mercadoria (orig) e a rota. Alíquota errada do emitente muda o crédito que a empresa pode tomar; peça nota de correção se for erro.",
  "inv.ft.ST_CFOP_WITHOUT_ST_GROUP.explain":
    "O CFOP {cfop} ({role}) foi emitido com {group} CST {cst}, que não traz ICMS-ST. Ou o CFOP ou o grupo de ICMS está errado.",
  "inv.ft.ST_CFOP_WITHOUT_ST_GROUP.role.substitute": "substituto, ST retida",
  "inv.ft.ST_CFOP_WITHOUT_ST_GROUP.role.substituted": "substituído, ST já retida",
  "inv.ft.ST_CFOP_WITHOUT_ST_GROUP.action":
    "Verifique se a mercadoria está sujeita a ICMS-ST nesta rota. No x403 o emitente é o substituto e deve informar o grupo e os valores de ST (CST 10/30/70); no x405 a mercadoria já teve ST retida (CST 60 / CSOSN 500).",
  "inv.ft.ST_CST_WITHOUT_ST_VALUES.explain":
    "O {group} com CST/CSOSN {cst} retém ICMS-ST, mas o item não tem base de ST (vBCST) nem valor de ST (vICMSST).",
  "inv.ft.ST_CST_WITHOUT_ST_VALUES.action":
    "Pergunte ao emitente se houve retenção de ST. Se houve, a nota deve informar vBCST e vICMSST; se não, o CST está errado.",
  "inv.ft.REDUCTION_WITHOUT_PRED_BC.explain":
    "O CST {cst} é de base reduzida, mas o item não informa pRedBC; a redução não pode ser conferida.",
  "inv.ft.REDUCTION_WITHOUT_PRED_BC.action":
    "Peça ao emitente o percentual de redução (pRedBC) e o fundamento legal da redução.",
  "inv.ft.PRED_BC_WITHOUT_REDUCTION_CST.explain":
    "Há pRedBC de {pRedBC} informado, mas o CST é {cst}, que não é de base reduzida (20, 70 ou 90).",
  "inv.ft.PRED_BC_WITHOUT_REDUCTION_CST.action":
    "Verifique se a base foi realmente reduzida. Se foi, o CST deveria ser 20 (ou 70 com ST); se não, retire o pRedBC.",
  "inv.ft.ICMS_VALUE_MISMATCH.explain":
    "O vICMS de {vICMS} difere de vBC {vBC} × pICMS {pICMS} (= {expected}) além do arredondamento.",
  "inv.ft.ICMS_VALUE_MISMATCH.action":
    "Compare com o DANFE e peça nota de correção ao emitente se o valor estiver errado.",
  "inv.ft.ICMS_ST_BASE_MISMATCH.explain":
    "O vBCST de {vBCST} difere de (vProd + IPI + frete + seg + outros − desc) × (1 + MVA {pMVAST}) = {expected} além da tolerância.",
  "inv.ft.ICMS_ST_BASE_MISMATCH.reduction":
    "O pRedBCST de {pRedBCST} está informado: alguns ERPs o aplicam à base ajustada pela MVA, outros ao valor da operação, e alguns o informam sem tê-lo aplicado ao vBCST; confirme qual convenção o emitente usou.",
  "inv.ft.ICMS_ST_BASE_MISMATCH.action":
    "Recalcule a base de ST com a MVA do destino (MVA ajustada em operação interestadual) e peça confirmação ao emitente.",
  "inv.ft.ICMS_ST_VALUE_MISMATCH.explain":
    "O vICMSST de {vICMSST} difere de vBCST {vBCST} × pICMSST {pICMSST} menos o ICMS próprio {vICMS} (= {expected}).",
  "inv.ft.ICMS_ST_VALUE_MISMATCH.action":
    "Peça nota de correção ao emitente se o valor de ST estiver errado.",
  "inv.ft.OTHER_TAX_VALUE_MISMATCH.explain":
    "{issues}: o valor informado difere de base × alíquota além do arredondamento.",
  "inv.ft.OTHER_TAX_VALUE_MISMATCH.action":
    "Compare com o DANFE; peça nota de correção ao emitente só se o valor for relevante.",
  "inv.ft.PIS_COFINS_ZERO_RATE_CST01.explain":
    "PIS CST {pisCst} ({pisRate}) e COFINS CST {cofinsCst} ({cofinsRate}): um CST tributável com alíquota zero não recolhe nada.",
  "inv.ft.PIS_COFINS_ZERO_RATE_CST01.action":
    "Verifique o regime de apuração e se a mercadoria tem alíquota zero, é monofásica ou tem suspensão; corrija o CST ou a alíquota com o emitente.",
  "inv.ft.MONOPHASIC_CHARGED_AS_CST01.explain":
    "O NCM {ncm} ({act}) está no regime monofásico, mas esta revenda (CFOP {cfop}) cobra PIS/COFINS com CST 01. Depois da cobrança concentrada, a revenda normalmente usa CST 04.",
  "inv.ft.MONOPHASIC_CHARGED_AS_CST01.action":
    "Confirme que o vendedor não é fabricante nem importador da mercadoria. Se for revendedor, as contribuições já foram recolhidas: peça nota de correção (CST 04) e revise o que foi pago. A tabela de NCM é uma lista revisada, não um parecer jurídico.",
  "inv.ft.POSSIBLE_DUPLICATE_EMITTED.explain.one":
    "Mesmos itens, valores e totais ({total}) de outra nota emitida {days} dia antes, em {date} (janela de 30 dias). O destinatário não é armazenado: também pode ser uma venda repetida legítima.",
  "inv.ft.POSSIBLE_DUPLICATE_EMITTED.explain.other":
    "Mesmos itens, valores e totais ({total}) de outra nota emitida {days} dias antes, em {date} (janela de 30 dias). O destinatário não é armazenado: também pode ser uma venda repetida legítima.",
  "inv.ft.POSSIBLE_DUPLICATE_EMITTED.explain.sameDay":
    "Mesmos itens, valores e totais ({total}) de outra nota emitida no mesmo dia, {date}. O destinatário não é armazenado: também pode ser uma venda repetida legítima.",
  "inv.ft.POSSIBLE_DUPLICATE_EMITTED.action":
    "Verifique se a nota anterior deveria ter sido substituída ou cancelada, ou se a venda realmente se repetiu. Se for duplicidade, cancele dentro do prazo da SEFAZ ou emita o ajuste correspondente.",
  "inv.ft.PLATFORM_RULE_DIVERGENCE.explain":
    "Neste mês, {invoices} e {items} informam {details}. O valor da plataforma vem de {source}.",
  "inv.ft.PLATFORM_RULE_DIVERGENCE.detail": "{field} {observed} onde a plataforma tem {expected}",
  "inv.ft.PLATFORM_RULE_DIVERGENCE.action":
    "Decida se o emitente errou, se a plataforma está desatualizada (abra um rascunho de proposta a partir do caminho) ou se a nota está certa para um caso que a plataforma não modela. A decisão sobre o caminho registra isso.",
  "lotMap.field.descricao": "Descrição do produto",
  "lotMap.field.margem_alvo": "Margem alvo (sobre o preço)",
  "lotMap.field.markup": "Markup (sobre o custo)",
  "lotMap.field.expected_landed": "Custo final esperado por unidade",
  "lotMap.field.expected_own_icms": "ICMS da entrada esperado por unidade",
  "lotMap.field.expected_purchase_pis_cofins": "PIS/COFINS da compra esperado por unidade",
  "lotMap.field.expected_workbook_cost": "Custo como na planilha esperado por unidade",
  "lotMap.field.expected_sale_price": "Valor de venda com TR esperado por unidade",
  "lotMap.field.expected_sale_icms": "ICMS próprio da venda esperado por unidade",
  "lotMap.field.expected_sale_pis_cofins": "PIS/COFINS da venda esperado por unidade",
  "lotMap.field.expected_sale_st_fcp": "ICMS-ST e FCP-ST da NF de venda esperado por unidade",
  "lotMap.field.expected_buyer_invoice": "NF de venda do comprador esperada por unidade",
  "lotMap.field.ref_cfop": "CFOP (só referência)",
  "lotMap.field.ref_mva": "MVA / IVA-ST (só referência)",
  "lotMap.field.ref_aliq_ipi": "Alíquota de IPI (só referência)",
  "lotMap.field.ref_aliq_icms": "Alíquota de ICMS (só referência)",
  "lotMap.field.ref_pis_cofins": "Alíquota de PIS/COFINS (só referência)",
  "lotMap.field.ref_frete": "Frete (só referência)",
  "wb.where.sheet": "Aba “{sheet}”",
  "wb.where.row": "linha {row}",
  "wb.where.column": "coluna {column}",
  "wb.where.columnHeader": "coluna {column} ({header})",
  "wb.detail.expected": "Esperado: {value}",
  "wb.detail.found": "Encontrado: {value}",
  "wb.expected.ncm-8-digits": "um NCM de 8 dígitos, por exemplo 1905.90.20",
  "wb.expected.cest-single": "um único CEST no formato 17.056.02",
  "wb.expected.uf-code": "a sigla da UF com 2 letras, por exemplo SP",
  "wb.expected.amount-brl": "um valor em reais, sem sinal negativo, com até 2 casas decimais",
  "wb.expected.unit-cost": "o custo unitário em reais",
  "wb.expected.quantity-whole-positive": "um número inteiro maior que zero",
  "wb.expected.margin-percent": "uma porcentagem entre 0 e 100 (ou fração entre 0 e 1)",
  "wb.expected.markup-fraction": "uma fração entre 0 e 1, por exemplo 0,5 para 50%",
  "wb.expected.ncm-and-unit-cost-columns": "uma coluna de NCM e uma de custo unitário",
  "wb.expected.uf-column-or-fallback": "uma coluna de UF ou uma UF de reserva",
  "wb.issues.label": "Problemas encontrados na planilha",
  "wb.issues.sheetLabel": "Avisos da aba {sheet}",
  "wb.issues.workbookNotes": "{count} avisos sobre o arquivo como um todo.",
  "calc.error.workbook.title": "Não foi possível ler a planilha",
  "calc.error.workbook.body":
    "Nada foi salvo e nenhum cálculo começou. Corrija o que está indicado e envie de novo.",
  "calc.error.howToFix": "Como resolver",
  "calc.error.chooseAnother": "Enviar outro arquivo",
  "calc.error.supportLabel": "Código para o suporte",
  "calc.error.supportHint":
    "Se precisar de ajuda, envie este código ao suporte: ele identifica esta tentativa.",
  "wb.issue.INVALID_WORKBOOK.steps":
    "Abra o arquivo no Excel. Se não abrir, peça uma nova cópia a quem enviou.\nUse Arquivo → Salvar como → Pasta de Trabalho do Excel (.xlsx), ou exporte a aba como .csv.\nEnvie o arquivo salvo.",
  "wb.issue.ENCRYPTED_WORKBOOK.steps":
    "Abra o arquivo no Excel com a senha.\nEm Arquivo → Informações → Proteger Pasta de Trabalho, retire a senha.\nSalve e envie de novo.",
  "wb.issue.LEGACY_XLS.steps":
    "Abra o arquivo .xls no Excel.\nUse Arquivo → Salvar como → Pasta de Trabalho do Excel (.xlsx).\nEnvie o arquivo .xlsx.",
  "wb.issue.HTML_AS_XLS.steps":
    "Este arquivo veio de um sistema web: tem nome de planilha, mas por dentro é uma página.\nAbra no Excel e use Arquivo → Salvar como → Pasta de Trabalho do Excel (.xlsx).\nEnvie o arquivo salvo.",
  "wb.issue.ZIP_NO_WORKBOOK.steps":
    "Descompacte o .zip no seu computador.\nEnvie o próprio arquivo .xlsx que estava dentro.",
  "wb.issue.FILE_TOO_LARGE.title": "O arquivo é grande demais para ler",
  "wb.issue.FILE_TOO_LARGE.hint":
    "O limite é {expected}. Apague abas ou linhas que não precisa calcular e envie de novo.",
  "wb.issue.INVALID_WORKBOOK.title": "O arquivo está danificado ou não é uma planilha",
  "wb.issue.INVALID_WORKBOOK.hint":
    "Abra no Excel, salve de novo como .xlsx (ou exporte a aba como .csv) e envie outra vez.",
  "wb.issue.ENCRYPTED_WORKBOOK.title": "A planilha está protegida por senha (criptografada)",
  "wb.issue.ENCRYPTED_WORKBOOK.hint":
    "Abra no Excel, retire a senha (Arquivo > Informações > Proteger Pasta de Trabalho), salve e envie de novo.",
  "wb.issue.LEGACY_XLS.title": "Este é um arquivo antigo do Excel 97-2003 (.xls)",
  "wb.issue.LEGACY_XLS.hint":
    "Abra no Excel, salve de novo como .xlsx (ou exporte a aba como .csv) e envie outra vez.",
  "wb.issue.TOO_MANY_SHEETS.title": "A planilha tem abas demais",
  "wb.issue.TOO_MANY_SHEETS.hint":
    "Mantenha no máximo {expected} abas (apagar, não só ocultar) e envie de novo.",
  "wb.issue.TOO_MANY_COLUMNS.title": "A aba tem colunas demais ({found})",
  "wb.issue.TOO_MANY_COLUMNS.hint":
    "Cada aba pode ter até {expected} colunas. Apague colunas vazias ou auxiliares e envie de novo.",
  "wb.issue.TOO_MANY_ROWS.title": "A aba passa do limite de 5.000 linhas de produtos",
  "wb.issue.TOO_MANY_ROWS.hint":
    "Cada aba pode ter até 5.000 linhas de produtos, mais o cabeçalho. Divida a aba em partes menores e envie cada uma separadamente.",
  "wb.issue.WORKSHEET_NOT_FOUND.title": "A aba escolhida não existe no arquivo",
  "wb.issue.WORKSHEET_NOT_FOUND.hint": "Escolha uma aba da lista e tente de novo.",
  "wb.issue.HEADER_ROW_OUT_OF_RANGE.title": "A linha de cabeçalho está fora da aba",
  "wb.issue.HEADER_ROW_OUT_OF_RANGE.hint": "Escolha uma linha de cabeçalho entre 1 e {expected}.",
  "wb.issue.COLUMN_MAPPING_OUT_OF_RANGE.title": "Uma coluna escolhida não existe na aba",
  "wb.issue.COLUMN_MAPPING_OUT_OF_RANGE.hint": "Escolha colunas até a {expected}.",
  "wb.issue.NO_DATA_ROWS.title": "Não há linhas de dados abaixo do cabeçalho",
  "wb.issue.NO_DATA_ROWS.hint":
    "Confira se a linha de cabeçalho é a dos nomes das colunas e se há produtos logo abaixo.",
  "wb.issue.TOO_MANY_DATA_ROWS.title": "Mais de 5.000 linhas para calcular ({found})",
  "wb.issue.TOO_MANY_DATA_ROWS.hint":
    "Divida a aba em partes menores e envie cada uma separadamente.",
  "wb.issue.SHEET_NOT_CONVERTIBLE.title": "Esta aba não pode ser calculada",
  "wb.issue.SHEET_NOT_CONVERTIBLE.hint":
    "Uma aba calculável tem uma linha por produto, com NCM e custo unitário.",
  "wb.issue.ROWS_SKIPPED.title": "{count} linhas sem dados de produto foram ignoradas",
  "wb.issue.ROWS_SKIPPED.hint":
    "Linhas sem NCM, SKU, descrição nem identificador são tratadas como linhas em branco ou de total.",
  "wb.issue.INVALID_CSV.title": "O arquivo CSV não pôde ser lido",
  "wb.issue.INVALID_CSV.hint": "Confira aspas e separadores, ou exporte de novo do Excel como CSV.",
  "wb.issue.CACHED_ERROR_VALUE.title": "O Excel guardou o erro {error} nesta coluna",
  "wb.issue.CACHED_ERROR_VALUE.hint":
    "Isso costuma acontecer quando a aba foi copiada para fora da planilha original e as fórmulas perderam a origem. Envie a planilha completa, ou copie as células e cole como valores (Colar especial → Valores) e envie de novo.",
  "wb.issue.FORMULA_NOT_CACHED.title": "Fórmula salva sem resultado",
  "wb.issue.FORMULA_NOT_CACHED.hint":
    "Abra o arquivo no Excel, deixe recalcular, salve e envie de novo.",
  "wb.issue.FORMULA_REVIEW_REQUIRED.title": "O valor vem de uma fórmula",
  "wb.issue.FORMULA_REVIEW_REQUIRED.hint":
    "Marque “Usar o valor que o Excel guardou nas fórmulas” para calcular com o que o Excel mostrava.",
  "wb.issue.COLUMN_REQUIRED.title": "Falta uma coluna obrigatória",
  "wb.issue.COLUMN_REQUIRED.hint": "Escolha a coluna correspondente na lista de campos.",
  "wb.field.ncm": "NCM",
  "wb.field.custo": "custo unitário",
  "wb.field.origem_mercadoria": "origem da mercadoria",
  "wb.field.marca": "marca",
  "wb.field.familia": "família",
  "wb.field.ean": "EAN",
  "wb.field.peso": "peso",
  "wb.issue.COLUMN_NOT_DETECTED.title": "Não encontramos a coluna de {field}",
  "wb.issue.COLUMN_NOT_DETECTED.hint":
    "Escolha a coluna na lista de campos. Se a planilha não tiver essa coluna, acrescente-a (por exemplo NCM com 8 dígitos por produto) e envie de novo.",
  "wb.issue.COLUMN_LOW_CONFIDENCE.title": "Confirme esta coluna",
  "wb.issue.COLUMN_LOW_CONFIDENCE.hint":
    "Associamos pelo nome parecido. Confira na prévia ou escolha outra coluna.",
  "wb.issue.COLUMN_LOW_CONFIDENCE.alternatives.title": "Confirme a coluna: {field}",
  "wb.issue.COLUMN_LOW_CONFIDENCE.alternatives.hint":
    "Outras colunas também podem alimentar este campo: {found}. Confira na prévia qual é a certa e escolha-a se não for esta.",
  "wb.issue.COLUMN_DUPLICATE.title": "Uma coluna não pode alimentar dois campos",
  "wb.issue.COLUMN_DUPLICATE.hint": "Escolha colunas diferentes para cada campo.",
  "wb.issue.ROUTE_REQUIRED.title": "A rota desta linha está incompleta",
  "wb.issue.ROUTE_REQUIRED.hint":
    "Preencha a UF na planilha, escolha as colunas de UF ou declare uma rota fixa.",
  "wb.issue.ROUTE_COLUMN_REQUIRED.title": "Escolha a coluna de UF ou uma UF de reserva",
  "wb.issue.ROUTE_COLUMN_REQUIRED.hint":
    "Com rota por linha, cada ponta precisa de uma coluna ou de uma UF de reserva.",
  "wb.issue.ROUTE_OVERRIDDEN.title": "{count} linhas tinham outra UF; valeu a rota fixa",
  "wb.issue.ROUTE_OVERRIDDEN.hint":
    "A rota fixa vale para todas as linhas. Use rota por linha se cada uma tem a sua.",
  "wb.issue.MISSING_VALUE.title": "Valor ausente",
  "wb.issue.MISSING_VALUE.hint":
    "Nenhum valor é preenchido por padrão. Campos opcionais vazios permanecem sinalizados para revisão; se houver erro em uma célula obrigatória, corrija a planilha e envie novamente antes de calcular esta linha.",
  "wb.issue.INVALID_NCM.title": "O NCM precisa ser um único código de 8 dígitos",
  "wb.issue.INVALID_NCM.hint":
    "Corrija o NCM na planilha (um código por produto, por exemplo 1905.90.20) e envie de novo.",
  "wb.issue.INVALID_CEST.title": "CEST inválido",
  "wb.issue.INVALID_CEST.hint":
    "Use um único código como 17.056.02 ou deixe em branco; a linha é calculada sem CEST.",
  "wb.issue.INVALID_CEST.zero.title": "CEST 0 lido como “sem CEST”",
  "wb.issue.INVALID_CEST.zero.hint":
    "Nas planilhas BackChannel, 0 indica que o produto não tem CEST. A linha é calculada sem CEST; se o produto tiver ST, preencha o código de 7 dígitos.",
  "wb.issue.INVALID_CEST.placeholder.title": "CEST pendente na planilha ({found})",
  "wb.issue.INVALID_CEST.placeholder.hint":
    "A célula diz que o CEST ainda não foi definido. A linha é calculada sem CEST; preencha o código quando estiver validado.",
  "wb.issue.INVALID_CEST.several.title": "Mais de um CEST na mesma célula",
  "wb.issue.INVALID_CEST.several.hint":
    "Deixe um único CEST por produto. A linha é calculada sem CEST até lá.",
  "wb.issue.GOODS_ORIGIN_UNREADABLE.title": "Origem da mercadoria não lida",
  "wb.issue.GOODS_ORIGIN_UNREADABLE.hint":
    "Use 0 a 8, nacional, importada ou estrangeira, ou deixe em branco. A linha é calculada sem origem.",
  "wb.issue.INVALID_UF.title": "UF inválida",
  "wb.issue.INVALID_UF.hint": "Use a sigla com 2 letras, por exemplo SP.",
  "wb.issue.INVALID_MONEY.title": "Valor em reais inválido",
  "wb.issue.INVALID_MONEY.hint":
    "Use um número positivo com até 2 casas decimais, por exemplo 1.234,56.",
  "wb.issue.ZERO_AMOUNT.title": "O custo unitário é zero",
  "wb.issue.ZERO_AMOUNT.hint":
    "A linha é calculada com custo zero. Se faltar o preço, preencha na planilha e envie de novo.",
  "wb.issue.AMOUNT_ROUNDED.title":
    "{count} valores tinham mais de 2 casas e foram arredondados para centavos",
  "wb.issue.AMOUNT_ROUNDED.hint": "O arquivo original continua guardado com o valor exato.",
  "wb.issue.INVALID_QUANTITY.title": "A quantidade precisa ser um número inteiro maior que zero",
  "wb.issue.INVALID_QUANTITY.hint":
    "Corrija a quantidade na planilha. Se ficar em branco, a linha é calculada por unidade.",
  "wb.issue.INVALID_RATE.title": "Não entendemos a margem ou o markup",
  "wb.issue.INVALID_RATE.hint":
    "Use uma porcentagem entre 0 e 100. O valor foi ignorado nesta linha.",
  "wb.issue.INVALID_EXPECTED_AMOUNT.title": "O valor de comparação não é válido",
  "wb.issue.INVALID_EXPECTED_AMOUNT.hint":
    "Use um valor por unidade, sem sinal negativo, com até 2 casas, ou desmarque a coluna de comparação.",
  "wb.issue.DUPLICATE_ITEM_ID.title": "Identificador repetido",
  "wb.issue.DUPLICATE_ITEM_ID.hint": "Cada linha precisa de um identificador diferente.",
  "wb.issue.INVALID_ITEM.title": "A linha não pôde ser lida",
  "wb.issue.INVALID_ITEM.hint": "Confira os valores desta linha na planilha.",
  "wb.route.title": "Rota do arquivo",
  "wb.route.help":
    "Diga de onde para onde vão as mercadorias. A mesma rota vale para todas as linhas, ou cada linha informa a sua.",
  "wb.route.fixed": "Uma rota para o arquivo todo",
  "wb.route.fixedHelp": "Escolha a UF de origem e a de destino.",
  "wb.route.dynamic": "Cada linha tem a sua rota",
  "wb.route.dynamicHelp": "Leia a origem e o destino das colunas de UF.",
  "wb.route.origin": "UF de origem",
  "wb.route.destination": "UF de destino",
  "wb.route.choose": "Escolha a UF",
  "wb.route.originColumn": "Coluna da UF de origem",
  "wb.route.destinationColumn": "Coluna da UF de destino",
  "wb.route.originFallback": "Origem quando a linha não informa",
  "wb.route.destinationFallback": "Destino quando a linha não informa",
  "wb.route.noFallback": "Nenhuma (bloquear a linha)",
  "wb.route.requiredFixed": "Escolha a UF de origem e a de destino para continuar.",
  "wb.route.requiredDynamic":
    "Para cada ponta da rota, escolha uma coluna de UF ou uma UF de reserva.",
  "wb.route.detected": "Sugestão a partir de {source}.",
  "wb.route.source.COLUMN": "as colunas de UF",
  "wb.route.source.SHEET_NAME": "o nome da aba",
  "wb.route.source.HEADER_BLOCK": "as células acima da tabela",
  "wb.route.source.PARAMETER_SHEET": "uma aba de parâmetros",
  "wb.route.source.NONE": "Não identificamos a rota nesta aba. Escolha-a acima.",
  "wb.route.perRow": "rota por linha",
  "wb.picker.title": "Abas deste arquivo",
  "wb.picker.help":
    "Escolha as listas de produtos a converter. Cada aba escolhida vira um cálculo separado.",
  "wb.picker.select": "Converter a aba {sheet}",
  "wb.picker.kind.SCENARIO": "Lista de produtos",
  "wb.picker.kind.CLIENT_SIMULATION": "Simulação de cliente",
  "wb.picker.kind.PARAMETERS": "Parâmetros",
  "wb.picker.kind.AUXILIARY": "Aba de apoio",
  "wb.picker.kind.UNKNOWN": "Não reconhecida",
  "wb.picker.hidden": "oculta",
  "wb.picker.confidence": "{percent}% de certeza",
  "wb.picker.confidenceHelp": "Quanto temos de certeza de que é este tipo de aba.",
  "wb.picker.errors": "{count} a corrigir",
  "wb.picker.warnings": "{count} a conferir",
  "wb.picker.incomplete": "falta completar",
  "wb.picker.noScenarios":
    "Nenhuma aba parece uma lista de produtos com NCM e custo. Abra uma das abas abaixo e escolha as colunas.",
  "wb.picker.others": "Outras abas ({count})",
  "wb.picker.othersHelp":
    "Simulações de cliente, parâmetros e abas de apoio não têm NCM e custo por produto. Você ainda pode abri-las e escolher colunas.",
  "wb.picker.parameters": "Premissas lidas das abas de parâmetros",
  "wb.picker.parametersHelp":
    "Só para conferência. Estes valores nunca viram regra fiscal: as regras vêm sempre do conjunto de regras publicado.",
  "wb.picker.notConvertible.SCENARIO":
    "Esta aba precisa de uma coluna de NCM e uma de custo unitário.",
  "wb.picker.notConvertible.CLIENT_SIMULATION":
    "É uma simulação comercial de cliente: não tem NCM por produto, então não dá para calcular impostos aqui.",
  "wb.picker.notConvertible.PARAMETERS":
    "É uma aba de parâmetros. As premissas aparecem para conferência, mas não viram regra fiscal.",
  "wb.picker.notConvertible.AUXILIARY":
    "É uma aba de apoio (auditoria, revisão ou resumo), sem lista de produtos.",
  "wb.picker.notConvertible.UNKNOWN":
    "Não reconhecemos esta aba como uma lista de produtos. Escolha as colunas manualmente se ela tiver NCM e custo.",
  "wb.picker.convertMany": "Converter {count} abas",
  "wb.picker.noneSelected": "Marque pelo menos uma aba para converter.",
  "wb.picker.fixSelected":
    "Complete custo, rota e objetivo do cálculo nas abas marcadas para continuar.",
  "wb.map.confidence": "{percent}% de acerto",
  "wb.map.confidenceHelp": "Quanto o nome da coluna e os valores combinam com este campo.",
  "wb.map.manual": "escolhida por você",
  "wb.map.alternatives": "Outras candidatas: {columns}",
  "wb.map.premises": "Premissas acima da tabela ({count})",
  "wb.map.premisesHelp":
    "Valores que a aba traz acima da tabela, como margem alvo, take rate ou UF de destino. Só para conferência.",
  "wb.map.reference": "Taxas citadas no arquivo (só referência)",
  "wb.map.referenceHelp":
    "CFOP, MVA, IPI, ICMS, PIS/COFINS e frete que a planilha informa. Aparecem na linha para conferência e nunca são usados como regra ou alíquota.",
  "wb.coverage.title": "Cobertura de regras",
  "wb.coverage.hint":
    "Quais rotas e NCMs do arquivo o conjunto de regras publicado consegue calcular. Rota sem regra nunca é calculada com valor padrão.",
  "wb.coverage.summary": "{covered} cobertas · {missing} sem regra · {stale} desatualizadas",
  "wb.coverage.unidentifiedSummary.one": "{count} linha sem identificação fiscal",
  "wb.coverage.unidentifiedSummary.other": "{count} linhas sem identificação fiscal",
  "wb.coverage.loading": "Verificando as regras…",
  "wb.coverage.needVersion": "Escolha uma versão publicada para ver a cobertura.",
  "wb.coverage.onlyGaps": "Só o que falta",
  "wb.coverage.noRuleset": "Não há conjunto de regras publicado: todas as rotas estão sem regra.",
  "wb.coverage.allCovered": "Todas as {count} combinações de rota e NCM têm regra publicada.",
  "wb.coverage.gapNote": "{count} linhas dependem de rotas sem regra válida e ficarão em revisão.",
  "wb.coverage.runNote":
    "{count} linhas não têm regra publicada válida. Elas serão marcadas para revisão, sem nenhum valor inventado.",
  "wb.coverage.unidentified":
    "{count} linhas sem NCM ou rota não puderam ser verificadas. Corrija na planilha.",
  "wb.coverage.unidentifiedAutomatic":
    "A planilha está salva. Ao calcular, o sistema tentará identificar os produtos sem NCM e verificar as regras disponíveis. O que não for resolvido ficará pendente no detalhe.",
  "wb.coverage.column.route": "Rota",
  "wb.coverage.column.ncm": "NCM",
  "wb.coverage.column.cest": "CEST",
  "wb.coverage.column.status": "Situação",
  "wb.coverage.column.reason": "Motivo",
  "wb.coverage.column.rows": "Linhas",
  "wb.coverage.status.COVERED": "Coberta",
  "wb.coverage.status.MISSING": "Sem regra",
  "wb.coverage.status.STALE": "Desatualizada",
  "wb.coverage.reason.RULE_FOUND": "Há regra publicada vigente.",
  "wb.coverage.reason.NO_RULE_FOR_ROUTE": "Há regras para este NCM, mas não para esta rota.",
  "wb.coverage.reason.NO_RULE_FOR_NCM": "Nenhuma regra publicada para este NCM.",
  "wb.coverage.reason.RULE_EXPIRED": "A regra desta rota terminou antes da data do cálculo.",
  "wb.coverage.reason.RULE_NOT_YET_EFFECTIVE":
    "A regra desta rota só passa a valer depois da data do cálculo.",
  "wb.coverage.reason.AMBIGUOUS_RULES": "Mais de uma regra serve e falta o CEST para escolher.",
  "wb.coverage.reason.RULESET_EMPTY": "O conjunto de regras não tem regras fiscais.",
  "wb.coverage.status.NEEDS_REVIEW": "Revisar",
  "wb.coverage.reason.RULE_FOUND_ANY_ORIGIN":
    "Coberto por regra válida para qualquer origem (destino {destination}).",
  "wb.coverage.reason.RULE_FOUND_ANY_ROUTE":
    "Coberto por regra válida para qualquer origem e destino.",
  "wb.coverage.reason.ICMS_NOT_PUBLISHED": "Só IPI (TIPI) — ICMS não publicado para esta rota.",
  "wb.coverage.reason.DESTINATION_ST_DERIVED":
    "Derivada da regra de ST de {destination} (origem {origin}): mesma MVA e alíquota interna, alíquota interestadual {rate} da Res. SF 22/89.",
  "wb.coverage.leg.SALE": "Venda {origin}→{destination}: {reason}",
  "wb.coverage.reason.GENERAL_RULE_NO_ST":
    "Regra geral (sem ST): alíquota interestadual da Res. SF 22/89 (ou interna verificada) e NCM sem ST comprovado.",
  "wb.coverage.reason.INTERSTATE_RATE_MISMATCH":
    "A regra em vigor declara ICMS interestadual de {stated}, mas a Res. SF 22/89 fixa {expected} para {origin} → {destination}. Revise a regra.",
  "wb.coverage.viewRule": "Ver regra",
  "wb.coverage.anyOriginTag": "Regra para qualquer origem",
  "wb.coverage.summaryReview": " · {count} para revisar",
  "wb.coverage.reviewNote":
    "{count} linhas usam uma regra que precisa de revisão: a alíquota interestadual declarada não confere com a rota.",
  "wb.coverage.showAll": "Mostrar mais {count}",
  "wb.row.reference": "Referência da planilha",
  "wb.run.converting": "Convertendo a aba {sheet}…",
  "wb.run.template": "Baixar CSV normalizado",
  "wb.run.backToSheets": "Voltar às abas",
  "wb.run.notes": "Avisos desta aba ({count})",
  "wb.run.notesLabel": "Avisos da conversão",
  "wb.run.tabs": "Abas convertidas",
  "wb.runAll.label": "Calcular todas as abas",
  "wb.runAll.title": "{count} abas neste arquivo",
  "wb.runAll.tally": "{done} calculadas · {running} em cálculo · {waiting} aguardando",
  "wb.runAll.action": "Calcular todas ({count})",
  "wb.rows.one": "{count} linha",
  "wb.rows.other": "{count} linhas",
  "wb.notes.one": "⚠ {count} aviso",
  "wb.notes.other": "⚠ {count} avisos",
  // -- Calculator research ("Buscar com agente?") — begin --
  "research.announce.CANCELLED": "Pesquisa cancelada: {route}, NCM {ncm}.",
  "research.announce.FAILED": "A pesquisa falhou: {route}, NCM {ncm}.",
  "research.announce.FOUND": "Pesquisa concluída: {route}, NCM {ncm}. Resultado encontrado.",
  "research.announce.NEEDS_REVIEW":
    "Pesquisa concluída: {route}, NCM {ncm}. Evidência aguardando revisão.",
  "research.announce.NOT_FOUND": "Pesquisa concluída: {route}, NCM {ncm}. Nada encontrado.",
  "research.announce.QUEUED": "Pesquisa na fila: {route}, NCM {ncm}.",
  "research.announce.RUNNING": "Pesquisa em andamento: {route}, NCM {ncm}.",
  "research.ask": "Buscar com agente?",
  "research.auto.deferred.one":
    "{count} combinação ficou fora do limite por planilha ({gaps} combinações, {cost}). Use “Buscar com agente?” para ela.",
  "research.auto.deferred.other":
    "{count} combinações ficaram fora do limite por planilha ({gaps} combinações, {cost}). Use “Buscar com agente?” para elas.",
  "research.auto.error": "Não foi possível iniciar a busca automática.",
  "research.auto.label": "Buscar automaticamente o que faltar",
  "research.auto.launching": "Iniciando a busca automática das combinações sem regra…",
  "research.auto.note":
    "Depois da conferência de cobertura, as combinações que faltam vão para a pesquisa web com IA (aqui não se usa IOB). Limite por planilha: {gaps} combinações e até {cost} estimados; o resto fica com “Buscar com agente?”. O resultado é evidência para revisão: não publica regra.",
  "research.banner.alsoPending": "Ainda há buscas em andamento para este cálculo.",
  "research.banner.pending.body":
    "O resultado deste cálculo continua como está até a busca terminar.",
  "research.banner.pending.title.one": "{count} pesquisa em andamento",
  "research.banner.pending.title.other": "{count} pesquisas em andamento",
  "research.banner.recalculable.body.one":
    "{count} busca terminou com dados utilizáveis. Recalcular cria um novo cálculo e mostra a diferença; este continua como está.",
  "research.banner.recalculable.body.other":
    "{count} buscas terminaram com dados utilizáveis. Recalcular cria um novo cálculo e mostra a diferença; este continua como está.",
  "research.banner.recalculable.title": "Nova pesquisa concluída; resultado anterior preservado.",
  "research.banner.since": "Desde {when}.",
  "research.banner.upToDate.title": "O resultado já considera o que a pesquisa encontrou.",
  "research.banner.waiting.body":
    "Consulte cada pedido para distinguir dados a corrigir de evidências a revisar. Os valores e a versão de regras do cálculo salvo permanecem preservados.",
  "research.banner.waiting.title": "Pendência da pesquisa; consulte os detalhes",
  "research.bar.allLabel": "Todas as combinações sem regra",
  "research.bar.combinations.one": "{count} combinação",
  "research.bar.combinations.other": "{count} combinações",
  "research.bar.covered": "Já pesquisada",
  "research.bar.disconnected": "Sem conexão: mostrando o último estado confirmado das pesquisas.",
  "research.bar.follow": "Pesquisas",
  "research.bar.groups": "Combinações sem regra por rota",
  "research.bar.hint":
    "O agente pesquisa na web. O resultado é evidência para revisão: não publica nem altera regras.",
  "research.bar.running.one": "{count} pesquisando",
  "research.bar.running.other": "{count} pesquisando",
  "research.bar.title.one": "{count} combinação sem regra pode ser pesquisada",
  "research.bar.title.other": "{count} combinações sem regra podem ser pesquisadas",
  "research.blocked.DAILY_GROUNDED_CAP":
    "O limite diário de consultas web foi atingido. O pedido aguarda.",
  "research.blocked.FEATURE_DISABLED":
    "A busca com agente está desligada pelo administrador. O pedido aguarda.",
  "research.blocked.IOB_PAUSED": "O agente IOB está pausado. O pedido aguarda.",
  "research.blocked.LANES_PAUSED":
    "As pesquisas estão pausadas. O pedido começa quando forem retomadas.",
  "research.blocked.MONTHLY_BUDGET":
    "O orçamento mensal de pesquisa foi atingido. O pedido aguarda.",
  "research.blocked.WEB_PAUSED": "A pesquisa web está pausada. O pedido aguarda.",
  "research.boundary":
    "O agente só traz evidência. Nada é publicado nem calculado: um revisor precisa aprovar antes de virar regra.",
  "research.cancel": "Cancelar busca",
  "research.cancel.reason": "Cancelado pelo operador na calculadora.",
  "research.cell.needsCest": "Informe o CEST",
  "research.cell.open": "Ver pesquisa",
  "research.column": "Pesquisa",
  "research.completed": "Concluída em {when}",
  "research.confirm.back": "Voltar",
  "research.confirm.cancel.action": "Sim, cancelar",
  "research.confirm.cancel.body": "Cancelar esta busca? O que já foi gasto não volta.",
  "research.confirm.cancel.shared":
    "Esta busca é compartilhada com {count} origens. Cancelar afeta todas.",
  "research.confirm.cancel.title": "Cancelar a busca",
  "research.confirm.existing.one":
    "{count} combinação já tem uma busca em andamento ou recente e será aproveitada, sem custo novo.",
  "research.confirm.existing.other":
    "{count} combinações já têm uma busca em andamento ou recente e serão aproveitadas, sem custo novo.",
  "research.confirm.follow": "Acompanhar busca existente",
  "research.confirm.launching": "Iniciando…",
  "research.confirm.lead": "{scope} — {combinations}, {rows}.",
  "research.confirm.more.one": "e mais {count}",
  "research.confirm.more.other": "e mais {count}",
  "research.confirm.newSearches": "Buscas novas",
  "research.confirm.partialEstimate":
    "A estimativa considera as primeiras {count} combinações; as demais seguem em lotes.",
  "research.confirm.retry.action": "Repetir busca",
  "research.confirm.retry.currentBudget":
    "Cria uma nova investigação com o orçamento individual atual de {cost}. O histórico e as evidências anteriores são preservados; chamadas em andamento podem superar a reserva estimada.",
  "research.confirm.retry.body": "Repetir a busca custa até {cost} (estimativa).",
  "research.confirm.retry.title": "Repetir a busca",
  "research.confirm.start": "Buscar",
  "research.cost.actual": "Gasto até agora",
  "research.cost.estimated": "Orçamento alocado à pesquisa",
  "research.created": "Criada em {when}",
  "research.created.body":
    "O cálculo anterior foi preservado. Confira a diferença abaixo antes de adotar o novo como resultado.",
  "research.created.dismiss": "Fechar",
  "research.created.open": "Abrir novo cálculo",
  "research.created.title": "Novo cálculo criado (revisão {number})",
  "research.deferral.AUTO_CAP_COST": "Adiada: limite de custo da planilha",
  "research.deferral.AUTO_CAP_GAPS": "Adiada: limite de combinações da planilha",
  "research.deferral.UPLOAD_NOT_AUTO": "Adiada: a planilha não é automática",
  "research.diff.change.AMOUNT": "Valor",
  "research.diff.change.COVERAGE": "Cobertura",
  "research.diff.change.FACTS_LEVEL": "Nível dos fatos",
  "research.diff.change.RULE": "Regra",
  "research.diff.change.STATUS": "Situação",
  "research.diff.col.changes": "Mudanças",
  "research.diff.col.coverage": "Cobertura",
  "research.diff.col.item": "Item",
  "research.diff.col.landed": "Custo unitário",
  "research.diff.col.tax": "Tributos",
  "research.diff.coverage.AMBIGUOUS": "Ambígua",
  "research.diff.coverage.EXACT": "Regra exata",
  "research.diff.coverage.MISSING": "Sem regra",
  "research.diff.coverage.NCM_UNIQUE": "Regra pelo NCM",
  "research.diff.deltaNote": "Soma só dos itens que tinham valor antes e depois.",
  "research.diff.factsMode": "Fatos: {mode}",
  "research.diff.factsNotApplied": "O valor ainda não mudou: os fatos estão em modo sombra.",
  "research.diff.noItems": "Nenhum item mudou.",
  "research.diff.summary.amount": "Valores",
  "research.diff.summary.changed": "Itens alterados",
  "research.diff.summary.coverage": "Cobertura",
  "research.diff.summary.delta": "Variação do custo unitário",
  "research.diff.summary.unverified": "Só evidência não verificada",
  "research.diff.table": "Itens que mudaram",
  "research.diff.title": "Diferença da revisão {number}",
  "research.diff.unavailable": "Indisponível → calculado",
  "research.diff.unverifiedOnly": "Só evidência não verificada: não conta como cobertura.",
  "research.disconnected":
    "Sem conexão com o servidor. Mostrando o último estado confirmado, às {when}. As buscas continuam no servidor.",
  "research.empty.body":
    "Quando você usar “Buscar com agente?” numa combinação sem regra, ela aparece aqui.",
  "research.empty.filtered.body": "Mude a situação, o modo ou a origem.",
  "research.empty.filtered.title": "Nenhuma pesquisa com esses filtros",
  "research.empty.title": "Nenhuma pesquisa ainda",
  "research.eta": "Tempo estimado",
  "research.etaValue": "≈ {minutes} min",
  "research.event.FOUND_IN_BASE": "Encontrado na base: nenhum agente foi necessário",
  "research.event.IOB_LOOKUP_DONE": "Consulta IOB concluída",
  "research.event.IOB_LOOKUP_STARTED": "Consulta IOB iniciada",
  "research.event.LANES_PAUSED": "Pesquisas pausadas",
  "research.event.REQUEST_CANCELLED": "Pedido cancelado",
  "research.event.REQUEST_FAILED": "Pedido falhou",
  "research.event.REQUEST_FOUND": "Resultado encontrado",
  "research.event.REQUEST_NEEDS_REVIEW": "Evidência aguardando revisão",
  "research.event.REQUEST_NOT_FOUND": "Nada encontrado",
  "research.event.REQUEST_QUEUED": "Pedido na fila",
  "research.event.RESOLVING_GAP": "Reavaliando a lacuna",
  "research.event.WEB_SWEEP_DONE": "Pesquisa web concluída",
  "research.event.WEB_SWEEP_FAILED": "Pesquisa web falhou",
  "research.event.WEB_SWEEP_STARTED": "Pesquisa web iniciada",
  "research.events.empty": "Ainda não há eventos.",
  "research.events.title": "Linha do tempo",
  "research.failed.detail": "Tentativas: {attempts}.",
  "research.failed.final": "Não pode ser repetida automaticamente.",
  "research.failed.retryable": "Pode ser repetida.",
  "research.family.ICMS": "ICMS",
  "research.family.ICMS_ST": "ICMS-ST",
  "research.filters.all": "Todos",
  "research.filters.label": "Filtros das pesquisas",
  "research.filters.mode": "Modo",
  "research.filters.origin": "Origem",
  "research.filters.status": "Situação",
  "research.filters.status.active": "Em andamento",
  "research.filters.status.all": "Todas",
  "research.filters.status.cancelled": "Canceladas",
  "research.filters.status.failed": "Com falha",
  "research.filters.status.found": "Encontradas",
  "research.filters.status.notFound": "Não encontradas",
  "research.filters.status.review": "Aguardando revisão",
  "research.hideDetail": "Ocultar detalhes",
  "research.jobs.activeSr.one": "pesquisa em andamento",
  "research.jobs.activeSr.other": "pesquisas em andamento",
  "research.jobs.button": "Pesquisas",
  "research.jobs.closeKeeps": "Fechar não cancela nenhuma busca.",
  "research.jobs.live": "{count} em andamento",
  "research.jobs.openPage": "Abrir a página de pesquisas",
  "research.jobs.subtitle": "O que o agente está procurando para as combinações sem regra.",
  "research.jobs.title": "Pesquisas do agente",
  "research.lane.eta.estimate": "Estimativa feita ao pedir a busca",
  "research.lane.eta.hours": "≈ {value} h",
  "research.lane.eta.minutes": "≈ {value} min",
  "research.lane.eta.rate": "Medido pelas unidades já concluídas",
  "research.lane.eta.seconds": "≈ {value} s",
  "research.lane.iob": "IOB",
  "research.lane.openIob": "Ver no Agente IOB",
  "research.lane.openWeb": "Ver na Pesquisa web",
  "research.lane.status.DONE": "concluída",
  "research.lane.status.FAILED": "falhou",
  "research.lane.status.NOT_PLANNED": "não planejada",
  "research.lane.status.QUEUED": "na fila",
  "research.lane.status.RUNNING": "consultando",
  "research.lane.status.SKIPPED": "não usada",
  "research.lane.units": "{done} de {total} unidades",
  "research.lane.web": "Web",
  "research.lanes.label": "Fontes consultadas",
  "research.lanes.unavailable.AVAILABLE": "A fonte {lane} está disponível.",
  "research.lanes.unavailable.BUDGET": "O orçamento da fonte {lane} foi atingido. A busca espera.",
  "research.lanes.unavailable.DAILY_CAP":
    "O limite diário da fonte {lane} foi atingido. A busca espera.",
  "research.lanes.unavailable.DISABLED": "A fonte {lane} está desligada.",
  "research.lanes.unavailable.PAUSED":
    "A fonte {lane} está pausada. A busca espera até ser retomada.",
  "research.launched.announce.one": "Busca iniciada para {count} combinação.",
  "research.launched.announce.other": "Busca iniciada para {count} combinações.",
  "research.launched.follow": "Acompanhar",
  "research.launched.shared":
    "Parte já tinha uma busca em andamento ou recente e foi aproveitada, sem custo novo.",
  "research.launched.title.one": "Busca iniciada · {count} combinação",
  "research.launched.title.other": "Busca iniciada · {count} combinações",
  "research.mode.ASK": "Manual",
  "research.mode.AUTO": "Automática",
  "research.more": "Mostrando as 100 mais recentes.",
  "research.origin.CALCULATION": "Cálculo",
  "research.origin.UPLOAD": "Planilha",
  "research.origin.launched": "iniciou a busca",
  "research.origins.title": "Usada por",
  "research.page.description":
    "Todas as buscas “Buscar com agente?” da organização, com situação, etapa e custo.",
  "research.page.title": "Pesquisas do agente",
  "research.page.unavailable": "A busca com agente não está disponível neste ambiente.",
  "research.panel.all.one": "Ver a pesquisa",
  "research.panel.all.other": "Ver as {count} pesquisas",
  "research.panel.gaps.one": "{count} combinação deste cálculo ainda não foi pesquisada.",
  "research.panel.gaps.other": "{count} combinações deste cálculo ainda não foram pesquisadas.",
  "research.panel.scope": "Este cálculo",
  "research.panel.loadError":
    "Não foi possível atualizar o status da pesquisa. O cálculo salvo permanece igual. Tente novamente.",
  "research.panel.title": "Pesquisas deste cálculo",
  "research.recalculate": "Recalcular",
  "research.recalculating": "Recalculando…",
  "research.reconnect": "Tentar agora",
  "research.resolution.applied":
    "Resultado disponível para esta combinação. Recalcule para usá-lo no cálculo.",
  "research.resolution.cancelled": "Pesquisa cancelada. A combinação continua sem regra.",
  "research.resolution.failed": "A pesquisa não terminou. A combinação continua sem regra.",
  "research.resolution.needsReview": "Evidência encontrada — aguardando revisão.",
  "research.resolution.notApplied":
    "Resultado encontrado, mas o valor ainda não muda: os fatos estão em modo sombra.",
  "research.resolution.notFound":
    "Nada encontrado nas fontes consultadas. A combinação continua sem regra.",
  "research.resolution.queued": "Aguardando a vez na fila.",
  "research.resolution.running": "Pesquisando nas fontes…",
  "research.resolution.unverified":
    "Evidência desta pesquisa não verificada; sua revisão ainda está pendente. Esta evidência, por si só, não estabelece uma regra fiscal.",
  "research.resolution.webUnverified":
    "Evidência encontrada na web; sua verificação ainda está pendente. Esta evidência, por si só, não estabelece uma regra fiscal.",
  "research.retry": "Repetir busca",
  "research.revision.chain": "Revisões",
  "research.revision.number": "Revisão {number}",
  "research.revision.openLatest": "Abrir revisão {number}",
  "research.revision.original": "Original",
  "research.revision.ownDiff": "Diferenças da revisão {number}",
  "research.rows.one": "{count} linha",
  "research.rows.other": "{count} linhas",
  "research.scope.calculation": "Mostrando só as pesquisas deste cálculo.",
  "research.scope.clear": "Ver todas",
  "research.scope.upload": "Mostrando só as pesquisas desta planilha.",
  "research.shared": "Compartilhada com {count} origens: o resultado vale para todas.",
  "research.showDetail": "Ver detalhes",
  "research.status.BLOCKED": "Pausada",
  "research.status.CANCELLED": "Cancelada",
  "research.status.FAILED": "Falhou",
  "research.status.FOUND": "Encontrada",
  "research.status.NEEDS_REVIEW": "Aguardando revisão",
  "research.status.NOT_FOUND": "Não encontrada",
  "research.status.QUEUED": "Na fila",
  "research.status.RUNNING": "Pesquisando",
  "research.step.DONE": "Concluída",
  "research.step.IOB": "IOB",
  "research.step.PLANNING": "Plano",
  "research.step.RESOLVING": "Resolução",
  "research.step.WEB": "Web",
  "research.stepState.blocked": "pausada",
  "research.stepState.current": "em andamento",
  "research.stepState.done": "concluída",
  "research.stepState.failed": "falhou",
  "research.stepState.pending": "pendente",
  "research.stepState.skipped": "não usada",
  "research.stepState.stopped": "interrompida",
  "research.steps.label": "Etapas da pesquisa",
  "research.summary":
    "{active} em andamento · {review} aguardando revisão · {found} encontradas · {failed} com falha · gasto {cost}",
  "research.updated": "Atualizada em {when}",
  // -- Repair spreadsheet --
  "repair.title": "Reparar planilha",
  "repair.intro.one": "Encontramos {count} valor que trava linhas desta aba.",
  "repair.intro.other": "Encontramos {count} valores que travam linhas desta aba.",
  "repair.safe":
    "Nada é aplicado sem a sua confirmação. Um reparo confirmado muda só o valor lido, nunca o arquivo original, e fica registrado com o seu nome, a data e o valor de antes.",
  "repair.counter": "{done} de {total} reparos confirmados",
  "repair.acceptSuggestions": "Aceitar sugestões ({count})",
  "repair.acceptSuggestions.help":
    "Aceita só o que não deixa dúvida: NCM do catálogo bem à frente dos outros, zero à esquerda do NCM, UF muito parecida e coluna de custo única. Valores digitados nunca entram aqui.",
  "repair.undoAll": "Desfazer todos",
  "repair.loading": "Procurando valores que podem ser reparados…",
  "repair.refreshing": "Atualizando as sugestões…",
  "repair.error": "Não foi possível procurar reparos agora. Você pode converter a aba sem eles.",
  "repair.catalogUnchecked":
    "O catálogo de NCM não pôde ser consultado: os códigos abaixo foram conferidos só pelo formato.",
  "repair.pendingNote.one":
    "{count} reparo sem confirmação: as linhas afetadas ficam de fora da conversão.",
  "repair.pendingNote.other":
    "{count} reparos sem confirmação: as linhas afetadas ficam de fora da conversão.",
  "repair.kind.NCM_PICK": "Mais de um NCM na célula",
  "repair.kind.NCM_LEADING_ZERO": "NCM sem o zero à esquerda",
  "repair.kind.UF_REPLACE": "UF que não existe",
  "repair.kind.CEST_REPLACE": "CEST que não corresponde ao NCM",
  "repair.kind.NCM_REPLACE": "Coluna de NCM com texto de produto",
  "repair.kind.COST_ALTERNATIVE_COLUMN": "Custo com erro do Excel",
  "repair.kind.COST_MANUAL": "Custo com erro do Excel, sem outra coluna",
  "repair.kindShort.NCM_PICK": "NCM escolhido",
  "repair.kindShort.NCM_LEADING_ZERO": "Zero à esquerda do NCM",
  "repair.kindShort.NCM_REPLACE": "NCM da tabela oficial",
  "repair.kindShort.UF_REPLACE": "UF substituída",
  "repair.kindShort.COST_ALTERNATIVE_COLUMN": "Custo de outra coluna",
  "repair.kindShort.COST_MANUAL": "Custo digitado",
  "repair.column": "Coluna {column} · {header}",
  "repair.original": "Valor atual",
  "repair.rowsMore": "e mais {count}",
  "repair.choose.ncm": "Qual NCM vale para estas linhas?",
  "repair.choose.uf": "Qual UF vale para estas linhas?",
  "repair.choose.costManual": "Qual é o custo destas linhas?",
  "repair.choose.cost": "De onde vem o custo?",
  "repair.badge.inCatalog": "no catálogo",
  "repair.badge.notInCatalog": "fora do catálogo",
  "repair.badge.unchecked": "não conferido no catálogo",
  "repair.best": "melhor sugestão",
  "repair.noDescription": "Sem descrição no catálogo",
  "repair.uf.other": "Escolher outra UF",
  "repair.uf.pick": "Selecione uma UF",
  "repair.uf.noCandidates": "Nenhuma UF se parece com este valor. Escolha a correta.",
  "repair.cost.coverage": "{rows} de {total} linhas",
  "repair.cost.partial": "As linhas sem valor nesta coluna continuam sem reparo e bloqueadas.",
  "repair.cost.manual": "Digitar um valor",
  "repair.cost.manualLabel": "Custo unitário (R$)",
  "repair.cost.manualHelp":
    "O valor é seu e fica registrado como digitado. Use vírgula ou ponto, com até 2 casas decimais.",
  "repair.cost.manualError": "Use só números, com até 2 casas decimais (por exemplo 12,50).",
  "repair.scope": "Aplicar a",
  "repair.scope.all": "Aplicar às {count} linhas com este valor",
  "repair.scope.first": "Somente a linha {row}",
  "repair.apply": "Aplicar",
  "repair.undo": "Desfazer",
  "repair.confirmed": "Reparo confirmado",
  "repair.willApply.one": "Vale para {count} linha",
  "repair.willApply.other": "Vale para {count} linhas",
  "repair.willApply.none": "Nenhuma linha tem valor nesta coluna",
  "repair.result.one": "{count} reparo confirmado",
  "repair.result.other": "{count} reparos confirmados",
  "repair.audit.title": "Reparos confirmados",
  "repair.audit.help":
    "Valores que uma pessoa corrigiu antes da conversão. O arquivo original não foi alterado.",
  "repair.audit.what": "O que",
  "repair.audit.where": "Onde",
  "repair.audit.change": "De → Para",
  "repair.audit.who": "Quem confirmou",
  "repair.audit.when": "Quando",
  "repair.audit.table": "Reparos confirmados neste arquivo",
  "repair.recovered.title": "Arquivo recuperado — confira os dados",
  "repair.recovered.body":
    "O arquivo estava danificado e foi reconstruído a partir das partes que ainda podiam ser lidas. Confira nomes, valores e quantidade de linhas antes de converter.",
  "repair.recovered.lost": "Abas que não puderam ser recuperadas e não aparecem aqui: {sheets}.",
  "wb.issue.FILE_RECOVERED.title": "O arquivo estava danificado e foi recuperado",
  "wb.issue.FILE_RECOVERED.hint":
    "Confira os dados antes de converter: partes do arquivo podem ter se perdido. Se algo parecer errado, abra no Excel, salve de novo como .xlsx e envie outra vez.",
  "wb.issue.FILE_RECOVERED.sheetLost.title": "A aba “{sheet}” não pôde ser recuperada",
  "wb.issue.FILE_RECOVERED.sheetLost.hint":
    "O arquivo estava danificado e esta aba se perdeu. Peça uma cópia íntegra ou exporte a aba de novo a partir do Excel.",
  "wb.issue.REPAIR_REJECTED.title": "Um reparo confirmado foi recusado: {reason}",
  "wb.issue.REPAIR_REJECTED.many.title":
    "{count} reparos confirmados foram recusados; o primeiro: {reason}",
  "wb.issue.REPAIR_REJECTED.hint":
    "Nada foi importado. Volte ao mapeamento, revise os reparos e confirme de novo.",
  "wb.repairReject.SHEET_MISMATCH": "o reparo é de outra aba",
  "wb.repairReject.FIELD_NOT_MAPPED": "a coluna do reparo já não está mapeada para esse campo",
  "wb.repairReject.CELL_MISSING": "a célula não existe no arquivo",
  "wb.repairReject.CELL_CHANGED": "o valor da célula mudou desde a sugestão",
  "wb.repairReject.DUPLICATE": "a mesma célula foi reparada duas vezes",
  "wb.repairReject.VALUE_NOT_ALLOWED": "o novo valor não é permitido para este tipo de reparo",
  "wb.repairReject.SOURCE_UNUSABLE": "a coluna de origem não tem um valor utilizável nesta linha",
  "wb.repairReject.NOT_IN_CATALOG": "o NCM resultante não está no catálogo",
  // -- Calculator research — end --
  "nav.uploadFailures": "Planilhas com erro",
  "uploadFailures.title": "Planilhas com erro",
  "uploadFailures.description":
    "Envios para a calculadora que falharam, com o que o operador viu e o arquivo original.",
  "uploadFailures.denied": "Somente administradores da plataforma veem as planilhas com erro.",
  "uploadFailures.filter.search": "Código para o suporte",
  "uploadFailures.filter.placeholder": "Cole o código aqui",
  "uploadFailures.filter.reviewed": "Revisão",
  "uploadFailures.filter.from": "De",
  "uploadFailures.filter.to": "Até",
  "uploadFailures.filter.operator": "Operador",
  "uploadFailures.filter.operatorPlaceholder": "E-mail ou id do operador",
  "uploadFailures.filter.errorCode": "Código de erro",
  "uploadFailures.filter.anyError": "Todos os erros",
  "uploadFailures.filter.kind": "Conteúdo do arquivo",
  "uploadFailures.filter.anyKind": "Todos os tipos",
  "uploadFailures.filter.stage": "Etapa",
  "uploadFailures.filter.anyStage": "Todas",
  "uploadFailures.filter.range": "Período",
  "uploadFailures.reviewed.all": "Todas",
  "uploadFailures.reviewed.pending": "Pendentes",
  "uploadFailures.reviewed.done": "Revisadas",
  "uploadFailures.stage.INSPECT": "Leitura",
  "uploadFailures.stage.IMPORT": "Importação",
  "uploadFailures.stage.REPAIR": "Correção",
  "uploadFailures.kind.xlsx": "Excel (.xlsx)",
  "uploadFailures.kind.xls": "Excel antigo (.xls)",
  "uploadFailures.kind.csv": "CSV",
  "uploadFailures.kind.zip": "Zip",
  "uploadFailures.kind.html": "HTML",
  "uploadFailures.kind.unknown": "Desconhecido",
  "uploadFailures.column.when": "Quando",
  "uploadFailures.column.operator": "Operador",
  "uploadFailures.column.file": "Arquivo",
  "uploadFailures.column.kind": "Conteúdo",
  "uploadFailures.column.stage": "Etapa",
  "uploadFailures.column.error": "Erro principal",
  "uploadFailures.column.code": "Código para o suporte",
  "uploadFailures.column.reviewed": "Revisão",
  "uploadFailures.status.reviewed": "Revisada",
  "uploadFailures.status.pending": "Pendente",
  "uploadFailures.open": "Abrir {name}",
  "uploadFailures.noName": "Arquivo sem nome",
  "uploadFailures.nameSays": "nome .{extension}",
  "uploadFailures.unknownOperator": "Operador sem e-mail",
  "uploadFailures.summary": "{count} nesta página",
  "uploadFailures.summaryMore": "{count} nesta página · há mais",
  "uploadFailures.empty.title": "Nenhuma planilha com erro",
  "uploadFailures.empty.body":
    "Quando um envio para a calculadora falhar, ele aparece aqui com o código que o operador viu.",
  "uploadFailures.searchHint":
    "Aceita também request id e correlation id. Busca exata; com 8 ou mais caracteres, pelo início.",
  "uploadFailures.drawer.subtitle": "{operator} · {relative}",
  "uploadFailures.drawer.notFoundTitle": "Envio não encontrado",
  "uploadFailures.drawer.notFound": "Nenhuma falha com o código {code}. Confira o código colado.",
  "uploadFailures.section.detected": "O que o servidor detectou",
  "uploadFailures.section.errors": "Erros",
  "uploadFailures.section.technical": "Detalhes técnicos",
  "uploadFailures.section.versions": "Versões",
  "uploadFailures.section.original": "Arquivo original",
  "uploadFailures.section.review": "Revisão",
  "uploadFailures.finding.OOXML_WORKBOOK": "Planilha Excel (.xlsx) válida",
  "uploadFailures.finding.OOXML_MACRO_WORKBOOK": "Planilha Excel com macros (.xlsm)",
  "uploadFailures.finding.OOXML_ENCRYPTED": "xlsx protegido por senha (criptografado)",
  "uploadFailures.finding.LEGACY_XLS_BIFF": "xls antigo (BIFF, Excel 97-2003)",
  "uploadFailures.finding.OLE2_OTHER": "Outro documento do Office (OLE2), não uma planilha",
  "uploadFailures.finding.HTML_DISGUISED": "O arquivo é HTML disfarçado de .xls/.xlsx",
  "uploadFailures.finding.ZIP_WITHOUT_WORKBOOK": "zip sem workbook (não há xl/workbook.xml)",
  "uploadFailures.finding.ZIP_DAMAGED": "zip danificado (o diretório do arquivo não pôde ser lido)",
  "uploadFailures.finding.DELIMITED_TEXT": "Texto delimitado (CSV)",
  "uploadFailures.finding.PDF": "O arquivo é um PDF, não uma planilha",
  "uploadFailures.finding.EMPTY": "O arquivo está vazio (0 bytes)",
  "uploadFailures.finding.TEXT_UNKNOWN": "Texto que não é uma tabela",
  "uploadFailures.finding.BINARY_UNKNOWN": "Binário de formato desconhecido",
  "uploadFailures.finding.NOT_RECEIVED": "Os bytes não chegaram ao servidor",
  "uploadFailures.detected.magic": "Assinatura (magic bytes)",
  "uploadFailures.detected.noMagic": "Sem assinatura binária (conteúdo de texto ou não recebido)",
  "uploadFailures.detected.extension": "Extensão do nome",
  "uploadFailures.detected.contentType": "Conteúdo detectado",
  "uploadFailures.detected.mismatch": "O nome diz .{extension}, mas o conteúdo é {detected}.",
  "uploadFailures.detected.sheets": "Abas lidas",
  "uploadFailures.detected.noSheets": "Nenhuma aba pôde ser lida",
  "uploadFailures.detected.zipEntries": "Entradas no zip",
  "uploadFailures.detected.noExtension": "sem extensão",
  "uploadFailures.errors.response": "HTTP {status} · {code}",
  "uploadFailures.errors.detail": "Mensagem técnica da API (inglês)",
  "uploadFailures.errors.none":
    "A API não devolveu violações para este envio; veja a mensagem técnica.",
  "uploadFailures.errors.field": "Campo",
  "uploadFailures.tech.more": "Dados técnicos (MIME, navegador, hashes)",
  "uploadFailures.tech.supportCode": "Código para o suporte",
  "uploadFailures.tech.requestId": "Request id",
  "uploadFailures.tech.correlationId": "Correlation id",
  "uploadFailures.tech.httpStatus": "Status HTTP",
  "uploadFailures.tech.problemCode": "Código do problema",
  "uploadFailures.tech.userAgent": "Navegador (user agent)",
  "uploadFailures.tech.sha256": "SHA-256",
  "uploadFailures.tech.size": "Tamanho",
  "uploadFailures.tech.declaredContentType": "Tipo declarado pelo nome",
  "uploadFailures.tech.stage": "Etapa",
  "uploadFailures.tech.createdAt": "Recebido em",
  "uploadFailures.tech.operator": "Operador",
  "uploadFailures.versions.app": "Aplicativo",
  "uploadFailures.versions.engine": "Motor de cálculo",
  "uploadFailures.versions.parser": "Leitor de planilhas",
  "uploadFailures.versions.ruleset": "Ruleset",
  "uploadFailures.original.status.STORED": "Guardado",
  "uploadFailures.original.status.PENDING": "Sendo guardado",
  "uploadFailures.original.status.NOT_RECEIVED": "Não recebido",
  "uploadFailures.original.status.TOO_LARGE": "Grande demais",
  "uploadFailures.original.status.STORE_FAILED": "Falha ao guardar",
  "uploadFailures.original.status.EXPIRED": "Expirado",
  "uploadFailures.original.explain.STORED":
    "Disponível para administradores durante a retenção de 30 dias.",
  "uploadFailures.original.explain.PENDING":
    "O arquivo ainda está sendo guardado. Tente de novo em alguns instantes.",
  "uploadFailures.original.explain.NOT_RECEIVED":
    "Os bytes não chegaram ao servidor; só os metadados foram registrados.",
  "uploadFailures.original.explain.TOO_LARGE":
    "O arquivo passou do limite de envio e não foi guardado; só os metadados foram registrados.",
  "uploadFailures.original.explain.STORE_FAILED":
    "O armazenamento estava indisponível; só os metadados foram registrados.",
  "uploadFailures.original.explain.EXPIRED": "O arquivo foi apagado ao fim da retenção de 30 dias.",
  "uploadFailures.original.expiresAt": "Expira em",
  "uploadFailures.original.expiredAt": "Expirou em",
  "uploadFailures.original.download": "Baixar arquivo original",
  "uploadFailures.original.downloading": "Baixando…",
  "uploadFailures.toast.downloaded": "Arquivo baixado · {name}",
  "uploadFailures.toast.downloadFailed": "Não foi possível baixar {name}",
  "uploadFailures.review.pending": "Ainda não revisada.",
  "uploadFailures.review.done": "Revisada por {by} em {date}.",
  "uploadFailures.review.markReviewed": "Marcar como revisado",
  "uploadFailures.review.reopen": "Reabrir",
  "uploadFailures.review.note": "Nota da revisão",
  "uploadFailures.review.notePlaceholder": "O que foi visto e o que foi orientado ao operador",
  "uploadFailures.review.noteCount": "{count} de {max} caracteres",
  "uploadFailures.review.saveNote": "Salvar nota",
  "uploadFailures.review.saving": "Salvando…",
  "uploadFailures.toast.reviewed": "Marcada como revisada · {name}",
  "uploadFailures.toast.reopened": "Reaberta · {name}",
  "uploadFailures.toast.noteSaved": "Nota salva · {name}",
  "uploadFailures.toast.reviewFailed": "Não foi possível salvar a revisão",
  "uploadFailures.copyCode": "Copiar código",
  "wb.issue.HTML_AS_XLS.title": "Este arquivo é uma página HTML com nome de planilha",
  "wb.issue.HTML_AS_XLS.hint":
    "Abra no Excel e use Salvar como → Pasta de Trabalho do Excel (.xlsx), depois envie de novo.",
  "wb.issue.ZIP_NO_WORKBOOK.title": "Este .zip não contém uma planilha Excel",
  "wb.issue.ZIP_NO_WORKBOOK.hint": "Envie o próprio arquivo .xlsx, sem compactar.",
  "nav.infraCost": "Custo da infraestrutura",
  "infraCost.title": "Custo estimado da infraestrutura",
  "infraCost.description":
    "Quanto a plataforma custa por mês no Google Cloud, por serviço, com cenários de uso e onde economizar.",
  "infraCost.denied":
    "Somente administradores da plataforma veem o custo estimado da infraestrutura.",
  "infraCost.estimateLabel": "Estimativa, não é fatura",
  "infraCost.loading": "Carregando a estimativa",
  "infraCost.banner.title": "Estimativa, não é uma fatura.",
  "infraCost.banner.body":
    "Preços públicos de tabela de {region} conferidos em {date}, sem descontos, créditos, compromissos de uso nem impostos. O valor cobrado de fato está no Cloud Billing.",
  "infraCost.scenario.legend": "Cenário",
  "infraCost.scenario.IDLE": "Ocioso",
  "infraCost.scenario.TYPICAL": "Típico",
  "infraCost.scenario.HIGH": "Alta carga",
  "infraCost.scenario.IDLE.summary":
    "Ninguém usando: só instâncias mínimas, banco, VMs, agendadores e armazenamento.",
  "infraCost.scenario.TYPICAL.summary":
    "Uso de hoje: lotes, linhas e gasto de IA dos últimos 30 dias registrados no app.",
  "infraCost.scenario.HIGH.summary":
    "Cerca de 2.000 usuários simultâneos, IA no teto do orçamento e Cloud SQL dimensionado para a carga.",
  "infraCost.totals.label": "Totais do cenário",
  "infraCost.totals.usd": "Total mensal (US$)",
  "infraCost.totals.brl": "Total mensal (R$)",
  "infraCost.totals.perMonth": "por mês",
  "infraCost.totals.perMonthShort": "/mês",
  "infraCost.totals.perYear": "≈ {value} por ano",
  "infraCost.totals.rate": "US$ 1 = R$ {rate} · PTAX venda de {date}",
  "infraCost.totals.fixed": "Custos fixos",
  "infraCost.totals.variable": "Custos por uso",
  "infraCost.totals.share": "{share} do total",
  "infraCost.totals.fixedHint": "pagos mesmo sem uso",
  "infraCost.totals.variableHint": "crescem com o uso",
  "infraCost.kind.FIXED": "Fixo",
  "infraCost.kind.VARIABLE": "Por uso",
  "infraCost.byService.title": "Custo por serviço",
  "infraCost.byService.tooltip": "{service}: fixo {fixed}, por uso {variable}",
  "infraCost.split.title": "Fixo × por uso",
  "infraCost.split.hint": "no cenário escolhido",
  "infraCost.split.aria": "Fixo {fixed}, por uso {variable}",
  "infraCost.split.fixedHint":
    "Instâncias mínimas, Cloud SQL, VMs, NAT, armazenamento e agendadores.",
  "infraCost.split.variableHint": "Requisições, CPU dos jobs, tokens do Gemini, egress e logs.",
  "infraCost.drivers.title": "Maiores custos",
  "infraCost.drivers.hint": "os 5 itens mais caros",
  "infraCost.compare.title": "Cenários",
  "infraCost.compare.hint": "escolha um para ver o detalhe",
  "infraCost.compare.shown": "Em exibição",
  "infraCost.compare.fixed": "Fixo",
  "infraCost.compare.variable": "Por uso",
  "infraCost.compare.requests": "Requisições/mês",
  "infraCost.compare.rows": "Linhas/mês",
  "infraCost.compare.ai": "IA (Gemini)",
  "infraCost.table.title": "Detalhamento por item",
  "infraCost.table.hint": "cenário {scenario}",
  "infraCost.table.showAll": "Mostrar todos os {count} itens",
  "infraCost.table.showLess": "Mostrar menos",
  "infraCost.table.item": "Item",
  "infraCost.table.service": "Serviço",
  "infraCost.table.kind": "Tipo",
  "infraCost.table.quantity": "Quantidade/mês",
  "infraCost.table.basis": "Base",
  "infraCost.table.usd": "US$/mês",
  "infraCost.table.brl": "R$/mês",
  "infraCost.basis.TERRAFORM": "Terraform",
  "infraCost.basis.RECORDED": "Registrado no app",
  "infraCost.basis.MODELED": "Premissa",
  "infraCost.service.CLOUD_RUN": "Cloud Run (serviços)",
  "infraCost.service.CLOUD_RUN_JOBS": "Cloud Run (jobs)",
  "infraCost.service.CLOUD_SQL": "Cloud SQL",
  "infraCost.service.COMPUTE_ENGINE": "Compute Engine (VMs)",
  "infraCost.service.NETWORKING": "Rede (NAT, IPs, egress)",
  "infraCost.service.API_GATEWAY": "API Gateway",
  "infraCost.service.CLOUD_STORAGE": "Cloud Storage",
  "infraCost.service.ARTIFACT_REGISTRY": "Artifact Registry",
  "infraCost.service.PUBSUB": "Pub/Sub",
  "infraCost.service.CLOUD_SCHEDULER": "Cloud Scheduler",
  "infraCost.service.SECRET_MANAGER": "Secret Manager",
  "infraCost.service.CLOUD_LOGGING": "Cloud Logging",
  "infraCost.service.FIREBASE_HOSTING": "Firebase Hosting",
  "infraCost.service.VERTEX_AI": "Vertex AI (Gemini)",
  "infraCost.line.runMinInstances": "APIs sempre ligadas",
  "infraCost.lineDetail.runMinInstances":
    "1 instância mínima da API admin (2 vCPU, 2 GiB, CPU sempre alocada, tarifa por instância) e da runtime (2 vCPU, 2 GiB, tarifa ociosa).",
  "infraCost.line.runServiceRequests": "Requisições das APIs",
  "infraCost.lineDetail.runServiceRequests":
    "CPU e memória enquanto atendem, mais US$ 0,40 por milhão.",
  "infraCost.line.runWorkers": "Workers de coleta e extração",
  "infraCost.lineDetail.runWorkers":
    "Fetcher e extractor (1 vCPU, 1 GiB) por documento processado.",
  "infraCost.line.jobsScheduledTicks": "Disparos agendados dos jobs",
  "infraCost.lineDetail.jobsScheduledTicks":
    "Cada disparo inicia uma execução mesmo sem trabalho: fila de lotes a cada minuto, pesquisa da calculadora a cada 2 min, pesquisa web, NF-e e agente a cada 5 min.",
  "infraCost.line.jobsLotRows": "Cálculo das linhas dos lotes",
  "infraCost.lineDetail.jobsLotRows": "CPU do executor de lotes por linha calculada.",
  "infraCost.line.jobsWebResearch": "Execução da pesquisa web",
  "infraCost.lineDetail.jobsWebResearch":
    "Horas do job de pesquisa (2 vCPU, 2 GiB) com varreduras ativas.",
  "infraCost.line.sqlInstance": "Instância do Cloud SQL",
  "infraCost.lineDetail.sqlInstance":
    "Postgres Enterprise db-custom-1-3840 (1 vCPU, 3,75 GB), zonal, 24 h.",
  "infraCost.line.sqlStorage": "Disco do Cloud SQL",
  "infraCost.lineDetail.sqlStorage": "25 GB SSD com crescimento automático.",
  "infraCost.line.sqlBackups": "Backups do Cloud SQL",
  "infraCost.lineDetail.sqlBackups": "14 backups diários e 7 dias de recuperação pontual (PITR).",
  "infraCost.line.vmBrowserAgent": "VM do agente de navegador",
  "infraCost.lineDetail.vmBrowserAgent":
    "e2-standard-4 (4 vCPU, 16 GB) ligada 24 h, mais 80 GiB de disco: 60 de inicialização e 20 do perfil.",
  "infraCost.line.vmTwingate": "VM do conector Twingate",
  "infraCost.lineDetail.vmTwingate": "e2-micro ligada 24 h, mais 10 GB de disco.",
  "infraCost.line.natGateways": "Gateways Cloud NAT",
  "infraCost.lineDetail.natGateways": "Dois NAT (workers e Twingate), cobrados por VM atrás deles.",
  "infraCost.line.natData": "Tráfego pelo NAT",
  "infraCost.lineDetail.natData": "Dados que os workers e o agente baixam da internet.",
  "infraCost.line.externalIps": "IPs externos",
  "infraCost.lineDetail.externalIps": "IP fixo de saída dos workers e IP do NAT do Twingate.",
  "infraCost.line.egress": "Egress para a internet",
  "infraCost.lineDetail.egress": "Respostas da API e downloads saindo de São Paulo.",
  "infraCost.line.apiGateway": "Chamadas ao API Gateway",
  "infraCost.lineDetail.apiGateway": "Chamadas do navegador à API admin, US$ 3 por milhão.",
  "infraCost.line.gcsStorage": "Buckets do Cloud Storage",
  "infraCost.lineDetail.gcsStorage":
    "Evidências, normalizados, cálculos, planilhas e quadros do agente.",
  "infraCost.line.registryStorage": "Imagens no Artifact Registry",
  "infraCost.lineDetail.registryStorage":
    "Imagens imutáveis de cada deploy, sem política de limpeza.",
  "infraCost.line.pubsub": "Mensagens do Pub/Sub",
  "infraCost.lineDetail.pubsub": "Descoberta, documentos coletados e normalizados, DLQ e pesquisa.",
  "infraCost.line.scheduler": "Jobs do Cloud Scheduler",
  "infraCost.lineDetail.scheduler": "8 agendamentos a US$ 0,10 por mês cada.",
  "infraCost.line.secretManager": "Segredos",
  "infraCost.lineDetail.secretManager": "Versões ativas de 12 segredos e seus acessos.",
  "infraCost.line.logging": "Ingestão de logs",
  "infraCost.lineDetail.logging": "Acima dos 50 GiB gratuitos por projeto.",
  "infraCost.line.firebaseHosting": "Firebase Hosting",
  "infraCost.lineDetail.firebaseHosting": "Transferência do app web acima de 360 MB por dia.",
  "infraCost.line.geminiResearch": "Gemini da pesquisa web",
  "infraCost.lineDetail.geminiResearch":
    "Buscas fundamentadas e tokens do Gemini 2.5 Flash, como o app registra por lote.",
  "infraCost.line.geminiNfe": "Gemini da análise de NF-e",
  "infraCost.lineDetail.geminiNfe": "Tokens do Gemini 2.5 Flash registrados por execução.",
  "infraCost.line.geminiBrowserAgent": "Gemini do agente de navegador",
  "infraCost.lineDetail.geminiBrowserAgent": "Tokens estimados por passo do agente.",
  "infraCost.savings.title": "Onde economizar",
  "infraCost.savings.hint": "até {total}/mês no cenário típico",
  "infraCost.savings.perMonth": "−{value}/mês",
  "infraCost.saving.browserAgentSmallerVm.title": "VM do agente em e2-standard-2",
  "infraCost.saving.browserAgentSmallerVm.detail":
    "Metade da CPU e da memória. Ou desligar fora do horário comercial com um agendamento.",
  "infraCost.saving.apiMinInstancesZero.title": "APIs sem instância mínima",
  "infraCost.saving.apiMinInstancesZero.detail":
    "min_instance_count 0 nas APIs admin e runtime (api_min_instances no módulo platform).",
  "infraCost.saving.cloudSqlCommittedUse.title": "Compromisso de uso do Cloud SQL",
  "infraCost.saving.cloudSqlCommittedUse.detail":
    "Desconto de 25% em vCPU e memória com compromisso de 1 ano.",
  "infraCost.saving.taskRunnerEveryFiveMinutes.title": "Fila de lotes a cada 5 minutos",
  "infraCost.saving.taskRunnerEveryFiveMinutes.detail":
    "Hoje o agendador dispara o executor de lotes a cada minuto, com ou sem trabalho.",
  "infraCost.saving.calculatorTickEveryFiveMinutes.title":
    "Pesquisa da calculadora a cada 5 minutos",
  "infraCost.saving.calculatorTickEveryFiveMinutes.detail":
    "O disparo instantâneo já cobre o caso urgente; o agendador é só a rede de segurança.",
  "infraCost.saving.registryCleanupPolicy.title": "Limpeza do Artifact Registry",
  "infraCost.saving.registryCleanupPolicy.detail": "Manter só as últimas imagens de cada serviço.",
  "infraCost.tradeoff.COLD_START": "Primeira requisição mais lenta (cold start antes do login).",
  "infraCost.tradeoff.SLOWER_PICKUP": "Trabalho novo pode esperar alguns minutos a mais.",
  "infraCost.tradeoff.SLOWER_AGENT": "Agente de navegador mais lento.",
  "infraCost.tradeoff.NONE": "Sem impacto no produto.",
  "infraCost.tradeoff.COMMITMENT": "Compromisso de pagamento por 1 ano.",
  "infraCost.usage.title": "Uso registrado no app",
  "infraCost.usage.window": "{from} a {to}",
  "infraCost.usage.unavailable":
    "Não foi possível ler os registros do app agora. O cenário típico usa o perfil documentado.",
  "infraCost.usage.lots": "Lotes",
  "infraCost.usage.lotRows": "Linhas de lotes",
  "infraCost.usage.calculations": "Cálculos",
  "infraCost.usage.researchUnits": "Unidades de pesquisa",
  "infraCost.usage.groundedCalls": "Buscas fundamentadas",
  "infraCost.usage.researchCost": "Gasto da pesquisa (registrado)",
  "infraCost.usage.nfeRuns": "Análises de NF-e",
  "infraCost.usage.nfeCost": "Gasto da NF-e (registrado)",
  "infraCost.usage.browserAgentSteps": "Passos do agente",
  "infraCost.usage.researchDocuments": "Documentos de pesquisa",
  "infraCost.usage.caps":
    "Tetos mensais de IA definidos no app: pesquisa web {research}, NF-e {nfe}.",
  "infraCost.assumptions.title": "Premissas e fontes",
  "infraCost.assumptions.model": "Premissas do modelo",
  "infraCost.assumptions.terraformSource": "Dimensionamento lido de: {source}.",
  "infraCost.assumption.prices":
    "Preços públicos de tabela de {region} (São Paulo, região mais cara que us-central1), conferidos em {date}.",
  "infraCost.assumption.freeTiers":
    "Cotas gratuitas da conta de faturamento (Cloud Run, Scheduler, Secret Manager, API Gateway, Artifact Registry) não são descontadas, porque a conta também paga outros projetos. Só os 50 GiB de logs por projeto são descontados.",
  "infraCost.assumption.terraform":
    "Tamanhos fixos (CPU, memória, instâncias mínimas, tier do banco, VMs, agendamentos) vêm do Terraform, modelo {version}. Um teste falha quando o Terraform muda e o modelo não.",
  "infraCost.assumption.ticks":
    "Cada disparo do Cloud Scheduler inicia uma execução de job mesmo sem trabalho; supomos 15 a 20 s por execução vazia.",
  "infraCost.assumption.requests":
    "O app não registra requisições: o cenário típico supõe {requests} por mês; alta carga, 2.000 usuários simultâneos com uma chamada a cada 20 s, 10 h por dia, 22 dias úteis.",
  "infraCost.assumption.ai":
    "Pesquisa web e NF-e usam o custo em US$ que o app registra (Gemini 2.5 Flash). A pesquisa cobra cada busca fundamentada a US$ 35 por 1.000, mas a Vertex AI dá 1.500 por dia grátis: o valor registrado é um teto.",
  "infraCost.assumption.browserAgent":
    "Agente de navegador: {input} tokens de entrada e {output} de saída por passo (Gemini 2.5 Flash).",
  "infraCost.assumption.highSql":
    "Alta carga supõe Cloud SQL com 4 vCPU, 16 GB e alta disponibilidade: o tier atual não sustenta milhares de usuários.",
  "infraCost.assumption.storage":
    "Volumes de armazenamento, backups, imagens, egress e logs são estimados; a exportação de faturamento daria os valores reais.",
  "infraCost.assumption.gateway":
    "O API Gateway roda em us-east1 (não existe em São Paulo); o tráfego entre regiões não está separado.",
  "infraCost.assumption.fx":
    "Câmbio só para exibição: PTAX venda do Banco Central de {date}, US$ 1 = R$ {rate}. O modelo é em US$.",
  "infraCost.billing.title": "Valores reais do faturamento",
  "infraCost.billing.NOT_CONFIGURED":
    "A exportação do Cloud Billing para o BigQuery não está configurada no Terraform, então esta página não usa a fatura real.",
  "infraCost.billing.CONFIGURED": "A exportação do Cloud Billing para o BigQuery está configurada.",
  "infraCost.billing.step1":
    "No console, abra Faturamento → Exportação de faturamento da conta que paga backchannel-agent-dolphin (requer Administrador da conta de faturamento).",
  "infraCost.billing.step2":
    "Ative “Custo de uso detalhado” para um dataset do BigQuery, por exemplo billing_export em backchannel-agent-dolphin.",
  "infraCost.billing.step3":
    "Os dados começam a chegar em algumas horas; o histórico anterior não é preenchido.",
  "infraCost.billing.step4":
    "Depois, filtre por project.id = backchannel-agent-dolphin e compare com esta estimativa.",
  "infraCost.billing.docs": "Como configurar a exportação (Google Cloud)",
  "infraCost.sources.title": "Preços unitários e fontes",
  "infraCost.sources.hint": "lista pública, em US$",
  "infraCost.sources.sku": "SKU",
  "infraCost.sources.price": "Preço",
  "infraCost.sources.scope": "Abrangência",
  "infraCost.sources.source": "Fonte",
  "infraCost.sources.checked": "Conferido em",
  "infraCost.unit.vCPU-s": "vCPU-s",
  "infraCost.unit.requests": "requisições",
  "infraCost.unit.documents": "documentos",
  "infraCost.unit.executions": "execuções",
  "infraCost.unit.rows": "linhas",
  "infraCost.unit.hours": "horas",
  "infraCost.unit.GB-month": "GB-mês",
  "infraCost.unit.gateways": "gateways",
  "infraCost.unit.addresses": "endereços",
  "infraCost.unit.GiB": "GiB",
  "infraCost.unit.calls": "chamadas",
  "infraCost.unit.jobs": "jobs",
  "infraCost.unit.versions": "versões",
  "infraCost.unit.GB": "GB",
  "infraCost.unit.USD": "US$",
  "infraCost.unit.steps": "passos",
  "infraCost.priceUnit.vCPU-second": "vCPU-segundo",
  "infraCost.priceUnit.GiB-second": "GiB-segundo",
  "infraCost.priceUnit.million requests": "milhão de requisições",
  "infraCost.priceUnit.vCPU-hour": "vCPU-hora",
  "infraCost.priceUnit.GB-hour": "GB-hora",
  "infraCost.priceUnit.GB-month": "GB-mês",
  "infraCost.priceUnit.hour": "hora",
  "infraCost.priceUnit.VM-hour": "VM-hora",
  "infraCost.priceUnit.GiB": "GiB",
  "infraCost.priceUnit.million calls": "milhão de chamadas",
  "infraCost.priceUnit.TiB": "TiB",
  "infraCost.priceUnit.job-month": "job-mês",
  "infraCost.priceUnit.version-month": "versão-mês",
  "infraCost.priceUnit.10,000 operations": "10.000 operações",
  "infraCost.priceUnit.GB": "GB",
  "infraCost.priceUnit.1M tokens": "1 milhão de tokens",
  "infraCost.priceUnit.1,000 grounded prompts": "1.000 prompts com grounding",
  "infraCost.note.runCpuActive": "southamerica-east1 é uma região Tier 2 do Cloud Run.",
  "infraCost.note.runCpuIdle":
    "Instâncias mínimas ociosas de serviços por requisição pagam CPU na tarifa ociosa reduzida.",
  "infraCost.note.runJobCpu": "Jobs cobram a execução inteira, inclusive a inicialização.",
  "infraCost.note.runCpuInstance":
    "Serviços com CPU sempre alocada pagam a vida inteira da instância, ociosa ou ocupada.",
  "infraCost.note.sqlVcpu": "HA (REGIONAL) dobra os preços de vCPU, memória e armazenamento.",
  "infraCost.note.externalIp": "IPs internos (agente de navegador, Twingate) são gratuitos.",
  "infraCost.note.geminiFlashInput":
    "O app precifica pesquisas e execuções de NF-e com a própria tabela de preços, editável pelo admin; quando existem, usamos esses valores registrados.",
  "infraCost.note.groundedPrompt":
    "O Vertex AI dá 1.500 prompts com grounding por dia de graça (família 2.0/2.5 Flash, compartilhada). O app registra cada chamada com grounding a este preço, então o gasto registrado em pesquisa é um teto.",
  "infraCost.scope.REGIONAL": "São Paulo",
  "infraCost.scope.GLOBAL": "Global",
  "infraCost.scope.OTHER_REGION": "Outra região",
  "ncmSearch.label": "Produto ou NCM",
  "ncmSearch.placeholder": "Ex.: bolacha ou 8471.30.12",
  "ncmSearch.hint":
    "Digite o nome do produto, em português, espanhol ou inglês, ou os 8 dígitos da NCM.",
  "ncmSearch.searching": "Procurando no catálogo oficial…",
  "ncmSearch.error": "Não foi possível procurar agora. Digite o NCM ou tente de novo.",
  "ncmSearch.empty": "Nenhum NCM encontrado. Tente outro nome, um sinônimo ou o código.",
  "ncmSearch.catalogPending":
    "A tabela completa ainda está sendo carregada; os resultados podem ser parciais.",
  "ncmSearch.clear": "Limpar",
  "ncmSearch.count": "{count} sugestões",
  "ncmSearch.results": "Sugestões de NCM",
  "ncmSearch.group.catalog": "Tabela NCM oficial",
  "ncmSearch.group.history": "Produtos parecidos já classificados",
  "ncmSearch.reference": "Referência Siscomex/TIPI. Confira a descrição oficial; não é alíquota.",
  "ncmSearch.matched": "encontrado por “{term}”",
  "ncmSearch.cestOne": "CEST {cest}",
  "ncmSearch.cestMany": "CEST {cest} +{count}",
  "ncmSearch.spSt": "SP: ST na regra publicada",
  "ncmSearch.spNoSt": "SP: sem ST na regra publicada",
  "ncmSearch.unofficial": "tradução não oficial",
  "ncmSearch.officialText": "Texto oficial:",
  "ncmSearch.notInTable": "Fora da tabela oficial vigente",
  "ncmSearch.historySeen.one": "visto em {count} linha dos seus lotes",
  "ncmSearch.historySeen.other": "visto em {count} linhas dos seus lotes",
  "ncmSearch.illustrative": "ilustrativo",
  "commandSearch.group.products": "Produtos → NCM",
  "commandSearch.product.hint": "Calcular com este NCM",
  "repair.ncm.search": "Nenhum destes? Procure o produto",
  "repair.ncm.searchHint":
    "Escolha um NCM da tabela oficial. Ele substitui o valor da célula só depois de você aplicar.",
  "repair.ncm.chosen": "NCM escolhido na tabela oficial",
  "ncmSearch.illustrativeHint":
    "Ilustrativo: imagem gerada por IA para sugerir o tipo de mercadoria. A identificação é o NCM e o texto oficial.",
  "rules.chapterDetail.illustration.illustrative":
    "Ilustrativo · imagem gerada por IA. A identidade do capítulo é a tesela SH e o título oficial Siscomex.",
  "nav.sessions": "Sessões",
  "sessions.replay.heading": "Sessão de {name}",
  "sessions.title": "Sessões",
  "sessions.description":
    "Veja o que cada operador fez: a gravação da tela e cada ação registrada.",
  "sessions.denied": "Somente um administrador da plataforma pode ver as sessões.",
  "sessions.configure": "Configurar gravação",
  "sessions.view.legend": "O que mostrar",
  "sessions.view.sessions": "Sessões",
  "sessions.view.activity": "Atividade",
  "sessions.filter.operator": "Operador",
  "sessions.filter.operatorPlaceholder": "E-mail ou identificador",
  "sessions.filter.from": "De",
  "sessions.filter.to": "Até",
  "sessions.filter.range": "Período",
  "sessions.filter.errors": "Erros",
  "sessions.filter.errors.all": "Todas",
  "sessions.filter.errors.with": "Com erros",
  "sessions.filter.errors.without": "Sem erros",
  "sessions.filter.kind": "Tipo de ação",
  "sessions.filter.anyKind": "Qualquer tipo",
  "sessions.filter.outcome": "Resultado",
  "sessions.filter.outcome.all": "Todos",
  "sessions.filter.outcome.ok": "OK",
  "sessions.filter.outcome.error": "Erro",
  "sessions.filter.organization": "Organização",
  "sessions.filter.anyOrganization": "Todas as organizações",
  "sessions.column.operator": "Operador",
  "sessions.column.started": "Início",
  "sessions.column.duration": "Duração",
  "sessions.column.path": "Percurso",
  "sessions.column.actions": "Ações",
  "sessions.column.errors": "Erros",
  "sessions.column.size": "Tamanho",
  "sessions.column.when": "Quando",
  "sessions.column.kind": "Tipo",
  "sessions.column.action": "Ação",
  "sessions.column.result": "Resultado",
  "sessions.column.session": "Sessão",
  "sessions.column.requestId": "requestId",
  "sessions.errors.none": "Sem erros",
  "sessions.errors.api.one": "{count} erro da API",
  "sessions.errors.api.other": "{count} erros da API",
  "sessions.errors.client.one": "{count} erro no navegador",
  "sessions.errors.client.other": "{count} erros no navegador",
  "sessions.actions.one": "{count} ação",
  "sessions.actions.other": "{count} ações",
  "sessions.summary.one": "{count} sessão",
  "sessions.summary.other": "{count} sessões",
  "sessions.summaryMore.one": "{count} sessão · há mais",
  "sessions.summaryMore.other": "{count} sessões · há mais",
  "sessions.activity.summary.one": "{count} registro",
  "sessions.activity.summary.other": "{count} registros",
  "sessions.activity.summaryMore.one": "{count} registro · há mais",
  "sessions.activity.summaryMore.other": "{count} registros · há mais",
  "sessions.kind.CALCULATION": "Cálculo individual",
  "sessions.kind.LOT": "Lote",
  "sessions.kind.SIMULATION": "Simulação de lote",
  "sessions.kind.RECALCULATION": "Recálculo",
  "sessions.kind.UPLOAD": "Envio de planilha",
  "sessions.kind.IMPORT": "Importação",
  "sessions.kind.PROFILE_CONFIRMATION": "Confirmação de perfil",
  "sessions.kind.PROPOSAL": "Proposta",
  "sessions.kind.EVIDENCE": "Evidência",
  "sessions.kind.API_ERROR": "Erro da API",
  "sessions.kind.CLIENT_ERROR": "Erro no navegador",
  "sessions.kind.NAVIGATION": "Navegação",
  "sessions.kind.OTHER": "Outra ação",
  "sessions.outcome.ok": "OK",
  "sessions.outcome.error": "Erro",
  "sessions.empty.title": "Nenhuma sessão neste filtro",
  "sessions.empty.body": "Ajuste o período ou o operador para ver outras sessões.",
  "sessions.activity.empty.title": "Nenhuma atividade neste filtro",
  "sessions.activity.empty.body": "Ajuste o período, o tipo ou o resultado.",
  "sessions.action.CALCULATION": "Calculou uma operação",
  "sessions.action.LOT": "Processou um lote",
  "sessions.action.SIMULATION": "Simulou um lote",
  "sessions.action.RECALCULATION": "Recalculou uma operação",
  "sessions.action.UPLOAD": "Enviou uma planilha",
  "sessions.action.IMPORT": "Importou planilha",
  "sessions.action.PROFILE_CONFIRMATION": "Confirmou o perfil fiscal",
  "sessions.action.PROPOSAL": "Registrou uma proposta",
  "sessions.action.EVIDENCE": "Registrou uma evidência",
  "sessions.action.API_ERROR": "Erro da API {status} · {code}",
  "sessions.action.CLIENT_ERROR": "Erro no navegador: {message}",
  "sessions.action.NAVIGATION": "Abriu {route}",
  "sessions.action.OTHER": "Fez outra ação",
  "sessions.route.sessions": "Sessões",
  "sessions.route.admin": "Administração",
  "sessions.route.calculations": "Calculadora",
  "sessions.route.lots": "Lotes",
  "sessions.route.rules": "Regras",
  "sessions.route.evidence": "Evidências",
  "sessions.route.proposals": "Propostas",
  "sessions.route.invoices": "Notas",
  "sessions.route.sources": "Fontes",
  "sessions.route.overview": "Visão geral",
  "sessions.route.unknown": "Percurso desconhecido",
  "sessions.path.none": "Sem percurso",
  "sessions.settings.title": "Configurar gravação",
  "sessions.settings.status.deployOn": "A gravação está ligada neste ambiente.",
  "sessions.settings.status.deployOff":
    "A gravação está desligada neste ambiente. A preferência da organização continua salva.",
  "sessions.settings.status.storageOn": "O armazenamento das gravações está configurado.",
  "sessions.settings.status.storageOff": "O armazenamento das gravações não está configurado.",
  "sessions.settings.retention.one": "Os registros ficam guardados por {count} dia.",
  "sessions.settings.retention.other": "Os registros ficam guardados por {count} dias.",
  "sessions.settings.enabled": "Gravar sessões nesta organização",
  "sessions.settings.enabledHint":
    "Quando desligado, a tela não é gravada. As ações e os erros continuam no registro.",
  "sessions.settings.sample": "Amostra",
  "sessions.settings.sampleHint": "Porcentagem das sessões que gravam a tela. 100 grava todas.",
  "sessions.settings.sampleInvalid": "Informe uma porcentagem de 0 a 100.",
  "sessions.settings.excluded": "Operadores excluídos",
  "sessions.settings.excludedHint": "Estes operadores não têm a tela gravada.",
  "sessions.settings.excludedPlaceholder": "Cole um identificador ou escolha um e-mail",
  "sessions.settings.excludedAdd": "Adicionar",
  "sessions.settings.excludedPick": "Escolher por e-mail",
  "sessions.settings.excludedInvalid": "Informe um identificador válido ou um e-mail da lista.",
  "sessions.settings.excludedEmpty": "Nenhum operador excluído.",
  "sessions.settings.excludedRemove": "Remover {name}",
  "sessions.settings.excludedFull": "A lista já tem 200 operadores.",
  "sessions.settings.save": "Salvar",
  "sessions.settings.saving": "Salvando…",
  "sessions.settings.saved": "Gravação atualizada",
  "sessions.settings.saveError": "Não foi possível salvar a gravação.",
  "sessions.settings.note":
    "Os registros de atividade (ações e erros) continuam mesmo sem gravação de tela.",
  "sessions.auditNote": "Seu acesso a esta gravação fica registrado na auditoria.",
  "sessions.expires": "Expira em {date}.",
  "sessions.expired": "Esta gravação expirou. A atividade continua listada.",
  "sessions.notFound.title": "Sessão não encontrada",
  "sessions.notFound.body": "Esta sessão não existe ou você não tem acesso a ela.",
  "sessions.back": "Voltar para sessões",
  "sessions.breadcrumb.admin": "Administração",
  "sessions.fact.operator": "Operador",
  "sessions.fact.started": "Início",
  "sessions.fact.duration": "Duração",
  "sessions.fact.browser": "Navegador",
  "sessions.fact.unknownBrowser": "Navegador desconhecido",
  "sessions.fact.version": "Versão",
  "sessions.fact.screen": "Tela",
  "sessions.fact.screenValue": "{width} × {height}",
  "sessions.fact.expires": "Expira em",
  "sessions.player.loading": "Carregando gravação… {loaded} de {total} partes",
  "sessions.player.empty.title": "Sem gravação de tela",
  "sessions.player.empty.body":
    "Não há imagem desta sessão. A atividade continua na linha do tempo.",
  "sessions.player.truncated": "A gravação foi interrompida depois de 400 partes.",
  "sessions.player.play": "Reproduzir",
  "sessions.player.pause": "Pausar",
  "sessions.player.back": "-5 s",
  "sessions.player.forward": "+5 s",
  "sessions.player.speed": "Velocidade",
  "sessions.player.skip": "Pular inatividade",
  "sessions.player.elapsed": "{elapsed} de {total}",
  "sessions.player.fullscreen": "Tela cheia",
  "sessions.player.exitFullscreen": "Sair da tela cheia",
  "sessions.player.scrubber": "Posição da gravação",
  "sessions.player.marker": "Ir para {label}",
  "sessions.timeline.legend": "Linha do tempo",
  "sessions.timeline.all": "Todos",
  "sessions.timeline.errors": "Erros",
  "sessions.timeline.actions": "Ações",
  "sessions.timeline.navigation": "Navegação",
  "sessions.timeline.empty": "Nenhuma ação neste filtro.",
  "sessions.timeline.outside": "fora da gravação",
  "sessions.timeline.details": "Detalhes técnicos",
  "sessions.timeline.method": "Método",
  "sessions.timeline.status": "Status HTTP",
  "sessions.timeline.problem": "Código",
  "sessions.timeline.duration": "Duração",
  "sessions.timeline.requestId": "requestId",
  "sessions.timeline.correlationId": "correlationId",
  "sessions.timeline.audit": "Auditoria",
  "sessions.timeline.uploadFailure": "Ver planilha com erro",
  "sessions.activityTruncated": "A linha do tempo mostra as primeiras 2.000 ações.",
  "sessions.link.watch": "Ver sessão",
  "sessions.link.noRecording": "Sessão sem gravação de tela",
  "sessions.link.activity": "Ver atividade",
  "sessionReplay.notice.title": "Sessão gravada para suporte",
  "sessionReplay.notice.body":
    "Gravamos a tela e as ações desta sessão para suporte e qualidade. Senhas, chaves e campos digitados ficam ocultos. Mantemos por {days} dias.",
  "sessionReplay.notice.ack": "Entendi",
  /* -- Autoaprovação (ADR 0020) ------------------------------------------- */
  "nav.autoApproval": "Autoaprovação",
  "autoApproval.title": "Autoaprovação",
  "autoApproval.description":
    "Aprovação automática governada: cada etapa tem seu interruptor, critérios e auditoria. Tudo começa desligado.",
  "autoApproval.denied": "Somente administradores da plataforma gerenciam a autoaprovação.",
  "autoApproval.tabs": "Seções da autoaprovação",
  "autoApproval.tab.stages": "Etapas",
  "autoApproval.tab.limits": "Limites",
  "autoApproval.tab.preview": "Pré-visualização",
  "autoApproval.tab.report": "Relatório diário",
  "autoApproval.actorLine": "Atuado como {actor} · critérios {policy}",
  "autoApproval.status.allOff": "Desligada. Nada é aprovado ou publicado automaticamente.",
  "autoApproval.status.killSwitch":
    "Interruptor geral do ambiente ativo (AUTO_APPROVAL_KILL_SWITCH). Nenhuma etapa executa.",
  "autoApproval.status.breaker": "Disjuntor aberto",
  "autoApproval.status.off": "Desligada",
  "autoApproval.status.on": "Ligada",
  "autoApproval.status.killed": "Bloqueada pelo interruptor geral",
  "autoApproval.status.breakerPill": "Disjuntor aberto",
  "autoApproval.stage.PACKAGE": "Importar pacote",
  "autoApproval.stage.PACKAGE.desc":
    "Cria propostas pendentes a partir do pacote de regras versionado no repositório, cada uma só quando a evidência dela está aprovada e a regra atual não mudou.",
  "autoApproval.stage.PACKAGE.criteria":
    "Evidência capturada|Evidência aprovada|Regra atual sem mudança|Ainda não importada|Dependência pronta|Grupo habilitado",
  "autoApproval.criterion.PACKAGE_EVIDENCE_READY": "Evidência do pacote aprovada",
  "autoApproval.criterion.PACKAGE_EVIDENCE_READY.tip":
    "Toda evidência citada pelo item está aprovada.",
  "autoApproval.criterion.PACKAGE_EVIDENCE_CAPTURED": "Evidência capturada",
  "autoApproval.criterion.PACKAGE_EVIDENCE_CAPTURED.tip":
    "O documento citado já existe em Documentos (capture a URL se faltar).",
  "autoApproval.criterion.PACKAGE_TARGET_CURRENT": "Regra atual sem mudança",
  "autoApproval.criterion.PACKAGE_TARGET_CURRENT.tip":
    "A regra que o item substitui ainda está como o pacote espera.",
  "autoApproval.criterion.PACKAGE_NOT_IMPORTED": "Ainda não importada",
  "autoApproval.criterion.PACKAGE_NOT_IMPORTED.tip": "O item não foi criado antes (idempotente).",
  "autoApproval.criterion.PACKAGE_DEPENDENCY_READY": "Dependência pronta",
  "autoApproval.criterion.PACKAGE_DEPENDENCY_READY.tip":
    "O SUPERSEDE do par já foi criado antes do UPSERT.",
  "autoApproval.criterion.PACKAGE_GROUP_ENABLED": "Grupo habilitado",
  "autoApproval.criterion.PACKAGE_GROUP_ENABLED.tip":
    "Grupos opcionais só entram com a opção ligada.",
  "autoApproval.outcome.CREATE": "Seria criada",
  "autoApproval.done.CREATE": "Criada",
  "autoApproval.stage.EVIDENCE": "Evidência",
  "autoApproval.stage.FACTS": "Fatos fiscais",
  "autoApproval.stage.PROPOSALS": "Propostas de regra",
  "autoApproval.stage.POLICY_SWITCH": "Política do rascunho",
  "autoApproval.stage.PUBLISH": "Publicação automática",
  "autoApproval.stage.EVIDENCE.desc":
    "Aprova documentos novos de fontes oficiais registradas e saudáveis, com digest estável e um tipo de ato suportado.",
  "autoApproval.stage.FACTS.desc":
    "Certifica fatos fiscais não verificados quando a evidência está aprovada, outra fonte independente concorda e não há conflito nem divergência.",
  "autoApproval.stage.PROPOSALS.desc":
    "Aprova propostas pendentes com evidência aprovada, simulação válida, sem sobreposição e dentro dos limites.",
  "autoApproval.stage.POLICY_SWITCH.desc":
    "Muda a política do rascunho (ex. tax-family-v2) só com readiness zero. Nunca acontece por outra etapa.",
  "autoApproval.stage.PUBLISH.desc":
    "Publica o rascunho quando o canário passa (golden + replay) e reverte sozinho se o canário pós-publicação falhar.",
  "autoApproval.stage.POLICY_SWITCH.note":
    "Mudar a política (ex. tax-family-v2) nunca é automático com esta etapa desligada.",
  "autoApproval.stage.EVIDENCE.criteria":
    "Fonte registrada|URL no registro|Fonte saudável|Fetch ok|Digest estável|Ato suportado",
  "autoApproval.stage.FACTS.criteria":
    "Evidência aprovada|Concordância independente|Sem conflito certificado|Sem drift",
  "autoApproval.stage.PROPOSALS.criteria":
    "Evidência aprovada|Dry-run válido|Sem sobreposição|Dentro dos tetos|Política inalterada",
  "autoApproval.stage.POLICY_SWITCH.criteria": "Política alvo com readiness zero",
  "autoApproval.stage.PUBLISH.criteria":
    "Rascunho presente|Readiness zero|Diff nos limites|Só autoaprovadas|Resfriamento|Canário ok",
  "autoApproval.switch.on": "Ligada",
  "autoApproval.switch.off": "Desligada",
  "autoApproval.lastChange": "Última alteração por {name} em {when} — “{reason}”",
  "autoApproval.neverChanged": "Nunca alterada (padrão de fábrica).",
  "autoApproval.reason.label": "Motivo",
  "autoApproval.reason.help": "Obrigatório, entre 10 e 500 caracteres. Fica na auditoria.",
  "autoApproval.reason.invalid": "Informe um motivo com pelo menos 10 caracteres.",
  "autoApproval.dialog.enable.title": "Ligar {stage}",
  "autoApproval.dialog.disable.title": "Desligar {stage}",
  "autoApproval.dialog.enable.confirm": "Ligar etapa",
  "autoApproval.dialog.disable.confirm": "Desligar etapa",
  "autoApproval.dialog.enable.body.EVIDENCE":
    "Com esta etapa ligada, documentos NEW que passarem em todos os critérios serão aprovados pelo ator do sistema.",
  "autoApproval.dialog.enable.body.FACTS":
    "Com esta etapa ligada, fatos UNVERIFIED que passarem em todos os critérios serão certificados.",
  "autoApproval.dialog.enable.body.PROPOSALS":
    "Com esta etapa ligada, propostas PENDING_REVIEW que passarem em todos os critérios serão aprovadas.",
  "autoApproval.dialog.enable.body.POLICY_SWITCH":
    "Com esta etapa ligada, o rascunho pode mudar para a política alvo quando a readiness for zero.",
  "autoApproval.dialog.enable.body.PUBLISH":
    "Com esta etapa ligada, o rascunho pode ser publicado após o canário. Uma falha pós-publicação reverte e abre o disjuntor.",
  "autoApproval.dialog.disable.body":
    "A etapa deixa de agir nas próximas execuções. Itens já aprovados não são desfeitos.",
  "autoApproval.dialog.enable.previewCount": "Hoje seriam aprovados {count}",
  "autoApproval.run.now": "Executar agora",
  "autoApproval.run.hint": "Dispara uma execução manual com as etapas efetivamente ligadas.",
  "autoApproval.run.disabledTip": "Nenhuma etapa está efetivamente ligada.",
  "autoApproval.run.confirmTitle": "Executar autoaprovação agora?",
  "autoApproval.run.confirmBody":
    "A execução usa as etapas efetivas atuais, com chave de idempotência. Continuar?",
  "autoApproval.run.confirm": "Executar",
  "autoApproval.run.resultTitle": "Resultado da execução",
  "autoApproval.run.result.status": "Status",
  "autoApproval.run.result.acted": "Atuados",
  "autoApproval.run.result.held": "Retidos",
  "autoApproval.run.result.stageCounts": "{acted} atuados · {held} retidos",
  "autoApproval.runStatus.DISABLED": "Desligada",
  "autoApproval.runStatus.LOCKED": "Bloqueada (outra execução)",
  "autoApproval.runStatus.RUNNING": "Em execução",
  "autoApproval.runStatus.COMPLETED": "Concluída",
  "autoApproval.runStatus.PARTIAL": "Parcial",
  "autoApproval.runStatus.FAILED": "Falhou",
  "autoApproval.runStage.SKIPPED": "Ignorada",
  "autoApproval.runStage.COMPLETED": "Concluída",
  "autoApproval.runStage.FAILED": "Falhou",
  "autoApproval.trigger.SCHEDULE": "Agenda",
  "autoApproval.trigger.MANUAL": "Manual",
  "autoApproval.toast.saved": "Configurações salvas",
  "autoApproval.toast.run": "Execução {status}",
  "autoApproval.error.conflict": "Alguém alterou as configurações. Recarregue.",
  "autoApproval.error.save": "Não foi possível salvar. Tente de novo.",
  "autoApproval.done.APPROVE": "Aprovada",
  "autoApproval.done.CERTIFY": "Certificado",
  "autoApproval.done.PUBLISH": "Publicada",
  "autoApproval.done.SWITCH_POLICY": "Política alterada",
  "autoApproval.done.ROLLBACK": "Revertida",
  "autoApproval.done.HOLD": "Retida",
  "autoApproval.outcome.APPROVE": "Seria aprovada",
  "autoApproval.outcome.CERTIFY": "Seria certificado",
  "autoApproval.outcome.PUBLISH": "Seria publicada",
  "autoApproval.outcome.SWITCH_POLICY": "Mudaria política",
  "autoApproval.outcome.ROLLBACK": "Reversão",
  "autoApproval.outcome.HOLD": "Retida",
  "autoApproval.limits.group.evidence": "Evidência",
  "autoApproval.limits.group.package": "Pacote",
  "autoApproval.limits.group.facts": "Fatos",
  "autoApproval.limits.group.proposals": "Propostas",
  "autoApproval.limits.group.publish": "Publicação",
  "autoApproval.limits.group.policy": "Política",
  "autoApproval.limits.package.packageId": "Identificador do pacote",
  "autoApproval.limits.package.packageId.help":
    "Pacote de regras versionado enviado com a API (somente leitura).",
  "autoApproval.limits.package.includeOptionalGroups": "Incluir grupos opcionais (8 e 9)",
  "autoApproval.limits.package.includeOptionalGroups.help":
    "Desligado por padrão. Os grupos 8 e 9 só entram na importação com este interruptor.",
  "autoApproval.limits.package.maxPerRun": "Máximo por execução",
  "autoApproval.limits.package.maxPerRun.help":
    "Itens do pacote avaliados por execução nesta etapa.",
  "autoApproval.package.prerequisites": "Pré-requisitos humanos",
  "autoApproval.package.panel.wouldCreate": "{count} seriam criadas",
  "autoApproval.package.panel.held": "{count} retidas",
  "autoApproval.preview.diagnostics": "Diagnóstico de {stage} (todos os candidatos)",
  "autoApproval.package.panel.title": "Pacote 2026-10-05",
  "autoApproval.package.panel.imported": "{imported} importados",
  "autoApproval.package.panel.total": "{total} itens",
  "autoApproval.package.panel.optional": "Opcional",
  "autoApproval.package.panel.plans": "Planos",
  "autoApproval.limits.invalid":
    "Há valores fora dos limites do contrato. Corrija antes de salvar.",
  "autoApproval.limits.save": "Salvar limites",
  "autoApproval.limits.reset": "Restaurar padrões",
  "autoApproval.limits.dirty": "Alterações locais ainda não salvas.",
  "autoApproval.limits.confirmTitle": "Salvar limites?",
  "autoApproval.limits.confirmBody":
    "Os novos tetos valem na próxima execução. Informe um motivo para a auditoria.",
  "autoApproval.limits.evidence.minObservations": "Observações mínimas",
  "autoApproval.limits.evidence.minObservations.help":
    "Recibos com o mesmo digest antes de aprovar.",
  "autoApproval.limits.evidence.minStableHours": "Horas mínimas estáveis",
  "autoApproval.limits.evidence.minStableHours.help":
    "Ou: visto pela primeira vez há pelo menos estas horas, sem mudança.",
  "autoApproval.limits.evidence.maxPerRun": "Máximo por execução",
  "autoApproval.limits.evidence.maxPerRun.help": "Documentos avaliados por execução nesta etapa.",
  "autoApproval.limits.evidence.supportedActs": "Atos suportados",
  "autoApproval.limits.evidence.supportedActs.help":
    "Tipos de ato oficial que a etapa pode aprovar.",
  "autoApproval.limits.facts.maxPerRun": "Máximo por execução",
  "autoApproval.limits.facts.maxPerRun.help": "Fatos avaliados por execução.",
  "autoApproval.limits.proposals.maxRateDeltaPp": "Delta máximo de alíquota",
  "autoApproval.limits.proposals.maxRateDeltaPp.help":
    "Maior variação permitida em pontos percentuais nas alíquotas.",
  "autoApproval.limits.proposals.maxMvaDeltaPp": "Delta máximo de MVA",
  "autoApproval.limits.proposals.maxMvaDeltaPp.help":
    "Maior variação permitida em pontos percentuais no MVA.",
  "autoApproval.limits.proposals.maxAffectedRules": "Máximo de regras afetadas",
  "autoApproval.limits.proposals.maxAffectedRules.help":
    "Regras adicionadas ou alteradas por uma execução.",
  "autoApproval.limits.proposals.maxPerRun": "Máximo por execução",
  "autoApproval.limits.proposals.maxPerRun.help": "Propostas avaliadas por execução.",
  "autoApproval.limits.proposals.allowDeletions": "Permitir exclusões",
  "autoApproval.limits.proposals.allowDeletions.help":
    "Desligado por padrão. SUPERSEDE que remove famílias ou campos fica retido.",
  "autoApproval.limits.proposals.allowNewRules": "Permitir novas regras",
  "autoApproval.limits.proposals.allowNewRules.help": "Se desligado, UPSERTs novos ficam retidos.",
  "autoApproval.limits.publish.maxAddedRules": "Máximo de regras adicionadas",
  "autoApproval.limits.publish.maxAddedRules.help": "Teto do diff de publicação (adicionadas).",
  "autoApproval.limits.publish.maxChangedRules": "Máximo de regras alteradas",
  "autoApproval.limits.publish.maxChangedRules.help": "Teto do diff de publicação (alteradas).",
  "autoApproval.limits.publish.maxRemovedRules": "Máximo de regras removidas",
  "autoApproval.limits.publish.maxRemovedRules.help":
    "Teto do diff de publicação (removidas). Padrão 0.",
  "autoApproval.limits.publish.minDraftAgeMinutes": "Idade mínima do rascunho",
  "autoApproval.limits.publish.minDraftAgeMinutes.help":
    "Minutos após a aprovação mais recente antes de publicar.",
  "autoApproval.limits.publish.includeHumanApproved": "Incluir propostas aprovadas por pessoas",
  "autoApproval.limits.publish.includeHumanApproved.help":
    "Desligado por padrão. Se ligado, o rascunho pode levar aprovações humanas.",
  "autoApproval.limits.policy.targetPolicyVersion": "Política alvo",
  "autoApproval.limits.policy.targetPolicyVersion.help":
    "Usada só quando a etapa de política está ligada.",
  "autoApproval.unit.observations": "observações",
  "autoApproval.unit.hours": "horas",
  "autoApproval.unit.documents": "documentos",
  "autoApproval.unit.facts": "fatos",
  "autoApproval.unit.pp": "pp",
  "autoApproval.unit.rules": "regras",
  "autoApproval.unit.proposals": "propostas",
  "autoApproval.unit.minutes": "minutos",
  "autoApproval.preview.readonly": "Somente leitura: nada foi alterado.",
  "autoApproval.preview.run": "Pré-visualizar agora",
  "autoApproval.preview.generatedAt": "Gerada em {when}",
  "autoApproval.preview.empty.title": "Nenhuma pré-visualização ainda",
  "autoApproval.preview.empty.body":
    "Execute a pré-visualização para ver o que seria aprovado, certificado ou retido agora.",
  "autoApproval.preview.stats": "Resumo por etapa",
  "autoApproval.preview.stat.wouldAct": "seriam atuados",
  "autoApproval.preview.stat.scope": "{held} retidos · {candidates} candidatos",
  "autoApproval.preview.truncated": "Lista truncada pelo teto da execução",
  "autoApproval.preview.enabled.on": "Etapa ligada",
  "autoApproval.preview.enabled.off": "Etapa desligada",
  "autoApproval.preview.elapsed": "Tempo {ms} ms",
  "autoApproval.preview.scenario.legend": "Cenário",
  "autoApproval.preview.scenario.current": "atual",
  "autoApproval.preview.scenario.all": "tudo ligado (inclui política)",
  "autoApproval.preview.canary.title": "Canário",
  "autoApproval.preview.canary.passed":
    "Canário passou: parity golden e replay sem regressões inesperadas.",
  "autoApproval.preview.canary.failed": "Canário falhou. Veja as falhas abaixo.",
  "autoApproval.preview.canary.suites": "Suítes golden",
  "autoApproval.preview.canary.suite": "Suíte",
  "autoApproval.preview.canary.passedTotal": "Passou / total",
  "autoApproval.preview.canary.replay":
    "Replay: {items} itens · {unchanged} iguais · {expected} mudanças esperadas · {unexpected} regressões",
  "autoApproval.preview.canary.failures": "Falhas do canário",
  "autoApproval.preview.canary.case": "Caso",
  "autoApproval.preview.canary.kind": "Tipo",
  "autoApproval.preview.canary.expectations": "Expectativas do dono",
  "autoApproval.preview.canary.expectation.label": "Expectativa",
  "autoApproval.preview.canary.expectation.expected": "Esperado",
  "autoApproval.preview.canary.expectation.actual": "Calculado",
  "autoApproval.preview.canary.expectation.status": "Situação",
  "autoApproval.preview.canary.expectation.note": "Nota",
  "autoApproval.preview.canary.expectation.PASS": "Passou",
  "autoApproval.preview.canary.expectation.FAIL": "Falhou",
  "autoApproval.preview.canary.expectation.NOT_APPLICABLE": "Não se aplica",
  "autoApproval.canaryKind.GOLDEN_MISMATCH": "Divergência golden",
  "autoApproval.canaryKind.UNEXPECTED_CHANGE": "Mudança inesperada",
  "autoApproval.canaryKind.STATUS_DOWNGRADE": "Rebaixamento de status",
  "autoApproval.canaryKind.REPLAY_MISMATCH": "Divergência de replay",
  "autoApproval.preview.items.title": "Itens avaliados",
  "autoApproval.preview.items.empty": "Nenhum item neste filtro",
  "autoApproval.preview.items.emptyBody": "Ajuste o filtro de etapa ou resultado.",
  "autoApproval.preview.filter.stage": "Etapa",
  "autoApproval.preview.filter.all": "Todas",
  "autoApproval.preview.filter.outcome": "Resultado",
  "autoApproval.preview.col.label": "Item",
  "autoApproval.preview.col.stage": "Etapa",
  "autoApproval.preview.col.outcome": "Resultado",
  "autoApproval.preview.col.reasons": "Critérios",
  "autoApproval.report.date": "Data",
  "autoApproval.report.timezone": "Fuso America/Sao_Paulo",
  "autoApproval.report.stats": "Totais do dia",
  "autoApproval.report.count.evidence": "Evidências aprovadas",
  "autoApproval.report.count.facts": "Fatos certificados",
  "autoApproval.report.count.proposals": "Propostas aprovadas",
  "autoApproval.report.count.policy": "Mudanças de política",
  "autoApproval.report.count.published": "Versões publicadas",
  "autoApproval.report.count.rollbacks": "Reversões",
  "autoApproval.report.actions.title": "Ações do dia",
  "autoApproval.report.actions.empty": "Nenhuma ação neste dia.",
  "autoApproval.report.actions.time": "Hora",
  "autoApproval.report.actions.stage": "Etapa",
  "autoApproval.report.actions.outcome": "Resultado",
  "autoApproval.report.actions.label": "Item",
  "autoApproval.report.actions.criteria": "Critérios",
  "autoApproval.report.holds.title": "Retidas (agrupadas)",
  "autoApproval.report.holds.empty": "Nenhuma retenção atual.",
  "autoApproval.report.holds.stage": "Etapa",
  "autoApproval.report.holds.reason": "Motivo",
  "autoApproval.report.holds.count": "Qtde",
  "autoApproval.report.holds.explanation": "Explicação",
  "autoApproval.report.breakers.title": "Disjuntores abertos",
  "autoApproval.report.breakers.empty": "Nenhum disjuntor aberto.",
  "autoApproval.report.runs.title": "Últimas execuções",
  "autoApproval.report.runs.empty": "Nenhuma execução registrada.",
  "autoApproval.report.runs.started": "Início",
  "autoApproval.report.runs.trigger": "Gatilho",
  "autoApproval.report.runs.status": "Status",
  "autoApproval.report.runs.acted": "Atuados",
  "autoApproval.report.runs.held": "Retidos",
  "autoApproval.report.runs.errors": "Erros por etapa",
  "autoApproval.status.breakerNotice":
    "Publicação automática interrompida: canário pós-publicação falhou em {date} e a versão anterior foi restaurada. Para retomar, ligue a etapa de novo com um motivo.",
  "autoApproval.criterion.STAGE_DISABLED": "Etapa desligada",
  "autoApproval.criterion.STAGE_DISABLED.tip": "A etapa está desligada nas configurações.",
  "autoApproval.criterion.KILL_SWITCH": "Interruptor geral",
  "autoApproval.criterion.KILL_SWITCH.tip":
    "O interruptor geral do ambiente bloqueia toda a pipeline.",
  "autoApproval.criterion.EVALUATION_FAILED": "Falha na avaliação",
  "autoApproval.criterion.EVALUATION_FAILED.tip": "A avaliação falhou por erro interno.",
  "autoApproval.criterion.LIMIT_REACHED": "Limite atingido",
  "autoApproval.criterion.LIMIT_REACHED.tip": "O limite por execução foi atingido.",
  "autoApproval.criterion.CHANGED_SINCE_EVALUATION": "Alterado após avaliação",
  "autoApproval.criterion.CHANGED_SINCE_EVALUATION.tip": "O recurso mudou depois da avaliação.",
  "autoApproval.criterion.SOURCE_REGISTERED": "Fonte registrada",
  "autoApproval.criterion.SOURCE_REGISTERED.tip": "A fonte está no registro oficial revisado.",
  "autoApproval.criterion.URL_IN_REGISTRY": "URL no registro",
  "autoApproval.criterion.URL_IN_REGISTRY.tip":
    "A URL canônica bate com o host e o prefixo da fonte.",
  "autoApproval.criterion.SOURCE_HEALTHY": "Fonte saudável",
  "autoApproval.criterion.SOURCE_HEALTHY.tip": "A fonte está ACTIVE (não degradada).",
  "autoApproval.criterion.FETCH_OK": "Fetch ok",
  "autoApproval.criterion.FETCH_OK.tip": "Há artefato bruto e content_sha256.",
  "autoApproval.criterion.DIGEST_STABLE": "Digest estável",
  "autoApproval.criterion.DIGEST_STABLE.tip":
    "O digest se repetiu o bastante ou ficou estável no tempo.",
  "autoApproval.criterion.ACT_SUPPORTED": "Ato suportado",
  "autoApproval.criterion.ACT_SUPPORTED.tip": "O tipo de ato está na lista suportada.",
  "autoApproval.criterion.EVIDENCE_APPROVED": "Evidência aprovada",
  "autoApproval.criterion.EVIDENCE_APPROVED.tip": "Toda evidência ligada está APPROVED.",
  "autoApproval.criterion.INDEPENDENT_AGREEMENT": "Concordância independente",
  "autoApproval.criterion.FULL_VALIDITY_COVERAGE": "Vigência completa comprovada",
  "autoApproval.criterion.FULL_VALIDITY_COVERAGE.tip":
    "As fontes devem comprovar todo o período de vigência proposto.",
  "autoApproval.criterion.QUALIFIED_APPLICABILITY": "Aplicabilidade qualificada",
  "autoApproval.criterion.QUALIFIED_APPLICABILITY.tip":
    "A evidência guardada deve comprovar o produto, a rota, as condições da operação e os parâmetros fiscais exatos. Um documento aprovado, por si só, não basta.",
  "autoApproval.criterion.INDEPENDENT_AGREEMENT.tip": "Há concordância de fonte independente.",
  "autoApproval.criterion.NO_CERTIFIED_CONFLICT": "Sem conflito certificado",
  "autoApproval.criterion.NO_CERTIFIED_CONFLICT.tip": "Não há fato certificado em conflito.",
  "autoApproval.criterion.NO_DRIFT": "Sem drift",
  "autoApproval.criterion.NO_DRIFT.tip": "Não está na lista de drift da Verificação.",
  "autoApproval.criterion.DRY_RUN_VALID": "Dry-run válido",
  "autoApproval.criterion.DRY_RUN_VALID.tip": "A simulação no rascunho passa na validação.",
  "autoApproval.criterion.NO_PENDING_OVERLAP": "Sem sobreposição pendente",
  "autoApproval.criterion.NO_PENDING_OVERLAP.tip": "Não há outra proposta pendente sobreposta.",
  "autoApproval.criterion.WITHIN_THRESHOLDS": "Dentro dos limites",
  "autoApproval.criterion.WITHIN_THRESHOLDS.tip":
    "Deltas e limites da proposta estão dentro do teto.",
  "autoApproval.criterion.RATE_DELTA_WITHIN_CAP": "Delta de alíquota ok",
  "autoApproval.criterion.RATE_DELTA_WITHIN_CAP.tip": "A variação de alíquota está dentro do teto.",
  "autoApproval.criterion.MVA_DELTA_WITHIN_CAP": "Delta de MVA ok",
  "autoApproval.criterion.MVA_DELTA_WITHIN_CAP.tip": "A variação de MVA está dentro do teto.",
  "autoApproval.criterion.NO_DELETION": "Sem exclusão",
  "autoApproval.criterion.NO_DELETION.tip": "Exclusões estão desligadas neste limite.",
  "autoApproval.criterion.NEW_RULES_ALLOWED": "Novas regras permitidas",
  "autoApproval.criterion.NEW_RULES_ALLOWED.tip": "Novas regras (UPSERT) estão permitidas.",
  "autoApproval.criterion.AFFECTED_RULES_WITHIN_CAP": "Regras afetadas ok",
  "autoApproval.criterion.AFFECTED_RULES_WITHIN_CAP.tip":
    "O total de regras afetadas cabe no teto da execução.",
  "autoApproval.criterion.POLICY_UNCHANGED": "Política inalterada",
  "autoApproval.criterion.POLICY_UNCHANGED.tip": "A proposta não exige outra política do rascunho.",
  "autoApproval.criterion.WAITING_FOR_DEPENDENCY": "Aguardando dependência",
  "autoApproval.criterion.WAITING_FOR_DEPENDENCY.tip":
    "Espera um SUPERSEDE pendente na mesma execução.",
  "autoApproval.criterion.POLICY_SWITCH_REQUIRES_HUMAN": "Política exige humano",
  "autoApproval.criterion.POLICY_SWITCH_REQUIRES_HUMAN.tip":
    "Mudar a política exige a etapa 5 ou uma pessoa.",
  "autoApproval.criterion.TARGET_POLICY_READY": "Política alvo pronta",
  "autoApproval.criterion.TARGET_POLICY_READY.tip": "A política alvo precisa de readiness zero.",
  "autoApproval.criterion.DRAFT_PRESENT": "Rascunho presente",
  "autoApproval.criterion.DRAFT_PRESENT.tip": "Há rascunho com propostas aprovadas e base atual.",
  "autoApproval.criterion.BASE_CURRENT": "Base atual",
  "autoApproval.criterion.BASE_CURRENT.tip": "A base do rascunho é a versão ativa.",
  "autoApproval.criterion.READINESS_ZERO": "Readiness zero",
  "autoApproval.criterion.READINESS_ZERO.tip":
    "A readiness da política do rascunho tem 0 violações.",
  "autoApproval.criterion.DIFF_WITHIN_BOUNDS": "Diff nos limites",
  "autoApproval.criterion.DIFF_WITHIN_BOUNDS.tip":
    "O diff do rascunho cabe nos tetos de publicação.",
  "autoApproval.criterion.ONLY_AUTO_APPROVED": "Só autoaprovadas",
  "autoApproval.criterion.ONLY_AUTO_APPROVED.tip":
    "Só entram propostas aprovadas pelo ator do sistema.",
  "autoApproval.criterion.COOLING_OFF": "Resfriamento",
  "autoApproval.criterion.COOLING_OFF.tip":
    "Ainda não passou o tempo mínimo após a última aprovação.",
  "autoApproval.criterion.CANARY_PASSED": "Canário ok",
  "autoApproval.criterion.CANARY_PASSED.tip": "O canário (golden + replay) passou.",
  "autoApproval.criterion.BREAKER_TRIPPED": "Disjuntor aberto",
  "autoApproval.criterion.BREAKER_TRIPPED.tip": "O disjuntor de publicação está aberto.",
  "autoApproval.criterion.POST_PUBLISH_CANARY_PASSED": "Canário pós-publicação ok",
  "autoApproval.criterion.POST_PUBLISH_CANARY_PASSED.tip":
    "O canário pós-publicação confirmou a versão ativa.",
  "autoApproval.act.LEI": "LEI",
  "autoApproval.act.LEI_COMPLEMENTAR": "LEI COMPLEMENTAR",
  "autoApproval.act.DECRETO": "DECRETO",
  "autoApproval.act.RICMS": "RICMS",
  "autoApproval.act.PORTARIA": "PORTARIA",
  "autoApproval.act.RESOLUCAO": "RESOLUCAO",
  "autoApproval.act.INSTRUCAO_NORMATIVA": "INSTRUCAO NORMATIVA",
  "autoApproval.act.CONVENIO_ICMS": "CONVENIO ICMS",
  "autoApproval.act.PROTOCOLO_ICMS": "PROTOCOLO ICMS",
  "autoApproval.act.AJUSTE_SINIEF": "AJUSTE SINIEF",
  "autoApproval.act.ATO_COTEPE": "ATO COTEPE",
  "autoApproval.act.DECISAO_NORMATIVA": "DECISAO NORMATIVA",
  "autoApproval.act.COMUNICADO": "COMUNICADO",
  "autoApproval.act.TIPI": "TIPI",
  "driveWatch.title": "Monitor do Drive comercial",
  "driveWatch.summary": "Acompanhe versões e mudanças na pasta de referência comercial.",
  "driveWatch.boundary":
    "Somente metadados. Este monitor não baixa planilhas nem aprova ou publica regras fiscais.",
  "driveWatch.disabled":
    "Monitor automático desativado. Ainda não há acompanhamento ativo desta pasta.",
  "driveWatch.scope":
    "Escopo: arquivos diretamente na pasta; subpastas e seus arquivos ficam fora. Histórico anterior ao primeiro escaneamento não confirmado.",
  "driveWatch.schedule":
    "Verificação diária pelo agendamento de pesquisa. Conciliação mensal pendente a partir do dia 1, às 06:00 de Brasília, no próximo acionamento disponível.",
  "driveWatch.openFolder": "Abrir pasta de referência",
  "driveWatch.lastCompleted": "Último escaneamento completo · Brasília",
  "driveWatch.observed": "Arquivos no último escaneamento completo",
  "driveWatch.nextCheck": "Próxima verificação elegível · Brasília",
  "driveWatch.nextMonthly": "Conciliação mensal elegível · Brasília",
  "driveWatch.lastAttempt": "Última tentativa: {date}",
  "driveWatch.retryAt": "Retomar a partir de {date}",
  "driveWatch.noRun":
    "Ainda sem escaneamento registrado. Ausência de dados não significa zero arquivos.",
  "driveWatch.files": "Metadados do último escaneamento completo",
  "driveWatch.comparison":
    "{added} novos · {changed} com metadados alterados · {absent} não observados. Não observado não confirma exclusão. Conteúdo não baixado.",
  "driveWatch.file": "ID do arquivo",
  "driveWatch.version": "Versão do Drive",
  "driveWatch.change": "Comparação",
  "driveWatch.observedAt": "Observado em · Brasília",
  "driveWatch.status.DISABLED": "Desativado",
  "driveWatch.status.FAILED": "Requer atenção",
  "driveWatch.status.RUNNING": "Escaneando",
  "driveWatch.status.PAUSED": "Aguardando retomada",
  "driveWatch.status.ACTIVE": "Monitorando",
  "driveWatch.status.WAITING": "Aguardando primeiro escaneamento",
  "driveWatch.change.NEWLY_OBSERVED": "Novo observado",
  "driveWatch.change.METADATA_CHANGED": "Metadados alterados",
  "driveWatch.change.UNCHANGED": "Sem mudança",
  "driveWatch.change.NOT_OBSERVED": "Não observado",
  "driveWatch.run.RUNNING": "Em execução",
  "driveWatch.run.RETRY_PENDING": "Nova tentativa pendente",
  "driveWatch.run.PAUSED": "Pausado",
  "driveWatch.run.COMPLETED": "Concluído",
  "driveWatch.run.FAILED": "Falhou",
  "driveWatch.run.SUPERSEDED": "Substituído por nova configuração",
  "driveWatch.error.PAGE_TOKEN_REJECTED": "Cursor rejeitado; nova listagem necessária",
  "driveWatch.error.CAPACITY_EXCEEDED":
    "Limite de páginas do escaneamento atingido; revisão necessária",
  "driveWatch.error.AUTHENTICATION_FAILED": "Autenticação do processo indisponível",
  "driveWatch.error.ACCESS_DENIED": "Sem permissão para listar a pasta",
  "driveWatch.error.NOT_FOUND": "Pasta não localizada",
  "driveWatch.error.API_DISABLED": "API do Drive desativada",
  "driveWatch.error.RATE_LIMITED": "Limite do Drive atingido",
  "driveWatch.error.NETWORK_ERROR": "Falha de conexão com o Drive",
  "driveWatch.error.TIMEOUT": "Tempo limite do Drive excedido",
  "driveWatch.error.INVALID_RESPONSE": "Resposta do Drive inválida",
  "driveWatch.error.PAGINATION_CYCLE": "Paginação repetida; escaneamento interrompido",
  "driveWatch.error.INCOMPLETE_SEARCH": "Listagem incompleta; comparação não concluída",
  "driveWatch.error.LEASE_LOST": "Execução assumida por outro processo",
  "driveWatch.error.BUDGET_EXCEEDED": "Limite desta execução atingido",
  "driveWatch.error.INTERNAL_ERROR": "Falha interna; revisão necessária",
  "autonomousResearch.title": "Pesquisa autônoma",
  "autonomousResearch.summary":
    "A cada ciclo, a plataforma escolhe as lacunas mais importantes e pesquisa sozinha, dentro do orçamento. Nada é aprovado ou publicado automaticamente.",
  "autonomousResearch.status.active": "Ativa",
  "autonomousResearch.status.disabled": "Desligada",
  "autonomousResearch.status.failed": "Falhou na última execução",
  "autonomousResearch.kpi.lastRun": "Última execução",
  "autonomousResearch.kpi.nextRun": "Próxima execução",
  "autonomousResearch.kpi.spend": "Gasto estimado hoje",
  "autonomousResearch.kpi.spendOf": "de {cap}",
  "autonomousResearch.kpi.queued": "Itens enfileirados",
  "autonomousResearch.kpi.noRun": "Nenhuma execução ainda",
  "autonomousResearch.queuedSplit":
    "Lacunas: {gaps} · Pesquisas web: {web} · Perguntas: {questions}",
  "autonomousResearch.rows": "{count} linhas de cálculo",
  "autonomousResearch.forcedHint":
    "Pesquisado de novo dentro da janela de reuso porque o último resultado veio vazio ou inconclusivo.",
  "autonomousResearch.brasiliaTime": "Horário de Brasília",
  "autonomousResearch.nextUnknown": "Horário da próxima execução indisponível",
  "autonomousResearch.run.RUNNING": "Em execução",
  "autonomousResearch.run.COMPLETED": "Concluída",
  "autonomousResearch.run.DISABLED": "Não enfileirou",
  "autonomousResearch.run.FAILED": "Falhou",
  "autonomousResearch.duration.seconds": "{seconds} s",
  "autonomousResearch.duration.minutes": "{minutes} min {seconds} s",
  "autonomousResearch.limits":
    "Até {max} itens por execução · espera após {after} resultados inconclusivos, por {days} dias · reutiliza por {reuse} dias",
  "autonomousResearch.disabled":
    "A pesquisa autônoma está desligada pelo interruptor. A execução diária pode continuar, mas não enfileira nada.",
  "autonomousResearch.empty": "Ainda não houve execução. A primeira acontece em {when}.",
  "autonomousResearch.emptyNoWhen":
    "Ainda não houve execução. A primeira acontece no próximo horário agendado.",
  "autonomousResearch.items.title": "Itens desta execução ({count})",
  "autonomousResearch.items.caption": "Itens da última execução",
  "autonomousResearch.items.empty": "Esta execução não registrou itens.",
  "autonomousResearch.items.tier": "Prioridade",
  "autonomousResearch.items.path": "Caminho",
  "autonomousResearch.items.target": "Alvo",
  "autonomousResearch.items.estimate": "Estimativa",
  "autonomousResearch.items.outcome": "Resultado",
  "autonomousResearch.tier.PRIORITY_ROUTE": "Rota prioritária",
  "autonomousResearch.tier.LOT_GAP": "Lote real",
  "autonomousResearch.tier.NATIONAL_BASE": "Base nacional",
  "autonomousResearch.path.CALCULATOR_RESEARCH": "Lacuna",
  "autonomousResearch.path.WEB_RESEARCH_SWEEP": "Pesquisa web",
  "autonomousResearch.path.AGENT_QUESTION": "Pergunta",
  "autonomousResearch.outcome.QUEUED": "Enfileirado",
  "autonomousResearch.outcome.REUSED": "Reutilizado",
  "autonomousResearch.outcome.JOINED_ACTIVE": "Já em andamento",
  "autonomousResearch.outcome.SKIPPED_BUDGET": "Sem orçamento",
  "autonomousResearch.outcome.SKIPPED_MAX_ITEMS": "Limite de itens",
  "autonomousResearch.outcome.SKIPPED_BACKOFF": "Em espera (backoff até {date})",
  "autonomousResearch.outcome.SKIPPED_UNAVAILABLE": "Indisponível",
  "autonomousResearch.outcome.FAILED": "Falhou",
  "autonomousResearch.forced": "reforçado",
  "autonomousResearch.link.request": "Abrir pedido",
  "autonomousResearch.link.sweep": "Abrir pesquisa",
  "autonomousResearch.link.task": "Abrir tarefa",
  "autonomousResearch.history.title": "Execuções recentes",
  "autonomousResearch.history.date": "Data",
  "autonomousResearch.history.queued": "Enfileirados",
  "autonomousResearch.history.spend": "Gasto estimado",
  "autonomousResearch.meter": "Gasto estimado de hoje em relação ao limite diário",
  "autonomousResearch.loading": "Carregando a pesquisa autônoma",
  "autonomousResearch.runSpend": "{amount} nesta execução",
  "autonomousResearch.route": "{origin} → {destination}",
  "acquisitionSettings.title": "Regime fiscal de aquisição · SP",
  "acquisitionSettings.description":
    "Política da entidade que compra para o centro de São Paulo. Confirme o regime e os créditos com a contabilidade; a classificação e os benefícios de cada produto continuam vinculados às suas evidências.",
  "acquisitionSettings.entity": "Entidade",
  "acquisitionSettings.chooseEntity": "Selecione a entidade",
  "acquisitionSettings.warehouse": "Centro de compra",
  "acquisitionSettings.regime": "Regime PIS/COFINS",
  "acquisitionSettings.regime.UNKNOWN": "Não confirmado",
  "acquisitionSettings.regime.NON_CUMULATIVE": "Não cumulativo",
  "acquisitionSettings.regime.CUMULATIVE": "Cumulativo",
  "acquisitionSettings.credit": "Crédito ordinário de aquisição",
  "acquisitionSettings.credit.UNCONFIRMED": "Não confirmado",
  "acquisitionSettings.credit.ELIGIBLE": "Elegível, confirmado pela contabilidade",
  "acquisitionSettings.credit.INELIGIBLE": "Não elegível",
  "acquisitionSettings.creditHint":
    "O crédito ordinário exige o regime não cumulativo. A aplicabilidade ao produto também é verificada no cálculo.",
  "acquisitionSettings.validFrom": "Válido a partir de",
  "acquisitionSettings.validTo": "Válido até",
  "acquisitionSettings.validToHint": "Opcional. Em branco: sem data final declarada.",
  "acquisitionSettings.reference": "Referência da confirmação contábil",
  "acquisitionSettings.referenceHint":
    "Informe a referência e a confirmação recebida da contabilidade (10 a 1.000 caracteres).",
  "acquisitionSettings.revision": "Revisão",
  "acquisitionSettings.confirmedAt": "Confirmado em",
  "acquisitionSettings.unconfigured":
    "Esta entidade ainda não tem uma política fiscal confirmada. Nenhum regime foi presumido.",
  "acquisitionSettings.save": "Confirmar política fiscal",
  "acquisitionSettings.saved": "Política fiscal confirmada",
  "acquisitionSettings.reload": "Descartar edição e recarregar",
  "acquisitionSettings.conflict":
    "A política mudou enquanto você editava. Recarregue a revisão atual antes de confirmar novamente.",
  "acquisitionSettings.invalidWindow": "A data final deve ser igual ou posterior à data inicial.",
  "acquisitionSettings.historyHint":
    "Cada confirmação cria uma revisão e uma auditoria. Cálculos já salvos conservam seus dados e valores.",
  "publication.form.title": "Objetivo do cálculo",
  "publication.form.intent": "Calcular para",
  "publication.form.taxes": "Impostos e cenário de venda",
  "publication.form.purchase": "Preço de publicação (compra)",
  "publication.form.takeRate": "Take rate da oferta (%)",
  "publication.form.goodsOriginScope":
    "Preenche somente os itens sem esse código na planilha. É a origem fiscal da mercadoria, diferente da UF do fornecedor; os códigos por produto são preservados.",
  "publication.form.hint":
    "De 0% até menos de 100%, sem arredondamento. Nesta oferta, despesas adicionais de aquisição e adicionais da base ST são zero.",
  "publication.form.source":
    "Take rate identificado em {cell}; confirme ou altere o valor antes de importar.",
  "publication.form.rateError":
    "Informe um take rate de 0% até menos de 100%, com no máximo 16 casas decimais.",
  "publication.form.unitRequired":
    "Declare o custo por unidade comercial ou mapeie a coluna que informa a base do valor. O modo de publicação exige UNIT em cada produto.",
  "publication.form.declarations":
    "Este modo declara uma compra de mercadorias para revenda pelo estabelecimento contribuinte de ICMS. Confirme abaixo o fornecedor, a composição do custo, a situação de ST e o regime. Consumo próprio e ativo fixo exigem outro cálculo.",
  "publication.form.saved":
    "Take rate: {rate}%. Compra até SP. Despesas adicionais: {charges}; adicionais da base ST: {stBase}. O destino e os tributos da revenda serão tratados quando houver um comprador.",
  "publication.title": "Aquisição e preço para publicação",
  "publication.scope":
    "Compra até SP. O preço da oferta inclui o take rate informado. Os tributos da revenda dependem do comprador e serão calculados quando o destino for conhecido.",
  "publication.supplierIpi.comparison": "Conferência do IPI informado",
  "publication.supplierIpi.incomplete":
    "Falta a origem do IPI informado. Para indústria, informe a alíquota e o valor unitário nas colunas N e O, mantendo as células de origem no cálculo.",
  "publication.supplierIpi.source": "Origem do IPI",
  "publication.supplierIpi.rate": "Alíquota informada",
  "publication.supplierIpi.amount": "Valor informado",
  "publication.supplierIpi.computed": "Valor pela alíquota informada",
  "publication.supplierIpi.qualifiedRate": "Alíquota fiscal de referência",
  "publication.supplierIpi.rateCell": "Célula da alíquota",
  "publication.supplierIpi.amountCell": "Célula do valor",
  "publication.supplierIpi.delta": "Diferença exata",
  "publication.supplierIpi.tolerance": "Limite de representação numérica",
  "publication.supplierIpi.declared": "Informado pelo fornecedor",
  "publication.supplierIpi.amountFormula": "Valor unitário de IPI informado pelo fornecedor",
  "publication.supplierIpi.rateFormula": "Preço NF × alíquota de IPI informada",
  "publication.supplierIpi.comparisonFormula":
    "Comparar o valor informado com preço NF × alíquota, preservando o valor original",
  "publication.supplierIpi.conflict":
    "IPI Valor não corresponde ao preço NF e à alíquota informada. Corrija N e O antes de publicar o preço.",
  "publication.supplierIpi.distributorConflict":
    "O perfil distribuidor comum não admite cobrança de IPI. Confira o fornecedor e os valores informados.",
  "publication.supplierIpi.exact": "Valores coincidem",
  "publication.supplierIpi.representation":
    "Diferença de representação do Excel; valor informado preservado",
  "publication.supplierIpi.savedTitle": "Declaração salva de IPI",
  "publication.supplierIpi.savedPending":
    "IPI informado pelo fornecedor na entrada salva. A qualificação fiscal continua pendente; estes valores não são imposto calculado nem preço de publicação.",
  "publication.supplierIpi.savedPrecision":
    "Decimais da entrada salva, sem arredondamento: alíquota em fração e valor em BRL por unidade comercial.",
  "publication.supplierIpi.notice":
    "O IPI utilizado foi informado pelo fornecedor. Sua alíquota, valor e células de origem estão no detalhe; uma alíquota fiscal de referência não substitui essa declaração.",
  "publication.pending":
    "A qualificação da aquisição ainda está incompleta. Os valores de publicação serão exibidos após a resolução dos dados fiscais necessários.",
  "publication.pending.ncm":
    "O NCM deste produto ainda precisa ser identificado. Isso é uma etapa de classificação, não uma alíquota adicional.",
  "publication.pending.ipiPredicate":
    "Uma característica deste modelo pode alterar o IPI. É preciso resolver a condição aplicável, sem assumir a alíquota genérica.",
  "publication.pending.purchaseRule":
    "Ainda falta uma regra de ICMS/ST aplicável a esta compra. Uma regra de outra UF de origem não substitui a regra desta rota.",
  "publication.pending.goodsOrigin":
    "Confirme o código fiscal da origem da mercadoria (0–8, primeiro dígito do CST) para calcular o preço de publicação. Esse código é diferente da UF de origem da compra, como MG.",
  "publication.principalUnit": "Preço negociado · unidade",
  "publication.acquisitionUnit": "Custo de aquisição · unidade",
  "publication.listingUnit": "Preço para publicação · unidade",
  "publication.listingLot": "Preço para publicação · lote",
  "publication.creditUnit": "Crédito PIS/COFINS · unidade",
  "publication.netAfterContributions": "Custo após crédito PIS/COFINS · unidade",
  "publication.creditUnconfirmed": "Não confirmado",
  "publication.creditUnconfirmedHint":
    "O crédito PIS/COFINS ainda não foi confirmado. Os valores de PIS e COFINS são referências calculadas pelo regime, sem atestar crédito recuperável. O preço para publicação usa o custo de aquisição e o take rate, sem descontar créditos.",
  "publication.precision":
    "{digits} algarismos significativos, sem arredondamento intermediário para centavos. Os valores exibem todos os dígitos salvos.",
  "publication.inputs": "Entradas de cada etapa",
  "publication.evidence": "Evidências da aquisição",
  "publication.distributorIpi": "Distribuidor ordinário: sem IPI destacado",
  "publication.formula.fcpNotApplicableToResale":
    "Não aplicável à aquisição MG → SP para revenda, sem ST.",
  "publication.treatment.NOT_APPLICABLE_TO_RESALE": "Não aplicável à revenda",
  "publication.supplier.INDUSTRY": "Indústria",
  "publication.supplier.DISTRIBUTOR": "Distribuidor",
  "publication.step.ownIcms": "ICMS próprio da compra",
  "publication.step.pisCofinsBase": "Base de PIS/COFINS: principal menos ICMS",
  "publication.step.pis": "PIS da compra",
  "publication.step.cofins": "COFINS da compra",
  "publication.step.ipi": "IPI sobre o preço principal",
  "publication.step.mva": "MVA aplicada",
  "publication.step.stBase": "Base de ICMS-ST, com IPI",
  "publication.step.icmsSt": "ICMS-ST da compra",
  "publication.step.fcpSt": "FCP-ST da compra",
  "publication.step.fcp": "FCP da compra",
  "publication.step.acquisitionCost": "Custo de aquisição",
  "publication.step.listingPrice": "Preço para publicação com take rate",
  "publication.input.intraRate": "Carga interna usada no ajuste",
  "publication.input.nominalInternalRate": "Alíquota interna nominal do débito ST",
  "publication.input.ignoredMaterializedMva": "MVA materializada não utilizada",
  "publication.input.acquisitionMvaMode": "Modo de cálculo da MVA",
  "publication.input.sourcePolicyVersion": "Política da versão de regras",
  "publication.input.intraSource": "Origem da carga interna",
  "publication.input.reason": "Motivo do ajuste",
  "publication.input.warning": "Aviso",
  "publication.mva.mode.EXACT_ACQUISITION": "Aquisição com precisão integral",
  "publication.mva.intraSource.RULE": "Carga efetiva publicada",
  "publication.mva.intraSource.NOMINAL_NOT_INFORMED": "Nominal: carga efetiva não informada",
  "publication.mva.intraSource.NOMINAL_OUT_OF_VALIDITY": "Nominal: carga efetiva fora da vigência",
  "publication.mva.reason.ADJUSTED": "Carga interna superior à interestadual",
  "publication.mva.reason.NOT_INTERSTATE": "Operação interna",
  "publication.mva.reason.INTRA_NOT_GREATER_THAN_INTER": "Carga interna não supera a interestadual",
  "publication.mva.warning.nominalNotInformed":
    "Carga efetiva não informada; usada a alíquota interna nominal.",
  "publication.mva.warning.nominalOutOfValidity":
    "Carga efetiva fora da vigência; usada a alíquota interna nominal.",
  "publication.formula.mvaEffectiveIntra":
    "((1 + MVA original) × (1 − alíquota interestadual) ÷ (1 − carga interna do ajuste)) − 1",
  "publication.formula.fcpNotApplicableToResaleRoute":
    "Não aplicável à aquisição {origin} → {destination} para revenda, sem ST.",
  "recalculateLot.change.SUPPLIER_IPI_PUBLICATION":
    "Aquisição interestadual para SP com IPI declarado e MVA pelo tratamento publicado, sem arredondamento intermediário; a autoridade fiscal vigente continua obrigatória.",
  "proposals.create.noAdditionalEvidence":
    "Nenhum outro documento aprovado nesta página. Altere a busca ou navegue pelas próximas páginas.",
  "publication.input.principal": "Preço principal",
  "publication.input.ownIcmsRate": "Alíquota ICMS próprio",
  "publication.input.ownIcms": "ICMS próprio",
  "publication.input.pisCofinsBase": "Base PIS/COFINS",
  "publication.input.pisRate": "Alíquota PIS",
  "publication.input.cofinsRate": "Alíquota COFINS",
  "publication.input.ipiRate": "Alíquota IPI",
  "publication.input.ipi": "IPI",
  "publication.input.originalMva": "MVA original",
  "publication.input.interstateRate": "Alíquota interestadual",
  "publication.input.internalRate": "Alíquota interna",
  "publication.input.additionalStBase": "Outras parcelas da base ST",
  "publication.input.appliedMva": "MVA aplicada",
  "publication.input.stBase": "Base ICMS-ST",
  "publication.input.fcpRate": "Alíquota FCP",
  "publication.input.acquisitionCharges": "Encargos de aquisição",
  "publication.input.acquisitionCost": "Custo de aquisição",
  "publication.input.takeRate": "Take rate",
  "publication.input.icmsSt": "ICMS-ST",
  "publication.input.fcp": "FCP",
  "publication.input.supplierType": "Tipo do fornecedor",
  "publication.input.legalReference": "Fundamento legal",
  "publication.input.sourceUrl": "Fonte oficial",
  "publication.input.treatment": "Tratamento fiscal",
  "recalculation.basis.RESEARCH": "Recalculado com os dados fiscais resolvidos pela pesquisa",
  "publication.latestTask":
    "Há um cálculo mais recente desta planilha. Este registro conserva a versão anterior.",
  "publication.openLatest": "Ver cálculo atualizado",
  "lotOps.group.publication": "Preço para publicação",
  "publication.summary.title": "Da compra à publicação",
  "publication.summary.cost": "Custo de aquisição do lote",
  "publication.summary.listing": "Preço de publicação com TR",
  "publication.summary.take": "Valor do take rate",
  "publication.summary.counts":
    "{confirmed} calculadas · {estimated} estimadas · {unpriced} sem cotação",
  "publication.summary.split": "Publicação: calculadas {confirmed} · estimadas {estimated}",
  "publication.summary.scope":
    "Cotação da compra até SP, com take rate. Valores estimados incluem hipóteses e não são tributos confirmados. Créditos não confirmados e impostos da futura venda ao destino não são deduzidos.",
  "publication.estimate.memory": "Memória de cálculo do cenário estimado",
  "publication.estimate.title": "Cotação com premissas",
  "publication.estimate.short": "Estimado",
  "publication.estimate.notice":
    "Preço estimado para cotação. Foi selecionado o maior preço entre os cenários avaliados. Os atributos indicados abaixo precisam de confirmação; o resultado fiscal permanece em revisão.",
  "publication.estimate.cost": "Custo unitário estimado",
  "publication.estimate.price": "Preço unitário estimado com take rate",
  "publication.estimate.range": "Faixa de preços dos cenários",
  "publication.estimate.selection": "Cenário utilizado",
  "publication.estimate.assumptions": "Premissas e impacto no preço",
  "publication.estimate.source": "Consultar fonte",
  "publication.estimate.scenarios": "Cenários da cotação",
  "publication.estimate.scenario": "Cenário",
  "publication.estimate.selected": "utilizado",
  "publication.estimate.tableHint":
    "Há {count} produtos com preço estimado e premissas explícitas. Esses valores não integram os totais fiscais confirmados; abra o produto para comparar os cenários.",
} as const;

export type MessageKey = keyof typeof ptBR;
export type MessageCatalog = Record<MessageKey, string>;
